/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 46);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(38);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    return {
        toDateObject: toDateObject,
        toDateString: toDateString,
        toUTCDateObject: toUTCDateObject
    };

    // Convert dateString like 20170101 to dateObject after get data form Markets Api 
    function toDateObject(dateString) {
        if (dateString && typeof dateString === 'string') {
            dateString = dateString.trim().replace(/(\/|-)/g, '');
            if (dateString.length >= 8) {
                return new Date(Number(dateString.slice(0, 4)), Number(dateString.slice(4, 6)) - 1, Number(dateString.slice(6, 8)));
            }
        }
        return null;
    }

    // Convert dateOject to dateString format as 20170101 before call Markets Api
    function toDateString(date) {
        if (date && date instanceof Date) {
            var year = date.getFullYear().toString();
            var month = (date.getMonth() + 1).toString();
            if (month.length === 1) {
                month = '0' + month;
            }
            var day = date.getDate().toString();
            if (day.length === 1) {
                day = '0' + day;
            }
            return year + month + day;
        }
        return null;
    }

    // Convert a date created in China timezone(or any other country timezone) to the US timezone where PAAPI resides
    function toUTCDateObject(date) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(37);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31);
module.exports = 'ngAnimate';


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
module.exports = 'ngAria';


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33);
module.exports = 'ngSanitize';


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34);
module.exports = 'ngTouch';


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(64)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * https://github.com/es-shims/es5-shim
 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
 */

// vim: ts=4 sts=4 sw=4 expandtab

// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
;

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/returnExports.js
(function (root, factory) {
    'use strict';

    /* global define, exports, module */
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.returnExports = factory();
    }
}(this, function () {

/**
 * Brings an environment as close to ECMAScript 5 compliance
 * as is possible with the facilities of erstwhile engines.
 *
 * Annotated ES5: http://es5.github.com/ (specific links below)
 * ES5 Spec: http://www.ecma-international.org/publications/files/ECMA-ST/Ecma-262.pdf
 * Required reading: http://javascriptweblog.wordpress.com/2011/12/05/extending-javascript-natives/
 */

// Shortcut to an often accessed properties, in order to avoid multiple
// dereference that costs universally. This also holds a reference to known-good
// functions.
var $Array = Array;
var ArrayPrototype = $Array.prototype;
var $Object = Object;
var ObjectPrototype = $Object.prototype;
var FunctionPrototype = Function.prototype;
var $String = String;
var StringPrototype = $String.prototype;
var $Number = Number;
var NumberPrototype = $Number.prototype;
var array_slice = ArrayPrototype.slice;
var array_splice = ArrayPrototype.splice;
var array_push = ArrayPrototype.push;
var array_unshift = ArrayPrototype.unshift;
var array_concat = ArrayPrototype.concat;
var call = FunctionPrototype.call;
var max = Math.max;
var min = Math.min;

// Having a toString local variable name breaks in Opera so use to_string.
var to_string = ObjectPrototype.toString;

var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var isCallable; /* inlined from https://npmjs.com/is-callable */ var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) { try { fnToStr.call(value); return true; } catch (e) { return false; } }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]'; isCallable = function isCallable(value) { if (typeof value !== 'function') { return false; } if (hasToStringTag) { return tryFunctionObject(value); } var strClass = to_string.call(value); return strClass === fnClass || strClass === genClass; };
var isRegex; /* inlined from https://npmjs.com/is-regex */ var regexExec = RegExp.prototype.exec, tryRegexExec = function tryRegexExec(value) { try { regexExec.call(value); return true; } catch (e) { return false; } }, regexClass = '[object RegExp]'; isRegex = function isRegex(value) { if (typeof value !== 'object') { return false; } return hasToStringTag ? tryRegexExec(value) : to_string.call(value) === regexClass; };
var isString; /* inlined from https://npmjs.com/is-string */ var strValue = String.prototype.valueOf, tryStringObject = function tryStringObject(value) { try { strValue.call(value); return true; } catch (e) { return false; } }, stringClass = '[object String]'; isString = function isString(value) { if (typeof value === 'string') { return true; } if (typeof value !== 'object') { return false; } return hasToStringTag ? tryStringObject(value) : to_string.call(value) === stringClass; };

/* inlined from http://npmjs.com/define-properties */
var defineProperties = (function (has) {
  var supportsDescriptors = $Object.defineProperty && (function () {
      try {
          var obj = {};
          $Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
          for (var _ in obj) { return false; }
          return obj.x === obj;
      } catch (e) { /* this is ES3 */
          return false;
      }
  }());

  // Define configurable, writable and non-enumerable props
  // if they don't exist.
  var defineProperty;
  if (supportsDescriptors) {
      defineProperty = function (object, name, method, forceAssign) {
          if (!forceAssign && (name in object)) { return; }
          $Object.defineProperty(object, name, {
              configurable: true,
              enumerable: false,
              writable: true,
              value: method
          });
      };
  } else {
      defineProperty = function (object, name, method, forceAssign) {
          if (!forceAssign && (name in object)) { return; }
          object[name] = method;
      };
  }
  return function defineProperties(object, map, forceAssign) {
      for (var name in map) {
          if (has.call(map, name)) {
            defineProperty(object, name, map[name], forceAssign);
          }
      }
  };
}(ObjectPrototype.hasOwnProperty));

//
// Util
// ======
//

/* replaceable with https://npmjs.com/package/es-abstract /helpers/isPrimitive */
var isPrimitive = function isPrimitive(input) {
    var type = typeof input;
    return input === null || (type !== 'object' && type !== 'function');
};

var isActualNaN = $Number.isNaN || function (x) { return x !== x; };

var ES = {
    // ES5 9.4
    // http://es5.github.com/#x9.4
    // http://jsperf.com/to-integer
    /* replaceable with https://npmjs.com/package/es-abstract ES5.ToInteger */
    ToInteger: function ToInteger(num) {
        var n = +num;
        if (isActualNaN(n)) {
            n = 0;
        } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
            n = (n > 0 || -1) * Math.floor(Math.abs(n));
        }
        return n;
    },

    /* replaceable with https://npmjs.com/package/es-abstract ES5.ToPrimitive */
    ToPrimitive: function ToPrimitive(input) {
        var val, valueOf, toStr;
        if (isPrimitive(input)) {
            return input;
        }
        valueOf = input.valueOf;
        if (isCallable(valueOf)) {
            val = valueOf.call(input);
            if (isPrimitive(val)) {
                return val;
            }
        }
        toStr = input.toString;
        if (isCallable(toStr)) {
            val = toStr.call(input);
            if (isPrimitive(val)) {
                return val;
            }
        }
        throw new TypeError();
    },

    // ES5 9.9
    // http://es5.github.com/#x9.9
    /* replaceable with https://npmjs.com/package/es-abstract ES5.ToObject */
    ToObject: function (o) {
        /* jshint eqnull: true */
        if (o == null) { // this matches both null and undefined
            throw new TypeError("can't convert " + o + ' to object');
        }
        return $Object(o);
    },

    /* replaceable with https://npmjs.com/package/es-abstract ES5.ToUint32 */
    ToUint32: function ToUint32(x) {
        return x >>> 0;
    }
};

//
// Function
// ========
//

// ES-5 15.3.4.5
// http://es5.github.com/#x15.3.4.5

var Empty = function Empty() {};

defineProperties(FunctionPrototype, {
    bind: function bind(that) { // .length is 1
        // 1. Let Target be the this value.
        var target = this;
        // 2. If IsCallable(Target) is false, throw a TypeError exception.
        if (!isCallable(target)) {
            throw new TypeError('Function.prototype.bind called on incompatible ' + target);
        }
        // 3. Let A be a new (possibly empty) internal list of all of the
        //   argument values provided after thisArg (arg1, arg2 etc), in order.
        // XXX slicedArgs will stand in for "A" if used
        var args = array_slice.call(arguments, 1); // for normal call
        // 4. Let F be a new native ECMAScript object.
        // 11. Set the [[Prototype]] internal property of F to the standard
        //   built-in Function prototype object as specified in 15.3.3.1.
        // 12. Set the [[Call]] internal property of F as described in
        //   15.3.4.5.1.
        // 13. Set the [[Construct]] internal property of F as described in
        //   15.3.4.5.2.
        // 14. Set the [[HasInstance]] internal property of F as described in
        //   15.3.4.5.3.
        var bound;
        var binder = function () {

            if (this instanceof bound) {
                // 15.3.4.5.2 [[Construct]]
                // When the [[Construct]] internal method of a function object,
                // F that was created using the bind function is called with a
                // list of arguments ExtraArgs, the following steps are taken:
                // 1. Let target be the value of F's [[TargetFunction]]
                //   internal property.
                // 2. If target has no [[Construct]] internal method, a
                //   TypeError exception is thrown.
                // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                //   property.
                // 4. Let args be a new list containing the same values as the
                //   list boundArgs in the same order followed by the same
                //   values as the list ExtraArgs in the same order.
                // 5. Return the result of calling the [[Construct]] internal
                //   method of target providing args as the arguments.

                var result = target.apply(
                    this,
                    array_concat.call(args, array_slice.call(arguments))
                );
                if ($Object(result) === result) {
                    return result;
                }
                return this;

            } else {
                // 15.3.4.5.1 [[Call]]
                // When the [[Call]] internal method of a function object, F,
                // which was created using the bind function is called with a
                // this value and a list of arguments ExtraArgs, the following
                // steps are taken:
                // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                //   property.
                // 2. Let boundThis be the value of F's [[BoundThis]] internal
                //   property.
                // 3. Let target be the value of F's [[TargetFunction]] internal
                //   property.
                // 4. Let args be a new list containing the same values as the
                //   list boundArgs in the same order followed by the same
                //   values as the list ExtraArgs in the same order.
                // 5. Return the result of calling the [[Call]] internal method
                //   of target providing boundThis as the this value and
                //   providing args as the arguments.

                // equiv: target.call(this, ...boundArgs, ...args)
                return target.apply(
                    that,
                    array_concat.call(args, array_slice.call(arguments))
                );

            }

        };

        // 15. If the [[Class]] internal property of Target is "Function", then
        //     a. Let L be the length property of Target minus the length of A.
        //     b. Set the length own property of F to either 0 or L, whichever is
        //       larger.
        // 16. Else set the length own property of F to 0.

        var boundLength = max(0, target.length - args.length);

        // 17. Set the attributes of the length own property of F to the values
        //   specified in 15.3.5.1.
        var boundArgs = [];
        for (var i = 0; i < boundLength; i++) {
            array_push.call(boundArgs, '$' + i);
        }

        // XXX Build a dynamic function with desired amount of arguments is the only
        // way to set the length property of a function.
        // In environments where Content Security Policies enabled (Chrome extensions,
        // for ex.) all use of eval or Function costructor throws an exception.
        // However in all of these environments Function.prototype.bind exists
        // and so this code will never be executed.
        bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);

        if (target.prototype) {
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            // Clean up dangling references.
            Empty.prototype = null;
        }

        // TODO
        // 18. Set the [[Extensible]] internal property of F to true.

        // TODO
        // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
        // 20. Call the [[DefineOwnProperty]] internal method of F with
        //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
        //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
        //   false.
        // 21. Call the [[DefineOwnProperty]] internal method of F with
        //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
        //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
        //   and false.

        // TODO
        // NOTE Function objects created using Function.prototype.bind do not
        // have a prototype property or the [[Code]], [[FormalParameters]], and
        // [[Scope]] internal properties.
        // XXX can't delete prototype in pure-js.

        // 22. Return F.
        return bound;
    }
});

// _Please note: Shortcuts are defined after `Function.prototype.bind` as we
// us it in defining shortcuts.
var owns = call.bind(ObjectPrototype.hasOwnProperty);
var toStr = call.bind(ObjectPrototype.toString);
var strSlice = call.bind(StringPrototype.slice);
var strSplit = call.bind(StringPrototype.split);
var strIndexOf = call.bind(StringPrototype.indexOf);
var push = call.bind(array_push);

//
// Array
// =====
//

var isArray = $Array.isArray || function isArray(obj) {
    return toStr(obj) === '[object Array]';
};

// ES5 15.4.4.12
// http://es5.github.com/#x15.4.4.13
// Return len+argCount.
// [bugfix, ielt8]
// IE < 8 bug: [].unshift(0) === undefined but should be "1"
var hasUnshiftReturnValueBug = [].unshift(0) !== 1;
defineProperties(ArrayPrototype, {
    unshift: function () {
        array_unshift.apply(this, arguments);
        return this.length;
    }
}, hasUnshiftReturnValueBug);

// ES5 15.4.3.2
// http://es5.github.com/#x15.4.3.2
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
defineProperties($Array, { isArray: isArray });

// The IsCallable() check in the Array functions
// has been replaced with a strict check on the
// internal class of the object to trap cases where
// the provided function was actually a regular
// expression literal, which in V8 and
// JavaScriptCore is a typeof "function".  Only in
// V8 are regular expression literals permitted as
// reduce parameters, so it is desirable in the
// general case for the shim to match the more
// strict and common behavior of rejecting regular
// expressions.

// ES5 15.4.4.18
// http://es5.github.com/#x15.4.4.18
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/array/forEach

// Check failure of by-index access of string characters (IE < 9)
// and failure of `0 in boxedString` (Rhino)
var boxedString = $Object('a');
var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

var properlyBoxesContext = function properlyBoxed(method) {
    // Check node 0.6.21 bug where third parameter is not boxed
    var properlyBoxesNonStrict = true;
    var properlyBoxesStrict = true;
    if (method) {
        method.call('foo', function (_, __, context) {
            if (typeof context !== 'object') { properlyBoxesNonStrict = false; }
        });

        method.call([1], function () {
            'use strict';

            properlyBoxesStrict = typeof this === 'string';
        }, 'x');
    }
    return !!method && properlyBoxesNonStrict && properlyBoxesStrict;
};

defineProperties(ArrayPrototype, {
    forEach: function forEach(callbackfn/*, thisArg*/) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var i = -1;
        var length = ES.ToUint32(self.length);
        var T;
        if (arguments.length > 1) {
          T = arguments[1];
        }

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.forEach callback must be a function');
        }

        while (++i < length) {
            if (i in self) {
                // Invoke the callback function with call, passing arguments:
                // context, property value, property key, thisArg object
                if (typeof T === 'undefined') {
                    callbackfn(self[i], i, object);
                } else {
                    callbackfn.call(T, self[i], i, object);
                }
            }
        }
    }
}, !properlyBoxesContext(ArrayPrototype.forEach));

// ES5 15.4.4.19
// http://es5.github.com/#x15.4.4.19
// https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
defineProperties(ArrayPrototype, {
    map: function map(callbackfn/*, thisArg*/) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var length = ES.ToUint32(self.length);
        var result = $Array(length);
        var T;
        if (arguments.length > 1) {
            T = arguments[1];
        }

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.map callback must be a function');
        }

        for (var i = 0; i < length; i++) {
            if (i in self) {
                if (typeof T === 'undefined') {
                    result[i] = callbackfn(self[i], i, object);
                } else {
                    result[i] = callbackfn.call(T, self[i], i, object);
                }
            }
        }
        return result;
    }
}, !properlyBoxesContext(ArrayPrototype.map));

// ES5 15.4.4.20
// http://es5.github.com/#x15.4.4.20
// https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
defineProperties(ArrayPrototype, {
    filter: function filter(callbackfn/*, thisArg*/) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var length = ES.ToUint32(self.length);
        var result = [];
        var value;
        var T;
        if (arguments.length > 1) {
            T = arguments[1];
        }

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.filter callback must be a function');
        }

        for (var i = 0; i < length; i++) {
            if (i in self) {
                value = self[i];
                if (typeof T === 'undefined' ? callbackfn(value, i, object) : callbackfn.call(T, value, i, object)) {
                    push(result, value);
                }
            }
        }
        return result;
    }
}, !properlyBoxesContext(ArrayPrototype.filter));

// ES5 15.4.4.16
// http://es5.github.com/#x15.4.4.16
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
defineProperties(ArrayPrototype, {
    every: function every(callbackfn/*, thisArg*/) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var length = ES.ToUint32(self.length);
        var T;
        if (arguments.length > 1) {
            T = arguments[1];
        }

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.every callback must be a function');
        }

        for (var i = 0; i < length; i++) {
            if (i in self && !(typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
                return false;
            }
        }
        return true;
    }
}, !properlyBoxesContext(ArrayPrototype.every));

// ES5 15.4.4.17
// http://es5.github.com/#x15.4.4.17
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
defineProperties(ArrayPrototype, {
    some: function some(callbackfn/*, thisArg */) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var length = ES.ToUint32(self.length);
        var T;
        if (arguments.length > 1) {
            T = arguments[1];
        }

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.some callback must be a function');
        }

        for (var i = 0; i < length; i++) {
            if (i in self && (typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
                return true;
            }
        }
        return false;
    }
}, !properlyBoxesContext(ArrayPrototype.some));

// ES5 15.4.4.21
// http://es5.github.com/#x15.4.4.21
// https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduce
var reduceCoercesToObject = false;
if (ArrayPrototype.reduce) {
    reduceCoercesToObject = typeof ArrayPrototype.reduce.call('es5', function (_, __, ___, list) { return list; }) === 'object';
}
defineProperties(ArrayPrototype, {
    reduce: function reduce(callbackfn/*, initialValue*/) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var length = ES.ToUint32(self.length);

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.reduce callback must be a function');
        }

        // no value to return if no initial value and an empty array
        if (length === 0 && arguments.length === 1) {
            throw new TypeError('reduce of empty array with no initial value');
        }

        var i = 0;
        var result;
        if (arguments.length >= 2) {
            result = arguments[1];
        } else {
            do {
                if (i in self) {
                    result = self[i++];
                    break;
                }

                // if array contains no values, no initial value to return
                if (++i >= length) {
                    throw new TypeError('reduce of empty array with no initial value');
                }
            } while (true);
        }

        for (; i < length; i++) {
            if (i in self) {
                result = callbackfn(result, self[i], i, object);
            }
        }

        return result;
    }
}, !reduceCoercesToObject);

// ES5 15.4.4.22
// http://es5.github.com/#x15.4.4.22
// https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduceRight
var reduceRightCoercesToObject = false;
if (ArrayPrototype.reduceRight) {
    reduceRightCoercesToObject = typeof ArrayPrototype.reduceRight.call('es5', function (_, __, ___, list) { return list; }) === 'object';
}
defineProperties(ArrayPrototype, {
    reduceRight: function reduceRight(callbackfn/*, initial*/) {
        var object = ES.ToObject(this);
        var self = splitString && isString(this) ? strSplit(this, '') : object;
        var length = ES.ToUint32(self.length);

        // If no callback function or if callback is not a callable function
        if (!isCallable(callbackfn)) {
            throw new TypeError('Array.prototype.reduceRight callback must be a function');
        }

        // no value to return if no initial value, empty array
        if (length === 0 && arguments.length === 1) {
            throw new TypeError('reduceRight of empty array with no initial value');
        }

        var result;
        var i = length - 1;
        if (arguments.length >= 2) {
            result = arguments[1];
        } else {
            do {
                if (i in self) {
                    result = self[i--];
                    break;
                }

                // if array contains no values, no initial value to return
                if (--i < 0) {
                    throw new TypeError('reduceRight of empty array with no initial value');
                }
            } while (true);
        }

        if (i < 0) {
            return result;
        }

        do {
            if (i in self) {
                result = callbackfn(result, self[i], i, object);
            }
        } while (i--);

        return result;
    }
}, !reduceRightCoercesToObject);

// ES5 15.4.4.14
// http://es5.github.com/#x15.4.4.14
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
var hasFirefox2IndexOfBug = ArrayPrototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
defineProperties(ArrayPrototype, {
    indexOf: function indexOf(searchElement/*, fromIndex */) {
        var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
        var length = ES.ToUint32(self.length);

        if (length === 0) {
            return -1;
        }

        var i = 0;
        if (arguments.length > 1) {
            i = ES.ToInteger(arguments[1]);
        }

        // handle negative indices
        i = i >= 0 ? i : max(0, length + i);
        for (; i < length; i++) {
            if (i in self && self[i] === searchElement) {
                return i;
            }
        }
        return -1;
    }
}, hasFirefox2IndexOfBug);

// ES5 15.4.4.15
// http://es5.github.com/#x15.4.4.15
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
var hasFirefox2LastIndexOfBug = ArrayPrototype.lastIndexOf && [0, 1].lastIndexOf(0, -3) !== -1;
defineProperties(ArrayPrototype, {
    lastIndexOf: function lastIndexOf(searchElement/*, fromIndex */) {
        var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
        var length = ES.ToUint32(self.length);

        if (length === 0) {
            return -1;
        }
        var i = length - 1;
        if (arguments.length > 1) {
            i = min(i, ES.ToInteger(arguments[1]));
        }
        // handle negative indices
        i = i >= 0 ? i : length - Math.abs(i);
        for (; i >= 0; i--) {
            if (i in self && searchElement === self[i]) {
                return i;
            }
        }
        return -1;
    }
}, hasFirefox2LastIndexOfBug);

// ES5 15.4.4.12
// http://es5.github.com/#x15.4.4.12
var spliceNoopReturnsEmptyArray = (function () {
    var a = [1, 2];
    var result = a.splice();
    return a.length === 2 && isArray(result) && result.length === 0;
}());
defineProperties(ArrayPrototype, {
    // Safari 5.0 bug where .splice() returns undefined
    splice: function splice(start, deleteCount) {
        if (arguments.length === 0) {
            return [];
        } else {
            return array_splice.apply(this, arguments);
        }
    }
}, !spliceNoopReturnsEmptyArray);

var spliceWorksWithEmptyObject = (function () {
    var obj = {};
    ArrayPrototype.splice.call(obj, 0, 0, 1);
    return obj.length === 1;
}());
defineProperties(ArrayPrototype, {
    splice: function splice(start, deleteCount) {
        if (arguments.length === 0) { return []; }
        var args = arguments;
        this.length = max(ES.ToInteger(this.length), 0);
        if (arguments.length > 0 && typeof deleteCount !== 'number') {
            args = array_slice.call(arguments);
            if (args.length < 2) {
                push(args, this.length - start);
            } else {
                args[1] = ES.ToInteger(deleteCount);
            }
        }
        return array_splice.apply(this, args);
    }
}, !spliceWorksWithEmptyObject);
var spliceWorksWithLargeSparseArrays = (function () {
    // Per https://github.com/es-shims/es5-shim/issues/295
    // Safari 7/8 breaks with sparse arrays of size 1e5 or greater
    var arr = new $Array(1e5);
    // note: the index MUST be 8 or larger or the test will false pass
    arr[8] = 'x';
    arr.splice(1, 1);
    // note: this test must be defined *after* the indexOf shim
    // per https://github.com/es-shims/es5-shim/issues/313
    return arr.indexOf('x') === 7;
}());
var spliceWorksWithSmallSparseArrays = (function () {
    // Per https://github.com/es-shims/es5-shim/issues/295
    // Opera 12.15 breaks on this, no idea why.
    var n = 256;
    var arr = [];
    arr[n] = 'a';
    arr.splice(n + 1, 0, 'b');
    return arr[n] === 'a';
}());
defineProperties(ArrayPrototype, {
    splice: function splice(start, deleteCount) {
        var O = ES.ToObject(this);
        var A = [];
        var len = ES.ToUint32(O.length);
        var relativeStart = ES.ToInteger(start);
        var actualStart = relativeStart < 0 ? max((len + relativeStart), 0) : min(relativeStart, len);
        var actualDeleteCount = min(max(ES.ToInteger(deleteCount), 0), len - actualStart);

        var k = 0;
        var from;
        while (k < actualDeleteCount) {
            from = $String(actualStart + k);
            if (owns(O, from)) {
                A[k] = O[from];
            }
            k += 1;
        }

        var items = array_slice.call(arguments, 2);
        var itemCount = items.length;
        var to;
        if (itemCount < actualDeleteCount) {
            k = actualStart;
            while (k < (len - actualDeleteCount)) {
                from = $String(k + actualDeleteCount);
                to = $String(k + itemCount);
                if (owns(O, from)) {
                    O[to] = O[from];
                } else {
                    delete O[to];
                }
                k += 1;
            }
            k = len;
            while (k > (len - actualDeleteCount + itemCount)) {
                delete O[k - 1];
                k -= 1;
            }
        } else if (itemCount > actualDeleteCount) {
            k = len - actualDeleteCount;
            while (k > actualStart) {
                from = $String(k + actualDeleteCount - 1);
                to = $String(k + itemCount - 1);
                if (owns(O, from)) {
                    O[to] = O[from];
                } else {
                    delete O[to];
                }
                k -= 1;
            }
        }
        k = actualStart;
        for (var i = 0; i < items.length; ++i) {
            O[k] = items[i];
            k += 1;
        }
        O.length = len - actualDeleteCount + itemCount;

        return A;
    }
}, !spliceWorksWithLargeSparseArrays || !spliceWorksWithSmallSparseArrays);

var hasJoinUndefinedBug = [1, 2].join(undefined) !== '1,2';
var originalJoin = ArrayPrototype.join;
defineProperties(ArrayPrototype, {
    join: function join(separator) {
        return originalJoin.call(this, typeof separator === 'undefined' ? ',' : separator);
    }
}, hasJoinUndefinedBug);

var pushShim = function push(item) {
    var O = ES.ToObject(this);
    var n = ES.ToUint32(O.length);
    var i = 0;
    while (i < arguments.length) {
        O[n + i] = arguments[i];
        i += 1;
    }
    O.length = n + i;
    return n + i;
};

var pushIsNotGeneric = (function () {
    var obj = {};
    var result = Array.prototype.push.call(obj, undefined);
    return result !== 1 || obj.length !== 1 || typeof obj[0] !== 'undefined' || !owns(obj, 0);
}());
defineProperties(ArrayPrototype, {
    push: function push(item) {
        if (isArray(this)) {
            return array_push.apply(this, arguments);
        }
        return pushShim.apply(this, arguments);
    }
}, pushIsNotGeneric);

// This fixes a very weird bug in Opera 10.6 when pushing `undefined
var pushUndefinedIsWeird = (function () {
    var arr = [];
    var result = arr.push(undefined);
    return result !== 1 || arr.length !== 1 || typeof arr[0] !== 'undefined' || !owns(arr, 0);
}());
defineProperties(ArrayPrototype, { push: pushShim }, pushUndefinedIsWeird);

//
// Object
// ======
//

// ES5 15.2.3.14
// http://es5.github.com/#x15.2.3.14

// http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
var hasDontEnumBug = !({ 'toString': null }).propertyIsEnumerable('toString');
var hasProtoEnumBug = function () {}.propertyIsEnumerable('prototype');
var hasStringEnumBug = !owns('x', '0');
var equalsConstructorPrototype = function (o) {
    var ctor = o.constructor;
    return ctor && ctor.prototype === o;
};
var blacklistedKeys = {
    $window: true,
    $console: true,
    $parent: true,
    $self: true,
    $frame: true,
    $frames: true,
    $frameElement: true,
    $webkitIndexedDB: true,
    $webkitStorageInfo: true
};
var hasAutomationEqualityBug = (function () {
    /* globals window */
    if (typeof window === 'undefined') { return false; }
    for (var k in window) {
        try {
            if (!blacklistedKeys['$' + k] && owns(window, k) && window[k] !== null && typeof window[k] === 'object') {
                equalsConstructorPrototype(window[k]);
            }
        } catch (e) {
            return true;
        }
    }
    return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (object) {
    if (typeof window === 'undefined' || !hasAutomationEqualityBug) { return equalsConstructorPrototype(object); }
    try {
        return equalsConstructorPrototype(object);
    } catch (e) {
        return false;
    }
};
var dontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
var dontEnumsLength = dontEnums.length;

// taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
// can be replaced with require('is-arguments') if we ever use a build process instead
var isStandardArguments = function isArguments(value) {
    return toStr(value) === '[object Arguments]';
};
var isLegacyArguments = function isArguments(value) {
    return value !== null &&
        typeof value === 'object' &&
        typeof value.length === 'number' &&
        value.length >= 0 &&
        !isArray(value) &&
        isCallable(value.callee);
};
var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;

defineProperties($Object, {
    keys: function keys(object) {
        var isFn = isCallable(object);
        var isArgs = isArguments(object);
        var isObject = object !== null && typeof object === 'object';
        var isStr = isObject && isString(object);

        if (!isObject && !isFn && !isArgs) {
            throw new TypeError('Object.keys called on a non-object');
        }

        var theKeys = [];
        var skipProto = hasProtoEnumBug && isFn;
        if ((isStr && hasStringEnumBug) || isArgs) {
            for (var i = 0; i < object.length; ++i) {
                push(theKeys, $String(i));
            }
        }

        if (!isArgs) {
            for (var name in object) {
                if (!(skipProto && name === 'prototype') && owns(object, name)) {
                    push(theKeys, $String(name));
                }
            }
        }

        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for (var j = 0; j < dontEnumsLength; j++) {
                var dontEnum = dontEnums[j];
                if (!(skipConstructor && dontEnum === 'constructor') && owns(object, dontEnum)) {
                    push(theKeys, dontEnum);
                }
            }
        }
        return theKeys;
    }
});

var keysWorksWithArguments = $Object.keys && (function () {
    // Safari 5.0 bug
    return $Object.keys(arguments).length === 2;
}(1, 2));
var keysHasArgumentsLengthBug = $Object.keys && (function () {
    var argKeys = $Object.keys(arguments);
    return arguments.length !== 1 || argKeys.length !== 1 || argKeys[0] !== 1;
}(1));
var originalKeys = $Object.keys;
defineProperties($Object, {
    keys: function keys(object) {
        if (isArguments(object)) {
            return originalKeys(array_slice.call(object));
        } else {
            return originalKeys(object);
        }
    }
}, !keysWorksWithArguments || keysHasArgumentsLengthBug);

//
// Date
// ====
//

// ES5 15.9.5.43
// http://es5.github.com/#x15.9.5.43
// This function returns a String value represent the instance in time
// represented by this Date object. The format of the String is the Date Time
// string format defined in 15.9.1.15. All fields are present in the String.
// The time zone is always UTC, denoted by the suffix Z. If the time value of
// this object is not a finite Number a RangeError exception is thrown.
var negativeDate = -62198755200000;
var negativeYearString = '-000001';
var hasNegativeDateBug = Date.prototype.toISOString && new Date(negativeDate).toISOString().indexOf(negativeYearString) === -1;
var hasSafari51DateBug = Date.prototype.toISOString && new Date(-1).toISOString() !== '1969-12-31T23:59:59.999Z';

defineProperties(Date.prototype, {
    toISOString: function toISOString() {
        var result, length, value, year, month;
        if (!isFinite(this)) {
            throw new RangeError('Date.prototype.toISOString called on non-finite value.');
        }

        year = this.getUTCFullYear();

        month = this.getUTCMonth();
        // see https://github.com/es-shims/es5-shim/issues/111
        year += Math.floor(month / 12);
        month = (month % 12 + 12) % 12;

        // the date time string format is specified in 15.9.1.15.
        result = [month + 1, this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds()];
        year = (
            (year < 0 ? '-' : (year > 9999 ? '+' : '')) +
            strSlice('00000' + Math.abs(year), (0 <= year && year <= 9999) ? -4 : -6)
        );

        length = result.length;
        while (length--) {
            value = result[length];
            // pad months, days, hours, minutes, and seconds to have two
            // digits.
            if (value < 10) {
                result[length] = '0' + value;
            }
        }
        // pad milliseconds to have three digits.
        return (
            year + '-' + array_slice.call(result, 0, 2).join('-') +
            'T' + array_slice.call(result, 2).join(':') + '.' +
            strSlice('000' + this.getUTCMilliseconds(), -3) + 'Z'
        );
    }
}, hasNegativeDateBug || hasSafari51DateBug);

// ES5 15.9.5.44
// http://es5.github.com/#x15.9.5.44
// This function provides a String representation of a Date object for use by
// JSON.stringify (15.12.3).
var dateToJSONIsSupported = (function () {
    try {
        return Date.prototype.toJSON &&
            new Date(NaN).toJSON() === null &&
            new Date(negativeDate).toJSON().indexOf(negativeYearString) !== -1 &&
            Date.prototype.toJSON.call({ // generic
                toISOString: function () { return true; }
            });
    } catch (e) {
        return false;
    }
}());
if (!dateToJSONIsSupported) {
    Date.prototype.toJSON = function toJSON(key) {
        // When the toJSON method is called with argument key, the following
        // steps are taken:

        // 1.  Let O be the result of calling ToObject, giving it the this
        // value as its argument.
        // 2. Let tv be ES.ToPrimitive(O, hint Number).
        var O = $Object(this);
        var tv = ES.ToPrimitive(O);
        // 3. If tv is a Number and is not finite, return null.
        if (typeof tv === 'number' && !isFinite(tv)) {
            return null;
        }
        // 4. Let toISO be the result of calling the [[Get]] internal method of
        // O with argument "toISOString".
        var toISO = O.toISOString;
        // 5. If IsCallable(toISO) is false, throw a TypeError exception.
        if (!isCallable(toISO)) {
            throw new TypeError('toISOString property is not callable');
        }
        // 6. Return the result of calling the [[Call]] internal method of
        //  toISO with O as the this value and an empty argument list.
        return toISO.call(O);

        // NOTE 1 The argument is ignored.

        // NOTE 2 The toJSON function is intentionally generic; it does not
        // require that its this value be a Date object. Therefore, it can be
        // transferred to other kinds of objects for use as a method. However,
        // it does require that any such object have a toISOString method. An
        // object is free to use the argument key to filter its
        // stringification.
    };
}

// ES5 15.9.4.2
// http://es5.github.com/#x15.9.4.2
// based on work shared by Daniel Friesen (dantman)
// http://gist.github.com/303249
var supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
var acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z')) || !isNaN(Date.parse('2012-12-31T23:59:60.000Z'));
var doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));
if (doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
    // XXX global assignment won't work in embeddings that use
    // an alternate object for the context.
    /* global Date: true */
    /* eslint-disable no-undef */
    var maxSafeUnsigned32Bit = Math.pow(2, 31) - 1;
    var secondsWithinMaxSafeUnsigned32Bit = Math.floor(maxSafeUnsigned32Bit / 1e3);
    var hasSafariSignedIntBug = isActualNaN(new Date(1970, 0, 1, 0, 0, 0, maxSafeUnsigned32Bit + 1).getTime());
    Date = (function (NativeDate) {
    /* eslint-enable no-undef */
        // Date.length === 7
        var DateShim = function Date(Y, M, D, h, m, s, ms) {
            var length = arguments.length;
            var date;
            if (this instanceof NativeDate) {
                var seconds = s;
                var millis = ms;
                if (hasSafariSignedIntBug && length >= 7 && ms > maxSafeUnsigned32Bit) {
                    // work around a Safari 8/9 bug where it treats the seconds as signed
                    var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
                    var sToShift = Math.floor(msToShift / 1e3);
                    seconds += sToShift;
                    millis -= sToShift * 1e3;
                }
                date = length === 1 && $String(Y) === Y ? // isString(Y)
                    // We explicitly pass it through parse:
                    new NativeDate(DateShim.parse(Y)) :
                    // We have to manually make calls depending on argument
                    // length here
                    length >= 7 ? new NativeDate(Y, M, D, h, m, seconds, millis) :
                    length >= 6 ? new NativeDate(Y, M, D, h, m, seconds) :
                    length >= 5 ? new NativeDate(Y, M, D, h, m) :
                    length >= 4 ? new NativeDate(Y, M, D, h) :
                    length >= 3 ? new NativeDate(Y, M, D) :
                    length >= 2 ? new NativeDate(Y, M) :
                    length >= 1 ? new NativeDate(Y) :
                                  new NativeDate();
            } else {
                date = NativeDate.apply(this, arguments);
            }
            if (!isPrimitive(date)) {
              // Prevent mixups with unfixed Date object
              defineProperties(date, { constructor: DateShim }, true);
            }
            return date;
        };

        // 15.9.1.15 Date Time String Format.
        var isoDateExpression = new RegExp('^' +
            '(\\d{4}|[+-]\\d{6})' + // four-digit year capture or sign +
                                      // 6-digit extended year
            '(?:-(\\d{2})' + // optional month capture
            '(?:-(\\d{2})' + // optional day capture
            '(?:' + // capture hours:minutes:seconds.milliseconds
                'T(\\d{2})' + // hours capture
                ':(\\d{2})' + // minutes capture
                '(?:' + // optional :seconds.milliseconds
                    ':(\\d{2})' + // seconds capture
                    '(?:(\\.\\d{1,}))?' + // milliseconds capture
                ')?' +
            '(' + // capture UTC offset component
                'Z|' + // UTC capture
                '(?:' + // offset specifier +/-hours:minutes
                    '([-+])' + // sign capture
                    '(\\d{2})' + // hours offset capture
                    ':(\\d{2})' + // minutes offset capture
                ')' +
            ')?)?)?)?' +
        '$');

        var months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];

        var dayFromMonth = function dayFromMonth(year, month) {
            var t = month > 1 ? 1 : 0;
            return (
                months[month] +
                Math.floor((year - 1969 + t) / 4) -
                Math.floor((year - 1901 + t) / 100) +
                Math.floor((year - 1601 + t) / 400) +
                365 * (year - 1970)
            );
        };

        var toUTC = function toUTC(t) {
            var s = 0;
            var ms = t;
            if (hasSafariSignedIntBug && ms > maxSafeUnsigned32Bit) {
                // work around a Safari 8/9 bug where it treats the seconds as signed
                var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
                var sToShift = Math.floor(msToShift / 1e3);
                s += sToShift;
                ms -= sToShift * 1e3;
            }
            return $Number(new NativeDate(1970, 0, 1, 0, 0, s, ms));
        };

        // Copy any custom methods a 3rd party library may have added
        for (var key in NativeDate) {
            if (owns(NativeDate, key)) {
                DateShim[key] = NativeDate[key];
            }
        }

        // Copy "native" methods explicitly; they may be non-enumerable
        defineProperties(DateShim, {
            now: NativeDate.now,
            UTC: NativeDate.UTC
        }, true);
        DateShim.prototype = NativeDate.prototype;
        defineProperties(DateShim.prototype, {
            constructor: DateShim
        }, true);

        // Upgrade Date.parse to handle simplified ISO 8601 strings
        var parseShim = function parse(string) {
            var match = isoDateExpression.exec(string);
            if (match) {
                // parse months, days, hours, minutes, seconds, and milliseconds
                // provide default values if necessary
                // parse the UTC offset component
                var year = $Number(match[1]),
                    month = $Number(match[2] || 1) - 1,
                    day = $Number(match[3] || 1) - 1,
                    hour = $Number(match[4] || 0),
                    minute = $Number(match[5] || 0),
                    second = $Number(match[6] || 0),
                    millisecond = Math.floor($Number(match[7] || 0) * 1000),
                    // When time zone is missed, local offset should be used
                    // (ES 5.1 bug)
                    // see https://bugs.ecmascript.org/show_bug.cgi?id=112
                    isLocalTime = Boolean(match[4] && !match[8]),
                    signOffset = match[9] === '-' ? 1 : -1,
                    hourOffset = $Number(match[10] || 0),
                    minuteOffset = $Number(match[11] || 0),
                    result;
                var hasMinutesOrSecondsOrMilliseconds = minute > 0 || second > 0 || millisecond > 0;
                if (
                    hour < (hasMinutesOrSecondsOrMilliseconds ? 24 : 25) &&
                    minute < 60 && second < 60 && millisecond < 1000 &&
                    month > -1 && month < 12 && hourOffset < 24 &&
                    minuteOffset < 60 && // detect invalid offsets
                    day > -1 &&
                    day < (dayFromMonth(year, month + 1) - dayFromMonth(year, month))
                ) {
                    result = (
                        (dayFromMonth(year, month) + day) * 24 +
                        hour +
                        hourOffset * signOffset
                    ) * 60;
                    result = (
                        (result + minute + minuteOffset * signOffset) * 60 +
                        second
                    ) * 1000 + millisecond;
                    if (isLocalTime) {
                        result = toUTC(result);
                    }
                    if (-8.64e15 <= result && result <= 8.64e15) {
                        return result;
                    }
                }
                return NaN;
            }
            return NativeDate.parse.apply(this, arguments);
        };
        defineProperties(DateShim, { parse: parseShim });

        return DateShim;
    }(Date));
    /* global Date: false */
}

// ES5 15.9.4.4
// http://es5.github.com/#x15.9.4.4
if (!Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}

//
// Number
// ======
//

// ES5.1 15.7.4.5
// http://es5.github.com/#x15.7.4.5
var hasToFixedBugs = NumberPrototype.toFixed && (
  (0.00008).toFixed(3) !== '0.000' ||
  (0.9).toFixed(0) !== '1' ||
  (1.255).toFixed(2) !== '1.25' ||
  (1000000000000000128).toFixed(0) !== '1000000000000000128'
);

var toFixedHelpers = {
  base: 1e7,
  size: 6,
  data: [0, 0, 0, 0, 0, 0],
  multiply: function multiply(n, c) {
      var i = -1;
      var c2 = c;
      while (++i < toFixedHelpers.size) {
          c2 += n * toFixedHelpers.data[i];
          toFixedHelpers.data[i] = c2 % toFixedHelpers.base;
          c2 = Math.floor(c2 / toFixedHelpers.base);
      }
  },
  divide: function divide(n) {
      var i = toFixedHelpers.size, c = 0;
      while (--i >= 0) {
          c += toFixedHelpers.data[i];
          toFixedHelpers.data[i] = Math.floor(c / n);
          c = (c % n) * toFixedHelpers.base;
      }
  },
  numToString: function numToString() {
      var i = toFixedHelpers.size;
      var s = '';
      while (--i >= 0) {
          if (s !== '' || i === 0 || toFixedHelpers.data[i] !== 0) {
              var t = $String(toFixedHelpers.data[i]);
              if (s === '') {
                  s = t;
              } else {
                  s += strSlice('0000000', 0, 7 - t.length) + t;
              }
          }
      }
      return s;
  },
  pow: function pow(x, n, acc) {
      return (n === 0 ? acc : (n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc)));
  },
  log: function log(x) {
      var n = 0;
      var x2 = x;
      while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
      }
      while (x2 >= 2) {
          n += 1;
          x2 /= 2;
      }
      return n;
  }
};

var toFixedShim = function toFixed(fractionDigits) {
    var f, x, s, m, e, z, j, k;

    // Test for NaN and round fractionDigits down
    f = $Number(fractionDigits);
    f = isActualNaN(f) ? 0 : Math.floor(f);

    if (f < 0 || f > 20) {
        throw new RangeError('Number.toFixed called with invalid number of decimals');
    }

    x = $Number(this);

    if (isActualNaN(x)) {
        return 'NaN';
    }

    // If it is too big or small, return the string value of the number
    if (x <= -1e21 || x >= 1e21) {
        return $String(x);
    }

    s = '';

    if (x < 0) {
        s = '-';
        x = -x;
    }

    m = '0';

    if (x > 1e-21) {
        // 1e-21 < x < 1e21
        // -70 < log2(x) < 70
        e = toFixedHelpers.log(x * toFixedHelpers.pow(2, 69, 1)) - 69;
        z = (e < 0 ? x * toFixedHelpers.pow(2, -e, 1) : x / toFixedHelpers.pow(2, e, 1));
        z *= 0x10000000000000; // Math.pow(2, 52);
        e = 52 - e;

        // -18 < e < 122
        // x = z / 2 ^ e
        if (e > 0) {
            toFixedHelpers.multiply(0, z);
            j = f;

            while (j >= 7) {
                toFixedHelpers.multiply(1e7, 0);
                j -= 7;
            }

            toFixedHelpers.multiply(toFixedHelpers.pow(10, j, 1), 0);
            j = e - 1;

            while (j >= 23) {
                toFixedHelpers.divide(1 << 23);
                j -= 23;
            }

            toFixedHelpers.divide(1 << j);
            toFixedHelpers.multiply(1, 1);
            toFixedHelpers.divide(2);
            m = toFixedHelpers.numToString();
        } else {
            toFixedHelpers.multiply(0, z);
            toFixedHelpers.multiply(1 << (-e), 0);
            m = toFixedHelpers.numToString() + strSlice('0.00000000000000000000', 2, 2 + f);
        }
    }

    if (f > 0) {
        k = m.length;

        if (k <= f) {
            m = s + strSlice('0.0000000000000000000', 0, f - k + 2) + m;
        } else {
            m = s + strSlice(m, 0, k - f) + '.' + strSlice(m, k - f);
        }
    } else {
        m = s + m;
    }

    return m;
};
defineProperties(NumberPrototype, { toFixed: toFixedShim }, hasToFixedBugs);

var hasToPrecisionUndefinedBug = (function () {
    try {
        return 1.0.toPrecision(undefined) === '1';
    } catch (e) {
        return true;
    }
}());
var originalToPrecision = NumberPrototype.toPrecision;
defineProperties(NumberPrototype, {
    toPrecision: function toPrecision(precision) {
        return typeof precision === 'undefined' ? originalToPrecision.call(this) : originalToPrecision.call(this, precision);
    }
}, hasToPrecisionUndefinedBug);

//
// String
// ======
//

// ES5 15.5.4.14
// http://es5.github.com/#x15.5.4.14

// [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
// Many browsers do not split properly with regular expressions or they
// do not perform the split correctly under obscure conditions.
// See http://blog.stevenlevithan.com/archives/cross-browser-split
// I've tested in many browsers and this seems to cover the deviant ones:
//    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
//    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
//    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
//       [undefined, "t", undefined, "e", ...]
//    ''.split(/.?/) should be [], not [""]
//    '.'.split(/()()/) should be ["."], not ["", "", "."]

if (
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    'tesst'.split(/(s)*/)[1] === 't' ||
    'test'.split(/(?:)/, -1).length !== 4 ||
    ''.split(/.?/).length ||
    '.'.split(/()()/).length > 1
) {
    (function () {
        var compliantExecNpcg = typeof (/()??/).exec('')[1] === 'undefined'; // NPCG: nonparticipating capturing group
        var maxSafe32BitInt = Math.pow(2, 32) - 1;

        StringPrototype.split = function (separator, limit) {
            var string = this;
            if (typeof separator === 'undefined' && limit === 0) {
                return [];
            }

            // If `separator` is not a regex, use native split
            if (!isRegex(separator)) {
                return strSplit(this, separator, limit);
            }

            var output = [];
            var flags = (separator.ignoreCase ? 'i' : '') +
                        (separator.multiline ? 'm' : '') +
                        (separator.unicode ? 'u' : '') + // in ES6
                        (separator.sticky ? 'y' : ''), // Firefox 3+ and ES6
                lastLastIndex = 0,
                // Make `global` and avoid `lastIndex` issues by working with a copy
                separator2, match, lastIndex, lastLength;
            var separatorCopy = new RegExp(separator.source, flags + 'g');
            string += ''; // Type-convert
            if (!compliantExecNpcg) {
                // Doesn't need flags gy, but they don't hurt
                separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
            }
            /* Values for `limit`, per the spec:
             * If undefined: 4294967295 // maxSafe32BitInt
             * If 0, Infinity, or NaN: 0
             * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
             * If negative number: 4294967296 - Math.floor(Math.abs(limit))
             * If other: Type-convert, then use the above rules
             */
            var splitLimit = typeof limit === 'undefined' ? maxSafe32BitInt : ES.ToUint32(limit);
            match = separatorCopy.exec(string);
            while (match) {
                // `separatorCopy.lastIndex` is not reliable cross-browser
                lastIndex = match.index + match[0].length;
                if (lastIndex > lastLastIndex) {
                    push(output, strSlice(string, lastLastIndex, match.index));
                    // Fix browsers whose `exec` methods don't consistently return `undefined` for
                    // nonparticipating capturing groups
                    if (!compliantExecNpcg && match.length > 1) {
                        /* eslint-disable no-loop-func */
                        match[0].replace(separator2, function () {
                            for (var i = 1; i < arguments.length - 2; i++) {
                                if (typeof arguments[i] === 'undefined') {
                                    match[i] = void 0;
                                }
                            }
                        });
                        /* eslint-enable no-loop-func */
                    }
                    if (match.length > 1 && match.index < string.length) {
                        array_push.apply(output, array_slice.call(match, 1));
                    }
                    lastLength = match[0].length;
                    lastLastIndex = lastIndex;
                    if (output.length >= splitLimit) {
                        break;
                    }
                }
                if (separatorCopy.lastIndex === match.index) {
                    separatorCopy.lastIndex++; // Avoid an infinite loop
                }
                match = separatorCopy.exec(string);
            }
            if (lastLastIndex === string.length) {
                if (lastLength || !separatorCopy.test('')) {
                    push(output, '');
                }
            } else {
                push(output, strSlice(string, lastLastIndex));
            }
            return output.length > splitLimit ? arraySlice(output, 0, splitLimit) : output;
        };
    }());

// [bugfix, chrome]
// If separator is undefined, then the result array contains just one String,
// which is the this value (converted to a String). If limit is not undefined,
// then the output array is truncated so that it contains no more than limit
// elements.
// "0".split(undefined, 0) -> []
} else if ('0'.split(void 0, 0).length) {
    StringPrototype.split = function split(separator, limit) {
        if (typeof separator === 'undefined' && limit === 0) { return []; }
        return strSplit(this, separator, limit);
    };
}

var str_replace = StringPrototype.replace;
var replaceReportsGroupsCorrectly = (function () {
    var groups = [];
    'x'.replace(/x(.)?/g, function (match, group) {
        push(groups, group);
    });
    return groups.length === 1 && typeof groups[0] === 'undefined';
}());

if (!replaceReportsGroupsCorrectly) {
    StringPrototype.replace = function replace(searchValue, replaceValue) {
        var isFn = isCallable(replaceValue);
        var hasCapturingGroups = isRegex(searchValue) && (/\)[*?]/).test(searchValue.source);
        if (!isFn || !hasCapturingGroups) {
            return str_replace.call(this, searchValue, replaceValue);
        } else {
            var wrappedReplaceValue = function (match) {
                var length = arguments.length;
                var originalLastIndex = searchValue.lastIndex;
                searchValue.lastIndex = 0;
                var args = searchValue.exec(match) || [];
                searchValue.lastIndex = originalLastIndex;
                push(args, arguments[length - 2], arguments[length - 1]);
                return replaceValue.apply(this, args);
            };
            return str_replace.call(this, searchValue, wrappedReplaceValue);
        }
    };
}

// ECMA-262, 3rd B.2.3
// Not an ECMAScript standard, although ECMAScript 3rd Edition has a
// non-normative section suggesting uniform semantics and it should be
// normalized across all browsers
// [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
var string_substr = StringPrototype.substr;
var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
defineProperties(StringPrototype, {
    substr: function substr(start, length) {
        var normalizedStart = start;
        if (start < 0) {
            normalizedStart = max(this.length + start, 0);
        }
        return string_substr.call(this, normalizedStart, length);
    }
}, hasNegativeSubstrBug);

// ES5 15.5.4.20
// whitespace from: http://es5.github.io/#x15.5.4.20
var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
    '\u2029\uFEFF';
var zeroWidth = '\u200b';
var wsRegexChars = '[' + ws + ']';
var trimBeginRegexp = new RegExp('^' + wsRegexChars + wsRegexChars + '*');
var trimEndRegexp = new RegExp(wsRegexChars + wsRegexChars + '*$');
var hasTrimWhitespaceBug = StringPrototype.trim && (ws.trim() || !zeroWidth.trim());
defineProperties(StringPrototype, {
    // http://blog.stevenlevithan.com/archives/faster-trim-javascript
    // http://perfectionkills.com/whitespace-deviations/
    trim: function trim() {
        if (typeof this === 'undefined' || this === null) {
            throw new TypeError("can't convert " + this + ' to object');
        }
        return $String(this).replace(trimBeginRegexp, '').replace(trimEndRegexp, '');
    }
}, hasTrimWhitespaceBug);

var hasLastIndexBug = StringPrototype.lastIndexOf && 'abcあい'.lastIndexOf('あい', 2) !== -1;
defineProperties(StringPrototype, {
    lastIndexOf: function lastIndexOf(searchString) {
        if (typeof this === 'undefined' || this === null) {
            throw new TypeError("can't convert " + this + ' to object');
        }
        var S = $String(this);
        var searchStr = $String(searchString);
        var numPos = arguments.length > 1 ? $Number(arguments[1]) : NaN;
        var pos = isActualNaN(numPos) ? Infinity : ES.ToInteger(numPos);
        var start = min(max(pos, 0), S.length);
        var searchLen = searchStr.length;
        var k = start + searchLen;
        while (k > 0) {
            k = max(0, k - searchLen);
            var index = strIndexOf(strSlice(S, k, start + searchLen), searchStr);
            if (index !== -1) {
                return k + index;
            }
        }
        return -1;
    }
}, hasLastIndexBug);

var originalLastIndexOf = StringPrototype.lastIndexOf;
defineProperties(StringPrototype, {
    lastIndexOf: function lastIndexOf(searchString) {
        return originalLastIndexOf.apply(this, arguments);
    }
}, StringPrototype.lastIndexOf.length !== 1);

// ES-5 15.1.2.2
/* eslint-disable radix */
if (parseInt(ws + '08') !== 8 || parseInt(ws + '0x16') !== 22) {
/* eslint-enable radix */
    /* global parseInt: true */
    parseInt = (function (origParseInt) {
        var hexRegex = /^[\-+]?0[xX]/;
        return function parseInt(str, radix) {
            var string = $String(str).trim();
            var defaultedRadix = $Number(radix) || (hexRegex.test(string) ? 16 : 10);
            return origParseInt(string, defaultedRadix);
        };
    }(parseInt));
}

if (String(new RangeError('test')) !== 'RangeError: test') {
    var originalErrorToString = Error.prototype.toString;
    var errorToStringShim = function toString() {
        if (typeof this === 'undefined' || this === null) {
            throw new TypeError("can't convert " + this + ' to object');
        }
        var name = this.name;
        if (typeof name === 'undefined') {
            name = 'Error';
        } else if (typeof name !== 'string') {
            name = $String(name);
        }
        var msg = this.message;
        if (typeof msg === 'undefined') {
            msg = '';
        } else if (typeof msg !== 'string') {
            msg = $String(msg);
        }
        if (!name) {
            return msg;
        }
        if (!msg) {
            return name;
        }
        return name + ': ' + msg;
    };
    // can't use defineProperties here because of toString enumeration issue in IE <= 8
    Error.prototype.toString = errorToStringShim;
}

}));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!
 * Select2 4.0.5
 * https://select2.github.io
 *
 * Released under the MIT license
 * https://github.com/select2/select2/blob/master/LICENSE.md
 */
(function (factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = function (root, jQuery) {
      if (jQuery === undefined) {
        // require('jQuery') returns a factory that requires window to
        // build a jQuery instance, we normalize how we use modules
        // that require this pattern but the window provided is a noop
        // if it's defined (how jquery works)
        if (typeof window !== 'undefined') {
          jQuery = require('jquery');
        }
        else {
          jQuery = require('jquery')(root);
        }
      }
      factory(jQuery);
      return jQuery;
    };
  } else {
    // Browser globals
    factory(jQuery);
  }
} (function (jQuery) {
  // This is needed so we can catch the AMD loader configuration and use it
  // The inner file should be wrapped (by `banner.start.js`) in a function that
  // returns the AMD loader references.
  var S2 =(function () {
  // Restore the Select2 AMD loader so it can be used
  // Needed mostly in the language files, where the loader is not inserted
  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
    var S2 = jQuery.fn.select2.amd;
  }
var S2;(function () { if (!S2 || !S2.requirejs) {
if (!S2) { S2 = {}; } else { require = S2; }
/**
 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name) {
            name = name.split('/');
            lastIndex = name.length - 1;

            // If wanting node ID compatibility, strip .js from end
            // of IDs. Have to do this here, and not in nameToUrl
            // because node allows either .js or non .js to map
            // to same file.
            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
            }

            // Starts with a '.' so need the baseName
            if (name[0].charAt(0) === '.' && baseParts) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that 'directory' and not name of the baseName's
                //module. For instance, baseName of 'one/two/three', maps to
                //'one/two/three.js', but we want the directory, 'one/two' for
                //this normalization.
                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                name = normalizedBaseParts.concat(name);
            }

            //start trimDots
            for (i = 0; i < name.length; i++) {
                part = name[i];
                if (part === '.') {
                    name.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        name.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
            //end trimDots

            name = name.join('/');
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    //Creates a parts array for a relName where first part is plugin ID,
    //second part is resource ID. Assumes relName has already been normalized.
    function makeRelParts(relName) {
        return relName ? splitPrefix(relName) : [];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relParts) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0],
            relResourceName = relParts[1];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relResourceName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relResourceName));
            } else {
                name = normalize(name, relResourceName);
            }
        } else {
            name = normalize(name, relResourceName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i, relParts,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;
        relParts = makeRelParts(relName);

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relParts);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, makeRelParts(callback)).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

S2.requirejs = requirejs;S2.require = require;S2.define = define;
}
}());
S2.define("almond", function(){});

/* global jQuery:false, $:false */
S2.define('jquery',[],function () {
  var _$ = jQuery || $;

  if (_$ == null && console && console.error) {
    console.error(
      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
      'found. Make sure that you are including jQuery before Select2 on your ' +
      'web page.'
    );
  }

  return _$;
});

S2.define('select2/utils',[
  'jquery'
], function ($) {
  var Utils = {};

  Utils.Extend = function (ChildClass, SuperClass) {
    var __hasProp = {}.hasOwnProperty;

    function BaseConstructor () {
      this.constructor = ChildClass;
    }

    for (var key in SuperClass) {
      if (__hasProp.call(SuperClass, key)) {
        ChildClass[key] = SuperClass[key];
      }
    }

    BaseConstructor.prototype = SuperClass.prototype;
    ChildClass.prototype = new BaseConstructor();
    ChildClass.__super__ = SuperClass.prototype;

    return ChildClass;
  };

  function getMethods (theClass) {
    var proto = theClass.prototype;

    var methods = [];

    for (var methodName in proto) {
      var m = proto[methodName];

      if (typeof m !== 'function') {
        continue;
      }

      if (methodName === 'constructor') {
        continue;
      }

      methods.push(methodName);
    }

    return methods;
  }

  Utils.Decorate = function (SuperClass, DecoratorClass) {
    var decoratedMethods = getMethods(DecoratorClass);
    var superMethods = getMethods(SuperClass);

    function DecoratedClass () {
      var unshift = Array.prototype.unshift;

      var argCount = DecoratorClass.prototype.constructor.length;

      var calledConstructor = SuperClass.prototype.constructor;

      if (argCount > 0) {
        unshift.call(arguments, SuperClass.prototype.constructor);

        calledConstructor = DecoratorClass.prototype.constructor;
      }

      calledConstructor.apply(this, arguments);
    }

    DecoratorClass.displayName = SuperClass.displayName;

    function ctr () {
      this.constructor = DecoratedClass;
    }

    DecoratedClass.prototype = new ctr();

    for (var m = 0; m < superMethods.length; m++) {
        var superMethod = superMethods[m];

        DecoratedClass.prototype[superMethod] =
          SuperClass.prototype[superMethod];
    }

    var calledMethod = function (methodName) {
      // Stub out the original method if it's not decorating an actual method
      var originalMethod = function () {};

      if (methodName in DecoratedClass.prototype) {
        originalMethod = DecoratedClass.prototype[methodName];
      }

      var decoratedMethod = DecoratorClass.prototype[methodName];

      return function () {
        var unshift = Array.prototype.unshift;

        unshift.call(arguments, originalMethod);

        return decoratedMethod.apply(this, arguments);
      };
    };

    for (var d = 0; d < decoratedMethods.length; d++) {
      var decoratedMethod = decoratedMethods[d];

      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
    }

    return DecoratedClass;
  };

  var Observable = function () {
    this.listeners = {};
  };

  Observable.prototype.on = function (event, callback) {
    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.listeners[event].push(callback);
    } else {
      this.listeners[event] = [callback];
    }
  };

  Observable.prototype.trigger = function (event) {
    var slice = Array.prototype.slice;
    var params = slice.call(arguments, 1);

    this.listeners = this.listeners || {};

    // Params should always come in as an array
    if (params == null) {
      params = [];
    }

    // If there are no arguments to the event, use a temporary object
    if (params.length === 0) {
      params.push({});
    }

    // Set the `_type` of the first object to the event
    params[0]._type = event;

    if (event in this.listeners) {
      this.invoke(this.listeners[event], slice.call(arguments, 1));
    }

    if ('*' in this.listeners) {
      this.invoke(this.listeners['*'], arguments);
    }
  };

  Observable.prototype.invoke = function (listeners, params) {
    for (var i = 0, len = listeners.length; i < len; i++) {
      listeners[i].apply(this, params);
    }
  };

  Utils.Observable = Observable;

  Utils.generateChars = function (length) {
    var chars = '';

    for (var i = 0; i < length; i++) {
      var randomChar = Math.floor(Math.random() * 36);
      chars += randomChar.toString(36);
    }

    return chars;
  };

  Utils.bind = function (func, context) {
    return function () {
      func.apply(context, arguments);
    };
  };

  Utils._convertData = function (data) {
    for (var originalKey in data) {
      var keys = originalKey.split('-');

      var dataLevel = data;

      if (keys.length === 1) {
        continue;
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k];

        // Lowercase the first letter
        // By default, dash-separated becomes camelCase
        key = key.substring(0, 1).toLowerCase() + key.substring(1);

        if (!(key in dataLevel)) {
          dataLevel[key] = {};
        }

        if (k == keys.length - 1) {
          dataLevel[key] = data[originalKey];
        }

        dataLevel = dataLevel[key];
      }

      delete data[originalKey];
    }

    return data;
  };

  Utils.hasScroll = function (index, el) {
    // Adapted from the function created by @ShadowScripter
    // and adapted by @BillBarry on the Stack Exchange Code Review website.
    // The original code can be found at
    // http://codereview.stackexchange.com/q/13338
    // and was designed to be used with the Sizzle selector engine.

    var $el = $(el);
    var overflowX = el.style.overflowX;
    var overflowY = el.style.overflowY;

    //Check both x and y declarations
    if (overflowX === overflowY &&
        (overflowY === 'hidden' || overflowY === 'visible')) {
      return false;
    }

    if (overflowX === 'scroll' || overflowY === 'scroll') {
      return true;
    }

    return ($el.innerHeight() < el.scrollHeight ||
      $el.innerWidth() < el.scrollWidth);
  };

  Utils.escapeMarkup = function (markup) {
    var replaceMap = {
      '\\': '&#92;',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#47;'
    };

    // Do not try to escape the markup if it's not a string
    if (typeof markup !== 'string') {
      return markup;
    }

    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
      return replaceMap[match];
    });
  };

  // Append an array of jQuery nodes to a given element.
  Utils.appendMany = function ($element, $nodes) {
    // jQuery 1.7.x does not support $.fn.append() with an array
    // Fall back to a jQuery object collection using $.fn.add()
    if ($.fn.jquery.substr(0, 3) === '1.7') {
      var $jqNodes = $();

      $.map($nodes, function (node) {
        $jqNodes = $jqNodes.add(node);
      });

      $nodes = $jqNodes;
    }

    $element.append($nodes);
  };

  return Utils;
});

S2.define('select2/results',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Results ($element, options, dataAdapter) {
    this.$element = $element;
    this.data = dataAdapter;
    this.options = options;

    Results.__super__.constructor.call(this);
  }

  Utils.Extend(Results, Utils.Observable);

  Results.prototype.render = function () {
    var $results = $(
      '<ul class="select2-results__options" role="tree"></ul>'
    );

    if (this.options.get('multiple')) {
      $results.attr('aria-multiselectable', 'true');
    }

    this.$results = $results;

    return $results;
  };

  Results.prototype.clear = function () {
    this.$results.empty();
  };

  Results.prototype.displayMessage = function (params) {
    var escapeMarkup = this.options.get('escapeMarkup');

    this.clear();
    this.hideLoading();

    var $message = $(
      '<li role="treeitem" aria-live="assertive"' +
      ' class="select2-results__option"></li>'
    );

    var message = this.options.get('translations').get(params.message);

    $message.append(
      escapeMarkup(
        message(params.args)
      )
    );

    $message[0].className += ' select2-results__message';

    this.$results.append($message);
  };

  Results.prototype.hideMessages = function () {
    this.$results.find('.select2-results__message').remove();
  };

  Results.prototype.append = function (data) {
    this.hideLoading();

    var $options = [];

    if (data.results == null || data.results.length === 0) {
      if (this.$results.children().length === 0) {
        this.trigger('results:message', {
          message: 'noResults'
        });
      }

      return;
    }

    data.results = this.sort(data.results);

    for (var d = 0; d < data.results.length; d++) {
      var item = data.results[d];

      var $option = this.option(item);

      $options.push($option);
    }

    this.$results.append($options);
  };

  Results.prototype.position = function ($results, $dropdown) {
    var $resultsContainer = $dropdown.find('.select2-results');
    $resultsContainer.append($results);
  };

  Results.prototype.sort = function (data) {
    var sorter = this.options.get('sorter');

    return sorter(data);
  };

  Results.prototype.highlightFirstItem = function () {
    var $options = this.$results
      .find('.select2-results__option[aria-selected]');

    var $selected = $options.filter('[aria-selected=true]');

    // Check if there are any selected options
    if ($selected.length > 0) {
      // If there are selected options, highlight the first
      $selected.first().trigger('mouseenter');
    } else {
      // If there are no selected options, highlight the first option
      // in the dropdown
      $options.first().trigger('mouseenter');
    }

    this.ensureHighlightVisible();
  };

  Results.prototype.setClasses = function () {
    var self = this;

    this.data.current(function (selected) {
      var selectedIds = $.map(selected, function (s) {
        return s.id.toString();
      });

      var $options = self.$results
        .find('.select2-results__option[aria-selected]');

      $options.each(function () {
        var $option = $(this);

        var item = $.data(this, 'data');

        // id needs to be converted to a string when comparing
        var id = '' + item.id;

        if ((item.element != null && item.element.selected) ||
            (item.element == null && $.inArray(id, selectedIds) > -1)) {
          $option.attr('aria-selected', 'true');
        } else {
          $option.attr('aria-selected', 'false');
        }
      });

    });
  };

  Results.prototype.showLoading = function (params) {
    this.hideLoading();

    var loadingMore = this.options.get('translations').get('searching');

    var loading = {
      disabled: true,
      loading: true,
      text: loadingMore(params)
    };
    var $loading = this.option(loading);
    $loading.className += ' loading-results';

    this.$results.prepend($loading);
  };

  Results.prototype.hideLoading = function () {
    this.$results.find('.loading-results').remove();
  };

  Results.prototype.option = function (data) {
    var option = document.createElement('li');
    option.className = 'select2-results__option';

    var attrs = {
      'role': 'treeitem',
      'aria-selected': 'false'
    };

    if (data.disabled) {
      delete attrs['aria-selected'];
      attrs['aria-disabled'] = 'true';
    }

    if (data.id == null) {
      delete attrs['aria-selected'];
    }

    if (data._resultId != null) {
      option.id = data._resultId;
    }

    if (data.title) {
      option.title = data.title;
    }

    if (data.children) {
      attrs.role = 'group';
      attrs['aria-label'] = data.text;
      delete attrs['aria-selected'];
    }

    for (var attr in attrs) {
      var val = attrs[attr];

      option.setAttribute(attr, val);
    }

    if (data.children) {
      var $option = $(option);

      var label = document.createElement('strong');
      label.className = 'select2-results__group';

      var $label = $(label);
      this.template(data, label);

      var $children = [];

      for (var c = 0; c < data.children.length; c++) {
        var child = data.children[c];

        var $child = this.option(child);

        $children.push($child);
      }

      var $childrenContainer = $('<ul></ul>', {
        'class': 'select2-results__options select2-results__options--nested'
      });

      $childrenContainer.append($children);

      $option.append(label);
      $option.append($childrenContainer);
    } else {
      this.template(data, option);
    }

    $.data(option, 'data', data);

    return option;
  };

  Results.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-results';

    this.$results.attr('id', id);

    container.on('results:all', function (params) {
      self.clear();
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
        self.highlightFirstItem();
      }
    });

    container.on('results:append', function (params) {
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('query', function (params) {
      self.hideMessages();
      self.showLoading(params);
    });

    container.on('select', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
      self.highlightFirstItem();
    });

    container.on('unselect', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
      self.highlightFirstItem();
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expended="true"
      self.$results.attr('aria-expanded', 'true');
      self.$results.attr('aria-hidden', 'false');

      self.setClasses();
      self.ensureHighlightVisible();
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expended="false"
      self.$results.attr('aria-expanded', 'false');
      self.$results.attr('aria-hidden', 'true');
      self.$results.removeAttr('aria-activedescendant');
    });

    container.on('results:toggle', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      $highlighted.trigger('mouseup');
    });

    container.on('results:select', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      var data = $highlighted.data('data');

      if ($highlighted.attr('aria-selected') == 'true') {
        self.trigger('close', {});
      } else {
        self.trigger('select', {
          data: data
        });
      }
    });

    container.on('results:previous', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      // If we are already at te top, don't move further
      if (currentIndex === 0) {
        return;
      }

      var nextIndex = currentIndex - 1;

      // If none are highlighted, highlight the first
      if ($highlighted.length === 0) {
        nextIndex = 0;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top;
      var nextTop = $next.offset().top;
      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextTop - currentOffset < 0) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:next', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      var nextIndex = currentIndex + 1;

      // If we are at the last option, stay there
      if (nextIndex >= $options.length) {
        return;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var nextBottom = $next.offset().top + $next.outerHeight(false);
      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextBottom > currentOffset) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:focus', function (params) {
      params.element.addClass('select2-results__option--highlighted');
    });

    container.on('results:message', function (params) {
      self.displayMessage(params);
    });

    if ($.fn.mousewheel) {
      this.$results.on('mousewheel', function (e) {
        var top = self.$results.scrollTop();

        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;

        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

        if (isAtTop) {
          self.$results.scrollTop(0);

          e.preventDefault();
          e.stopPropagation();
        } else if (isAtBottom) {
          self.$results.scrollTop(
            self.$results.get(0).scrollHeight - self.$results.height()
          );

          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
      function (evt) {
      var $this = $(this);

      var data = $this.data('data');

      if ($this.attr('aria-selected') === 'true') {
        if (self.options.get('multiple')) {
          self.trigger('unselect', {
            originalEvent: evt,
            data: data
          });
        } else {
          self.trigger('close', {});
        }

        return;
      }

      self.trigger('select', {
        originalEvent: evt,
        data: data
      });
    });

    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
      function (evt) {
      var data = $(this).data('data');

      self.getHighlightedResults()
          .removeClass('select2-results__option--highlighted');

      self.trigger('results:focus', {
        data: data,
        element: $(this)
      });
    });
  };

  Results.prototype.getHighlightedResults = function () {
    var $highlighted = this.$results
    .find('.select2-results__option--highlighted');

    return $highlighted;
  };

  Results.prototype.destroy = function () {
    this.$results.remove();
  };

  Results.prototype.ensureHighlightVisible = function () {
    var $highlighted = this.getHighlightedResults();

    if ($highlighted.length === 0) {
      return;
    }

    var $options = this.$results.find('[aria-selected]');

    var currentIndex = $options.index($highlighted);

    var currentOffset = this.$results.offset().top;
    var nextTop = $highlighted.offset().top;
    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

    var offsetDelta = nextTop - currentOffset;
    nextOffset -= $highlighted.outerHeight(false) * 2;

    if (currentIndex <= 2) {
      this.$results.scrollTop(0);
    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
      this.$results.scrollTop(nextOffset);
    }
  };

  Results.prototype.template = function (result, container) {
    var template = this.options.get('templateResult');
    var escapeMarkup = this.options.get('escapeMarkup');

    var content = template(result, container);

    if (content == null) {
      container.style.display = 'none';
    } else if (typeof content === 'string') {
      container.innerHTML = escapeMarkup(content);
    } else {
      $(container).append(content);
    }
  };

  return Results;
});

S2.define('select2/keys',[

], function () {
  var KEYS = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46
  };

  return KEYS;
});

S2.define('select2/selection/base',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function BaseSelection ($element, options) {
    this.$element = $element;
    this.options = options;

    BaseSelection.__super__.constructor.call(this);
  }

  Utils.Extend(BaseSelection, Utils.Observable);

  BaseSelection.prototype.render = function () {
    var $selection = $(
      '<span class="select2-selection" role="combobox" ' +
      ' aria-haspopup="true" aria-expanded="false">' +
      '</span>'
    );

    this._tabindex = 0;

    if (this.$element.data('old-tabindex') != null) {
      this._tabindex = this.$element.data('old-tabindex');
    } else if (this.$element.attr('tabindex') != null) {
      this._tabindex = this.$element.attr('tabindex');
    }

    $selection.attr('title', this.$element.attr('title'));
    $selection.attr('tabindex', this._tabindex);

    this.$selection = $selection;

    return $selection;
  };

  BaseSelection.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-container';
    var resultsId = container.id + '-results';

    this.container = container;

    this.$selection.on('focus', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('blur', function (evt) {
      self._handleBlur(evt);
    });

    this.$selection.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      if (evt.which === KEYS.SPACE) {
        evt.preventDefault();
      }
    });

    container.on('results:focus', function (params) {
      self.$selection.attr('aria-activedescendant', params.data._resultId);
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expanded="true"
      self.$selection.attr('aria-expanded', 'true');
      self.$selection.attr('aria-owns', resultsId);

      self._attachCloseHandler(container);
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expanded="false"
      self.$selection.attr('aria-expanded', 'false');
      self.$selection.removeAttr('aria-activedescendant');
      self.$selection.removeAttr('aria-owns');

      self.$selection.focus();

      self._detachCloseHandler(container);
    });

    container.on('enable', function () {
      self.$selection.attr('tabindex', self._tabindex);
    });

    container.on('disable', function () {
      self.$selection.attr('tabindex', '-1');
    });
  };

  BaseSelection.prototype._handleBlur = function (evt) {
    var self = this;

    // This needs to be delayed as the active element is the body when the tab
    // key is pressed, possibly along with others.
    window.setTimeout(function () {
      // Don't trigger `blur` if the focus is still in the selection
      if (
        (document.activeElement == self.$selection[0]) ||
        ($.contains(self.$selection[0], document.activeElement))
      ) {
        return;
      }

      self.trigger('blur', evt);
    }, 1);
  };

  BaseSelection.prototype._attachCloseHandler = function (container) {
    var self = this;

    $(document.body).on('mousedown.select2.' + container.id, function (e) {
      var $target = $(e.target);

      var $select = $target.closest('.select2');

      var $all = $('.select2.select2-container--open');

      $all.each(function () {
        var $this = $(this);

        if (this == $select[0]) {
          return;
        }

        var $element = $this.data('element');

        $element.select2('close');
      });
    });
  };

  BaseSelection.prototype._detachCloseHandler = function (container) {
    $(document.body).off('mousedown.select2.' + container.id);
  };

  BaseSelection.prototype.position = function ($selection, $container) {
    var $selectionContainer = $container.find('.selection');
    $selectionContainer.append($selection);
  };

  BaseSelection.prototype.destroy = function () {
    this._detachCloseHandler(this.container);
  };

  BaseSelection.prototype.update = function (data) {
    throw new Error('The `update` method must be defined in child classes.');
  };

  return BaseSelection;
});

S2.define('select2/selection/single',[
  'jquery',
  './base',
  '../utils',
  '../keys'
], function ($, BaseSelection, Utils, KEYS) {
  function SingleSelection () {
    SingleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(SingleSelection, BaseSelection);

  SingleSelection.prototype.render = function () {
    var $selection = SingleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--single');

    $selection.html(
      '<span class="select2-selection__rendered"></span>' +
      '<span class="select2-selection__arrow" role="presentation">' +
        '<b role="presentation"></b>' +
      '</span>'
    );

    return $selection;
  };

  SingleSelection.prototype.bind = function (container, $container) {
    var self = this;

    SingleSelection.__super__.bind.apply(this, arguments);

    var id = container.id + '-container';

    this.$selection.find('.select2-selection__rendered').attr('id', id);
    this.$selection.attr('aria-labelledby', id);

    this.$selection.on('mousedown', function (evt) {
      // Only respond to left clicks
      if (evt.which !== 1) {
        return;
      }

      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('focus', function (evt) {
      // User focuses on the container
    });

    this.$selection.on('blur', function (evt) {
      // User exits the container
    });

    container.on('focus', function (evt) {
      if (!container.isOpen()) {
        self.$selection.focus();
      }
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });
  };

  SingleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  SingleSelection.prototype.display = function (data, container) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data, container));
  };

  SingleSelection.prototype.selectionContainer = function () {
    return $('<span></span>');
  };

  SingleSelection.prototype.update = function (data) {
    if (data.length === 0) {
      this.clear();
      return;
    }

    var selection = data[0];

    var $rendered = this.$selection.find('.select2-selection__rendered');
    var formatted = this.display(selection, $rendered);

    $rendered.empty().append(formatted);
    $rendered.prop('title', selection.title || selection.text);
  };

  return SingleSelection;
});

S2.define('select2/selection/multiple',[
  'jquery',
  './base',
  '../utils'
], function ($, BaseSelection, Utils) {
  function MultipleSelection ($element, options) {
    MultipleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(MultipleSelection, BaseSelection);

  MultipleSelection.prototype.render = function () {
    var $selection = MultipleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--multiple');

    $selection.html(
      '<ul class="select2-selection__rendered"></ul>'
    );

    return $selection;
  };

  MultipleSelection.prototype.bind = function (container, $container) {
    var self = this;

    MultipleSelection.__super__.bind.apply(this, arguments);

    this.$selection.on('click', function (evt) {
      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on(
      'click',
      '.select2-selection__choice__remove',
      function (evt) {
        // Ignore the event if it is disabled
        if (self.options.get('disabled')) {
          return;
        }

        var $remove = $(this);
        var $selection = $remove.parent();

        var data = $selection.data('data');

        self.trigger('unselect', {
          originalEvent: evt,
          data: data
        });
      }
    );
  };

  MultipleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  MultipleSelection.prototype.display = function (data, container) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data, container));
  };

  MultipleSelection.prototype.selectionContainer = function () {
    var $container = $(
      '<li class="select2-selection__choice">' +
        '<span class="select2-selection__choice__remove" role="presentation">' +
          '&times;' +
        '</span>' +
      '</li>'
    );

    return $container;
  };

  MultipleSelection.prototype.update = function (data) {
    this.clear();

    if (data.length === 0) {
      return;
    }

    var $selections = [];

    for (var d = 0; d < data.length; d++) {
      var selection = data[d];

      var $selection = this.selectionContainer();
      var formatted = this.display(selection, $selection);

      $selection.append(formatted);
      $selection.prop('title', selection.title || selection.text);

      $selection.data('data', selection);

      $selections.push($selection);
    }

    var $rendered = this.$selection.find('.select2-selection__rendered');

    Utils.appendMany($rendered, $selections);
  };

  return MultipleSelection;
});

S2.define('select2/selection/placeholder',[
  '../utils'
], function (Utils) {
  function Placeholder (decorated, $element, options) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options);
  }

  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
    var $placeholder = this.selectionContainer();

    $placeholder.html(this.display(placeholder));
    $placeholder.addClass('select2-selection__placeholder')
                .removeClass('select2-selection__choice');

    return $placeholder;
  };

  Placeholder.prototype.update = function (decorated, data) {
    var singlePlaceholder = (
      data.length == 1 && data[0].id != this.placeholder.id
    );
    var multipleSelections = data.length > 1;

    if (multipleSelections || singlePlaceholder) {
      return decorated.call(this, data);
    }

    this.clear();

    var $placeholder = this.createPlaceholder(this.placeholder);

    this.$selection.find('.select2-selection__rendered').append($placeholder);
  };

  return Placeholder;
});

S2.define('select2/selection/allowClear',[
  'jquery',
  '../keys'
], function ($, KEYS) {
  function AllowClear () { }

  AllowClear.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    if (this.placeholder == null) {
      if (this.options.get('debug') && window.console && console.error) {
        console.error(
          'Select2: The `allowClear` option should be used in combination ' +
          'with the `placeholder` option.'
        );
      }
    }

    this.$selection.on('mousedown', '.select2-selection__clear',
      function (evt) {
        self._handleClear(evt);
    });

    container.on('keypress', function (evt) {
      self._handleKeyboardClear(evt, container);
    });
  };

  AllowClear.prototype._handleClear = function (_, evt) {
    // Ignore the event if it is disabled
    if (this.options.get('disabled')) {
      return;
    }

    var $clear = this.$selection.find('.select2-selection__clear');

    // Ignore the event if nothing has been selected
    if ($clear.length === 0) {
      return;
    }

    evt.stopPropagation();

    var data = $clear.data('data');

    for (var d = 0; d < data.length; d++) {
      var unselectData = {
        data: data[d]
      };

      // Trigger the `unselect` event, so people can prevent it from being
      // cleared.
      this.trigger('unselect', unselectData);

      // If the event was prevented, don't clear it out.
      if (unselectData.prevented) {
        return;
      }
    }

    this.$element.val(this.placeholder.id).trigger('change');

    this.trigger('toggle', {});
  };

  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
    if (container.isOpen()) {
      return;
    }

    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
      this._handleClear(evt);
    }
  };

  AllowClear.prototype.update = function (decorated, data) {
    decorated.call(this, data);

    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
        data.length === 0) {
      return;
    }

    var $remove = $(
      '<span class="select2-selection__clear">' +
        '&times;' +
      '</span>'
    );
    $remove.data('data', data);

    this.$selection.find('.select2-selection__rendered').prepend($remove);
  };

  return AllowClear;
});

S2.define('select2/selection/search',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function Search (decorated, $element, options) {
    decorated.call(this, $element, options);
  }

  Search.prototype.render = function (decorated) {
    var $search = $(
      '<li class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
        ' spellcheck="false" role="textbox" aria-autocomplete="list" />' +
      '</li>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    var $rendered = decorated.call(this);

    this._transferTabIndex();

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self.$search.trigger('focus');
    });

    container.on('close', function () {
      self.$search.val('');
      self.$search.removeAttr('aria-activedescendant');
      self.$search.trigger('focus');
    });

    container.on('enable', function () {
      self.$search.prop('disabled', false);

      self._transferTabIndex();
    });

    container.on('disable', function () {
      self.$search.prop('disabled', true);
    });

    container.on('focus', function (evt) {
      self.$search.trigger('focus');
    });

    container.on('results:focus', function (params) {
      self.$search.attr('aria-activedescendant', params.id);
    });

    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
      self._handleBlur(evt);
    });

    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
      evt.stopPropagation();

      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();

      var key = evt.which;

      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
        var $previousChoice = self.$searchContainer
          .prev('.select2-selection__choice');

        if ($previousChoice.length > 0) {
          var item = $previousChoice.data('data');

          self.searchRemoveChoice(item);

          evt.preventDefault();
        }
      }
    });

    // Try to detect the IE version should the `documentMode` property that
    // is stored on the document. This is only implemented in IE and is
    // slightly cleaner than doing a user agent check.
    // This property is not available in Edge, but Edge also doesn't have
    // this bug.
    var msie = document.documentMode;
    var disableInputEvents = msie && msie <= 11;

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$selection.on(
      'input.searchcheck',
      '.select2-search--inline',
      function (evt) {
        // IE will trigger the `input` event when a placeholder is used on a
        // search box. To get around this issue, we are forced to ignore all
        // `input` events in IE and keep using `keyup`.
        if (disableInputEvents) {
          self.$selection.off('input.search input.searchcheck');
          return;
        }

        // Unbind the duplicated `keyup` event
        self.$selection.off('keyup.search');
      }
    );

    this.$selection.on(
      'keyup.search input.search',
      '.select2-search--inline',
      function (evt) {
        // IE will trigger the `input` event when a placeholder is used on a
        // search box. To get around this issue, we are forced to ignore all
        // `input` events in IE and keep using `keyup`.
        if (disableInputEvents && evt.type === 'input') {
          self.$selection.off('input.search input.searchcheck');
          return;
        }

        var key = evt.which;

        // We can freely ignore events from modifier keys
        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
          return;
        }

        // Tabbing will be handled during the `keydown` phase
        if (key == KEYS.TAB) {
          return;
        }

        self.handleSearch(evt);
      }
    );
  };

  /**
   * This method will transfer the tabindex attribute from the rendered
   * selection to the search box. This allows for the search box to be used as
   * the primary focus instead of the selection container.
   *
   * @private
   */
  Search.prototype._transferTabIndex = function (decorated) {
    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
    this.$selection.attr('tabindex', '-1');
  };

  Search.prototype.createPlaceholder = function (decorated, placeholder) {
    this.$search.attr('placeholder', placeholder.text);
  };

  Search.prototype.update = function (decorated, data) {
    var searchHadFocus = this.$search[0] == document.activeElement;

    this.$search.attr('placeholder', '');

    decorated.call(this, data);

    this.$selection.find('.select2-selection__rendered')
                   .append(this.$searchContainer);

    this.resizeSearch();
    if (searchHadFocus) {
      this.$search.focus();
    }
  };

  Search.prototype.handleSearch = function () {
    this.resizeSearch();

    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.searchRemoveChoice = function (decorated, item) {
    this.trigger('unselect', {
      data: item
    });

    this.$search.val(item.text);
    this.handleSearch();
  };

  Search.prototype.resizeSearch = function () {
    this.$search.css('width', '25px');

    var width = '';

    if (this.$search.attr('placeholder') !== '') {
      width = this.$selection.find('.select2-selection__rendered').innerWidth();
    } else {
      var minimumWidth = this.$search.val().length + 1;

      width = (minimumWidth * 0.75) + 'em';
    }

    this.$search.css('width', width);
  };

  return Search;
});

S2.define('select2/selection/eventRelay',[
  'jquery'
], function ($) {
  function EventRelay () { }

  EventRelay.prototype.bind = function (decorated, container, $container) {
    var self = this;
    var relayEvents = [
      'open', 'opening',
      'close', 'closing',
      'select', 'selecting',
      'unselect', 'unselecting'
    ];

    var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting'];

    decorated.call(this, container, $container);

    container.on('*', function (name, params) {
      // Ignore events that should not be relayed
      if ($.inArray(name, relayEvents) === -1) {
        return;
      }

      // The parameters should always be an object
      params = params || {};

      // Generate the jQuery event for the Select2 event
      var evt = $.Event('select2:' + name, {
        params: params
      });

      self.$element.trigger(evt);

      // Only handle preventable events if it was one
      if ($.inArray(name, preventableEvents) === -1) {
        return;
      }

      params.prevented = evt.isDefaultPrevented();
    });
  };

  return EventRelay;
});

S2.define('select2/translation',[
  'jquery',
  'require'
], function ($, require) {
  function Translation (dict) {
    this.dict = dict || {};
  }

  Translation.prototype.all = function () {
    return this.dict;
  };

  Translation.prototype.get = function (key) {
    return this.dict[key];
  };

  Translation.prototype.extend = function (translation) {
    this.dict = $.extend({}, translation.all(), this.dict);
  };

  // Static functions

  Translation._cache = {};

  Translation.loadPath = function (path) {
    if (!(path in Translation._cache)) {
      var translations = require(path);

      Translation._cache[path] = translations;
    }

    return new Translation(Translation._cache[path]);
  };

  return Translation;
});

S2.define('select2/diacritics',[

], function () {
  var diacritics = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3'
  };

  return diacritics;
});

S2.define('select2/data/base',[
  '../utils'
], function (Utils) {
  function BaseAdapter ($element, options) {
    BaseAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(BaseAdapter, Utils.Observable);

  BaseAdapter.prototype.current = function (callback) {
    throw new Error('The `current` method must be defined in child classes.');
  };

  BaseAdapter.prototype.query = function (params, callback) {
    throw new Error('The `query` method must be defined in child classes.');
  };

  BaseAdapter.prototype.bind = function (container, $container) {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.destroy = function () {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.generateResultId = function (container, data) {
    var id = container.id + '-result-';

    id += Utils.generateChars(4);

    if (data.id != null) {
      id += '-' + data.id.toString();
    } else {
      id += '-' + Utils.generateChars(4);
    }
    return id;
  };

  return BaseAdapter;
});

S2.define('select2/data/select',[
  './base',
  '../utils',
  'jquery'
], function (BaseAdapter, Utils, $) {
  function SelectAdapter ($element, options) {
    this.$element = $element;
    this.options = options;

    SelectAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(SelectAdapter, BaseAdapter);

  SelectAdapter.prototype.current = function (callback) {
    var data = [];
    var self = this;

    this.$element.find(':selected').each(function () {
      var $option = $(this);

      var option = self.item($option);

      data.push(option);
    });

    callback(data);
  };

  SelectAdapter.prototype.select = function (data) {
    var self = this;

    data.selected = true;

    // If data.element is a DOM node, use it instead
    if ($(data.element).is('option')) {
      data.element.selected = true;

      this.$element.trigger('change');

      return;
    }

    if (this.$element.prop('multiple')) {
      this.current(function (currentData) {
        var val = [];

        data = [data];
        data.push.apply(data, currentData);

        for (var d = 0; d < data.length; d++) {
          var id = data[d].id;

          if ($.inArray(id, val) === -1) {
            val.push(id);
          }
        }

        self.$element.val(val);
        self.$element.trigger('change');
      });
    } else {
      var val = data.id;

      this.$element.val(val);
      this.$element.trigger('change');
    }
  };

  SelectAdapter.prototype.unselect = function (data) {
    var self = this;

    if (!this.$element.prop('multiple')) {
      return;
    }

    data.selected = false;

    if ($(data.element).is('option')) {
      data.element.selected = false;

      this.$element.trigger('change');

      return;
    }

    this.current(function (currentData) {
      var val = [];

      for (var d = 0; d < currentData.length; d++) {
        var id = currentData[d].id;

        if (id !== data.id && $.inArray(id, val) === -1) {
          val.push(id);
        }
      }

      self.$element.val(val);

      self.$element.trigger('change');
    });
  };

  SelectAdapter.prototype.bind = function (container, $container) {
    var self = this;

    this.container = container;

    container.on('select', function (params) {
      self.select(params.data);
    });

    container.on('unselect', function (params) {
      self.unselect(params.data);
    });
  };

  SelectAdapter.prototype.destroy = function () {
    // Remove anything added to child elements
    this.$element.find('*').each(function () {
      // Remove any custom data set by Select2
      $.removeData(this, 'data');
    });
  };

  SelectAdapter.prototype.query = function (params, callback) {
    var data = [];
    var self = this;

    var $options = this.$element.children();

    $options.each(function () {
      var $option = $(this);

      if (!$option.is('option') && !$option.is('optgroup')) {
        return;
      }

      var option = self.item($option);

      var matches = self.matches(params, option);

      if (matches !== null) {
        data.push(matches);
      }
    });

    callback({
      results: data
    });
  };

  SelectAdapter.prototype.addOptions = function ($options) {
    Utils.appendMany(this.$element, $options);
  };

  SelectAdapter.prototype.option = function (data) {
    var option;

    if (data.children) {
      option = document.createElement('optgroup');
      option.label = data.text;
    } else {
      option = document.createElement('option');

      if (option.textContent !== undefined) {
        option.textContent = data.text;
      } else {
        option.innerText = data.text;
      }
    }

    if (data.id !== undefined) {
      option.value = data.id;
    }

    if (data.disabled) {
      option.disabled = true;
    }

    if (data.selected) {
      option.selected = true;
    }

    if (data.title) {
      option.title = data.title;
    }

    var $option = $(option);

    var normalizedData = this._normalizeItem(data);
    normalizedData.element = option;

    // Override the option's data with the combined data
    $.data(option, 'data', normalizedData);

    return $option;
  };

  SelectAdapter.prototype.item = function ($option) {
    var data = {};

    data = $.data($option[0], 'data');

    if (data != null) {
      return data;
    }

    if ($option.is('option')) {
      data = {
        id: $option.val(),
        text: $option.text(),
        disabled: $option.prop('disabled'),
        selected: $option.prop('selected'),
        title: $option.prop('title')
      };
    } else if ($option.is('optgroup')) {
      data = {
        text: $option.prop('label'),
        children: [],
        title: $option.prop('title')
      };

      var $children = $option.children('option');
      var children = [];

      for (var c = 0; c < $children.length; c++) {
        var $child = $($children[c]);

        var child = this.item($child);

        children.push(child);
      }

      data.children = children;
    }

    data = this._normalizeItem(data);
    data.element = $option[0];

    $.data($option[0], 'data', data);

    return data;
  };

  SelectAdapter.prototype._normalizeItem = function (item) {
    if (!$.isPlainObject(item)) {
      item = {
        id: item,
        text: item
      };
    }

    item = $.extend({}, {
      text: ''
    }, item);

    var defaults = {
      selected: false,
      disabled: false
    };

    if (item.id != null) {
      item.id = item.id.toString();
    }

    if (item.text != null) {
      item.text = item.text.toString();
    }

    if (item._resultId == null && item.id && this.container != null) {
      item._resultId = this.generateResultId(this.container, item);
    }

    return $.extend({}, defaults, item);
  };

  SelectAdapter.prototype.matches = function (params, data) {
    var matcher = this.options.get('matcher');

    return matcher(params, data);
  };

  return SelectAdapter;
});

S2.define('select2/data/array',[
  './select',
  '../utils',
  'jquery'
], function (SelectAdapter, Utils, $) {
  function ArrayAdapter ($element, options) {
    var data = options.get('data') || [];

    ArrayAdapter.__super__.constructor.call(this, $element, options);

    this.addOptions(this.convertToOptions(data));
  }

  Utils.Extend(ArrayAdapter, SelectAdapter);

  ArrayAdapter.prototype.select = function (data) {
    var $option = this.$element.find('option').filter(function (i, elm) {
      return elm.value == data.id.toString();
    });

    if ($option.length === 0) {
      $option = this.option(data);

      this.addOptions($option);
    }

    ArrayAdapter.__super__.select.call(this, data);
  };

  ArrayAdapter.prototype.convertToOptions = function (data) {
    var self = this;

    var $existing = this.$element.find('option');
    var existingIds = $existing.map(function () {
      return self.item($(this)).id;
    }).get();

    var $options = [];

    // Filter out all items except for the one passed in the argument
    function onlyItem (item) {
      return function () {
        return $(this).val() == item.id;
      };
    }

    for (var d = 0; d < data.length; d++) {
      var item = this._normalizeItem(data[d]);

      // Skip items which were pre-loaded, only merge the data
      if ($.inArray(item.id, existingIds) >= 0) {
        var $existingOption = $existing.filter(onlyItem(item));

        var existingData = this.item($existingOption);
        var newData = $.extend(true, {}, item, existingData);

        var $newOption = this.option(newData);

        $existingOption.replaceWith($newOption);

        continue;
      }

      var $option = this.option(item);

      if (item.children) {
        var $children = this.convertToOptions(item.children);

        Utils.appendMany($option, $children);
      }

      $options.push($option);
    }

    return $options;
  };

  return ArrayAdapter;
});

S2.define('select2/data/ajax',[
  './array',
  '../utils',
  'jquery'
], function (ArrayAdapter, Utils, $) {
  function AjaxAdapter ($element, options) {
    this.ajaxOptions = this._applyDefaults(options.get('ajax'));

    if (this.ajaxOptions.processResults != null) {
      this.processResults = this.ajaxOptions.processResults;
    }

    AjaxAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(AjaxAdapter, ArrayAdapter);

  AjaxAdapter.prototype._applyDefaults = function (options) {
    var defaults = {
      data: function (params) {
        return $.extend({}, params, {
          q: params.term
        });
      },
      transport: function (params, success, failure) {
        var $request = $.ajax(params);

        $request.then(success);
        $request.fail(failure);

        return $request;
      }
    };

    return $.extend({}, defaults, options, true);
  };

  AjaxAdapter.prototype.processResults = function (results) {
    return results;
  };

  AjaxAdapter.prototype.query = function (params, callback) {
    var matches = [];
    var self = this;

    if (this._request != null) {
      // JSONP requests cannot always be aborted
      if ($.isFunction(this._request.abort)) {
        this._request.abort();
      }

      this._request = null;
    }

    var options = $.extend({
      type: 'GET'
    }, this.ajaxOptions);

    if (typeof options.url === 'function') {
      options.url = options.url.call(this.$element, params);
    }

    if (typeof options.data === 'function') {
      options.data = options.data.call(this.$element, params);
    }

    function request () {
      var $request = options.transport(options, function (data) {
        var results = self.processResults(data, params);

        if (self.options.get('debug') && window.console && console.error) {
          // Check to make sure that the response included a `results` key.
          if (!results || !results.results || !$.isArray(results.results)) {
            console.error(
              'Select2: The AJAX results did not return an array in the ' +
              '`results` key of the response.'
            );
          }
        }

        callback(results);
      }, function () {
        // Attempt to detect if a request was aborted
        // Only works if the transport exposes a status property
        if ($request.status && $request.status === '0') {
          return;
        }

        self.trigger('results:message', {
          message: 'errorLoading'
        });
      });

      self._request = $request;
    }

    if (this.ajaxOptions.delay && params.term != null) {
      if (this._queryTimeout) {
        window.clearTimeout(this._queryTimeout);
      }

      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
    } else {
      request();
    }
  };

  return AjaxAdapter;
});

S2.define('select2/data/tags',[
  'jquery'
], function ($) {
  function Tags (decorated, $element, options) {
    var tags = options.get('tags');

    var createTag = options.get('createTag');

    if (createTag !== undefined) {
      this.createTag = createTag;
    }

    var insertTag = options.get('insertTag');

    if (insertTag !== undefined) {
        this.insertTag = insertTag;
    }

    decorated.call(this, $element, options);

    if ($.isArray(tags)) {
      for (var t = 0; t < tags.length; t++) {
        var tag = tags[t];
        var item = this._normalizeItem(tag);

        var $option = this.option(item);

        this.$element.append($option);
      }
    }
  }

  Tags.prototype.query = function (decorated, params, callback) {
    var self = this;

    this._removeOldTags();

    if (params.term == null || params.page != null) {
      decorated.call(this, params, callback);
      return;
    }

    function wrapper (obj, child) {
      var data = obj.results;

      for (var i = 0; i < data.length; i++) {
        var option = data[i];

        var checkChildren = (
          option.children != null &&
          !wrapper({
            results: option.children
          }, true)
        );

        var optionText = (option.text || '').toUpperCase();
        var paramsTerm = (params.term || '').toUpperCase();

        var checkText = optionText === paramsTerm;

        if (checkText || checkChildren) {
          if (child) {
            return false;
          }

          obj.data = data;
          callback(obj);

          return;
        }
      }

      if (child) {
        return true;
      }

      var tag = self.createTag(params);

      if (tag != null) {
        var $option = self.option(tag);
        $option.attr('data-select2-tag', true);

        self.addOptions([$option]);

        self.insertTag(data, tag);
      }

      obj.results = data;

      callback(obj);
    }

    decorated.call(this, params, wrapper);
  };

  Tags.prototype.createTag = function (decorated, params) {
    var term = $.trim(params.term);

    if (term === '') {
      return null;
    }

    return {
      id: term,
      text: term
    };
  };

  Tags.prototype.insertTag = function (_, data, tag) {
    data.unshift(tag);
  };

  Tags.prototype._removeOldTags = function (_) {
    var tag = this._lastTag;

    var $options = this.$element.find('option[data-select2-tag]');

    $options.each(function () {
      if (this.selected) {
        return;
      }

      $(this).remove();
    });
  };

  return Tags;
});

S2.define('select2/data/tokenizer',[
  'jquery'
], function ($) {
  function Tokenizer (decorated, $element, options) {
    var tokenizer = options.get('tokenizer');

    if (tokenizer !== undefined) {
      this.tokenizer = tokenizer;
    }

    decorated.call(this, $element, options);
  }

  Tokenizer.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    this.$search =  container.dropdown.$search || container.selection.$search ||
      $container.find('.select2-search__field');
  };

  Tokenizer.prototype.query = function (decorated, params, callback) {
    var self = this;

    function createAndSelect (data) {
      // Normalize the data object so we can use it for checks
      var item = self._normalizeItem(data);

      // Check if the data object already exists as a tag
      // Select it if it doesn't
      var $existingOptions = self.$element.find('option').filter(function () {
        return $(this).val() === item.id;
      });

      // If an existing option wasn't found for it, create the option
      if (!$existingOptions.length) {
        var $option = self.option(item);
        $option.attr('data-select2-tag', true);

        self._removeOldTags();
        self.addOptions([$option]);
      }

      // Select the item, now that we know there is an option for it
      select(item);
    }

    function select (data) {
      self.trigger('select', {
        data: data
      });
    }

    params.term = params.term || '';

    var tokenData = this.tokenizer(params, this.options, createAndSelect);

    if (tokenData.term !== params.term) {
      // Replace the search term if we have the search box
      if (this.$search.length) {
        this.$search.val(tokenData.term);
        this.$search.focus();
      }

      params.term = tokenData.term;
    }

    decorated.call(this, params, callback);
  };

  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
    var separators = options.get('tokenSeparators') || [];
    var term = params.term;
    var i = 0;

    var createTag = this.createTag || function (params) {
      return {
        id: params.term,
        text: params.term
      };
    };

    while (i < term.length) {
      var termChar = term[i];

      if ($.inArray(termChar, separators) === -1) {
        i++;

        continue;
      }

      var part = term.substr(0, i);
      var partParams = $.extend({}, params, {
        term: part
      });

      var data = createTag(partParams);

      if (data == null) {
        i++;
        continue;
      }

      callback(data);

      // Reset the term to not include the tokenized portion
      term = term.substr(i + 1) || '';
      i = 0;
    }

    return {
      term: term
    };
  };

  return Tokenizer;
});

S2.define('select2/data/minimumInputLength',[

], function () {
  function MinimumInputLength (decorated, $e, options) {
    this.minimumInputLength = options.get('minimumInputLength');

    decorated.call(this, $e, options);
  }

  MinimumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (params.term.length < this.minimumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooShort',
        args: {
          minimum: this.minimumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MinimumInputLength;
});

S2.define('select2/data/maximumInputLength',[

], function () {
  function MaximumInputLength (decorated, $e, options) {
    this.maximumInputLength = options.get('maximumInputLength');

    decorated.call(this, $e, options);
  }

  MaximumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (this.maximumInputLength > 0 &&
        params.term.length > this.maximumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooLong',
        args: {
          maximum: this.maximumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MaximumInputLength;
});

S2.define('select2/data/maximumSelectionLength',[

], function (){
  function MaximumSelectionLength (decorated, $e, options) {
    this.maximumSelectionLength = options.get('maximumSelectionLength');

    decorated.call(this, $e, options);
  }

  MaximumSelectionLength.prototype.query =
    function (decorated, params, callback) {
      var self = this;

      this.current(function (currentData) {
        var count = currentData != null ? currentData.length : 0;
        if (self.maximumSelectionLength > 0 &&
          count >= self.maximumSelectionLength) {
          self.trigger('results:message', {
            message: 'maximumSelected',
            args: {
              maximum: self.maximumSelectionLength
            }
          });
          return;
        }
        decorated.call(self, params, callback);
      });
  };

  return MaximumSelectionLength;
});

S2.define('select2/dropdown',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Dropdown ($element, options) {
    this.$element = $element;
    this.options = options;

    Dropdown.__super__.constructor.call(this);
  }

  Utils.Extend(Dropdown, Utils.Observable);

  Dropdown.prototype.render = function () {
    var $dropdown = $(
      '<span class="select2-dropdown">' +
        '<span class="select2-results"></span>' +
      '</span>'
    );

    $dropdown.attr('dir', this.options.get('dir'));

    this.$dropdown = $dropdown;

    return $dropdown;
  };

  Dropdown.prototype.bind = function () {
    // Should be implemented in subclasses
  };

  Dropdown.prototype.position = function ($dropdown, $container) {
    // Should be implmented in subclasses
  };

  Dropdown.prototype.destroy = function () {
    // Remove the dropdown from the DOM
    this.$dropdown.remove();
  };

  return Dropdown;
});

S2.define('select2/dropdown/search',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function Search () { }

  Search.prototype.render = function (decorated) {
    var $rendered = decorated.call(this);

    var $search = $(
      '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
        ' spellcheck="false" role="textbox" />' +
      '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    $rendered.prepend($search);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    this.$search.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$search.on('input', function (evt) {
      // Unbind the duplicated `keyup` event
      $(this).off('keyup');
    });

    this.$search.on('keyup input', function (evt) {
      self.handleSearch(evt);
    });

    container.on('open', function () {
      self.$search.attr('tabindex', 0);

      self.$search.focus();

      window.setTimeout(function () {
        self.$search.focus();
      }, 0);
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);

      self.$search.val('');
    });

    container.on('focus', function () {
      if (!container.isOpen()) {
        self.$search.focus();
      }
    });

    container.on('results:all', function (params) {
      if (params.query.term == null || params.query.term === '') {
        var showSearch = self.showSearch(params);

        if (showSearch) {
          self.$searchContainer.removeClass('select2-search--hide');
        } else {
          self.$searchContainer.addClass('select2-search--hide');
        }
      }
    });
  };

  Search.prototype.handleSearch = function (evt) {
    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.showSearch = function (_, params) {
    return true;
  };

  return Search;
});

S2.define('select2/dropdown/hidePlaceholder',[

], function () {
  function HidePlaceholder (decorated, $element, options, dataAdapter) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options, dataAdapter);
  }

  HidePlaceholder.prototype.append = function (decorated, data) {
    data.results = this.removePlaceholder(data.results);

    decorated.call(this, data);
  };

  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
    var modifiedData = data.slice(0);

    for (var d = data.length - 1; d >= 0; d--) {
      var item = data[d];

      if (this.placeholder.id === item.id) {
        modifiedData.splice(d, 1);
      }
    }

    return modifiedData;
  };

  return HidePlaceholder;
});

S2.define('select2/dropdown/infiniteScroll',[
  'jquery'
], function ($) {
  function InfiniteScroll (decorated, $element, options, dataAdapter) {
    this.lastParams = {};

    decorated.call(this, $element, options, dataAdapter);

    this.$loadingMore = this.createLoadingMore();
    this.loading = false;
  }

  InfiniteScroll.prototype.append = function (decorated, data) {
    this.$loadingMore.remove();
    this.loading = false;

    decorated.call(this, data);

    if (this.showLoadingMore(data)) {
      this.$results.append(this.$loadingMore);
    }
  };

  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('query', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    container.on('query:append', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    this.$results.on('scroll', function () {
      var isLoadMoreVisible = $.contains(
        document.documentElement,
        self.$loadingMore[0]
      );

      if (self.loading || !isLoadMoreVisible) {
        return;
      }

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var loadingMoreOffset = self.$loadingMore.offset().top +
        self.$loadingMore.outerHeight(false);

      if (currentOffset + 50 >= loadingMoreOffset) {
        self.loadMore();
      }
    });
  };

  InfiniteScroll.prototype.loadMore = function () {
    this.loading = true;

    var params = $.extend({}, {page: 1}, this.lastParams);

    params.page++;

    this.trigger('query:append', params);
  };

  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
    return data.pagination && data.pagination.more;
  };

  InfiniteScroll.prototype.createLoadingMore = function () {
    var $option = $(
      '<li ' +
      'class="select2-results__option select2-results__option--load-more"' +
      'role="treeitem" aria-disabled="true"></li>'
    );

    var message = this.options.get('translations').get('loadingMore');

    $option.html(message(this.lastParams));

    return $option;
  };

  return InfiniteScroll;
});

S2.define('select2/dropdown/attachBody',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function AttachBody (decorated, $element, options) {
    this.$dropdownParent = options.get('dropdownParent') || $(document.body);

    decorated.call(this, $element, options);
  }

  AttachBody.prototype.bind = function (decorated, container, $container) {
    var self = this;

    var setupResultsEvents = false;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self._showDropdown();
      self._attachPositioningHandler(container);

      if (!setupResultsEvents) {
        setupResultsEvents = true;

        container.on('results:all', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });

        container.on('results:append', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });
      }
    });

    container.on('close', function () {
      self._hideDropdown();
      self._detachPositioningHandler(container);
    });

    this.$dropdownContainer.on('mousedown', function (evt) {
      evt.stopPropagation();
    });
  };

  AttachBody.prototype.destroy = function (decorated) {
    decorated.call(this);

    this.$dropdownContainer.remove();
  };

  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
    // Clone all of the container classes
    $dropdown.attr('class', $container.attr('class'));

    $dropdown.removeClass('select2');
    $dropdown.addClass('select2-container--open');

    $dropdown.css({
      position: 'absolute',
      top: -999999
    });

    this.$container = $container;
  };

  AttachBody.prototype.render = function (decorated) {
    var $container = $('<span></span>');

    var $dropdown = decorated.call(this);
    $container.append($dropdown);

    this.$dropdownContainer = $container;

    return $container;
  };

  AttachBody.prototype._hideDropdown = function (decorated) {
    this.$dropdownContainer.detach();
  };

  AttachBody.prototype._attachPositioningHandler =
      function (decorated, container) {
    var self = this;

    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.each(function () {
      $(this).data('select2-scroll-position', {
        x: $(this).scrollLeft(),
        y: $(this).scrollTop()
      });
    });

    $watchers.on(scrollEvent, function (ev) {
      var position = $(this).data('select2-scroll-position');
      $(this).scrollTop(position.y);
    });

    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
      function (e) {
      self._positionDropdown();
      self._resizeDropdown();
    });
  };

  AttachBody.prototype._detachPositioningHandler =
      function (decorated, container) {
    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.off(scrollEvent);

    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
  };

  AttachBody.prototype._positionDropdown = function () {
    var $window = $(window);

    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

    var newDirection = null;

    var offset = this.$container.offset();

    offset.bottom = offset.top + this.$container.outerHeight(false);

    var container = {
      height: this.$container.outerHeight(false)
    };

    container.top = offset.top;
    container.bottom = offset.top + container.height;

    var dropdown = {
      height: this.$dropdown.outerHeight(false)
    };

    var viewport = {
      top: $window.scrollTop(),
      bottom: $window.scrollTop() + $window.height()
    };

    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

    var css = {
      left: offset.left,
      top: container.bottom
    };

    // Determine what the parent element is to use for calciulating the offset
    var $offsetParent = this.$dropdownParent;

    // For statically positoned elements, we need to get the element
    // that is determining the offset
    if ($offsetParent.css('position') === 'static') {
      $offsetParent = $offsetParent.offsetParent();
    }

    var parentOffset = $offsetParent.offset();

    css.top -= parentOffset.top;
    css.left -= parentOffset.left;

    if (!isCurrentlyAbove && !isCurrentlyBelow) {
      newDirection = 'below';
    }

    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
      newDirection = 'above';
    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
      newDirection = 'below';
    }

    if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
      css.top = container.top - parentOffset.top - dropdown.height;
    }

    if (newDirection != null) {
      this.$dropdown
        .removeClass('select2-dropdown--below select2-dropdown--above')
        .addClass('select2-dropdown--' + newDirection);
      this.$container
        .removeClass('select2-container--below select2-container--above')
        .addClass('select2-container--' + newDirection);
    }

    this.$dropdownContainer.css(css);
  };

  AttachBody.prototype._resizeDropdown = function () {
    var css = {
      width: this.$container.outerWidth(false) + 'px'
    };

    if (this.options.get('dropdownAutoWidth')) {
      css.minWidth = css.width;
      css.position = 'relative';
      css.width = 'auto';
    }

    this.$dropdown.css(css);
  };

  AttachBody.prototype._showDropdown = function (decorated) {
    this.$dropdownContainer.appendTo(this.$dropdownParent);

    this._positionDropdown();
    this._resizeDropdown();
  };

  return AttachBody;
});

S2.define('select2/dropdown/minimumResultsForSearch',[

], function () {
  function countResults (data) {
    var count = 0;

    for (var d = 0; d < data.length; d++) {
      var item = data[d];

      if (item.children) {
        count += countResults(item.children);
      } else {
        count++;
      }
    }

    return count;
  }

  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
    this.minimumResultsForSearch = options.get('minimumResultsForSearch');

    if (this.minimumResultsForSearch < 0) {
      this.minimumResultsForSearch = Infinity;
    }

    decorated.call(this, $element, options, dataAdapter);
  }

  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
    if (countResults(params.data.results) < this.minimumResultsForSearch) {
      return false;
    }

    return decorated.call(this, params);
  };

  return MinimumResultsForSearch;
});

S2.define('select2/dropdown/selectOnClose',[

], function () {
  function SelectOnClose () { }

  SelectOnClose.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('close', function (params) {
      self._handleSelectOnClose(params);
    });
  };

  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
    if (params && params.originalSelect2Event != null) {
      var event = params.originalSelect2Event;

      // Don't select an item if the close event was triggered from a select or
      // unselect event
      if (event._type === 'select' || event._type === 'unselect') {
        return;
      }
    }

    var $highlightedResults = this.getHighlightedResults();

    // Only select highlighted results
    if ($highlightedResults.length < 1) {
      return;
    }

    var data = $highlightedResults.data('data');

    // Don't re-select already selected resulte
    if (
      (data.element != null && data.element.selected) ||
      (data.element == null && data.selected)
    ) {
      return;
    }

    this.trigger('select', {
        data: data
    });
  };

  return SelectOnClose;
});

S2.define('select2/dropdown/closeOnSelect',[

], function () {
  function CloseOnSelect () { }

  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('select', function (evt) {
      self._selectTriggered(evt);
    });

    container.on('unselect', function (evt) {
      self._selectTriggered(evt);
    });
  };

  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
    var originalEvent = evt.originalEvent;

    // Don't close if the control key is being held
    if (originalEvent && originalEvent.ctrlKey) {
      return;
    }

    this.trigger('close', {
      originalEvent: originalEvent,
      originalSelect2Event: evt
    });
  };

  return CloseOnSelect;
});

S2.define('select2/i18n/en',[],function () {
  // English
  return {
    errorLoading: function () {
      return 'The results could not be loaded.';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Please delete ' + overChars + ' character';

      if (overChars != 1) {
        message += 's';
      }

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Please enter ' + remainingChars + ' or more characters';

      return message;
    },
    loadingMore: function () {
      return 'Loading more results…';
    },
    maximumSelected: function (args) {
      var message = 'You can only select ' + args.maximum + ' item';

      if (args.maximum != 1) {
        message += 's';
      }

      return message;
    },
    noResults: function () {
      return 'No results found';
    },
    searching: function () {
      return 'Searching…';
    }
  };
});

S2.define('select2/defaults',[
  'jquery',
  'require',

  './results',

  './selection/single',
  './selection/multiple',
  './selection/placeholder',
  './selection/allowClear',
  './selection/search',
  './selection/eventRelay',

  './utils',
  './translation',
  './diacritics',

  './data/select',
  './data/array',
  './data/ajax',
  './data/tags',
  './data/tokenizer',
  './data/minimumInputLength',
  './data/maximumInputLength',
  './data/maximumSelectionLength',

  './dropdown',
  './dropdown/search',
  './dropdown/hidePlaceholder',
  './dropdown/infiniteScroll',
  './dropdown/attachBody',
  './dropdown/minimumResultsForSearch',
  './dropdown/selectOnClose',
  './dropdown/closeOnSelect',

  './i18n/en'
], function ($, require,

             ResultsList,

             SingleSelection, MultipleSelection, Placeholder, AllowClear,
             SelectionSearch, EventRelay,

             Utils, Translation, DIACRITICS,

             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,

             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,

             EnglishTranslation) {
  function Defaults () {
    this.reset();
  }

  Defaults.prototype.apply = function (options) {
    options = $.extend(true, {}, this.defaults, options);

    if (options.dataAdapter == null) {
      if (options.ajax != null) {
        options.dataAdapter = AjaxData;
      } else if (options.data != null) {
        options.dataAdapter = ArrayData;
      } else {
        options.dataAdapter = SelectData;
      }

      if (options.minimumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MinimumInputLength
        );
      }

      if (options.maximumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumInputLength
        );
      }

      if (options.maximumSelectionLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumSelectionLength
        );
      }

      if (options.tags) {
        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
      }

      if (options.tokenSeparators != null || options.tokenizer != null) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Tokenizer
        );
      }

      if (options.query != null) {
        var Query = require(options.amdBase + 'compat/query');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Query
        );
      }

      if (options.initSelection != null) {
        var InitSelection = require(options.amdBase + 'compat/initSelection');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          InitSelection
        );
      }
    }

    if (options.resultsAdapter == null) {
      options.resultsAdapter = ResultsList;

      if (options.ajax != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          InfiniteScroll
        );
      }

      if (options.placeholder != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          HidePlaceholder
        );
      }

      if (options.selectOnClose) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          SelectOnClose
        );
      }
    }

    if (options.dropdownAdapter == null) {
      if (options.multiple) {
        options.dropdownAdapter = Dropdown;
      } else {
        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

        options.dropdownAdapter = SearchableDropdown;
      }

      if (options.minimumResultsForSearch !== 0) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          MinimumResultsForSearch
        );
      }

      if (options.closeOnSelect) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          CloseOnSelect
        );
      }

      if (
        options.dropdownCssClass != null ||
        options.dropdownCss != null ||
        options.adaptDropdownCssClass != null
      ) {
        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');

        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          DropdownCSS
        );
      }

      options.dropdownAdapter = Utils.Decorate(
        options.dropdownAdapter,
        AttachBody
      );
    }

    if (options.selectionAdapter == null) {
      if (options.multiple) {
        options.selectionAdapter = MultipleSelection;
      } else {
        options.selectionAdapter = SingleSelection;
      }

      // Add the placeholder mixin if a placeholder was specified
      if (options.placeholder != null) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          Placeholder
        );
      }

      if (options.allowClear) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          AllowClear
        );
      }

      if (options.multiple) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          SelectionSearch
        );
      }

      if (
        options.containerCssClass != null ||
        options.containerCss != null ||
        options.adaptContainerCssClass != null
      ) {
        var ContainerCSS = require(options.amdBase + 'compat/containerCss');

        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          ContainerCSS
        );
      }

      options.selectionAdapter = Utils.Decorate(
        options.selectionAdapter,
        EventRelay
      );
    }

    if (typeof options.language === 'string') {
      // Check if the language is specified with a region
      if (options.language.indexOf('-') > 0) {
        // Extract the region information if it is included
        var languageParts = options.language.split('-');
        var baseLanguage = languageParts[0];

        options.language = [options.language, baseLanguage];
      } else {
        options.language = [options.language];
      }
    }

    if ($.isArray(options.language)) {
      var languages = new Translation();
      options.language.push('en');

      var languageNames = options.language;

      for (var l = 0; l < languageNames.length; l++) {
        var name = languageNames[l];
        var language = {};

        try {
          // Try to load it with the original name
          language = Translation.loadPath(name);
        } catch (e) {
          try {
            // If we couldn't load it, check if it wasn't the full path
            name = this.defaults.amdLanguageBase + name;
            language = Translation.loadPath(name);
          } catch (ex) {
            // The translation could not be loaded at all. Sometimes this is
            // because of a configuration problem, other times this can be
            // because of how Select2 helps load all possible translation files.
            if (options.debug && window.console && console.warn) {
              console.warn(
                'Select2: The language file for "' + name + '" could not be ' +
                'automatically loaded. A fallback will be used instead.'
              );
            }

            continue;
          }
        }

        languages.extend(language);
      }

      options.translations = languages;
    } else {
      var baseTranslation = Translation.loadPath(
        this.defaults.amdLanguageBase + 'en'
      );
      var customTranslation = new Translation(options.language);

      customTranslation.extend(baseTranslation);

      options.translations = customTranslation;
    }

    return options;
  };

  Defaults.prototype.reset = function () {
    function stripDiacritics (text) {
      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
      function match(a) {
        return DIACRITICS[a] || a;
      }

      return text.replace(/[^\u0000-\u007E]/g, match);
    }

    function matcher (params, data) {
      // Always return the object if there is nothing to compare
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do a recursive check for options with children
      if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
          var child = data.children[c];

          var matches = matcher(params, child);

          // If there wasn't a match, remove the object in the array
          if (matches == null) {
            match.children.splice(c, 1);
          }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
          return match;
        }

        // If there were no matching children, check just the plain object
        return matcher(params, match);
      }

      var original = stripDiacritics(data.text).toUpperCase();
      var term = stripDiacritics(params.term).toUpperCase();

      // Check if the text contains the term
      if (original.indexOf(term) > -1) {
        return data;
      }

      // If it doesn't contain the term, don't return anything
      return null;
    }

    this.defaults = {
      amdBase: './',
      amdLanguageBase: './i18n/',
      closeOnSelect: true,
      debug: false,
      dropdownAutoWidth: false,
      escapeMarkup: Utils.escapeMarkup,
      language: EnglishTranslation,
      matcher: matcher,
      minimumInputLength: 0,
      maximumInputLength: 0,
      maximumSelectionLength: 0,
      minimumResultsForSearch: 0,
      selectOnClose: false,
      sorter: function (data) {
        return data;
      },
      templateResult: function (result) {
        return result.text;
      },
      templateSelection: function (selection) {
        return selection.text;
      },
      theme: 'default',
      width: 'resolve'
    };
  };

  Defaults.prototype.set = function (key, value) {
    var camelKey = $.camelCase(key);

    var data = {};
    data[camelKey] = value;

    var convertedData = Utils._convertData(data);

    $.extend(this.defaults, convertedData);
  };

  var defaults = new Defaults();

  return defaults;
});

S2.define('select2/options',[
  'require',
  'jquery',
  './defaults',
  './utils'
], function (require, $, Defaults, Utils) {
  function Options (options, $element) {
    this.options = options;

    if ($element != null) {
      this.fromElement($element);
    }

    this.options = Defaults.apply(this.options);

    if ($element && $element.is('input')) {
      var InputCompat = require(this.get('amdBase') + 'compat/inputData');

      this.options.dataAdapter = Utils.Decorate(
        this.options.dataAdapter,
        InputCompat
      );
    }
  }

  Options.prototype.fromElement = function ($e) {
    var excludedData = ['select2'];

    if (this.options.multiple == null) {
      this.options.multiple = $e.prop('multiple');
    }

    if (this.options.disabled == null) {
      this.options.disabled = $e.prop('disabled');
    }

    if (this.options.language == null) {
      if ($e.prop('lang')) {
        this.options.language = $e.prop('lang').toLowerCase();
      } else if ($e.closest('[lang]').prop('lang')) {
        this.options.language = $e.closest('[lang]').prop('lang');
      }
    }

    if (this.options.dir == null) {
      if ($e.prop('dir')) {
        this.options.dir = $e.prop('dir');
      } else if ($e.closest('[dir]').prop('dir')) {
        this.options.dir = $e.closest('[dir]').prop('dir');
      } else {
        this.options.dir = 'ltr';
      }
    }

    $e.prop('disabled', this.options.disabled);
    $e.prop('multiple', this.options.multiple);

    if ($e.data('select2Tags')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-select2-tags` attribute has been changed to ' +
          'use the `data-data` and `data-tags="true"` attributes and will be ' +
          'removed in future versions of Select2.'
        );
      }

      $e.data('data', $e.data('select2Tags'));
      $e.data('tags', true);
    }

    if ($e.data('ajaxUrl')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-ajax-url` attribute has been changed to ' +
          '`data-ajax--url` and support for the old attribute will be removed' +
          ' in future versions of Select2.'
        );
      }

      $e.attr('ajax--url', $e.data('ajaxUrl'));
      $e.data('ajax--url', $e.data('ajaxUrl'));
    }

    var dataset = {};

    // Prefer the element's `dataset` attribute if it exists
    // jQuery 1.x does not correctly handle data attributes with multiple dashes
    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
      dataset = $.extend(true, {}, $e[0].dataset, $e.data());
    } else {
      dataset = $e.data();
    }

    var data = $.extend(true, {}, dataset);

    data = Utils._convertData(data);

    for (var key in data) {
      if ($.inArray(key, excludedData) > -1) {
        continue;
      }

      if ($.isPlainObject(this.options[key])) {
        $.extend(this.options[key], data[key]);
      } else {
        this.options[key] = data[key];
      }
    }

    return this;
  };

  Options.prototype.get = function (key) {
    return this.options[key];
  };

  Options.prototype.set = function (key, val) {
    this.options[key] = val;
  };

  return Options;
});

S2.define('select2/core',[
  'jquery',
  './options',
  './utils',
  './keys'
], function ($, Options, Utils, KEYS) {
  var Select2 = function ($element, options) {
    if ($element.data('select2') != null) {
      $element.data('select2').destroy();
    }

    this.$element = $element;

    this.id = this._generateId($element);

    options = options || {};

    this.options = new Options(options, $element);

    Select2.__super__.constructor.call(this);

    // Set up the tabindex

    var tabindex = $element.attr('tabindex') || 0;
    $element.data('old-tabindex', tabindex);
    $element.attr('tabindex', '-1');

    // Set up containers and adapters

    var DataAdapter = this.options.get('dataAdapter');
    this.dataAdapter = new DataAdapter($element, this.options);

    var $container = this.render();

    this._placeContainer($container);

    var SelectionAdapter = this.options.get('selectionAdapter');
    this.selection = new SelectionAdapter($element, this.options);
    this.$selection = this.selection.render();

    this.selection.position(this.$selection, $container);

    var DropdownAdapter = this.options.get('dropdownAdapter');
    this.dropdown = new DropdownAdapter($element, this.options);
    this.$dropdown = this.dropdown.render();

    this.dropdown.position(this.$dropdown, $container);

    var ResultsAdapter = this.options.get('resultsAdapter');
    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
    this.$results = this.results.render();

    this.results.position(this.$results, this.$dropdown);

    // Bind events

    var self = this;

    // Bind the container to all of the adapters
    this._bindAdapters();

    // Register any DOM event handlers
    this._registerDomEvents();

    // Register any internal event handlers
    this._registerDataEvents();
    this._registerSelectionEvents();
    this._registerDropdownEvents();
    this._registerResultsEvents();
    this._registerEvents();

    // Set the initial state
    this.dataAdapter.current(function (initialData) {
      self.trigger('selection:update', {
        data: initialData
      });
    });

    // Hide the original select
    $element.addClass('select2-hidden-accessible');
    $element.attr('aria-hidden', 'true');

    // Synchronize any monitored attributes
    this._syncAttributes();

    $element.data('select2', this);
  };

  Utils.Extend(Select2, Utils.Observable);

  Select2.prototype._generateId = function ($element) {
    var id = '';

    if ($element.attr('id') != null) {
      id = $element.attr('id');
    } else if ($element.attr('name') != null) {
      id = $element.attr('name') + '-' + Utils.generateChars(2);
    } else {
      id = Utils.generateChars(4);
    }

    id = id.replace(/(:|\.|\[|\]|,)/g, '');
    id = 'select2-' + id;

    return id;
  };

  Select2.prototype._placeContainer = function ($container) {
    $container.insertAfter(this.$element);

    var width = this._resolveWidth(this.$element, this.options.get('width'));

    if (width != null) {
      $container.css('width', width);
    }
  };

  Select2.prototype._resolveWidth = function ($element, method) {
    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

    if (method == 'resolve') {
      var styleWidth = this._resolveWidth($element, 'style');

      if (styleWidth != null) {
        return styleWidth;
      }

      return this._resolveWidth($element, 'element');
    }

    if (method == 'element') {
      var elementWidth = $element.outerWidth(false);

      if (elementWidth <= 0) {
        return 'auto';
      }

      return elementWidth + 'px';
    }

    if (method == 'style') {
      var style = $element.attr('style');

      if (typeof(style) !== 'string') {
        return null;
      }

      var attrs = style.split(';');

      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
        var attr = attrs[i].replace(/\s/g, '');
        var matches = attr.match(WIDTH);

        if (matches !== null && matches.length >= 1) {
          return matches[1];
        }
      }

      return null;
    }

    return method;
  };

  Select2.prototype._bindAdapters = function () {
    this.dataAdapter.bind(this, this.$container);
    this.selection.bind(this, this.$container);

    this.dropdown.bind(this, this.$container);
    this.results.bind(this, this.$container);
  };

  Select2.prototype._registerDomEvents = function () {
    var self = this;

    this.$element.on('change.select2', function () {
      self.dataAdapter.current(function (data) {
        self.trigger('selection:update', {
          data: data
        });
      });
    });

    this.$element.on('focus.select2', function (evt) {
      self.trigger('focus', evt);
    });

    this._syncA = Utils.bind(this._syncAttributes, this);
    this._syncS = Utils.bind(this._syncSubtree, this);

    if (this.$element[0].attachEvent) {
      this.$element[0].attachEvent('onpropertychange', this._syncA);
    }

    var observer = window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    ;

    if (observer != null) {
      this._observer = new observer(function (mutations) {
        $.each(mutations, self._syncA);
        $.each(mutations, self._syncS);
      });
      this._observer.observe(this.$element[0], {
        attributes: true,
        childList: true,
        subtree: false
      });
    } else if (this.$element[0].addEventListener) {
      this.$element[0].addEventListener(
        'DOMAttrModified',
        self._syncA,
        false
      );
      this.$element[0].addEventListener(
        'DOMNodeInserted',
        self._syncS,
        false
      );
      this.$element[0].addEventListener(
        'DOMNodeRemoved',
        self._syncS,
        false
      );
    }
  };

  Select2.prototype._registerDataEvents = function () {
    var self = this;

    this.dataAdapter.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerSelectionEvents = function () {
    var self = this;
    var nonRelayEvents = ['toggle', 'focus'];

    this.selection.on('toggle', function () {
      self.toggleDropdown();
    });

    this.selection.on('focus', function (params) {
      self.focus(params);
    });

    this.selection.on('*', function (name, params) {
      if ($.inArray(name, nonRelayEvents) !== -1) {
        return;
      }

      self.trigger(name, params);
    });
  };

  Select2.prototype._registerDropdownEvents = function () {
    var self = this;

    this.dropdown.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerResultsEvents = function () {
    var self = this;

    this.results.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerEvents = function () {
    var self = this;

    this.on('open', function () {
      self.$container.addClass('select2-container--open');
    });

    this.on('close', function () {
      self.$container.removeClass('select2-container--open');
    });

    this.on('enable', function () {
      self.$container.removeClass('select2-container--disabled');
    });

    this.on('disable', function () {
      self.$container.addClass('select2-container--disabled');
    });

    this.on('blur', function () {
      self.$container.removeClass('select2-container--focus');
    });

    this.on('query', function (params) {
      if (!self.isOpen()) {
        self.trigger('open', {});
      }

      this.dataAdapter.query(params, function (data) {
        self.trigger('results:all', {
          data: data,
          query: params
        });
      });
    });

    this.on('query:append', function (params) {
      this.dataAdapter.query(params, function (data) {
        self.trigger('results:append', {
          data: data,
          query: params
        });
      });
    });

    this.on('keypress', function (evt) {
      var key = evt.which;

      if (self.isOpen()) {
        if (key === KEYS.ESC || key === KEYS.TAB ||
            (key === KEYS.UP && evt.altKey)) {
          self.close();

          evt.preventDefault();
        } else if (key === KEYS.ENTER) {
          self.trigger('results:select', {});

          evt.preventDefault();
        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
          self.trigger('results:toggle', {});

          evt.preventDefault();
        } else if (key === KEYS.UP) {
          self.trigger('results:previous', {});

          evt.preventDefault();
        } else if (key === KEYS.DOWN) {
          self.trigger('results:next', {});

          evt.preventDefault();
        }
      } else {
        if (key === KEYS.ENTER || key === KEYS.SPACE ||
            (key === KEYS.DOWN && evt.altKey)) {
          self.open();

          evt.preventDefault();
        }
      }
    });
  };

  Select2.prototype._syncAttributes = function () {
    this.options.set('disabled', this.$element.prop('disabled'));

    if (this.options.get('disabled')) {
      if (this.isOpen()) {
        this.close();
      }

      this.trigger('disable', {});
    } else {
      this.trigger('enable', {});
    }
  };

  Select2.prototype._syncSubtree = function (evt, mutations) {
    var changed = false;
    var self = this;

    // Ignore any mutation events raised for elements that aren't options or
    // optgroups. This handles the case when the select element is destroyed
    if (
      evt && evt.target && (
        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
      )
    ) {
      return;
    }

    if (!mutations) {
      // If mutation events aren't supported, then we can only assume that the
      // change affected the selections
      changed = true;
    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
      for (var n = 0; n < mutations.addedNodes.length; n++) {
        var node = mutations.addedNodes[n];

        if (node.selected) {
          changed = true;
        }
      }
    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
      changed = true;
    }

    // Only re-pull the data if we think there is a change
    if (changed) {
      this.dataAdapter.current(function (currentData) {
        self.trigger('selection:update', {
          data: currentData
        });
      });
    }
  };

  /**
   * Override the trigger method to automatically trigger pre-events when
   * there are events that can be prevented.
   */
  Select2.prototype.trigger = function (name, args) {
    var actualTrigger = Select2.__super__.trigger;
    var preTriggerMap = {
      'open': 'opening',
      'close': 'closing',
      'select': 'selecting',
      'unselect': 'unselecting'
    };

    if (args === undefined) {
      args = {};
    }

    if (name in preTriggerMap) {
      var preTriggerName = preTriggerMap[name];
      var preTriggerArgs = {
        prevented: false,
        name: name,
        args: args
      };

      actualTrigger.call(this, preTriggerName, preTriggerArgs);

      if (preTriggerArgs.prevented) {
        args.prevented = true;

        return;
      }
    }

    actualTrigger.call(this, name, args);
  };

  Select2.prototype.toggleDropdown = function () {
    if (this.options.get('disabled')) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  Select2.prototype.open = function () {
    if (this.isOpen()) {
      return;
    }

    this.trigger('query', {});
  };

  Select2.prototype.close = function () {
    if (!this.isOpen()) {
      return;
    }

    this.trigger('close', {});
  };

  Select2.prototype.isOpen = function () {
    return this.$container.hasClass('select2-container--open');
  };

  Select2.prototype.hasFocus = function () {
    return this.$container.hasClass('select2-container--focus');
  };

  Select2.prototype.focus = function (data) {
    // No need to re-trigger focus events if we are already focused
    if (this.hasFocus()) {
      return;
    }

    this.$container.addClass('select2-container--focus');
    this.trigger('focus', {});
  };

  Select2.prototype.enable = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("enable")` method has been deprecated and will' +
        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
        ' instead.'
      );
    }

    if (args == null || args.length === 0) {
      args = [true];
    }

    var disabled = !args[0];

    this.$element.prop('disabled', disabled);
  };

  Select2.prototype.data = function () {
    if (this.options.get('debug') &&
        arguments.length > 0 && window.console && console.warn) {
      console.warn(
        'Select2: Data can no longer be set using `select2("data")`. You ' +
        'should consider setting the value instead using `$element.val()`.'
      );
    }

    var data = [];

    this.dataAdapter.current(function (currentData) {
      data = currentData;
    });

    return data;
  };

  Select2.prototype.val = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("val")` method has been deprecated and will be' +
        ' removed in later Select2 versions. Use $element.val() instead.'
      );
    }

    if (args == null || args.length === 0) {
      return this.$element.val();
    }

    var newVal = args[0];

    if ($.isArray(newVal)) {
      newVal = $.map(newVal, function (obj) {
        return obj.toString();
      });
    }

    this.$element.val(newVal).trigger('change');
  };

  Select2.prototype.destroy = function () {
    this.$container.remove();

    if (this.$element[0].detachEvent) {
      this.$element[0].detachEvent('onpropertychange', this._syncA);
    }

    if (this._observer != null) {
      this._observer.disconnect();
      this._observer = null;
    } else if (this.$element[0].removeEventListener) {
      this.$element[0]
        .removeEventListener('DOMAttrModified', this._syncA, false);
      this.$element[0]
        .removeEventListener('DOMNodeInserted', this._syncS, false);
      this.$element[0]
        .removeEventListener('DOMNodeRemoved', this._syncS, false);
    }

    this._syncA = null;
    this._syncS = null;

    this.$element.off('.select2');
    this.$element.attr('tabindex', this.$element.data('old-tabindex'));

    this.$element.removeClass('select2-hidden-accessible');
    this.$element.attr('aria-hidden', 'false');
    this.$element.removeData('select2');

    this.dataAdapter.destroy();
    this.selection.destroy();
    this.dropdown.destroy();
    this.results.destroy();

    this.dataAdapter = null;
    this.selection = null;
    this.dropdown = null;
    this.results = null;
  };

  Select2.prototype.render = function () {
    var $container = $(
      '<span class="select2 select2-container">' +
        '<span class="selection"></span>' +
        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
      '</span>'
    );

    $container.attr('dir', this.options.get('dir'));

    this.$container = $container;

    this.$container.addClass('select2-container--' + this.options.get('theme'));

    $container.data('element', this.$element);

    return $container;
  };

  return Select2;
});

S2.define('select2/compat/utils',[
  'jquery'
], function ($) {
  function syncCssClasses ($dest, $src, adapter) {
    var classes, replacements = [], adapted;

    classes = $.trim($dest.attr('class'));

    if (classes) {
      classes = '' + classes; // for IE which returns object

      $(classes.split(/\s+/)).each(function () {
        // Save all Select2 classes
        if (this.indexOf('select2-') === 0) {
          replacements.push(this);
        }
      });
    }

    classes = $.trim($src.attr('class'));

    if (classes) {
      classes = '' + classes; // for IE which returns object

      $(classes.split(/\s+/)).each(function () {
        // Only adapt non-Select2 classes
        if (this.indexOf('select2-') !== 0) {
          adapted = adapter(this);

          if (adapted != null) {
            replacements.push(adapted);
          }
        }
      });
    }

    $dest.attr('class', replacements.join(' '));
  }

  return {
    syncCssClasses: syncCssClasses
  };
});

S2.define('select2/compat/containerCss',[
  'jquery',
  './utils'
], function ($, CompatUtils) {
  // No-op CSS adapter that discards all classes by default
  function _containerAdapter (clazz) {
    return null;
  }

  function ContainerCSS () { }

  ContainerCSS.prototype.render = function (decorated) {
    var $container = decorated.call(this);

    var containerCssClass = this.options.get('containerCssClass') || '';

    if ($.isFunction(containerCssClass)) {
      containerCssClass = containerCssClass(this.$element);
    }

    var containerCssAdapter = this.options.get('adaptContainerCssClass');
    containerCssAdapter = containerCssAdapter || _containerAdapter;

    if (containerCssClass.indexOf(':all:') !== -1) {
      containerCssClass = containerCssClass.replace(':all:', '');

      var _cssAdapter = containerCssAdapter;

      containerCssAdapter = function (clazz) {
        var adapted = _cssAdapter(clazz);

        if (adapted != null) {
          // Append the old one along with the adapted one
          return adapted + ' ' + clazz;
        }

        return clazz;
      };
    }

    var containerCss = this.options.get('containerCss') || {};

    if ($.isFunction(containerCss)) {
      containerCss = containerCss(this.$element);
    }

    CompatUtils.syncCssClasses($container, this.$element, containerCssAdapter);

    $container.css(containerCss);
    $container.addClass(containerCssClass);

    return $container;
  };

  return ContainerCSS;
});

S2.define('select2/compat/dropdownCss',[
  'jquery',
  './utils'
], function ($, CompatUtils) {
  // No-op CSS adapter that discards all classes by default
  function _dropdownAdapter (clazz) {
    return null;
  }

  function DropdownCSS () { }

  DropdownCSS.prototype.render = function (decorated) {
    var $dropdown = decorated.call(this);

    var dropdownCssClass = this.options.get('dropdownCssClass') || '';

    if ($.isFunction(dropdownCssClass)) {
      dropdownCssClass = dropdownCssClass(this.$element);
    }

    var dropdownCssAdapter = this.options.get('adaptDropdownCssClass');
    dropdownCssAdapter = dropdownCssAdapter || _dropdownAdapter;

    if (dropdownCssClass.indexOf(':all:') !== -1) {
      dropdownCssClass = dropdownCssClass.replace(':all:', '');

      var _cssAdapter = dropdownCssAdapter;

      dropdownCssAdapter = function (clazz) {
        var adapted = _cssAdapter(clazz);

        if (adapted != null) {
          // Append the old one along with the adapted one
          return adapted + ' ' + clazz;
        }

        return clazz;
      };
    }

    var dropdownCss = this.options.get('dropdownCss') || {};

    if ($.isFunction(dropdownCss)) {
      dropdownCss = dropdownCss(this.$element);
    }

    CompatUtils.syncCssClasses($dropdown, this.$element, dropdownCssAdapter);

    $dropdown.css(dropdownCss);
    $dropdown.addClass(dropdownCssClass);

    return $dropdown;
  };

  return DropdownCSS;
});

S2.define('select2/compat/initSelection',[
  'jquery'
], function ($) {
  function InitSelection (decorated, $element, options) {
    if (options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `initSelection` option has been deprecated in favor' +
        ' of a custom data adapter that overrides the `current` method. ' +
        'This method is now called multiple times instead of a single ' +
        'time when the instance is initialized. Support will be removed ' +
        'for the `initSelection` option in future versions of Select2'
      );
    }

    this.initSelection = options.get('initSelection');
    this._isInitialized = false;

    decorated.call(this, $element, options);
  }

  InitSelection.prototype.current = function (decorated, callback) {
    var self = this;

    if (this._isInitialized) {
      decorated.call(this, callback);

      return;
    }

    this.initSelection.call(null, this.$element, function (data) {
      self._isInitialized = true;

      if (!$.isArray(data)) {
        data = [data];
      }

      callback(data);
    });
  };

  return InitSelection;
});

S2.define('select2/compat/inputData',[
  'jquery'
], function ($) {
  function InputData (decorated, $element, options) {
    this._currentData = [];
    this._valueSeparator = options.get('valueSeparator') || ',';

    if ($element.prop('type') === 'hidden') {
      if (options.get('debug') && console && console.warn) {
        console.warn(
          'Select2: Using a hidden input with Select2 is no longer ' +
          'supported and may stop working in the future. It is recommended ' +
          'to use a `<select>` element instead.'
        );
      }
    }

    decorated.call(this, $element, options);
  }

  InputData.prototype.current = function (_, callback) {
    function getSelected (data, selectedIds) {
      var selected = [];

      if (data.selected || $.inArray(data.id, selectedIds) !== -1) {
        data.selected = true;
        selected.push(data);
      } else {
        data.selected = false;
      }

      if (data.children) {
        selected.push.apply(selected, getSelected(data.children, selectedIds));
      }

      return selected;
    }

    var selected = [];

    for (var d = 0; d < this._currentData.length; d++) {
      var data = this._currentData[d];

      selected.push.apply(
        selected,
        getSelected(
          data,
          this.$element.val().split(
            this._valueSeparator
          )
        )
      );
    }

    callback(selected);
  };

  InputData.prototype.select = function (_, data) {
    if (!this.options.get('multiple')) {
      this.current(function (allData) {
        $.map(allData, function (data) {
          data.selected = false;
        });
      });

      this.$element.val(data.id);
      this.$element.trigger('change');
    } else {
      var value = this.$element.val();
      value += this._valueSeparator + data.id;

      this.$element.val(value);
      this.$element.trigger('change');
    }
  };

  InputData.prototype.unselect = function (_, data) {
    var self = this;

    data.selected = false;

    this.current(function (allData) {
      var values = [];

      for (var d = 0; d < allData.length; d++) {
        var item = allData[d];

        if (data.id == item.id) {
          continue;
        }

        values.push(item.id);
      }

      self.$element.val(values.join(self._valueSeparator));
      self.$element.trigger('change');
    });
  };

  InputData.prototype.query = function (_, params, callback) {
    var results = [];

    for (var d = 0; d < this._currentData.length; d++) {
      var data = this._currentData[d];

      var matches = this.matches(params, data);

      if (matches !== null) {
        results.push(matches);
      }
    }

    callback({
      results: results
    });
  };

  InputData.prototype.addOptions = function (_, $options) {
    var options = $.map($options, function ($option) {
      return $.data($option[0], 'data');
    });

    this._currentData.push.apply(this._currentData, options);
  };

  return InputData;
});

S2.define('select2/compat/matcher',[
  'jquery'
], function ($) {
  function oldMatcher (matcher) {
    function wrappedMatcher (params, data) {
      var match = $.extend(true, {}, data);

      if (params.term == null || $.trim(params.term) === '') {
        return match;
      }

      if (data.children) {
        for (var c = data.children.length - 1; c >= 0; c--) {
          var child = data.children[c];

          // Check if the child object matches
          // The old matcher returned a boolean true or false
          var doesMatch = matcher(params.term, child.text, child);

          // If the child didn't match, pop it off
          if (!doesMatch) {
            match.children.splice(c, 1);
          }
        }

        if (match.children.length > 0) {
          return match;
        }
      }

      if (matcher(params.term, data.text, data)) {
        return match;
      }

      return null;
    }

    return wrappedMatcher;
  }

  return oldMatcher;
});

S2.define('select2/compat/query',[

], function () {
  function Query (decorated, $element, options) {
    if (options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `query` option has been deprecated in favor of a ' +
        'custom data adapter that overrides the `query` method. Support ' +
        'will be removed for the `query` option in future versions of ' +
        'Select2.'
      );
    }

    decorated.call(this, $element, options);
  }

  Query.prototype.query = function (_, params, callback) {
    params.callback = callback;

    var query = this.options.get('query');

    query.call(null, params);
  };

  return Query;
});

S2.define('select2/dropdown/attachContainer',[

], function () {
  function AttachContainer (decorated, $element, options) {
    decorated.call(this, $element, options);
  }

  AttachContainer.prototype.position =
    function (decorated, $dropdown, $container) {
    var $dropdownContainer = $container.find('.dropdown-wrapper');
    $dropdownContainer.append($dropdown);

    $dropdown.addClass('select2-dropdown--below');
    $container.addClass('select2-container--below');
  };

  return AttachContainer;
});

S2.define('select2/dropdown/stopPropagation',[

], function () {
  function StopPropagation () { }

  StopPropagation.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    var stoppedEvents = [
    'blur',
    'change',
    'click',
    'dblclick',
    'focus',
    'focusin',
    'focusout',
    'input',
    'keydown',
    'keyup',
    'keypress',
    'mousedown',
    'mouseenter',
    'mouseleave',
    'mousemove',
    'mouseover',
    'mouseup',
    'search',
    'touchend',
    'touchstart'
    ];

    this.$dropdown.on(stoppedEvents.join(' '), function (evt) {
      evt.stopPropagation();
    });
  };

  return StopPropagation;
});

S2.define('select2/selection/stopPropagation',[

], function () {
  function StopPropagation () { }

  StopPropagation.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    var stoppedEvents = [
      'blur',
      'change',
      'click',
      'dblclick',
      'focus',
      'focusin',
      'focusout',
      'input',
      'keydown',
      'keyup',
      'keypress',
      'mousedown',
      'mouseenter',
      'mouseleave',
      'mousemove',
      'mouseover',
      'mouseup',
      'search',
      'touchend',
      'touchstart'
    ];

    this.$selection.on(stoppedEvents.join(' '), function (evt) {
      evt.stopPropagation();
    });
  };

  return StopPropagation;
});

/*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 */

(function (factory) {
    if ( typeof S2.define === 'function' && S2.define.amd ) {
        // AMD. Register as an anonymous module.
        S2.define('jquery-mousewheel',['jquery'], factory);
    } else if (true) {
        // Node/CommonJS style for Browserify
        module.exports = factory;
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
        slice  = Array.prototype.slice,
        nullLowestDeltaTimeout, lowestDelta;

    if ( $.event.fixHooks ) {
        for ( var i = toFix.length; i; ) {
            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
        }
    }

    var special = $.event.special.mousewheel = {
        version: '3.1.12',

        setup: function() {
            if ( this.addEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.addEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
            // Store the line height and page height for this particular element
            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.removeEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
            // Clean up the data we added to the element
            $.removeData(this, 'mousewheel-line-height');
            $.removeData(this, 'mousewheel-page-height');
        },

        getLineHeight: function(elem) {
            var $elem = $(elem),
                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
            if (!$parent.length) {
                $parent = $('body');
            }
            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
        },

        getPageHeight: function(elem) {
            return $(elem).height();
        },

        settings: {
            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
            normalizeOffset: true  // calls getBoundingClientRect for each event
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
        },

        unmousewheel: function(fn) {
            return this.unbind('mousewheel', fn);
        }
    });


    function handler(event) {
        var orgEvent   = event || window.event,
            args       = slice.call(arguments, 1),
            delta      = 0,
            deltaX     = 0,
            deltaY     = 0,
            absDelta   = 0,
            offsetX    = 0,
            offsetY    = 0;
        event = $.event.fix(orgEvent);
        event.type = 'mousewheel';

        // Old school scrollwheel delta
        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaX = deltaY * -1;
            deltaY = 0;
        }

        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
        delta = deltaY === 0 ? deltaX : deltaY;

        // New school wheel delta (wheel event)
        if ( 'deltaY' in orgEvent ) {
            deltaY = orgEvent.deltaY * -1;
            delta  = deltaY;
        }
        if ( 'deltaX' in orgEvent ) {
            deltaX = orgEvent.deltaX;
            if ( deltaY === 0 ) { delta  = deltaX * -1; }
        }

        // No change actually happened, no reason to go any further
        if ( deltaY === 0 && deltaX === 0 ) { return; }

        // Need to convert lines and pages to pixels if we aren't already in pixels
        // There are three delta modes:
        //   * deltaMode 0 is by pixels, nothing to do
        //   * deltaMode 1 is by lines
        //   * deltaMode 2 is by pages
        if ( orgEvent.deltaMode === 1 ) {
            var lineHeight = $.data(this, 'mousewheel-line-height');
            delta  *= lineHeight;
            deltaY *= lineHeight;
            deltaX *= lineHeight;
        } else if ( orgEvent.deltaMode === 2 ) {
            var pageHeight = $.data(this, 'mousewheel-page-height');
            delta  *= pageHeight;
            deltaY *= pageHeight;
            deltaX *= pageHeight;
        }

        // Store lowest absolute delta to normalize the delta values
        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

        if ( !lowestDelta || absDelta < lowestDelta ) {
            lowestDelta = absDelta;

            // Adjust older deltas if necessary
            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
                lowestDelta /= 40;
            }
        }

        // Adjust older deltas if necessary
        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
            // Divide all the things by 40!
            delta  /= 40;
            deltaX /= 40;
            deltaY /= 40;
        }

        // Get a whole, normalized value for the deltas
        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

        // Normalise offsetX and offsetY properties
        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
            var boundingRect = this.getBoundingClientRect();
            offsetX = event.clientX - boundingRect.left;
            offsetY = event.clientY - boundingRect.top;
        }

        // Add information to the event object
        event.deltaX = deltaX;
        event.deltaY = deltaY;
        event.deltaFactor = lowestDelta;
        event.offsetX = offsetX;
        event.offsetY = offsetY;
        // Go ahead and set deltaMode to 0 since we converted to pixels
        // Although this is a little odd since we overwrite the deltaX/Y
        // properties with normalized deltas.
        event.deltaMode = 0;

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        // Clearout lowestDelta after sometime to better
        // handle multiple device types that give different
        // a different lowestDelta
        // Ex: trackpad = 3 and mouse wheel = 120
        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

    function nullLowestDelta() {
        lowestDelta = null;
    }

    function shouldAdjustOldDeltas(orgEvent, absDelta) {
        // If this is an older event and the delta is divisable by 120,
        // then we are assuming that the browser is treating this as an
        // older mouse wheel event and that we should divide the deltas
        // by 40 to try and get a more usable deltaFactor.
        // Side note, this actually impacts the reported scroll distance
        // in older browsers and can cause scrolling to be slower than native.
        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
    }

}));

S2.define('jquery.select2',[
  'jquery',
  'jquery-mousewheel',

  './select2/core',
  './select2/defaults'
], function ($, _, Select2, Defaults) {
  if ($.fn.select2 == null) {
    // All methods that should return the element
    var thisMethods = ['open', 'close', 'destroy'];

    $.fn.select2 = function (options) {
      options = options || {};

      if (typeof options === 'object') {
        this.each(function () {
          var instanceOptions = $.extend(true, {}, options);

          var instance = new Select2($(this), instanceOptions);
        });

        return this;
      } else if (typeof options === 'string') {
        var ret;
        var args = Array.prototype.slice.call(arguments, 1);

        this.each(function () {
          var instance = $(this).data('select2');

          if (instance == null && window.console && console.error) {
            console.error(
              'The select2(\'' + options + '\') method was called on an ' +
              'element that is not using Select2.'
            );
          }

          ret = instance[options].apply(instance, args);
        });

        // Check if we should be returning `this`
        if ($.inArray(options, thisMethods) > -1) {
          return this;
        }

        return ret;
      } else {
        throw new Error('Invalid arguments for Select2: ' + options);
      }
    };
  }

  if ($.fn.select2.defaults == null) {
    $.fn.select2.defaults = Defaults;
  }

  return Select2;
});

  // Return the AMD loader configuration so it can be used outside of this file
  return {
    define: S2.define,
    require: S2.require
  };
}());

  // Autoload the jQuery bindings
  // We know that all of the modules exist above this, so we're safe
  var select2 = S2.require('jquery.select2');

  // Hold the AMD module references on the jQuery function that was just loaded
  // This allows Select2 to use the internal loader outside of this file, such
  // as in the language files.
  jQuery.fn.select2.amd = S2;

  // Return the Select2 instance for anyone who is importing it.
  return select2;
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecMultipleChart', __webpack_require__(63).ecMultipleChart);

    __webpack_require__(49);
    __webpack_require__(52);
    __webpack_require__(51);
    __webpack_require__(54);
    __webpack_require__(53);
    __webpack_require__(50);
    __webpack_require__(47);
    __webpack_require__(48);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(35);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(36);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(39);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(41);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(42);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(43);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(45);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(55);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(57);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(58);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(59);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(60);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(61);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(62);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses(element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockTransitions(node, duration) {
  // we use a negative delay value since it performs blocking
  // yet it doesn't kill any existing transitions running on the
  // same element which makes this safe for class-based animations
  var value = duration ? '-' + duration + 's' : '';
  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
  return [TRANSITION_DELAY_PROP, value];
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## Usage
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

function createLocalCacheLookup() {
  var cache = Object.create(null);
  return {
    flush: function() {
      cache = Object.create(null);
    },

    count: function(key) {
      var entry = cache[key];
      return entry ? entry.total : 0;
    },

    get: function(key) {
      var entry = cache[key];
      return entry && entry.value;
    },

    put: function(key, value) {
      if (!cache[key]) {
        cache[key] = { total: 1, value: value };
      } else {
        cache[key].total++;
      }
    }
  };
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var gcsLookup = createLocalCacheLookup();
  var gcsStaggerLookup = createLocalCacheLookup();

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var parentCounter = 0;
    function gcsHashFn(node, extraClasses) {
      var KEY = '$$ngAnimateParentKey';
      var parentNode = node.parentNode;
      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
    }

    function computeCachedCssStyles(node, className, cacheKey, properties) {
      var timings = gcsLookup.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      gcsLookup.put(cacheKey, timings);
      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if (gcsLookup.count(cacheKey) > 0) {
        stagger = gcsStaggerLookup.get(cacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          gcsStaggerLookup.put(cacheKey, stagger);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        gcsLookup.flush();
        gcsStaggerLookup.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey) {
      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var cacheKey, stagger;
      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        cacheKey = gcsHashFn(node, fullClassName);
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : gcsLookup.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (!options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }
        $$jqLite.removeClass(element, activeClasses);

        blockKeyframeAnimations(node, false);
        blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.className + ' ' + preparationClasses;
            cacheKey = gcsHashFn(node, fullClassName);

            timings = computeTimings(node, fullClassName, cacheKey);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(element, currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(element, newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow) {

    var activeAnimationsLookup = new $$HashMap();
    var disabledElementsLookup = new $$HashMap();
    var animationsEnabled = null;

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the classNameFilter is set during the provider/config
    // stage therefore we can optimize here and setup a helper function
    var classNameFilter = $animateProvider.classNameFilter();
    var isAnimatableClassName = !classNameFilter
              ? function() { return true; }
              : function(className) {
                return classNameFilter.test(className);
              };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(parent, element, event) {
      var targetNode = getDomNode(element);
      var targetParentNode = getDomNode(parent);

      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, element) {
      if (phase === 'close' && !element[0].parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(element);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              disabledElementsLookup.put(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(element, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var node, parent;
      element = stripCommentsFromElement(element);
      if (element) {
        node = getDomNode(element);
        parent = element.parent();
      }

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // there are situations where a directive issues an animation for
      // a jqLite wrapper that contains only comment nodes... If this
      // happens then there is no way we can perform an animation
      if (!node) {
        close();
        return runner;
      }

      var className = [node.className, options.addClass, options.removeClass].join(' ');
      if (!isAnimatableClassName(className)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $document[0].hidden;

      // this is a hard disable of all animations for the application or on
      // the element itself, therefore  there is no need to continue further
      // past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(element, parent, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start');
        close();
        if (documentHidden) notifyProgress(runner, event, 'close');
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(element);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(element);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(element);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(element, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', {});

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(getDomNode(element));
          }
          notifyProgress(runner, event, 'close', {});
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parent, element, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, element);
            });
          } else {
            cleanupEventListeners(phase, element);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(element) {
      var node = getDomNode(element);
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.remove(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(element) {
      var node = getDomNode(element);
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.remove(node);
    }

    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(element, parentElement, event) {
      var bodyElement = jqLite($document[0].body);
      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
      var rootElementDetected = isMatchingElement(element, $rootElement);
      var parentAnimationDetected = false;
      var animateChildren;
      var elementDisabled = disabledElementsLookup.get(getDomNode(element));

      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentElement = parentHost;
      }

      parentElement = getDomNode(parentElement);

      while (parentElement) {
        if (!rootElementDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootElementDetected = isMatchingElement(parentElement, $rootElement);
        }

        if (parentElement.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentElement) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentElementDisabled = disabledElementsLookup.get(parentElement);

          if (parentElementDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentElementDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyElementDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
        }

        if (bodyElementDetected && rootElementDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootElementDetected) {
          // If no rootElement is detected, check if the parentElement is pinned to another element
          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentElement = getDomNode(parentHost);
            continue;
          }
        }

        parentElement = parentElement.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootElementDetected && bodyElementDetected;
    }

    function markElementAnimationState(element, state, details) {
      details = details || {};
      details.state = state;

      var node = getDomNode(element);
      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.put(node, newValue);
    }
  }];
}];

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$HashMap();

      // this is done first beforehand so that the hashmap
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.put(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.put(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry.fn);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      setRunner(element, runner);

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      var prepareClassName;
      if (isStructural) {
        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
        $$jqLite.addClass(element, prepareClassName);
      }

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          toBeSortedAnimations.push({
            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
            fn: function triggerAnimationStart() {
              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        element.addClass(NG_ANIMATE_CLASSNAME);
        if (tempClasses) {
          $$jqLite.addClass(element, tempClasses);
        }
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        element.removeClass(NG_ANIMATE_CLASSNAME);
        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 600, // we use 600 here to ensure that the directive is caught before others
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          previousScope = scope.$new();
          $transclude(previousScope, function(element) {
            previousElement = element;
            $animate.enter(element, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
 *
 * <div doc-module-components="ngAnimate"></div>
 *
 * # Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                                                | Supported Animations                                                     |
 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
 *
 * (More information can be found by visiting each the documentation associated with each directive.)
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 *
 * ```
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that angular
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from angular core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngAria
 * @description
 *
 * The `ngAria` module provides support for common
 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
 * attributes that convey state or semantic information about the application for users
 * of assistive technologies, such as screen readers.
 *
 * <div doc-module-components="ngAria"></div>
 *
 * ## Usage
 *
 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
 * directives are supported:
 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
 * `ngDblClick`, and `ngMessages`.
 *
 * Below is a more detailed breakdown of the attributes handled by ngAria:
 *
 * | Directive                                   | Supported Attributes                                                                   |
 * |---------------------------------------------|----------------------------------------------------------------------------------------|
 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                          |
 * | {@link ng.directive:ngRequired ngRequired}  | aria-required
 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked
 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                          |
 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                           |
 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                            |
 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                            |
 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                               |
 * | {@link module:ngMessages ngMessages}        | aria-live                                                                              |
 * | {@link ng.directive:ngClick ngClick}        | tabindex, keypress event, button role                                                  |
 *
 * Find out more information about each directive by reading the
 * {@link guide/accessibility ngAria Developer Guide}.
 *
 * ## Example
 * Using ngDisabled with ngAria:
 * ```html
 * <md-checkbox ng-disabled="disabled">
 * ```
 * Becomes:
 * ```html
 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
 * ```
 *
 * ## Disabling Attributes
 * It's possible to disable individual attributes added by ngAria with the
 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
 * {@link guide/accessibility Developer Guide}.
 */
var ngAriaModule = angular.module('ngAria', ['ng']).
                        provider('$aria', $AriaProvider);

/**
* Internal Utilities
*/
var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];

var isNodeOneOf = function(elem, nodeTypeArray) {
  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
    return true;
  }
};
/**
 * @ngdoc provider
 * @name $ariaProvider
 * @this
 *
 * @description
 *
 * Used for configuring the ARIA attributes injected and managed by ngAria.
 *
 * ```js
 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
 *   $ariaProvider.config({
 *     ariaValue: true,
 *     tabindex: false
 *   });
 * });
 *```
 *
 * ## Dependencies
 * Requires the {@link ngAria} module to be installed.
 *
 */
function $AriaProvider() {
  var config = {
    ariaHidden: true,
    ariaChecked: true,
    ariaReadonly: true,
    ariaDisabled: true,
    ariaRequired: true,
    ariaInvalid: true,
    ariaValue: true,
    tabindex: true,
    bindKeypress: true,
    bindRoleForClick: true
  };

  /**
   * @ngdoc method
   * @name $ariaProvider#config
   *
   * @param {object} config object to enable/disable specific ARIA attributes
   *
   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
   *  - **bindKeypress** – `{boolean}` – Enables/disables keypress event binding on `div` and
   *    `li` elements with ng-click
   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements like `div`
   *    using ng-click, making them more accessible to users of assistive technologies
   *
   * @description
   * Enables/disables various ARIA attributes
   */
  this.config = function(newConfig) {
    config = angular.extend(config, newConfig);
  };

  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
    return function(scope, elem, attr) {
      var ariaCamelName = attr.$normalize(ariaAttr);
      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
        scope.$watch(attr[attrName], function(boolVal) {
          // ensure boolean value
          boolVal = negate ? !boolVal : !!boolVal;
          elem.attr(ariaAttr, boolVal);
        });
      }
    };
  }
  /**
   * @ngdoc service
   * @name $aria
   *
   * @description
   * @priority 200
   *
   * The $aria service contains helper methods for applying common
   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
   *
   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
   * let's review a code snippet from ngAria itself:
   *
   *```js
   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
   * }])
   *```
   * Shown above, the ngAria module creates a directive with the same signature as the
   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
   * value in `ngDisabled`.
   *
   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
   *
   * The full list of directives that interface with ngAria:
   * * **ngModel**
   * * **ngChecked**
   * * **ngReadonly**
   * * **ngRequired**
   * * **ngDisabled**
   * * **ngValue**
   * * **ngShow**
   * * **ngHide**
   * * **ngClick**
   * * **ngDblclick**
   * * **ngMessages**
   *
   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
   * directive.
   *
   *
   * ## Dependencies
   * Requires the {@link ngAria} module to be installed.
   */
  this.$get = function() {
    return {
      config: function(key) {
        return config[key];
      },
      $$watchExpr: watchExpr
    };
  };
}


ngAriaModule.directive('ngShow', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
}])
.directive('ngHide', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
}])
.directive('ngValue', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
}])
.directive('ngChecked', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
}])
.directive('ngReadonly', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
}])
.directive('ngRequired', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
}])
.directive('ngModel', ['$aria', function($aria) {

  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
  }

  function shouldAttachRole(role, elem) {
    // if element does not have role attribute
    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
    // AND element is not INPUT
    return !elem.attr('role') && (elem.attr('type') === role) && (elem[0].nodeName !== 'INPUT');
  }

  function getShape(attr, elem) {
    var type = attr.type,
        role = attr.role;

    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
    compile: function(elem, attr) {
      var shape = getShape(attr, elem);

      return {
        pre: function(scope, elem, attr, ngModel) {
          if (shape === 'checkbox') {
            //Use the input[checkbox] $isEmpty implementation for elements with checkbox roles
            ngModel.$isEmpty = function(value) {
              return value === false;
            };
          }
        },
        post: function(scope, elem, attr, ngModel) {
          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);

          function ngAriaWatchModelValue() {
            return ngModel.$modelValue;
          }

          function getRadioReaction(newVal) {
            // Strict comparison would cause a BC
            // eslint-disable-next-line eqeqeq
            var boolVal = (attr.value == ngModel.$viewValue);
            elem.attr('aria-checked', boolVal);
          }

          function getCheckboxReaction() {
            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
          }

          switch (shape) {
            case 'radio':
            case 'checkbox':
              if (shouldAttachRole(shape, elem)) {
                elem.attr('role', shape);
              }
              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
                    getRadioReaction : getCheckboxReaction);
              }
              if (needsTabIndex) {
                elem.attr('tabindex', 0);
              }
              break;
            case 'range':
              if (shouldAttachRole(shape, elem)) {
                elem.attr('role', 'slider');
              }
              if ($aria.config('ariaValue')) {
                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
                var needsAriaValuenow = !elem.attr('aria-valuenow');

                if (needsAriaValuemin) {
                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
                    elem.attr('aria-valuemin', newVal);
                  });
                }
                if (needsAriaValuemax) {
                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
                    elem.attr('aria-valuemax', newVal);
                  });
                }
                if (needsAriaValuenow) {
                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
                    elem.attr('aria-valuenow', newVal);
                  });
                }
              }
              if (needsTabIndex) {
                elem.attr('tabindex', 0);
              }
              break;
          }

          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
            // ngModel.$error.required is undefined on custom controls
            attr.$observe('required', function() {
              elem.attr('aria-required', !!attr['required']);
            });
          }

          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
            scope.$watch(function ngAriaInvalidWatch() {
              return ngModel.$invalid;
            }, function ngAriaInvalidReaction(newVal) {
              elem.attr('aria-invalid', !!newVal);
            });
          }
        }
      };
    }
  };
}])
.directive('ngDisabled', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
}])
.directive('ngMessages', function() {
  return {
    restrict: 'A',
    require: '?ngMessages',
    link: function(scope, elem, attr, ngMessages) {
      if (!elem.attr('aria-live')) {
        elem.attr('aria-live', 'assertive');
      }
    }
  };
})
.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
  return {
    restrict: 'A',
    compile: function(elem, attr) {
      var fn = $parse(attr.ngClick, /* interceptorFn */ null, /* expensiveChecks */ true);
      return function(scope, elem, attr) {

        if (!isNodeOneOf(elem, nodeBlackList)) {

          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
            elem.attr('role', 'button');
          }

          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
            elem.attr('tabindex', 0);
          }

          if ($aria.config('bindKeypress') && !attr.ngKeypress) {
            elem.on('keypress', function(event) {
              var keyCode = event.which || event.keyCode;
              if (keyCode === 32 || keyCode === 13) {
                scope.$apply(callback);
              }

              function callback() {
                fn(scope, { $event: event });
              }
            });
          }
        }
      };
    }
  };
}])
.directive('ngDblclick', ['$aria', function($aria) {
  return function(scope, elem, attr) {
    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
      elem.attr('tabindex', 0);
    }
  };
}]);


})(window, window.angular);


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isDefined;
var lowercase;
var noop;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * # ngSanitize
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 *
 * <div doc-module-components="ngSanitize"></div>
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
 *   `$compileProvider`}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isDefined = angular.isDefined;
  lowercase = angular.lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = toMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = toMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = toMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');

  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function toMap(str, lowercaseKeys) {
    var obj = {}, items = str.split(','), i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  var inertBodyElement;
  (function(window) {
    var doc;
    if (window.document && window.document.implementation) {
      doc = window.document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var docElement = doc.documentElement || doc.getDocumentElement();
    var bodyElements = docElement.getElementsByTagName('body');

    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
    if (bodyElements.length === 1) {
      inertBodyElement = bodyElements[0];
    } else {
      var html = doc.createElement('html');
      inertBodyElement = doc.createElement('body');
      html.appendChild(inertBodyElement);
      doc.appendChild(html);
    }
  })(window);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }
    inertBodyElement.innerHTML = html;

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // strip custom-namespaced attributes on IE<=11
      if (window.document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }
      html = inertBodyElement.innerHTML; //trigger mXSS
      inertBodyElement.innerHTML = html;
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
      if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = node.nextSibling;
        if (!nextNode) {
          while (nextNode == null) {
            node = node.parentNode;
            if (node === inertBodyElement) break;
            nextNode = node.nextSibling;
          if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = node.nextSibling;
    }
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global ngTouchClickDirectiveFactory: false */

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * # ngTouch
 *
 * The `ngTouch` module provides touch events and other helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)).
 *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * <div doc-module-components="ngTouch"></div>
 *
 */

// define ngTouch module
/* global -ngTouch */
var ngTouch = angular.module('ngTouch', []);

ngTouch.provider('$touch', $TouchProvider);

function nodeName_(element) {
  return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

/**
 * @ngdoc provider
 * @name $touchProvider
 *
 * @description
 * The `$touchProvider` allows enabling / disabling {@link ngTouch.ngClick ngTouch's ngClick directive}.
 */
$TouchProvider.$inject = ['$provide', '$compileProvider'];
function $TouchProvider($provide, $compileProvider) {

  /**
   * @ngdoc method
   * @name  $touchProvider#ngClickOverrideEnabled
   *
   * @param {boolean=} enabled update the ngClickOverrideEnabled state if provided, otherwise just return the
   * current ngClickOverrideEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable {@link ngTouch.ngClick ngTouch's ngClick directive}. If enabled,
   * the default ngClick directive will be replaced by a version that eliminates the 300ms delay for
   * click events on browser for touch-devices.
   *
   * The default is `false`.
   *
   */
  var ngClickOverrideEnabled = false;
  var ngClickDirectiveAdded = false;
  // eslint-disable-next-line no-invalid-this
  this.ngClickOverrideEnabled = function(enabled) {
    if (angular.isDefined(enabled)) {

      if (enabled && !ngClickDirectiveAdded) {
        ngClickDirectiveAdded = true;

        // Use this to identify the correct directive in the delegate
        ngTouchClickDirectiveFactory.$$moduleName = 'ngTouch';
        $compileProvider.directive('ngClick', ngTouchClickDirectiveFactory);

        $provide.decorator('ngClickDirective', ['$delegate', function($delegate) {
          if (ngClickOverrideEnabled) {
            // drop the default ngClick directive
            $delegate.shift();
          } else {
            // drop the ngTouch ngClick directive if the override has been re-disabled (because
            // we cannot de-register added directives)
            var i = $delegate.length - 1;
            while (i >= 0) {
              if ($delegate[i].$$moduleName === 'ngTouch') {
                $delegate.splice(i, 1);
                break;
              }
              i--;
            }
          }

          return $delegate;
        }]);
      }

      ngClickOverrideEnabled = enabled;
      return this;
    }

    return ngClickOverrideEnabled;
  };

  /**
  * @ngdoc service
  * @name $touch
  * @kind object
  *
  * @description
  * Provides the {@link ngTouch.$touch#ngClickOverrideEnabled `ngClickOverrideEnabled`} method.
  *
  */
  // eslint-disable-next-line no-invalid-this
  this.$get = function() {
    return {
      /**
       * @ngdoc method
       * @name  $touch#ngClickOverrideEnabled
       *
       * @returns {*} current value of `ngClickOverrideEnabled` set in the {@link ngTouch.$touchProvider $touchProvider},
       * i.e. if {@link ngTouch.ngClick ngTouch's ngClick} directive is enabled.
       *
       * @kind function
       */
      ngClickOverrideEnabled: function() {
        return ngClickOverrideEnabled;
      }
    };
  };

}

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    },
    'pointer': {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      cancel: 'pointercancel'
    }
  };

  function getCoordinates(event) {
    var originalEvent = event.originalEvent || event;
    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
     * `event`. `cancel` receives the raw `event` as its single parameter.
     *
     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
     *
     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        if (eventHandlers['start']) {
          eventHandlers['start'](startCoords, event);
        }
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          if (eventHandlers['move']) {
            eventHandlers['move'](coords, event);
          }
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        if (eventHandlers['end']) {
          eventHandlers['end'](getCoordinates(event), event);
        }
      });
    }
  };
}]);

/* global ngTouch: false,
  nodeName_: false
*/

/**
 * @ngdoc directive
 * @name ngClick
 * @deprecated
 * sinceVersion="v1.5.0"
 * This directive is deprecated and **disabled** by default.
 * The directive will receive no further support and might be removed from future releases.
 * If you need the directive, you can enable it with the {@link ngTouch.$touchProvider $touchProvider#ngClickOverrideEnabled}
 * function. We also recommend that you migrate to [FastClick](https://github.com/ftlabs/fastclick).
 * To learn more about the 300ms delay, this [Telerik article](http://developer.telerik.com/featured/300-ms-click-delay-ios-8/)
 * gives a good overview.
 *
 * @description
 * A more powerful replacement for the default ngClick designed to be used on touchscreen
 * devices. Most mobile browsers wait about 300ms after a tap-and-release before sending
 * the click event. This version handles them immediately, and then prevents the
 * following click event from propagating.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * This directive can fall back to using an ordinary click event, and so works on desktop
 * browsers as well as mobile.
 *
 * This directive also sets the CSS class `ng-click-active` while the element is being held
 * down (by a mouse click or touch) so you can restyle the depressed element if you wish.
 *
 * @element ANY
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate
 * upon tap. (Event object is available as `$event`)
 *
 * @example
    <example module="ngClickExample" deps="angular-touch.js" name="ng-touch-ng-click">
      <file name="index.html">
        <button ng-click="count = count + 1" ng-init="count=0">
          Increment
        </button>
        count: {{ count }}
      </file>
      <file name="script.js">
        angular.module('ngClickExample', ['ngTouch']);
      </file>
    </example>
 */

var ngTouchClickDirectiveFactory = ['$parse', '$timeout', '$rootElement',
    function($parse, $timeout, $rootElement) {
  var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
  var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
  var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
  var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.

  var ACTIVE_CLASS_NAME = 'ng-click-active';
  var lastPreventedTime;
  var touchCoordinates;
  var lastLabelClickCoordinates;


  // TAP EVENTS AND GHOST CLICKS
  //
  // Why tap events?
  // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
  // double-tapping, and then fire a click event.
  //
  // This delay sucks and makes mobile apps feel unresponsive.
  // So we detect touchstart, touchcancel and touchend ourselves and determine when
  // the user has tapped on something.
  //
  // What happens when the browser then generates a click event?
  // The browser, of course, also detects the tap and fires a click after a delay. This results in
  // tapping/clicking twice. We do "clickbusting" to prevent it.
  //
  // How does it work?
  // We attach global touchstart and click handlers, that run during the capture (early) phase.
  // So the sequence for a tap is:
  // - global touchstart: Sets an "allowable region" at the point touched.
  // - element's touchstart: Starts a touch
  // (- touchcancel ends the touch, no click follows)
  // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
  //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
  // - preventGhostClick() removes the allowable region the global touchstart created.
  // - The browser generates a click event.
  // - The global click handler catches the click, and checks whether it was in an allowable region.
  //     - If preventGhostClick was called, the region will have been removed, the click is busted.
  //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
  //       other elements without ngTap on them work normally.
  //
  // This is an ugly, terrible hack!
  // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
  // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
  // encapsulates this ugly logic away from the user.
  //
  // Why not just put click handlers on the element?
  // We do that too, just to be sure. If the tap event caused the DOM to change,
  // it is possible another element is now in that position. To take account for these possibly
  // distinct elements, the handlers are global and care only about coordinates.

  // Checks if the coordinates are close enough to be within the region.
  function hit(x1, y1, x2, y2) {
    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
  }

  // Checks a list of allowable regions against a click location.
  // Returns true if the click should be allowed.
  // Splices out the allowable region from the list after it has been used.
  function checkAllowableRegions(touchCoordinates, x, y) {
    for (var i = 0; i < touchCoordinates.length; i += 2) {
      if (hit(touchCoordinates[i], touchCoordinates[i + 1], x, y)) {
        touchCoordinates.splice(i, i + 2);
        return true; // allowable region
      }
    }
    return false; // No allowable region; bust it.
  }

  // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
  // was called recently.
  function onClick(event) {
    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
      return; // Too old.
    }

    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
    // and on the input element). Depending on the exact browser, this second click we don't want
    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
    // click event
    if (x < 1 && y < 1) {
      return; // offscreen
    }
    if (lastLabelClickCoordinates &&
        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
      return; // input click triggered by label click
    }
    // reset label click coordinates on first subsequent click
    if (lastLabelClickCoordinates) {
      lastLabelClickCoordinates = null;
    }
    // remember label click coordinates to prevent click busting of trigger click event on input
    if (nodeName_(event.target) === 'label') {
      lastLabelClickCoordinates = [x, y];
    }

    // Look for an allowable region containing this click.
    // If we find one, that means it was created by touchstart and not removed by
    // preventGhostClick, so we don't bust it.
    if (checkAllowableRegions(touchCoordinates, x, y)) {
      return;
    }

    // If we didn't find an allowable region, bust the click.
    event.stopPropagation();
    event.preventDefault();

    // Blur focused form elements
    if (event.target && event.target.blur) {
      event.target.blur();
    }
  }


  // Global touchstart handler that creates an allowable region for a click event.
  // This allowable region can be removed by preventGhostClick if we want to bust it.
  function onTouchStart(event) {
    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    touchCoordinates.push(x, y);

    $timeout(function() {
      // Remove the allowable region.
      for (var i = 0; i < touchCoordinates.length; i += 2) {
        if (touchCoordinates[i] === x && touchCoordinates[i + 1] === y) {
          touchCoordinates.splice(i, i + 2);
          return;
        }
      }
    }, PREVENT_DURATION, false);
  }

  // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
  // zone around the touchstart where clicks will get busted.
  function preventGhostClick(x, y) {
    if (!touchCoordinates) {
      $rootElement[0].addEventListener('click', onClick, true);
      $rootElement[0].addEventListener('touchstart', onTouchStart, true);
      touchCoordinates = [];
    }

    lastPreventedTime = Date.now();

    checkAllowableRegions(touchCoordinates, x, y);
  }

  // Actual linking function.
  return function(scope, element, attr) {
    var clickHandler = $parse(attr.ngClick),
        tapping = false,
        tapElement,  // Used to blur the element after a tap.
        startTime,   // Used to check if the tap was held too long.
        touchStartX,
        touchStartY;

    function resetState() {
      tapping = false;
      element.removeClass(ACTIVE_CLASS_NAME);
    }

    element.on('touchstart', function(event) {
      tapping = true;
      tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
      // Hack for Safari, which can target text nodes instead of containers.
      if (tapElement.nodeType === 3) {
        tapElement = tapElement.parentNode;
      }

      element.addClass(ACTIVE_CLASS_NAME);

      startTime = Date.now();

      // Use jQuery originalEvent
      var originalEvent = event.originalEvent || event;
      var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
      var e = touches[0];
      touchStartX = e.clientX;
      touchStartY = e.clientY;
    });

    element.on('touchcancel', function(event) {
      resetState();
    });

    element.on('touchend', function(event) {
      var diff = Date.now() - startTime;

      // Use jQuery originalEvent
      var originalEvent = event.originalEvent || event;
      var touches = (originalEvent.changedTouches && originalEvent.changedTouches.length) ?
          originalEvent.changedTouches :
          ((originalEvent.touches && originalEvent.touches.length) ? originalEvent.touches : [originalEvent]);
      var e = touches[0];
      var x = e.clientX;
      var y = e.clientY;
      var dist = Math.sqrt(Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2));

      if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
        // Call preventGhostClick so the clickbuster will catch the corresponding click.
        preventGhostClick(x, y);

        // Blur the focused element (the button, probably) before firing the callback.
        // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
        // I couldn't get anything to work reliably on Android Chrome.
        if (tapElement) {
          tapElement.blur();
        }

        if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
          element.triggerHandler('click', [event]);
        }
      }

      resetState();
    });

    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
    // something else nearby.
    element.onclick = function(event) { };

    // Actual click handler.
    // There are three different kinds of clicks, only two of which reach this point.
    // - On desktop browsers without touch events, their clicks will always come here.
    // - On mobile browsers, the simulated "fast" click will call this.
    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
    // Therefore it's safe to use this directive on both mobile and desktop.
    element.on('click', function(event, touchend) {
      scope.$apply(function() {
        clickHandler(scope, {$event: (touchend || event)});
      });
    });

    element.on('mousedown', function(event) {
      element.addClass(ACTIVE_CLASS_NAME);
    });

    element.on('mousemove mouseup', function(event) {
      element.removeClass(ACTIVE_CLASS_NAME);
    });

  };
}];

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);


/***/ }),
/* 35 */
/***/ (function(module, exports) {

!function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="build/",t(t.s=104)}([function(e,t,n){"use strict";var r,i;r=[n(16),n(11),n(3),n(2),n(54),n(49)],void 0!==(i=function(e,t,n,r,i,o){function a(e){this._tags=e?n({},e):e,_&&_.sessionId&&(this._tags=this._tags||{},this._tags.sessionId=_.sessionId)}function s(){this._log("warn",m.WARN,Array.apply(null,arguments))}function u(){this._log("info",m.INFO,Array.apply(null,arguments))}function c(){this._log("debug",m.DEBUG,Array.apply(null,arguments))}function l(){this._log("trace",m.TRACE,Array.apply(null,arguments))}function p(e,t){this._tags=e,this._loggerInstance=t||C}function f(e,t,n){return this._loggerInstance.trace("Tracing started for "+e),new h(e,t||this._tags,n||this._loggerInstance)}function d(){return{end:v}}function g(e,t){return e.end(t)}function h(e,t,n){this._name=e,this._startTime=(new Date).getTime(),this._alive=!0,this._tags=t,this._loggerInstance=n}function y(e){if(!this._alive)return void this._loggerInstance.warn('Tried to end trace "'+this._name+'" which has already ended');var t=this,n=(new Date).getTime();this._alive=!1;var r={startTime:t._startTime,endTime:n,elapsedTime:n-t._startTime,name:t._name,context:e,tags:t._tags};return this._loggerInstance.trace("Tracing ended for "+this._name,r),r}var v=function(){},m={FATAL:1,ERROR:2,WARN:4,INFO:8,DEBUG:16,TRACE:32},b={NONE:0,ALL:m.FATAL|m.ERROR|m.WARN|m.INFO|m.DEBUG|m.TRACE,DEFAULT:m.FATAL|m.ERROR},_={},S={formatter:v};a.prototype.updateTags=function(e){e&&(this._tags=n(this._tags||{},e))},a.prototype._log=function(e,t,n){var r=this;x.providers[e].each(function(t){t[e].apply(t,r._tags?n.concat(r._tags):n)})},a.prototype.fatal=function(e){throw this._log("fatal",m.FATAL,Array.apply(null,arguments)),e},a.prototype.error=function(){this._log("error",m.ERROR,Array.apply(null,arguments))},a.prototype.warn=s,a.prototype.info=u,a.prototype.debug=c,a.prototype.trace=l;var C=new a;p.prototype.startTrace=f,p.prototype.endTrace=g,h.prototype.end=y;var x={providers:{},register:function(t,n){var i=this;r(m,function(r,o){(!e(n.logLevel)&&(r&b.DEFAULT)===r||(r&n.logLevel)===r)&&i.providers[o.toLowerCase()].register(t,n)})},get:function(e){var t,n=this;for(var r in m)if(m.hasOwnProperty(r)&&(t=n.providers[r.toLowerCase()].get(e)))break;return t},unregister:function(e){var t=this;r(m,function(n,r){t.providers[r.toLowerCase()].unregister(e)})},init:function(){var e=this;r(m,function(t,n){e.providers[n.toLowerCase()]=new i})},updateLogabilityAndTraceability:function(){var e=this,t=e.providers.trace.hasProviders();a.prototype.warn=e.providers.warn.hasProviders()?s:v,a.prototype.info=e.providers.info.hasProviders()?u:v,a.prototype.debug=e.providers.debug.hasProviders()?c:v,a.prototype.trace=t?l:v,p.prototype.startTrace=t?f:d,p.prototype.endTrace=t?g:v,h.prototype.end=t?y:v}};return x.init(),x.updateLogabilityAndTraceability(),{logger:C,getTagsDecoratedLogger:function(e){return new a(e)},tracer:new p,getTagsDecoratedTracer:function(e,t){return new p(e,t)},LOG_LEVEL:b,LOG_TYPE:m,getLogProvider:function(e){return x.get(e)},registerLogProvider:function(e,t,n){x.unregister(e),n?x.register(e,new o(n,t)):x.register(e,t),x.updateLogabilityAndTraceability()},unregisterLogProvider:function(e){x.unregister(e),x.updateLogabilityAndTraceability()},changeLogLevelForProvider:function(t,n){var r;e(n)&&(r=x.get(t))&&r.logLevel!==n&&(r.logLevel=n,x.unregister(t),x.register(t,r)),x.updateLogabilityAndTraceability()},updateIdentity:function(e){_=t(_||{},e),_&&_.sessionId&&C.updateTags({sessionId:_.sessionId}),C.info(e)},getIdentity:function(){return _},resetIdentity:function(){_=null,C.info("Resetting identity")},updateOptions:function(e){S=t(S,e)}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return{isFunction:n(23),isArray:n(15),isBoolean:n(115),isPlainObject:n(24),isWindow:n(62),isDate:n(33),isValidDate:n(61),isEmptyObject:n(117),isNumber:n(16),isString:n(6),isRegex:n(118),isUndefined:n(60),isUndefinedOrNull:n(59),isObject:n(17),isDomElement:n(116),getPrototype:n(56),noop:n(121),url:n(122),parse:n(63),each:n(2),filter:n(111),any:n(105),has:n(57),toString:n(65),isEqual:n(58),componentPath:n(106),string:n(64),merge:n(11),map:n(34),css:n(107),intlNumberFormat:n(114),intlDateFormat:n(113),log:n(120),field:n(110),fastdom:n(130),ensureObjectPaths:n(109),date:n(108),freeze:n(112),lightMerge:n(119),cloneObject:n(55)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e,t,n){if(null==e)return e;var r,i=e.length;if(i===+i)for(r=0;r<i;r++)t(e[r],r,e);else{var o=Object.keys(e);for(r=0,i=o.length;r<i;r++)t(e[o[r]],o[r],e)}return e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(23),n(15),n(24)],void 0!==(i=function(e,t,n){function r(){var i,a,s,u,c,l,p=arguments[0]||{},f=1,d=arguments.length,g=!1;if(1!==d){for("boolean"==typeof p&&(g=p,p=arguments[1]||{},f=2),"object"===(void 0===p?"undefined":o(p))||e(p)||(p={});f<d;f++)if(null!=(c=arguments[f])){var h=Object.getOwnPropertyNames(c||{});for(var y in h)if(h.hasOwnProperty(y)){if("_$parent"===(u=h[y]))continue;if(i=p[u],s=c[u],p===s)continue;var v=Object.getOwnPropertyDescriptor(c,u);if(void 0===v)continue;var m=v.get||v.set||!v.enumerable||!v.writable;!m&&g&&s&&(n(s)||(a=t(s)))?(a?(a=!1,l=i&&t(i)?i:[]):l=i&&n(i)?i:{},p[u]=r(g,l,s),Object.defineProperty(p[u],"_$parent",{enumerable:!1,value:p})):void 0!==s&&Object.defineProperty(p,u,v)}}return p}}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(8),n(37),n(27)],void 0!==(i=function(e,t,n){function r(r){if(n.unindexedChars&&t(r)){for(var i=-1,o=r.length,a=Object(r);++i<o;)a[i]=r.charAt(i);return a}return e(r)?r:Object(r)}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(74),n(13),n(7)],void 0!==(i=function(e,t,n){var r=Object.prototype,i=r.toString;return e(Array,"isArray")||function(e){return n(e)&&t(e.length)&&"[object Array]"==i.call(e)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return"string"==typeof e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[],void 0!==(i=function(){function e(e){return!!e&&"object"==(void 0===e?"undefined":o(e))}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[],void 0!==(i=function(){function e(e){var t=void 0===e?"undefined":o(e);return!!e&&("object"==t||"function"==t)}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(3),n(1),n(0)],void 0!==(i=function(e,t,n){var r={},i={custom:{__requires:[{name:"execute",type:"function"}]},regex:{__requires:[{name:"pattern",type:"regex",transformType:"string",transform:function(e){return new RegExp(e)}}],execute:function(e,t){return this.pattern.test(e)}}},o=function(e,n){switch(n){case"regex":return t.isRegex(e);case"function":return t.isFunction(e);case"string":return t.isString(e)}return!1},a=function(a,s){s.type||n.logger.fatal(new Error("addValidationRule requires type")),t.isString(a)||t.isArray(a)||n.logger.fatal(new Error("addValidationRule requires a string or array key")),i[s.type]||n.logger.fatal(new Error("Unrecognized validator type: "+s.type));var u=e({},i[s.type]);if(t.each(u.__requires,function(e,t){var r=s[e.name];s.hasOwnProperty(e.name)&&o(r,e.type)||(!o(r,e.type)&&o(r,e.transformType)?s[e.name]=e.transform(r):n.logger.fatal(new Error("baseValidator requires property: "+e.name+" of type "+e.type)))}),delete u.__requires,s=e(u,s),t.isArray(a))for(var c in a){var l=a[c];r.hasOwnProperty(l)||(r[l]=s)}else{if(r.hasOwnProperty(a))return;r[a]=s}},s=function(e){var t=r.hasOwnProperty(e)?r[e]:null;return null===t&&n.logger.fatal(new Error("Invalid validator key: "+e)),t},u=function(e,t){return!1===t||!0===e.runFalsy},c=function(e,r){switch(e){case"number":return t.isNumber(r);case"string":return t.isString(r);case"date":return t.isDate(r);default:n.logger.fatal(new Error("Unrecognized data type: "+e))}};return{addValidationRule:a,addCustomValidationRule:function(e,t){a(e,{type:"custom",execute:t})},getValidator:function(e){if(e=e||{},!(e.rules&&t.isPlainObject(e.rules)&&0!==Object.keys(e.rules).length||t.isString(e.dataType)))return null;var r=e.path?t.parse(e.path):null;return{validate:function(i){i=r?r(i):i;var o={},a=null==i||""===i;return t.isString(e.dataType)&&!1===a&&(o.dataType={rule:{type:"dataType",labelKey:e.dataTypeLabelKey||"fieldInvalidDatatype"+t.string.firstUpperCase(e.dataType)},returnValue:c(e.dataType,i)},!o.dataType.returnValue)?o:(t.each(e.rules,function(e,t){var r=s(e.type);u(r,a)&&(o[t]&&n.logger.fatal(new Error("Multiple occurrences of the same rule key: "+t)),o[t]={rule:e,returnValue:r.execute(i,e)})}),o)}}}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[],void 0!==(i=function(){function e(e){return!!e&&"object"==(void 0===e?"undefined":o(e))}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return n(165).merge}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(73),n(13)],void 0!==(i=function(e,t){function n(n){return null!=n&&t(e(n))}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=t}var t=9007199254740991;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[],void 0!==(i=function(){function e(e){var t=void 0===e?"undefined":o(e);return!!e&&("object"==t||"function"==t)}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return Array.isArray||function(e){return e instanceof Array}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return"number"==typeof e}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[],void 0!==(i=function(){return function(e){return"object"===(void 0===e?"undefined":o(e))&&null!==e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(74),n(12),n(8),n(161),n(27)],void 0!==(i=function(e,t,n,r,i){var o=e(Object,"keys");return o?function(e){var a=null==e?void 0:e.constructor;return"function"==typeof a&&a.prototype===e||("function"==typeof e?i.enumPrototypes:t(e))?r(e):n(e)?o(e):[]}:r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(187),n(20)],void 0!==(i=function(e,t){function n(n){return null!=n&&t(e(n))}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=t}var t=9007199254740991;return e}.apply(t,r))&&(e.exports=i)},function(e,t){e.exports=morningstar},function(e,t,n){"use strict";var r,i;r=[n(1),n(0),n(168),n(197),n(198)],void 0!==(i=function(e,t,n,r,i){return n.config(e,t,r,i)}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return"function"==typeof e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(56),n(62)],void 0!==(i=function(e,t){return function(t){return!(!t||t.nodeType)&&("object"===(void 0===t?"undefined":o(t))&&e(t)===Object.prototype)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(12),n(7)],void 0!==(i=function(e,t){function n(n){return t(n)&&e(n)&&i.call(n,"callee")&&!o.call(n,"callee")}var r=Object.prototype,i=r.hasOwnProperty,o=r.propertyIsEnumerable;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(67),n(25),n(5),n(78),n(36),n(13),n(8),n(37),n(27)],void 0!==(i=function(e,t,n,r,i,o,a,s,u){function c(e){if(null==e)return[];a(e)||(e=Object(e));var c=e.length;c=c&&o(c)&&(n(e)||t(e)||s(e))&&c||0;for(var _=e.constructor,S=-1,C=r(_)&&_.prototype||h,x=C===e,w=Array(c),E=c>0,j=u.enumErrorProps&&(e===g||e instanceof Error),P=u.enumPrototypes&&r(e);++S<c;)w[S]=S+"";for(var A in e)P&&"prototype"==A||j&&("message"==A||"name"==A)||E&&i(A,c)||"constructor"==A&&(x||!v.call(e,A))||w.push(A);if(u.nonEnumShadows&&e!==h){var z=e===y?f:e===g?l:m.call(e),k=b[z]||b[p];for(z==p&&(C=h),c=d.length;c--;){A=d[c];var T=k[A];x&&T||(T?!v.call(e,A):e[A]===C[A])||w.push(A)}}return w}var l="[object Error]",p="[object Object]",f="[object String]",d=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],g=Error.prototype,h=Object.prototype,y=String.prototype,v=h.hasOwnProperty,m=h.toString,b={};return b["[object Array]"]=b["[object Date]"]=b["[object Number]"]={constructor:!0,toLocaleString:!0,toString:!0,valueOf:!0},b["[object Boolean]"]=b[f]={constructor:!0,toString:!0,valueOf:!0},b[l]=b["[object Function]"]=b["[object RegExp]"]={constructor:!0,toString:!0},b[p]={constructor:!0},e(d,function(e){for(var t in b)if(v.call(b,t)){var n=b[t];n[e]=v.call(n,e)}}),c}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){var e=Array.prototype,t=Error.prototype,n=Object.prototype,r=n.propertyIsEnumerable,i=e.splice,o={};return function(e){var n=function(){this.x=1},a={0:1,length:1},s=[];n.prototype={valueOf:1,y:1};for(var u in new n)s.push(u);o.enumErrorProps=r.call(t,"message")||r.call(t,"name"),o.enumPrototypes=r.call(n,"prototype"),o.nonEnumShadows=!/valueOf/.test(s),o.ownLast="x"!=s[0],o.spliceObjects=(i.call(a,0,1),!a[0]),o.unindexedChars="x"[0]+Object("x")[0]!="xx"}(),o}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(19),n(10)],void 0!==(i=function(e,t){function n(n){return t(n)&&e(n)&&i.call(n,"callee")&&!o.call(n,"callee")}var r=Object.prototype,i=r.hasOwnProperty,o=r.propertyIsEnumerable;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(92),n(20),n(10)],void 0!==(i=function(e,t,n){var r=Object.prototype,i=r.toString;return e(Array,"isArray")||function(e){return n(e)&&t(e.length)&&"[object Array]"==i.call(e)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(91),n(28),n(29),n(94),n(42),n(20),n(14),n(44),n(31)],void 0!==(i=function(e,t,n,r,i,o,a,s,u){function c(e){if(null==e)return[];a(e)||(e=Object(e));var c=e.length;c=c&&o(c)&&(n(e)||t(e)||s(e))&&c||0;for(var _=e.constructor,S=-1,C=r(_)&&_.prototype||h,x=C===e,w=Array(c),E=c>0,j=u.enumErrorProps&&(e===g||e instanceof Error),P=u.enumPrototypes&&r(e);++S<c;)w[S]=S+"";for(var A in e)P&&"prototype"==A||j&&("message"==A||"name"==A)||E&&i(A,c)||"constructor"==A&&(x||!v.call(e,A))||w.push(A);if(u.nonEnumShadows&&e!==h){var z=e===y?f:e===g?l:m.call(e),k=b[z]||b[p];for(z==p&&(C=h),c=d.length;c--;){A=d[c];var T=k[A];x&&T||(T?!v.call(e,A):e[A]===C[A])||w.push(A)}}return w}var l="[object Error]",p="[object Object]",f="[object String]",d=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],g=Error.prototype,h=Object.prototype,y=String.prototype,v=h.hasOwnProperty,m=h.toString,b={};return b["[object Array]"]=b["[object Date]"]=b["[object Number]"]={constructor:!0,toLocaleString:!0,toString:!0,valueOf:!0},b["[object Boolean]"]=b[f]={constructor:!0,toString:!0,valueOf:!0},b[l]=b["[object Function]"]=b["[object RegExp]"]={constructor:!0,toString:!0},b[p]={constructor:!0},e(d,function(e){for(var t in b)if(v.call(b,t)){var n=b[t];n[e]=v.call(n,e)}}),c}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){var e=Array.prototype,t=Error.prototype,n=Object.prototype,r=n.propertyIsEnumerable,i=e.splice,o={};return function(e){var n=function(){this.x=1},a={0:1,length:1},s=[];n.prototype={valueOf:1,y:1};for(var u in new n)s.push(u);o.enumErrorProps=r.call(t,"message")||r.call(t,"name"),o.enumPrototypes=r.call(n,"prototype"),o.nonEnumShadows=!/valueOf/.test(s),o.ownLast="x"!=s[0],o.spliceObjects=(i.call(a,0,1),!a[0]),o.unindexedChars="x"[0]+Object("x")[0]!="xx"}(),o}.apply(t,r))&&(e.exports=i)},function(module,exports,__webpack_require__){"use strict";var __WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;__WEBPACK_AMD_DEFINE_ARRAY__=[__webpack_require__(1),__webpack_require__(3),__webpack_require__(0)],void 0!==(__WEBPACK_AMD_DEFINE_RESULT__=function(util,extend,instrumentation){function ConfigEvaluator(e,t,n){this._logger=instrumentation.getTagsDecoratedLogger({componentModulePath:e}),this._logger.debug("ConfigEvaluator constructor",t,n),this.modulePath=e,this.instanceRegistry=t,this.context=n,this._cache={}}var singleMustacheRegex=new RegExp("\\{\\{\\_\\s*(.*?)\\s*\\_\\}\\}"),multiMustacheRegex=new RegExp("\\{\\{\\_\\s*(.*?)\\s*\\_\\}\\}","g"),exactlyOneMustacheRegex=new RegExp("^\\{\\{\\_\\s*([^}]*?)\\s*\\_\\}\\}$");return ConfigEvaluator.prototype.evaluate=function(e,t,n){this._logger.debug("ConfigEvaluator.evaluate()",e,t,n);var r=this,i=instrumentation.tracer.startTrace("ConfigEvaluator.evaluate",{componentModulePath:r.modulePath},this._logger);this.references=[],this.evaluationTypes=t||{settings:!0,model:!0,labels:!0,parameters:!0,value:!0,self:!0,tokens:!0},this.options=extend({selfStatic:null,placeholders:{}},n),this.options.selfStatic||(this.evaluationTypes.self=!1),util.each(this.options.placeholders,function(e,t){r.evaluationTypes[t]=!0});var o={reEvaluate:function(){var t=instrumentation.tracer.startTrace("ConfigEvaluator.reEvaluate",{componentModulePath:r.modulePath},this._loggerInstance),n=util.isPlainObject(e)||util.isArray(e)?JSON.parse(JSON.stringify(e)):e;r.references.length=0;var i=r._traverse(n);return this.references=r.references.slice(),t.end(i),i}};return o.evaluated=o.reEvaluate(),o.listen=function(e){var t=[];return util.each(this.references,function(n){t.push(n.listen(e))}),function(){util.each(t,function(e){e()})}},Object.defineProperty(o,"hasValues",{get:function(){return!util.any(this.references,function(e){return!e.hasValue})}}),i.end({obj:e,evaluationTypes:t,options:n,result:o}),o},ConfigEvaluator.prototype._hasMustache=function(e){return singleMustacheRegex.test(e)},ConfigEvaluator.prototype._evaluateString=function(e,t){var n=this;if(!this._hasMustache(e))return e;var r={expression:e,path:t};if(n._cache[r.expression]){var i=!1;if(util.each(n._cache[r.expression].referenceEntries,function(e){if(!i)return null==e?void(i=!0):void(e.prevValue!==e.getCurrentValue()&&(i=!0))}),!i)return n.references.push.apply(n.references,n._cache[r.expression].references),n._cache[r.expression].result}var o=null;if(exactlyOneMustacheRegex.test(e)){var a=e.match(exactlyOneMustacheRegex);o=n._evaluateStringExpressions(a[1],a[0],r,!0)}else o=e.replace(multiMustacheRegex,function(e,t){return n._evaluateStringExpressions(t,e,r)});return n._cache[r.expression]=n._cache[r.expression]||{referenceEntries:[]},n._cache[r.expression].result=o,n._cache[r.expression].references=this.references.slice(),o},ConfigEvaluator.prototype._evaluateStringExpressions=function(e,t,n,r){this.hasStringValue=!1,this.isObject=!1;var i=e,o=this;n.isSingleMatch=!!r;var a=e;return a=o._evaluateStringExpressionTypes(a,n,t,function(e){var t=this.type;return o.options.placeholders[t]?o.options.placeholders[t]:"self"===t?o.options.selfStatic:"tokens"===t?o.context.getTokens():e["get"+util.string.firstUpperCase(t)]()}),a===i?t:this.hasStringValue?a:this.isObject?a:this._eval(a)},ConfigEvaluator.prototype._eval=function _eval(str){return this._isJsonSerialized(str)?JSON.parse(str):eval(str)},ConfigEvaluator.prototype._isJsonSerialized=function(e){return 0===e.indexOf("{")||0===e.indexOf("[")},ConfigEvaluator.prototype._evaluateStringExpressionTypes=function(e,t,n,r){var i=this,o=null,a=[];if(util.each(this.evaluationTypes,function(e,t){e&&a.push(t)}),!a.length)return e;var s=new RegExp(["(",a.join("|"),")"].join("")+"\\((.*?)\\)(?:\\.([^+\\-*\\/\\s|()]*))?(?:\\|(number|date)(?:\\(([^)]*)\\))?)?","g");return e=e.replace(s,function(e,a,s,u,c,l){return o=i._getReplacementsRecursively(r,s,u,c,l,a,t,n)}),this.isObject?o:e},ConfigEvaluator.prototype._getReplacementsRecursively=function(e,t,n,r,i,o,a,s){e=e.bind({type:o});var u;try{u=this.instanceRegistry.get(this.modulePath,t)}catch(e){return this.hasStringValue=!0,this._logger.error(new Error("ConfigEvaluator failed to evaluate expression"),{mustache:s,modulePath:this.modulePath}),s}var c=this;u||c._logger.fatal(new Error("ConfigEvaluator could not find referenced instance: "+this.modulePath+", "+t));var l={type:o,instance:u,refPath:n||"",source:a,listen:this._createListener(o,n||"",u),assign:this._createAssigner(o,n||"",u),cacheKey:this._createCacheKey(o,n||"",u),get:this._createGetter(n||"",u,e),eventType:this._getEventType(o,n||""),mustache:s,modulePath:this.modulePath,relativeModulePath:t,formatType:r,format:i,evaluate:function(){return new ConfigEvaluator(this.modulePath,c.instanceRegistry,c.context).evaluate(this.source.expression,c.evaluationTypes,c.options)}},p=e(u);if("self"===o&&c.options.selfStatic?(l.assign=function(e){morningstar.asterix.util.parse(n).assign(c.options.selfStatic,e)},l.get=function(){return morningstar.asterix.util.parse(n)(c.options.selfStatic)}):c.options.placeholders[o]&&(l.assign=function(e){morningstar.asterix.util.parse(n).assign(c.options.placeholders[o],e)},l.get=function(){return morningstar.asterix.util.parse(n)(c.options.placeholders[o])}),p=n?util.parse(n)(p):p,c.options.extractPath){var f=util.parse(c.options.extractPath)(p);null!=f&&(p=f)}if(this._hasMustache(p)&&"model"!==o){var d=util.componentPath.relative(c.modulePath,u.getModulePath()),g=new ConfigEvaluator(u.getModulePath(),this.instanceRegistry),h=g.evaluate(p);util.each(h.references,function(e){var t=d?util.componentPath.resolve(d,e.relativeModulePath):e.relativeModulePath,n=e.mustache.replace("("+e.relativeModulePath+")","("+t+")");if(r){var o="|"+r+(i?"("+i+")":"");n=n.replace(/(?:\|.*?)?(\s*\_\}\})/,function(e,t){return o+t})}e.modulePath=c.modulePath,e.source=l.source,e.source.expression=e.source.expression.replace(s,n)}),Array.prototype.push.apply(this.references,h.references),p=h.evaluated,util.each(h.references,function(e){c._cacheReferenceEntry(e)})}else this.references.push(l),c._cacheReferenceEntry(l);l.value=p,l.hasValue=null!=p;var y=p;return p=this._getFormatted(p,this.instanceRegistry.get(this.modulePath),r,i),a.isSingleMatch&&morningstar.asterix.util.isObject(y)&&(this.isObject=!0,p=y),!0===this.hasStringValue?p:this.isObject?p:JSON.stringify(p)},ConfigEvaluator.prototype._cacheReferenceEntry=function(e){this._cache[e.source.expression]=this._cache[e.source.expression]||{referenceEntries:{}},this._cache[e.source.expression].referenceEntries[e.cacheKey]=util.isObject(e.get())?null:{prevValue:e.get(),getCurrentValue:e.get}},ConfigEvaluator.prototype._getEventType=function(e,t){switch(e){case"parameters":return t?["parameterChanged",t].join(":"):"parametersChanged";case"model":return t?["modelPropertyChanged",t].join(":"):"modelChanged";case"value":if(!t)return"valueChanged";this._logger.fatal(new Error('refPath for reference of type "value" in ConfigEvaluator is not implemented yet'));case"tokens":if(t)return["tokenChanged",t].join(":");this._logger.fatal(new Error("can't use a tokens expression without a refPath"))}return null},ConfigEvaluator.prototype._createCacheKey=function(e,t,n){return t?[n.getModulePath(),e,t].join(":"):[n.getModulePath(),e].join(":")},ConfigEvaluator.prototype._createAssigner=function(e,t,n){return function(r){switch(e){case"parameters":t?n.setParameter(t,r):n.setParameters(r);break;case"model":t?n.setModelProperty(t,r):n.setModel(r);break;default:this._logger.fatal(new Error('can\'t use reference "assign" method for type '+e))}}},ConfigEvaluator.prototype._createGetter=function(e,t,n){return function(){var r=n(t);return e?morningstar.asterix.util.parse(e)(r):r}},ConfigEvaluator.prototype._createListener=function(e,t,n){var r=this;return function(i){var o=r._getEventType(e,t);return null==o?util.noop:0===o.indexOf("tokenChanged")?r.context.onTokenChanged(o.split(":")[1],i):n.on(o,i)}},ConfigEvaluator.prototype._getFormatted=function(e,t,n,r){if(null==n)return util.isString(e)&&(this.hasStringValue=!0),e;this.hasStringValue=!0;var i=t.getFormatter();return"number"===n?e=i.number(e,{formatString:r}):"date"===n&&(e=i.date(e,{formatString:r})),e},ConfigEvaluator.prototype._traverse=function(e,t){t=t||"";var n=this;if(util.isString(e))return n._evaluateString(e,t);if(util.isPlainObject(e)||util.isArray(e)){var r=t;util.each(e,function(i,o){t=r?r+"."+o:o,e[o]=n._traverse(i,t)})}return e},ConfigEvaluator}.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__))&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return"[object Date]"===Object.prototype.toString.call(e)}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(e){return n(132).map}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(){try{Object({toString:0}+"")}catch(e){return function(){return!1}}return function(e){return"function"!=typeof e.toString&&"string"==typeof(e+"")}}()}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,r){return e="number"==typeof e||t.test(e)?+e:-1,r=null==r?n:r,e>-1&&e%1==0&&e<r}var t=/^\d+$/,n=9007199254740991;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(7)],void 0!==(i=function(e){function t(t){return"string"==typeof t||e(t)&&i.call(t)==n}var n="[object String]",r=Object.prototype,i=r.toString;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(13),n(7)],void 0!==(i=function(e,t){function n(n){return t(n)&&e(n.length)&&!!r[o.call(n)]}var r={};r["[object Float32Array]"]=r["[object Float64Array]"]=r["[object Int8Array]"]=r["[object Int16Array]"]=r["[object Int32Array]"]=r["[object Uint8Array]"]=r["[object Uint8ClampedArray]"]=r["[object Uint16Array]"]=r["[object Uint32Array]"]=!0,r["[object Arguments]"]=r["[object Array]"]=r["[object ArrayBuffer]"]=r["[object Boolean]"]=r["[object Date]"]=r["[object Error]"]=r["[object Function]"]=r["[object Map]"]=r["[object Number]"]=r["[object Object]"]=r["[object RegExp]"]=r["[object Set]"]=r["[object String]"]=r["[object WeakMap]"]=!1;var i=Object.prototype,o=i.toString;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e,t,n){if(null==e)return e;var r,i=e.length;if(i===+i)for(r=0;r<i;r++)t(e[r],r,e);else{var o=Object.keys(e);for(r=0,i=o.length;r<i;r++)t(e[o[r]],o[r],e)}return e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(82),n(90)],void 0!==(i=function(e,t){return function(t){return!(!t||t.nodeType)&&("object"===(void 0===t?"undefined":o(t))&&e(t)===Object.prototype)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return n(193).merge}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,r){return e="number"==typeof e||t.test(e)?+e:-1,r=null==r?n:r,e>-1&&e%1==0&&e<r}var t=/^\d+$/,n=9007199254740991;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(14),n(44),n(31)],void 0!==(i=function(e,t,n){function r(r){if(n.unindexedChars&&t(r)){for(var i=-1,o=r.length,a=Object(r);++i<o;)a[i]=r.charAt(i);return a}return e(r)?r:Object(r)}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(10)],void 0!==(i=function(e){function t(t){return"string"==typeof t||e(t)&&i.call(t)==n}var n="[object String]",r=Object.prototype,i=r.toString;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(92),n(19),n(14),n(189),n(31)],void 0!==(i=function(e,t,n,r,i){var o=e(Object,"keys");return o?function(e){var a=null==e?void 0:e.constructor;return"function"==typeof a&&a.prototype===e||("function"==typeof e?i.enumPrototypes:t(e))?r(e):n(e)?o(e):[]}:r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(22),n(1),n(47),n(52),n(3),n(32),n(123),n(53),n(0),n(51)],void 0!==(i=function(e,t,n,r,i,o,a,s,u,c){function l(e,n){this._logger=u.getTagsDecoratedLogger({componentModulePath:e}),this._logger.debug("ComponentInstance.ctor()",n),this._usageTracker=c.getComponentDecoratedTracker(this),this._tracer=u.getTagsDecoratedTracer({componentModulePath:e},this._logger),this.isActive=!1,this.modulePath=e,this.instanceRegistry=n,this._moduleType=null,this._moduleTypePath=null,this.events={},this.listeners=[],this.model={},this.parameters={},this.labelsCache={},this.isDestroyed=!1,this.eventPathPrevValue={parameterChanged:{},modelPropertyChanged:{},modelPropertyChanging:{},modelPropertyReset:{}},this.unregisterFunctions=[],this.resetValidationState();var r=this;t.each(p,function(e){r.events[e]=[]})}var p=["activated","cancel","click","dataLoaded","deactivated","destroyed","editItem","labelChanged","labelsChanged","modelChanged","modelPropertyChanged","modelPropertyReset","modelReset","parameterChanged","parametersChanged","save","takeAction","valueChanged","validationReferenceChanged","validationStateChanged","dragStart","drag","dragEnd","dropEnter","drop","dropOut","loaded"],f=/^(activated|deactivated|destroyed)/;return l.prototype.hasParent=function(){return this.getModulePath().indexOf(".")>=0},l.prototype.getOwnInstanceId=function(){var e=this.getModulePath().split(".");return e[e.length-1]},l.prototype.resetValidationState=function(){this._logger.info("ComponentInstance.resetValidationState()"),this.validationState=this.validationState||new a(this),this.validationState.reset()},l.prototype.getValidationState=function(){return this.validationState},l.prototype.resetModel=function(){this._logger.info("ComponentInstance.resetModel()"),this.model={},this.prevModel=null,t.each(this.eventPathPrevValue,function(e,n){t.each(e,function(e){delete e.prevValue})}),this.resetValidationState(),this.trigger("modelReset")},l.prototype.destroy=function(){this._logger.info("ComponentInstance.destroy()");var e=this;this.trigger("destroyed"),this.events={},t.each(this.listeners,function(t){t.instance.isDestroyed||t.instance==e||t.instance.off(t.eventName,t.callback)}),t.each(this.unregisterFunctions,function(e){e()}),this.listeners.length=0,this.isDestroyed=!0},l.prototype.on=function(e,n){this._logger.debug("ComponentInstance.on()",e);var r,i=this;if(2===(r=e.split(":")).length&&this.eventPathPrevValue[r[0]]&&(this.eventPathPrevValue[r[0]][r[1]]||(this.eventPathPrevValue[r[0]][r[1]]={prevValue:null,getValue:t.parse(r[1])}),this.events.hasOwnProperty(e)||(this.events[e]=[])),!this.events.hasOwnProperty(e)){var o=morningstar.asterix.meta.get(this.getModuleType(),"allowedEvents");o&&-1!==o.indexOf(e)?this.events[e]=[]:this._logger.fatal(new Error("("+this.modulePath+") Unrecognized event: "+e))}return this.events[e].push(n),function(){i.off(e,n)}},l.prototype.off=function(e,t){this._logger.debug("ComponentInstance.off()",e),this.events.hasOwnProperty(e)&&this.events.hasOwnProperty(e)&&this.events[e].indexOf(t)>=0&&this.events[e].splice(this.events[e].indexOf(t),1)},l.prototype.trigger=function(e,n){this._logger.info("ComponentInstance.trigger()",e,n);var r=this,i={or:function(t){r.events[e]&&0!==r.events[e].length&&r.isActive||t()}},o=f.test(e);return t.isUndefined(n)&&(n=[]),this.events[e]||o?((r.isActive||o)&&t.each(this.events[e],function(e){e&&t.isFunction(e)&&e.apply(r,n)}),i):i},l.prototype.hasListener=function(e){return this.events.hasOwnProperty(e)&&this.events[e].length>0},l.prototype.listen=function(e,n,r){this._logger.debug("ComponentInstance.listen()",e,n),t.any(this.listeners,function(t){return t.instance===e&&t.eventName===n})||(this.listeners.push({instance:e,eventName:n,callback:r}),e.on(n,r))},l.prototype.getModulePath=function(){return this.modulePath},l.prototype.getModuleType=function(){return this._moduleType=this._moduleType||e.getComponentType(this.getModulePath())},l.prototype.getModuleTypePath=function(){var e=this;return this._moduleTypePath=this._moduleTypePath||function(){var n="";return e.hasParent()&&(n=e.instanceRegistry.get(t.componentPath.resolve(e.getModulePath(),"_")).getModuleTypePath()),""===n?e.getModuleType():n+"."+e.getModuleType()}()},l.prototype.getValue=function(){return this.value},l.prototype.setValue=function(e){this._logger.info("ComponentInstance.setValue()",e),this.value=e,this.trigger("valueChanged",[e])},l.prototype.getModel=function(){return this.model},l.prototype.setModel=function(e){this._logger.info("ComponentInstance.setModel()",e,this.prevModel),t.isEqual(e,this.prevModel)||(this.prevModel=t.isObject(e)?t.merge(t.isArray(e)?[]:{},e):e,this._triggerPathEvents("modelPropertyChanging",e),this.model=e,this.trigger("modelChanged",[e]),this._triggerPathEvents("modelPropertyChanged",e))},l.prototype.setModelProperty=function(e,n){this._logger.info("ComponentInstance.setModelProperty()",e,n);var r=t.parse(e);null!==n&&t.isEqual(r(this.prevModel),n)||(this.prevModel=this.prevModel||{},r.assign(this.prevModel,t.isObject(n)?t.merge(t.isArray(n)?[]:{},n):n),r.assign(this.model,n),this._triggerPathEvents("modelPropertyChanging",this.model,e),this.trigger("modelChanged",[this.model]),this.trigger("modelPropertyChanged",[n,e]),this._triggerPathEvents("modelPropertyChanged",this.model,e),null===n&&(this.trigger("modelPropertyReset",[n,e]),this._triggerPathEvents("modelPropertyReset",this.model,e)))},l.prototype.getModelProperty=function(e){return t.parse(e)(this.model)},l.prototype.validate=function(e){if(this.validator=r.getValidator(this._getEvaluatedValidationRulesAndListenForChanges()),this.validator){var t=this.validator.validate(e);return this._logger.debug("ComponentInstance.validate()",t),t}},l.prototype._isValid=function(e){return!t.any(e,function(e){return!e.returnValue})},l.prototype._pathHasBeginning=function(e,t){e&&-1!==e.indexOf(".")&&(e=e.substring(0,e.indexOf(".")));var n=t.split(".")[0];return n.indexOf("[")>-1&&(n=n.replace(/\[[0-9]+\]/g,"")),n===e||!e},l.prototype._triggerPathEvents=function(e,n,r){this._logger.info("ComponentInstance.triggerPathEvents()",e,n,r);var i=this;t.each(this.eventPathPrevValue[e],function(o,a){if(i._pathHasBeginning(r,a)){var s=o.getValue(n),u=null;u=t.isPlainObject(o.prevValue)||t.isArray(o.prevValue)?t.merge(t.isArray(o.prevValue)?[]:{},o.prevValue):o.prevValue,t.isEqual(s,o.prevValue)||(t.isPlainObject(s)||t.isArray(s)?o.prevValue=t.merge(t.isArray(s)?[]:{},s):o.prevValue=s,i.trigger(e+":"+a,[s,u]))}})},l.prototype._getEvaluatedValidationRulesAndListenForChanges=function(){var e=this,n=i(!0,{},this.getSettings()._validation),r=new o(this.modulePath,e.instanceRegistry),a=r.evaluate(n);return t.each(a.references,function(t){e.listen(t.instance,t.eventType,function(n){e.trigger("validationReferenceChanged",[t,n])})}),a.evaluated},l.prototype.getSettings=function(){return this._cachedSettings?this._cachedSettings:(this._cachedSettings=e.getSettings(this.modulePath),this._cachedSettings.fields&&(this._cachedSettings=t.merge({},this._cachedSettings),this._cachedSettings.fields=t.field.applyDefinitionsAndAliasesToMany(this._cachedSettings.fields,this._cachedSettings.fieldDefinitions,this._cachedSettings.formatAliases),this.getSettings().freezeConfig&&t.freeze.deep(this._cachedSettings)),this._cachedSettings)},l.prototype.getLabels=function(){return this.labelsCache[this.getSettings().languageId]?this.labelsCache[this.getSettings().languageId]:this.labelsCache[this.getSettings().languageId]=this._getEvaluatedLabelsAndListenForChanges()},l.prototype._getEvaluatedLabelsAndListenForChanges=function(){var n=this,r=e.getLabels(this.modulePath,this.getSettings().languageId),i=new o(this.modulePath,this.instanceRegistry),a=!1;for(var s in r){if(a)break;var u=r[s];i._hasMustache(u)&&(a=!0)}if(!a)return r;var c=i.evaluate(r,{model:!0,value:!0,settings:!0,parameters:!0});return this.isListeningToLabelReferences||(this.isListeningToLabelReferences=!0,t.each(c.references,function(e){n.unregisterFunctions.push(e.listen(function(){var r=n.labelsCache[n.getSettings().languageId],i=e.evaluate();t.parse(e.source.path).assign(r,i.evaluated),n.trigger("labelChanged",[i.evaluated,e.source.path])}))})),c.evaluated},l.prototype.getFormatter=function(){var t,r,i,o;t=e.getSetting(this.modulePath,"format"),o=e.getSetting(this.modulePath,"formatAliases"),r=e.getLabels(this.modulePath,this.getSettings().languageId),i=e.getSetting(this.modulePath,"currencyId");var a={thousands:r.thousands,millions:r.millions,billions:r.billions,trillions:r.trillions};return n.getFormatter(this.getSettings().languageId,t,o,a,i)},l.prototype._cloneParameters=function(e){return t.isObject(e)?t.merge(t.isArray(e)?[]:{},e,function(e,n,r){return t.isFunction(e)&&!n?e:t.isFunction(n)?n:void 0}):e},l.prototype.setParameters=function(e){this._logger.info("ComponentInstance.setParameters()",e,this.prevParameters),t.isEqual(e,this.prevParameters)||(this.parameters=e,this.prevParameters=this._cloneParameters(e),this.trigger("parametersChanged",[this.parameters]),this._triggerPathEvents("parameterChanged",e))},l.prototype.getParameters=function(){return this.parameters},l.prototype.setParameter=function(e,n){this._logger.info("ComponentInstance.setParameter()",e,n,this.prevParameters);var r=t.parse(e);if(!t.isEqual(r(this.prevParameters),n)){var i=t.parse(e)(this.parameters);r.assign(this.parameters,n),this.prevParameters=this._cloneParameters(this.parameters),this.trigger("parameterChanged",[n,e]),this.trigger("parameterChanged:"+e,[n,i])}},l.prototype.getParameter=function(e){return t.parse(e)(this.parameters)},l.prototype.getDefaultColorPalette=function(){return this.getSettings().colors||this.getSettings().colorPalettes[this.getSettings().colorPaletteName]},l.prototype.activate=function(){this._logger.info("ComponentInstance.activate()"),this.isActive=!0,this.trigger("activated")},l.prototype.deactivate=function(){this._logger.info("ComponentInstance.deactivate()"),this.isActive=!1,this.trigger("deactivated")},l.prototype.findRelative=function(e){return this.instanceRegistry.get(this.getModulePath(),e)},l.prototype.findAllRelative=function(e){return new s(this.instanceRegistry.findAll(this.getModulePath()+"."+e))},l.prototype.getRelative=function(e){return this.instanceRegistry.get(this.getModulePath(),e)},l.prototype.onChildAdded=function(e,t){this.instanceRegistry.onInstanceAdded(new RegExp(this.getModulePath()+"\\.?"+e),t)},l.prototype.getLogger=function(){return this._logger},l.prototype.getUsageTracker=function(){return this._usageTracker},l.prototype.getTracer=function(){return this._tracer},l}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(3),n(1),n(0)],void 0!==(i=function(e,t,n){function r(r,i,o,a,s){r||n.logger.fatal(new Error("getFormatter expects languageId")),i=e(!0,{number:{},date:{},any:{number:{},date:{}}},i);var u=t.intlNumberFormat.getFormatter(r,i.number,o,a,s).format,c=function(e,n){var u=e;n=t.isString(n)?o[n]:n,n=n||{};var c=n.optionOverrides||i.any.nullString;return u=t.isNumber(e)?t.intlNumberFormat.getFormatter(r,i.any.number,o,a,s).format(e,n.number):t.isDate(e)?t.intlDateFormat.getFormatter(r,i.any.date,o).format(e,n.date):u||c},l=function(e,t){var n=["symbol","code","name"];return n.indexOf(t)<0&&(t=n[0]),u(0,{style:"currency",currency:e||s||"GBP",currencyDisplay:t,minimumFractionDigits:0,maximumFractionDigits:0}).replace("0","").trim()};return{getOptionValue:function(e){return i[e]},number:u,date:t.intlDateFormat.getFormatter(r,i.date,o).format,currencySymbol:l,any:c}}return{getFormatter:r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(22),n(1),n(46),n(53),n(0)],void 0!==(i=function(e,t,n,r,i){function o(){var n=i.tracer.startTrace("instanceRegistry.init()");a();var r=e.getModulePaths();t.each(r,function(e,t){c(t)}),n.end(r)}function a(){i.logger.info("instanceRegistry.reset()"),t.each(v,function(e,t){e.destroy(),delete v[t]}),m=[]}function s(e,t){m.push({regex:e,cb:t})}function u(e){t.each(m,function(t){t.regex.test(e.getModulePath())&&t.cb(e)})}function c(t,r){if(v.hasOwnProperty(t))return v[t];var o=!1;i.logger.info("instanceRegistry.register()",t,r),e.canAddModulePathDynamically(t)&&r&&r.type&&!e.hasInstance(t)?(o=!0,e.addInstance(t,r)):e.hasInstance(t)||i.logger.fatal(new Error("(instanceRegistry) tried to register a module path that does not exist in the config"));var a=new n(t,b);return v[t]=a,o&&u(a),a}function l(e){return v[e.getModulePath()]=e,e}function p(){return v}function f(e){var t=h(e);for(var n in v)if(v.hasOwnProperty(n)&&t.test(n))return v[n]}function d(e){var n=h(e);return new r(t.filter(v,function(e,t){return n.test(t)}))}function g(e){return new r(t.filter(v,function(t,n){return t.getModuleType()===e}))}function h(e){return t.isString(e)?(e=e.replace(/\./g,"\\.").replace(/\*/g,".*"),new RegExp("^"+e+"$")):new RegExp(e)}function y(){if(2===arguments.length){var e=t.isPlainObject(arguments[1])?null:arguments[1];if(null!=e){var n=t.componentPath.resolve(arguments[0],e);return v[n]||i.logger.fatal(new Error("(instanceRegistry) could not find any instance for: "+n)),v[n]}return c(arguments[0],arguments[1])}if(1===arguments.length)return v[arguments[0]]||i.logger.fatal(new Error("(instanceRegistry) could not find any instance for: "+arguments[0])),v[arguments[0]];i.logger.fatal(new Error("(instanceRegistry) get expects 1 or 2 arguments"))}var v={},m=[],b={init:o,reset:a,register:c,registerExisting:l,get:y,findAll:d,find:f,findByType:g,all:p,instances:v,onInstanceAdded:s};return b}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(6)],void 0!==(i=function(e){function t(e,t){if(!t)throw"logProvider is undefined/null";this.logLevel=e.logLevel,this._componentModulePath=n(e.componentModulePath),this._operation=n(e.operation),this._includeStack=e.includeStack,this._filterFunc=e.filterFunc,this._logProvider=t}function n(t){return e(t)?new RegExp(t):t}return t.prototype._allow=function(e){var t=e[0],n=e[e.length-1]&&e[e.length-1].tags?e[e.length-1].tags:e[e.length-1]||{};return(!this._componentModulePath||n.componentModulePath&&n.componentModulePath.match&&null!==n.componentModulePath.match(this._componentModulePath))&&(!this._componentType||n.componentType&&n.componentType.match&&null!==n.componentType.match(this._componentType))&&(!this._operation||t&&t.match&&null!==t.match(this._operation))&&(!this._filterFunc||this._filterFunc.apply(this,e))},t.prototype.setLogLevel=function(e){this.logLevel=e},t.prototype.fatal=function(){var e=this;this._allow(arguments)&&this._logProvider.fatal.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.error=function(){var e=this;this._allow(arguments)&&this._logProvider.error.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.warn=function(){var e=this;this._allow(arguments)&&this._logProvider.warn.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.info=function(){var e=this;this._allow(arguments)&&this._logProvider.info.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.debug=function(){var e=this;this._allow(arguments)&&this._logProvider.debug.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.trace=function(){var e=this;this._allow(arguments)&&this._logProvider.trace.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(6)],void 0!==(i=function(e){function t(e,t){if(!t)throw"usageTrackingProvider is undefined/null";this._componentModulePath=n(e.componentModulePath),this._componentType=n(e.componentType),this._componentTypePath=n(e.componentTypePath),this._type=n(e.type),this._category=n(e.category),this._action=n(e.action),this._filterFunc=e.filterFunc,this._usageTrackingProvider=t}function n(t){return e(t)?new RegExp(t):t}return t.prototype._allow=function(e){return(!this._componentModulePath||e.componentModulePath&&e.componentModulePath.match&&null!==e.componentModulePath.match(this._componentModulePath))&&(!e._componentType||e.componentType&&e.componentType.match&&null!==e.componentType.match(this._componentType))&&(!e._componentTypePath||e.componentTypePath&&e.componentTypePath.match&&null!==e.componentTypePath.match(this._componentTypePath))&&(!this._type||e.type&&e.type.match&&null!==e.type.match(this._type))&&(!this._category||e.category&&e.category.match&&null!==e.category.match(this._category))&&(!this._action||e.action&&e.action.match&&null!==e.action.match(this._action))&&(!this._filterFunc||this._filterFunc.apply(this,args))},t.prototype.onHit=function(e){this._allow(e)&&this._usageTrackingProvider.onHit(e)},t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(54),n(0),n(1),n(50)],void 0!==(i=function(e,t,n,r){function i(e){this._componentInstance=e}function o(e){if(a.hasProviders()){var n=t.getIdentity();if(n&&(e.configPath=n.configPath),e.sourceComponent&&(e.componentType=e.sourceComponent.getModuleType(),e.componentTypePath=e.sourceComponent.getModuleTypePath(),e.componentModulePath=e.sourceComponent.getModulePath(),!e.category)){var r=e.componentTypePath.split(".");e.category=r&&r.length&&r[0]}a.each(function(t){t.onHit(e)})}}var a=new e;return i.prototype.trackHit=function(e){e.sourceComponent=this._componentInstance,o(e)},{trackHit:o,getComponentDecoratedTracker:function(e){return new i(e)},registerUsageTrackingProvider:function(e,t,n){n?a.register(e,new r(n,t)):a.register(e,t)},unregisterUsageTrackingProvider:function(e){var t=a.get(e);t&&n.isFunction(t.dispose)&&t.dispose(),a.unregister(e)}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){var e=n(9);return n(129),n(127),n(126),n(128),n(124),n(125),e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){this.push.apply(this,e)}return e.prototype=new Array,e.prototype.on=function(e,t){var n=[];return this.forEach(function(r,i){n.push(r.on(e,t))}),n},e.prototype.trigger=function(e,t){this.forEach(function(n,r){n.trigger(e,t)})},e.prototype.setParameter=function(e,t){this.forEach(function(n,r){n.setParameter(e,t)})},e.prototype.setModelProperty=function(e,t){this.forEach(function(n,r){n.setModelProperty(e,t)})},e.prototype.destroy=function(){this.forEach(function(e,t){e.destroy()})},e.prototype.activate=function(){this.forEach(function(e,t){e.activate()})},e.prototype.deactivate=function(){this.forEach(function(e,t){e.deactivate()})},e.prototype.filterByTypes=function(t){if(morningstar.asterix.util.isArray(t)&&t.length){var n=new e;return this.forEach(function(e){t.indexOf(e.getModuleType())>-1&&n.push(e)}),n}return this},e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(){this._providers={}}return e.prototype.register=function(e,t){if(!t)throw"Cannot register undefined/null provider - "+e;this._providers[e]=t},e.prototype.unregister=function(e){delete this._providers[e]},e.prototype.clear=function(){this._providers={}},e.prototype.hasProviders=function(){var e=this;for(var t in e._providers)if(e._providers.hasOwnProperty(t))return!0;return!1},e.prototype.get=function(e){return this._providers[e]},e.prototype.each=function(e){var t=this;for(var n in t._providers)t._providers.hasOwnProperty(n)&&e(t._providers[n])},e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return JSON.parse(JSON.stringify(e))}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return e.__proto__||e.prototype||e.constructor&&e.constructor.prototype||Object.prototype}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e,t){return null!=e&&hasOwnProperty.call(e,t)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(23),n(57),n(65),n(2)],void 0!==(i=function(e,t,n,r){var i,a,s;return i=function(e,t,n,r){if(e===t)return 0!==e||1/e==1/t;if(null==e||null==t)return e===t;if(e!==e)return t!==t;var i=void 0===e?"undefined":o(e);return"function"===i&&"function"==typeof t||("function"===i||"object"===i||"object"===(void 0===t?"undefined":o(t)))&&a(e,t,n,r)},a=function(r,a,u,c){var l=n(r);if(l!==n(a))return!1;switch(l){case"[object RegExp]":case"[object String]":return""+r==""+a;case"[object Number]":return+r!=+r?+a!=+a:0==+r?1/+r==1/a:+r==+a;case"[object Date]":case"[object Boolean]":return+r==+a}var p="[object Array]"===l;if(!p){if("object"!=(void 0===r?"undefined":o(r))||"object"!=(void 0===a?"undefined":o(a)))return!1;var f=r.constructor,d=a.constructor;if(f!==d&&!(e(f)&&f instanceof f&&e(d)&&d instanceof d)&&"constructor"in r&&"constructor"in a)return!1}u=u||[],c=c||[];for(var g=u.length;g--;)if(u[g]===r)return c[g]===a;if(u.push(r),c.push(a),p){var h=s(r),y=s(a);if(h.length!==y.length)return!1;for(var v in h)if(v=h[v],!i(r[v],a[v],u,c))return!1}else{var v,m=s(r);if(g=m.length,s(a).length!==g)return!1;for(;g--;)if(v=m[g],!t(a,v)||!i(r[v],a[v],u,c))return!1}return u.pop(),c.pop(),!0},s=function(e){var t=[];if(e)for(var n=Object.keys(e),r=0;r<n.length;r++)0!==n[r].indexOf("$")&&t.push(n[r]);return t},function(e,t){return i(e,t)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return null==e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return void 0===e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return"[object Date]"===Object.prototype.toString.call(e)&&!isNaN(e.getTime())}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return null!==e&&e===e.window||window&&e===window}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2),n(3),n(0)],void 0!==(i=function(e,t,n){function r(r){if(r=r||"",i[r])return i[r];var o=r?r.replace("]","").split(/[.\[]/):[],a=[];a.push("var curr = obj;"),e(o,function(e){a.push("if (!curr) return curr;"),a.push('curr = curr["'+e+'"];')}),a.push("return curr;");var s=new Function("obj",a.join(""));return s.assign=function(r,i){if(r||n.logger.fatal(new Error("util.parse.assign expects its first argument to be an object")),!o.length)return void t(!0,r,i);var a,s,u=r;e(o,function(e,t){s=e,a=u,null==(u=u[e])&&(t<o.length-1&&!isNaN(o[t+1])?a[e]=[]:a[e]={},u=a[e])}),a&&s&&(a[s]=i)},i[r]=s}var i={};return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(34),n(0)],void 0!==(i=function(e,t){var n=function(e){return e?e[0].toUpperCase()+e.slice(1):e},r=function(e){return e?e[0].toLowerCase()+e.slice(1):e},i=["_","-",".","/"],o=function(n,o,a){if(!n)return n;i.indexOf(o)<0&&t.logger.fatal(new Error("Tried to call separatorCase with an unknown separator: "+o));var s=i.slice();s.splice(i.indexOf(o),1),s=e(s,function(e){return"-"===e?"\\-":e}),n=r(n);var u=new RegExp(["["].concat(s).concat(["]"]).join(""),"g");return n=n.replace(u,o),n=n.replace(/[A-Z]/g,function(e){return o+e.toLowerCase()}),a?n.toUpperCase():n},a=function(e){return o(e,"_")};return{firstUpperCase:n,firstLowerCase:r,dashCase:function(e){return o(e,"-")},snakeCase:a,slashCase:function(e){return o(e,"/")},dotCase:function(e){return o(e,".")},separatorCase:o,camelCase:function(e){return e===e.toUpperCase()&&(e=e.toLowerCase()),e.replace(/(?:^\w|[A-Z]|(?:\b|_)\w)/g,function(e,t){return 0==t?e.toLowerCase():e.toUpperCase()}).replace(/[\s\-._]+/g,"")},format:function(e){if(null===e)return null;var t=Array.prototype.slice.call(arguments,1);return e.replace(/{{(\d+)}}/g,function(e,n){return void 0!==t[n]?t[n]:e})}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return{}.toString.call.bind({}.toString)}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(136),n(138),n(145),n(5)],void 0!==(i=function(e,t,n,r){function i(i,o,a){var s=r(i)?e:n;return o=t(o,a,3),s(i,o)}return i}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t){for(var n=-1,r=e.length;++n<r&&!1!==t(e[n],n,e););return e}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(155)],void 0!==(i=function(e){return e()}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(4)],void 0!==(i=function(e){function t(t,r,i){if(null!=t){t=e(t),i!==n&&i in t&&(r=[i]);for(var o=0,a=r.length;null!=t&&o<a;)t=e(t)[r[o++]];return o&&o==a?t:n}}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(143),n(8),n(7)],void 0!==(i=function(e,t,n){function r(i,o,a,s,u,c){return i===o||(null==i||null==o||!t(i)&&!n(o)?i!==i&&o!==o:e(i,o,r,a,s,u,c))}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(4)],void 0!==(i=function(e){function t(t){return function(r){return null==r?n:e(r)[t]}}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(80)],void 0!==(i=function(e){function t(t,r,i){if("function"!=typeof t)return e;if(r===n)return t;switch(i){case 1:return function(e){return t.call(r,e)};case 3:return function(e,n,i){return t.call(r,e,n,i)};case 4:return function(e,n,i,o){return t.call(r,e,n,i,o)};case 5:return function(e,n,i,o,a){return t.call(r,e,n,i,o,a)}}return function(){return t.apply(r,arguments)}}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(71)],void 0!==(i=function(e){return e("length")}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(162)],void 0!==(i=function(e){function t(t,r){var i=null==t?n:t[r];return e(i)?i:n}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(5),n(4)],void 0!==(i=function(e,t){function n(n,a){var s=void 0===n?"undefined":o(n);return!!("string"==s&&i.test(n)||"number"==s)||!e(n)&&(!r.test(n)||null!=a&&n in t(a))}var r=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,i=/^\w*$/;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(8)],void 0!==(i=function(e){function t(t){return t===t&&!e(t)}return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(152),n(5)],void 0!==(i=function(e,t){function n(n){if(t(n))return n;var o=[];return e(n).replace(r,function(e,t,n,r){o.push(n?r.replace(i,"$1"):t||e)}),o}var r=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,i=/\\(\\)?/g;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(8)],void 0!==(i=function(e){function t(t){return e(t)&&i.call(t)==n}var n="[object Function]",r=Object.prototype,i=r.toString;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(18),n(4)],void 0!==(i=function(e,t){function n(n){n=t(n);for(var r=-1,i=e(n),o=i.length,a=Array(o);++r<o;){var s=i[r];a[r]=[s,n[s]]}return a}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return e}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(85),n(41),n(169),n(39),n(170),n(171)],void 0!==(i=function(e,t,n,r,i,o){function a(e){this._tags=e?n({},e):e,_&&_.sessionId&&(this._tags=this._tags||{},this._tags.sessionId=_.sessionId)}function s(){this._log("warn",m.WARN,Array.apply(null,arguments))}function u(){this._log("info",m.INFO,Array.apply(null,arguments))}function c(){this._log("debug",m.DEBUG,Array.apply(null,arguments))}function l(){this._log("trace",m.TRACE,Array.apply(null,arguments))}function p(e,t){this._tags=e,this._loggerInstance=t||C}function f(e,t,n){return this._loggerInstance.trace("Tracing started for "+e),new h(e,t||this._tags,n||this._loggerInstance)}function d(){return{end:v}}function g(e,t){return e.end(t)}function h(e,t,n){this._name=e,this._startTime=(new Date).getTime(),this._alive=!0,this._tags=t,this._loggerInstance=n}function y(e){if(!this._alive)return void this._loggerInstance.warn('Tried to end trace "'+this._name+'" which has already ended');var t=this,n=(new Date).getTime();this._alive=!1;var r={startTime:t._startTime,endTime:n,elapsedTime:n-t._startTime,name:t._name,context:e,tags:t._tags};return this._loggerInstance.trace("Tracing ended for "+this._name,r),r}var v=function(){},m={FATAL:1,ERROR:2,WARN:4,INFO:8,DEBUG:16,TRACE:32},b={NONE:0,ALL:m.FATAL|m.ERROR|m.WARN|m.INFO|m.DEBUG|m.TRACE,DEFAULT:m.FATAL|m.ERROR},_={},S={formatter:v};a.prototype.updateTags=function(e){e&&(this._tags=n(this._tags||{},e))},a.prototype._log=function(e,t,n){var r=this;x.providers[e].each(function(t){t[e].apply(t,r._tags?n.concat(r._tags):n)})},a.prototype.fatal=function(e){throw this._log("fatal",m.FATAL,Array.apply(null,arguments)),e},a.prototype.error=function(){this._log("error",m.ERROR,Array.apply(null,arguments))},a.prototype.warn=s,a.prototype.info=u,a.prototype.debug=c,a.prototype.trace=l;var C=new a;p.prototype.startTrace=f,p.prototype.endTrace=g,h.prototype.end=y;var x={providers:{},register:function(t,n){var i=this;r(m,function(r,o){(!e(n.logLevel)&&(r&b.DEFAULT)===r||(r&n.logLevel)===r)&&i.providers[o.toLowerCase()].register(t,n)})},get:function(e){var t,n=this;for(var r in m)if(m.hasOwnProperty(r)&&(t=n.providers[r.toLowerCase()].get(e)))break;return t},unregister:function(e){var t=this;r(m,function(n,r){t.providers[r.toLowerCase()].unregister(e)})},init:function(){var e=this;r(m,function(t,n){e.providers[n.toLowerCase()]=new i})},updateLogabilityAndTraceability:function(){var e=this,t=e.providers.trace.hasProviders();a.prototype.warn=e.providers.warn.hasProviders()?s:v,a.prototype.info=e.providers.info.hasProviders()?u:v,a.prototype.debug=e.providers.debug.hasProviders()?c:v,a.prototype.trace=t?l:v,p.prototype.startTrace=t?f:d,p.prototype.endTrace=t?g:v,h.prototype.end=t?y:v}};return x.init(),x.updateLogabilityAndTraceability(),{logger:C,getTagsDecoratedLogger:function(e){return new a(e)},tracer:new p,getTagsDecoratedTracer:function(e,t){return new p(e,t)},LOG_LEVEL:b,LOG_TYPE:m,getLogProvider:function(e){return x.get(e)},registerLogProvider:function(e,t,n){x.unregister(e),n?x.register(e,new o(n,t)):x.register(e,t),x.updateLogabilityAndTraceability()},unregisterLogProvider:function(e){x.unregister(e),x.updateLogabilityAndTraceability()},changeLogLevelForProvider:function(t,n){var r;e(n)&&(r=x.get(t))&&r.logLevel!==n&&(r.logLevel=n,x.unregister(t),x.register(t,r)),x.updateLogabilityAndTraceability()},updateIdentity:function(e){_=t(_||{},e),_&&_.sessionId&&C.updateTags({sessionId:_.sessionId}),C.info(e)},getIdentity:function(){return _},resetIdentity:function(){_=null,C.info("Resetting identity")},updateOptions:function(e){S=t(S,e)}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return e.__proto__||e.prototype||e.constructor&&e.constructor.prototype||Object.prototype}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return Array.isArray||function(e){return e instanceof Array}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return"function"==typeof e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return"number"==typeof e}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[],void 0!==(i=function(){return function(e){return"object"===(void 0===e?"undefined":o(e))&&null!==e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return"string"==typeof e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return null==e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return void 0===e}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return null!==e&&e===e.window||window&&e===window}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t){for(var n=-1,r=e.length;++n<r&&!1!==t(e[n],n,e););return e}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(190)],void 0!==(i=function(e){function t(t,r){var i=null==t?n:t[r];return e(i)?i:n}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(){try{Object({toString:0}+"")}catch(e){return function(){return!1}}return function(e){return"function"!=typeof e.toString&&"string"==typeof(e+"")}}()}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(14)],void 0!==(i=function(e){function t(t){return e(t)&&i.call(t)==n}var n="[object Function]",r=Object.prototype,i=r.toString;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(20),n(10)],void 0!==(i=function(e,t){function n(n){return t(n)&&e(n.length)&&!!r[o.call(n)]}var r={};r["[object Float32Array]"]=r["[object Float64Array]"]=r["[object Int8Array]"]=r["[object Int16Array]"]=r["[object Int32Array]"]=r["[object Uint8Array]"]=r["[object Uint8ClampedArray]"]=r["[object Uint16Array]"]=r["[object Uint32Array]"]=!0,r["[object Arguments]"]=r["[object Array]"]=r["[object ArrayBuffer]"]=r["[object Boolean]"]=r["[object Date]"]=r["[object Error]"]=r["[object Function]"]=r["[object Map]"]=r["[object Number]"]=r["[object Object]"]=r["[object RegExp]"]=r["[object Set]"]=r["[object String]"]=r["[object WeakMap]"]=!1;var i=Object.prototype,o=i.toString;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(21),n(22),n(48),n(1),n(0)],void 0!==(i=function(e,t,n,r,i){function o(t){var n=i.tracer.startTrace("bootstrap.init()");if(c=(new Date).getTime(),p&&window&&!window.__karma__&&!window.__testing__)return void(window.console&&i.logger.warn("bootstrap.init()","Tried to call asterix.bootstrap.init multiple times"));p=!0,t=t||{};var o=t.appConfig;delete t.appConfig,t=r.merge({},{appName:"morningstarApp",appConfig:null,baseLabels:{},baseSettings:{},configOptions:{dynamic:!1}},t||{}),t.appConfig=o,t.defaultConfig=e.components._defaultConfig||{},e.appConfig=e.asterix.extend(!0,{},t.appConfig,e.appConfig),t.appConfig&&t.appConfig.components&&0!==Object.keys(t.appConfig.components).length||(t.configOptions.dynamic=!0),t.apiTokenExpiredCallback&&e.asterix.context.setApiTokenExpiredCallback(t.apiTokenExpiredCallback),r.each(l,function(e){e(t)}),n.end(t)}function a(){return c}function s(e){l.push(e)}function u(){i.logger.debug("bootstrap.reset()"),l=[],l.push(function(r){t.init(r.appConfig||e.components._appConfig||{components:{}},r.defaultConfig,r.baseLabels,r.baseSettings,r.configOptions),n.init(),window.mwc&&window.mwc.asterixConfigWrapper&&(t.setOption("dynamic",!0),window.mwc.configuration=t,t.getConfig=window.mwc.asterixConfigWrapper)})}var c,l=[],p=!1;return u(),{init:o,getInitTimestamp:a,reset:u,registerCallback:s}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(21)],void 0!==(i=function(e){function t(t,n){e.asterix.instrumentation.logger.debug("Initialising component",t,n);var r=e.asterix.config.getInstanceConfig(t);if(!r)return e.asterix.instrumentation.logger.warning("Invalid morningstar component instance with id:"+t),null;var i=e.asterix.util.string.dashCase(r.type);if(/^ec-/.test(i)){var o=document.createElement(i);return o.setAttribute("mstar-component-id",t),e.asterix.util.isDomElement(n.container)?n.container.appendChild(o):e.asterix.instrumentation.logger.debug("params.container is not a object."),e.asterix.instanceRegistry.get(t)}return/^markets-components-/.test(i)?(r.labels&&(r.settings.labels=e.asterix.util.merge(r.labels,r.settings.labels||{})),e.components[i].createComponent({element:n.container,initialConfiguration:n.initialConfiguration||{component:{configuration:r.settings,callbacks:r.settings.callbacks}}})):void 0}return{init:t}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2),n(58),n(6),n(23),n(0)],void 0!==(i=function(e,t,n,r,i){function o(){return d}function a(e){return e&&n(e)||i.logger.fatal(new Error("getToken expects a string key")),d[e]}function s(e){var t=a(e);return t.startsWith("Bearer ")?t:"Bearer "+t}function u(r,o){i.logger.info("context.setToken()",r,o),r&&n(r)||i.logger.fatal(new Error("setToken expects a string key")),t(d[r],o)||(d[r]=o,e(g[r]||[],function(e){e(d[r])}))}function c(e,t){return i.logger.debug("context.onTokenChanged()",e),e&&n(e)||i.logger.fatal(new Error("onTokenChanged expects a string key")),r(t)||i.logger.fatal(new Error("onTokenChanged expects a callback of type function")),g[e]||(g[e]=[]),g[e].push(t),function(){g[e].splice(g[e].indexOf(t),1)}}function l(e){h=e}function p(){return h}function f(){i.logger.info("context.reset()"),d={},g={}}var d,g,h;return f(),{getToken:a,getTokens:o,getTokenPrependBearer:s,setToken:u,onTokenChanged:c,reset:f,getApiTokenExpiredCallback:p,setApiTokenExpiredCallback:l}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(e,t){var n={};return{register:function(e,r,i){return t.logger.info("meta.register()",e,r,i),n[e]||(n[e]={}),n[e][r]=i,this},get:function(e,t){return t?n[e]?n[e][t]:void 0:n[e]},findTypesWhere:function(t,r){var i=[];return e(n,function(e,n){e[t]===r&&i.push(n)}),i}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(1),n(3),n(0)],void 0!==(i=function(e,t,n){return function(){function r(){if(u=window.morningstar,window.morningstar=window.morningstar||{},window.morningstar.asterix)n.logger.debug("Tried to create morningstar.asterix multiple times.");else{var e=t(!0,{},{name:"morningstar",asterix:{},components:{_defaultConfig:{},_appConfig:{settings:{},components:{}}}},window.morningstar);window.morningstar=e}}function i(t,n){var r=t.split(".");r[0]===window.morningstar.name&&(r=r.slice(1)),"components"===r[0]&&(r=r.slice(1));for(var i=r.length,o=window.morningstar.components,a=0;a<i;a++)void 0===o[r[a]]&&(o[r[a]]={}),o=o[r[a]];if(n){var s=r.join(".");window.morningstar.components.defaultConfig=window.morningstar.components.defaultConfig||{},o.defaultConfig=window.morningstar.components._defaultConfig[s]=n,o.defaultConfig.type=s,o.instances={},o.registerInstance=function(t,n){n=n||{},n.type=s,o.instances[t]=n,e.componentPath.assignInstance(t,window.morningstar.components._appConfig,window.morningstar.components._defaultConfig,s,n,null)}}return window.morningstar}function o(e){return e?(window.morningstar.components._defaultConfig||{})[e]:window.morningstar.components._defaultConfig||{}}function a(){return window[window.morningstar.name]=u,window.morningstar}function s(){window.morningstar.components={_defaultConfig:{},_appConfig:{settings:{},components:{}}}}var u;return r(),{init:r,register:i,reset:s,noConflict:a,getDefaultConfig:o}}()}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(21)],void 0!==(i=function(e){function t(){}return t.prototype.setLogLevel=function(e){this.logLevel=e},t.prototype.fatal=function(){},t.prototype.error=function(){console.error.apply(console,arguments)},t.prototype.warn=function(){console.warn.apply(console,arguments)},t.prototype.info=function(){console.info.apply(console,arguments)},t.prototype.debug=function(){console.debug.apply(console,arguments)},t.prototype.trace=function(){console.debug.apply(console,arguments)},t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(21),n(0)],void 0!==(i=function(e,t){function n(n){this._gaWrapper=n,self=this,t.registerLogProvider("errorLogProviderForGoogleAnalytics",{logLevel:e.asterix.instrumentation.LOG_TYPE.FATAL|e.asterix.instrumentation.LOG_TYPE.ERROR,fatal:function(e){(self._gaWrapper||window.ga)("send","exception",{exDescription:e&&e.message,exFatal:!0})},error:function(e){(self._gaWrapper||window.ga)("send","exception",{exDescription:e&&e.message,exFatal:!1})}})}return n.prototype.onHit=function(t){switch(t.type){case"timing":(self._gaWrapper||window.ga)("send",t.type,t.category,t.action,t.value.elapsedTime,t.label||t.componentModulePath,t.value.context);break;case"event":(self._gaWrapper||window.ga)("send",t.type,t.category,t.action,t.label||t.componentModulePath,t.value);break;default:e.asterix.instrumentation.logger.error(new Error('GoogleAnalyticsUsageTrackingProvider.onHit: Unknown type "'+t.type+'" for hitObj'),t)}},n.prototype.dispose=function(){t.unregisterLogProvider("errorLogProviderForGoogleAnalytics")},n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(21),n(0)],void 0!==(i=function(e,t){function n(n){this._newRelicApiWrapper=n;var r=this;t.registerLogProvider("errorLogProviderForNewRelic",{logLevel:e.asterix.instrumentation.LOG_TYPE.FATAL|e.asterix.instrumentation.LOG_TYPE.ERROR,fatal:function(e){(r._newRelicApiWrapper||window.newrelic).noticeError(e&&e.message,e)},error:function(e){(r._newRelicApiWrapper||window.newrelic).noticeError(e&&e.message,e)}})}return n.prototype.dispose=function(){t.unregisterLogProvider("errorLogProviderForNewRelic")},n.prototype.onHit=function(e){switch(e.type){case"timing":(this._newRelicApiWrapper||window.newrelic).addToTrace({name:e.action,start:e.value.startTime,end:e.value.endTime,origin:e.componentModulePath,type:e.category}),"Component loaded"===e.action&&(this._newRelicApiWrapper||window.newrelic).setCustomAttribute("End time for load component of "+e.componentType,e.value.elapsedTime);break;case"event":(this._newRelicApiWrapper||window.newrelic).addPageAction(e.action,e);break;default:(this._newRelicApiWrapper||window.newrelic).addPageAction(e.action,e)}},n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(100),n(96),n(22),n(3),n(1),n(47),n(52),n(48),n(32),n(99),n(97),n(98),n(46),n(0),n(51)],void 0!==(i=function(e,t,r,i,o,a,s,u,c,l,p,f,d,g,h){function y(){o.isEmptyObject(morningstar.asterix)&&(morningstar.asterix={register:e.register,reset:e.reset,noConflict:e.noConflict,config:r,extend:i,util:o,formatting:a,validation:s,instanceRegistry:u,ConfigEvaluator:c,bootstrap:t,meta:l,context:f,ComponentInstance:d,instrumentation:g,usageTracker:h,providers:{ConsoleLogProvider:n(101),FilterLogProvider:n(49),GoogleAnalyticsUsageTrackingProvider:n(102),NewRelicUsageTrackingProvider:n(103),FilterUsageTrackingProvider:n(50)}})}return y(),morningstar.initComponent=p.init,{createAsterix:y}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(15)],void 0!==(i=function(e){return function(t,n){for(var r=!e(t)&&Object.keys(t),i=(r||t).length,o=0;o<i;o++){var a=r?r[o]:o;if(n(t[a],a,t))return!0}return!1}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2),n(11),n(0)],void 0!==(i=function(e,t,n){function r(r,i,o,a,s,u){var c,l=i,p=r.split(".");e(p,function(e,r){l.components&&l.components[e]?l=l.components[e]:l.type&&o[l.type]&&o[l.type].components[e]?l=o[l.type].components[e]:r===p.length-1?(e.indexOf("[")>=0&&(e=e.substring(0,e.lastIndexOf("[")),l.components&&l.components[e]?s=t({},o&&o[l.type]&&o[l.type].components?o[l.type].components[e]:{},l.components[e],s):o[l.type]&&o[l.type].components&&o[l.type].components[e]&&(s=t({},o[l.type].components[e],s))),l.components||(l.components={}),c=l.components):n.logger.fatal(new Error("(util) Could not assign instance dynamically because a parent instance was not initialized: "+e))}),c&&(s=s||{components:{}},s.type=a,c[p[p.length-1]]=s),u&&u(r)}function i(t,r){if(!r)return t;null==t&&n.logger.fatal(new Error("currentPath must have a value"));var i=t.split(".");""===i[0]&&i.splice(0,1);var o=r.split("."),a=[],s=!1;return e(o,function(e){"_"===e?s?n.logger.fatal(new Error("Invalid relative path: "+r)):i.pop()||n.logger.fatal(new Error("Invalid relative path lookup: "+t+", "+r)):(a.push(e),s=!0)}),i.join(".")+(i.length&&a.length?".":"")+a.join(".")}function o(e,t){for(var n=e?e.split("."):[],r=t?t.split("."):[],i=[],o=[],a=!0,s=0;s<Math.max(n.length,r.length);s++)if(n.length>s&&r.length>s){if(n[s]==r[s]&&a)continue;i.push("_"),o.push(r[s]),a=!1}else n.length>s?i.push("_"):r.length>s&&o.push(r[s]);return i.concat(o).join(".")}return{resolve:i,relative:o,assignInstance:r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(64),n(34),n(15)],void 0!==(i=function(e,t,n){function r(r,i){r=n(r)?r:[r];var o=t(r,function(t){return e.dashCase(t)});return i?t(n(i)?i:i.split(" "),function(n){return n=e.dashCase(n),t(o,function(e){return e?[e,n].join(0===n.indexOf("-")?"":"-"):n}).join(" ")+(o.length&&o[0]?" "+n:"")}).join(" "):o.join(" ")}return{namespaceSelector:r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(16),n(33)],void 0!==(i=function(e,t){function n(n,r){if(!t(n))throw new Error("The date is invalid");if(!e(r))throw new Error("The number is invalid");return i(n).getDate()===n.getDate()?(n.setDate(1),n.setMonth(n.getMonth()+r),n.setDate(i(n).getDate())):n.setMonth(n.getMonth()+r),n}function r(e){return e&&e.split?e.split(" ")[0]:""}function i(e){return new Date(e.getFullYear(),e.getMonth()+1,0)}function o(e,n){if(!t(e)||!t(n))throw new Error("The date is invalid");if(e>n)throw new Error("from must be less than to");return 12*(n.getFullYear()-e.getFullYear())-e.getMonth()+n.getMonth()}function a(e){return new Date(Date.UTC(e.getFullYear(),e.getMonth(),e.getDate()))}function s(e){return e.toISOString().replace("Z","")}function u(e){return e=a(e),e.getTimezoneOffset()>0&&e.setUTCMinutes(2*e.getTimezoneOffset()),e}function c(e){return e.getTimezoneOffset()>0&&e.setUTCMinutes(2*e.getTimezoneOffset()),e}function l(e){return s(a(e))}return{addMonths:n,extractDateFromDatetime:r,monthDiff:o,getMonthEndDate:i,convertToUTC:a,toLocalISOString:s,toUTCLocalISOString:l,convertToStandard:u,utcToStandard:c}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(17),n(6),n(15),n(2),n(63),n(0)],void 0!==(i=function(e,t,n,r,i,o){function a(a,s){if(null==a)return!1;e(a)&&(t(s)||n(s))||o.logger.fatal(new Error("Invalid arguments to ensureObjectPaths")),s=t(s)?[s]:s;var u=!0;return r(s,function(e){t(e)||o.logger.fatal(new Error("Invalid path given to ensureObjectPaths: "+e)),null==i(e)(a)&&(u=!1)}),u}return a}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(11),n(6),n(2),n(24),n(0)],void 0!==(i=function(e,t,n,r,i){function o(e,t,r){return n(e,function(n,i){e[i]=a(n,t,r)}),e}function a(n,o,a){function s(e,n,i){if("format"===i){if(r(n)&&Object.keys(n).length<2)return;var o=n||e;return t(o)&&(o=a[o]),o||{}}}if(!n)return n;o=o||{},a=a||{};var u=n;return t(n)?(o[n]||i.logger.fatal(new Error("Got field by name with missing field definition: "+n)),!0!==n._hasInheritedFromFieldDefinition&&(u=e({},o[n],s),u.fieldId=n,u.fieldName=u.fieldName||n,u.format=u.format||{},u._hasInheritedFromFieldDefinition=!0)):n.fieldName?!0!==n._hasInheritedFromFieldDefinition&&(u=e({},o[n.fieldName],n,s),u.fieldId=n.fieldId||n.fieldName,o[n.fieldName]&&o[n.fieldName].fieldName&&(u.fieldName=o[n.fieldName].fieldName),u.format=u.format||{},u._hasInheritedFromFieldDefinition=!0):!0!==n._hasInheritedFromFieldDefinition&&(u=e({},n,function(e,n,r){if("format"===r){var i=n||e;return t(i)&&(i=a[i]),i||{}}}),u.format=u.format||{},u._hasInheritedFromFieldDefinition=!0),u}return{applyDefinitionsAndAliases:a,applyDefinitionsAndAliasesToMany:o}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2)],void 0!==(i=function(e){return function(t,n){var r=[];return e(t,function(e,t,i){n(e,t,i)&&r.push(e)}),r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(17)],void 0!==(i=function(e){function t(t){for(var r in t)t.hasOwnProperty(r)&&e(t[r])&&n(t[r]);return t}function n(t){if(Object.isFrozen(t))return t;for(var r in t)t.hasOwnProperty(r)&&e(t[r])&&n(t[r]);return Object.freeze(t)}return{deep:n,deepProperties:t}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2),n(17),n(33),n(6),n(16),n(0),n(11),n(55),n(61)],void 0!==(i=function(e,t,n,r,i,o,a,s,u){function c(n,r){e(r,function(e,r){n.push(r),t(e)?c(n,e):n.push(e)})}function l(e,t,n){t=t||{},t=p(t,n);var r=[];return r.push(e),c(r,t),r=r.join("|"),d[r]||(d[r]=f(e,t,n)),d[r]}function p(e,t){if(!r(e))return e;var n=t[e];return n||o.logger.fatal(new Error("Could not find format alias: "+e)),n}function f(t,o,c){o=a({},h,o||{});var f;f=window.Intl?window.Intl.DateTimeFormat(o.culture||t,o):{format:function(e){return n(e)?new Date(e).toDateString():e}};var d={};return{format:function(h,v){if(v&&(r(v)||Object.keys(v).length)){v=p(v,c);var m=!1;e(y,function(e){v.hasOwnProperty(e)&&(m=!0)});var b;return!0===m?(b=s(v),b.nullString||(b.nullString=o.nullString)):b=a({},o,v),l(b.culture||t,b).format(h)}if(null==h)return o.nullString;var _=h?h.toString():"null";if(d[_])return d[_];if(!n(h)){if(r(h)&&!u(new Date(h))&&(h=h.replace(/-/g,"/")),!r(h)&&!i(h))return d[_]=h;h=g[h]=g[h]||new Date(h)}var S=f.format(h);return d[_]=S,S}}}var d={},g={},h={nullString:"–"},y=["year","month","day","hour","minute","second"];return{getFormatter:l}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(2),n(17),n(3),n(6),n(0),n(11),n(16)],void 0!==(i=function(e,t,n,r,i,o,a){function s(n,r){e(r,function(e,r){n.push(r),t(e)?s(n,e):n.push(e)})}function u(t){var n={},r=t.split("|");return e(r,function(e){var t=e.split(":");if(2===t.length)switch(t[0]=t[0].trim(),t[1]=t[1].trim(),t[0]){case"abbr":n.abbreviate=n.abbreviate||{},n.abbreviate.mode=t[1];break;case"dec":var r=t[1].split(",");n.minimumFractionDigits=parseInt(r[0]),n.maximumFractionDigits=parseInt(r[1]);break;case"style":case"currency":case"currencyDisplay":case"prefix":case"suffix":n[t[0]]=t[1];break;default:i.logger.fatal(new Error("Could not parse format string containing key: "+t[0]))}}),n}function c(e,t,n,r,i){t=t||{},t=l(t,n),t.formatString&&(t=o({},t,u(t.formatString))),t=o({},t),t.currency=t.currency||i,t.abbreviate=t.abbreviate||{},t.abbreviate.abbreviations=t.abbreviate.abbreviations||r;var a=[];return a.push(e),s(a,t),a=a.join("|"),h[a]||(h[a]=p(e,t,n)),h[a]}function l(e,t){if(!r(e))return e;var n=t[e];return n||i.logger.fatal(new Error("Could not find format alias: "+e)),n}function p(e,t,n){t=o({},m,t||{}),"currency"===t.style&&v[t.currency]&&(t.suffix=t.suffix||"",t.currencyDisplay=t.currencyDisplay||"symbol","symbol"===t.currencyDisplay&&v[t.currency].symbol?t.suffix+=v[t.currency].symbol:"name"===t.currencyDisplay&&v[t.currency].name?t.suffix+=" "+v[t.currency].name:t.suffix+=" "+t.currency,t.style="decimal");var i;i=window.Intl?window.Intl.NumberFormat(t.culture||e,t):{format:function(e){return a(e)?e.toFixed(0):e}};var s={};return{format:function(a,u){if(u&&(r(u)||Object.keys(u).length)){u=l(u,n);var p=o({},t,u);return c(p.culture||e,p).format(a)}if(null==a||isNaN(a))return t.nullString;var g=a?a.toString():"null";if(s[g])return s[g];var h=null,y=t.prefix||"",v=t.suffix||"";t.abbreviate&&t.abbreviate.mode&&(h=d(a,t),a=h.value,v=h.abbreviation+v),t.minimumFractionDigits>t.maximumFractionDigits&&(t.maximumFractionDigits=t.minimumFractionDigits),t.minimumSignificantDigits>t.maximumSignificantDigits&&(t.maximumSignificantDigits=t.minimumSignificantDigits),0===Math.abs(f(a,t.maximumFractionDigits))&&(a=0);var m;return a<0&&t.negativeTemplate&&"-%v"!==t.negativeTemplate?(m=i.format(Math.abs(a)),m=m.replace(b,function(e,n,r){return t.negativeTemplate.replace("%v",n)+v+r})):(m=i.format(a),v&&(m=m.replace(b,function(e,t,n){return t+v+n}))),y&&(m=y+m),s[g]=m,m}}}function f(e,t){return+(Math.round(e+"e+"+t)+"e-"+t)}function d(t,n){var r=Math.abs(t),i="";return e(y,function(e,o){i||g(r,o,n.abbreviate.mode)&&(i=n.abbreviate.abbreviations[o],t/=Math.pow(10,e.pow10))}),{value:t,abbreviation:i}}function g(e,t,n){var r=y[t];return e>=Math.pow(10,r.pow10)&&(null==r.next||Math.pow(10,r.next)>e)&&"auto"===n||n===t}var h={},y={thousands:{pow10:3,next:6},millions:{pow10:6,next:9},billions:{pow10:9,next:12},trillions:{pow10:12,next:null}},v={GBX:{symbol:"p",name:"pence"}},m={negativeTemplate:"−%v",nullString:"–"},b=/([0-9,._' ]*[0-9])([\sa-zA-Z]*)$/;return{getFormatter:c}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return!0===e||!1===e||"[object Boolean]"===toString.call(e)}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return e instanceof HTMLElement}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){var t;for(t in e)if(e.hasOwnProperty(t))return!1;return!0}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(e){return e instanceof RegExp}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(24),n(60),n(59)],void 0!==(i=function(e,t,n){function r(r,o,a,s){!n(a)&&!t(a[r])||t(o[r])?t(a[r])||(e(a[r])&&!n(o[r])&&e(o[r])?s[r]=i(o[r],a[r]):s[r]=a[r]):s[r]=o[r]}function i(e,t){var n={};for(var i in e)r(i,e,t,n);for(var i in t)e&&e.hasOwnProperty(i)||r(i,e,t,n);return n}return i.prop=r,i}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(0)],void 0!==(i=function(e){return{debug:function(){e.logger.debug.apply(e.logger,arguments)},info:function(){e.logger.info.apply(e.logger,arguments)},error:function(){e.logger.error.apply(e.logger,arguments)}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return function(){}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return{parameterize:function(e,t){var n=e;return n&&t&&(n=n.replace(/\{\{\s*(.*?)\s*\}\}/g,function(e,n){return t.hasOwnProperty(n)?t[n]:e})),n},unescapeBaseUrl:function(e){var t=e||"";if(e){var n=e.match(/(https?:)?\/\/[^\/]*/i);n&&n.length&&(t=e.replace(n[0],decodeURIComponent(n[0])))}return t}}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(1),n(3),n(32)],void 0!==(i=function(e,t,n){function r(e){this._instance=e,this._configEvaluator=new n(this._instance.getModulePath(),this._instance.instanceRegistry),this.reset()}var i=function(e){return!1===e.returnValue};return r.prototype.reset=function(){this._state={},this._children={},this._calculcatedMergedState={}},r.prototype.getState=function(){return this._state},r.prototype.setState=function(t){e.isEqual(this.getState(),t)||(this._state=t||{},this.triggerUpdated())},r.prototype.triggerUpdated=function(){this._instance.hasParent()&&this._instance.getRelative("_").getValidationState().setChild(this._instance.getOwnInstanceId(),this),this._calculateMergedState(),this._instance.trigger("validationStateChanged",[this.isValid(),this.getState(),this.getMergedStateFiltered()]),this._instance.hasParent()&&this._instance.getRelative("_").getValidationState().triggerUpdated()},r.prototype.getChildren=function(){return this._children},r.prototype.setChild=function(e,t){this._children[e]=t},r.prototype.getNamespacedKey=function(e){return[this._instance.getModulePath(),e].join("_")},r.prototype._calculateMergedState=function(){var t=this.getNamespacedState();e.each(this._children,function(n){e.each(n.getMergedStateFiltered(),function(e,n){t[n]=e})}),this._calculcatedMergedState=t},r.prototype.getMergedStateFiltered=function(n){var r=t({},this._calculcatedMergedState);return n?(e.each(r,function(e,t){n(e)||delete r[t]}),r):r},r.prototype.getNamespacedState=function(){var n=this,r={};return e.each(this.getState(),function(e,i){e=t(!0,{},e);var o=n._configEvaluator.evaluate(n._instance.getLabels()[e.rule.labelKey]||e.rule.labelKey,null,{selfStatic:e.rule});e.label=o.evaluated,e.ownInstanceId=n._instance.getOwnInstanceId(),e.modulePath=n._instance.getModulePath(),r[n.getNamespacedKey(i)]=e}),r},r.prototype.isValid=function(){var e=this.getMergedStateFiltered(i);return 0===Object.keys(e).length},r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(9)],void 0!==(i=function(e){e.addValidationRule("alpha",{type:"regex",pattern:/^([A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ])+$/}),e.addValidationRule("alphaSpaces",{type:"regex",pattern:/^([A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\s])+$/}),e.addValidationRule("alphaNumeric",{type:"regex",pattern:/^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ])+$/}),e.addValidationRule("alphaNumSpaces",{type:"regex",pattern:/^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\s])+$/}),e.addValidationRule("alphaDash",{type:"regex",pattern:/^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ_-])+$/}),e.addValidationRule("alphaDashSpaces",{type:"regex",pattern:/^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\s_-])+$/})}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(9),n(1)],void 0!==(i=function(e,t){e.addCustomValidationRule("equality",function(e,n){return t.isEqual(e,n.compareTo)})}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(9)],void 0!==(i=function(e){e.addCustomValidationRule("integer",function(e,t){return e%1==0})}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(9)],void 0!==(i=function(e){e.addCustomValidationRule("range",function(e,t){return(!t.hasOwnProperty("min")||e>=t.min)&&(!t.hasOwnProperty("max")||e<=t.max)})}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(9),n(1),n(0)],void 0!==(i=function(e,t,n){function r(e){return t.isString(e)?e=i[e]?i[e]:i[e]=new RegExp(e):n.logger.fatal(new Error("invalid regex pattern")),e}var i={};e.addCustomValidationRule("regex",function(e,i){i.pattern||n.logger.fatal(new Error("regex validator requires a pattern"));var o=i.pattern;return t.isRegex(o)||(o=r(o)),o.test(e)})}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(9)],void 0!==(i=function(e){e.addValidationRule("required",{type:"custom",runFalsy:!0,execute:function(e,t){return void 0!==e&&null!==e&&""!==e}})}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";(function(e){var t,r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};!function(i){function o(){var e=this;e.reads=[],e.writes=[],e.raf=d.bind(i),f("initialized",e)}function a(){return i&&i.__karma__}function s(e){e.scheduled||(e.scheduled=!0,e.raf(u.bind(null,e)),f("flush scheduled"))}function u(e){f("flush");var t,n=e.writes,r=e.reads;try{f("flushing reads",r.length),c(r),f("flushing writes",n.length),c(n)}catch(e){t=e}if(e.scheduled=!1,(r.length||n.length)&&s(e),t){if(f("task errored",t.message),!e.catch)throw t;e.catch(t)}}function c(e){f("run tasks");for(var t;t=e.shift();)t()}function l(e,t){var n=e.indexOf(t);return!!~n&&!!e.splice(n,1)}function p(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])}var f=function(){},d=i.requestAnimationFrame||i.webkitRequestAnimationFrame||i.mozRequestAnimationFrame||i.msRequestAnimationFrame||function(e){return setTimeout(e,16)};o.prototype={constructor:o,measure:function(e,t){if(a())return void e();f("measure");var n=t?e.bind(t):e;return this.reads.push(n),s(this),n},mutate:function(e,t){if(a())return void e();f("mutate");var n=t?e.bind(t):e;return this.writes.push(n),s(this),n},clear:function(e){return f("clear",e),l(this.reads,e)||l(this.writes,e)},extend:function(e){if(f("extend",e),"object"!=(void 0===e?"undefined":r(e)))throw new Error("expected object");var t=Object.create(this);return p(t,e),t.fastdom=this,t.initialize&&t.initialize(),t},catch:null};var g=new o;"f"==r(n(199))[0]?void 0!==(t=function(){return g}.call(g,n,g,e))&&(e.exports=t):"o"==r(e)[0]&&(e.exports=g)}(window||void 0)}).call(t,n(200)(e))},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){var n=e?e.length:0;return n?e[n-1]:t}var t;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(133),n(66)],void 0!==(i=function(e,t){return{collect:e,map:t}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(66)],void 0!==(i=function(e){return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,i){if("function"!=typeof e)throw new TypeError(n);return i=r(i===t?e.length-1:+i||0,0),function(){for(var t=arguments,n=-1,o=r(t.length-i,0),a=Array(o);++n<o;)a[n]=t[i+n];switch(i){case 0:return e.call(this,a);case 1:return e.call(this,t[0],a);case 2:return e.call(this,t[0],t[1],a)}var s=Array(i+1);for(n=-1;++n<i;)s[n]=t[n];return s[i]=a,e.apply(this,s)}}var t,n="Expected a function",r=Math.max;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t){for(var n=-1,r=e.length,i=Array(r);++n<r;)i[n]=t(e[n],n,e);return i}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t){for(var n=-1,r=e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(146),n(147),n(72),n(80),n(167)],void 0!==(i=function(e,t,n,r,i){function a(a,u,c){var l=void 0===a?"undefined":o(a);return"function"==l?u===s?a:n(a,u,c):null==a?r:"object"==l?e(a):u===s?i(a):t(a,u)}var s;return a}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t,n){n||(n={});for(var r=-1,i=t.length;++r<i;){var o=t[r];n[o]=e[o]}return n}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(142),n(154)],void 0!==(i=function(e,t){return t(e)}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(68),n(26)],void 0!==(i=function(e,t){function n(n,r){return e(n,r,t)}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(68),n(18)],void 0!==(i=function(e,t){function n(n,r){return e(n,r,t)}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(156),n(157),n(158),n(5),n(35),n(38)],void 0!==(i=function(e,t,n,r,i,o){function a(a,l,d,g,h,y,v){var m=r(a),b=r(l),_=u,S=u;m||(_=f.call(a),_==s?_=c:_!=c&&(m=o(a))),b||(S=f.call(l),S==s?S=c:S!=c&&(b=o(l)));var C=_==c&&!i(a),x=S==c&&!i(l),w=_==S;if(w&&!m&&!C)return t(a,l,_);if(!h){var E=C&&p.call(a,"__wrapped__"),j=x&&p.call(l,"__wrapped__");if(E||j)return d(E?a.value():a,j?l.value():l,g,h,y,v)}if(!w)return!1;y||(y=[]),v||(v=[]);for(var P=y.length;P--;)if(y[P]==a)return v[P]==l;y.push(a),v.push(l);var A=(m?e:n)(a,l,d,g,h,y,v);return y.pop(),v.pop(),A}var s="[object Arguments]",u="[object Array]",c="[object Object]",l=Object.prototype,p=l.hasOwnProperty,f=l.toString;return a}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(70),n(4)],void 0!==(i=function(e,t){function n(n,i,o){var a=i.length,s=a,u=!o;if(null==n)return!s;for(n=t(n);a--;){var c=i[a];if(u&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return!1}for(;++a<s;){c=i[a];var l=c[0],p=n[l],f=c[1];if(u&&c[2]){if(p===r&&!(l in n))return!1}else{var d=o?o(p,f,l):r;if(!(d===r?e(f,p,o,!0):d))return!1}}return!0}var r;return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(140),n(12)],void 0!==(i=function(e,t){function n(n,r){var i=-1,o=t(n)?Array(n.length):[];return e(n,function(e,t,n){o[++i]=r(e,t,n)}),o}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(144),n(159),n(4)],void 0!==(i=function(e,t,n){function r(r){var o=t(r);if(1==o.length&&o[0][2]){var a=o[0][0],s=o[0][1];return function(e){return null!=e&&(e=n(e),e[a]===s&&(s!==i||a in e))}}return function(t){return e(t,o)}}var i;return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(69),n(70),n(151),n(5),n(75),n(76),n(131),n(4),n(77)],void 0!==(i=function(e,t,n,r,i,o,a,s,u){function c(c,p){var f=r(c),d=i(c)&&o(p),g=c+"";return c=u(c),function(r){if(null==r)return!1;var i=g;if(r=s(r),(f||!d)&&!(i in r)){if(null==(r=1==c.length?r:e(r,n(c,0,-1))))return!1;i=a(c),r=s(r)}return r[i]===p?p!==l||i in r:t(p,r[i],l,!0)}}var l;return c}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(67),n(149),n(5),n(12),n(8),n(7),n(38),n(18)],void 0!==(i=function(e,t,n,r,i,o,a,s){function u(l,p,f,d,g){if(!i(l))return l;var h=r(p)&&(n(p)||a(p)),y=h?c:s(p);return e(y||p,function(e,n){if(y&&(n=e,e=p[n]),o(e))d||(d=[]),g||(g=[]),t(l,p,n,u,f,d,g);else{var r=l[n],i=f?f(r,e,n,l,p):c,a=i===c;a&&(i=e),i===c&&(!h||n in l)||!a&&(i===i?i===r:r!==r)||(l[n]=i)}}),l}var c;return u}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(135),n(25),n(5),n(12),n(163),n(38),n(164)],void 0!==(i=function(e,t,n,r,i,o,a){function s(s,c,l,p,f,d,g){for(var h=d.length,y=c[l];h--;)if(d[h]==y)return void(s[l]=g[h]);var v=s[l],m=f?f(v,y,l,s,c):u,b=m===u;b&&(m=y,r(y)&&(n(y)||o(y))?m=n(v)?v:r(v)?e(v):[]:i(y)||t(y)?m=t(v)?a(v):i(v)?v:{}:b=!1),d.push(y),g.push(m),b?s[l]=p(m,y,f,d,g):(m===m?m!==v:v===v)&&(s[l]=m)}var u;return s}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(69),n(77)],void 0!==(i=function(e,t){function n(n){var r=n+"";return n=t(n),function(t){return e(t,n,r)}}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,n,r){var i=-1,o=e.length;n=null==n?0:+n||0,n<0&&(n=-n>o?0:o+n),r=r===t||r>o?o:+r||0,r<0&&(r+=o),o=n>r?0:r-n>>>0,n>>>=0;for(var a=Array(o);++i<o;)a[i]=e[i+n];return a}var t;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return null==e?"":e+""}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(72),n(160),n(134)],void 0!==(i=function(e,t,n){function r(r){return n(function(n,o){var a=-1,s=null==n?0:o.length,u=s>2?o[s-2]:i,c=s>2?o[2]:i,l=s>1?o[s-1]:i;for("function"==typeof u?(u=e(u,l,5),s-=2):(u="function"==typeof l?l:i,s-=u?1:0),c&&t(o[0],o[1],c)&&(u=s<3?i:u,s=1);++a<s;){var p=o[a];p&&r(n,p,u)}return n})}var i;return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(73),n(13),n(4)],void 0!==(i=function(e,t,n){function r(r,i){return function(o,a){var s=o?e(o):0;if(!t(s))return r(o,a);for(var u=i?s:-1,c=n(o);(i?u--:++u<s)&&!1!==a(c[u],u,c););return o}}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(4)],void 0!==(i=function(e){function t(t){return function(n,r,i){for(var o=e(n),a=i(n),s=a.length,u=t?s:-1;t?u--:++u<s;){var c=a[u];if(!1===r(o[c],c,o))break}return n}}return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(137)],void 0!==(i=function(e){function t(t,r,i,o,a,s,u){var c=-1,l=t.length,p=r.length;if(l!=p&&!(a&&p>l))return!1;for(;++c<l;){var f=t[c],d=r[c],g=o?o(a?d:f,a?f:d,c):n;if(g!==n){if(g)continue;return!1}if(a){if(!e(r,function(e){return f===e||i(f,e,o,a,s,u)}))return!1}else if(f!==d&&!i(f,d,o,a,s,u))return!1}return!0}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,s,u){switch(u){case t:case n:return+e==+s;case r:return e.name==s.name&&e.message==s.message;case i:return e!=+e?s!=+s:e==+s;case o:case a:return e==s+""}return!1}var t="[object Boolean]",n="[object Date]",r="[object Error]",i="[object Number]",o="[object RegExp]",a="[object String]";return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(18)],void 0!==(i=function(e){function t(t,r,o,a,s,u,c){var l=e(t),p=l.length;if(p!=e(r).length&&!s)return!1;for(var f=p;f--;){var d=l[f];if(!(s?d in r:i.call(r,d)))return!1}for(var g=s;++f<p;){d=l[f];var h=t[d],y=r[d],v=a?a(s?y:h,s?h:y,d):n;if(!(v===n?o(h,y,a,s,u,c):v))return!1;g||(g="constructor"==d)}if(!g){var m=t.constructor,b=r.constructor;if(m!=b&&"constructor"in t&&"constructor"in r&&!("function"==typeof m&&m instanceof m&&"function"==typeof b&&b instanceof b))return!1}return!0}var n,r=Object.prototype,i=r.hasOwnProperty;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(76),n(79)],void 0!==(i=function(e,t){function n(n){for(var r=t(n),i=r.length;i--;)r[i][2]=e(r[i][1]);return r}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(12),n(36),n(8)],void 0!==(i=function(e,t,n){function r(r,i,a){if(!n(a))return!1;var s=void 0===i?"undefined":o(i);if("number"==s?e(a)&&t(i,a.length):"string"==s&&i in a){var u=a[i];return r===r?r===u:u!==u}return!1}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(25),n(5),n(36),n(13),n(37),n(26)],void 0!==(i=function(e,t,n,r,i,o){function a(a){for(var s=o(a),c=s.length,l=c&&a.length,p=!!l&&r(l)&&(t(a)||e(a)||i(a)),f=-1,d=[];++f<c;){var g=s[f];(p&&n(g,l)||u.call(a,g))&&d.push(g)}return d}var s=Object.prototype,u=s.hasOwnProperty;return a}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(78),n(35),n(7)],void 0!==(i=function(e,t,n){function r(r){return null!=r&&(e(r)?u.test(a.call(r)):n(r)&&(t(r)?u:i).test(r))}var i=/^\[object .+?Constructor\]$/,o=Object.prototype,a=Function.prototype.toString,s=o.hasOwnProperty,u=RegExp("^"+a.call(s).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(141),n(25),n(35),n(7),n(27)],void 0!==(i=function(e,t,n,r,i){function o(o){var u;if(!r(o)||l.call(o)!=s||n(o)||t(o)||!c.call(o,"constructor")&&"function"==typeof(u=o.constructor)&&!(u instanceof u))return!1;var p;return i.ownLast?(e(o,function(e,t,n){return p=c.call(n,t),!1}),!1!==p):(e(o,function(e,t){p=t}),p===a||c.call(o,p))}var a,s="[object Object]",u=Object.prototype,c=u.hasOwnProperty,l=u.toString;return o}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(139),n(26)],void 0!==(i=function(e,t){function n(n){return e(n,t(n))}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(18),n(26),n(166),n(79)],void 0!==(i=function(e,t,n,r){return{keys:e,keysIn:t,merge:n,pairs:r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(148),n(153)],void 0!==(i=function(e,t){return t(e)}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(71),n(150),n(75)],void 0!==(i=function(e,t,n){function r(r){return n(r)?e(r):t(r)}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";function r(e,t,r,i){function o(n,r,i){r.indexOf("[")>=0&&(r=r.substring(0,r.lastIndexOf("[")));var o=w(n)||n,a=L[o];a||t.logger.fatal(new Error("Missing default for modulePath: "+n+" with type: "+o)),ae[o]=void 0,e.each(X,function(e,t){t.indexOf(n)>-1&&(X[t]=void 0)}),e.each(q,function(e,t){t.indexOf(n)>-1&&(q[t]=void 0)}),e.each(Y,function(e,t){t.indexOf(n)>-1&&(Y[t]=void 0)}),e.each(J,function(e,t){t.indexOf(n)>-1&&(J[t]=void 0)}),e.each(Q,function(e,t){t.indexOf(n)>-1&&(Q[t]=void 0)}),e.each(ne,function(e,t){t.indexOf(n)>-1&&(ne[t]=void 0)}),e.each(ee,function(e,t){t.indexOf(n)>-1&&(ee[t]=void 0)}),a.components||(a.components={}),a.components[r]=e.merge({},a.components[r],i)}function a(t){var n={};return e.each(t,function(e,t){"_"!==t.charAt(0)&&(n[t]=e)}),n}function s(t){var n={};return e.each(t,function(e,t){"_"===t.charAt(0)&&(n[t]=e)}),n}function u(t,n){return se?e.lightMerge(t,n):e.merge({},t,n,c)}function c(t,n,r){if(e.isArray(n))return n}function l(t,n){if(n=n||"",n.indexOf("settings")>=0&&t.__env){var r=t.__env[F.env];r&&e.merge(t,r)}return e.each(t,function(r,i){e.isPlainObject(r)&&["labels"].indexOf(i)<0&&(t[i]=l(r,n?n+"."+i:i))}),t}function p(e,n,r){if(Q[e])return Q[e];var i=L[n]||{};return t.logger.debug("config.defaultConfigCacher()",n,e,{name:"typeDefaultConfig",value:i}),Q[e]=u(i,r)}function f(t,n,r){return ee[t]?ee[t]:ee[t]=e.merge(a(n),r&&r.settings?r.settings:{},c)}function d(t,n,r,i){return te[t]?te[t]:te[t]=e.merge(s(i),a(r),n.settings,c)}function g(t,n,r){if(ne[t])return ne[t];var i=r&&r.labels?r.labels:{},o={};for(var a in n)"_"!==a.charAt(0)&&e.lightMerge.prop(a,n,i||{},o);for(var a in i)o.hasOwnProperty(a)||(o[a]=i[a]);return ne[t]=o}function h(t,n,r,i){return re[t]?re[t]:(re[t]=e.merge(s(i),a(r),n.labels,c),re[t])}function y(t){e.each(t,function(t,n){ie[n]?ie[n]=e.merge({},ie[n],t):ie[n]=t})}function v(e){var n=e;if(e=_(e),q[e])return W[n]=W[e],q[e];for(var r,i=t.tracer.startTrace("config.getComponentInstanceConfig()",{componentModulePath:e}),o=H,a=o.settings,s=o.labels,u={},c={},l={},y=e.split("."),v="",m=0;m<y.length;m++){var S=y[m],C=v+=(v?".":"")+S;v=_(v),v!==C&&(S=v.split(".")[v.split(".").length-1]),v=C,o=o.components&&o.components[S]?o.components[S]:{},u=u&&u.components&&u.components[S]?u.components[S]:{},r=o.type||u.type||(L[v]?v:void 0),t.logger.debug("config.getComponentInstanceConfig()",r,v,e,{name:"ancestorDefaultConfig",value:u}),u=p(v,r,u),t.logger.debug("config.getComponentInstanceConfig()",r,v,e,{name:"ancestorInstanceConfig",value:o}),o=b(v,o,u,r),o.defaultSettings=c=f(v,c,u),o.defaultLabels=l=g(v,l,u),o.settings=a=d(v,o,a,c),o.labels=s=h(v,o,s,l),W[v]=r,W[v]||t.logger.fatal(new Error("Invalid component type for modulePath: "+v))}return i.end({currentInstanceConfig:o}),o}function m(t){if(ae[t])return ae[t];var n=e.merge({},B);if(L[t]&&L[t].settings){if(L[t].settings.__allowed)for(var r=0;r<L[t].settings.__allowed.length;r++)n[L[t].settings.__allowed[r]]=!0;for(var i in L[t].settings)n[i]=!0}return ae[t]=n}function b(n,r,i,o){if(q[n])return q[n];var a=t.tracer.startTrace("config.instanceConfigCacher()",{componentModulePath:n}),s=e.isUndefined(r.blueprint)?i.blueprint:r.blueprint;if(i.blueprints&&s&&i.blueprints[s]){var u=i.blueprints[s];t.logger.debug("config.instanceConfigCacher()",o,n,s,{name:"blueprintConfig",value:u}),r=e.merge({},u,r,c)}return i.types&&(t.logger.debug("config.instanceConfigCacher()",o,n,{name:"typesConfigFromDefault",value:i.types}),y(i.types)),r.types&&(t.logger.debug("config.instanceConfigCacher()",o,n,{name:"typesConfigFromInstance",value:r.types}),y(r.types)),ie[o]&&(t.logger.debug("config.instanceConfigCacher()",o,n,{name:"typeConfigFromInstance",value:ie[o]}),r=e.merge({},ie[o],r,c)),q[n]=r,a.end({currentInstanceConfig:r}),q[n]}function _(e){return e.lastIndexOf("]")===e.length-1&&oe[e]?_(e.substring(0,e.lastIndexOf("["))):e}function S(n){if(n=_(n),X[n])return X[n];var r=t.tracer.startTrace("config.getComponentInstanceSettings()",{componentModulePath:n}),i=v(n),o=u(i.defaultSettings,i.settings),a=u(V,o);return a=C(a,W[n]),se&&e.freeze.deep(a),X[n]=a,r.end({componentInstanceSettings:a}),X[n]}function C(e,t){for(var n=m(t),r=Object.keys(e),i=0;i<r.length;i++)n.hasOwnProperty(r[i])||delete e[r[i]];return e}function x(e,n){e=_(e);var r=Y[e];if(!r){var i=v(e);r=u(i.defaultLabels,i.labels),Y[e]=r}var o=J[e]&&J[e][n]?J[e][n]:null;if(!o){var a=t.tracer.startTrace("config.getComponentInstanceLabels()",{componentModulePath:e});o={};var s=null;n.split("-").length>1&&(s=n.split("-")[0]);for(var c in $){var l=$[c];l[n]?o[c]=l[n]:s&&l[s]?o[c]=l[s]:l.en&&(o[c]=l.en)}for(var p in r){var f=r[p];if(!f)return;f[n]?o[p]=f[n]:s&&f[s]?o[p]=f[s]:f.en&&!o[p]&&(o[p]=f.en)}J[e]||(J[e]={}),J[e][n]=o,a.end({languageLabels:o,languageId:n})}return o}function w(e){var n=t.tracer.startTrace("config.getComponentInstanceType()",{componentModulePath:e});return e=_(e),v(e),n.end({type:W[e]}),W[e]}function E(e,t){return S(e)[t]}function j(n,r,i,o,a){var s=t.tracer.startTrace("config.init()");n||t.logger.fatal(new Error("(config) No applicationConfig provided")),r||t.logger.fatal(new Error("(config) No defaultConfig provided")),q={},X={},Y={},J={},W={},Z={},Q={},ee={},te={},ne={},re={},H=e.merge({},n),U=n,L=e.merge({},r),$=e.merge({},ue,i),G={},V=e.merge({},ce,o),oe={},F=a||{},se=V.freezeConfig,n.settings&&!e.isUndefined(n.settings.freezeConfig)&&(se=n.settings.freezeConfig),F.hasOwnProperty("dynamic")||(F.dynamic=!1),e.each(Object.keys(V),function(e){B[e]=!0}),l({settings:V}),l(H),l(L),P(n.components),s.end({applicationConfig:n,defaultConfig:r,baseLabelsIn:i,baseSettingsIn:o,optionsIn:a})}function P(n,r){0!==Object.keys(n).length&&e.each(n,function(n,i){var o=(r?r+".":"")+i;if(Z.hasOwnProperty(o)||(Z[o]=!0),n.type||t.logger.fatal(new Error("Missing component type for path: "+o)),L.hasOwnProperty(n.type)){var a=L[n.type].blueprints;n.blueprint&&a&&a[n.blueprint]&&e.isPlainObject(a[n.blueprint].components)?P(e.merge({},L[n.type].components,a[n.blueprint].components),o):e.isPlainObject(L[n.type].components)&&P(L[n.type].components,o)}e.isPlainObject(n.components)&&P(n.components,o)})}function A(){return Z}function z(e){return w(e)}function k(e){return!!L[e]}function T(e){return!!Z[e]}function M(n,r){n&&r&&r.type||t.logger.fatal(new Error("(config) addInstanceInternal requires modulePath and opts (with type)")),e.componentPath.assignInstance(n,H,L,r.type,r.instanceConfig,function(e){Z[e]=!0,oe[e]=!0})}function N(){return!F||F.dynamic}function D(e){return e?(window.morningstar.components._defaultConfig||{})[e]:window.morningstar.components._defaultConfig||{}}function K(e,n){t.logger.info("config.addType()",e,n),N()||t.logger.fatal(new Error("(config) The configuration module has been configured not to allow dynamic behaviour.")),n=n||D(e),e&&n||t.logger.fatal(new Error("(config) _addType requires type and defaultConfig")),n.type||(n.type=e),L[e]=n}function O(e,n,r){t.logger.info("config.registerComponent()",e,n),N()||t.logger.fatal(new Error("(config) The configuration module has been configured not to allow dynamic behaviour.")),e&&n||t.logger.fatal(new Error("(config) registerComponent requires type and defaultConfig")),n.type||(n.type=e),k(e)||(L[e]=n,ae[e]=void 0),r&&r.indexOf("[")>=0&&(Z[r]=!0,oe[r]=!0)}function I(e,n){t.logger.info("config.addInstance()",e,n),R(e)||t.logger.fatal(new Error("(config) The configuration module has been configured not to allow dynamic behaviour.")),e&&n||t.logger.fatal(new Error("(config) addInstance requires modulePath and options")),n.type||t.logger.fatal(new Error("(config) addInstance requires options.type")),k(n.type)||K(n.type,n.defaultConfig),T(e)||M(e,n)}function R(e){return N()||e&&e.indexOf("[")>=0&&T(e.substring(0,e.lastIndexOf("[")))}e||(e=n(172)),t||(t=n(81));var F,B={baseUrlApiGatewayEU:!0,baseUrlApiGatewayUS:!0,baseUrlMorningstarEU:!0,baseUrlMorningstarUS:!0,baseUrlPdfServiceEU:!0,baseUrlQuoteSpeed:!0,baseUrlQuoteSpeedPull:!0,currencyId:!0,currencySymbol:!0,defaultDateFormat:!0,defaultNumberFormat:!0,format:!0,freezeConfig:!0,languageId:!0,urlKey:!0,useCalculatedWidth:!0,validation:!0,_validation:!0},L=null,H=null,U=null,$=null,G=null,V=null,q={},X={},Y={},J={},W={},Z={},Q={},ee={},te={},ne={},re={},ie={},oe={},ae={},se=!1,ue=r||{},ce=e.merge({languageId:"en-GB"},i);return{init:j,getSetting:E,getSettings:S,getLabels:x,getComponentType:z,getModulePaths:A,addType:K,addInstance:I,hasType:k,hasInstance:T,canAddModulePathDynamically:R,allowsDynamic:N,getInstanceConfig:function(e){return U&&U.components&&U.components[e]?U.components[e]:null},getDefaultConfig:function(e){return L&&L[e]?L[e]:null},getOption:function(e){return(F||{})[e]},setOption:function(e,t){F=F||{},F[e]=t},getBaseSettings:function(){return ce},mergeBaseSettings:function(t){ce=e.merge({},ce,t)},util:e,registerComponent:O,updateDefaultConfigForInstance:o,registerModulePaths:P}}e.exports={config:r}},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(84),n(83),n(40)],void 0!==(i=function(e,t,n){function r(){var i,a,s,u,c,l,p=arguments[0]||{},f=1,d=arguments.length,g=!1;if(1!==d){for("boolean"==typeof p&&(g=p,p=arguments[1]||{},f=2),"object"===(void 0===p?"undefined":o(p))||e(p)||(p={});f<d;f++)if(null!=(c=arguments[f])){var h=Object.getOwnPropertyNames(c||{});for(var y in h)if(h.hasOwnProperty(y)){if("_$parent"===(u=h[y]))continue;if(i=p[u],s=c[u],p===s)continue;var v=Object.getOwnPropertyDescriptor(c,u);if(void 0===v)continue;var m=v.get||v.set||!v.enumerable||!v.writable;!m&&g&&s&&(n(s)||(a=t(s)))?(a?(a=!1,l=i&&t(i)?i:[]):l=i&&n(i)?i:{},p[u]=r(g,l,s),Object.defineProperty(p[u],"_$parent",{enumerable:!1,value:p})):void 0!==s&&Object.defineProperty(p,u,v)}}return p}}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(){this._providers={}}return e.prototype.register=function(e,t){if(!t)throw"Cannot register undefined/null provider - "+e;this._providers[e]=t},e.prototype.unregister=function(e){delete this._providers[e]},e.prototype.clear=function(){this._providers={}},e.prototype.hasProviders=function(){var e=this;for(var t in e._providers)if(e._providers.hasOwnProperty(t))return!0;return!1},e.prototype.get=function(e){return this._providers[e]},e.prototype.each=function(e){var t=this;for(var n in t._providers)t._providers.hasOwnProperty(n)&&e(t._providers[n])},e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(87)],void 0!==(i=function(e){function t(e,t){if(!t)throw"logProvider is undefined/null";this.logLevel=e.logLevel,this._componentModulePath=n(e.componentModulePath),this._operation=n(e.operation),this._includeStack=e.includeStack,this._filterFunc=e.filterFunc,this._logProvider=t}function n(t){return e(t)?new RegExp(t):t}return t.prototype._allow=function(e){var t=e[0],n=e[e.length-1]&&e[e.length-1].tags?e[e.length-1].tags:e[e.length-1]||{};return(!this._componentModulePath||n.componentModulePath&&n.componentModulePath.match&&null!==n.componentModulePath.match(this._componentModulePath))&&(!this._componentType||n.componentType&&n.componentType.match&&null!==n.componentType.match(this._componentType))&&(!this._operation||t&&t.match&&null!==t.match(this._operation))&&(!this._filterFunc||this._filterFunc.apply(this,e))},t.prototype.setLogLevel=function(e){this.logLevel=e},t.prototype.fatal=function(){var e=this;this._allow(arguments)&&this._logProvider.fatal.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.error=function(){var e=this;this._allow(arguments)&&this._logProvider.error.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.warn=function(){var e=this;this._allow(arguments)&&this._logProvider.warn.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.info=function(){var e=this;this._allow(arguments)&&this._logProvider.info.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.debug=function(){var e=this;this._allow(arguments)&&this._logProvider.debug.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t.prototype.trace=function(){var e=this;this._allow(arguments)&&this._logProvider.trace.apply(e._logProvider,!0===this._includeStack?Array.apply(null,arguments).concat((new Error).stack):arguments)},t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){return{isFunction:n(84),isArray:n(83),isPlainObject:n(40),isWindow:n(90),isNumber:n(85),isString:n(87),isUndefined:n(89),isUndefinedOrNull:n(88),isObject:n(86),getPrototype:n(82),each:n(39),componentPath:n(173),merge:n(41),freeze:n(174),lightMerge:n(175)}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(39),n(41),n(81)],void 0!==(i=function(e,t,n){function r(r,i,o,a,s,u){var c,l=i,p=r.split(".");e(p,function(e,r){l.components&&l.components[e]?l=l.components[e]:l.type&&o[l.type]&&o[l.type].components[e]?l=o[l.type].components[e]:r===p.length-1?(e.indexOf("[")>=0&&(e=e.substring(0,e.lastIndexOf("[")),l.components&&l.components[e]?s=t({},o&&o[l.type]&&o[l.type].components?o[l.type].components[e]:{},l.components[e],s):o[l.type]&&o[l.type].components&&o[l.type].components[e]&&(s=t({},o[l.type].components[e],s))),l.components||(l.components={}),c=l.components):n.logger.fatal(new Error("(util) Could not assign instance dynamically because a parent instance was not initialized: "+e))}),c&&(s=s||{components:{}},s.type=a,c[p[p.length-1]]=s),u&&u(r)}function i(t,r){if(!r)return t;null==t&&n.logger.fatal(new Error("currentPath must have a value"));var i=t.split(".");""===i[0]&&i.splice(0,1);var o=r.split("."),a=[],s=!1;return e(o,function(e){"_"===e?s?n.logger.fatal(new Error("Invalid relative path: "+r)):i.pop()||n.logger.fatal(new Error("Invalid relative path lookup: "+t+", "+r)):(a.push(e),s=!0)}),i.join(".")+(i.length&&a.length?".":"")+a.join(".")}function o(e,t){for(var n=e?e.split("."):[],r=t?t.split("."):[],i=[],o=[],a=!0,s=0;s<Math.max(n.length,r.length);s++)if(n.length>s&&r.length>s){if(n[s]==r[s]&&a)continue;i.push("_"),o.push(r[s]),a=!1}else n.length>s?i.push("_"):r.length>s&&o.push(r[s]);return i.concat(o).join(".")}return{resolve:i,relative:o,assignInstance:r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(86)],void 0!==(i=function(e){function t(t){for(var r in t)t.hasOwnProperty(r)&&e(t[r])&&n(t[r]);return t}function n(t){if(Object.isFrozen(t))return t;for(var r in t)t.hasOwnProperty(r)&&e(t[r])&&n(t[r]);return Object.freeze(t)}return{deep:n,deepProperties:t}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(40),n(89),n(88)],void 0!==(i=function(e,t,n){function r(r,o,a,s){!n(a)&&!t(a[r])||t(o[r])?t(a[r])||(e(a[r])&&!n(o[r])&&e(o[r])?s[r]=i(o[r],a[r]):s[r]=a[r]):s[r]=o[r]}function i(e,t){var n={};for(var i in e)r(i,e,t,n);for(var i in t)e&&e.hasOwnProperty(i)||r(i,e,t,n);return n}return i.prop=r,i}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,i){if("function"!=typeof e)throw new TypeError(n);return i=r(i===t?e.length-1:+i||0,0),function(){for(var t=arguments,n=-1,o=r(t.length-i,0),a=Array(o);++n<o;)a[n]=t[i+n];switch(i){case 0:return e.call(this,a);case 1:return e.call(this,t[0],a);case 2:return e.call(this,t[0],t[1],a)}var s=Array(i+1);for(n=-1;++n<i;)s[n]=t[n];return s[i]=a,e.apply(this,s)}}var t,n="Expected a function",r=Math.max;return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e,t,n){n||(n={});for(var r=-1,i=t.length;++r<i;){var o=t[r];n[o]=e[o]}return n}return e}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(186)],void 0!==(i=function(e){return e()}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(179),n(30)],void 0!==(i=function(e,t){function n(n,r){return e(n,r,t)}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(91),n(182),n(29),n(19),n(14),n(10),n(95),n(45)],void 0!==(i=function(e,t,n,r,i,o,a,s){function u(l,p,f,d,g){if(!i(l))return l;var h=r(p)&&(n(p)||a(p)),y=h?c:s(p);return e(y||p,function(e,n){if(y&&(n=e,e=p[n]),o(e))d||(d=[]),g||(g=[]),t(l,p,n,u,f,d,g);else{var r=l[n],i=f?f(r,e,n,l,p):c,a=i===c;a&&(i=e),i===c&&(!h||n in l)||!a&&(i===i?i===r:r!==r)||(l[n]=i)}}),l}var c;return u}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(177),n(28),n(29),n(19),n(191),n(95),n(192)],void 0!==(i=function(e,t,n,r,i,o,a){function s(s,c,l,p,f,d,g){for(var h=d.length,y=c[l];h--;)if(d[h]==y)return void(s[l]=g[h]);var v=s[l],m=f?f(v,y,l,s,c):u,b=m===u;b&&(m=y,r(y)&&(n(y)||o(y))?m=n(v)?v:r(v)?e(v):[]:i(y)||t(y)?m=t(v)?a(v):i(v)?v:{}:b=!1),d.push(y),g.push(m),b?s[l]=p(m,y,f,d,g):(m===m?m!==v:v===v)&&(s[l]=m)}var u;return s}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(43)],void 0!==(i=function(e){function t(t){return function(r){return null==r?n:e(r)[t]}}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(196)],void 0!==(i=function(e){function t(t,r,i){if("function"!=typeof t)return e;if(r===n)return t;switch(i){case 1:return function(e){return t.call(r,e)};case 3:return function(e,n,i){return t.call(r,e,n,i)};case 4:return function(e,n,i,o){return t.call(r,e,n,i,o)};case 5:return function(e,n,i,o,a){return t.call(r,e,n,i,o,a)}}return function(){return t.apply(r,arguments)}}var n;return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(184),n(188),n(176)],void 0!==(i=function(e,t,n){function r(r){return n(function(n,o){var a=-1,s=null==n?0:o.length,u=s>2?o[s-2]:i,c=s>2?o[2]:i,l=s>1?o[s-1]:i;for("function"==typeof u?(u=e(u,l,5),s-=2):(u="function"==typeof l?l:i,s-=u?1:0),c&&t(o[0],o[1],c)&&(u=s<3?i:u,s=1);++a<s;){var p=o[a];p&&r(n,p,u)}return n})}var i;return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(43)],void 0!==(i=function(e){function t(t){return function(n,r,i){for(var o=e(n),a=i(n),s=a.length,u=t?s:-1;t?u--:++u<s;){var c=a[u];if(!1===r(o[c],c,o))break}return n}}return t}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(183)],void 0!==(i=function(e){return e("length")}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r=[n(19),n(42),n(14)],void 0!==(i=function(e,t,n){function r(r,i,a){if(!n(a))return!1;var s=void 0===i?"undefined":o(i);if("number"==s?e(a)&&t(i,a.length):"string"==s&&i in a){var u=a[i];return r===r?r===u:u!==u}return!1}return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(28),n(29),n(42),n(20),n(44),n(30)],void 0!==(i=function(e,t,n,r,i,o){function a(a){for(var s=o(a),c=s.length,l=c&&a.length,p=!!l&&r(l)&&(t(a)||e(a)||i(a)),f=-1,d=[];++f<c;){var g=s[f];(p&&n(g,l)||u.call(a,g))&&d.push(g)}return d}var s=Object.prototype,u=s.hasOwnProperty;return a}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(94),n(93),n(10)],void 0!==(i=function(e,t,n){function r(r){return null!=r&&(e(r)?u.test(a.call(r)):n(r)&&(t(r)?u:i).test(r))}var i=/^\[object .+?Constructor\]$/,o=Object.prototype,a=Function.prototype.toString,s=o.hasOwnProperty,u=RegExp("^"+a.call(s).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");return r}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(180),n(28),n(93),n(10),n(31)],void 0!==(i=function(e,t,n,r,i){function o(o){var u;if(!r(o)||l.call(o)!=s||n(o)||t(o)||!c.call(o,"constructor")&&"function"==typeof(u=o.constructor)&&!(u instanceof u))return!1;var p;return i.ownLast?(e(o,function(e,t,n){return p=c.call(n,t),!1}),!1!==p):(e(o,function(e,t){p=t}),p===a||c.call(o,p))}var a,s="[object Object]",u=Object.prototype,c=u.hasOwnProperty,l=u.toString;return o}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(178),n(30)],void 0!==(i=function(e,t){function n(n){return e(n,t(n))}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(45),n(30),n(194),n(195)],void 0!==(i=function(e,t,n,r){return{keys:e,keysIn:t,merge:n,pairs:r}}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(181),n(185)],void 0!==(i=function(e,t){return t(e)}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[n(45),n(43)],void 0!==(i=function(e,t){function n(n){n=t(n);for(var r=-1,i=e(n),o=i.length,a=Array(o);++r<o;){var s=i[r];a[r]=[s,n[s]]}return a}return n}.apply(t,r))&&(e.exports=i)},function(e,t,n){"use strict";var r,i;r=[],void 0!==(i=function(){function e(e){return e}return e}.apply(t,r))&&(e.exports=i)},function(e,t){e.exports={analystRating_bronze:{"da-DK":"Bronze",de:"Bronze",en:"Bronze",es:"Bronce",fr:"Bronze",it:"Bronzo",ja:"ブロンズ","zh-CN":"铜","zh-HK":"銅"},analystRating_gold:{"da-DK":"Guld",de:"Gold",en:"Gold",es:"Oro",fr:"Or",it:"Oro",ja:"ゴールド","zh-CN":"金","zh-HK":"金"},analystRating_negative:{"da-DK":"Negativ",de:"Negativ",en:"Negative",es:"Negativo",fr:"Négatif",it:"Negativo",ja:"ネガティブ","zh-CN":"负面","zh-HK":"負面"},analystRating_neutral:{"da-DK":"Neutral",de:"Neutral",en:"Neutral",es:"Neutral",fr:"Neutre",it:"Neutrale",ja:"ニュートラル","zh-CN":"中性","zh-HK":"中性"},analystRating_notRated:{"da-DK":"Ikke bedømt",en:"Not Rated",es:"Sin Clasificar",it:"Senza rating",ja:"評価なし"},analystRating_silver:{"da-DK":"Sølv",de:"Silber",en:"Silver",es:"Plata",fr:"Argent",it:"Argento",ja:"シルバー","zh-CN":"银","zh-HK":"銀"},analystRating_underReview:{"da-DK":"Under Revidering",de:"Wird derzeit geprüft",en:"Under Review",es:"Under review",fr:"En cours d'étude",it:"Sotto revisione",ja:"評価中","zh-CN":"评估中","zh-HK":"評估中"},april:{"da-DK":"April",en:"April",fr:"Avril",it:"Aprile",ja:"4月",sv:"april","zh-CN":"四月","zh-HK":"四月"},august:{"da-DK":"August",en:"August",fr:"Août",it:"Agosto",ja:"8月",sv:"augusti","zh-CN":"八月","zh-HK":"八月"},basicMaterials:{"da-DK":"Materialer",en:"Basic Materials",es:"Materiales basicos",fr:"Matériels de base","fr-CA":"Matériaux de base",it:"Materiali di base",ja:"原材料",sv:"Råvaror","zh-CN":"基本物料","zh-HK":"基本物料"},billions:{en:"b",fr:"b",ja:"十億","zh-CN":"十亿","zh-HK":"十億"},bondStyleBox_highExtreme:{"da-DK":"Høj Extreme",en:"High Extreme",it:"Estremamente alto",ja:"高格付長期"},bondStyleBox_highLimited:{"da-DK":"Høj Limited",en:"High Limited",it:"Limitatamente alto",ja:"高格付短期"},bondStyleBox_highModerate:{"da-DK":"Høj Moderate",en:"High Moderate",it:"Moderatamente alto",ja:"高格付中期"},bondStyleBox_lowExtreme:{"da-DK":"Lav Extreme",en:"Low Extreme",it:"Estremamente basso",ja:"低格付長期"},bondStyleBox_lowLimited:{"da-DK":"Lav Limited",en:"Low Limited",it:"Limitatamente basso",ja:"低格付短期",sv:"Low Limited"},bondStyleBox_lowModerate:{"da-DK":"Lav Moderate",en:"Low Moderate",it:"Moderatamente basso",ja:"低格付中期"},bondStyleBox_mediumExtreme:{"da-DK":"Mellem Extreme",en:"Medium Extreme",it:"Estremamente medio",ja:"中格付長期"},bondStyleBox_mediumLimited:{"da-DK":"Mellem Limited",en:"Medium Limited",it:"Limitatamente medio",ja:"中格付短期"},bondStyleBox_mediumModerate:{"da-DK":"Mellem Moderate",en:"Medium Moderate",it:"Moderatamente medio",ja:"中格付中期"},communicationServices:{"da-DK":"Kommunikationsservice",en:"Comm Services",es:"Servicios Comerciales",fr:"Services de communications","fr-CA":"Services de communication",it:"Comunicazioni",ja:"通信",sv:"Kommunikationstjänster","zh-CN":"通讯服务","zh-HK":"通訊服務"},consumerCyclical:{"da-DK":"Cyklisk forbrug",en:"Con Cyclical",es:"Con Cíclico",fr:"Consommation cyclique",it:"Cons. ciclici",ja:"景気循環消費財",sv:"Konsument cyklisk","zh-CN":"周期性消费品","zh-HK":"週期性消費品"},consumerDefensive:{"da-DK":"Forbrugsvarer",en:"Con Defensive",es:"Defensivo",fr:"Consommation défensive",it:"Cons. difensivi",ja:"景気非連動消費財",sv:"Konsument stabil","zh-CN":"防守性消费品","zh-HK":"防守性消費品"},country_abw:{en:"Aruba",it:"Aruba"},country_afg:{en:"Afghanistan",it:"Afghanistan (Repubblica Islamica del)"},country_ago:{en:"Angola",it:"Angola"},country_aia:{en:"Anguilla",it:"Anguilla"},country_ala:{en:"Åland Islands",it:"Isole Åland",sv:"Åland"},country_alb:{en:"Albania",it:"Albania",sv:"Albanien"},country_and:{en:"Andorra",it:"Andorra"},country_ant:{en:"Netherlands Antilles",it:"Antille Olandesi",sv:"Nederländska Antillerna"},country_are:{"da-DK":"Forenede Arabiske Emirater",de:"Vereinigte Arabische Emirate",en:"United Arab Emirates",es:"Emiratos Árabes",fr:"Emirats arabes unis","fr-CA":"Émirats arabes unis",it:"Emirati Arabi Uniti",ja:"アラブ首長国連邦",sv:"Förenade Arabemiraten","zh-CN":"阿拉伯联合酋长国","zh-HK":"亞拉伯聯合酋長國"},country_arg:{de:"Argentinien",en:"Argentina",es:"Argentina",fr:"Argentine",it:"Argentina",ja:"アルゼンチン","zh-CN":"阿根廷","zh-HK":"阿根廷"},country_arm:{en:"Armenia",it:"Armenia",sv:"Armenien"},country_asm:{en:"American Samoa",it:"Samoa Americane",sv:"Amerikanska Samoa"},country_ata:{en:"Antarctica",it:"Antartide",sv:"Antarktis"},country_atf:{en:"French Southern and Antarctic Lands (French Southern Territories)",it:"Terre Australi e Antartiche Francesi (Territori Francesi Meridionali)",sv:"Franska Södra Territorierna"},country_atg:{en:"Antigua and Barbuda",it:"Antigua e Barbuda",sv:"Antigua och Barbuda"},country_aus:{de:"Australien",en:"Australia",es:"Australia",fr:"Australie",it:"Australia",ja:"オーストラリア",sv:"Australien","zh-CN":"澳大利亚","zh-HK":"澳洲"},country_aut:{de:"Österreich",en:"Austria",es:"Austria",fr:"Autriche",it:"Austria",ja:"オーストリア",sv:"Österrike","zh-CN":"奥地利","zh-HK":"奧地利"},country_aze:{en:"Azerbaijan",it:"Azerbaijan",sv:"Azerbadjan"},country_bdi:{en:"Burundi",it:"Burundi"},country_bel:{de:"Belgien",en:"Belgium",es:"Bélgica",fr:"Belgique",it:"Belgio",ja:"ベルギー",sv:"Belgien","zh-CN":"比利时","zh-HK":"比利時"},country_ben:{en:"Benin",it:"Benin"},country_bfa:{en:"Burkina Faso",it:"Burkina Faso"},country_bgd:{en:"Bangladesh",it:"Bangladesh"},country_bgr:{de:"Bulgarien",en:"Bulgaria",es:"Bulgaria",fr:"Bulgarie",it:"Bulgaria",ja:"ブルガリア",sv:"Bulgarien","zh-CN":"保加利亚","zh-HK":"保加利亞"},country_bhr:{en:"Bahrain",it:"Bahrein"},country_bhs:{de:"Bahamas",en:"Bahamas",es:"Bahamas",fr:"Bahamas",it:"Bahamas",ja:"バハマ","zh-CN":"巴哈马","zh-HK":"巴哈馬"},country_bih:{en:"Bosnia and Herzegovina",it:"Bosnia ed Erzegovina",sv:"Bosnien och Hercegovina"},country_blm:{en:"Saint Barthélemy",it:"Saint Barthélemy",sv:"St bart"},country_blr:{en:"Belarus",it:"Bielorussia",sv:"Vitryssland"},country_blz:{en:"Belize",it:"Belize"},country_bmu:{de:"Bermuda",en:"Bermuda",es:"Bermuda",fr:"Bermudes",it:"Bermuda",ja:"バミューダ","zh-CN":"百慕大","zh-HK":"百慕達"},country_bol:{en:"Bolivia",it:"Bolivia"},country_bra:{de:"Brasilien",en:"Brazil",es:"Brasil",fr:"Brésil",it:"Brasile",ja:"ブラジル",sv:"Brasilien","zh-CN":"巴西","zh-HK":"巴西"},country_brb:{en:"Barbados",it:"Barbados"},country_brn:{en:"Brunei Darussalam",it:"Brunei",sv:"Brunei"},country_btn:{en:"Bhutan",it:"Bhutan"},country_bvt:{en:"Bouvet Island",it:"Isola Bouvet",sv:"Bouvetön"},country_bwa:{en:"Botswana",it:"Botswana"},country_caf:{en:"Central African Republic",it:"Repubblica Centrafricana",sv:"Centralafrikanska Republiken"},country_can:{de:"Kanada",en:"Canada",es:"Canadá",fr:"Canada",it:"Canada",ja:"カナダ",sv:"Kanada","zh-CN":"加拿大","zh-HK":"加拿大"},country_cck:{en:"Cocos (Keeling) Islands",it:"Isole Cocos",sv:"Kokosöarna"},country_che:{de:"Schweiz",en:"Switzerland",es:"Suiza",fr:"Suisse",it:"Svizzera",ja:"スイス",sv:"Schweiz","zh-CN":"瑞士","zh-HK":"瑞士"},country_chl:{en:"Chile",it:"Cile"},country_chn:{de:"China",en:"China",es:"China",fr:"Chine",it:"Cina",ja:"中国",sv:"Kina","zh-CN":"中国","zh-HK":"中國"},country_civ:{en:"Ivory Coast",it:"Costa D'Avorio",sv:"Elfenbenskusten"},country_cmr:{en:"Cameroon",it:"Camerun",sv:"Kamerun"},country_cod:{en:"Democratic Republic of the Congo (Kinshasa)",it:"Repubblica Democratica del Congo (Kinshasa)",sv:"Kongo"},country_cog:{en:"Congo, Republic of (Brazzaville)",it:"Repubblica del Congo (Brazzaville)",sv:"Kongo"},country_cok:{en:"Cook Islands",it:"Isole Cook",sv:"Cooköarna"},country_col:{en:"Colombia",it:"Colombia"},country_com:{en:"Comoros",it:"Comore",sv:"Komorerna"},country_cpv:{en:"Cape Verde",it:"Capo Verde",sv:"Kap Verdeöarna"},country_cri:{en:"Costa Rica",it:"Costa Rica"},country_cub:{en:"Cuba",it:"Cuba",sv:"Kuba"},country_cxr:{en:"Christmas Island (Australia)",it:"Isola di Natale (Australia)",sv:"Julön"},country_cym:{de:"Cayman Islands",en:"Cayman Islands",es:"Islas Caimán",fr:"Caïman",it:"Isole Cayman",ja:"ケイマン諸島",sv:"Caymanöarna","zh-CN":"开曼群岛","zh-HK":"開曼群島"},country_cyp:{de:"Zypern",en:"Cyprus",es:"Chipre",fr:"Chypre",it:"Cipro",ja:"キプロス",sv:"Cypern","zh-CN":"塞浦路斯","zh-HK":"塞浦路斯"},country_cze:{de:"Tschechische Republik",en:"Czech Republic",es:"República Checa",fr:"République tchèque",it:"Repubblica Ceca",ja:"チェコ共和国",sv:"Tjeckien","zh-CN":"捷克共和国","zh-HK":"捷克共和國"},country_deu:{de:"Deutschland",en:"Germany",es:"Alemania",fr:"Allemagne",it:"Germania",ja:"ドイツ",sv:"Tyskland","zh-CN":"德国","zh-HK":"德國"},country_dji:{en:"Djibouti",it:"Gibuti",sv:"Djibouti"},country_dma:{en:"Dominica",it:"Dominica"},country_dnk:{de:"Dänemark",en:"Denmark",es:"Dinamarca",fr:"Danemark",it:"Danimarca",ja:"デンマーク",sv:"Danmark","zh-CN":"丹麦","zh-HK":"丹麥"},country_dom:{en:"Dominican Republic",it:"Repubblica Dominicana",sv:"Dominikanska Republiken","zh-CN":"多米尼加共和国","zh-HK":"多米尼加共和國"},country_dza:{en:"Algeria",it:"Algeria",sv:"Algeriet"},country_ecu:{en:"Ecuador",it:"Ecuador"},country_egy:{en:"Egypt",it:"Egitto",sv:"Egypten","zh-CN":"埃及","zh-HK":"埃及"},country_eri:{en:"Eritrea",it:"Eritrea"},country_esh:{en:"Western Sahara",it:"Sahara Occidentale",sv:"Västsahara"},country_esp:{de:"Spanien",en:"Spain",es:"España",fr:"Espagne",it:"Spagna",ja:"スペイン",sv:"Spanien","zh-CN":"西班牙","zh-HK":"西班牙"},country_est:{de:"Estland",en:"Estonia",es:"Estonia",fr:"Estonie",it:"Estonia",ja:"エストニア",sv:"Estland","zh-CN":"爱沙尼亚","zh-HK":"愛沙尼亞"},country_eth:{en:"Ethiopia",it:"Etiopia",sv:"Etiopien"},country_fin:{de:"Finnland",en:"Finland",es:"Finlandia",fr:"Finlande",it:"Finlandia",ja:"フィンランド","zh-CN":"芬兰","zh-HK":"芬蘭"},country_fji:{de:"Fidschi",en:"Fiji",es:"Islas Fidji",fr:"Iles Fidji","fr-CA":"Fidji",it:"Fiji",ja:"フィジー",sv:"Fijiöarna","zh-CN":"斐济","zh-HK":"斐濟"},country_flk:{en:"Falkland Islands",it:"Isole Falkland",sv:"Falklandsöarna"},country_fra:{de:"Frankreich",en:"France",es:"Francia",fr:"France",it:"Francia",ja:"フランス",sv:"Frankrike","zh-CN":"法国","zh-HK":"法國"},country_fro:{en:"Faroe Islands",it:"Isole Faroe",sv:"Färöarna"},country_fsm:{en:"Micronesia, Federal States of",it:"Stati Federati di Micronesia",sv:"Mikronesien"},country_gab:{en:"Gabon",it:"Gabon","zh-CN":"加蓬","zh-HK":"加蓬"},country_gbl:{de:"Global",en:"Global",es:"Global",fr:"Global","fr-CA":"Mondial",it:"Globale",ja:"グローバル","zh-CN":"环球","zh-HK":"環球"},country_gbr:{de:"Vereinigtes Königreich",en:"United Kingdom",es:"Reino Unido",fr:"Royaume-Uni",it:"Regno Unito",ja:"イギリス",sv:"Storbritannien","zh-CN":"英国","zh-HK":"英國"},country_geo:{de:"Georgien",en:"Georgia",es:"Georgia",fr:"Géorgie",it:"Georgia",ja:"ジョージア",sv:"Georgien","zh-CN":"乔治亚州","zh-HK":"格魯吉亞"},country_ggy:{de:"Guernsey",en:"Guernsey",es:"Guernsey",fr:"Guernesey",it:"Guernsey",ja:"ガーンジー","zh-CN":"格恩西岛","zh-HK":"根西島"},country_gha:{en:"Ghana",it:"Ghana"},country_gib:{en:"Gibraltar",it:"Gibilterra"},country_gin:{en:"Guinea",it:"Guinea"},country_glp:{en:"Guadeloupe",it:"Guadalupa"},country_gmb:{en:"Gambia",it:"Gambia"},country_gnb:{en:"Guinea-Bissau",it:"Guinea Bissau"},country_gnq:{en:"Equatorial Guinea",it:"Guinea Equatoriale",sv:"Ekvatorialguinea"},country_grc:{de:"Griechenland",en:"Greece",es:"Grecia",fr:"Grèce",it:"Grecia",ja:"ギリシャ",sv:"Grekland","zh-CN":"希腊","zh-HK":"希臘"},country_grd:{en:"Grenada",it:"Grenada"},country_grl:{en:"Greenland",it:"Groenlandia",sv:"Grönland"},country_gtm:{en:"Guatemala",it:"Guatemala"},country_guf:{en:"French Guiana",it:"Guayana Francese",sv:"Franska Guyana"},country_gum:{en:"Guam",it:"Guam"},country_guy:{en:"Guyana",it:"Guyana"},country_hkg:{de:"Hongkong",en:"Hongkong",es:"Hong Kong",fr:"Hong Kong",it:"Hong Kong",ja:"香港","zh-CN":"香港","zh-HK":"香港"},country_hmd:{en:"Heard and McDonald Islands",it:"Isole Heard e McDonald",sv:"Heard- och McDonaldöarna"},country_hnd:{en:"Honduras",it:"Honduras"},country_hrv:{de:"Kroatien",en:"Croatia",es:"Croacia",fr:"Croatie",it:"Croazia",ja:"クロアチア",sv:"Kroatien","zh-CN":"克罗地亚","zh-HK":"克羅地亞"},country_hti:{en:"Haiti",it:"Haiti"},country_hun:{de:"Ungarn",en:"Hungary",es:"Hungría",fr:"Hongrie",it:"Ungheria",ja:"ハンガリー",sv:"Ungern","zh-CN":"匈牙利","zh-HK":"匈牙利"},country_idn:{de:"Indonesien",en:"Indonesia",es:"Indonesia",fr:"Indonésie",it:"Indonesia",ja:"インドネシア",sv:"Indonesien","zh-CN":"印尼","zh-HK":"印尼"},country_imn:{en:"Isle of Man",it:"Isola di Man"},country_ind:{de:"Indien",en:"India",es:"India",fr:"Inde",it:"India",ja:"インド",sv:"Indien","zh-CN":"印度","zh-HK":"印度"},country_iot:{en:"British Indian Ocean Territory",it:"Territorio Britannico Oceano Indiano",sv:"Brittiska Västindien"},country_irl:{de:"Irland",en:"Ireland",es:"Irlanda",fr:"Irlande",it:"Irlanda",ja:"アイルランド",sv:"Irland","zh-CN":"爱尔兰","zh-HK":"愛爾蘭"},country_irn:{en:"Iran (Islamic Republic of)",it:"Iran (Persia)",sv:"Iran"},country_irq:{en:"Iraq",it:"Iraq",sv:"Irak"},country_isl:{en:"Iceland",it:"Islanda",sv:"Island"},country_isr:{de:"Israel",en:"Israel",es:"Israel",fr:"Israël",it:"Israele",ja:"イスラエル","zh-CN":"以色列","zh-HK":"以色列"},country_ita:{de:"Italien",en:"Italy",es:"Italia",fr:"Italie",it:"Italia",ja:"イタリア",sv:"Italien","zh-CN":"意大利","zh-HK":"意大利"},country_ixx:{de:"Irland, Dublin",en:"Ireland, Dublin",es:"Dublín",fr:"Dublin",it:"Irlanda, Dublino",ja:"アイルランド、ダブリン","zh-CN":"爱尔兰，都柏林","zh-HK":"愛爾蘭，都柏林"},country_jam:{en:"Jamaica",it:"Giamaica"},country_jey:{en:"Jersey",fr:"Jersey",it:"Jersey",ja:"ジャージー","zh-CN":"泽西岛","zh-HK":"澤西島"},country_jor:{de:"Jordanien",en:"Jordan",es:"Jordania",fr:"Jordanie",it:"Giordania",ja:"ヨルダン",sv:"Jordanien","zh-CN":"约旦","zh-HK":"約旦"},country_jpn:{de:"Japan",en:"Japan",es:"Japón",fr:"Japon",it:"Giappone",ja:"日本","zh-CN":"日本","zh-HK":"日本"},country_kaz:{en:"Kazakhstan",it:"Kazakhstan",sv:"Kazakstan"},country_ken:{en:"Kenya",it:"Kenya"},country_kgz:{en:"Kyrgyzstan",it:"Kirghizistan",sv:"Kirgizistan"},country_khm:{en:"Cambodia",it:"Cambogia",sv:"Kambodja"},country_kir:{en:"Kiribati",it:"Kiribati"},country_kna:{en:"Saint Kitts and Nevis",it:"Saint Kitts e Nevis",sv:"Saint Kitts och Nevis"},country_kor:{de:"Südkorea",en:"South Korea",es:"Corea del Sur",fr:"Corée du Sud",it:"Corea del Sud",ja:"韓国",sv:"Sydkorea","zh-CN":"南韩","zh-HK":"南韓"},country_kwt:{en:"Kuwait",it:"Kuwait","zh-CN":"科威特","zh-HK":"科威特"},country_lao:{en:"Laos (People's Democratic Republic)",it:"Laos (Repubblica Popolare Democratica del Laos)",sv:"Laos"},country_lbn:{en:"Lebanon",it:"Libano",sv:"Libanon"},country_lbr:{en:"Liberia",it:"Liberia"},country_lby:{en:"Libya",it:"Libia",sv:"Libyen"},country_lca:{en:"Saint Lucia",it:"Santa Lucia"},country_lie:{en:"Liechtenstein",it:"Liechtenstein",sv:"Lichtenstein"},country_lka:{en:"Sri Lanka",it:"Sri Lanka"},country_lso:{en:"Lesotho",it:"Lesotho"},country_ltu:{en:"Lithuania",it:"Lituania",sv:"Litauen"},country_lux:{de:"Luxemburg",en:"Luxembourg",es:"Luxemburgo",fr:"Luxembourg",it:"Lussemburgo",ja:"ルクセンブルグ",sv:"Luxemburg","zh-CN":"卢森堡","zh-HK":"盧森堡"},country_lva:{de:"Lettland",en:"Latvia",es:"Letonia",fr:"Lettonie",it:"Lettonia",ja:"ラトビア",sv:"Lettland","zh-CN":"拉脱维亚","zh-HK":"拉脫維亞"},country_mac:{en:"Macao",it:"Macao"},country_maf:{en:"Saint Martin (French part)",it:"Saint Martin (parte Francese)",sv:"St Martin"},country_mar:{de:"Marokko",en:"Morocco",es:"Marruecos",fr:"Maroc",it:"Marocco",ja:"モロッコ",sv:"Marocko","zh-CN":"摩洛哥","zh-HK":"摩洛哥"},country_mco:{en:"Monaco",it:"Monaco"},country_mda:{en:"Moldova, Republic of",it:"Moldova",sv:"Moldavien"},country_mdg:{en:"Madagascar",it:"Madagascar",sv:"Madagaskar"},country_mdv:{en:"Maldives",it:"Maldive",sv:"Maldiverna"},country_mex:{de:"Mexiko",en:"Mexico",es:"México",fr:"Mexique",it:"Messico",ja:"メキシコ",sv:"Mexiko","zh-CN":"墨西哥","zh-HK":"墨西哥"},country_mhl:{en:"Marshall Islands",it:"Isole Marshall",sv:"Marshallöarna"},country_mkd:{en:"Macedonia, Rep. of",it:"Repubblica di Macedonia",sv:"Makedonien"},country_mli:{en:"Mali",it:"Mali"},country_mlt:{en:"Malta",it:"Malta"},country_mmr:{en:"Myanmar, Burma",it:"Birmania (Myanmar)",sv:"Burma (Myanmar)"},country_mne:{en:"Montenegro",it:"Montenegro"},country_mng:{en:"Mongolia",it:"Mongolia",sv:"Mongoliet","zh-CN":"蒙古","zh-HK":"蒙古"},country_mnp:{en:"Northern Mariana Islands",it:"Isole Marianne Settentrionali",sv:"Nordmarianerna"},country_moz:{en:"Mozambique",it:"Mozambico",sv:"Mocambique"},country_mrt:{en:"Mauritania",it:"Mauritania",sv:"Mauretanien"},country_msr:{en:"Montserrat",it:"Montserrat"},country_mtq:{en:"Martinique",it:"Martinica"},country_mus:{en:"Mauritius",it:"Mauritius"},country_mwi:{en:"Malawi",it:"Malawi"},country_mys:{de:"Malaysia",en:"Malaysia",es:"Malasia",fr:"Malaisie",it:"Malesia",ja:"マレーシア","zh-CN":"马来西亚","zh-HK":"馬來西亞"},country_myt:{en:"Mayotte",it:"Mayotte"},country_nam:{en:"Namibia",it:"Namibia"},country_ncl:{en:"New Caledonia",it:"Nuova Caledonia",sv:"Nya Kaledonien"},country_ner:{en:"Niger",it:"Niger"},country_nfk:{en:"Norfolk Island",it:"Isola Norfolk",sv:"Norfolkön"},country_nga:{en:"Nigeria",it:"Nigeria"},country_nic:{en:"Nicaragua",it:"Nicaragua"},country_niu:{en:"Niue",it:"Niue"},country_nld:{de:"Niederlande",en:"Netherlands",es:"Holanda",fr:"Pays-Bas",it:"Paesi Bassi (Olanda)",ja:"オランダ",sv:"Nederländerna","zh-CN":"荷兰","zh-HK":"荷蘭"},country_nor:{de:"Norwegen",en:"Norway",es:"Noruega",fr:"Norvège",it:"Norvegia",ja:"ノルウェー",sv:"Norge","zh-CN":"挪威","zh-HK":"挪威"},country_npl:{en:"Nepal",it:"Nepal"},country_nru:{en:"Nauru",it:"Nauru"},country_nzl:{de:"Neuseeland",en:"New Zealand",es:"Nueva Zelanda",fr:"Nouvelle-Zélande",it:"Nuova Zelanda",ja:"ニュージーランド",sv:"Nya Zeeland","zh-CN":"新西兰","zh-HK":"新西蘭"},country_omn:{en:"Oman",it:"Oman","zh-CN":"阿曼","zh-HK":"阿曼"},country_pak:{en:"Pakistan",it:"Pakistan"},country_pan:{de:"Panama",en:"Panama",es:"Panamá",fr:"Panama",it:"Panama",ja:"パナマ","zh-CN":"巴拿马","zh-HK":"巴拿馬"},country_pcn:{en:"Pitcairn Island",it:"Isole Pitcairn",sv:"Pitcairnöarna"},country_per:{en:"Peru",it:"Peru"},country_phl:{de:"Philippinen",en:"Philippines",es:"Filipinas",fr:"Philippines",it:"Filippine",ja:"フィリピン",sv:"Filippinerna","zh-CN":"菲律宾","zh-HK":"菲律賓"},country_plw:{en:"Palau",it:"Palau"},country_png:{en:"Papua New Guinea",it:"Papua Nuova Guinea",sv:"Papua Nya Guinea"},country_pol:{de:"Polen",en:"Poland",es:"Polonia",fr:"Pologne",it:"Polonia",ja:"ポーランド",sv:"Polen","zh-CN":"波兰","zh-HK":"波蘭"},country_pri:{en:"Puerto Rico",it:"Porto Rico"},country_prk:{en:"Korea, Democratic People's Rep. (North Korea)",it:"Repubblica Popolare Democratica di Corea (Corea del Nord)",sv:"Nordkorea"},country_prt:{de:"Portugal",en:"Portugal",es:"Portugal",fr:"Portugal",it:"Portogallo",ja:"ポルトガル","zh-CN":"葡萄牙","zh-HK":"葡萄牙"},country_pry:{en:"Paraguay",it:"Paraguay"},country_pse:{en:"Palestinian territories",it:"Territori palestinesi",sv:"Palestina"},country_pyf:{en:"French Polynesia",it:"Polinesia Francese",sv:"Franska Polynesien"},country_qat:{de:"Katar",en:"Qatar",es:"Qatar",fr:"Qatar",it:"Qatar",ja:"カタール","zh-CN":"卡塔尔","zh-HK":"卡塔爾"},country_reu:{en:"Reunion Island",it:"Riunione (Isola)",sv:"Reunion"},country_rou:{en:"Romania",it:"Romania",sv:"Rumänien"},country_rus:{de:"Russland",en:"Russia",es:"Rusia",fr:"Russie",it:"Russia",ja:"ロシア",sv:"Ryssland","zh-CN":"俄罗斯","zh-HK":"俄羅斯"},country_rwa:{en:"Rwanda",it:"Ruanda"},country_sau:{en:"Saudi Arabia",it:"Arabia Saudita",sv:"Saudiarabien","zh-CN":"沙特阿拉伯","zh-HK":"沙特阿拉伯"},country_sdn:{en:"Sudan",it:"Sudan"},country_sen:{en:"Senegal",it:"Senegal"},country_sgp:{de:"Singapur",en:"Singapore",es:"Singapur",fr:"Singapour",it:"Singapore",ja:"シンガポール","zh-CN":"新加坡","zh-HK":"新加坡"},country_sgs:{en:"South Georgia and South Sandwich Islands",it:"Georgia del Sud e Isole Sandwich Australi",sv:"Sydgeorgien och Södra Sandwichöarna"},country_shn:{en:"Saint Helena",it:"Sant'Elena (isola)",sv:"Sankta Helena"},country_sjm:{en:"Svalbard and Jan Mayen Islands",it:"Svalbard e Jan Mayen",sv:"Svalbard"},country_slb:{en:"Solomon Islands",it:"Isole Salomone",sv:"Salomonöarna"},country_sle:{en:"Sierra Leone",it:"Sierra Leone"},country_slv:{en:"El Salvador",it:"El Salvador"},country_smr:{en:"San Marino",it:"San Marino"},country_som:{en:"Somalia",it:"Somalia"},country_spm:{en:"St. Pierre and Miquelon",it:"St. Pierre e Miquelon",sv:"St. Pierre och Miquelon"},country_srb:{en:"Serbia",it:"Serbia",sv:"Sao Tome och Principe"},country_stp:{en:"Sao Tome and Príncipe",it:"Sao Tomé e Principe",sv:"Surinam"},country_sur:{en:"Suriname",it:"Suriname"},country_svk:{en:"Slovakia (Slovak Republic)",it:"Slovacchia (Repubblica Slovacca)",sv:"Slovakien"},country_svn:{en:"Slovenia",it:"Slovenia",sv:"Slovenien"},country_swe:{de:"Schweden",en:"Sweden",es:"Suecia",fr:"Suède",it:"Svezia",ja:"スウェーデン",sv:"Sverige","zh-CN":"瑞典","zh-HK":"瑞典"},country_swz:{en:"Swaziland",it:"Swaziland"},country_syc:{en:"Seychelles",it:"Seychelles",sv:"Seychellerna"},country_syr:{en:"Syria, Syrian Arab Republic",it:"Siria, Repubblica Araba di Siria",sv:"Syrien"},country_tca:{en:"Turks and Caicos Islands",it:"Isole Turks and Caicos",sv:"Turks- och Caicosöarna"},country_tcd:{en:"Chad",it:"Ciad",sv:"Tchad"},country_tgo:{en:"Togo",it:"Togo"},country_tha:{de:"Thailand",en:"Thailand",es:"Tailandia",fr:"Thaïlande",it:"Thailandia",ja:"タイ","zh-CN":"泰国","zh-HK":"泰國"},country_tjk:{en:"Tajikistan",it:"Tagikistan",sv:"Tadzjikistan"},country_tkl:{en:"Tokelau",it:"Tokelau",sv:"Tokelauöarna"},country_tkm:{en:"Turkmenistan",it:"Turkmenistan"},country_tls:{en:"Timor-Leste (East Timor)",it:"Timor Est",sv:"Östtimor"},country_ton:{en:"Tonga",it:"Tonga"},country_tto:{en:"Trinidad and Tobago",it:"Trinidad e Tobago",sv:"Trinidad och Tobago"},country_tun:{en:"Tunisia",it:"Tunisia",sv:"Tunisien"},country_tur:{de:"Türkei",en:"Turkey",es:"Turquía",fr:"Turquie",it:"Turchia",ja:"トルコ",sv:"Turkiet","zh-CN":"土耳其","zh-HK":"土耳其"},country_tuv:{en:"Tuvalu",it:"Tuvalu"},country_twn:{de:"Taiwan",en:"Taiwan",es:"Taiwán",fr:"Taiwan","fr-CA":"Taïwan",it:"Taiwan",ja:"台湾","zh-CN":"台湾","zh-HK":"台灣"},country_tza:{en:"Tanzania",it:"Tanzania"},country_uga:{en:"Uganda",it:"Uganda"},country_ukr:{de:"Ukraine",en:"Ukraine",es:"Ucrania",fr:"Ukraine",it:"Ucraina",ja:"ウクライナ",sv:"Ukraina","zh-CN":"乌克兰","zh-HK":"烏克蘭"},country_umi:{en:"U.S. Minor Outlying Islands",it:"Isole minori esterne degli Stati Uniti d'America",sv:"USA:s yttre öar"},country_ury:{en:"Uruguay",it:"Uruguay","zh-CN":"乌拉圭","zh-HK":"烏拉圭"},country_usa:{de:"USA",en:"United States",es:"Estados Unidos",fr:"Etats-Unis","fr-CA":"États-Unis",it:"Stati Uniti d'America",ja:"アメリカ",sv:"USA","zh-CN":"美国","zh-HK":"美國"},country_uzb:{en:"Uzbekistan",it:"Uzbekistan"},country_vat:{"da-DK":"Vatikanstaten",de:"Heiliger Stuhl (Vatikanstadt)",en:"Holy See (Vatican City State)",es:"Vaticano",fr:"Etat de la cite du Vatican","fr-CA":"Saint-Siège (Cité du Vatican)",it:"Santa Sede (Città del Vaticano)",ja:"バチカン",sv:"Vatikanstaten","zh-CN":"圣座（梵蒂冈城）","zh-HK":"聖座（梵蒂岡城）"},country_vct:{en:"Saint Vincent and the Grenadines",it:"Saint Vincent e Grenadine",sv:"Saint Vincent och Grenadinerna"},country_ven:{en:"Venezuela",it:"Venezuela"},country_vgb:{"da-DK":"Jomfruøerne (britiske)",de:"Britische Jungferninseln",en:"British Virgin Islands",es:"Islas Vírgenes (Británicas)",fr:"Iles vierges britanniques","fr-CA":"Îles Vierges britanniques",it:"Isole Vergini Britanniche",ja:"英領ヴァージン諸島",sv:"Brittiska Jungfruöarna","zh-CN":"英属维尔京群岛","zh-HK":"英屬維爾京群島"},country_vir:{en:"Virgin Islands (U.S.)",it:"Isole Vergini (USA)",sv:"Amerikanska Jungfruöarna"},country_vnm:{en:"Vietnam",it:"Vietnam","zh-CN":"越南","zh-HK":"越南"},country_vut:{en:"Vanuatu",it:"Vanuatu"},country_wlf:{en:"Wallis and Futuna Islands",it:"Wallis e Futuna",sv:"Wallis och Futunaöarna"},country_wsm:{en:"Samoa",it:"Samoa (Samoa Occidentali)"},country_yem:{en:"Yemen",it:"Yemen",sv:"Jemen"},country_zaf:{"da-DK":"Sydafrika",de:"Südafrika",en:"South Africa",es:"Sudáfrica",fr:"Afrique du sud","fr-CA":"Afrique du Sud",it:"Sud Africa",ja:"南アフリカ",sv:"Jugoslavien","zh-CN":"南非","zh-HK":"南非"},country_zmb:{en:"Zambia",it:"Zambia",sv:"Sydafrika"},country_zwe:{en:"Zimbabwe",it:"Zimbabwe",sv:"Zambia"},creditQuality_A:{"da-DK":"A",en:"A",fr:"A",it:"A",ja:"A","zh-CN":"A","zh-HK":"A"},creditQuality_AA:{"da-DK":"AA",en:"AA",fr:"AA",it:"AA",ja:"AA","zh-CN":"AA","zh-HK":"AA"},creditQuality_AAA:{"da-DK":"AAA",en:"AAA",fr:"AAA",it:"AAA",ja:"AAA","zh-CN":"AAA","zh-HK":"AAA"},creditQuality_B:{"da-DK":"B",en:"B",fr:"B",it:"B",ja:"B","zh-CN":"B","zh-HK":"B"},creditQuality_BB:{"da-DK":"BB",en:"BB",fr:"BB",it:"BB",ja:"BB","zh-CN":"BB","zh-HK":"BB"},creditQuality_BBB:{"da-DK":"BBB",en:"BBB",fr:"BBB",it:"BBB",ja:"BBB","zh-CN":"BBB","zh-HK":"BBB"},creditQuality_belowB:{"da-DK":"Under B",en:"Below B",fr:"Inférieure à B",it:"Inferiore a B",ja:"B未満",sv:"Under B","zh-CN":"低于B","zh-HK":"低於B"},creditQuality_notRated:{"da-DK":"Ikke rated",en:"NR",fr:"Non noté","fr-CA":"Non coté",it:"NR",ja:"格付け無し",sv:"Rating saknas","zh-CN":"NR","zh-HK":"NR"},currency_aud:{da:"Australske Dollar",en:"Australian Dollar",fr:"Dollar australien",it:"Dollaro australiano",ja:"豪ドル",sv:"Australienska dollar","zh-CN":"澳元","zh-HK":"澳元"},currency_brl:{da:"Brasilianske Real",en:"Brazilian Real",fr:"Real brésilien","fr-CA":"Réal brésilien",it:"Real brasiliano",ja:"ブラジルレアル",sv:"Brasilianska real","zh-CN":"巴西雷亚尔","zh-HK":"巴西雷亞爾"},currency_cad:{da:"Canadiske Dollar",en:"Canadian Dollar",fr:"Dollar canadien",it:"Dollaro canadese",ja:"カナダドル",sv:"Kanadensiska dollar","zh-CN":"加拿大元","zh-HK":"加拿大元"},currency_chf:{da:"Schweiziske Francs",de:"Schweizer Franken",en:"Swiss Francs",es:"Francos Suizos",fr:"Franc Suisse","fr-CA":"Franc suisse",it:"Franco svizzero",ja:"スイスフラン",sv:"Schweiziska francs","zh-CN":"瑞士法郎","zh-HK":"瑞士法郎"},currency_clp:{da:"Chilenske Peso",en:"Chilean Peso",fr:"Peso chilien",it:"Peso cileno",ja:"チリペソ",sv:"Chilenska peso","zh-CN":"智利比索","zh-HK":"智利比索"},currency_cnh:{da:"Offshore Kinesisk Yuan",en:"Offshore Chinese Yuan",fr:"Yuan chinois","fr-CA":"Yuan chinois (extérieur)",it:"Offshore Yuan cinese",ja:"オフショア人民元",sv:"Kinesiska yuan (offshore)","zh-CN":"离岸人民币","zh-HK":"離岸人民幣"},currency_cny:{da:"Kinesisk Yuan Renminbi",en:"Chinese Yuan Renminbi",fr:"Yuan renminbi chinois","fr-CA":"Yuan renminbi",it:"Yuan cinese Renminbi",ja:"人民元",sv:"Kinesiska yuan (Renminbi)","zh-CN":"人民币","zh-HK":"人民幣"},currency_czk:{da:"Tjekkiske Koruna",en:"Czech Koruna",fr:"Couronne tchèque",it:"Corona ceca",ja:"チェココルナ",sv:"Tjeckiska kronor","zh-CN":"捷克克朗","zh-HK":"捷克克朗"},currency_dkk:{da:"Danske Kroner",en:"Danish Kronor",fr:"Couronne danoise",it:"Corona danese",ja:"デンマーククローネ",sv:"Danska kronor","zh-CN":"丹麦克朗","zh-HK":"丹麥克朗"},currency_eur:{da:"Euro",en:"Euro",fr:"Euro",it:"Euro",ja:"ユーロ","zh-CN":"欧元","zh-HK":"歐元"},currency_gbp:{da:"Britiske Pund",de:"Englisches Pfund",en:"British Pound",es:"Libras",fr:"Livre Britannique","fr-CA":"Livre sterling",it:"Sterlina",ja:"英ポンド",sv:"Pund","zh-CN":"英镑","zh-HK":"英鎊"},currency_hkd:{da:"Hongkong Dollar",en:"Hong Kong Dollar",fr:"Dollar Hong Kong","fr-CA":"Dollar de Hong Kong",it:"Dollaro Hong Kong",ja:"香港ドル",sv:"Hongkongdollar","zh-CN":"港元","zh-HK":"港元"},currency_huf:{da:"Ungarske Forint",en:"Hungarian Forint",fr:"Forint hongrois","fr-CA":"Florin hongrois",it:"Fiorino ungherese",ja:"ハンガリーフォリント",sv:"Ungerska forint","zh-CN":"匈牙利福林","zh-HK":"匈牙利福林"},currency_ils:{da:"Israelsk Shekel",en:"Israeli Shekel",fr:"Shekel israélien",it:"Shekel israeliano",ja:"イスラエルシュケル",sv:"Israeliska shekel","zh-CN":"以色列谢克尔","zh-HK":"以色列謝克爾"},currency_jpy:{da:"Japanske Yen",de:"Japanischer Yen",en:"Japanese Yen",es:"Yenes",fr:"Yen japonais",it:"Yen giapponese",ja:"日本円",sv:"Japanska yen","zh-CN":"日圆","zh-HK":"日圓"},currency_mxn:{da:"Mexicansk Peso",en:"Mexican Peso",fr:"Peso mexicain",it:"Peso messicano",ja:"メキシコペソ",sv:"Mexikanska pesos","zh-CN":"墨西哥比索","zh-HK":"墨西哥比索"},currency_nok:{da:"Norske Kroner",en:"Norwegian Kronor",fr:"Couronne norvégienne",it:"Corona norvegese",ja:"ノルウェークローネ",sv:"Norska kronor","zh-CN":"挪威克朗","zh-HK":"挪威克朗"},currency_nzd:{da:"New Zealand Dollar",en:"New Zealand Dollar",fr:"Dollar néo-zélandais",it:"Dollaro Neozelandese",ja:"ニュージーランドドル",sv:"Nya Zealand-dollar","zh-CN":"新西兰元","zh-HK":"新西蘭元"},currency_pln:{da:"Polsk Zolty",en:"Polish Zloty",fr:"Zloty polonais",it:"Zloty polacco",ja:"ポーランドズロチ",sv:"Polska zloty","zh-CN":"波兰兹尔兹","zh-HK":"波蘭茲爾茲"},currency_sek:{da:"Svenske Kroner",en:"Swedish Krona",fr:"Couronne suédoise",it:"Corona svedese",ja:"スウェーデンクローナ",sv:"Svenska kronor","zh-CN":"瑞典克朗","zh-HK":"瑞典克朗"},currency_sgd:{da:"Singapore Dollar",de:"Singapur Dollar",en:"Singapore Dollar",es:"Dólar Singapur",fr:"Dollar de Singapour","fr-CA":"Dollar singapourien",it:"Dollaro di Singapore",ja:"シンガポールドル",sv:"Singaporedollar","zh-CN":"新加坡元","zh-HK":"新加坡元"},currency_usd:{da:"Amerikansk Dollar",de:"US Dollar",en:"US Dollar",es:"Dólar US",fr:"Dollar US","fr-CA":"Dollar américain",it:"Dollaro US",ja:"米ドル",sv:"Amerikanska dollar","zh-CN":"美元","zh-HK":"美元"},currency_zar:{da:"Sydafrikanske Rand",en:"South African Rand",fr:"Rand sud-africain",it:"Rand sudafricano",ja:"南アランド",sv:"Sydafrikanska rand","zh-CN":"南非兰德","zh-HK":"南非蘭德"},december:{"da-DK":"December",en:"December",fr:"Décembre",it:"Dicembre",ja:"12月",sv:"december","zh-CN":"十二月","zh-HK":"十二月"},energy:{"da-DK":"Olie og Gas",en:"Energy",es:"Energía",fr:"Énergie",it:"Energia",ja:"エネルギー",sv:"Energi","zh-CN":"能源","zh-HK":"能源"},equityStyleBox_largeBlend:{"da-DK":"Store Blend",en:"Large Blend",es:"Mixto Gran cap.",fr:"Grandes Mixte","fr-CA":"Mixte Grande cap",ja:"大型ブレンド",sv:"Stora mix","zh-CN":"大企业综合基金","zh-HK":"大企業綜合基金"},equityStyleBox_largeCore:{"da-DK":"Store Core",en:"Large Core",es:"Núcleo grande",fr:"Grand noyau",it:"Grande core",ja:"大型コア",sv:"Stora"},equityStyleBox_largeGrowth:{"da-DK":"Store Vækst",en:"Large Growth",es:"Crecim. Gran cap.",fr:"Grandes Croissance","fr-CA":"Croissance Grande cap",ja:"大型成長",sv:"Stora tillväxt","zh-CN":"大企业成长基金","zh-HK":"大企業成長基金"},equityStyleBox_largeValue:{"da-DK":"Store Værdi",en:"Large Value",es:"Valor Gran cap.",fr:"Grandes Valeur","fr-CA":"Valeur Grande cap",ja:"大型割安",sv:"Stora värde","zh-CN":"大企业价值基金","zh-HK":"大企業價值基金"},equityStyleBox_midBlend:{"da-DK":"Ml. Blend",en:"Mid Blend",es:"Mixto Med. cap.",fr:"Moyennes Mixte","fr-CA":"Mixte Moyenne cap",it:"Mid-Cap Blend",ja:"中型ブレンド",sv:"Medelstora mix","zh-CN":"中型混合型","zh-HK":"中型混合型"},equityStyleBox_midCore:{"da-DK":"Ml. Core",en:"Mid Core",ja:"中型コア",sv:"Medel"},equityStyleBox_midGrowth:{"da-DK":"Ml. Vækst",en:"Mid Growth",es:"Crecim. Med. cap.",fr:"Moyennes Croissance","fr-CA":"Croissance Moyenne cap",ja:"中型成長",sv:"Medelstora tillväxt","zh-CN":"中型增长型","zh-HK":"中型增長型"},equityStyleBox_midValue:{"da-DK":"Ml. Værdi",en:"Mid Value",es:"Valor Med. cap.",fr:"Moyennes Petite","fr-CA":"Valeur Moyenne cap",ja:"中型割安",sv:"Medelstora värde","zh-CN":"中型价值型","zh-HK":"中型價值型"},equityStyleBox_smallBlend:{"da-DK":"Små Blend",en:"Small Blend",es:"Mixto Peq. cap",fr:"Petites Mixte","fr-CA":"Mixte Petite cap",ja:"小型ブレンド",sv:"Små mix","zh-CN":"小型混合型","zh-HK":"小型混合型"},equityStyleBox_smallCore:{"da-DK":"Små Core",en:"Small Core",ja:"小型コア",sv:"Små"},equityStyleBox_smallGrowth:{"da-DK":"Små Vækst",en:"Small Growth",es:"Crecim. Peq. cap.",fr:"Petites Croissance","fr-CA":"Croissance Petite cap",ja:"小型成長",sv:"Små tillväxt","zh-CN":"小型增长型","zh-HK":"小型增長型"},equityStyleBox_smallValue:{"da-DK":"Små Værdi",en:"Small Value",es:"Valor Peq. cap.",fr:"Petites Valeur","fr-CA":"Valeur Petite cap",ja:"小型割安",sv:"Små värde","zh-CN":"小型价值型","zh-HK":"小型價值型"},exchange_EX$$$$PINX:{"da-DK":"Pink Sheets LLC (NQB)",en:"Pink Sheets LLC (NQB)",ja:"ピンクシート（NQB）"},exchange_EX$$$$XAMS:{"da-DK":"NYSE Euronext - Euronext Amsterdam",en:"NYSE Euronext - Euronext Amsterdam",ja:"NYSEﾕｰﾛﾈｸｽﾄ - ﾕｰﾛﾈｸｽﾄ・ｱﾑｽﾃﾙﾀﾞﾑ"},exchange_EX$$$$XASE:{"da-DK":"NYSE Amex Equities",en:"NYSE Amex Equities",ja:"NYSE MKT"},exchange_EX$$$$XASX:{"da-DK":"Australian Securities Exchange Ltd",en:"Australian Securities Exchange Ltd",ja:"オーストラリア証券取引所"},exchange_EX$$$$XBRU:{"da-DK":"NYSE Euronext - Euronext  Brussels",en:"NYSE Euronext - Euronext  Brussels",ja:"NYSEﾕｰﾛﾈｸｽﾄ - ﾕｰﾛﾈｸｽﾄ・ﾌﾞﾘｭｯｾﾙ"},exchange_EX$$$$XCSE:{"da-DK":"OMX Nordic Exchange Copenhagen A/S",en:"OMX Nordic Exchange Copenhagen A/S",ja:"OMXﾉﾙﾃﾞｨｯｸ取引所ｺﾍﾟﾝﾊｰｹﾞﾝ"},exchange_EX$$$$XDUB:{"da-DK":"Irish Stock Exchange - Main Securities Market",en:"Irish Stock Exchange - Main Securities Market",ja:"アイルランド証券取引所"},exchange_EX$$$$XETR:{"da-DK":"XETRA",en:"XETRA",ja:"XETRA"},exchange_EX$$$$XHEL:{"da-DK":"OMX Nordic Exchange Helsinki OY",en:"OMX Nordic Exchange Helsinki OY",ja:"OMXﾉﾙﾃﾞｨｯｸ取引所ﾍﾙｼﾝｷ"},exchange_EX$$$$XHKG:{"da-DK":"Stock Exchange Of Hong Kong Ltd",en:"Stock Exchange Of Hong Kong Ltd",ja:"香港証券取引所"},exchange_EX$$$$XIST:{"da-DK":"Istanbul Stock Exchange",en:"Istanbul Stock Exchange",ja:"イスタンブ－ル証券取引所"},exchange_EX$$$$XJSE:{"da-DK":"JSE Securities Exchange",en:"JSE Securities Exchange",ja:"ヨハネスブルグ証券取引所"},exchange_EX$$$$XKLS:{"da-DK":"Bursa Malaysia",en:"Bursa Malaysia",ja:"マレーシア証券取引所"},exchange_EX$$$$XLIS:{"da-DK":"NYSE Euronext - Euronext Lisbon",en:"NYSE Euronext - Euronext Lisbon",ja:"NYSEﾕｰﾛﾈｸｽﾄ - ﾕｰﾛﾈｸｽﾄ・ﾘｽﾎﾞﾝ"},exchange_EX$$$$XLON:{"da-DK":"London Stock Exchange",en:"London Stock Exchange",ja:"ロンドン証券取引所"},exchange_EX$$$$XMCE:{"da-DK":"Mercado Continuo Espanol",en:"Mercado Continuo Espanol",ja:"スペイン証券取引所"},exchange_EX$$$$XMIL:{"da-DK":"Borsa Italiana S.P.A.",en:"Borsa Italiana S.P.A.",ja:"イタリア証券取引所"},exchange_EX$$$$XNAS:{"da-DK":"NASDAQ",en:"NASDAQ",ja:"NASDAQ"},exchange_EX$$$$XNYS:{"da-DK":"New York Stock Exchange, Inc.",en:"New York Stock Exchange, Inc.",ja:"ニューヨーク証券取引所"},exchange_EX$$$$XNZE:{"da-DK":"New Zealand Exchange Ltd",en:"New Zealand Exchange Ltd",ja:"ニュージーランド証券取引所"},exchange_EX$$$$XOSL:{"da-DK":"Oslo Bors Asa",en:"Oslo Bors Asa",ja:"オスロ証券取引所"},exchange_EX$$$$XOTC:{"da-DK":"OTC Bulletin Board",en:"OTC Bulletin Board",ja:"OTCブリティンボード"},exchange_EX$$$$XPAR:{"da-DK":"NYSE Euronext - Euronext Paris",en:"NYSE Euronext - Euronext Paris",ja:"NYSEﾕｰﾛﾈｸｽﾄ - ﾕｰﾛﾈｸｽﾄ・ﾊﾟﾘ"},exchange_EX$$$$XSES:{"da-DK":"Singapore Exchange",en:"Singapore Exchange",ja:"シンガポール証券取引所"},exchange_EX$$$$XSTO:{"da-DK":"OMX Nordic Exchange Stockholm AB",en:"OMX Nordic Exchange Stockholm AB",ja:"OMXﾉﾙﾃﾞｨｯｸ取引所ｽﾄｯｸﾎﾙﾑ"},exchange_EX$$$$XSWX:{"da-DK":"Swiss Exchange",en:"Swiss Exchange",ja:"スイス証券取引所"},exchange_EX$$$$XTKS:{"da-DK":"Tokyo Stock Exchange",en:"Tokyo Stock Exchange",ja:"東京証券取引所"},exchange_EX$$$$XTSE:{"da-DK":"Toronto Stock Exchange",en:"Toronto Stock Exchange",ja:"トロント証券取引所"},exchange_EX$$$$XTSX:{"da-DK":"TSX Venture Exchange",en:"TSX Venture Exchange",ja:"TSXベンチャー取引所"},exchange_EX$$$$XWBO:{"da-DK":"Wiener Boerse AG",en:"Wiener Boerse AG",ja:"ウィーン証券取引所",sv:"Wienbörsen"},february:{"da-DK":"Februar",en:"February",fr:"Février",it:"Febbraio",ja:"2月",sv:"februari","zh-CN":"二月","zh-HK":"二月"},financialServices:{"da-DK":"Finans",en:"Financial Svs",es:"Servicios financieros",fr:"Services financiers",it:"Serv. finanziari",ja:"金融サービス",sv:"Finansiella tjänster","zh-CN":"金融服务","zh-HK":"金融服務"},healthcare:{"da-DK":"Sundhed",en:"Healthcare",es:"Cuidado de la salud",fr:"Soins de la santé",it:"Salute",ja:"ヘルスケア",sv:"Sjukvård","zh-CN":"医疗保健","zh-HK":"醫療保健"},industrials:{"da-DK":"Industri",en:"Industrials",es:"Acciones industriales",fr:"Valeurs industrielles",it:"Industria",ja:"資本財",sv:"Industri","zh-CN":"工业","zh-HK":"工業"},january:{"da-DK":"Januar",en:"January",fr:"Janvier",it:"Gennaio",ja:"1月",sv:"januari","zh-CN":"一月","zh-HK":"一月"},july:{"da-DK":"Juli",en:"July",fr:"Juillet",it:"Luglio",ja:"7月",sv:"juli","zh-CN":"七月","zh-HK":"七月"},june:{"da-DK":"Juni",en:"June",fr:"Juin",it:"Giugno",ja:"6月",sv:"juni","zh-CN":"六月","zh-HK":"六月"},march:{"da-DK":"Marts",en:"March",fr:"Mars",it:"Marzo",ja:"3月",sv:"mars","zh-CN":"三月","zh-HK":"三月"},may:{"da-DK":"Maj",en:"May",fr:"Mai",it:"Maggio",ja:"5月",sv:"maj","zh-CN":"五月","zh-HK":"五月"},millions:{en:"m",fr:"m",ja:"百万","zh-CN":"百万","zh-HK":"百萬"},november:{"da-DK":"November",en:"November",fr:"Novembre",it:"Novembre",ja:"11月",sv:"november","zh-CN":"十一月","zh-HK":"十一月"},october:{"da-DK":"Oktober",en:"October",fr:"Octobre",it:"Ottobre",ja:"10月",sv:"oktober","zh-CN":"十月","zh-HK":"十月"},realEstate:{"da-DK":"Ejendomme",en:"Real Estate",es:"Bienes raíces",fr:"Immobilier",it:"Immobiliare",ja:"不動産",sv:"Fastigheter","zh-CN":"房地产","zh-HK":"房地產"},september:{"da-DK":"September",en:"September",fr:"Septembre",it:"Settembre",ja:"9月",sv:"september","zh-CN":"九月","zh-HK":"九月"},sustainabilityRating_1:{"da-DK":"1 Globus eller flere",en:"1 Globe or more",it:"1 globo o più",ja:"1グローブ以上",sv:"1 glob eller mer"},sustainabilityRating_2:{"da-DK":"2 Globusser eller flere",en:"2 Globes or more",it:"2 globi o più",ja:"2グローブ以上",sv:"2 glober eller fler"},sustainabilityRating_3:{"da-DK":"3 Globusser eller flere",en:"3 Globes or more",it:"3 globi o più",ja:"3グローブ以上",sv:"3 glober eller fler"},sustainabilityRating_4:{"da-DK":"4 Globusser eller flere",en:"4 Globes or more",it:"4 globi o più",ja:"4グローブ以上",sv:"4 gloder eller fler"},sustainabilityRating_5:{"da-DK":"5 Globusser",en:"5 Globes",it:"5 globi",ja:"5グローブ以上",sv:"5 glober"},technology:{"da-DK":"Teknologi",en:"Technology",es:"Tecnología",fr:"Technologie",it:"Tecnologia",ja:"テクノロジー",sv:"Teknik","zh-CN":"科技","zh-HK":"科技"},thousands:{en:"k",fr:"k",ja:"千","zh-CN":"千","zh-HK":"千"},trillions:{en:"t",fr:"t",ja:"兆","zh-CN":"万亿","zh-HK":"萬億"},utilities:{"da-DK":"Forsyning",en:"Utilities",es:"Utilidades",fr:"Services publics",ja:"公益",sv:"Allmännyttigt","zh-CN":"公用事业","zh-HK":"公用事業"}}},function(e,t){e.exports={__env:{dev:{baseUrlApiGatewayEU:"00103-uat.eci0254d.eas.morningstar.com",baseUrlApiGatewayUS:"www.us-qa-api.morningstar.com",baseUrlMorningstarEU:"eultrcqa.morningstar.com",baseUrlMorningstarUS:"api-qa.morningstar.com",baseUrlPdfServiceEU:"ecsvcs-qa.morningstar.com",baseUrlQuoteSpeed:"markets-uat.morningstar.com",baseUrlQuoteSpeedPull:"markets-uat.morningstar.com"},qa:{baseUrlApiGatewayEU:"00103-uat.eci0254d.eas.morningstar.com",baseUrlApiGatewayUS:"www.us-qa-api.morningstar.com",baseUrlMorningstarEU:"eultrcqa.morningstar.com",baseUrlMorningstarUS:"api-qa.morningstar.com",baseUrlPdfServiceEU:"ecsvcs-qa.morningstar.com",baseUrlQuoteSpeed:"markets-uat.morningstar.com",baseUrlQuoteSpeedPull:"markets-uat.morningstar.com"},uat:{baseUrlApiGatewayEU:"www.emea-uat-api.morningstar.com",baseUrlApiGatewayUS:"www.us-uat-api.morningstar.com",baseUrlMorningstarEU:"eultrcqa.morningstar.com",baseUrlMorningstarUS:"api-uat.morningstar.com",baseUrlPdfServiceEU:"ecsvcs-qa.morningstar.com",baseUrlQuoteSpeed:"markets-uat.morningstar.com",baseUrlQuoteSpeedPull:"markets-uat.morningstar.com"},stage:{baseUrlApiGatewayEU:"www.emea-uat-api.morningstar.com",baseUrlApiGatewayUS:"www.us-stg-api.morningstar.com",baseUrlMorningstarEU:"ltqa.morningstar.com",baseUrlMorningstarUS:"api-stg.morningstar.com",baseUrlPdfServiceEU:"ecsvcs-qa.morningstar.com",baseUrlQuoteSpeed:"markets-uat.morningstar.com",baseUrlQuoteSpeedPull:"markets-uat.morningstar.com"},production:{baseUrlApiGatewayEU:"www.emea-api.morningstar.com",baseUrlApiGatewayUS:"www.us-api.morningstar.com",baseUrlMorningstarEU:"lt.morningstar.com",baseUrlMorningstarUS:"api.morningstar.com",baseUrlPdfServiceEU:"ecsvcs.morningstar.com",baseUrlQuoteSpeed:"quotespeed.morningstar.com",baseUrlQuoteSpeedPull:"pullqs.morningstar.com"}},languageId:"en-GB",currencyId:"GBP",format:{nullString:"–",any:{dataType:"any",number:{dataType:"number",style:"decimal",useGrouping:!0,minimumFractionDigits:0,maximumFractionDigits:2,abbreviate:{},nullString:"–"},date:{dataType:"date",year:"numeric",month:"numeric",day:"numeric",nullString:"–"},nullString:"–"},number:{dataType:"number",style:"decimal",useGrouping:!0,minimumFractionDigits:0,maximumFractionDigits:2,abbreviate:{},nullString:"–"},date:{dataType:"date",year:"numeric",month:"numeric",day:"numeric",nullString:"–"}},formatAliases:{defaultAny:{dataType:"any",number:"shortDecimal",date:"yyyy-mm-dd"},standardDecimal:{dataType:"number",minimumFractionDigits:0,maximumFractionDigits:2},integer:{dataType:"number",minimumFractionDigits:0,maximumFractionDigits:0},shortDecimal:{dataType:"number",minimumFractionDigits:2,maximumFractionDigits:2},longDecimal:{dataType:"number",minimumFractionDigits:3,maximumFractionDigits:3},currencyDecimal:{currencyDisplay:"symbol",dataType:"number",style:"currency",minimumFractionDigits:2,maximumFractionDigits:2},thousandsDecimal:{dataType:"number",abbreviate:{abbreviations:{thousands:"K"},mode:"thousands"},minimumFractionDigits:2,maximumFractionDigits:2},"hh:mm":{dataType:"date",hour:"numeric",minute:"numeric"},mm:{dataType:"date",month:"short"},"yyyy-mm-dd":{dataType:"date",year:"numeric",month:"numeric",day:"numeric"},"yyyy-mmmm-dd":{dataType:"date",year:"numeric",month:"long",day:"numeric"},"yyyy-mmm-dd":{dataType:"date",year:"numeric",month:"short",day:"numeric"},"yyyy-mmm-dd-hh-mm":{dataType:"date",year:"numeric",month:"short",day:"numeric",hour:"numeric",minute:"numeric"},"yy-mmm-dd":{dataType:"date",year:"2-digit",month:"short",day:"numeric"}},freezeConfig:null,colors:null,colorPaletteName:"charts",colorPalettes:{areaChart:["#000","#333","#666","#999","#CCC","#EEE"],assetAllocations:["#000","#333","#666","#999","#CCC","#EEE"],charts:["#000","#333","#666","#999","#CCC","#EEE"],fixedIncomeStyleBox:["#000","#333","#666","#999","#CCC","#EEE"],lineChart:["#000","#333","#666","#999","#CCC","#EEE"],pieChart:["#000","#333","#666","#999","#CCC","#EEE"],stockStyleBox:["#000","#333","#666","#999","#CCC","#EEE"]},fieldDefinitions:{categoryId:{requiredFields:[]},categoryName:{requiredFields:[]},closePrice:{requiredFields:[],format:"shortDecimal"},debtEquityRatio:{requiredFields:[],format:"longDecimal"},dividendYield:{requiredFields:[],format:"longDecimal"},epsGrowth5Y:{requiredFields:[],format:"shortDecimal"},expenseRatio:{requiredFields:[],format:"standardDecimal"},industryName:{requiredFields:[]},name:{requiredFields:[]},marketCap:{requiredFields:[],format:{dataType:"number",style:"decimal",abbreviate:{mode:"auto"}}},priceBookRatio:{requiredFields:[],format:"standardDecimal"},priceCurrency:{requiredFields:[]},priceEarningsRatio:{requiredFields:[],format:"standardDecimal"},priceSalesRatio:{requiredFields:[],format:"standardDecimal"},rating:{requiredFields:[]},returnD1:{requiredFields:[],format:"shortDecimal"},returnW1:{requiredFields:[],format:"shortDecimal"},returnM0:{requiredFields:[],format:"shortDecimal"},returnM1:{requiredFields:[],format:"shortDecimal"},returnM3:{requiredFields:[],format:"shortDecimal"},returnM6:{requiredFields:[],format:"shortDecimal"},returnM12:{requiredFields:[],format:"shortDecimal"},returnM36:{requiredFields:[],format:"shortDecimal"},returnM60:{requiredFields:[],format:"shortDecimal"},returnM120:{requiredFields:[],format:"shortDecimal"},revenueGrowth3Y:{requiredFields:[],format:"shortDecimal"},roettm:{requiredFields:[],format:"longDecimal"},salesYield:{requiredFields:[],format:"longDecimal"},sectorName:{requiredFields:[]}},useCalculatedWidth:null,viewBreakpoints:{small:640,medium:1024,large:1440,xlarge:1920}}},function(e,t){e.exports=function(){throw new Error("define cannot be used indirect")}},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}}]);
//# sourceMappingURL=asterix-core.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {!function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="build/",e(e.s=41)}([function(t,e){t.exports=morningstar},function(t,e){t.exports=_},function(t,e){t.exports=angular},function(t,e){t.exports=jQuery},function(t,e,n){"use strict";var r,i;r=[n(0),n(3),n(1)],void 0!==(i=function(t,e,n){angular.module("mstarCore").factory("mstarComponentSharedStorage",function(){return{components:{}}}).config(["$locationProvider",function(t){t.html5Mode({requireBase:e("base").length>0})}]).directive("mstarComponentId",["$parse","$compile","$interpolate","$filter","$rootScope","$q","$location","$timeout","$interval","mstarTemplate","mstarModelBinder","mstarDebounce","mstarComponent",function(e,r,i,a,o,s,l,u,c,p,d,f,g){return{restrict:"A",controller:["$scope","$element","$attrs",function(r,a,o){function s(n,r,i){return n=n||{},i=i||function(t){return n[t]},{get:function(a,o){if(!a)return n;if(t.asterix.util.isString(a)&&a.indexOf(" ")>=0)return a;if(b[r]&&b[r].hasOwnProperty(a))return b[r][a];var s=e(a)(n);return angular.isUndefined(s)?o||(!C[a]&&isNaN(a)&&h.getLogger().warn("(mstarComponent) Missing "+r+" key ("+x.getComponentId()+", "+a+")"),C[a]=!0,i(a)):s},contains:function(t){var r=null;if(t&&t.indexOf(" ")>=0)return!1;try{r=e(t)(n)}catch(t){return!1}return!angular.isUndefined(r)}}}var u,c,m,h,v,y,x=this,_=[],C={},b={};this.addUnregisterCallback=function(t){_.push(t)},this.addUnregisterCallbacks=function(e){t.asterix.util.isArray(e)&&t.asterix.util.each(e,function(t){_.push(t)})},this.getUnregisterCallbacks=function(){return _},this.getOwnComponentId=function(){return i(o.mstarComponentId)(r)},this.getClosestNonContainerController=function(){var t=a.parent(),e=t.controller("mstarComponentId");return h.getLogger().debug("mstarComponent.getClosestNonContainerController()",e),this.isContainerType()?e&&e.getClosestNonContainerController?e.getClosestNonContainerController():null:this},this.isContainerType=function(){return-1!==t.asterix.meta.findTypesWhere("skipInFullIdentifier",!0).indexOf(this.getComponentType())},this.getComponentId=function(){if(v)return v;var e=t.asterix.meta.findTypesWhere("skipInFullIdentifier",!0),n=a.parent(),r=this.getOwnComponentId(),i=n.controller("mstarComponentId"),o=i&&i.getComponentId?i.getComponentId():null;return o&&(o=-1!==e.indexOf(i.getComponentType())?o.substring(0,o.lastIndexOf(".")):o),v=(o?o+".":"")+r},this.getSettings=function(){return u||s(this.getComponentInstance().getSettings(),"settings")},this.setSettingOverride=function(t,e){b.settings=b.settings||{},b.settings[t]=e},this.getLabels=function(){return m||s(this.getComponentInstance().getLabels(),"labels",function(t){return t})},this.getComponentType=function(){return t.asterix.config.getComponentType(this.getComponentId())},this.getComponentTypePath=function(){if(y)return y;var t=a.parent(),e=this.getComponentType(),n=t.controller("mstarComponentId"),r=n&&n.getComponentTypePath?n.getComponentTypePath():null;return y=(r?r+".":"")+e},this.getFormatter=function(){return this.getComponentInstance().getFormatter()},this.getValidator=function(){return c||t.asterix.validation.getValidator(u.get("_validation",{}))},this.getModel=function(){return this.getComponentInstance().getModel()},this.getParameters=function(){return this.getComponentInstance().getParameters()},this.getDefaultColorPalette=function(){return this.getComponentInstance().getDefaultColorPalette()};var P=!1;this.getComponentInstance=function(){if(!P&&t.asterix.config.canAddModulePathDynamically(this.getComponentId())&&!t.asterix.config.hasInstance(this.getComponentId())){var e=t.asterix.util.string.camelCase(a.get(0).tagName);t.asterix.config.hasType(e)||(e=n.chain(g.getSelectorTypeMappings()).filter(function(t){return a.is(t.selector)}).pluck("type").first().value());var i={};n.chain(o).map(function(t,e){return{key:e,value:t}}).filter(function(t){return 0===t.key.indexOf("setting")}).each(function(e){n.isString(e.key)&&(e.key=t.asterix.util.string.camelCase(e.key.replace("setting",""))),i[e.key]=r.$eval(e.value)}),t.asterix.instanceRegistry.register(this.getComponentId(),{type:e,instanceConfig:{settings:i}}),P=!0}return h||t.asterix.instanceRegistry.get(this.getComponentId())},this.hasPreCompiled=function(t){var e=this.getComponentInstance();return e._preCompiledTemplates&&e._preCompiledTemplates.indexOf(t)>=0},this.compileTemplate=function(t,e,n){if(h.getLogger().debug("mstarComponent.compileTemplate()",e,n),!this.hasPreCompiled(e)){n=n||{};var r=u.contains(e)?u.get(e):null;if(n.template=r||n.template,!n.template)return;p.compile(t,a,n)}},this._twoWayBindParameters=function(t,e,n){e.refPath||h.getLogger().fatal(new Error("Trying to create a two-way binding to a parameter without a path."));t.$watch("parameters"+(e.source.path?"."+e.source.path:null),f(function(t,n){if(e.instance.getParameter(e.refPath)==t)return void e.instance.trigger("parameterChanged",[t,e.refPath]);e.instance.setParameter(e.refPath,t)},10),!0),_.push(e.listen(function(r){if(n(t.parameters)==r)return void t.$evalAsync();t.$evalAsync(function(){e.setScopeParameter(r)})}))},this._oneWayBindModelToParameter=function(t,e,n){_.push(e.listen(function(r){if(!angular.isUndefined(r))return n(t.parameters)==r?void t.$evalAsync():void t.$evalAsync(function(){e.setScopeParameter(r)})}))},this._evaluateParameters=function(n,r){var i,a=this,o=new t.asterix.ConfigEvaluator(this.getComponentId(),t.asterix.instanceRegistry,t.asterix.context);try{i=o.evaluate(r,{parameters:!0,model:!0,tokens:!0})}catch(t){return void h.getLogger().debug("(mstarComponent) one of these parameter bindings failed to map: "+JSON.stringify(r)+" ("+a.getComponentId()+")")}return r=i.evaluated,t.asterix.util.each(i.references,function(t,r){t.refPath||h.getLogger().fatal(new Error("Expected refPath"));var i=e(t.source.path);t.setScopeParameter=function(t){i.assign(n.parameters,t)},t.setScopeParameter(t),"parameters"===t.type?a._twoWayBindParameters(n,t,i):"model"===t.type&&a._oneWayBindModelToParameter(n,t,i)}),r},this._bindParametersToUrl=function(e,r){var i=[];if(t.asterix.util.each(r,function(r,a){function o(t){return n.find(l.search(),function(e,n){return t.toLowerCase()==n.toLowerCase()})}function s(t,n){if(t!==n.valueJson){n.valueJson=t;var r=t;try{r=angular.fromJson(t)}catch(t){}e.$evalAsync(function(){n.v.parsed.assign(e.parameters,r)})}}function u(){var n=o(r.url.key);try{var i=angular.fromJson(n);!t.asterix.util.isArray(i)&&t.asterix.util.isObject(i)&&(n=angular.copy(e.settings.get(r.url.key)),t.asterix.util.each(i,function(t,e){n[e]=t}))}catch(t){}s(n,c)}if(r.hasOwnProperty("url")&&null!=r.url){r.url=r.url||{},r.url.key=r.url.key||r.path;var c={key:r.url.key,v:r},p=o(r.url.key);e.$evalAsync(function(){s(p,c)}),i.push(c),e.$on("$locationChangeSuccess",u)}}),i.length){var a="["+n.chain(i).map(function(t){return"parameters"+(t.v.path?"."+t.v.path:null)}).value().join(",")+"]";e.$watch(a,f(function(r){var a=l.search();n.each(r,function(e,o){var s=i[o];if("null"!==r[o]){if(t.asterix.util.isObject(r[o])){var l={};n.each(r[o],function(e,r){if(!(!e||"null"===e||e.id&&"null"===e.id||t.asterix.util.isArray(e)&&!e.length)){if(t.asterix.util.isArray(e)){var i=[];t.asterix.util.each(e,function(e){t.asterix.util.isObject(e)&&e.hasOwnProperty("id")&&i.push(n.pick(e,"id"))}),e=i.length?i:e}l[r]=t.asterix.util.isArray(e)?e:t.asterix.util.isObject(e)?{id:e.id}:e}}),r[o]=l}s.valueJson=angular.toJson(r[o]),a[s.v.url.key]=t.asterix.util.isObject(r[o])||t.asterix.util.isArray(r[o])?s.valueJson:r[o]}}),e.$evalAsync(function(){l.search(a)})},500),!0)}},this.bindParameters=function(n){var r=this,i=u.contains("_parameters")?t.asterix.util.merge({},u.get("_parameters")||{}):{},a={};t.asterix.util.each(i,function(t,n){i[n]=t=t||{},n=t.path=t.path||n,t.parsed=e(n),t.parsed.assign(a,t.binding),t.hasOwnProperty("binding")&&t.hasOwnProperty("url")&&null!==t.url&&h.getLogger().fatal(new Error("(mstarComponent) Can't create a parameter with both a binding and a url binding ("+r.getComponentId()+", "+t.path+")"))});var o=this._evaluateParameters(n,a),s={};t.asterix.util.each(i,function(e,n){if(n=e.path||n,u.contains(n)){var r=u.get(n);t.asterix.util.isPlainObject(r)?r=t.asterix.util.merge({},r):t.asterix.util.isArray(r)&&(r=t.asterix.util.merge([],r)),null!=r&&e.parsed.assign(s,r)}}),h.getLogger().debug("mstarComponent.bindParameters()",{_parameters:i,settingsToParameters:s,scopeParameters:n.parameters,instanceParameters:h.getParameters(),boundParameters:o}),a=t.asterix.extend(!0,{},n.parameters,s,h.getParameters(),o),n.parameters=a,h.setParameters(a),this._bindParametersToUrl(n,i);var l=!1;n.$watch("parameters",function(t,e){l=!0,h.setParameters(t),l=!1},!0),_.push(h.on("parametersChanged",function(t){!0!==l&&n.$evalAsync(function(){n.parameters=t})})),_.push(h.on("parameterChanged",function(t,r){if(!0!==l){var i=e(r);n.$evalAsync(function(){i.assign(n.parameters,t)})}}))};var w=!1;this.bindValue=function(n,r){if(!w){w=!0;var i,a=!1;r=r||"ngModel";var o=function(){return i(n)};if(t.asterix.util.isArray(r)&&r.length>1){var s=[];t.asterix.util.each(r,function(t,n){s.push(e(t))}),o=function(){var e=[];return t.asterix.util.each(r,function(t,r){e.push(s[r](n))}),e},function(e){a=!0,t.asterix.util.each(s,function(t,r){t.assign(n,e[r])}),a=!1}}i=e(r),h.setValue(o()),n.$watch(function(){return o()},function(t){!0!==a&&h.setValue(t)},!0),h.getLogger().debug("mstarComponent.bindValue()",h.getValue())}};var S=!1;this.bindModel=function(e){if(!S){S=!0;var n=h.getModel();n&&!t.asterix.util.isPlainObject(n)||(t.asterix.util.isPlainObject(e.model)?n=t.asterix.extend(!0,e.model,h.getModel()):e.model&&(n=e.model)),e.model=n,h.setModel(n),_.push(h.on("modelChanged",function(t){e.$evalAsync(function(){e.model=t})})),h.getLogger().debug("mstarComponent.bindModel()",n)}};var T=!1;this.bindModelValue=function(e,n){if(!T){T=!0,e.model=e.model||{};var r=h.getModelProperty("value");r&&!t.asterix.util.isPlainObject(r)||(t.asterix.util.isPlainObject(e[n])?r=t.asterix.extend(!0,e[n]||{},r):e[n]&&(r=e[n])),e.model.value=e[n]=r,h.setModelProperty("value",r),_.push(h.on("modelPropertyChanged:value",function(t){e.$evalAsync(function(){e[n]=t,e.model.value=t})})),e.$watch(n,function(t){h.setModelProperty("value",t)},!0),e.$watch("model.value",function(t){h.setModelProperty("value",t)},!0),h.getLogger().debug("mstarComponent.bindModelValue()",n,r)}},this.bindModelData=function(t,e){function n(e){t.model=e||t.model}var r=this;e=e||{};var i=this.getComponentInstance(),a=this.getSettings().contains("_model")?this.getSettings().get("_model"):null;if(t.model={},a){var o=d.get(t,this.getComponentId(),a,e);o.bind(),i.hasListener("dataLoaded")?t.$watch(function(){return o.getPromisesCount()},function(e,i){0===e&&i>0&&r.trigger("dataLoaded",[t.model,n])}):n()}else this.trigger("dataLoaded",[t.model,n]).or(function(){n()});this.bindModel(t)},this.bindConfig=function(e){e.settings=this.getSettings(),e.labels=this.getLabels(),e.format=this.getFormatter(),e.templates=e.settings.contains("_templates")?e.settings.get("_templates"):{},e.instance=this.getComponentInstance(),e.logger=h.getLogger(),e.tracer=h.getTracer(),e.usageTracker=h.getUsageTracker();var n=this.getOwnComponentId();"mstar-"!==n.substring(0,6)&&(n="mstar-"+n),a.addClass(t.asterix.util.css.namespaceSelector(n)),a.addClass(t.asterix.util.css.namespaceSelector(this.getComponentType())),a.addClass("ec-component");var r=this;e.log=function(t){h.getLogger().info(t)},e.namespaceClass=function(e){return t.asterix.ng.util.namespaceClass(r.getSettings().contains("namespaceClass")?r.getSettings().get("namespaceClass"):null,e)},e.namespaceId=function(e){return t.asterix.ng.util.namespaceId(r.getComponentId(),e)},e.times=function(t){return"number"!=typeof t||isNaN(t)||t===1/0?[]:new Array(t)},h.getLogger().debug("mstarComponent.bindConfig()",{settings:e.settings,labels:e.labels,format:e.format,templates:e.templates})},this.trigger=function(){return this.getComponentInstance().trigger.apply(this.getComponentInstance(),arguments)},u=this.getSettings(),m=this.getLabels(),this.getFormatter(),c=this.getValidator(),h=this.getComponentInstance()}],link:function(e,r,i,a){var o=r.controller("mstarComponentId"),s=o.getComponentInstance();s.isActive||(s.activate(),e.$on("$destroy",function(){n.each(o.getUnregisterCallbacks(),function(t){t()}),s.resetModel(),s.deactivate()}),e.$index&&e.$watch("$index",function(t){s.setModelProperty("index",t)}));var l=t.asterix.meta.get(s.getModuleType(),"usageTracking");if(l&&l.componentLoad&&l.componentLoad.endsWhen){var u=window.performance&&window.performance.timing?window.performance.timing.fetchStart:null;if(!u)return;var p=function(){var t=(new Date).getTime(),e={startTime:u,endTime:t,elapsedTime:t-u};s.trigger("loaded",[e]),s.getUsageTracker().trackHit({type:"timing",action:"Component loaded",value:e})};switch(l.componentLoad.endsWhen){case"dataLoaded":var d=s.on("dataLoaded",function(){p(),d()});o.addUnregisterCallback(d);break;case"directiveEnds":p();break;case"elementRendered":l.componentLoad.dependentModelProperty&&l.componentLoad.modelPropertyPathToCheck&&l.componentLoad.elementSelector||s.getLogger().warn("mstarComponent.linkFn.componentLoadCheck",'dependentModelProperty, modelPropertyPathToCheck & elementSelector are required when componentLoad.endsWhen is "elementRendered"',l.componentLoad);var d=s.on("modelPropertyChanged:"+l.componentLoad.dependentModelProperty,function(e){if(e&&!e._$isLoading){var n=(new Date).getTime();s.getLogger().debug("mstarComponent.linkFn.componentLoadCheck",l.componentLoad.dependentModelProperty+" model loaded in "+(n-u)+" milliseconds after request fetch started");var i,a=t.asterix.util.parse(l.componentLoad.modelPropertyPathToCheck)(e),o=(new Date).getTime(),f=c(function(){s.getLogger().debug("mstarComponent.linkFn.componentLoadCheck","Interval for element-rendered ran after "+((new Date).getTime()-o)+" milliseconds"),o=(new Date).getTime(),i&&i.length||(i=r.find(l.componentLoad.elementSelector)),i.length&&i[0].innerHTML.trim()===a&&(s.getLogger().debug("mstarComponent.linkFn.componentLoadCheck","Element-rendered completed in "+((new Date).getTime()-n)+" milliseconds after model property loaded"),c.cancel(f),d(),p())},l.componentLoad.intervalDelay||100,l.componentLoad.intervalCount||50)}});o.addUnregisterCallback(d);break;default:s.getLogger().warn("mstarComponent.linkFn",'Unknown identifier "'+l.componentLoad.endsWhen+'" for usageTrackingMeta.componentLoad.endsWhen')}}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(3),n(1)],void 0!==(i=function(t,e,n){angular.module("mstarCore").directive("mstarDrag",["mstarDragDrop",function(t){function e(e,n,r){t.drag(e,n,r.mstarDrag)}return{restrict:"A",link:e}}]).directive("mstarDrop",["mstarDragDrop",function(t){function e(e,n,r){t.drop(e,n,r.mstarDrop)}return{restrict:"A",link:e}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(t,e){t.module("mstarCore").directive("mstarInclude",["mstarTemplate","$parse",function(t,n){function r(e,r,i){var a=!!i.useParentScope&&n(i.useParentScope)(e),o=this._hasPreCompiled&&!a||!1;!0!==o&&e.$watch(i.mstarInclude,function(n){if(!o&&n){var s=e.$parent&&a?e.$parent:e;e.$evalAsync(function(){t.compile(s,r,{template:n,keepRootElement:"true"!==i.removeRoot})}),o=!0}})}return{restrict:"A",scope:!1,compile:function(t,n){var i=e.asterix.ng.util.getPreCompilationInstanceId(t);if(i){var a=e.asterix.instanceRegistry.find(i);if(a){var o=a.getSettings(),s=e.asterix.util.parse((0===n.mstarInclude.indexOf("templates")?"_":"")+n.mstarInclude)(o);if(s)return s=e.asterix.ng.util.preProcessTemplate(a,s),t.html(s),r.bind({_hasPreCompiled:!0})}}return r.bind({})}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2)],void 0!==(i=function(t){t.module("mstarCore").directive("mstarLoader",["mstarLoader",function(t){return{restrict:"A",link:function(e,n,r){t(e,n,r.mstarLoader,r.mstarLoaderSettings?e.$eval(r.mstarLoaderSettings):null)}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2)],void 0!==(i=function(t){function e(t){function e(e,n,r){var i={};n.parents(".mstar-modal-holder").length&&(i.zIndex=900);var a;r.$observe("mstarTooltipContent",function(r){r&&(a||(a=t(e,n,i)),a.setContent(r),a.updatePosition(),""!==r?n.addClass("mstar-tooltip-term"):n.removeClass("mstar-tooltip-term"))})}return{restrict:"A",scope:!1,link:e}}e.$inject=["mstarTooltip"],t.module("mstarCore").directive("mstarTooltip",e)}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1),n(0)],void 0!==(i=function(t,e,n){t.module("mstarCore").directive("mstarValidate",["mstarTooltip","mstarValidationMessageContainers",function(t,r){return{restrict:"A",require:["?ngModel","^mstarComponentId","?^form","mstarValidate"],controller:["$scope","$element","$attrs",function(e,r,i){this.getTooltip=function(){return this.tooltip},this.getInlineError=function(){return this.inlineError},this.setValidationMessageContainer=function(t){n.asterix.util.isFunction(t.show)&&n.asterix.util.isFunction(t.hide)&&(this.validationMessageProvider=t)};var a=r.controller("mstarComponentId").getSettings().get("_validation");this.elementType=a.errorWhen?"inline":"tooltip",a&&Object.keys(a.rules).length&&(this.isActive=!0,"inline"===this.elementType?(this.inlineErrorId=r.controller("mstarComponentId").getOwnComponentId()+"-error",this.inlineError=function(t){var e=document.createElement("span");return e.setAttribute("id",t),e.setAttribute("role","alert"),e.className="mds-form__field-error",e}(this.inlineErrorId)):this.tooltip=t(e,r,{trigger:"manual"}))}],link:function(t,n,i,a){function o(t){return!e.some(t,function(t){return!t.returnValue})}function s(t){if(h.validationMessageProvider)return void h.validationMessageProvider.show(t);"inline"===h.elementType?(d(),p(t),P.setAttribute("aria-describedby",h.inlineErrorId),P.setAttribute("aria-invalid","true"),P.parentNode.insertBefore(b,P.nextSibling),P.parentNode.className.indexOf("mds-form__field-group")>-1&&-1===P.parentNode.className.indexOf("mds-form--error")&&P.parentNode.classList.add("mds-form--error")):(C.setContent(t),C.show())}function l(){if(h.validationMessageProvider)return void h.validationMessageProvider.hide();"inline"===h.elementType?(d(),b.remove(),P.removeAttribute("aria-describedby"),P.setAttribute("aria-invalid","false"),P.parentNode.className.indexOf("mds-form--error")>-1&&P.parentNode.classList.remove("mds-form--error")):(C.setContent(""),C.hide())}function u(t){var n=e.chain(t).filter(function(t){return!t.returnValue}).map(function(t){return g.getLabels().get(t.rule.labelKey)}).value();n.length&&c()?s(n[0]):l()}function c(){if("never"===w)return!1;if("manual"===w&&!f._validationHasBeenTriggered)return!1;if(!w||f.$modelValue||f.$viewValue)return!0;switch(w){case"dirty":return f.$dirty;case"touched":return f.$touched}return!0}function p(t){var e=document.createElement("span");e.className="mds-form__field-error-text",e.appendChild(document.createTextNode(t)),b.appendChild(e)}function d(){for(;b.firstChild;)b.removeChild(b.firstChild)}var f=a[0],g=a[1],m=a[2],h=a[3];if(!f){var v=n.find("[ng-model]");v.length&&(f=v.controller("ngModel"))}if(h.isActive){r.register(g.getComponentInstance(),function(){});var y,x=g.getSettings().contains("_validation")?g.getSettings().get("_validation"):{},_=[],C=h.tooltip,b=h.inlineError,P=n[0],w=x.errorWhen||x.tooltipWhen;w&&["dirty","touched"].indexOf(w)>0&&t.$watch(function(){return f["$"+w]},function(){y&&u(y)}),"manual"===w&&(g.getComponentInstance().triggerValidation=function(){y&&(f._validationHasBeenTriggered=!0,u(y))}),m&&t.$watch(function(){return m.$submitted},function(t){!0===t&&(f.$setTouched(),f.$setDirty())}),_.push(g.getComponentInstance().on("validationReferenceChanged",function(){f.$validate()})),f.$validators.mstarValidate=function(t,e){return y=g.getComponentInstance().validate(t||e),g.getComponentInstance().getValidationState().setState(y),u(y),o(y)},t.$on("$destroy",function(){e.each(_,function(t){t()})})}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0),n(1)],void 0!==(i=function(t,e,r){function i(){return r.each(e.components._angularComponents,function(t){e.components._angularModuleDependencies.indexOf(t)<0&&e.asterix.ng.util.angularModuleExists(t)&&e.components._angularModuleDependencies.push(t)}),e.components._angularModuleDependencies}function a(t,n,i){t&&n||e.asterix.instrumentation.logger.fatal(new Error("(asterix.ng) register expects type and defaultConfig")),l||(s(),l=!0),e.asterix.register(t,n),e.components._angularModuleDependencies||o(),e.components._angularComponents.push(t),e.components._angularModuleDependencies=r.uniq(e.components._angularModuleDependencies.concat(i||[]))}function o(){e.components._angularComponents=[],e.components._angularModuleDependencies=[]}function s(){e.asterix.bootstrap.registerCallback(function(n){var r=e.asterix.util.merge({},{bootstrapElement:document,bootstrap:!0},n.angularOptions||{});n.angularOptions=r,n.angularOptions.bootstrap&&(e.components._angularInjector=t.bootstrap(n.angularOptions.bootstrapElement,i()))})}var l=!1;e.asterix.ng={util:n(47),transforms:n(43),register:a,reset:o,getAngularModuleDependencies:i,ValidationMessages:n(42)},e.asterix.config.mergeBaseSettings({tooltip:{classes:"mstar-tip",content:"",delay:0,hasArrow:!0,html:!1,offset:10,position:"top",removeTitle:!0,selector:!1,smartReposition:!0,trigger:"hover"},loader:{enabled:!0,template:"<div></div>",loaderContainer:"page",selector:null}}),t.module("mstarCore",["ngStorage","ngAria"])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(2),n(1)],void 0!==(i=function(t,e,n){e.module("mstarCore").factory("mstarAjax",["$http","$q",function(e,r){return{handleHttpPromise:function(e){return e.then(function(t){return t.data},function(e){return e&&t.asterix.instrumentation.logger.error("(handleHttpPromise) Error:",e),e.error=!0,e.message=null,e})},jsonp:function(n,i,a,o,s,l){var u=(new Date).getTime(),c=(s||t.asterix.instrumentation.tracer).startTrace("mstarAjax.jsonp()");(a||i)&&(n=t.asterix.util.url.parameterize(n,a||i));var p={};n.match(/[&?]callback=JSON_CALLBACK/)||(p.callback="JSON_CALLBACK");var d=r.defer(),f=this.handleHttpPromise(e.jsonp(n,{data:i,params:p,timeout:d.promise}));return f.then(function(e){var r={url:n,data:i,urlParameters:a,status:"success"};c.end(r);var o=(new Date).getTime();(l||t.asterix.usageTracker).trackHit({type:"timing",action:"ajax.jsonp",value:{startTime:u,endTime:o,elapsedTime:o-u,context:r}})},function(e){var r={url:n,data:i,urlParameters:a,response:e,status:"error"};c.end(r);var o=(new Date).getTime();(l||t.asterix.usageTracker).trackHit({type:"timing",action:"ajax.jsonp",value:{startTime:u,endTime:o,elapsedTime:o-u,context:r}})}),{promise:f,cancel:function(){var e={url:n,data:i,urlParameters:a,status:"cancelled"};c.end(e);var r=(new Date).getTime();(l||t.asterix.usageTracker).trackHit({type:"timing",action:"ajax.jsonp",value:{startTime:u,endTime:r,elapsedTime:r-u,context:e}}),d.resolve("Cancelled.")}}},api:function(i,a,o,s,l,u){i.method&&i.url||(s||t.asterix.instrumentation.logger).fatal(new Error("apiSettings requires method and url"));var c=(new Date).getTime(),p=(l||t.asterix.instrumentation.tracer).startTrace("mstarAjax.api()"),d=o||a&&"get"===i.method.toLowerCase()?t.asterix.util.url.parameterize(i.url,o||a):i.url,f=r.defer();if(i=n.extend({},i,{url:d,data:i.data||a,timeout:f.promise}),!0===i.jsonp)return this.jsonp(i.url,a,o);var g=this.handleHttpPromise(e(i));return g.then(function(e){var n={apiSettings:i,data:a,urlParameters:o,status:"success"};p.end(n);var r=(new Date).getTime();(u||t.asterix.usageTracker).trackHit({type:"timing",action:"ajax.api",value:{startTime:c,endTime:r,elapsedTime:r-c,context:n}})},function(e){var n={apiSettings:i,data:a,urlParameters:o,response:e,status:"error"};p.end(n);var r=(new Date).getTime();(u||t.asterix.usageTracker).trackHit({type:"timing",action:"ajax.api",value:{startTime:c,endTime:r,elapsedTime:r-c,context:n}})}),{promise:g,cancel:function(){var e={apiSettings:i,data:a,urlParameters:o,status:"cancelled"};p.end(e);var n=(new Date).getTime();(u||t.asterix.usageTracker).trackHit({type:"timing",action:"ajax.api",value:{startTime:c,endTime:n,elapsedTime:n-c,context:e}}),f.resolve("Cancelled.")}}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0),n(3)],void 0!==(i=function(t,e,r){t.module("mstarCore").factory("mstarAlert",["mstarTemplate","$rootScope","$q","$document",function(i,a,o,s){return function(l,u){function c(t){t.type=t.type||"alert";var e="confirm"==t.type?d.confirmTemplate:d.alertTemplate,n=o.defer(),s=a.$new();s.messages=t.messages,s.okButtonLabel=d.okButtonLabel,s.cancelButtonLabel=d.cancelButtonLabel,s.parentScope=u;var l=function(e){var i={type:t.type,status:e};n.resolve(i),f.off("keydown",m),r("#ecAlertContainer").remove(),s.$destroy(),s=null};s.ok=function(){l(!0)},s.cancel=function(){l(!1)},s.close=function(){l(!0)};var c=r("#ecAlertContainer");c.length<=0&&(f.append('<div id="ecAlertContainer"></div>'),c=r("#ecAlertContainer")),f.on("keydown",m),i.compile(s,c,{template:e});var p=c.find(".mstar-u-capsuleStyleButton");return p[p.length-1].focus(),n.promise}var p={alertTemplate:n(49),confirmTemplate:n(50),okButtonLabel:"OK",cancelButtonLabel:"Cancel",captureKeyboardNavigation:!1},d=e.asterix.extend({},p,l||{}),f=r("body"),g=[9,13,32],m=d.captureKeyboardNavigation?function(t){var e=t.keyCode||t.which,n=r("#ecAlertContainer").find(".mstar-u-capsuleStyleButton").filter(function(){return this!==s[0].activeElement});g.indexOf(e)>=0&&n.length>1&&t.preventDefault(),9===e&&n.length&&n[0].focus()}:t.noop;return{show:c}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1)],void 0!==(i=function(t,e){t.module("mstarCore").service("mstarBrowser",["$window",function(t){var e=t.window.bowser;return function(){return{mobile:e.mobile,table:e.tablet}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1)],void 0!==(i=function(t,e){t.module("mstarCore").factory("mstarRebase",function(){function t(t){var e=new Date(t),n=e.getMonth();return e.setDate(e.getDate()+1),e.getMonth()!==n}function n(e,n){var r=new Date(e);if(r.setDate(1),r.setMonth(r.getMonth()+n),t(e)){var i=new Date(r.getFullYear(),r.getMonth()+1,0);r.setDate(i.getDate())}else r.setDate(new Date(e).getDate());var a=r.getMonth()+1,o=r.getFullYear();return o+="-"+(a<10?"0"+a:a),o+="-"+(r.getDate()<10?"0"+r.getDate():r.getDate())}function r(t,e){var r={};return r.endDate=n(t,-1),r.value=l,e.unshift(r),e}function i(t,n){if(!n||!n.length)return[];var i=e.extend([],n),a=e.find(i,function(e){return e.endDate===t}),o=e.indexOf(i,a);return o<=0?r(e.first(i).endDate,i):i.splice(o-1)}function a(t){var n=null,r=[];return e.each(t,function(t,e){var i={};0===e?(i.value=l,n=l):(n*=1+t.value/100,i.value=n),i.endDate=t.endDate,r.push(i)}),r}function o(t,r){var i=n(e.last(t).endDate,1-12*r),a=e.find(t,function(t){return t.endDate===i});return e.isUndefined(a)&&(i=e.first(t).endDate),i}function s(t,n,r){var s=morningstar.asterix.instrumentation.tracer.startTrace("mstarRebase.createFrequencyData()");l=t;var u=[],c=o(e.first(n.series).data,r);return e.each(n.series,function(t){var e=i(c,t.data);u.push({name:t.name,data:a(e)})}),s.end({chartValue:t,performanceChartData:n,selectedFrequency:r,series:u}),u}var l=0;return{graphData:s}})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2)],void 0!==(i=function(t){var e=[];t.module("mstarCore").factory("mstarComponent",["$parse",function(t){return{setSelectorTypeMapping:function(t,n){e.push({selector:t,type:n})},getSelectorTypeMappings:function(){return e}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1)],void 0!==(i=function(t,e){t.module("mstarCore").service("mstarDebounce",["$timeout",function(t){return function(e,n,r){function i(){s=this,o=arguments;var i=function(){a=null,r||(u.end({status:"executed",wait:n,immediate:r}),l=e.apply(s,o))},c=r&&!a;return a&&t.cancel(a),a=t(i,n,!1),c&&(u.end({status:"executed",wait:n,immediate:r}),l=e.apply(s,o)),l}var a,o,s,l,u=morningstar.asterix.instrumentation.tracer.startTrace("mstarDebounce");return i.cancel=function(){u.end({status:"executed",wait:n,immediate:r}),t.cancel(a),a=null},i}}]).service("mstarThrottle",["$timeout",function(t){return function(n,r,i){var a,o,s,l=morningstar.asterix.instrumentation.tracer.startTrace("mstarThrottle"),u=null,c=0;i||(i={});var p=function(){c=!1===i.leading?0:e.now(),u=null,l.end({status:"executed",wait:r,options:i}),s=n.apply(a,o),u||(a=o=null)};return function(){var d=e.now();c||!1!==i.leading||(c=d);var f=r-(d-c);return a=this,o=arguments,f<=0||f>r?(u&&(t.cancel(u),u=null),c=d,l.end({status:"executed",wait:r,options:i}),s=n.apply(a,o),u||(a=o=null)):u||!1===i.trailing||(u=t(p,f,!1)),s}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1),n(0)],void 0!==(i=function(t,e,n){t.module("mstarCore").service("mstarDimensions",["mstarElementMonitor",function(t){return function(r,i){function a(){s||(s=!0,e.each(o,function(t){t()}))}var o=[];r.$on("$destroy",a);var s=!1;return{addListener:function(e,n){return o.push(t.on(i,n||{width:!0,height:!0},function(t){e({width:t.dimensions.width,height:t.dimensions.height,visible:t.visible,top:t.offset.top,left:t.offset.left})})),this},destroy:a,getDimensions:function(){return{width:i.width(),height:i.height(),visible:i.is(":visible"),top:i.offset().top,left:i.offset().left}},requestDimensions:function(t){n.asterix.util.fastdom.measure(function(){var e={width:i.width(),height:i.height(),visible:i.is(":visible"),top:i.offset().top,left:i.offset().left};t(e)})}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(t,e){t.module("mstarCore").factory("mstarDragDrop",["$document","$rootScope","$timeout",function(r,i,a){function o(e){return t.isDefined(e.touches)?e.touches[0]:t.isDefined(e.originalEvent)&&t.isDefined(e.originalEvent.touches)?e.originalEvent.touches[0]:e}function s(t,e){var n=[],r=[];for(var i in e)e[i]?r.push(i):n.push(i);t.removeClass(n.join(" ")).addClass(r.join(" "))}function l(t,e){var n=[],r=t.clientX,i=t.clientY,a=e[0].getBoundingClientRect(),o=a.right-a.left,s=a.bottom-a.top;return r>=a.left&&r<a.left+o/2?n.push("left"):r>=a.left+o/2&&r<=a.right&&n.push("right"),i>=a.top&&i<a.top+s/2?n.push("top"):i>=a.top+s/2&&i<=a.bottom&&n.push("bottom"),n}function u(n,i,u){function c(t){e.asterix.instrumentation.logger.debug("mstarDragDrop.startDrag()",t);var a=o(t),s={element:i,scope:n,instance:$};if(d.set(u,p.DRAG,s),T.drag(s),$.trigger("dragStart",[T]),_(a),k=T.direction().indexOf("x")<0,D=T.direction().indexOf("y")<0,S=T.containment(),r.on(m,function(t){C(t),y(t)}).on(h,function(t){C(t),x(t)}),b(t)){var l=r.scrollTop();r.on(v,function(t){r.scrollTop(l)})}}function y(t){var e=o(t);_(e);var n=d.get(u,p.DROP),r=[],i=[];n.forEach(function(t){t.areaPos=l(e,t.element),2===t.areaPos.length?r.push(t):i.push(t)}),i.forEach(function(t){t.isEnter&&(t.isEnter=!1,T.drop(t),t.instance.trigger("dropOut",[T]),T.drop(null))}),r.forEach(function(t){t.isEnter||(t.isEnter=!0,T.drop(t),t.instance.trigger("dropEnter",[T]))}),$.trigger("drag",[T])}function x(t){e.asterix.instrumentation.logger.debug("mstarDragDrop.endDrag()",t),d.get(u,p.DROP).forEach(function(t){t.isEnter&&(T.drop(t),t.instance.trigger("drop",[T]))}),$.trigger("dragEnd",[T]),s(T.element(),{"mstar-dragdrop-proxy--yes":!1}),T.element().hide(),T.drag(null).direction(null).transferData(null).containment(null).drop(null),r.off(m).off(h),b(t)&&r.off(v)}function _(e){var n={top:D?null:e.pageY,left:k?null:e.pageX};if(S){var r=t.isElement(S)?S[0].getBoundingClientRect():S;n.top=n.top?Math.min(Math.max(n.top,r.top),r.bottom):null,n.left=n.left?Math.min(Math.max(n.left,r.left),r.right-T.element().outerWidth(!0)):null}T.element().css(n).show()}function C(t){b(t)||t.preventDefault()}function b(t){return 0===t.type.indexOf("touch")}if(u){var P=i.controller("mstarComponentId");P||e.asterix.instrumentation.logger.fatal(new Error("(drop) Could not find mstarComponentId."));var w,S,T=f(u),$=P.getComponentInstance(),k=!1,D=!1;i.on(g,function(t){C(t),w=a(function(){c(t)},200)}).on(h,function(t){C(t),a.cancel(w)}),n.$on("$destroy",function(){i.off(".mstarDragDrop"),d.remove(u,p.DRAG,{element:i})})}}function c(t,n,r){if(e.asterix.instrumentation.logger.debug("mstarDragDrop.endDrag()",n,r),r){var i=n.controller("mstarComponentId");i||e.asterix.instrumentation.logger.fatal(new Error("(drop) Could not find mstarComponentId.")),d.set(r,p.DROP,{element:n,scope:t,instance:i.getComponentInstance(),isEnter:!1}),t.$on("$destroy",function(){d.remove(r,p.DROP,n)})}}var p={DRAG:"drag",DROP:"drop"},d=function(){var t={};return{set:function(e,n,r){t[e]=t[e]||{},t[e][n]=t[e][n]||[],t[e][n].push(r)},get:function(e,n){return t[e]&&t[e][n]?t[e][n]:[]},remove:function(e,n,r){for(var i=this.get(e,n),a=-1,o=0,s=i.length;o<s;o++)if(i[o].element===r.element){a=o;break}a>-1&&t[e][n].splice(a,1)}}}(),f=function(){var e={};return function(i){return e[i]||(e[i]={element:function(e){return this._element||(this._element=t.element(n(51)).appendTo(r.find("body"))),arguments.length?(this._element=e,this):this._element},direction:function(t){return arguments.length?(this._direction=t,this):this._direction||"xy"},containment:function(t){return arguments.length?(this._containment=t,this):this._containment},drag:function(t){return arguments.length?(this._drag=t,this):this._drag},drop:function(t){return arguments.length?(this._drop=t,this):this._drop},transferData:function(t){return arguments.length?(this._data=t,this):this._data}}),e[i]}}(),g="touchstart.mstarDragDrop mousedown.mstarDragDrop",m="touchmove.mstarDragDrop mousemove.mstarDragDrop",h="touchend.mstarDragDrop mouseup.mstarDragDrop",v="scroll.unable";return{drag:u,drop:c}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0),n(1)],void 0!==(i=function(t,e,n){t.module("mstarCore").factory("mstarElementMonitor",["$timeout","$interval","$window",function(r,i,a){function o(){l||(l=i(function(){++p%10==0&&e.asterix.instrumentation.logger.debug("mstarElementMonitor is monitoring "+u.length+" elements"),n.each(u,function(n){n&&e.asterix.util.fastdom.measure(function(){var e=!1,r=t.copy(n.state);if(n.monitorProperties.visibility){var i=n.element.is(":visible");!0!==r.visible&&i?(e=!0,r.visible=!0):!0!==r.visible||i||(e=!0,r.visible=!1)}if(n.monitorProperties.offset){var a=n.element.offset();a.top===r.offset.top&&a.left===r.offset.left||(r.offset=a,e=!0)}if(n.monitorProperties.width){var o=n.element.width();o!==r.dimensions.width&&(r.dimensions.width=o,e=!0)}if(n.monitorProperties.height){var s=n.element.height();s!==r.dimensions.height&&(r.dimensions.height=s,e=!0)}e&&(n.state=r,n.cb(r))})})},200,0,!1))}function s(){l&&(i.cancel(l),l=null)}var l,u=[],c=[];o();var p=0;return t.element(a).on("blur",function(){e.asterix.instrumentation.logger.debug("tab lost focus, stopping mstarDimensions interval"),s()}),t.element(a).on("focus",function(){e.asterix.instrumentation.logger.debug("tab gained focus, starting mstarDimensions interval"),o()}),{on:function(t,e,r){if(c.indexOf(t)>=0)return u[c.indexOf(t)].cbs.push(r),function(){};var i={element:t,monitorProperties:e,cbs:[r],state:{dimensions:{},offset:{},visible:!0},cb:function(t){n.each(this.cbs,function(e){e(t)})}};return u.push(i),c.push(t),function(){c.splice(c.indexOf(t),1),u.splice(u.indexOf(i),1)}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(t,e){t.module("mstarCore").factory("mstarLoader",["mstarDimensions",function(n){return function(r,i,a,o){function s(){v||(v=!0,m.destroy(),h(),g.remove())}var l=i.controller("mstarComponentId"),u={page:function(){t.element("body").append(g)},componentBased:function(){i.append(g)},selectorBased:function(){p.selector&&t.element(p.selector).length>0?t.element(p.selector).eq(0).append(g):u.page()}};l||e.asterix.instrumentation.logger.fatal(new Error("(loader) Could not find mstarComponentId."));var c=l&&l.getSettings().contains("loader")?l.getSettings().get("loader"):{},p=e.asterix.util.merge({},c,o||{});if(!p.enabled)return{destroy:function(){}};var d=!1,f=p.loaderContainer||"page",g=t.element(p.template).addClass(e.asterix.util.css.namespaceSelector([l.getComponentTypePath(),l.getComponentId()],"mstar-loader"));e.asterix.util.isFunction(u[f])?u[f]():u.page();var m=n(r,i).addListener(function(t){t.visible?d&&e.asterix.util.fastdom.mutate(function(){g.css({top:t.top,left:t.left,width:t.width,height:t.height}),g.show()}):g.hide()},{width:!0,height:!0,offset:!0}),h=r.$watch(a,function(t){if(d=t,!0===t){var e=m.getDimensions();g.css({top:e.top,left:e.left,width:e.width,height:e.height}).show()}else g.hide()});r.$on("$destroy",s);var v=!1;return{destroy:s}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(t,e){t.module("mstarCore").factory("mstarModal",["$rootScope","$q","$document","$sce","$interpolate","mstarTemplate",function(r,i,a,o,s,l){function u(a,o,s){s=e.asterix.util.merge({overrideTemplate:!1,parentComponentPath:"",open:!0},s||{});var u=i.defer();c&&(c.$destroy(),c=null,d.find(".mstar-modal-holder").length>0&&(d.find(".mstar-modal-holder").remove(),d.removeClass("mstar-modal-open"))),c=o?o.$new():r.$new();var p=d.find(".mstar-modal-holder");p.length<=0&&(d.append('<div class="mstar-modal-holder"></div>'),p=d.find(".mstar-modal-holder"),!0===s.open&&d.addClass("mstar-modal-open")),c.modalContent=a;var f=!0===s.overrideTemplate?a:n(52),g=t.element("<div>");return s.parentComponentPath&&g.attr("mstar-component-id",s.parentComponentPath),s.modalId&&p.attr("id",s.modalId),g.append(f),l.compile(c,p,{template:g[0].outerHTML}),!1===s.open&&(p.removeClass("mstar-modal-holder"),u.resolve(p)),c.closeModal=function(){d.removeClass("mstar-modal-open"),u.notify(c),c.$destroy(),c=null,p&&p.remove()},c.resolveModal=function(){d.removeClass("mstar-modal-open"),u.resolve(c),c.$destroy(),c=null,p&&p.remove()},c.rejectModal=function(){d.removeClass("mstar-modal-open"),u.reject(c),c.$destroy(),c=null,p&&p.remove()},u.promise}var c,p={launch:u},d=a.find("body");return p}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(2),n(1)],void 0!==(i=function(t,e,n){e.module("mstarCore").factory("mstarModelBinder",["mstarAjax","mstarThrottle","$parse",function(e,r,i){function a(e,r,i,a,s){var l=this;this.instance=t.asterix.instanceRegistry.get(a),this._logger=t.asterix.instrumentation.getTagsDecoratedLogger({componentModulePath:a,componentType:l.instance.getModuleType()}),this._tracer=t.asterix.instrumentation.getTagsDecoratedTracer({componentModulePath:a,componentType:l.instance.getModuleType()},l._logger),this._logger.debug("ModelBinder.ctor()",i,a,s),this.scope=e,this.scope.model=this.scope.model||o,this.instanceId=a,this.options=s||{editable:!1},this.configEvaluator=r,this.modelSettings=i,this.promises=[],this.unregisterFunctions=[],this._previousRequestState={},this._calculatedPaths=[],this._invokedStatusForPaths={},e.$on("$destroy",function(){n.each(l.unregisterFunctions,function(t){t()})})}var o=[],s={};return a.prototype.getPromises=function(){return this.promises},a.prototype.getPromisesCount=function(){return(this.promises||[]).length},a.prototype.bind=function(){var e=this._tracer.startTrace("ModelBinder.bind()"),n=t.asterix.util.merge({},this.modelSettings);this._recursivelyBind(n,null),e.end(n)},a.prototype._box=function(e){return t.asterix.util.isArray(e)||t.asterix.util.isObject(e)?e:(t.asterix.util.isNumber(e)?(e=new Number(e),e.__primitiveValue=e.__primitiveValue||e.valueOf()):t.asterix.util.isString(e)?(e=new String(e),e.__primitiveValue=e.__primitiveValue||e.valueOf()):t.asterix.util.isBoolean(e)&&(e=new Boolean(e),e.__primitiveValue=e.__primitiveValue||e.valueOf()),e)},a.prototype._assignValue=function(t,e){this._logger.debug("ModelBinder._assignValue()",t,e),t&&n.some(this._calculatedPaths,function(e){return 0===t.indexOf(e)})||(t?this.instance.setModelProperty(t,e):this.instance.setModel(e))},a.prototype._getPrevious=function(t){return t?this.instance.getModelProperty(t):this.instance.getModel()},a.prototype._getContext=function(t,e){return{labels:this.scope.labels,settings:this.scope.settings,parameters:this.scope.parameters,format:this.scope.format,prevData:t?this._getPrevious(t)||{}:{},oldParameters:e||{},instance:this.scope.instance}},a.prototype._assignApiData=function(e,n,r,i,a){function s(n){n=null===n||t.asterix.util.isUndefined(n)?o:n,n=l._box(n),n._$isLoading=!1,n._$refresh=i,n._$isDataSource=!0,a&&(n.$errorMessage=a.message),e?l.instance.setModelProperty(e,n):l.instance.setModel(n)}this._logger.debug("ModelBinder._assignApiData()",e,n,r,i,a);var l=this;if(t.asterix.ng.transforms.isPipelineEmpty(r))s(n);else{t.asterix.ng.transforms.transformAsync(r,n,this._getContext(e)).then(function(t){s(t)})}},a.prototype._triggerSavePropagation=function(e,n){var r=this;this._logger.debug("ModelBinder._triggerSavePropagation()",e,n);var i=r._cloneAndStripMeta(r.instance.getModelProperty(e));i=t.asterix.ng.transforms.transform(n.propagateChanges.transformStack||n.propagateChanges.transformPipeline,i,r._getContext()),r.instance.trigger("save",[e,i])},a.prototype._populateMetaFromSelectorDataSource=function(e,n,r,i){var a=this._getReferenceDataSource(n),o=this;i.propagateChanges&&i.propagateChanges.trigger&&(e._$propagated=!0,e._$save=function(){o._triggerSavePropagation(r,i)}),a&&(e._$isDataSource=!0,e._$isLoading=a._$isLoading||!1,e._$refresh=a._$refresh||t.asterix.util.noop)},a.prototype._getReferenceDataSource=function(t){var e=this._getReferenceDataSourcePath(t);return!1===e?null:e?t.instance.getModelProperty(e):t.instance.getModel()},a.prototype._getReferenceDataSourcePath=function(e){for(var n=e.instance.getSettings()["_"+e.type],r=e.refPath;;){if(r?t.asterix.util.parse(r)(n):n)return r;if(!r)return!1;r=r.substr(0,r.lastIndexOf("."))}},a.prototype._updateReferenceListener=function(e){var n=this,r=this._getReferenceDataSourcePath(e);!1===r&&t.asterix.instrumentation.logger.fatal(new Error("Couldn't resolve data source path for reference "+JSON.stringify(e))),r!==e.refPath&&(e.listen=function(i){return n.configEvaluator._createListener(e.type,r,e.instance)(function(){i(t.asterix.util.parse(e.refPath)(e.instance["get"+t.asterix.util.string.firstUpperCase(e.type)]()))})})},a.prototype._assignSelectorValue=function(e,n,r,i,a){function s(n){!0===a.merge&&(n=t.asterix.extend(!0,{},l._getDefaultData(e,a.defaults),l.instance.getModelProperty(e),n)),n=null===n||t.asterix.util.isUndefined(n)?o:n,n=l._box(n),l._populateMetaFromSelectorDataSource(n,i,e,a),e?l.instance.setModelProperty(e,n):l.instance.setModel(n),u.end({path:e,data:n})}var l=this,u=this._tracer.startTrace("ModelBinder._assignSelectorValue()");t.asterix.ng.transforms.isPipelineEmpty(r)?s(n):t.asterix.ng.transforms.transformAsyncCloned(r,n,this._getContext()).then(s)},a.prototype._assignWaitingValue=function(t,e){var n=t?this.instance.getModelProperty(t):this.instance.getModel();n=this._box(n)||o,n._$isLoading=!0,n._$refresh=e,n._$isDataSource=!0,t?this.instance.setModelProperty(t,n):this.instance.setModel(n)},a.prototype._encodeParameters=function(e){if(t.asterix.util.isString(e))return e;var n=this;return t.asterix.util.each(e,function(r,i){t.asterix.util.isString(r)?e[i]=encodeURIComponent(r):(t.asterix.util.isArray(r)||t.asterix.util.isObject(r))&&(e[i]=n._encodeParameters(r))}),e},a.prototype._deepClone=function(e){return t.asterix.extend(!0,t.asterix.util.isString(e)?e:t.asterix.util.isArray(e)?[]:{},e)},a.prototype._createLoadApiDataCallback=function(a,o){function l(){v=d.configEvaluator.evaluate(a.api.url).evaluated,y=d.configEvaluator.evaluate(t.asterix.extend(!0,{},a.api.data)).evaluated,_=d.configEvaluator.evaluate(t.asterix.extend(!0,{},a.api.headers)).evaluated}function u(n){function r(r){var s=d._encodeParameters(d._deepClone(r));if(r&&(n||h.error||!h.encodedTransformedParameters||!t.asterix.util.isEqual(s,h.encodedTransformedParameters))){c&&c.cancel(),d._assignWaitingValue(o,u),h.parameters=t.asterix.extend(!0,{},f.parameters),h.encodedTransformedParameters=s,r=r||{},s=s||{};var l={apiSettings:t.asterix.extend({},a.api,{url:v,headers:_}),data:r.requestData?r.requestData:s,parameters:r.parameters?d._encodeParameters(d._deepClone(r.parameters)):s,originalUrl:a.api.url,originalHeaders:a.api.headers,retryCount:0};c=e.api(l.apiSettings,l.data,l.parameters,d.instance.getLogger(),d.instance.getTracer(),d.instance.getUsageTracker()),i(c,l)}}function i(e,n){d.promises.push(e.promise),e.promise.then(function(r){if(r){if(r.error)if((401===r.status||403===r.status)&&t.asterix.context.getApiTokenExpiredCallback()&&n.retryCount<1){n.retryCount=n.retryCount+1;var i=t.asterix.context.getApiTokenExpiredCallback(),l={url:n.originalUrl,parameters:n.parameters,headers:n.originalHeaders};i(l,function(e,i){if(t.asterix.context.getToken(e)&&!s[n.originalUrl])return s[n.originalUrl]=!0,void t.asterix.context.setToken(e,i);h.error=!0,d._assignApiData(o,a.api.usePreviousDataOnError?p:r,a.transformStack||a.transformPipeline,u,r)})}else h.error=!0,d._assignApiData(o,a.api.usePreviousDataOnError?p:r,a.transformStack||a.transformPipeline,u,r);else p=r,h.error=!1,s[n.originalUrl]=!1,d._assignApiData(o,r,a.transformStack||a.transformPipeline,u);d.promises.splice(d.promises.indexOf(e.promise),1)}})}if(d._logger.debug("ModelBinder.loadApiData()",a,o),m&&!0!==m(f))return h.parameters=t.asterix.extend(!0,{},f.parameters),void(h.encodedTransformedParameters=null);if(a.api.validationExpressions&&a.api.validationExpressions.length){var l=d.configEvaluator.evaluate(t.asterix.extend(!0,{},a.api.validationExpressions));if(t.asterix.util.any(l.evaluated,function(t){return!t}))return h.parameters=t.asterix.extend(!0,{},f.parameters),void(h.encodedTransformedParameters=null)}if(g){c&&c.cancel(),d._assignWaitingValue(o,u);var x={apiSettings:t.asterix.extend({},a.api,{url:encodeURI(t.asterix.util.url.unescapeBaseUrl(v)),data:y,headers:_}),originalUrl:a.api.url,originalHeaders:a.api.headers,retryCount:0};c=e.api(x.apiSettings,x.data,x.parameters,d.instance.getLogger(),d.instance.getTracer(),d.instance.getUsageTracker()),i(c,x)}else if(t.asterix.ng.transforms.isPipelineEmpty(a.api.parameters.transformStack||a.api.parameters.transformPipeline))r(f.parameters);else if(a.api.parameters.isTransformSync){var C=t.asterix.ng.transforms.transform(a.api.parameters.transformStack||a.api.parameters.transformPipeline,f.parameters,d._getContext(null,h.parameters));r(C)}else{var b=P=t.asterix.ng.transforms.transformAsync(a.api.parameters.transformStack||a.api.parameters.transformPipeline,f.parameters,d._getContext(null,h.parameters));w.push(b.promise),P.catch(function(t){w.splice(w.indexOf(b.promise),1)}).then(function(t){w.splice(w.indexOf(b.promise),1),P===b&&r(t)})}}var u,c,p,d=this,f=d.scope,g=!1,m=a.api.validationExpression?i(a.api.validationExpression):null,h=this._previousRequestState[o]={error:!1,encodedTransformedParameters:null,parameters:null},v=a.api.url,y=a.api.data,x=t.asterix.context.getToken("defaultApiHeaders")||{},_=a.api.headers;!0!==a.api.ignoreDefaultHeaders&&(_=t.asterix.extend(!0,_,x));var C=d.configEvaluator.evaluate(t.asterix.extend(!0,{},a.api));if(C.references.length){var b=n.filter(C.references,function(t){return"headers."!==t.source.path.substr(0,8)});g=b.length>0,l(),d.unregisterFunctions.push(C.listen(function(){l(),u(!0)}))}var P,w=[],S=a.api.parameters?a.api.parameters.throttleTime:200;return S>0&&(u=r(u,S,{leading:!1,trailing:!0})),d._assignWaitingValue(o,u),u},a.prototype._getDefaultData=function(e,r){return(this.options.defaultDataCallbacks&&this.options.defaultDataCallbacks[e]?this.options.defaultDataCallbacks[e]():null)||(t.asterix.util.isPlainObject(r)||t.asterix.util.isArray(r)?t.asterix.extend(!0,n.isArray(r)?[]:{},r):r)},a.prototype._hasDefaultData=function(t,e){return this.options.defaultDataCallbacks&&this.options.defaultDataCallbacks[t]||e.defaults},a.prototype._bindDataSource=function(e,r){var i=this;switch(e.dataSourceType){case"api":e.api||t.asterix.instrumentation.logger.fatal(new Error("Expecting api property for dataSourceType api."));var a=i._createLoadApiDataCallback(e,r);if(i._hasDefaultData(r,e)&&i._assignValue(r,i._getDefaultData(r,e.defaults)),e.api.parameters&&null!=e.api.parameters.watchedPaths){var o="",s=!1;t.asterix.util.isString(e.api.parameters.watchedPaths)?o="parameters"+(e.api.parameters.watchedPaths?"."+e.api.parameters.watchedPaths:""):t.asterix.util.isArray(e.api.parameters.watchedPaths)&&(s=!0,o=JSON.stringify(n.chain(e.api.parameters.watchedPaths).map(function(e){return e&&t.asterix.util.isString(e)?"parameters."+e:null}).filter(function(t){return t}).value()).replace(/"/g,"")),i._invokedStatusForPaths[r]=!1,!e.api.parameters.deep&&s?i.scope.$watchCollection(o,function(e,n){i._invokedStatusForPaths[r]&&t.asterix.util.isEqual(e,n)||(i._invokedStatusForPaths[r]=!0,a())}):i.scope.$watch(o,function(e,n){i._invokedStatusForPaths[r]&&t.asterix.util.isEqual(e,n)||(i._invokedStatusForPaths[r]=!0,a())},e.api.parameters.deep)}else a();break;case"selector":e.selector||t.asterix.instrumentation.logger.fatal(new Error("Expecting selector property for dataSourceType selector."));var l=i.configEvaluator.evaluate(e.selector,e.evaluationTypes||{model:!0,tokens:!0});if(!l.references||0===l.references.length)throw new Error("Failed to evaluate selector: "+e.selector);i._assignSelectorValue(r,l.evaluated||i._getDefaultData(r,e.defaults),l.evaluated?e.transformStack||e.transformPipeline:[],l.references[0],e),n.each(l.references,function(t){i._updateReferenceListener(t),i.unregisterFunctions.push(t.listen(function(){var n=l.reEvaluate();i._assignSelectorValue(r,n,e.transformStack||e.transformPipeline,t,e)}))});break;default:if(!e.dataSourceType)return;t.asterix.instrumentation.logger.fatal(new Error("dataSourceType: "+e.dataSourceType+" has not been implemented in modelBinder."))}},a.prototype._cloneAndStripMeta=function(e){return t.asterix.util.isPlainObject(e)||t.asterix.util.isArray(e)?(e=this._deepClone(e),t.asterix.util.each(Object.keys(e),function(t){0===t.indexOf("_$")&&delete e[t]}),e):e},a.prototype._cleanUpDataDefinitionObject=function(t){var e=[];t.dataSourceType?"api"===t.dataSourceType?(e.push("selector"),e.push("merge")):"selector"===t.dataSourceType&&e.push("api"):e=e.concat(["api","selector","transformStack","transformPipeline","dataSourceType","merge"]),e.forEach(function(e){delete t[e]})},a.prototype._assignCalculatedPropertyValue=function(e,r,i){var a=this,o=e;if(t.asterix.util.isPlainObject(o)&&(o=[o]),t.asterix.util.isArray(o)){var s={};n.each(r.properties,function(t,e){s[e]=[],n.each(o,function(t){null!=t[e]&&s[e].push(t)})}),n.each(r.aggregates,function(t,e){a._createCalculatedPropertyDescriptors(o,e,t,s,null)}),n.each(o,function(e){t.asterix.util.isPlainObject(e)||t.asterix.instrumentation.logger.fatal(new Error("Tried to add a calculated property to an array item that wasn't an object.")),n.each(r.properties,function(t,n){a._createCalculatedPropertyDescriptors(e,n,t,s,o)}),t.asterix.util.isPlainObject(r.children)&&n.each(r.children,function(n,r){a._assignCalculatedPropertyValue(t.asterix.util.parse(r)(e),n,[i,r].join("."))})})}},a.prototype._createCalculatedPropertyDescriptors=function(e,r,i,a,o){e.hasOwnProperty("__lock")||Object.defineProperty(e,"__lock",{enumerable:!1,value:{}});var s=this,l=Object.getOwnPropertyDescriptor(e,r);if(!l||!l.get){var u=(i.transformStack||i.transformPipeline||[]).slice(),c=null;if(i.onSet){c=["__",r].join("");var p=null!=e[c]?e[c]:null!=e[r]?e[r]:null;Object.defineProperty(e,["__",r].join(""),{value:p,writable:!0})}var d=new t.asterix.ConfigEvaluator(s.instanceId,t.asterix.instanceRegistry,t.asterix.context);Object.defineProperty(e,r,{enumerable:!0,get:function(){if(c&&null!=this[c])return this[c];if(!0===this.__lock[r])return null;if(!i.data)return null;this.__lock[r]=!0;var e=d.evaluate([i.data,u],null,{selfStatic:this,placeholders:{collection:o}});if(e.hasValues&&e.evaluated&&e.evaluated.length>1){if(e.evaluated[1].length){var n=t.asterix.ng.transforms.transform(e.evaluated[1],e.evaluated[0]);return this.__lock[r]=!1,n}return this.__lock[r]=!1,e.evaluated[0]}return this.__lock[r]=!1,null},set:function(e){var a=this,s=o?a._$parent||o:a;c?(this[c]=e,i.onSet&&i.onSet.sequence&&n.each(i.onSet.sequence,function(e){if(e.condition){if(!d.evaluate(e.condition,null,{selfStatic:a,placeholders:{collection:s}}).evaluated)return}if("set"===e.operation){var i=d.evaluate(e.target,null,{selfStatic:a,placeholders:{collection:s}}),l=d.evaluate(e.value,null,{selfStatic:a,placeholders:{collection:s}});i.references[0].assign(l.references.length?l.evaluated:e.value)}else"setAll"===e.operation?(o||t.asterix.instrumentation.logger.fatal(new Error("can't use setAll operation for aggregate properties")),n.each(s,function(t){if(e.condition){if(!d.evaluate(e.condition,null,{selfStatic:t,placeholders:{collection:s}}).evaluated)return}var n=d.evaluate(e.target,null,{selfStatic:t,placeholders:{collection:s}}),r=d.evaluate(e.value,null,{selfStatic:t,placeholders:{collection:s}});n.references[0].assign(r.references.length?r.evaluated:e.value)})):t.asterix.instrumentation.logger.fatal(new Error("unrecognized onSet operation for property "+r+" ("+e.operation+")"))})):t.asterix.instrumentation.logger.fatal(new Error("trying to set the value of a calculated (non-settable) property: "+r))}}),c&&a[r]&&a[r].indexOf(e)>-1&&(e[r]=e[r])}},a.prototype._mapCalculatedPaths=function(e,r){var i=this;if(r.definition){var a=this.configEvaluator.evaluate(r.definition,null,{extractPath:"definition"});a.hasValues&&(r=a.evaluated)}return n.each(r.properties,function(t,n){i._calculatedPaths.push([e,n].join("."))}),n.each(r.aggregates,function(t,n){i._calculatedPaths.push([e,n].join("."))}),t.asterix.util.isPlainObject(r.children)&&n.each(r.children,function(t,n){r.children[n]=i._mapCalculatedPaths([e,n].join("."),t)}),r},a.prototype._hookupCalculatedProperties=function(t,e){var n=this;e=n._mapCalculatedPaths(t,e),n.unregisterFunctions.push(n.instance.on("modelPropertyChanging:"+t,function(r){n._assignCalculatedPropertyValue(r,e,t)}));var r=n.instance.getModelProperty(t);r||(r={},n.instance.setModelProperty(t,r)),n._assignCalculatedPropertyValue(r,e,t)},a.prototype._recursivelyBind=function(e,r){var i=this;if(t.asterix.util.isPlainObject(e)){e.hasOwnProperty("dataSourceType")&&i._cleanUpDataDefinitionObject(e);var a=t.asterix.util.merge({},e);a.propagateChanges&&a.propagateChanges.trigger&&("auto"===a.propagateChanges.trigger&&i.unregisterFunctions.push(i.instance.on("modelPropertyChanged:"+r,function(){i._triggerSavePropagation(r,a)})),delete e.propagateChanges);var o=e.calculated;delete e.calculated,a.dataSourceType?i._bindDataSource(a,r):r&&this._hasDefaultData(r,e)?i._assignValue(r,this._getDefaultData(r,e.defaults)):n.each(e,function(t,e){!0!==i.options.editable||r||i.scope.$watch("model."+e,function(t){i.instance.setModelProperty(e,t)},!0),i._recursivelyBind(t,r?r+"."+e:e)}),t.asterix.util.isPlainObject(o)&&i._hookupCalculatedProperties(r,o)}else i._assignValue(r,e)},{get:function(e,n,r,i){return new a(e,new t.asterix.ConfigEvaluator(n,t.asterix.instanceRegistry,t.asterix.context),r,n,i)}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1),n(0)],void 0!==(i=function(t,e,n){var r={};t.module("mstarCore").factory("mstarModelValidate",function(){function t(t){return r[t.getModulePath()]}function i(e){n.asterix.instrumentation.logger.info("mstarModelValidate.bind()",{componentModulePath:e.getModulePath()}),r[e.getModulePath()]=[],t(e).push(e.on("deactivated",function(){o(e)})),s(e)}function a(){n.asterix.instrumentation.logger.info("mstarModelValidate.reset()"),e.each(r,function(t){e.each(t,function(t){t()})}),r={}}function o(n){e.each(t(n),function(t){t()}),delete r[n.getModulePath()]}function s(r){var i=r.getSettings()._validation&&r.getSettings()._validation.modelRules;if(i&&0!==Object.keys(i).length){var a=new n.asterix.ConfigEvaluator(r.getModulePath(),n.asterix.instanceRegistry,n.asterix.context);e.each(i,function(e,i){function o(){var t=r.getValidationState().getState(),a=s.reEvaluate(),o=n.asterix.ng.transforms.transform(a.transformPipeline,a.data);t[i]={returnValue:o===a.ok,rule:e},r.getValidationState().triggerUpdated()}var s=a.evaluate(e);o(),t(r).push(s.listen(o))})}}return{bind:i,reset:a}})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2)],void 0!==(i=function(t){t.module("mstarCore").factory("mstarSort",["$parse",function(e){function n(e){return t.isUndefined(e)||null===e}function r(t,e){return t<e?-1:t>e?1:0}return{updateParameters:function(t,e){if(morningstar.asterix.instrumentation.logger.info("mstarSort.updateParameters()",t,e),!t)throw"(mstarSort) Missing parameters.";if(!e)throw"(mstarSort) Missing field.";return t.sortField!==e?(t.sortField=e,t.sortOrder="asc"):"desc"===t.sortOrder?t.sortOrder="asc":t.sortOrder="desc",t},sort:function(t,i,a){if(morningstar.asterix.instrumentation.logger.info("mstarSort.sort()",t,i,a),t&&t.sort){var o=e(i.sortField);return t.sort(function(t,e){var s,l=o(t),u=o(e);return n(l)&&n(u)?0:n(l)?1:n(u)?-1:(a&&"string"==typeof l&&"string"==typeof u?(l=l.toLocaleLowerCase(),u=u.toLocaleLowerCase(),s=r(l,u)):s=r(l,u),"desc"===i.sortOrder?-s:s)}),i}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(1)],void 0!==(i=function(t){angular.module("mstarCore").factory("mstarState",["$rootScope","$location","$localStorage","$sessionStorage","mstarThrottle",function(t,e,n,r,i){return{_defaultOptions:function(t){return t=t||{},angular.extend({key:null,query:!0,local:!1,throttle:100,defaults:{}},t)},reset:function(t,e){morningstar.asterix.instrumentation.logger.info("mstarState.reset()",t,e),angular.forEach(Object.keys(t),function(e,n){delete t[n]}),angular.forEach(e,function(e,n){t[n]=e})},bind:function(a){if(morningstar.asterix.instrumentation.logger.info("mstarState.bind()",a),a=this._defaultOptions(a),!a.key)return a.defaults;var o={},s="session"===a.local?r:n;o[a.key]=a.defaults;var l,u=a.local?s.$default(o)[a.key]:a.defaults;if(!a.query)return u;var c=function(){var t=e.search()[a.key];if(t&&t!==l){l=t;try{t=angular.fromJson(t)}catch(t){return}angular.forEach(t,function(t,e){u[e]=t})}};return c(),t.$watchCollection(function(){return u},i(function(){l=angular.toJson(u),t.$evalAsync(function(){e.search(a.key,l)})},a.throttle,{leading:!1})),t.$on("$locationChangeSuccess",c),u}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(t,e){t.module("mstarCore").factory("mstarTemplate",["$compile",function(n){var r={};return{compile:function(i,a,o){e.asterix.instrumentation.logger.info("mstarTemplate.compile()",a,o),o=o||{};var s=null==o.keepRootElement||o.keepRootElement,l=o.template;if(e.asterix.util.isString(l)||e.asterix.instrumentation.logger.fatal(new Error("(mstarTemplate) options.template should be a string")),l){i.instance&&(l=e.asterix.ng.util.preProcessTemplate(i.instance,l,o));var u=r[l]=r[l]?r[l]:t.element(l);if(i.instance&&o.preProcessElement){var c=i.instance;o.preProcessElement.call({instance:c,settings:c.getSettings(),element:u,removeUnlessSettingIn:function(t,e,n){-1===n.indexOf(this.settings[e])&&this.element.find(t).remove()}})}!1===s&&(u[0].tagName!==a[0].tagName?s=!0:e.asterix.ng.util.mergeAttributes(u,a));var p=(!1===s?u.contents():u).clone();a.empty().append(p),n(a.contents())(i)}}}}])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2)],void 0!==(i=function(t){function e(){return{convertHTMLToPlainText:function(t){if(t&&"string"==typeof t){return t.valueOf().replace(/<\/?[a-z][a-z0-9]*[^<>]*>/gi,"")}return""}}}t.module("mstarCore").factory("mstarTextConvert",e)}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1),n(48)],void 0!==(i=function(t,e){function n(e){var n='<span class="mstar-tooltip__content--close"></span>';return function(r,i,a){function o(){x=!0,i.frosty("show")}function s(){x=!1,i.frosty("hide")}function l(){i.frosty("toggle")}function u(){var t=i.frosty("getContent");return t=t&&morningstar.asterix.util.isFunction(t.html)?t.html():t||"",t.replace(n,"")}function c(e){var r=t.element('<div class="mstar-tooltip__content">'+e+"</div>"),a=t.element(n);a.on("click",function(){i.frosty("hide")}),r.append(a),i.frosty("setContent",r)}function p(n){_&&_.destroy(),_=e(r,t.element(n)).addListener(function(t){f(t)}),i.frosty("setAnchor",morningstar.asterix.util.isDomElement(n)?n:n&&n[0])}function d(){return i.frosty("getState")||"hidden"}function f(t){var e=d();i.frosty("updatePosition"),x&&"hidden"===e&&t.visible?i.frosty("show"):"visible"===e&&(!1===t.visible||t.width<0||t.height<0)&&i.frosty("hide")}function g(){return y}function m(){C||(C=!0,i.frosty("destroy"),_&&_.destroy())}var h={};if(i&&i.length){if(i.controller){var v=i.controller("mstarComponentId");h=v&&v.getSettings().contains("tooltip")?v.getSettings().get("tooltip"):{}}var y=morningstar.asterix.util.merge({onHidden:function(){},onShown:function(){}},h,a||{}),x=!1;i.frosty(y),i.attr("mstar-tooltip-content")&&""!==i.attr("mstar-tooltip-content")&&i.addClass("mstar-tooltip-term");var _=e(r,i).addListener(function(t){f(t)},{width:!0,height:!0,offset:!0,visibility:!0}),C=!1;return r.$on("$destroy",m),{show:o,hide:s,getContent:u,setContent:c,updatePosition:f,toggle:l,destroy:m,getSettings:g,getState:d,setAnchor:p}}}}n.$inject=["mstarDimensions"],t.module("mstarCore").factory("mstarTooltip",n)}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1),n(0)],void 0!==(i=function(t,e,n){var r={};t.module("mstarCore").factory("mstarValidationMessageContainers",function(){function t(t){return r[t.getModulePath()]&&r[t.getModulePath()].unregisterCallbacks}function i(n,i){return r[n.getModulePath()]={unregisterCallbacks:[],handleMessages:i,instance:n,_setIsActive:function(t,r){if(this.isActive=r,r&&this.messages&&Object.keys(this.messages).length>0&&this.handleMessages(this.messages),t){var i=s(n);e.each(i,function(e){e._setIsActive(t,r)})}},activate:function(t){this._setIsActive(t,!0)},deactivate:function(t){this._setIsActive(t,!1)}},t(n).push(n.on("deactivated",function(){o(n)})),u(n),r[n.getModulePath()]}function a(){e.each(r,function(t){e.each(t.unregisterCallbacks,function(t){t()})}),r={}}function o(n){e.each(t(n),function(t){t()}),delete r[n.getModulePath()]}function s(t){return e.filter(r,function(e){return e.instance.getModulePath()!==t.getModulePath()&&0===e.instance.getModulePath().indexOf(t.getModulePath())})}function l(t,e){if(e.modulePath===t.getModulePath())return!1;if("self"===e.validationMessageHandlerType)return!0;for(var n=e.modulePath;n.length&&n!==t.getModulePath();){var i=r[n];if(i&&"self"===i.instance.getSettings()._validation.validationMessageHandlerType)return!0;n=n.substring(0,n.lastIndexOf("."))}return!1}function u(i){var a=i.getSettings()._validation&&i.getSettings()._validation;if(a){var o=r[i.getModulePath()];o.isActive="always"===a.messageWhen,"self"===a.validationMessageHandlerType?t(i).push(i.on("validationStateChanged",function(t,r,a){var s={};e.each(a,function(t,e){l(i,t)||(s[e]=n.asterix.util.merge({},t))}),o.messages=new n.asterix.ng.ValidationMessages(s),Object.keys(s).length&&o.isActive&&o.handleMessages(o.messages)})):a.validationMessageHandlerType}}return{register:i,reset:a}})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("arrayWrap",function(t){return[t]})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("booleanize",function(t){return!!t})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("defaultIfEmpty",function(t){var n=this.options.defaults;if(!e.isObject(n))throw new Error("defaultIfEmpty expects a defaults object");return e.each(n,function(e,n){null!==t[n]&&void 0!==t[n]||(t[n]=e)}),t})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("join",function(t){return t&&e.isArray(t)?t.join(this.options.separator):null})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("mapSingle",["arrayWrap",{name:"map",options:{criteria:{path:"criteria"}}},"first"])}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("split",function(t){return t&&e.isString(t)?t.split(this.options.separator):null})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("transformChildren",function(n){if(!this.options||!this.options.childMap)return n;var r=this.options.childMap;return e.each(r,function(e,r){var i=t.asterix.util.parse(r),a=i(n);i.assign(n,t.asterix.ng.transforms.transform(e,a))}),n})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("appendString",function(t){if(!this.options||!this.options.string)return t;var n=this.options.string;return e.isString(n)||this.context.instance.getLogger().fatal(new Error("appendString transform expects a string")),e.isString(t)||this.context.instance.getLogger().fatal(new Error("appendString transform can only be applied to a string")),t+n}),t.asterix.ng.transforms.register("prependString",function(t){if(!this.options||!this.options.string)return t;var n=this.options.string;return e.isString(n)||this.context.instance.getLogger().fatal(new Error("prependString transform expects a string")),e.isString(t)||this.context.instance.getLogger().fatal(new Error("prependString transform can only be applied to a string")),n+t});var n=["toLocaleLowerCase","toLocaleUpperCase","toLowerCase","toUpperCase","trim","trimLeft","trimRight"];e.each(n,function(n){t.asterix.ng.transforms.register(n,function(t){if(!e.isString(t))throw new Error(n+" transform can only be applied to a string");return t[n].apply(t,this.options)})})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1),n(46)],void 0!==(i=function(t,e,r){n(44);var i=["find","filter","where","size","sample","first","last","rest","compact","flatten","without","union","intersection","difference","zip","unzip","object","indexOf","lastIndexOf","range","reduce","reduceRight","map","uniq","propertyOf"];e.each(i,function(n){t.asterix.ng.transforms.register(n,function(t){var i;if(i=this.options?this.options.criteria:[],e.isArray(i)||(i=i?[i]:[]),r.transform(i),"propertyOf"==n){var a=[t];return e[n].apply(this,a)(i[0])}var a=i.slice();return a.unshift(t),e[n].apply(this,a)})})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";!function(){function t(){if(!n){var t=(v||"")+".resize-triggers { "+(y||"")+'visibility: hidden; opacity: 0; z-index: -1; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',e=document.head||document.getElementsByTagName("head")[0],r=document.createElement("style");r.type="text/css",r.styleSheet?r.styleSheet.cssText=t:r.appendChild(document.createTextNode(t)),e.appendChild(r),n=!0}}var e=document.attachEvent,n=!1;if(!e){var r=function(){var t=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||function(t){return window.setTimeout(t,20)};return function(e){return t(e)}}(),i=function(){var t=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.clearTimeout;return function(e){return t(e)}}(),a=function(t){var e,n,r,i=t.__resizeTriggers__;i&&(e=i.firstElementChild,n=i.lastElementChild,e&&(r=e.firstElementChild,n.scrollLeft=n.scrollWidth,n.scrollTop=n.scrollHeight,r.style.width=e.offsetWidth+2+"px",r.style.height=e.offsetHeight+2+"px",e.scrollLeft=e.scrollWidth,e.scrollTop=e.scrollHeight))},o=function(t){return t.offsetWidth!=t.__resizeLast__.width||t.offsetHeight!=t.__resizeLast__.height},s=function(t){var e=this;a(this),this.__resizeRAF__&&i(this.__resizeRAF__),this.__resizeRAF__=r(function(){o(e)&&(e.__resizeLast__.width=e.offsetWidth,e.__resizeLast__.height=e.offsetHeight,e.__resizeListeners__.forEach(function(n){n.call(e,t)}))})},l=!1,u="",c="animationstart",p="Webkit Moz O ms".split(" "),d="webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),f="",g=document.createElement("fakeelement");if(void 0!==g.style.animationName&&(l=!0),!1===l)for(var m=0;m<p.length;m++)if(void 0!==g.style[p[m]+"AnimationName"]){f=p[m],f+"Animation",u="-"+f.toLowerCase()+"-",c=d[m],l=!0;break}var h="resizeanim",v="@"+u+"keyframes "+h+" { from { opacity: 0; } to { opacity: 0; } } ",y=u+"animation: 1ms "+h+"; "}window.addResizeListener=function(n,r){e?n.attachEvent("onresize",r):(n.__resizeTriggers__||("static"==getComputedStyle(n).position&&(n.style.position="relative"),t(),n.__resizeLast__={},n.__resizeListeners__=[],(n.__resizeTriggers__=document.createElement("div")).className="resize-triggers",n.__resizeTriggers__.innerHTML='<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',n.appendChild(n.__resizeTriggers__),a(n),n.addEventListener("scroll",s,!0),c&&n.__resizeTriggers__.addEventListener(c,function(t){t.animationName==h&&a(n)})),n.__resizeListeners__.push(r))},window.removeResizeListener=function(t,n){e?t.detachEvent("onresize",n):(t.__resizeListeners__.splice(t.__resizeListeners__.indexOf(n),1),t.__resizeListeners__.length||(t.removeEventListener("scroll",s),t.__resizeTriggers__=!t.removeChild(t.__resizeTriggers__)))}}()},function(t,e,n){"use strict";!function(){function t(t){return["$rootScope","$window",function(e,n){for(var r,i,a,o=n[t]||(morningstar.asterix.instrumentation.warn("This browser does not support Web Storage!"),{}),s={$default:function(t){for(var e in t)angular.isDefined(s[e])||(s[e]=t[e]);return s},$reset:function(t){for(var e in s)"$"===e[0]||delete s[e];return s.$default(t)}},l=0;l<o.length;l++)(a=o.key(l))&&"ngStorage-"===a.slice(0,10)&&(s[a.slice(10)]=angular.fromJson(o.getItem(a)));return r=angular.copy(s),e.$watch(function(){i||(i=setTimeout(function(){if(i=null,!angular.equals(s,r)){angular.forEach(s,function(t,e){angular.isDefined(t)&&"$"!==e[0]&&o.setItem("ngStorage-"+e,angular.toJson(t)),delete r[e]});for(var t in r)o.removeItem("ngStorage-"+t);r=angular.copy(s)}},100))}),"localStorage"===t&&n.addEventListener&&n.addEventListener("storage",function(t){"ngStorage-"===t.key.slice(0,10)&&(t.newValue?s[t.key.slice(10)]=angular.fromJson(t.newValue):delete s[t.key.slice(10)],r=angular.copy(s),e.$apply())}),s}]}angular.module("ngStorage",[]).factory("$localStorage",t("localStorage")).factory("$sessionStorage",t("sessionStorage"))}()},function(t,e,n){"use strict";var r,i;r=[n(0)],void 0!==(i=function(t){function e(){if(t.asterix.ng)return void t.asterix.instrumentation.logger.warn("Tried to create morningstar.asterix.ng multiple times.");n(10),n(39),n(40),n(4),n(6),n(7),n(9),n(8),n(5),n(14),n(15),n(20),n(26),n(11),n(25),n(24),n(16),n(22),n(19),n(17),n(27),n(28),n(12),n(21),n(13),n(18),n(23),n(29),n(36),n(38),n(30),n(34),n(35),n(33),n(32),n(37),n(31)}return e(),{createAsterixNg:e}}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(1)],void 0!==(i=function(t){function e(t){this._messages=t}return e.prototype.getAll=function(){return this._messages},e.prototype.getErrors=function(){return t.filter(this._messages,function(t){return!1===t.returnValue})},e.prototype.getActiveErrors=function(){return t.filter(this._messages,function(t){return!1===t.returnValue&&!0===t.showMessage})},e}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(0)],void 0!==(i=function(t,e){function n(t,n){if(e.asterix.instrumentation.logger.info("transform.registerTransform()",t,n),m.hasOwnProperty(t))return void e.asterix.instrumentation.logger.warn("Tried to add transform with the name "+t+" multiple times!");e.asterix.util.isArray(n)&&(n=r(n)),m[t]=n}function r(t){return function(n){var r=this.options,i=l(t);return e.asterix.util.each(i,function(t,n){e.asterix.util.isPlainObject(t)&&e.asterix.util.each(t.options,function(n,i){n&&n.path&&(t.options[i]=e.asterix.util.parse(n.path)(r))})}),u(i,n,this.context)}}function i(t){e.asterix.instrumentation.logger.info("transform.removeTransform()",t),m[t]&&delete m[t]}function a(){e.asterix.instrumentation.logger.info("transform.reset()"),m={}}function o(t,n,r){(r&&r.instance?r.instance.getLogger():e.asterix.instrumentation.logger).info("transform.transformCloned()",t,n,r);var n=l(n);return u.apply(this,[t,n,r])}function s(t,n,r){(r&&r.instance?r.instance.getLogger():e.asterix.instrumentation.logger).info("transform.transformAsyncCloned()",t,n,r);var n=l(n);return c.apply(this,[t,n,r])}function l(t){return h.isPlainObject(t)?e.asterix.extend(!0,{},t):h.isArray(t)?e.asterix.extend(!0,[],t):t}function u(t,n,r){var i=(r&&r.instance?r.instance.getTracer():e.asterix.instrumentation.tracer).startTrace("transform.transform()"),a=d(t),o=new f(a,n,r).run();return i.end({transformPipeline:t,data:n,context:r,result:o}),o}function c(t,n,r){var i=(r&&r.instance?r.instance.getTracer():e.asterix.instrumentation.tracer).startTrace("transform.transformAsync()"),a=d(t),o=new f(a,n,r).runAsync();return o.catch(function(e){i.end({transformPipeline:t,data:n,context:r,status:"error",result:e})}).then(function(e){i.end({transformPipeline:t,data:n,context:r,status:"success",result:e})}),o}function p(t){var e=d(t);return!e||0===e.length}function d(t){if(h.isUndefined(t)||null===t||h.isArray(t))return t;if(h.isString(t)||h.isObject(t))return[t];throw"_getNormalisedPipeline: unsupported type for transformPipeline: "+t.toString()}function f(t,n,r){function i(){return s(t,l)}function a(){return v=!0,g(function(e,n){f=n,d=e,p={resolve:e,reject:n},s(t,u)})}function o(){if(x.debug("transform._terminate",t,y,n,r),!v)return y;p.resolve(y)}function s(t,e){if(!t||!t.length)return o();var n=c(t[0]);return x.debug("transform._executeNext",n,y),n.transform?e(t,n):o()}function l(t,e){return y=e.transform.apply(e.thisObj,[y]),s(t.slice(1),l)}function u(t,e){var n=e.transform.apply(e.thisObj,[y]);n&&h.isFunction(n.then)?n.then(function(e){y=e,s(t.slice(1),u)},function(t){p.reject(t)}):(y=n,s(t.slice(1),u))}function c(t){return h.isPlainObject(t)?{name:t.name,transform:m[t.name],thisObj:{options:t.options,context:r,origData:n}}:{name:t,transform:m[t],thisObj:{context:r,origData:n}}}var p,d,f,v=!1,y=n,x=r&&r.instance?r.instance.getLogger():e.asterix.instrumentation.logger;return x.info("TransformPipelineWorker.ctor()",t,n,r),{run:i,runAsync:a}}var g=t.injector(["ng"]).get("$q"),m={},h=e.asterix.util;return n("apiWrapObjectPath",function(t){if(!this.options||!this.options.path)throw"apiWrapObjectPath: options.path not specified";var e={},n=this.options.path;return h.parse(n).assign(e,t),e}),n("apiUnwrapObjectPath",function(t){if(!this.options||!this.options.path)throw"apiUnwrapObjectPath: options.path not specified";var e=this.options.path;return h.parse(e)(t)}),n("wrapObjectPath",function(t){if(!this.options||!this.options.path)throw"wrapObjectPath: options.path not specified";var e=this.options.path,n={};return h.parse(e).assign(n,t),n}),n("unwrapObjectPath",function(t){if(!this.options||!this.options.path)throw"unwrapObjectPath: options.path not specified";var e=this.options.path;return h.parse(e)(t)}),{transformCloned:o,transform:u,transformAsyncCloned:s,transformAsync:c,register:n,remove:i,isPipelineEmpty:p,reset:a}}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){t.asterix.ng.transforms.register("pluck",function(n){if(!n)return n;var r=this.options?this.options.criteria||[]:[];r.length||t.asterix.instrumentation.logger.fatal(new Error("transform underscore/pluck expects a propName as its first criteria"));var i=r[0],a=t.asterix.util.parse(i);return e.map(n,a)})}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1)],void 0!==(i=function(t,e){function n(e,n){return T[e]||t.asterix.instrumentation.logger.fatal(new Error("couldn't find predefined fn: "+e)),function(){var t=Array.prototype.slice.call(arguments);return T[e].apply({args:n},t)}}function r(t,e){return t+w(this,e)}function i(t,e){return t-w(this,e)}function a(t,e){return t*w(this,e)}function o(t,e){return t/w(this,e)}function s(n){if(!n)return n;var r={};return e.isObject(this.args)?e.each(this.args,function(e,i){t.asterix.util.parse(i).assign(r,t.asterix.util.parse(e)(n))}):e.isString(this.args)?r=t.asterix.util.parse(this.args)(n):t.asterix.instrumentation.logger.fatal(new Error("unrecognized type of args for predefined fn select")),r}function l(t){return t?(t=w(this,t),isNaN(t)?null:t+P(this)):t}function u(t){return t?(t=w(this,t),isNaN(t)?null:t-P(this)):t}function c(t){return t?(t=w(this,t),isNaN(t)?null:t/P(this)):t}function p(t){return t?(t=w(this,t),isNaN(t)?null:t*P(this)):t}function d(t){return(t=w(this,t))>P(this)}function f(t){return(t=w(this,t))<P(this)}function g(t){return(t=w(this,t))>=P(this)}function m(t){return(t=w(this,t))<=P(this)}function h(t){return(t=w(this,t))===P(this)}function v(t){return t=w(this,t),e.isArray(t)?!t.length:null==t}function y(t){return t=w(this,t),!v(t)}function x(n){return e.isObject(this.args)||t.asterix.instrumentation.logger.fatal(new Error("startsWith expects property and value as args")),n=w(this,n),!!e.isString(n)&&n.indexOf(P(this))>-1}function _(t){t=w(this,t);var r=!1;return e.each(this.args,function(e){r||n(e.fn,e.args)(t)&&(r=!0)}),r}function C(t){t=w(this,t);var r=!0;return e.each(this.args,function(e){r&&(n(e.fn,e.args)(t)||(r=!1))}),r}function b(t){return t=w(this,t),!n(this.args.fn,this.args.args)(t)}function P(t){return e.isObject(t.args)?t.args.value:t.args}function w(n,r){return n&&e.isString(n.args)?t.asterix.util.parse(n.args)(r):n&&n.args&&e.isString(n.args.property)?t.asterix.util.parse(n.args.property)(r):r}function S(t){if(!t)return t;if(!e.isObject(this.args))throw new Error("defaultIfEmpty expects a defaults object");return e.each(this.args.defaults,function(e,n){null!==t[n]&&void 0!==t[n]||(t[n]=e)}),t}var T={sum:r,difference:i,product:a,quotient:o,select:s,add:l,subtract:u,divide:c,multiply:p,gt:d,eq:h,lt:f,gte:g,lte:m,empty:v,nonEmpty:y,and:C,or:_,not:b,startsWith:x,defaultIfEmpty:S};return{factory:n}}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(0),n(1),n(45)],void 0!==(i=function(t,e,n){function r(t){t.length&&e.each(t,function(e,r){e.fn&&(t[r]=n.factory.apply(this,[e.fn,e.args]))})}return{transform:r}}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r,i;r=[n(2),n(1),n(0)],void 0!==(i=function(t,e,n){function r(t,e){for(var n=t[0].attributes,r=0;r<n.length;r++){var i=n[r];if(i.specified){var a=i.name,o=i.value,s=e.attr(a);if(o!==s){var l=void 0===s?o:o+" "+s;e.attr(a,l)}}}}function i(e){try{t.module(e)}catch(t){return!1}return!0}function a(t){for(var e=[];t.length;){var n=t.attr("mstar-component-id");if(n){if(-1!==n.indexOf("[")&&(n=n.replace(/\[.*?\]/,"")),-1!==n.indexOf("{{"))return null;e.unshift(n)}t=t.parent().closest("[mstar-component-id]")}for(var r=e.length,i=1;i<=r;i++){var a=e.slice(0,i).join(".");d.skipInFullIdentifier(a)&&(e.splice(i-1,1),r--)}return e.join(".")}function o(t){if(g[t])return g[t];var e=n.asterix.instanceRegistry.find(t);if(!e)return g[t]=!0;var r=n.asterix.meta.findTypesWhere("skipInFullIdentifier",!0);return g[t]=-1!==r.indexOf(e.getModuleType())}function s(e,r){r=r||{};var i=r.keepRootElement||!0;return function(o,s){var l=a(o);if(l){var u=n.asterix.instanceRegistry.find(l);if(u){var c=u.getSettings(),d=n.asterix.util.parse(e)(c);if(d){u._preCompiledTemplates=[e],d=p(u,d);var f=t.element(d);return r.preProcessElement&&r.preProcessElement.call({instance:u,settings:u.getSettings(),element:f,removeUnlessSettingIn:function(t,e,n){-1===n.indexOf(this.settings[e])&&this.element.find(t).remove()}}),!1===i&&(f[0].tagName!==o[0].tagName?i=!0:n.asterix.ng.util.mergeAttributes(f,o)),d=i||1!==f.length?t.element("<div/>").append(f).html():f[0].innerHTML,n.asterix.instrumentation.logger.debug("ngUtil.createTemplateFunction",d,{componentModulePath:l}),d}}}}}function l(t,e){return n.asterix.util.isString(e)?n.asterix.util.string.dashCase(t+n.asterix.util.string.firstUpperCase(e)):n.asterix.util.string.dashCase(t)}function u(t,e){var r=t+e||"NO_BEM";if(f[r])return f[r];if(t&&e){var i="-";return"-"!=e.charAt(0)&&"_"!=e.charAt(0)||(i=""),f[r]=n.asterix.util.string.dashCase(t)+i+e}return f[r]=t?n.asterix.util.string.dashCase(t):e}function c(t,e,r){var i=[];return t&&!e&&i.push(t),!n.asterix.util.isString(r)||t&&e?i.push(null==r?""+r:r):(i.push("'"),i.push(null==r?""+r:r.replace(/\'/g,"\\'")),i.push("'")),e&&!t&&i.push(e),i}function p(t,e,r){var i=n.asterix.instrumentation.tracer.startTrace("ngUtil.preProcessTemplate",{componentModulePath:t.getModulePath()}),a=t.getSettings(),o=t.getLabels();return a.namespaceClass&&(e=e.replace(/\{\{\s*(namespaceClass\(['"]?([^'")]*?)['"]?\))\s*\}\}/g,function(t,e,n){return u(a.namespaceClass,n)})),e=e.replace(/\{\{\s*(namespaceId\(['"]?([^'")]*?)['"]?\))\s*\}\}/g,function(e,n,r){return l(t.getModulePath(),r)}),a&&(e=e.replace(/(\{\{)?[\s\r\n\t]*(::)?[\s\n\r\t]*(settings\.get\(['"]?([^'")]*?)['"]?\))\s*(\}\})?/g,function(t,e,r,i,o,s){if(!o||/[tT]emplates/.test(o))return t;var l=n.asterix.util.parse(o)(a);return n.asterix.util.isPlainObject(l)||n.asterix.util.isArray(l)?t:n.asterix.util.isString(l)?t:c(e,s,l).join("")})),o&&(e=e.replace(/(\{\{)?[\s\n\r\t]*(::)?[\s\n\r\t]*(labels\.get\(['")]?([^'")]*?)['"]?\))\s*(\}\})?/g,function(t,e,n,r,i,a){return o[i]?c(e,a,o[i]).join(""):t})),t._preProcessedTemplates=t._preProcessedTemplates||[],t._preProcessedTemplates.push(e),e=e.replace('mwc-id-tag="','mwc-id="'+t.modulePath+"."),i.end({template:e}),e}var d,f={},g={};return d={angularModuleExists:i,mergeAttributes:r,getPreCompilationInstanceId:a,createTemplateFunction:s,preProcessTemplate:p,namespaceClass:u,namespaceId:l,skipInFullIdentifier:o}}.apply(e,r))&&(t.exports=i)},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(t,e,n,i){function a(e,n){this.anchor=e,this.$anchor=t(e),this.options=t.extend({},s,n,this.$anchor.data()),this._defaults=s,this._name=o,this.init()}var o="frosty",s={attribute:"mstarTooltipContent",classes:"mstar-tip",content:"",delay:0,hasArrow:!0,html:!1,offset:10,position:"top",removeTitle:!0,selector:!1,smartReposition:!0,trigger:"hover",zIndex:100,onHidden:function(){},onShown:function(){}};a.prototype={init:function(){this.rid=Math.random().toString(36).substr(2,16),this._createTip(),this._bindEvents()},_createTip:function(){this.options.html||this.options.content?this.tipContent=this.options.content:this.options.selector?this.tipContent=t(this.options.selector).html():this.tipContent=this.$anchor.attr(this.options.attribute),"title"===this.options.attribute&&this.options.removeTitle&&(this.$anchor.attr("data-original-title",this.tipContent),this.$anchor.removeAttr("title")),this.$el=t("<div />",{class:this.options.classes,html:this.tipContent}).css({"z-index":this.options.zIndex,left:"-9999px",position:"absolute"}),this.$el.appendTo("body");var e=this;e.$el.detach(),morningstar.asterix.util.fastdom.measure(function(){var t=e._getPosition();t=e._checkOverflow(t),e.$el.css(t),e.options.hasArrow&&e._addArrowClass()})},_bindEvents:function(){switch(this.options.trigger){case"click":this.$anchor.on("click."+o,t.proxy(this.toggle,this));break;case"manual":break;case"focus":this.$anchor.on("focus."+o,t.proxy(this.show,this)),this.$anchor.on("blur."+o,t.proxy(this.hide,this));break;default:this.$anchor.on("mouseenter."+o,t.proxy(this.show,this)),this.$anchor.on("mouseleave."+o,t.proxy(this.hide,this))}t(e).on("resize."+this.rid,t.proxy(this._setPosition,this))},_setState:function(t){switch(this.state=t,t){case"visible":if(this._checkContent(),!this.tipContent||!this.$anchor.is(":visible"))return void this._setState("hidden");this.$el.appendTo("body"),this._setPosition(),this.options.onShown.call(this),this.$anchor.triggerHandler("shown");break;case"hidden":this.$el.detach(),this.options.onHidden.call(this),this.$anchor.triggerHandler("hidden")}},_checkContent:function(){this.options.selector&&(this.tipContent=t(this.options.selector).html(),this.$el.html(this.tipContent))},_addArrowClass:function(t){switch(t||this.options.position){case"left":this.$el.addClass("mstar-arrow-right");break;case"right":this.$el.addClass("mstar-arrow-left");break;case"bottom":this.$el.addClass("mstar-arrow-top");break;default:this.$el.addClass("mstar-arrow-bottom")}},_getPosition:function(t){var e=this.$anchor.offset();switch(t||this.options.position){case"left":e.left=e.left-this.$el.outerWidth()-this.options.offset,e.top=e.top+this.$anchor.outerHeight()/2-this.$el.outerHeight()/2;break;case"right":e.left=e.left+this.$anchor.outerWidth()+this.options.offset,e.top=e.top+this.$anchor.outerHeight()/2-this.$el.outerHeight()/2;break;case"bottom":e.top=e.top+this.$anchor.outerHeight()+this.options.offset,e.left=e.left+this.$anchor.outerWidth()/2-this.$el.outerWidth()/2;break;default:e.top=e.top-this.$el.outerHeight()-this.options.offset,e.left=e.left+this.$anchor.outerWidth()/2-this.$el.outerWidth()/2}return e},_checkOverflow:function(n){if(!this.options.smartReposition)return n;var r=this.options.position,i=r;return this.prevPosition=this.prevPosition||r,n.top<0&&(i="bottom"),n.top+this.$el.height()>t(e).height()&&(i="top"),n.left<0&&(i="right"),n.left+this.$el.width()>t(e).width()&&(i="left"),this.prevPosition===i&&i===r||(this.prevPosition=i,n=this._getPosition(i),n.top=n.top>0?n.top:0,n.left=n.left>0?n.left:0,this.$el.attr("class",this.options.classes),this._addArrowClass(i)),n},_setPosition:function(){var t=this;morningstar.asterix.util.fastdom.measure(function(){var e=t._getPosition();e=t._checkOverflow(e),morningstar.asterix.util.fastdom.mutate(function(){t.$el.css(e)})})},show:function(){var t=this,e="object"===r(this.options.delay)?parseInt(this.options.delay.show,10):parseInt(this.options.delay,10);clearTimeout(this.timeout),this.timeout=0===e?this._setState("visible"):setTimeout(function(){t._setState("visible")},e)},hide:function(){var t=this,e="object"===r(this.options.delay)?parseInt(this.options.delay.hide,10):parseInt(this.options.delay,10);clearTimeout(this.timeout),this.timeout=0===e?this._setState("hidden"):setTimeout(function(){t._setState("hidden")},e)},toggle:function(){"visible"===this.state?this.hide():this.show()},addClass:function(t){"string"==typeof t&&this.$el.addClass(t)},removeClass:function(t){"string"==typeof t&&this.$el.removeClass(t)},setContent:function(t){this.tipContent=t,this.$el.html(t)},getContent:function(){return this.tipContent},getState:function(){return this.state},setAnchor:function(e){this.anchor=e,this.$anchor=t(e),this._setPosition()},destroy:function(){t(e).off("resize."+this.rid),this.$el.hide(),this.$anchor.removeData("plugin_"+o),this.$anchor.off("."+o),this.$el.remove()}},t.fn[o]=function(e,n){if("string"!=typeof e)return this.each(function(){t.data(this,"plugin_"+o)||t.data(this,"plugin_"+o,new a(this,e))});var r=[];return this.each(function(){if(t.data(this,"plugin_"+o))switch(e){case"show":t.data(this,"plugin_"+o).show();break;case"hide":t.data(this,"plugin_"+o).hide();break;case"toggle":t.data(this,"plugin_"+o).toggle();break;case"addClass":t.data(this,"plugin_"+o).addClass(n);break;case"removeClass":t.data(this,"plugin_"+o).removeClass(n);break;case"destroy":t.data(this,"plugin_"+o).destroy();break;case"setContent":t.data(this,"plugin_"+o).setContent(n);break;case"getContent":r.push(t.data(this,"plugin_"+o).getContent());break;case"getState":r.push(t.data(this,"plugin_"+o).getState());break;case"updatePosition":t.data(this,"plugin_"+o)._setPosition();break;case"setAnchor":t.data(this,"plugin_"+o).setAnchor(n)}}),1===r.length?r[0]:void 0}}(jQuery,window,document)},function(t,e){t.exports='<div class="mstar-modal-overlay">\r\n    <div class="row">\r\n        <div class="col-xs-12 col-sm-12">\r\n            <div ng-repeat="m in messages" class="mstar-u-alert mstar-u-alert-{{m.type}}">{{m.message}}</div>\r\n        </div>\r\n    </div>\r\n    <div class="row">\r\n        <div class="col-xs-12">\r\n            <div class="text-right">\r\n                <div class="mstar-u-capsuleStyleButton mstar-u-btn--close mstar-u-btn--widthUnset" ng-click="close()">{{okButtonLabel}}</div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="mstar-modal-fade"></div>'},function(t,e){t.exports='<div class="mstar-modal-overlay">\r\n    <div class="row">\r\n        <div class="col-xs-12 col-sm-12">\r\n            <div ng-repeat="m in messages" class="mstar-u-alert mstar-u-alert-{{m.type}}">{{m.message}}</div>\r\n        </div>\r\n    </div>\r\n    <div class="row">\r\n        <div class="col-xs-12">\r\n            <div class="text-right">\r\n                <div class="mstar-u-capsuleStyleButton mstar-u-btn--cancel mstar-u-btn--widthUnset" ng-click="cancel()">{{cancelButtonLabel}}</div>\r\n                <div class="mstar-u-capsuleStyleButton mstar-u-btn--close mstar-u-btn--widthUnset" ng-click="ok()">{{okButtonLabel}}</div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="mstar-modal-fade"></div>'},function(t,e){t.exports='<div class="mstar-dragdrop-proxy">PROXY</div>'},function(t,e){t.exports='<div class="mstar-modal__content">\r\n    <div data-mstar-include="modalContent"></div>\r\n    <div data-ng-click="closeModal()" class="mstar-modal__close-btn"></div>\r\n</div>\r\n<div class="mstar-modal__mask" data-ng-click="closeModal()"></div>\r\n'}]);
//# sourceMappingURL=asterix-ng.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
}();

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 11);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 1 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        return {
            generateBaseUrlParameters: generateBaseUrlParameters,
            updateEUUrlParameters: updateEUUrlParameters,
            updateUSUrlParameters: updateUSUrlParameters
        };

        function generateBaseUrlParameters(context) {
            return {
                languageId: context.settings.get('languageId'),
                currencyId: context.settings.get('currencyId'),
                filters: context.parameters.filters,
                maxRows: context.parameters.maxRows,
                sortField: context.parameters.sortField,
                sortOrder: context.parameters.sortOrder,
                universeId: context.parameters.universeId,
                securityDataPoints: context.parameters.securityDataPoints,
                search: context.parameters.search,
                subUniverseId: context.parameters.subUniverseId,
                priceDate: context.parameters.priceDate
            };
        }

        function updateUSUrlParameters(context, urlParameters) {
            var apiGatewayToken = morningstar.asterix.context.getToken('apiGatewayToken'),
                apiKey = morningstar.asterix.context.getToken('apiKey'),
                accessToken = morningstar.asterix.context.getToken('accessToken');

            if (!(apiGatewayToken || apiKey || accessToken)) {
                context.instance.getLogger().fatal('Missing authentication key: apiGatewayToken or apiKey or accessToken.');
            }

            if (apiGatewayToken) {
                urlParameters.apiTokenType = '';
                urlParameters.apiTokenValue = '';
                urlParameters.baseUrl = context.settings.get('baseUrlApiGatewayUS');
            } else {
                urlParameters.baseUrl = context.settings.get('baseUrlMorningstarUS');
                if (accessToken) {
                    urlParameters.apiTokenType = 'access_token';
                    urlParameters.apiTokenValue = accessToken;
                } else if (apiKey) {
                    urlParameters.apiTokenType = 'apikey';
                    urlParameters.apiTokenValue = apiKey;
                }
            }
        }

        function updateEUUrlParameters(context, urlParameters) {
            urlParameters.baseUrl = context.settings.get('baseUrlMorningstarEU');
            urlParameters.urlKey = context.parameters.urlKey;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 2 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15), __webpack_require__(0), __webpack_require__(2), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, $) {
        'use strict';

        angular.module('ecAutocomplete', ['mstarCore', 'ecInput']).directive('ecAutocomplete', ['$document', autocomplete]);

        var instances = [];
        var clickOutsideCloseResult = function clickOutsideCloseResult(event) {
            _.each(instances, function (instance) {
                if (instance.element.find(event.target).length > 0) {
                    return;
                }
                if (instance.scope.showResult) {
                    instance.scope.$applyAsync(function () {
                        instance.scope.showResult = false;
                    });
                }
            });
        };
        var oldParams = {
            selectedSecurity: null
        };

        $('body').on('click', clickOutsideCloseResult);

        function autocomplete($document) {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {
                    ngModel: '=?'
                },
                template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
                link: linkFn
            };

            function linkFn(scope, elem, attr, mstarComponent) {
                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // compiles the main template
                mstarComponent.compileTemplate(scope, '_templates.main');

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
                mstarComponent.bindModelData(scope);
                // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

                var componentId = mstarComponent.getComponentId(),
                    usageTrackingHitMap = scope.settings.get('usageTrackingHitMap');
                instances.push({ componentId: componentId, scope: scope, element: elem });
                scope.showResult = false;
                scope.hasSearch = false;
                scope.ngModel = scope.ngModel || {};
                scope.instance.setParameter('latestSelectedSecurity', morningstar.asterix.extend(true, {}, scope.ngModel));

                var setSelectedSecurityText = function setSelectedSecurityText(newValue) {
                    if (newValue && scope.settings.get('showSearchText')) {

                        if (newValue.name && scope.instance.parameters.search !== newValue.name || newValue.legalName && scope.instance.parameters.search !== newValue.legalName) {
                            usageTracking(usageTrackingHitMap.searchedText, 'text=' + scope.instance.parameters.search);
                        }

                        scope.instance.parameters.search = newValue.name || newValue.legalName || scope.instance.parameters.search;

                        if (newValue.secId && oldParams.selectedSecurity !== newValue.secId) {
                            usageTracking(usageTrackingHitMap.selectedSecurity, newValue.secId);
                            oldParams.selectedSecurity = newValue.secId;
                        }
                    } else {
                        scope.instance.parameters.search = '';
                    }
                };

                var usageTracking = function usageTracking(hitObj, hitValue) {
                    if (hitValue) {
                        hitObj.value = hitValue;
                    }
                    scope.usageTracker.trackHit(hitObj);
                };

                var restoreResults = function restoreResults() {
                    if (scope.instance.getParameter('search') && scope.instance.getParameter('search').length >= scope.settings.get('minSearchSize')) {
                        scope.showResult = true;
                    }
                };

                setSelectedSecurityText(scope.ngModel);
                scope.$watch('ngModel', setSelectedSecurityText, true);

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:search', function (newValue) {
                    var minSearchSize = scope.settings.get('minSearchSize');
                    if (newValue && newValue.length >= minSearchSize && (!scope.ngModel || newValue !== scope.ngModel.name && newValue !== scope.ngModel.legalName)) {
                        scope.loading = scope.namespaceClass('search--loading');
                        scope.hasSearch = true;
                    } else if (!newValue) {
                        scope.hasSearch = false;
                        scope.loading = '';
                        scope.selectItem(null);
                    } else {
                        scope.hasSearch = false;
                        scope.loading = '';
                    }
                    if (minSearchSize > newValue.length) {
                        scope.instance.setModelProperty('securities', []);
                    }
                    checkNoResultsDisplayCondition();
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:securities', function (newValue) {
                    if (!newValue.error) {
                        scope.loading = newValue._$isLoading ? scope.loading : '';
                        if (newValue && newValue.rows && newValue.rows.length > 0 && scope.parameters.search.length >= scope.settings.get('minSearchSize')) {
                            if (scope.settings.get('groupBy').length > 0) {
                                var groupBySecurities = _.groupBy(newValue.rows, scope.settings.get('groupBy'));
                                var securities = [];
                                for (var groupName in groupBySecurities) {
                                    var newGroupLabelName = groupName;
                                    if (scope.settings.get('groupBy') === 'holdingTypeId') {
                                        newGroupLabelName = 'holdingTypeId' + newGroupLabelName;
                                    }

                                    if (scope.labels.contains(newGroupLabelName)) {
                                        newGroupLabelName = scope.labels.get(newGroupLabelName);
                                    }
                                    securities.push({ group: true, name: newGroupLabelName });
                                    _.each(groupBySecurities[groupName], function (currSecurity) {
                                        securities.push(currSecurity);
                                    });
                                }
                                scope.securities = securities;
                            } else {
                                scope.securities = newValue.rows;
                            }
                            scope.showResult = true;
                        } else {
                            scope.showResult = false;
                            scope.securities = [];
                        }

                        scope.focusIndex = -1;
                        checkNoResultsDisplayCondition();
                    }
                }));

                function checkNoResultsDisplayCondition() {
                    scope.showNoResults = (!scope.securities || !scope.securities.length) && !scope.showResult && scope.parameters.search.length >= scope.settings.get('minSearchSize') && scope.parameters.search !== scope.ngModel.name;
                }

                function setPropagatedFields(security) {
                    _.each(scope.settings.get('propagatedFields'), function (to, from) {
                        scope.ngModel[to] = angular.copy(security[from]);
                    });
                    setSelectedSecurityText(scope.ngModel);
                }

                scope.selectItem = function (security, selectedIndex) {
                    if (!security || security.group) {
                        setPropagatedFields({});
                    } else {
                        _.each(scope.settings.get('propagatedFields'), function (to, from) {
                            scope.parameters.latestSelectedSecurity[to] = angular.copy(security[from]);
                        });
                        setPropagatedFields(security);
                    }

                    scope.showResult = false;

                    if (selectedIndex) {
                        elem.find('.' + scope.namespaceClass('container__item')).attr('aria-selected', false);
                        elem.find('.' + scope.namespaceClass('container__item_' + selectedIndex)).attr('aria-selected', true);
                    }
                };

                scope.focusIndex = 0;
                scope.showAriaDescribedBy = scope.settings.get('showAriaDescribedBy');

                var keyActions = {
                    // enter keyCode 13
                    '13': function securitySelect() {
                        if (scope.focusIndex >= 0 && scope.focusIndex < scope.securities.length) {
                            scope.selectItem(scope.securities[scope.focusIndex], scope.focusIndex);
                        }
                    },
                    // arrow up keyCode 38
                    '38': function highlightPrevSecurity() {
                        if (scope.focusIndex > 0) {
                            scope.highlight(false);
                        }
                    },
                    // arrow down keyCode 40
                    '40': function highlightNextSecurity() {
                        if (!scope.showResult) {
                            restoreResults();
                        }
                        if (scope.securities) {
                            if (scope.focusIndex === -1 || scope.focusIndex < scope.securities.length - 1) {
                                scope.highlight(true);
                            }
                        }
                    }
                };

                elem.off('keydown').on('keydown', function onAutocompleteKeydown(event) {
                    if (keyActions[event.keyCode]) {
                        keyActions[event.keyCode]();
                        event.preventDefault();
                        scope.$apply();
                    }
                });

                scope.$on('$destroy', function () {
                    scope.parameters.search = null;
                    scope.model.securities = null;
                    scope.securities = null;

                    var foundIndex = _.findIndex(instances, function (id) {
                        return id === componentId;
                    });
                    if (foundIndex >= 0) {
                        instances.splice(foundIndex, 1);
                    }

                    if (instances.length === 0) {
                        $document.find('body').off('click', clickOutsideCloseResult);
                    }
                });

                scope.highlight = function (isDown) {
                    var highlightedClass = scope.namespaceClass('container__item--highlighted');
                    var preHighlighted = elem.find('.' + highlightedClass);

                    if (scope.focusIndex === -1 && isDown) {
                        scope.focusIndex++;
                    }
                    if (preHighlighted.length) {
                        preHighlighted.removeClass(highlightedClass);
                        if (isDown) {
                            scope.focusIndex++;
                        } else {
                            scope.focusIndex--;
                        }
                    }

                    var highBottom, highTop, maxHeight, visibleBottom, visibleTop;
                    var highlighted = elem.find('.' + scope.namespaceClass('container__item_' + scope.focusIndex));
                    var searchResult = elem.find('.' + scope.namespaceClass('container__results'));
                    var input = elem.find('input');

                    input.attr('aria-activedescendant', highlighted.attr('id'));
                    highlighted.addClass(highlightedClass);
                    maxHeight = parseInt(searchResult.css('maxHeight'), 10);
                    visibleTop = searchResult.scrollTop();
                    visibleBottom = maxHeight + visibleTop;
                    highTop = highlighted.position().top + searchResult.scrollTop();
                    highBottom = highTop + highlighted.outerHeight();
                    if (highBottom >= visibleBottom) {
                        searchResult.scrollTop(highBottom - maxHeight > 0 ? highBottom - maxHeight : 0);
                    } else if (highTop < visibleTop) {
                        searchResult.scrollTop(highTop);
                    }
                };

                // Adding event listener when search input is focused to show the results list if available
                elem.find('ec-input').on('focusin', function (e) {
                    if (scope.settings.get('restoreResultsOnFocus')) {
                        restoreResults();
                    }
                });
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
        'use strict';

        var dataPointMapping = _.invert(__webpack_require__(14));

        morningstar.asterix.ng.transforms.register('fromAutocomplete', function (data) {
            var newDataRow,
                newDataRows = [];
            if (data && data.rows && data.rows.length) {
                morningstar.asterix.util.each(data.rows, function (dataRow) {
                    newDataRow = {};
                    morningstar.asterix.util.each(dataRow, function (value, key) {
                        newDataRow[dataPointMapping[key] || key] = value;
                    });
                    newDataRows.push(newDataRow);
                });
                data.rows = newDataRows;
            }
            return data;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromPortfolioAPIAutocomplete', function (securities) {
            var data = _.filter(morningstar.asterix.util.parse('data.datas')(securities), function (item) {
                return item.type && item.type.toLowerCase() !== 'custom';
            }),
                rows = [];

            _.each(data, function (item) {
                if (!_.findWhere(rows, { id: item.id })) {
                    item.secId = item.id;
                    rows.push(item);
                }
            });

            return {
                rows: rows
            };
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 6 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        var dataPointMapping = __webpack_require__(13);

        morningstar.asterix.ng.transforms.register('ecAutocomplete.fromUSAutocomplete', function (data) {
            var newDataRow,
                newDataRows = [],
                newData = {},
                util = morningstar.asterix.util;

            var transformDate = function transformDate(dateString) {
                if (dateString && typeof dateString === 'string' && dateString >= 8) {
                    dateString = dateString.trim();
                    var year = Number(dateString.slice(0, 4));
                    var month = Number(dateString.slice(4, 6)) - 1;
                    var day = Number(dateString.slice(6, 8));
                    return new Date(year, month, day);
                }

                return dateString;
            };

            if (data && data.securities && +data.securities.TotalRecords) {
                var securities = util.parse('securities.s')(data);
                if (!util.isArray(securities)) {
                    var newArray = [];
                    newArray.push(securities);
                    securities = newArray;
                }
                util.each(securities, function (dataRow) {
                    newDataRow = {};
                    util.each(dataRow, function (value, key) {
                        if (key === 'inceptionDate') {
                            newDataRow[key] = transformDate(value);
                        } else {
                            newDataRow[dataPointMapping[key] || key] = value;
                        }
                    });
                    newDataRows.push(newDataRow);
                });
                newData.rows = newDataRows;

                newData.total = data.securities.TotalRecords;
                newData.page = 1;
                newData.pageSize = 100;
            }
            return newData;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toAutocomplete', function (parameters) {
            var urlParameters = helper.generateBaseUrlParameters(this.context);
            helper.updateEUUrlParameters(this.context, urlParameters);
            return urlParameters;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 8 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper, dataMapping) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toPortfolioAPIAutocomplete', function () {
            var urlParameters = helper.generateBaseUrlParameters(this.context);
            helper.updateUSUrlParameters(this.context, urlParameters);
            var filters = this.context.settings.get('filters') || {};
            urlParameters.filters = '';
            filters.currencyId = filters.currencyId || this.context.settings.get('currencyId');
            _.each(filters, function (value, dataPoint) {
                var dataPointFilters = generateDataPointFilters(dataPoint, value);
                if (dataPointFilters) {
                    var format = urlParameters.filters ? 'AND{{0}}' : '{{0}}';
                    urlParameters.filters += morningstar.asterix.util.string.format(format, dataPointFilters);
                }
            });
            return urlParameters;
        });

        function generateDataPointFilters(dataPoint, value) {
            if (dataMapping[dataPoint]) {
                var data = _.isArray(value) ? value : [value];
                var dataPointFilters = '';
                _.each(data, function (item) {
                    var format = dataPointFilters ? 'OR({{0}}:{{1}})' : '({{0}}:{{1}})';
                    dataPointFilters += morningstar.asterix.util.string.format(format, dataMapping[dataPoint], item);
                });
                return data.length > 1 ? '(' + dataPointFilters + ')' : dataPointFilters;
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 9 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toUSAutocomplete', function (parameters) {
            var urlParameters = helper.generateBaseUrlParameters(this.context);
            helper.updateUSUrlParameters(this.context, urlParameters);
            return urlParameters;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 10 */
/***/function (module, exports) {

    module.exports = {
        "ecAutocomplete": {
            "blueprints": {
                "standardUS": {
                    "settings": {
                        "_model": {
                            "securities": {
                                "api": {
                                    "headers": {
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "parameters": {
                                        "transformPipeline": ["toUSAutocomplete"]
                                    },
                                    "url": "https://{{baseUrl}}/ec/v1/autocomplete?currency={{currencyId}}&langcult={{languageId}}&results={{maxRows}}&output=json&query={{search}}&universes={{universeId}}&securityDataPoints={{securityDataPoints}}&filterCriteria={{filters}}&{{apiTokenType}}={{apiTokenValue}}"
                                },
                                "transformPipeline": ["ecAutocomplete.fromUSAutocomplete"]
                            }
                        },
                        "currencyId": "USD",
                        "filters": "",
                        "groupBy": "universe",
                        "maxRows": 10,
                        "minSearchSize": "1",
                        "securityDataPoints": "name|secId|cusip|ticker|category|universe|categoryId|country",
                        "universeId": "FOUSA|FEUSA|FCUSA|STUSA|FIUSA"
                    },
                    "type": "ecAutocomplete"
                },
                "v2PortfolioAPI": {
                    "settings": {
                        "_model": {
                            "securities": {
                                "api": {
                                    "headers": {
                                        "access_token": "{{_ tokens().accessToken _}}",
                                        "apiKey": "{{_ tokens().apiKey _}}",
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "parameters": {
                                        "transformPipeline": ["toPortfolioAPIAutocomplete"],
                                        "watchedPaths": ["search"]
                                    },
                                    "url": "https://{{baseUrl}}/paapi/v2/editor/search_holdings?keyword={{search}}&condition={{filters}}"
                                },
                                "transformPipeline": ["fromPortfolioAPIAutocomplete"]
                            }
                        },
                        "groupBy": "universe"
                    },
                    "type": "ecAutocomplete"
                }
            },
            "components": {
                "searchInput": {
                    "labels": {
                        "placeholder": {
                            "en": "Enter name, ISIN or ticker",
                            "it": "Inserire nome, ISIN o ticker",
                            "sv": "Skriv in namn, ISIN eller ticker"
                        }
                    },
                    "type": "ecInput"
                }
            },
            "labels": {
                "FC": {
                    "da-DK": "Closed-End Fund",
                    "en": "Closed-end Fund",
                    "en-GB": null,
                    "fr": "Closed-end Fund",
                    "fr-CA": "Fonds à capital fixe",
                    "it": "Fondo chiuso",
                    "sv": "Investmentbolag",
                    "sv-SE": null,
                    "zh-CN": "封闭式基金",
                    "zh-HK": "封閉式基金"
                },
                "FE": {
                    "da-DK": "Exchange Traded Fund",
                    "en": "Exchange Traded Fund",
                    "en-GB": null,
                    "fr": "Exchange Traded Fund",
                    "fr-CA": "Fonds négocié en bourse",
                    "it": "ETF",
                    "sv": "Börshandlad fond (ETF)",
                    "sv-SE": null,
                    "zh-CN": "交易所买卖基金",
                    "zh-HK": "交易所買賣基金"
                },
                "FI": {
                    "da-DK": "Unit Investment Trust",
                    "en": "Unit Investment Trust",
                    "en-GB": null,
                    "fr": "Unit Investment Trust",
                    "fr-CA": "Fonds de placement à capital fixe",
                    "it": "Quota trust d'investimento",
                    "sv": "Livbolag",
                    "sv-SE": null,
                    "zh-CN": "单位投资信托",
                    "zh-HK": "單位投資信託"
                },
                "FO": {
                    "da-DK": "Mutual Fund",
                    "en": "Mutual Fund",
                    "en-GB": null,
                    "fr": "Mutual Fund",
                    "fr-CA": "Fonds commun de placement",
                    "it": "Fondo comune",
                    "sv": "Fond",
                    "sv-SE": null,
                    "zh-CN": "共同基金",
                    "zh-HK": "共同基金"
                },
                "ST": {
                    "da-DK": "Aktie",
                    "en": "Stock",
                    "en-GB": null,
                    "fr": "Action",
                    "it": "Azione",
                    "sv": "Aktie",
                    "sv-SE": null,
                    "zh-CN": "股票",
                    "zh-HK": "股票"
                },
                "ariaDescription": {
                    "en": "Please use up and down arrow keys to navigate search results",
                    "it": "Usa le freccie verso l'alto e verso il basso per navigare tra i risultati della ricerca",
                    "sv": "Använd pil upp och ned för att överblicka sökresultatet"
                },
                "holdingTypeId1": {
                    "da-DK": "Valutaer",
                    "en": "Currencies",
                    "en-GB": null,
                    "fr": "Devises",
                    "it": "Valute",
                    "sv": "Valutor",
                    "sv-SE": null,
                    "zh-CN": "货币",
                    "zh-HK": "貨幣"
                },
                "holdingTypeId2": {
                    "da-DK": "Open End Funds",
                    "en": "Open End Funds",
                    "en-GB": null,
                    "fr": "Fonds ouverts",
                    "fr-CA": "Fonds à capital variable",
                    "it": "Fondi aperti",
                    "sv": "Värdepappersfonder",
                    "sv-SE": null,
                    "zh-CN": "开放式基金",
                    "zh-HK": "開放式基金"
                },
                "holdingTypeId21": {
                    "da-DK": "Close End Funds",
                    "en": "Close End Funds",
                    "en-GB": null,
                    "fr": "Fonds fermés",
                    "fr-CA": "Fonds à capital fixe",
                    "it": "Fondi chiusi",
                    "sv": "Investmentbolag",
                    "sv-SE": null,
                    "zh-CN": "封闭式基金",
                    "zh-HK": "封閉式基金"
                },
                "holdingTypeId22": {
                    "da-DK": "ETF'er",
                    "en": "ETFs",
                    "en-GB": null,
                    "fr": "ETFs",
                    "fr-CA": "FNB",
                    "it": "ETF",
                    "sv": "ETFer",
                    "sv-SE": null,
                    "zh-CN": "交易所买卖基金",
                    "zh-HK": "交易所買賣基金"
                },
                "holdingTypeId23": {
                    "da-DK": "Særlige Fonde",
                    "en": "Custom Funds",
                    "en-GB": null,
                    "fr": "Custom Funds",
                    "fr-CA": "Fonds",
                    "it": "Fondi personalizzati",
                    "sv": "Custom Funds",
                    "sv-SE": null,
                    "zh-CN": "定制基金",
                    "zh-HK": "定制基金"
                },
                "holdingTypeId3": {
                    "da-DK": "Aktier",
                    "en": "Equities",
                    "en-GB": null,
                    "fr": "Actions",
                    "it": "Azioni",
                    "sv": "Aktier",
                    "sv-SE": null,
                    "zh-CN": "股票",
                    "zh-HK": "股票"
                },
                "holdingTypeId4": {
                    "da-DK": "Obligationer",
                    "en": "Bonds",
                    "en-GB": null,
                    "fr": "Obligations",
                    "it": "Obbligazioni",
                    "sv": "Räntor",
                    "sv-SE": null,
                    "zh-CN": "债券",
                    "zh-HK": "債券"
                },
                "holdingTypeId50": {
                    "da-DK": "Hedge Fonde",
                    "en": "Hedge Funds",
                    "en-GB": null,
                    "fr": "Hedge Funds",
                    "fr-CA": "Fonds spéculatifs",
                    "it": "Fondi hedge",
                    "sv": "Hedgefonder",
                    "sv-SE": null,
                    "zh-CN": "对冲基金",
                    "zh-HK": "對沖基金"
                },
                "holdingTypeId7": {
                    "da-DK": "Indeks",
                    "en": "Index",
                    "en-GB": null,
                    "fr": "Indice",
                    "it": "Indice",
                    "sv": "Index",
                    "sv-SE": null,
                    "zh-CN": "指数",
                    "zh-HK": "指數"
                },
                "holdingTypeId8": {
                    "da-DK": "Kategorier",
                    "en": "Categories",
                    "en-GB": null,
                    "fr": "Catégories",
                    "it": "Categorie",
                    "sv": "Kategorier",
                    "sv-SE": null,
                    "zh-CN": "组别",
                    "zh-HK": "組別"
                },
                "holdingTypeId9": {
                    "da-DK": "Liv & Pension",
                    "en": "Life & Pensions",
                    "en-GB": null,
                    "fr": "Life & Pensions",
                    "fr-CA": "Assurance vie et retraite",
                    "it": "Polizze vita e fondi pensione",
                    "sv": "Liv & Pension",
                    "sv-SE": null,
                    "zh-CN": "退休金",
                    "zh-HK": "退休金"
                },
                "noResults": {
                    "da-DK": "Ingen Resultater Fundet",
                    "en": "No Results Found",
                    "en-GB": null,
                    "fr": "Aucun résultat",
                    "fr-CA": "Aucun résultat",
                    "fr-FR": "Aucun résultat",
                    "it": "Non è stato trovato nessun risultato",
                    "sv": "Inga resultat",
                    "sv-SE": null
                }
            },
            "settings": {
                "_model": {
                    "securities": {
                        "api": {
                            "method": "get",
                            "parameters": {
                                "deep": true,
                                "isTransformSync": false,
                                "throttleTime": 0,
                                "transformPipeline": ["toAutocomplete"],
                                "watchedPaths": ["filters", "maxRows", "search", "securityDataPoints", "sortField", "sortOrder", "universeId", "urlKey", "subUniverseId"]
                            },
                            "url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/security/screener?page=1&pageSize={{maxRows}}&sortOrder={{sortField}}%20{{sortOrder}}&outputType=json&version=1&languageId={{languageId}}&currencyId={{currencyId}}&universeIds={{universeId}}&securityDataPoints={{securityDataPoints}}&filters={{filters}}&term={{search}}&subUniverseId={{subUniverseId}}",
                            "usePreviousDataOnError": false,
                            "validationExpression": "hasSearch",
                            "validationExpressions": []
                        },
                        "dataSourceType": "api",
                        "defaults": null,
                        "merge": false,
                        "selector": null,
                        "transformPipeline": ["fromAutocomplete"]
                    }
                },
                "_parameters": {
                    "filters": {},
                    "latestSelectedSecurity": {},
                    "maxRows": {},
                    "search": "",
                    "securityDataPoints": {},
                    "sortField": {},
                    "sortOrder": {},
                    "subUniverseId": {},
                    "universeId": {},
                    "urlKey": {}
                },
                "_templates": {
                    "item": "<span>{{s.name}}</span>",
                    "main": "<div class=\"{{ ::namespaceClass('search') }}\" data-ng-class=\"loading\">\r\n    <ec-input mstar-component-id=\"searchInput\"\r\n        class=\"{{ ::namespaceClass('search__input') }}\"\r\n        data-name=\"{{ :: settings.get('name') || namespaceId('searchInput') }}\"\r\n        data-ng-model=\"parameters.search\"\r\n        data-ng-model-options=\"{ updateOn: 'default', debounce: {'default': 300, 'blur': 0} }\"\r\n        data-aria-autocomplete=\"both\"\r\n        data-aria-owns=\"{{ ::namespaceId('results') }}\"\r\n        data-aria-label=\"{{ :: labels.contains('ariaLabel') ? labels.get('ariaLabel') : undefined }}\"\r\n        data-aria-describedby=\"{{ :: showAriaDescribedBy ? namespaceId('describedby') : undefined }}\"\r\n        data-role=\"combobox\"></ec-input>\r\n    <div class=\"{{ ::namespaceClass('search-spinner') }}\" >\r\n        <div data-ng-repeat=\"i in ::times(12) track by $index\"\r\n            class=\"{{ ::namespaceClass('search-spinner__bar') }} {{ ::namespaceClass('search-spinner__bar--'+ $index) }}\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"{{ ::namespaceClass('container') }}\" data-ng-show=\"showResult\">\r\n        <ul id=\"{{ ::namespaceId('results')}}\" class=\"{{ ::namespaceClass('container__results') }}\" role=\"listbox\" tabindex=\"-1\" aria-expanded=\"showResult\">\r\n            <li id=\"{{ ::namespaceId('results' + $index)}}\"\r\n                class=\"{{ ::namespaceClass('container__item') }} {{ ::namespaceClass('container__item')+'_'+$index }}\"\r\n                data-ng-class=\"{ '{{::namespaceClass('container__item--group')}}': s.group}\"\r\n                data-ng-repeat=\"s in securities\"\r\n                data-ng-click=\"!s.group && selectItem(s)\"\r\n                role=\"option\"\r\n                tabindex=\"-1\">\r\n                <div mstar-include=\"templates.item\"></div>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <span id=\"{{ ::namespaceId('describedby')}}\" data-ng-show=\"false\" data-ng-if=\"showAriaDescribedBy\">{{ ::labels.get('ariaDescription') }}</span>\r\n    <div class=\"{{ ::namespaceClass('__zero-result-found') }}\" data-ng-show=\"showNoResults && !loading\">\r\n        <span>{{ ::labels.get('noResults') }}</span>\r\n    </div>\r\n</div>\r\n"
                },
                "filters": "",
                "groupBy": "holdingTypeId",
                "latestSelectedSecurity": null,
                "maxRows": 100,
                "minSearchSize": 2,
                "name": null,
                "namespaceClass": "ec-autocomplete",
                "propagatedFields": {
                    "holdingTypeId": "holdingTypeId",
                    "name": "name",
                    "secId": "secId"
                },
                "restoreResultsOnFocus": false,
                "search": "",
                "securityDataPoints": "SecId,TenforeId,Name,InvestmentType,HoldingTypeId,Universe",
                "showAriaDescribedBy": true,
                "showSearchText": true,
                "sortField": "name",
                "sortOrder": "asc",
                "subUniverseId": "",
                "universeId": null,
                "urlKey": "",
                "usageTrackingHitMap": {
                    "searchedText": {
                        "action": "criteriaChanged",
                        "label": "Criteria Changed",
                        "type": "event"
                    },
                    "selectedSecurity": {
                        "action": "investmentSelected",
                        "label": "Investment Selected",
                        "type": "event"
                    }
                }
            },
            "type": "ecAutocomplete"
        }
    };

    /***/
},
/* 11 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecAutocomplete', __webpack_require__(10).ecAutocomplete);

        __webpack_require__(3);
        __webpack_require__(4);
        __webpack_require__(6);
        __webpack_require__(7);
        __webpack_require__(9);
        __webpack_require__(5);
        __webpack_require__(8);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 12 */
/***/function (module, exports) {

    module.exports = {
        "currencyId": "OS05M",
        "exchangeCountryId": "OS01V"
    };

    /***/
},
/* 13 */
/***/function (module, exports) {

    module.exports = {
        "id": "secId",
        "n": "name",
        "t": "symbol",
        "univ": "universe",
        "country": "country"
    };

    /***/
},
/* 14 */
/***/function (module, exports) {

    module.exports = {
        "exchangeCode": "ExchangeCode",
        "globalCategoryId": "GlobalCategoryId",
        "globalCategoryName": "GlobalCategoryName",
        "holdingTypeId": "HoldingTypeId",
        "investmentType": "InvestmentType",
        "legalName": "LegalName",
        "name": "Name",
        "secId": "SecId",
        "symbol": "Symbol",
        "tenforeId": "TenforeId",
        "universe": "Universe"
    };

    /***/
},
/* 15 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
},
/* 16 */
/***/function (module, exports) {

    module.exports = jQuery;

    /***/
}]
/******/);
//# sourceMappingURL=ec-autocomplete.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 3);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _) {
        'use strict';

        angular.module('ecButton', ['mstarCore']).directive('ecButton', ['mstarTemplate', 'mstarDebounce', '$interpolate', button]);

        function button(mstarTemplate, mstarDebounce, $interpolate) {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {
                    label: '@?',
                    model: '=?buttonData'
                },
                link: linkFn
            };

            function linkFn(scope, elem, attr, mstarComponent) {

                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
                if (attr.buttonData) {
                    scope.instance.setModel(scope.model);
                } else {
                    mstarComponent.bindModelData(scope);
                }

                var parameters = scope.parameters;
                scope.iconPositionClass = parameters.iconPosition === 'left' ? 'ec-components-u-leftAlign' : 'ec-components-u-rightAlign';

                scope.buttonClick = function (event) {
                    if (parameters.onClick !== null && typeof parameters.onClick === 'function') {
                        parameters.onClick(event);
                    }
                    mstarComponent.trigger('click', [event]);
                };
                var currentTemplate = '_templates.' + (scope.settings.get('_templates')[parameters.buttonType] ? parameters.buttonType : 'main');

                // compiles the main template
                mstarComponent.compileTemplate(scope, currentTemplate);

                // Button label
                if (scope.label) {
                    scope.$watch(function () {
                        return $interpolate(scope.labels.get(scope.label))(scope);
                    }, function (value) {
                        scope.buttonLabel = value;
                    });
                } else {
                    scope.$watch(function () {
                        return $interpolate(scope.labels.get('caption'))(scope);
                    }, function (value) {
                        scope.buttonLabel = value;
                    });
                }

                if (parameters.buttonType === 'link') {
                    generateHref();
                }

                scope.$watch('parameters.href', mstarDebounce(function () {
                    generateHref();
                }, 20), true);

                scope.$watch('parameters.hrefParams', mstarDebounce(function () {
                    generateHref();
                }, 20), true);

                function generateHref() {
                    var href = scope.parameters.href;
                    if (href && href !== '') {
                        var queryParams = morningstar.asterix.util.merge({}, scope.settings.get('hrefParams'), scope.parameters.hrefParams);
                        _.each(queryParams, function (value, key, obj) {
                            obj[key] = encodeURIComponent(value);
                        });
                        scope.href = morningstar.asterix.util.url.parameterize(href, queryParams);
                    }
                }
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 1 */
/***/function (module, exports) {

    module.exports = {
        "ecButton": {
            "labels": {
                "caption": {
                    "en": null,
                    "en-GB": null,
                    "sv-SE": null
                }
            },
            "settings": {
                "_model": {
                    "disabled": false
                },
                "_parameters": {
                    "badgeContent": {},
                    "buttonCSS": {},
                    "buttonType": {},
                    "captionLabelKey": {},
                    "disabled": {},
                    "href": {},
                    "hrefParams": {},
                    "iconCSS": {},
                    "iconPosition": {},
                    "onClick": {},
                    "visible": {}
                },
                "_templates": {
                    "badge": "<button title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" data-ng-attr-type=\"{{parameters.buttonType}}\" data-ng-click=\"buttonClick($event)\"\r\n    class=\"{{ ::namespaceClass('__btn') + ' '+ namespaceClass('__badge-btn') }} {{parameters.buttonCSS}}\"\r\n    data-ng-disabled=\"parameters.disabled\">\r\n    <span data-ng-if=\"parameters.iconCSS\" class=\"{{ ::namespaceClass('__icon') }}\" data-ng-class=\"parameters.iconCSS\"></span>\r\n    <span class=\"{{ ::namespaceClass('__caption') }}\">{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}</span>\r\n    <span class=\"{{ ::namespaceClass('__badge-content') }}\">{{parameters.badgeContent}}</span>\r\n</button>",
                    "icon": "<button title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" data-ng-attr-type=\"{{parameters.buttonType}}\" data-ng-click=\"buttonClick($event)\"\r\n    class=\"{{ ::namespaceClass('__btn') + ' ' + namespaceClass('--icon-only') }} {{parameters.buttonCSS}}\"\r\n    data-ng-disabled=\"parameters.disabled\" role=\"button\">\r\n    <svg class=\"mui-icon mui-button__icon\">\r\n        <use data-ng-attr-href=\"{{ ::settings.get('iconSprite') }}.svg#{{ ::settings.get('iconName') }}\"/>\r\n    </svg>\r\n</button>",
                    "link": "<a title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" href=\"{{href}}\" target=\"{{ ::settings.get('target') }}\"\r\n    data-ng-click=\"buttonClick($event)\" class=\"{{ ::namespaceClass('__link') }} {{parameters.buttonCSS}}\">\r\n    <span data-ng-if=\"parameters.iconCSS\" class=\"{{iconPositionClass}}\" data-ng-class=\"parameters.iconCSS\"></span>\r\n    {{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\r\n</a>\r\n",
                    "main": "<button title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" data-ng-attr-type=\"{{parameters.buttonType}}\"\r\n    data-ng-click=\"buttonClick($event)\" class=\"{{ ::namespaceClass('__btn') }} {{parameters.buttonCSS}}\" data-ng-disabled=\"parameters.disabled || model.disabled\">\r\n    <span data-ng-if=\"parameters.iconCSS\" class=\"{{namespaceClass('__icon')}}\" data-ng-class=\"parameters.iconCSS\"></span>\r\n    <span class=\"{{ ::namespaceClass('__caption') }}\">{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}</span>\r\n</button>\r\n"
                },
                "badgeContent": null,
                "buttonCSS": "ec-components-button",
                "buttonType": "button",
                "disabled": false,
                "href": null,
                "hrefParams": null,
                "iconCSS": null,
                "iconName": "person-padless",
                "iconPosition": "left",
                "iconSprite": "mds_icons",
                "namespaceClass": "ec-button",
                "onClick": null,
                "target": null,
                "visible": true
            },
            "type": "ecButton"
        }
    };

    /***/
},
/* 2 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecButton', __webpack_require__(1).ecButton);
        __webpack_require__(0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 5 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
}]
/******/);
//# sourceMappingURL=ec-button.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // identity function for calling harmony imports with the correct context
  /******/__webpack_require__.i = function (value) {
    return value;
  };
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        /******/configurable: false,
        /******/enumerable: true,
        /******/get: getter
        /******/ });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "build/";
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 6);
  /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

  module.exports = morningstar;

  /***/
},
/* 1 */
/***/function (module, exports) {

  module.exports = _;

  /***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    chosen.$inject = ["mstarLoader", "mstarDebounce"];
    angular.module('ecChosen', ['mstarCore']).directive('ecChosen', chosen);

    function chosen(mstarLoader, mstarDebounce) {
      var controlType = {
        accordionCheckboxList: 'accordionCheckboxList',
        checkbox: 'checkbox',
        radio: 'radio',
        select: 'select',
        minimumRating: 'minimumRating',
        radioImage: 'radioImage',
        checkboxImage: 'checkboxImage',
        customList: 'customList',
        buttonList: 'buttonList'
      };

      var chosenOptionWhitelist = ['allowSingleDeselect', 'disableSearch', 'disableSearchThreshold', 'displayDisabledOptions', 'displaySelectedOptions', 'enableSplitWordSearch', 'inheritSelectClasses', 'maxSelectedOptions', 'multiple', 'searchContains', 'singleBackstrokeDelete', 'width'];

      var chosenOptionWhitelistLabels = ['noResultsText', 'placeholderTextMultiple', 'placeholderTextSingle'];

      return {
        restrict: 'E',
        require: ['ngModel', 'mstarComponentId'],
        scope: {
          ngModel: '=?',
          ngConfig: '=?',
          model: '=?inputData'
        },
        link: linkFn
      };

      function linkFn(scope, elem, attr, controllers) {
        var select,
            ngModel = controllers[0],
            mstarComponent = controllers[1],
            validate;

        // binds settings, labels, formatter and templates to scope properties
        mstarComponent.bindConfig(scope);

        // compiles the main template
        mstarComponent.compileTemplate(scope, '_templates.main');

        // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
        mstarComponent.bindParameters(scope);

        mstarComponent.bindValue(scope);

        scope.chosenType = scope.$eval('parameters.controlType');

        scope.$watch('parameters.controlType', function (newValue, oldValue) {
          if (newValue === oldValue) {
            return;
          }
          scope.chosenType = newValue;
        });

        // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
        if (attr.inputData) {
          if (scope.model) {
            scope.instance.setModel(scope.model);
          } else {
            scope.instance.setModel({});
            var listener = scope.$watch('model', function (currVal) {
              if (currVal) {
                scope.instance.setModel(currVal);
                listener();
              }
            });
          }
        } else {
          // binds model data (listItems)
          mstarComponent.bindModelData(scope);
        }

        // use for dynamic instance to update the parameters passed from config
        if (attr.ngConfig) {
          var parameters = scope.instance.getParameters(),
              keys = _.keys(scope.ngConfig);

          _.each(keys, function (key) {
            if (parameters.hasOwnProperty(key)) {
              scope.instance.setParameter(key, scope.ngConfig[key]);
            }
          });
        }

        var currentType = scope.chosenType;
        var currentControlClass = scope.settings.get('controlClass') ? scope.settings.get('namespaceClass') + '__' + scope.settings.get('controlClass') : '';
        var imageOptions = scope.settings.get('imageOptions');
        var imageOptionsClass = scope.settings.get('namespaceClass') + '__' + scope.settings.get('imageOptionsClass');
        var imageOptionsClassActive = scope.settings.get('imageOptionsClassActive');
        var imageOptionsClassInactive = scope.settings.get('imageOptionsClassInactive');
        var imageSelection = imageOptions && _.isArray(imageOptions);
        var keyField = scope.settings.get('keyField'),
            valueField = scope.settings.get('valueField');

        scope.$watch('ngModel', mstarDebounce(update, 20), true);

        scope.$watch('parameters', mstarDebounce(function () {
          initializeChosen();
        }, 20), true);

        scope.$watchCollection('model.listItems', mstarDebounce(update, 20));

        //initiate an array to hold all parent->child obj
        scope.parentChildItems = [];

        var hasBuilt = false,
            loader;

        function refreshImages() {
          var model = _.isArray(scope.ngModel) ? scope.ngModel : scope.ngModel ? [scope.ngModel] : [];

          if (currentType === controlType.minimumRating && model.length > 0) {
            model = _.chain(scope.model.listItems).pluck('key').difference(model).union([model[0]]).value();
          }

          scope.images = _.chain(imageOptions).filter(function (item) {
            return _.contains(_.pluck(scope.model.listItems, 'key'), item.key);
          }).map(function (item) {
            return {
              key: item.key,
              currentClasses: _.contains(model, item.key) ? imageOptionsClass + '--' + item.itemClass + ' ' + imageOptionsClass + '--' + imageOptionsClassActive : imageOptionsClass + '--' + item.itemClass + ' ' + imageOptionsClass + '--' + imageOptionsClassInactive,
              selected: _.contains(model, item.key) ? true : false
            };
          }).value();
        }

        function initializeChosen() {

          if (currentControlClass) {
            elem.addClass(currentControlClass);
          }

          if (imageSelection) {
            initializeImages();
          } else if (currentType === controlType.checkbox) {
            initializeCheckboxes();
          } else if (currentType === controlType.radio) {
            initializeRadioButtons();
          } else if (currentType === controlType.select) {
            initializeSelect();
          } else if (currentType === controlType.accordionCheckboxList) {
            initializeAccordionCheckboxes();
          } else if (currentType === controlType.customList) {
            initializeCustomListItems();
          } else if (currentType === controlType.buttonList) {
            initializeButtonListItems();
          }

          if (scope.parameters.disabled) {
            elem.addClass(scope.settings.get('namespaceClass') + '--disabled');
          } else {
            elem.removeClass(scope.settings.get('namespaceClass') + '--disabled');
          }

          update();

          hasBuilt = true;

          function initializeCheckboxes() {
            scope.checkboxChange = function () {
              var checkedItems = [];
              _.each(scope.model.listItems, function (listItem) {
                var value = scope.checkboxStatus[listItem[keyField]];
                if (value) {
                  checkedItems.push(value);
                }
              });
              scope.ngModel = checkedItems;
            };
          }

          function initializeImages() {

            refreshImages();

            scope.imageClicked = function (key) {
              if (currentType === controlType.checkboxImage) {
                if (_.contains(scope.ngModel, key)) {
                  scope.ngModel = _.without(scope.ngModel, key);
                } else if (scope.ngModel) {
                  scope.ngModel.push(key);
                } else {
                  scope.ngModel = [key];
                }
                if (scope.ngModel.length === 0) {
                  delete scope.ngModel;
                }
              } else if (currentType === controlType.radioImage) {
                scope.ngModel = key;
              } else if (currentType === controlType.minimumRating) {

                if (!scope.ngModel) {
                  scope.ngModel = [];
                }

                if (scope.ngModel.length > 0 && scope.ngModel[0] === key) {
                  delete scope.ngModel;
                } else {

                  var minimumRating = function minimumRating(items, memo) {
                    if (items.length > 0) {
                      if (memo.length > 0 || items[0].key === key) {
                        memo.push(items[0].key);
                      }
                      minimumRating(items.slice(1), memo);
                    }
                    return memo;
                  };

                  if (_.contains(_.pluck(scope.model.listItems, 'key'), key)) {
                    scope.ngModel = minimumRating(scope.model.listItems, []);
                  } else {
                    scope.ngModel = [];
                  }
                }
              }
            };
          }

          function initializeCustomListItems() {
            scope.customItemOptions = scope.settings.get('customItemOptions');

            if (!_.isUndefined(scope.parameters.customItemOptions) && !_.isEmpty(scope.parameters.customItemOptions)) {
              scope.customItemOptions = scope.parameters.customItemOptions;
            }

            scope.chooseCustomItem = function (key) {
              scope.ngModel = key;
            };
          }

          function initializeRadioButtons() {
            scope.radioChange = function () {
              scope.ngModel = scope.radio.selected;
            };
          }

          function initializeSelect() {
            var options = {};
            morningstar.asterix.util.each(scope.parameters, function (value, key) {
              if (chosenOptionWhitelist.indexOf(key) >= 0) {
                options[morningstar.asterix.util.string.snakeCase(key)] = value;
              }
            });

            morningstar.asterix.util.each(chosenOptionWhitelistLabels, function (value) {
              if (scope.ngConfig && scope.ngConfig[value]) {
                options[morningstar.asterix.util.string.snakeCase(value)] = scope.labels.get(scope.ngConfig[value]);
              } else if (scope.labels.contains(value)) {
                options[morningstar.asterix.util.string.snakeCase(value)] = scope.labels.get(value);
              }
            });

            if (!select) {
              select = elem.find('select');
            }

            if (hasBuilt) {
              select.chosen(options, 'destroy');
              select.chosen(options);
            } else {
              select.chosen(options);
            }
          }

          function initializeAccordionCheckboxes() {
            scope.addCheckedItem = function (childItem, parentKey) {

              var found = _.find(scope.parentChildItems, function (item) {
                return item.child === childItem.key;
              });

              childItem.selected = !found;

              if (!found) {
                scope.parentChildItems.push({
                  'child': childItem.key,
                  'parent': parentKey
                });
              } else {
                scope.parentChildItems.splice(_.indexOf(scope.parentChildItems, found), 1);
              }

              updateNestedAccordionCheckboxesModel();

              // select or un-select parent checkbox when child is selected
              var listItems = scope.model.listItems;
              for (var index = 0; index < listItems.length; index++) {
                if (listItems[index].parentKey === parentKey) {
                  listItems[index].selectAll = _.some(scope.ngModel.parent, function (key) {
                    return listItems[index].parentKey === parentKey;
                  });
                  return;
                }
              }
            };
          }

          function initializeButtonListItems() {
            scope.chooseButtonItem = function (key) {
              scope.parameters.buttonItemSelected = key;
            };
          }
        }

        function update() {
          scope.$evalAsync(function () {
            if (imageSelection) {
              refreshImages();
            } else if (currentType === controlType.checkbox) {
              // todo add validation
              scope.checkboxStatus = {};
              morningstar.asterix.util.each(scope.ngModel, function (value) {
                scope.checkboxStatus[value] = value;
              });
            } else if (currentType === controlType.radio) {
              // todo add validation
              scope.radio = {
                selected: scope.ngModel
              };
            } else if (currentType === controlType.select) {
              if (!select) {
                select = elem.find('select');
              }

              validate = select.controller('mstarValidate');
              ngModel = select.controller('ngModel');

              if (validate && validate.isActive) {
                if (select.data('chosen') && select.data('chosen').container.length) {
                  validate.getTooltip().setAnchor(select.data('chosen').container[0]);
                }
              }

              select.trigger('chosen:updated');
              if (scope.settings.get('loader.enabled')) {
                if (loader) {
                  loader.destroy();
                }

                loader = mstarLoader(scope, angular.element(select.data('chosen') ? select.data('chosen').container[0] : select), 'model.listItems._$isLoading');
              }
            }
            scope.instance.trigger('ecChosenItemSelected', [scope.ngModel]);
          });
        }

        //update nested accordion model
        function updateNestedAccordionCheckboxesModel() {
          if (!scope.parameters.accordionQueries) {
            scope.parameters.accordionQueries = {};
          }
          scope.parameters.accordionQueries.parentFilters = _.uniq(_.pluck(scope.parentChildItems, 'parent'));
          scope.parameters.accordionQueries.childFilters = _.uniq(_.pluck(scope.parentChildItems, 'child'));
          scope.ngModel = {
            parent: scope.parameters.accordionQueries.parentFilters,
            child: scope.parameters.accordionQueries.childFilters
          };
        }

        //initiate an array to hold all active tabs
        scope.activeTabs = [];
        //check if the tab is active
        scope.isOpenTab = function (tab) {
          //check if this tab is already in the activeTabs array
          if (scope.activeTabs.indexOf(tab) > -1) {
            return true;
          } else {
            return false;
          }
        };

        //function to select and deselect all child items
        scope.toggleChildItems = function (tabIndex, $event) {
          if ($event.stopPropagation) {
            $event.stopPropagation();
          }

          var parentItem = scope.model.listItems[tabIndex],
              childItems = parentItem.childListItems,
              selectAllChildItems = parentItem.selectAll;

          morningstar.asterix.util.each(childItems, function (childItem) {

            childItem.selected = selectAllChildItems;

            if (selectAllChildItems) {
              var found = _.some(scope.parentChildItems, function (item) {
                return item.child === childItem.key;
              });
              if (!found) {
                scope.parentChildItems.push({
                  'child': childItem.key,
                  'parent': parentItem.parentKey
                });
              }
            } else {
              var itemToRemove = _.find(scope.parentChildItems, function (item) {
                return item.child === childItem.key;
              });
              if (itemToRemove) {
                scope.parentChildItems.splice(_.indexOf(scope.parentChildItems, itemToRemove), 1);
              }
            }
          });
          updateNestedAccordionCheckboxesModel();
        };

        //function to 'open' a tab
        scope.openTab = function (tab) {
          //check if tab is already open;
          if (scope.isOpenTab(tab)) {
            //if it is, remove it from the activeTabs array
            scope.activeTabs.splice(scope.activeTabs.indexOf(tab), 1);
          } else {
            //if it's not, reset & add it!
            scope.activeTabs = [];
            scope.activeTabs.push(tab);
          }
        };

        // allow to rearrange list item 
        if (currentType === controlType.checkbox) {
          var removeHighlightClass = function removeHighlightClass(element) {
            element.removeClass(itemHighlightTopClassName).removeClass(itemHighlightBottomClassName);
          };

          var addHighlightClass = function addHighlightClass(element, areaPos) {
            element.addClass(areaPos === 'top' ? itemHighlightTopClassName : itemHighlightBottomClassName);
          };

          var addData = function addData(newListItems, newNgModel, checkboxStatus, item) {
            var key = item[keyField];
            if (checkboxStatus[key]) {
              newNgModel.push(checkboxStatus[key]);
            }
            newListItems.push(item);
          };

          var itemHighlightTopClassName = scope.namespaceClass('__item--highlight-top'),
              itemHighlightBottomClassName = scope.namespaceClass('__item--highlight-bottom');

          mstarComponent.addUnregisterCallback(scope.instance.on('dragStart', function (proxy) {
            var drag = proxy.drag(),
                bounds = drag.element[0].getBoundingClientRect(),
                elemParent = drag.element.parent().parent(),
                parentOffset = elemParent.offset(),
                listItem = drag.scope.listItem;
            proxy.direction('y').containment({
              left: bounds.left,
              right: bounds.right,
              top: parentOffset.top,
              bottom: elemParent.outerHeight(true) + parentOffset.top
            });
            if (scope.settings.get('runtimeSelectLabel') && scope.labels.contains(listItem[valueField])) {
              proxy.element().html(scope.labels.get(listItem[valueField]));
            } else {
              proxy.element().html(listItem[valueField]);
            }
          }));

          mstarComponent.addUnregisterCallback(scope.instance.on('drag', function (proxy) {
            var drop = proxy.drop();
            if (!drop) {
              return;
            }
            var dropElem = drop.element;
            removeHighlightClass(dropElem);
            addHighlightClass(dropElem, drop.areaPos[1]);
          }));

          mstarComponent.addUnregisterCallback(scope.instance.on('drop', function (proxy) {
            var drop = proxy.drop(),
                dropElem = drop.element,
                dragListItem = proxy.drag().scope.listItem,
                dropListItem = drop.scope.listItem,
                dropKey = dropListItem[keyField],
                dragKey = dragListItem[keyField],
                areaPos = drop.areaPos[1],
                checkboxStatus = scope.checkboxStatus;
            if (dropKey !== dragKey) {
              var newListItems = [],
                  newNgModel = [];
              _.each(scope.model.listItems, function (item) {
                var key = item[keyField];
                if (key !== dragKey) {
                  if (key === dropKey) {
                    if (areaPos === 'top') {
                      addData(newListItems, newNgModel, checkboxStatus, dragListItem);
                      addData(newListItems, newNgModel, checkboxStatus, item);
                    } else {
                      addData(newListItems, newNgModel, checkboxStatus, item);
                      addData(newListItems, newNgModel, checkboxStatus, dragListItem);
                    }
                  } else {
                    addData(newListItems, newNgModel, checkboxStatus, item);
                  }
                }
              });

              scope.$apply(function () {
                scope.ngModel = newNgModel;
                scope.model.listItems = newListItems;
              });
            }
            removeHighlightClass(dropElem);
          }));

          mstarComponent.addUnregisterCallback(scope.instance.on('dropOut', function (proxy) {
            removeHighlightClass(proxy.drop().element);
          }));
        }
      }
    }
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
    'use strict';

    morningstar.asterix.ng.transforms.register('ecChosen.listItemsSort', function (data) {
      if (!data) {
        return;
      }

      var context = this.context;
      var valueField = context.settings.get('valueField');

      var output = _.sortBy(data, function (item) {
        return context.settings.get('runtimeSelectLabel') && context.labels.contains(item[valueField]) ? context.labels.get(item[valueField]) : item[valueField];
      });

      return output;
    });
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  /*!
  Chosen, a Select Box Enhancer for jQuery and Prototype
  by Patrick Filler for Harvest, http://getharvest.com
  
  Version 1.6.2
  Full source at https://github.com/harvesthq/chosen
  Copyright (c) 2011-2016 Harvest http://getharvest.com
  
  MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
  This file is generated by `grunt build`, do not edit it by hand.
  As an IE11 bug please help update this function (Chosen.prototype.update_results_content) .
   
  */

  (function () {
    var $,
        AbstractChosen,
        Chosen,
        SelectParser,
        _ref,
        __hasProp = {}.hasOwnProperty,
        __extends = function __extends(child, parent) {
      for (var key in parent) {
        if (__hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    };

    SelectParser = function () {
      function SelectParser() {
        this.options_index = 0;
        this.parsed = [];
      }

      SelectParser.prototype.add_node = function (child) {
        if (child.nodeName.toUpperCase() === "OPTGROUP") {
          return this.add_group(child);
        } else {
          return this.add_option(child);
        }
      };

      SelectParser.prototype.add_group = function (group) {
        var group_position, option, _i, _len, _ref, _results;
        group_position = this.parsed.length;
        this.parsed.push({
          array_index: group_position,
          group: true,
          label: this.escapeExpression(group.label),
          title: group.title ? group.title : void 0,
          children: 0,
          disabled: group.disabled,
          classes: group.className
        });
        _ref = group.childNodes;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          option = _ref[_i];
          _results.push(this.add_option(option, group_position, group.disabled));
        }
        return _results;
      };

      SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
        if (option.nodeName.toUpperCase() === "OPTION") {
          if (option.text !== "") {
            if (group_position != null) {
              this.parsed[group_position].children += 1;
            }
            this.parsed.push({
              array_index: this.parsed.length,
              options_index: this.options_index,
              value: option.value,
              text: option.text,
              html: option.innerHTML,
              title: option.title ? option.title : void 0,
              selected: option.selected,
              disabled: group_disabled === true ? group_disabled : option.disabled,
              group_array_index: group_position,
              group_label: group_position != null ? this.parsed[group_position].label : null,
              classes: option.className,
              style: option.style.cssText
            });
          } else {
            this.parsed.push({
              array_index: this.parsed.length,
              options_index: this.options_index,
              empty: true
            });
          }
          return this.options_index += 1;
        }
      };

      SelectParser.prototype.escapeExpression = function (text) {
        var map, unsafe_chars;
        if (text == null || text === false) {
          return "";
        }
        if (!/[\&\<\>\"\'\`]/.test(text)) {
          return text;
        }
        map = {
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;"
        };
        unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
        return text.replace(unsafe_chars, function (chr) {
          return map[chr] || "&amp;";
        });
      };

      return SelectParser;
    }();

    SelectParser.select_to_array = function (select) {
      var child, parser, _i, _len, _ref;
      parser = new SelectParser();
      _ref = select.childNodes;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        child = _ref[_i];
        parser.add_node(child);
      }
      return parser.parsed;
    };

    AbstractChosen = function () {
      function AbstractChosen(form_field, options) {
        this.form_field = form_field;
        this.options = options != null ? options : {};
        if (!AbstractChosen.browser_is_supported()) {
          return;
        }
        this.is_multiple = this.form_field.multiple;
        this.set_default_text();
        this.set_default_values();
        this.setup();
        this.set_up_html();
        this.register_observers();
        this.on_ready();
      }

      AbstractChosen.prototype.set_default_values = function () {
        var _this = this;
        this.click_test_action = function (evt) {
          return _this.test_active_click(evt);
        };
        this.activate_action = function (evt) {
          return _this.activate_field(evt);
        };
        this.active_field = false;
        this.mouse_on_container = false;
        this.results_showing = false;
        this.result_highlighted = null;
        this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
        this.disable_search_threshold = this.options.disable_search_threshold || 0;
        this.disable_search = this.options.disable_search || false;
        this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
        this.group_search = this.options.group_search != null ? this.options.group_search : true;
        this.search_contains = this.options.search_contains || false;
        this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
        this.max_selected_options = this.options.max_selected_options || Infinity;
        this.inherit_select_classes = this.options.inherit_select_classes || false;
        this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
        this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
        this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
        this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
        return this.case_sensitive_search = this.options.case_sensitive_search || false;
      };

      AbstractChosen.prototype.set_default_text = function () {
        if (this.form_field.getAttribute("data-placeholder")) {
          this.default_text = this.form_field.getAttribute("data-placeholder");
        } else if (this.is_multiple) {
          this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
        } else {
          this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
        }
        return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
      };

      AbstractChosen.prototype.choice_label = function (item) {
        if (this.include_group_label_in_selected && item.group_label != null) {
          return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
        } else {
          return item.html;
        }
      };

      AbstractChosen.prototype.mouse_enter = function () {
        return this.mouse_on_container = true;
      };

      AbstractChosen.prototype.mouse_leave = function () {
        return this.mouse_on_container = false;
      };

      AbstractChosen.prototype.input_focus = function (evt) {
        var _this = this;
        if (this.is_multiple) {
          if (!this.active_field) {
            return setTimeout(function () {
              return _this.container_mousedown();
            }, 50);
          }
        } else {
          if (!this.active_field) {
            return this.activate_field();
          }
        }
      };

      AbstractChosen.prototype.input_blur = function (evt) {
        var _this = this;
        if (!this.mouse_on_container) {
          this.active_field = false;
          return setTimeout(function () {
            return _this.blur_test();
          }, 100);
        }
      };

      AbstractChosen.prototype.results_option_build = function (options) {
        var content, data, data_content, shown_results, _i, _len, _ref;
        content = '';
        shown_results = 0;
        _ref = this.results_data;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          data = _ref[_i];
          data_content = '';
          if (data.group) {
            data_content = this.result_add_group(data);
          } else {
            data_content = this.result_add_option(data);
          }
          if (data_content !== '') {
            shown_results++;
            content += data_content;
          }
          if (options != null ? options.first : void 0) {
            if (data.selected && this.is_multiple) {
              this.choice_build(data);
            } else if (data.selected && !this.is_multiple) {
              this.single_set_selected_text(this.choice_label(data));
            }
          }
          if (shown_results >= this.max_shown_results) {
            break;
          }
        }
        return content;
      };

      AbstractChosen.prototype.result_add_option = function (option) {
        var classes, option_el;
        if (!option.search_match) {
          return '';
        }
        if (!this.include_option_in_results(option)) {
          return '';
        }
        classes = [];
        if (!option.disabled && !(option.selected && this.is_multiple)) {
          classes.push("active-result");
        }
        if (option.disabled && !(option.selected && this.is_multiple)) {
          classes.push("disabled-result");
        }
        if (option.selected) {
          classes.push("result-selected");
        }
        if (option.group_array_index != null) {
          classes.push("group-option");
        }
        if (option.classes !== "") {
          classes.push(option.classes);
        }
        option_el = document.createElement("li");
        option_el.className = classes.join(" ");
        option_el.style.cssText = option.style;
        option_el.setAttribute("data-option-array-index", option.array_index);
        option_el.innerHTML = option.search_text;
        if (option.title) {
          option_el.title = option.title;
        }
        return this.outerHTML(option_el);
      };

      AbstractChosen.prototype.result_add_group = function (group) {
        var classes, group_el;
        if (!(group.search_match || group.group_match)) {
          return '';
        }
        if (!(group.active_options > 0)) {
          return '';
        }
        classes = [];
        classes.push("group-result");
        if (group.classes) {
          classes.push(group.classes);
        }
        group_el = document.createElement("li");
        group_el.className = classes.join(" ");
        group_el.innerHTML = group.search_text;
        if (group.title) {
          group_el.title = group.title;
        }
        return this.outerHTML(group_el);
      };

      AbstractChosen.prototype.results_update_field = function () {
        this.set_default_text();
        if (!this.is_multiple) {
          this.results_reset_cleanup();
        }
        this.result_clear_highlight();
        this.results_build();
        if (this.results_showing) {
          return this.winnow_results();
        }
      };

      AbstractChosen.prototype.reset_single_select_options = function () {
        var result, _i, _len, _ref, _results;
        _ref = this.results_data;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          result = _ref[_i];
          if (result.selected) {
            _results.push(result.selected = false);
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };

      AbstractChosen.prototype.results_toggle = function () {
        if (this.results_showing) {
          return this.results_hide();
        } else {
          return this.results_show();
        }
      };

      AbstractChosen.prototype.results_search = function (evt) {
        if (this.results_showing) {
          return this.winnow_results();
        } else {
          return this.results_show();
        }
      };

      AbstractChosen.prototype.winnow_results = function () {
        var escapedSearchText, option, regex, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;
        this.no_results_clear();
        results = 0;
        searchText = this.get_search_text();
        escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
        zregex = new RegExp(escapedSearchText, 'i');
        regex = this.get_search_regex(escapedSearchText);
        _ref = this.results_data;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          option = _ref[_i];
          option.search_match = false;
          results_group = null;
          if (this.include_option_in_results(option)) {
            if (option.group) {
              option.group_match = false;
              option.active_options = 0;
            }
            if (option.group_array_index != null && this.results_data[option.group_array_index]) {
              results_group = this.results_data[option.group_array_index];
              if (results_group.active_options === 0 && results_group.search_match) {
                results += 1;
              }
              results_group.active_options += 1;
            }
            option.search_text = option.group ? option.label : option.html;
            if (!(option.group && !this.group_search)) {
              option.search_match = this.search_string_match(option.search_text, regex);
              if (option.search_match && !option.group) {
                results += 1;
              }
              if (option.search_match) {
                if (searchText.length) {
                  startpos = option.search_text.search(zregex);
                  text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                  option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                }
                if (results_group != null) {
                  results_group.group_match = true;
                }
              } else if (option.group_array_index != null && this.results_data[option.group_array_index].search_match) {
                option.search_match = true;
              }
            }
          }
        }
        this.result_clear_highlight();
        if (results < 1 && searchText.length) {
          this.update_results_content("");
          return this.no_results(searchText);
        } else {
          this.update_results_content(this.results_option_build());
          return this.winnow_results_set_highlight();
        }
      };

      AbstractChosen.prototype.get_search_regex = function (escaped_search_string) {
        var regex_anchor, regex_flag;
        regex_anchor = this.search_contains ? "" : "^";
        regex_flag = this.case_sensitive_search ? "" : "i";
        return new RegExp(regex_anchor + escaped_search_string, regex_flag);
      };

      AbstractChosen.prototype.search_string_match = function (search_string, regex) {
        var part, parts, _i, _len;
        if (regex.test(search_string)) {
          return true;
        } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
          parts = search_string.replace(/\[|\]/g, "").split(" ");
          if (parts.length) {
            for (_i = 0, _len = parts.length; _i < _len; _i++) {
              part = parts[_i];
              if (regex.test(part)) {
                return true;
              }
            }
          }
        }
      };

      AbstractChosen.prototype.choices_count = function () {
        var option, _i, _len, _ref;
        if (this.selected_option_count != null) {
          return this.selected_option_count;
        }
        this.selected_option_count = 0;
        _ref = this.form_field.options;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          option = _ref[_i];
          if (option.selected) {
            this.selected_option_count += 1;
          }
        }
        return this.selected_option_count;
      };

      AbstractChosen.prototype.choices_click = function (evt) {
        evt.preventDefault();
        if (!(this.results_showing || this.is_disabled)) {
          return this.results_show();
        }
      };

      AbstractChosen.prototype.keyup_checker = function (evt) {
        var stroke, _ref;
        stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
        this.search_field_scale();
        switch (stroke) {
          case 8:
            if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
              return this.keydown_backstroke();
            } else if (!this.pending_backstroke) {
              this.result_clear_highlight();
              return this.results_search();
            }
            break;
          case 13:
            evt.preventDefault();
            if (this.results_showing) {
              return this.result_select(evt);
            }
            break;
          case 27:
            if (this.results_showing) {
              this.results_hide();
            }
            return true;
          case 9:
          case 38:
          case 40:
          case 16:
          case 91:
          case 17:
          case 18:
            break;
          default:
            return this.results_search();
        }
      };

      AbstractChosen.prototype.clipboard_event_checker = function (evt) {
        var _this = this;
        return setTimeout(function () {
          return _this.results_search();
        }, 50);
      };

      AbstractChosen.prototype.container_width = function () {
        if (this.options.width != null) {
          return this.options.width;
        } else {
          return "" + this.form_field.offsetWidth + "px";
        }
      };

      AbstractChosen.prototype.include_option_in_results = function (option) {
        if (this.is_multiple && !this.display_selected_options && option.selected) {
          return false;
        }
        if (!this.display_disabled_options && option.disabled) {
          return false;
        }
        if (option.empty) {
          return false;
        }
        return true;
      };

      AbstractChosen.prototype.search_results_touchstart = function (evt) {
        this.touch_started = true;
        return this.search_results_mouseover(evt);
      };

      AbstractChosen.prototype.search_results_touchmove = function (evt) {
        this.touch_started = false;
        return this.search_results_mouseout(evt);
      };

      AbstractChosen.prototype.search_results_touchend = function (evt) {
        if (this.touch_started) {
          return this.search_results_mouseup(evt);
        }
      };

      AbstractChosen.prototype.outerHTML = function (element) {
        var tmp;
        if (element.outerHTML) {
          return element.outerHTML;
        }
        tmp = document.createElement("div");
        tmp.appendChild(element);
        return tmp.innerHTML;
      };

      AbstractChosen.browser_is_supported = function () {
        if ("Microsoft Internet Explorer" === window.navigator.appName) {
          return document.documentMode >= 8;
        }
        if (/iP(od|ad|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
          return false;
        }
        return true;
      };

      AbstractChosen.default_multiple_text = "Select Some Options";

      AbstractChosen.default_single_text = "Select an Option";

      AbstractChosen.default_no_result_text = "No results match";

      return AbstractChosen;
    }();

    $ = jQuery;

    $.fn.extend({
      chosen: function chosen(options) {
        if (!AbstractChosen.browser_is_supported()) {
          return this;
        }
        return this.each(function (input_field) {
          var $this, chosen;
          $this = $(this);
          chosen = $this.data('chosen');
          if (options === 'destroy') {
            if (chosen instanceof Chosen) {
              chosen.destroy();
            }
            return;
          }
          if (!(chosen instanceof Chosen)) {
            $this.data('chosen', new Chosen(this, options));
          }
        });
      }
    });

    Chosen = function (_super) {
      __extends(Chosen, _super);

      function Chosen() {
        _ref = Chosen.__super__.constructor.apply(this, arguments);
        return _ref;
      }

      Chosen.prototype.setup = function () {
        this.form_field_jq = $(this.form_field);
        this.current_selectedIndex = this.form_field.selectedIndex;
        return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
      };

      Chosen.prototype.set_up_html = function () {
        var container_classes, container_props;
        container_classes = ["chosen-container"];
        container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
        if (this.inherit_select_classes && this.form_field.className) {
          container_classes.push(this.form_field.className);
        }
        if (this.is_rtl) {
          container_classes.push("chosen-rtl");
        }
        container_props = {
          'class': container_classes.join(' '),
          'style': "width: " + this.container_width() + ";",
          'title': this.form_field.title
        };
        if (this.form_field.id.length) {
          container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
        }
        this.container = $("<div />", container_props);
        if (this.is_multiple) {
          this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
        } else {
          this.container.html('<a class="chosen-single chosen-default"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
        }
        this.form_field_jq.hide().after(this.container);
        this.dropdown = this.container.find('div.chosen-drop').first();
        this.search_field = this.container.find('input').first();
        this.search_results = this.container.find('ul.chosen-results').first();
        this.search_field_scale();
        this.search_no_results = this.container.find('li.no-results').first();
        if (this.is_multiple) {
          this.search_choices = this.container.find('ul.chosen-choices').first();
          this.search_container = this.container.find('li.search-field').first();
        } else {
          this.search_container = this.container.find('div.chosen-search').first();
          this.selected_item = this.container.find('.chosen-single').first();
        }
        this.results_build();
        this.set_tab_index();
        return this.set_label_behavior();
      };

      Chosen.prototype.on_ready = function () {
        return this.form_field_jq.trigger("chosen:ready", {
          chosen: this
        });
      };

      Chosen.prototype.register_observers = function () {
        var _this = this;
        this.container.bind('touchstart.chosen', function (evt) {
          _this.container_mousedown(evt);
          return evt.preventDefault();
        });
        this.container.bind('touchend.chosen', function (evt) {
          _this.container_mouseup(evt);
          return evt.preventDefault();
        });
        this.container.bind('mousedown.chosen', function (evt) {
          _this.container_mousedown(evt);
        });
        this.container.bind('mouseup.chosen', function (evt) {
          _this.container_mouseup(evt);
        });
        this.container.bind('mouseenter.chosen', function (evt) {
          _this.mouse_enter(evt);
        });
        this.container.bind('mouseleave.chosen', function (evt) {
          _this.mouse_leave(evt);
        });
        this.search_results.bind('mouseup.chosen', function (evt) {
          _this.search_results_mouseup(evt);
        });
        this.search_results.bind('mouseover.chosen', function (evt) {
          _this.search_results_mouseover(evt);
        });
        this.search_results.bind('mouseout.chosen', function (evt) {
          _this.search_results_mouseout(evt);
        });
        this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function (evt) {
          _this.search_results_mousewheel(evt);
        });
        this.search_results.bind('touchstart.chosen', function (evt) {
          _this.search_results_touchstart(evt);
        });
        this.search_results.bind('touchmove.chosen', function (evt) {
          _this.search_results_touchmove(evt);
        });
        this.search_results.bind('touchend.chosen', function (evt) {
          _this.search_results_touchend(evt);
        });
        this.form_field_jq.bind("chosen:updated.chosen", function (evt) {
          _this.results_update_field(evt);
        });
        this.form_field_jq.bind("chosen:activate.chosen", function (evt) {
          _this.activate_field(evt);
        });
        this.form_field_jq.bind("chosen:open.chosen", function (evt) {
          _this.container_mousedown(evt);
        });
        this.form_field_jq.bind("chosen:close.chosen", function (evt) {
          _this.input_blur(evt);
        });
        this.search_field.bind('blur.chosen', function (evt) {
          _this.input_blur(evt);
        });
        this.search_field.bind('keyup.chosen', function (evt) {
          _this.keyup_checker(evt);
        });
        this.search_field.bind('keydown.chosen', function (evt) {
          _this.keydown_checker(evt);
        });
        this.search_field.bind('focus.chosen', function (evt) {
          _this.input_focus(evt);
        });
        this.search_field.bind('cut.chosen', function (evt) {
          _this.clipboard_event_checker(evt);
        });
        this.search_field.bind('paste.chosen', function (evt) {
          _this.clipboard_event_checker(evt);
        });
        if (this.is_multiple) {
          return this.search_choices.bind('click.chosen', function (evt) {
            _this.choices_click(evt);
          });
        } else {
          return this.container.bind('click.chosen', function (evt) {
            evt.preventDefault();
          });
        }
      };

      Chosen.prototype.destroy = function () {
        $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
        if (this.search_field[0].tabIndex) {
          this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
        }
        this.container.remove();
        this.form_field_jq.removeData('chosen');
        return this.form_field_jq.show();
      };

      Chosen.prototype.search_field_disabled = function () {
        this.is_disabled = this.form_field_jq[0].disabled;
        if (this.is_disabled) {
          this.container.addClass('chosen-disabled');
          this.search_field[0].disabled = true;
          if (!this.is_multiple) {
            this.selected_item.unbind("focus.chosen", this.activate_action);
          }
          return this.close_field();
        } else {
          this.container.removeClass('chosen-disabled');
          this.search_field[0].disabled = false;
          if (!this.is_multiple) {
            return this.selected_item.bind("focus.chosen", this.activate_action);
          }
        }
      };

      Chosen.prototype.container_mousedown = function (evt) {
        if (!this.is_disabled) {
          if (evt && evt.type === "mousedown" && !this.results_showing) {
            evt.preventDefault();
          }
          if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
            if (!this.active_field) {
              if (this.is_multiple) {
                this.search_field.val("");
              }
              $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
              this.results_show();
            } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chosen-single").length)) {
              evt.preventDefault();
              this.results_toggle();
            }
            return this.activate_field();
          }
        }
      };

      Chosen.prototype.container_mouseup = function (evt) {
        if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
          return this.results_reset(evt);
        }
      };

      Chosen.prototype.search_results_mousewheel = function (evt) {
        var delta;
        if (evt.originalEvent) {
          delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
        }
        if (delta != null) {
          evt.preventDefault();
          if (evt.type === 'DOMMouseScroll') {
            delta = delta * 40;
          }
          return this.search_results.scrollTop(delta + this.search_results.scrollTop());
        }
      };

      Chosen.prototype.blur_test = function (evt) {
        if (!this.active_field && this.container.hasClass("chosen-container-active")) {
          return this.close_field();
        }
      };

      Chosen.prototype.close_field = function () {
        $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
        this.active_field = false;
        this.results_hide();
        this.container.removeClass("chosen-container-active");
        this.clear_backstroke();
        this.show_search_field_default();
        return this.search_field_scale();
      };

      Chosen.prototype.activate_field = function () {
        this.container.addClass("chosen-container-active");
        this.active_field = true;
        this.search_field.val(this.search_field.val());
        return this.search_field.focus();
      };

      Chosen.prototype.test_active_click = function (evt) {
        var active_container;
        active_container = $(evt.target).closest('.chosen-container');
        if (active_container.length && this.container[0] === active_container[0]) {
          return this.active_field = true;
        } else {
          return this.close_field();
        }
      };

      Chosen.prototype.results_build = function () {
        this.parsing = true;
        this.selected_option_count = null;
        this.results_data = SelectParser.select_to_array(this.form_field);
        if (this.is_multiple) {
          this.search_choices.find("li.search-choice").remove();
        } else if (!this.is_multiple) {
          this.single_set_selected_text();
          if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
            this.search_field[0].readOnly = true;
            this.container.addClass("chosen-container-single-nosearch");
          } else {
            this.search_field[0].readOnly = false;
            this.container.removeClass("chosen-container-single-nosearch");
          }
        }
        this.update_results_content(this.results_option_build({
          first: true
        }));
        this.search_field_disabled();
        this.show_search_field_default();
        this.search_field_scale();
        return this.parsing = false;
      };

      Chosen.prototype.result_do_highlight = function (el) {
        var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
        if (el.length) {
          this.result_clear_highlight();
          this.result_highlight = el;
          this.result_highlight.addClass("highlighted");
          maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
          visible_top = this.search_results.scrollTop();
          visible_bottom = maxHeight + visible_top;
          high_top = this.result_highlight.position().top + this.search_results.scrollTop();
          high_bottom = high_top + this.result_highlight.outerHeight();
          if (high_bottom >= visible_bottom) {
            return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
          } else if (high_top < visible_top) {
            return this.search_results.scrollTop(high_top);
          }
        }
      };

      Chosen.prototype.result_clear_highlight = function () {
        if (this.result_highlight) {
          this.result_highlight.removeClass("highlighted");
        }
        return this.result_highlight = null;
      };

      Chosen.prototype.results_show = function () {
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger("chosen:maxselected", {
            chosen: this
          });
          return false;
        }
        this.container.addClass("chosen-with-drop");
        this.results_showing = true;
        this.search_field.focus();
        this.search_field.val(this.search_field.val());
        this.winnow_results();
        return this.form_field_jq.trigger("chosen:showing_dropdown", {
          chosen: this
        });
      };

      Chosen.prototype.update_results_content = function (content) {
        if (content === '') {
          return this.search_results.html(content).height();
        }
        return this.search_results.html(content);
      };

      Chosen.prototype.results_hide = function () {
        if (this.results_showing) {
          this.result_clear_highlight();
          this.container.removeClass("chosen-with-drop");
          this.form_field_jq.trigger("chosen:hiding_dropdown", {
            chosen: this
          });
        }
        return this.results_showing = false;
      };

      Chosen.prototype.set_tab_index = function (el) {
        var ti;
        if (this.form_field.tabIndex) {
          ti = this.form_field.tabIndex;
          this.form_field.tabIndex = -1;
          return this.search_field[0].tabIndex = ti;
        }
      };

      Chosen.prototype.set_label_behavior = function () {
        var _this = this;
        this.form_field_label = this.form_field_jq.parents("label");
        if (!this.form_field_label.length && this.form_field.id.length) {
          this.form_field_label = $("label[for='" + this.form_field.id + "']");
        }
        if (this.form_field_label.length > 0) {
          return this.form_field_label.bind('click.chosen', function (evt) {
            if (_this.is_multiple) {
              return _this.container_mousedown(evt);
            } else {
              return _this.activate_field();
            }
          });
        }
      };

      Chosen.prototype.show_search_field_default = function () {
        if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
          this.search_field.val(this.default_text);
          return this.search_field.addClass("default");
        } else {
          this.search_field.val("");
          return this.search_field.removeClass("default");
        }
      };

      Chosen.prototype.search_results_mouseup = function (evt) {
        var target;
        target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
        if (target.length) {
          this.result_highlight = target;
          this.result_select(evt);
          return this.search_field.focus();
        }
      };

      Chosen.prototype.search_results_mouseover = function (evt) {
        var target;
        target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
        if (target) {
          return this.result_do_highlight(target);
        }
      };

      Chosen.prototype.search_results_mouseout = function (evt) {
        if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
          return this.result_clear_highlight();
        }
      };

      Chosen.prototype.choice_build = function (item) {
        var choice,
            close_link,
            _this = this;
        choice = $('<li />', {
          "class": "search-choice"
        }).html("<span>" + this.choice_label(item) + "</span>");
        if (item.disabled) {
          choice.addClass('search-choice-disabled');
        } else {
          close_link = $('<a />', {
            "class": 'search-choice-close',
            'data-option-array-index': item.array_index
          });
          close_link.bind('click.chosen', function (evt) {
            return _this.choice_destroy_link_click(evt);
          });
          choice.append(close_link);
        }
        return this.search_container.before(choice);
      };

      Chosen.prototype.choice_destroy_link_click = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (!this.is_disabled) {
          return this.choice_destroy($(evt.target));
        }
      };

      Chosen.prototype.choice_destroy = function (link) {
        if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
          this.show_search_field_default();
          if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
            this.results_hide();
          }
          link.parents('li').first().remove();
          return this.search_field_scale();
        }
      };

      Chosen.prototype.results_reset = function () {
        this.reset_single_select_options();
        this.form_field.options[0].selected = true;
        this.single_set_selected_text();
        this.show_search_field_default();
        this.results_reset_cleanup();
        this.form_field_jq.trigger("change");
        if (this.active_field) {
          return this.results_hide();
        }
      };

      Chosen.prototype.results_reset_cleanup = function () {
        this.current_selectedIndex = this.form_field.selectedIndex;
        return this.selected_item.find("abbr").remove();
      };

      Chosen.prototype.result_select = function (evt) {
        var high, item;
        if (this.result_highlight) {
          high = this.result_highlight;
          this.result_clear_highlight();
          if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
            this.form_field_jq.trigger("chosen:maxselected", {
              chosen: this
            });
            return false;
          }
          if (this.is_multiple) {
            high.removeClass("active-result");
          } else {
            this.reset_single_select_options();
          }
          high.addClass("result-selected");
          item = this.results_data[high[0].getAttribute("data-option-array-index")];
          item.selected = true;
          this.form_field.options[item.options_index].selected = true;
          this.selected_option_count = null;
          if (this.is_multiple) {
            this.choice_build(item);
          } else {
            this.single_set_selected_text(this.choice_label(item));
          }
          if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
            this.results_hide();
          }
          this.show_search_field_default();
          if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
            this.form_field_jq.trigger("change", {
              'selected': this.form_field.options[item.options_index].value
            });
          }
          this.current_selectedIndex = this.form_field.selectedIndex;
          evt.preventDefault();
          return this.search_field_scale();
        }
      };

      Chosen.prototype.single_set_selected_text = function (text) {
        if (text == null) {
          text = this.default_text;
        }
        if (text === this.default_text) {
          this.selected_item.addClass("chosen-default");
        } else {
          this.single_deselect_control_build();
          this.selected_item.removeClass("chosen-default");
        }
        return this.selected_item.find("span").html(text);
      };

      Chosen.prototype.result_deselect = function (pos) {
        var result_data;
        result_data = this.results_data[pos];
        if (!this.form_field.options[result_data.options_index].disabled) {
          result_data.selected = false;
          this.form_field.options[result_data.options_index].selected = false;
          this.selected_option_count = null;
          this.result_clear_highlight();
          if (this.results_showing) {
            this.winnow_results();
          }
          this.form_field_jq.trigger("change", {
            deselected: this.form_field.options[result_data.options_index].value
          });
          this.search_field_scale();
          return true;
        } else {
          return false;
        }
      };

      Chosen.prototype.single_deselect_control_build = function () {
        if (!this.allow_single_deselect) {
          return;
        }
        if (!this.selected_item.find("abbr").length) {
          this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
        }
        return this.selected_item.addClass("chosen-single-with-deselect");
      };

      Chosen.prototype.get_search_text = function () {
        return $('<div/>').text($.trim(this.search_field.val())).html();
      };

      Chosen.prototype.winnow_results_set_highlight = function () {
        var do_high, selected_results;
        selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
        do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
        if (do_high != null) {
          return this.result_do_highlight(do_high);
        }
      };

      Chosen.prototype.no_results = function (terms) {
        var no_results_html;
        no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
        no_results_html.find("span").first().html(terms);
        this.search_results.append(no_results_html);
        return this.form_field_jq.trigger("chosen:no_results", {
          chosen: this
        });
      };

      Chosen.prototype.no_results_clear = function () {
        return this.search_results.find(".no-results").remove();
      };

      Chosen.prototype.keydown_arrow = function () {
        var next_sib;
        if (this.results_showing && this.result_highlight) {
          next_sib = this.result_highlight.nextAll("li.active-result").first();
          if (next_sib) {
            return this.result_do_highlight(next_sib);
          }
        } else {
          return this.results_show();
        }
      };

      Chosen.prototype.keyup_arrow = function () {
        var prev_sibs;
        if (!this.results_showing && !this.is_multiple) {
          return this.results_show();
        } else if (this.result_highlight) {
          prev_sibs = this.result_highlight.prevAll("li.active-result");
          if (prev_sibs.length) {
            return this.result_do_highlight(prev_sibs.first());
          } else {
            if (this.choices_count() > 0) {
              this.results_hide();
            }
            return this.result_clear_highlight();
          }
        }
      };

      Chosen.prototype.keydown_backstroke = function () {
        var next_available_destroy;
        if (this.pending_backstroke) {
          this.choice_destroy(this.pending_backstroke.find("a").first());
          return this.clear_backstroke();
        } else {
          next_available_destroy = this.search_container.siblings("li.search-choice").last();
          if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
            this.pending_backstroke = next_available_destroy;
            if (this.single_backstroke_delete) {
              return this.keydown_backstroke();
            } else {
              return this.pending_backstroke.addClass("search-choice-focus");
            }
          }
        }
      };

      Chosen.prototype.clear_backstroke = function () {
        if (this.pending_backstroke) {
          this.pending_backstroke.removeClass("search-choice-focus");
        }
        return this.pending_backstroke = null;
      };

      Chosen.prototype.keydown_checker = function (evt) {
        var stroke, _ref1;
        stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
        this.search_field_scale();
        if (stroke !== 8 && this.pending_backstroke) {
          this.clear_backstroke();
        }
        switch (stroke) {
          case 8:
            this.backstroke_length = this.search_field.val().length;
            break;
          case 9:
            if (this.results_showing && !this.is_multiple) {
              this.result_select(evt);
            }
            this.mouse_on_container = false;
            break;
          case 13:
            if (this.results_showing) {
              evt.preventDefault();
            }
            break;
          case 32:
            if (this.disable_search) {
              evt.preventDefault();
            }
            break;
          case 38:
            evt.preventDefault();
            this.keyup_arrow();
            break;
          case 40:
            evt.preventDefault();
            this.keydown_arrow();
            break;
        }
      };

      Chosen.prototype.search_field_scale = function () {
        var div, f_width, h, style, style_block, styles, w, _i, _len;
        if (this.is_multiple) {
          h = 0;
          w = 0;
          style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
          styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
          for (_i = 0, _len = styles.length; _i < _len; _i++) {
            style = styles[_i];
            style_block += style + ":" + this.search_field.css(style) + ";";
          }
          div = $('<div />', {
            'style': style_block
          });
          div.text(this.search_field.val());
          $('body').append(div);
          w = div.width() + 25;
          div.remove();
          f_width = this.container.outerWidth();
          if (w > f_width - 10) {
            w = f_width - 10;
          }
          return this.search_field.css({
            'width': w + 'px'
          });
        }
      };

      return Chosen;
    }(AbstractChosen);
  }).call(undefined);

  /***/
},
/* 5 */
/***/function (module, exports) {

  module.exports = {
    "ecChosen": {
      "labels": {
        "noResultsText": {
          "da-DK": "Ingen resultater fundet",
          "en": "No results for",
          "en-GB": null,
          "fr": "Pas de résultat",
          "it": "Nessun risultato per",
          "ja": "結果なし",
          "sv": "Inga resultat för",
          "sv-SE": null,
          "zh-CN": "没有结果",
          "zh-HK": "沒有結果"
        },
        "placeholderTextMultiple": {
          "da-DK": "Vælg en eller flere",
          "en": "Select one or several items",
          "en-GB": null,
          "fr": "Sélectionnez un ou plusieurs éléments",
          "it": "Scegli una o più voci",
          "ja": "一つ以上の項目を選択",
          "sv": "Välj en eller flera alternativ",
          "sv-SE": null,
          "zh-CN": "选择一个或多个项目",
          "zh-HK": "選擇一個或多個項目"
        },
        "placeholderTextSingle": {
          "da": "Vælg et element",
          "da-DK": "Vælg en",
          "en": "Select an item",
          "en-GB": null,
          "fr": "Sélectionnez un élément",
          "it": "Scegli una voce",
          "ja": "項目を選択",
          "sv": "Välj ett alternativ",
          "sv-SE": null,
          "zh-CN": "选择一个项目",
          "zh-HK": "選擇一個項目"
        }
      },
      "settings": {
        "_model": {
          "listItems": {
            "api": {
              "method": "get",
              "parameters": {
                "deep": true,
                "isTransformSync": false,
                "throttleTime": 200,
                "transformPipeline": []
              },
              "url": null,
              "usePreviousDataOnError": true,
              "validationExpression": "",
              "validationExpressions": []
            },
            "dataSourceType": "",
            "defaults": null,
            "merge": false,
            "selector": null,
            "transformPipeline": []
          }
        },
        "_parameters": {
          "accordionQueries": {
            "childFilters": null,
            "parentFilters": null
          },
          "allowSingleDeselect": null,
          "controlClass": {},
          "controlType": {},
          "disableSearch": null,
          "disableSearchThreshold": null,
          "disabled": null,
          "displayDisabledOptions": null,
          "displaySelectedOptions": null,
          "enableSplitWordSearch": null,
          "horizontal": {},
          "imageOptionsClass": {},
          "imageOptionsClassActive": {},
          "imageOptionsClassInactive": {},
          "inheritSelectClasses": null,
          "maxSelectedOptions": null,
          "multiple": null,
          "searchContains": null,
          "singleBackstrokeDelete": null,
          "width": null
        },
        "_templates": {
          "accordionCheckboxList": "<div data-ng-if=\"::settings.get('controlType') === 'accordionCheckboxList'\" data-ng-disabled=\"parameters.disabled\" class=\"ec-form__fieldset--accordion-checkbox\">\r\n    <div class=\"ec-accordion__container\">\r\n        <div class=\"ec-accordion__tab\" data-ng-repeat=\"listItem in model.listItems track by $index\">\r\n            <div class=\"ec-accordion__tab-title\" name=\"{{ ::listItem.parentKey }}\" data-ng-click=\"openTab(tab-$index)\">\r\n                <input class=\"ec-accordion__parent\" data-ng-if=\" ::settings.get('allowSelectableAccordionTitle') \" type=\"checkbox\"\r\n                       data-ng-model=\"listItem.selectAll\"\r\n                       data-ng-click=\"toggleChildItems($index,$event)\"\r\n                       name=\"{{ ::namespaceId('checkbox') }}\"\r\n                       value=\"{{ ::listItem.parentKey }}\">\r\n                {{ ::(!labels.contains(listItem.parentValue) ? listItem.parentValue : labels.get(listItem.parentValue)) }}\r\n            </div>\r\n            <div class=\"ec-accordion__tab-content\" data-ng-class=\"isOpenTab(tab-$index) ? 'open-collapse-section' : 'close-collapse-section'\" id=\"collapse-{{ ::namespaceId(listItem.parentKey) }}-{{ ::$index }}\">\r\n                <div data-ng-repeat=\"childItem in listItem.childListItems track by $index\">\r\n                    <label class=\"ec-form__label ec-form__label--checkbox\">\r\n                        <input type=\"checkbox\" name=\"{{ ::namespaceId('checkbox') }}\"\r\n                            value=\"{{ ::childItem[settings.get('keyField')] }}\"\r\n                            data-ng-model=\"childItem.selected\"\r\n                            data-ng-change=\"addCheckedItem(childItem, listItem.parentKey)\"\r\n                            class=\"ec-form__input ec-form__input--checkbox\" />\r\n                        {{ ::(settings.get('runtimeSelectLabel') && labels.contains(childItem[settings.get('valueField')]) ? labels.get(childItem[settings.get('valueField')]) : childItem[settings.get('valueField')]) }}\r\n                    </label>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
          "buttonList": "<ul class=\"{{ ::namespaceClass('__button-list') }}\" data-ng-if=\"::(settings.get('controlType') === 'buttonList' && !settings.get('imageOptions'))\">\r\n    <li class=\"{{ ::namespaceClass('__button-item') }}\" data-ng-repeat=\"listItem in model.listItems track by $index\">\r\n        <button class=\"{{ ::namespaceClass('__btn') }}\"\r\n            data-ng-click=\"chooseButtonItem(listItem.key)\"\r\n            data-ng-class=\"parameters.buttonItemSelected == listItem.key || !parameters.buttonItemSelected && $index == 0 ? 'is-active' : ''\"\r\n            aria-pressed=\"{{ parameters.buttonItemSelected == listItem.key || !parameters.buttonItemSelected && $index == 0 }}\">\r\n            <span class=\"{{ ::namespaceClass('__btn-caption') }}\">{{ ::labels.get(listItem.value) }}</span>\r\n        </button>\r\n    </li>\r\n</ul>\r\n",
          "checkbox": "<div data-ng-if=\"::(settings.get('controlType') === 'checkbox' && !settings.get('imageOptions'))\" data-ng-disabled=\"parameters.disabled\" class=\"ec-form__fieldset ec-form__fieldset--checkbox\">\r\n    <div data-ng-repeat=\"listItem in model.listItems\" class=\"ec-form__checkbox\" mstar-drag=\"{{ listItem.rearrangeEnabled ? namespaceId() : ''}}\" mstar-drop=\"{{ listItem.rearrangeEnabled ? namespaceId() : ''}}\">\r\n        <label class=\"ec-form__label ec-form__label--checkbox {{ listItem[settings.get('disabledField')] ? 'ec-form__checkbox--disabled' : ''}} \">\r\n            <input type=\"checkbox\" name=\"{{ ::namespaceId('checkbox') }}\"\r\n                   value=\"{{ ::listItem[settings.get('keyField')] }}\"\r\n                   data-ng-model=\"checkboxStatus[listItem[settings.get('keyField')]]\"\r\n                   data-ng-change=\"checkboxChange()\"\r\n                   data-ng-true-value=\"'{{ ::listItem[settings.get('keyField')] }}'\"\r\n                   data-ng-false-value=\"null\"\r\n                   data-ng-disabled=\"listItem[settings.get('disabledField')]\"\r\n                   class=\"ec-form__input ec-form__input--checkbox\" />\r\n            <span class=\"ec-form__checkbox-text\">\r\n                {{ ::(settings.get('runtimeSelectLabel') && labels.contains(listItem[settings.get('valueField')])) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')] }}\r\n            </span>\r\n            <span class=\"ec-form__checkbox-microcopy\" data-ng-if=\"listItem[settings.get('microValueField')]\">{{ labels.contains(listItem[settings.get('microValueField')]) ? labels.get(listItem[settings.get('microValueField')]) : listItem[settings.get('microValueField')]}}</span>\r\n            <span class=\"ec-form__checkbox-tooltip\" data-ng-if=\"::listItem.tooltipKey\" mstar-tooltip-content=\"{{ ::labels.get(listItem.tooltipKey) }}\" mstar-tooltip>\r\n            </span>\r\n        </label>\r\n    </div>\r\n</div>",
          "checkboxImage": "<div data-ng-if=\"::settings.get('imageOptions')\" data-ng-disabled=\"parameters.disabled\" class=\"ec-form__fieldset ec-form__fieldset--image\">\r\n    <div data-ng-repeat=\"image in images track by $index\"\r\n        data-ng-class=\"[image.currentClasses]\"\r\n        data-ng-click=\"imageClicked(image.key)\"\r\n        aria-pressed=\"{{ image.selected }}\"\r\n        class=\"{{ ::namespaceClass('__' + settings.get('imageOptionsClass'))}}\">\r\n    </div>\r\n</div>\r\n",
          "customList": "<ul data-ng-if=\"::settings.get('controlType') === 'customList'\" class=\"{{ ::namespaceClass(settings.get('groupClass')) }}\">\r\n    <li data-ng-repeat=\"customItemOption in ::customItemOptions track by $index\"\r\n        mstar-include=\"templates.customChosenTemplate\"\r\n        data-ng-click=\"chooseCustomItem(customItemOption.key)\"\r\n        class=\"{{ ::namespaceClass(settings.get('itemClass'))}}{{ customItemOption.key === ngModel ? ' ' + namespaceClass(settings.get('itemClass')) + '--selected':''}}\"></li>\r\n</ul>\r\n",
          "main": "<div mstar-include=\"templates[chosenType]\"></div>\r\n",
          "minimumRating": "<div data-ng-if=\"::settings.get('imageOptions')\" data-ng-disabled=\"parameters.disabled\" class=\"ec-form__fieldset ec-form__fieldset--image\">\r\n    <div data-ng-repeat=\"image in images track by $index\"\r\n        data-ng-class=\"[image.currentClasses]\"\r\n        data-ng-click=\"imageClicked(image.key)\"\r\n        aria-pressed=\"{{ image.selected }}\"\r\n        class=\"{{ ::namespaceClass('__' + settings.get('imageOptionsClass'))}}\">\r\n    </div>\r\n</div>\r\n",
          "radio": "<fieldset data-ng-if=\"::(settings.get('controlType') === 'radio' && !settings.get('imageOptions'))\" data-ng-disabled=\"parameters.disabled\" class=\"ec-form__fieldset ec-form__fieldset--radio{{ ::settings.get('horizontal') ? ' ec-form__fieldset--horizontal' : ''  }}\">\r\n    <legend data-ng-if=\"::labels.contains('fieldsetLegend')\" class=\"ec-form__legend\">\r\n        <span>{{ ::labels.get('fieldsetLegend') }}</span>\r\n    </legend>\r\n    <div data-ng-repeat=\"listItem in model.listItems track by $index\" class=\"ec-form__radio\">\r\n        <label class=\"ec-form__label ec-form__label--radio\">\r\n            <input type=\"radio\" name=\"{{namespaceId('radio')}}\"\r\n                   value=\"{{ ::listItem[settings.get('keyField')] }}\"\r\n                   data-ng-model=\"radio.selected\"\r\n                   data-ng-change=\"radioChange()\"\r\n                   class=\"ec-form__input ec-form__input--radio\" />\r\n            <span class=\"ec-form__radio-text\">\r\n                {{ ::(settings.get('runtimeSelectLabel') && labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]) }}\r\n            </span>\r\n        </label>\r\n    </div>\r\n</fieldset>\r\n",
          "radioImage": "<div data-ng-if=\"::settings.get('imageOptions')\" data-ng-disabled=\"parameters.disabled\" class=\"ec-form__fieldset ec-form__fieldset--image\">\r\n    <div data-ng-repeat=\"image in images track by $index\"\r\n        data-ng-class=\"[image.currentClasses]\"\r\n        data-ng-click=\"imageClicked(image.key)\"\r\n        aria-pressed=\"{{ image.selected }}\"\r\n        class=\"{{ ::namespaceClass('__' + settings.get('imageOptionsClass'))}}\">\r\n    </div>\r\n</div>\r\n",
          "select": "<div data-ng-if=\"::(settings.get('controlType') === 'select' && !settings.get('multiple'))\" class=\"{{ ::namespaceClass('__select') + ' ' + namespaceClass('__select--single') }}\">\r\n    <select data-ng-model=\"$parent.ngModel\"\r\n            name=\"todo\" mstar-validate\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId('select') }}\"\r\n            class=\"ec-form__select\">\r\n        <option value=\"\" data-ng-if=\"::!settings.get('multiple') && ::settings.get('displayFirstEmptyOption')\"></option>\r\n        <option data-ng-repeat=\"listItem in model.listItems track by $index\" value=\"{{ listItem[settings.get('keyField')] }}\">\r\n            {{ (settings.get('runtimeSelectLabel') && labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]) }}\r\n        </option>\r\n    </select>\r\n</div>\r\n\r\n<div data-ng-if=\"::(settings.get('controlType') === 'select' && settings.get('multiple'))\" class=\"{{ ::namespaceClass('__select') + ' ' + namespaceClass('__select--multiple') }}\">\r\n    <select data-ng-model=\"$parent.ngModel\"\r\n            name=\"todo\" multiple=\"multiple\" mstar-validate\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId('select') }}\"\r\n            class=\"ec-form__select\">\r\n        <option value=\"\" data-ng-if=\"::!settings.get('multiple')\"></option>\r\n        <option data-ng-repeat=\"listItem in model.listItems track by $index\" value=\"{{ listItem[settings.get('keyField')] }}\">\r\n            {{ (settings.get('runtimeSelectLabel') && labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]) }}\r\n        </option>\r\n    </select>\r\n</div>\r\n"
        },
        "_validation": {
          "dataType": null,
          "messageWhen": "always",
          "modelRules": {},
          "rules": {},
          "tooltipWhen": "touched",
          "validationMessageHandlerType": "self"
        },
        "accordionQueries": {
          "childFilters": null,
          "parentFilters": null
        },
        "allowSelectableAccordionTitle": false,
        "allowSingleDeselect": true,
        "controlClass": null,
        "controlType": "select",
        "customItemOptions": null,
        "disableSearch": false,
        "disableSearchThreshold": null,
        "disabled": false,
        "disabledField": "disabled",
        "displayDisabledOptions": null,
        "displayFirstEmptyOption": true,
        "displaySelectedOptions": null,
        "enableSplitWordSearch": null,
        "groupClass": "group-class",
        "horizontal": false,
        "imageOptions": null,
        "imageOptionsClass": null,
        "imageOptionsClassActive": "active",
        "imageOptionsClassInactive": "inactive",
        "inheritSelectClasses": null,
        "itemClass": "item-class",
        "keyField": "key",
        "loader": {
          "enabled": false
        },
        "loaderEnabled": true,
        "maxSelectedOptions": null,
        "microValueField": null,
        "multiple": false,
        "namespaceClass": "ec-chosen",
        "runtimeSelectLabel": true,
        "searchContains": null,
        "singleBackstrokeDelete": null,
        "valueField": "value",
        "width": null
      },
      "type": "ecChosen"
    }
  };

  /***/
},
/* 6 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecChosen', __webpack_require__(5).ecChosen);
    morningstar.asterix.meta.register('ecChosen', 'allowedEvents', ['ecChosenItemSelected']);
    __webpack_require__(4);
    __webpack_require__(2);
    __webpack_require__(3);
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  /***/
},
/* 7 */
/***/function (module, exports) {

  module.exports = angular;

  /***/
}]
/******/);
//# sourceMappingURL=ec-chosen.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 3);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 1 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(0), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
        'use strict';

        comboBox.$inject = ["$timeout"];
        angular.module('ecComboBox', ['mstarCore']).directive('ecComboBox', comboBox);

        function comboBox($timeout) {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {
                    ngModel: '=',
                    ngConfig: '=?',
                    inputData: '=?inputData'
                },
                link: linkFn
            };

            function linkFn(scope, elem, attr, mstarComponent) {

                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
                if (attr.inputData) {
                    scope.instance.setModel(scope.inputData || {});
                    mstarComponent.bindModel(scope);
                    scope.$watch('inputData', function (currVal) {
                        if (currVal) {
                            scope.instance.setModel(currVal);
                            mstarComponent.bindModel(scope);
                        }
                    }, true);
                } else {
                    mstarComponent.bindModelData(scope);
                }

                // use for dynamic instance to update the parameters passed from config
                if (attr.ngConfig) {
                    var parameters = scope.instance.getParameters(),
                        keys = _.keys(scope.ngConfig);

                    _.each(keys, function (key) {
                        if (parameters.hasOwnProperty(key)) {
                            scope.instance.setParameter(key, scope.ngConfig[key]);
                        }
                    });
                }
                // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

                var selectorComboBox = '__select',
                    displaySettings = scope.parameters.displaySettings,
                    selectElement,
                    currentTemplate = '_templates.main';

                if (scope.parameters.groupByField) {
                    if (displaySettings.multiple) {
                        currentTemplate = '_templates.groupedMultiSelect';
                    } else {
                        currentTemplate = '_templates.groupedSingleSelect';
                    }
                } else if (displaySettings.multiple) {
                    currentTemplate = '_templates.multiSelect';
                }

                mstarComponent.compileTemplate(scope, currentTemplate);

                var findSelectElem = function findSelectElem() {
                    if (!selectElement || !selectElement.length) {
                        selectElement = elem.find('.' + scope.settings.get('namespaceClass') + selectorComboBox);
                    }
                };

                mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:listItems', function () {
                    $timeout(function () {
                        selectElement.trigger('change');
                    }, 0);
                }));

                $timeout(function () {
                    findSelectElem();
                    if (scope.ngConfig && scope.ngConfig.placeholder) {
                        displaySettings.placeholder = scope.labels.get(scope.ngConfig.placeholder);
                    } else if (scope.labels.contains('placeholder')) {
                        displaySettings.placeholder = scope.labels.get('placeholder');
                    }
                    selectElement.select2(displaySettings);

                    // If using label option, change the default label for the combo-box to the main label
                    // This is because screen readers will otherwise hear the first option in the list
                    // which in a lot of cases is just the word "All" so users won't know what the combo-box is for
                    if (scope.settings.get('ariaLabelledBy') === 'label') {
                        var combobox = elem.find('[role="combobox"]');
                        combobox.attr('aria-labelledby', scope.namespaceId('label'));
                    }
                }, 0);

                var refreshSelect = function refreshSelect() {
                    $timeout(function () {
                        findSelectElem();
                        selectElement.trigger('change.select2');

                        // Add a title attribute to the combo-box so the default item is read out by screen readers
                        if (scope.settings.get('ariaLabelledBy') === 'label') {
                            var combobox = elem.find('[role="combobox"]'),
                                selected = elem.find('.select2-selection__rendered');
                            combobox.attr('title', selected.attr('title'));
                        }
                    }, 0);
                };

                scope.$watch('ngModel', refreshSelect);

                var destroySelect2 = function destroySelect2() {
                    findSelectElem();

                    if (selectElement.data('select2')) {
                        selectElement.select2('destroy');
                    }
                };

                scope.$on('$destroy', destroySelect2);
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 2 */
/***/function (module, exports) {

    module.exports = {
        "ecComboBox": {
            "components": {},
            "labels": {
                "caption": {
                    "en": null,
                    "en-GB": null,
                    "sv-SE": null
                },
                "placeholder": {
                    "en": null,
                    "en-GB": null,
                    "sv-SE": null
                }
            },
            "settings": {
                "_model": {
                    "listItems": {
                        "api": {
                            "method": "get",
                            "parameters": {
                                "deep": true,
                                "isTransformSync": false,
                                "throttleTime": 200,
                                "transformPipeline": []
                            },
                            "url": null,
                            "usePreviousDataOnError": true,
                            "validationExpression": "",
                            "validationExpressions": []
                        },
                        "dataSourceType": "",
                        "defaults": null,
                        "merge": false,
                        "selector": null,
                        "transformPipeline": []
                    }
                },
                "_parameters": {
                    "disabled": {},
                    "displaySettings": {},
                    "groupByField": {},
                    "runtimeSelectLabel": {}
                },
                "_templates": {
                    "groupedMultiSelect": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label data-ng-if=\"labels.contains('caption')\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId() }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId() }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')] group by listItem[parameters.groupByField]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\"\r\n            multiple=\"multiple\">\r\n    </select>\r\n</div>\r\n",
                    "groupedSingleSelect": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label data-ng-if=\"labels.contains('caption')\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId() }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId() }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')] group by listItem[parameters.groupByField]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\">\r\n        <option data-ng-if=\"labels.contains('placeholder') || (ngConfig && ngConfig.placeholder)\" value=\"\"></option>\r\n    </select>\r\n</div>\r\n",
                    "main": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label id=\"{{ ::namespaceId('label') }}\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId('select') }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId('select') }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\">\r\n        <option data-ng-if=\"labels.contains('placeholder') || (ngConfig && ngConfig.placeholder)\" value=\"\"></option>\r\n    </select>\r\n</div>\r\n",
                    "multiSelect": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label id=\"{{ ::namespaceId('label') }}\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId('select') }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId('select') }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\"\r\n            multiple=\"multiple\">\r\n    </select>\r\n</div>\r\n"
                },
                "ariaLabelledBy": "label",
                "disabled": false,
                "displaySettings": {
                    "containerCssClass": "mui-combo-box__container",
                    "dropdownCssClass": "mui-combo-box__dropdown",
                    "theme": "default mui-combo-box",
                    "width": "200"
                },
                "groupByField": false,
                "keyField": "key",
                "namespaceClass": "ec-combo-box",
                "runtimeSelectLabel": true,
                "valueField": "value"
            },
            "type": "ecComboBox"
        }
    };

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecComboBox', __webpack_require__(2).ecComboBox);
        morningstar.asterix.meta.register('ecComboBox', 'allowedEvents', ['ecComboBoxItemSelected']);
        __webpack_require__(1);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 5 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
}]
/******/);
//# sourceMappingURL=ec-combo-box.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 7);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 1 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 2 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, angular) {
        'use strict';

        var _groupElement = null;
        var MAX_COLS = 12;
        var MAX_WIDTH = 1200;

        var calculateSelfWidth = function calculateSelfWidth(cols, parentWidth) {
            return cols / MAX_COLS * parentWidth;
        };

        var callWithActiveBreakpoint = function callWithActiveBreakpoint(breakpointObj, width, cb) {
            //Original call was with a dimensions object instead of width
            //so check if param is object and get width value from it if it is
            if (morningstar.asterix.util.isPlainObject(width)) {
                width = width.width;
            }

            var breakpoints = _.chain(breakpointObj).map(function (breakpoint, key) {
                return {
                    name: key,
                    width: breakpoint
                };
            }).sortBy(function (breakpoint) {
                return breakpoint.width;
            }).value();

            for (var i = 0; i < breakpoints.length; ++i) {
                var breakpoint = breakpoints[i];
                if (width <= breakpoint.width || i + 1 === breakpoints.length) {
                    cb(breakpoint);
                    break;
                }
            }
        };

        var evaluateCols = function evaluateCols(configEvaluator, expression, callback, unregisterCallbacks) {
            function extractFirstElementThatMeetsCondition(conditions) {
                var r = _.find(conditions, function (e) {
                    return e.condition || morningstar.asterix.util.isNumber(e);
                });
                return morningstar.asterix.util.isNumber(r) ? r : r.value;
            }

            if (morningstar.asterix.util.isNumber(expression)) {
                return expression;
            }

            var evaluation = configEvaluator.evaluate(expression, {
                model: true,
                settings: true
            });

            unregisterCallbacks.push(evaluation.listen(function () {
                var reevaluated = evaluation.reEvaluate();
                callback(extractFirstElementThatMeetsCondition(reevaluated));
            }));

            return extractFirstElementThatMeetsCondition(evaluation.evaluated);
        };

        var evaluateColsExpression = function evaluateColsExpression(configEvaluator, expression, component, callback) {
            if (morningstar.asterix.util.isNumber(expression)) {
                // expression is numeric value
                callback(expression);
            } else if (morningstar.asterix.util.isString(expression) && expression !== '') {
                // evaluate and add listener for binding
                var evaluation = configEvaluator.evaluate(expression, {
                    model: true,
                    settings: true
                });

                callback(evaluation.evaluated);

                component.addUnregisterCallback(evaluation.listen(function () {
                    var value = evaluation.reEvaluate();
                    callback(value);
                }));
            }
        };

        var evaluateShowExpression = function evaluateShowExpression(configEvaluator, expression, component, callback) {
            function evaluationValueSetter(value) {
                callback(value && value.toString().toLowerCase() === 'true');
            }

            // evaluate and add listener for binding
            if (morningstar.asterix.util.isString(expression) && expression !== '') {
                var evaluation = configEvaluator.evaluate(expression, {
                    model: true,
                    settings: true
                });

                evaluationValueSetter(evaluation.evaluated);

                _.each(evaluation.references, function handleSelectorReference(reference) {
                    component.addUnregisterCallback(reference.listen(function (value) {
                        evaluationValueSetter(value);
                    }));
                });
            } else if (morningstar.asterix.util.isBoolean(expression)) {
                // expression is boolean value i.e true/false
                callback(expression);
            }
        };

        var getGroupElementClone = function getGroupElementClone() {
            var ret;
            if (!_groupElement) {
                _groupElement = angular.element(__webpack_require__(9));
            }

            ret = _groupElement.clone();
            return ret;
        };

        var triggerBreakpointListeners = function triggerBreakpointListeners(scope) {
            morningstar.asterix.util.each(scope.breakpointListeners, function (cb) {
                cb(scope.breakpoint);
            });
        };

        var triggerWidthListeners = function triggerWidthListeners(scope, dimensions) {
            morningstar.asterix.util.each(scope.widthListeners, function (cb) {
                cb(dimensions);
            });
        };

        module.exports = {
            calculateSelfWidth: calculateSelfWidth,
            callWithActiveBreakpoint: callWithActiveBreakpoint,
            evaluateCols: evaluateCols,
            evaluateColsExpression: evaluateColsExpression,
            evaluateShowExpression: evaluateShowExpression,
            getGroupElementClone: getGroupElementClone,
            triggerBreakpointListeners: triggerBreakpointListeners,
            triggerWidthListeners: triggerWidthListeners,
            MAX_COLS: MAX_COLS,
            MAX_WIDTH: MAX_WIDTH
        };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
        'use strict';

        container.$inject = ["mstarDimensions", "mstarDebounce", "$interpolate", "$log", "$compile"];
        var _eventTopicExpanded = 'ecContainerExpanded',
            _eventTopicCollapsed = 'ecContainerCollapsed';

        angular.module('ecContainer', ['mstarCore', 'ngSanitize']).directive('ecContainer', container);

        function container(mstarDimensions, mstarDebounce, $interpolate, $log, $compile) {
            controllerFn.$inject = ["$scope", "$element"];
            return {
                restrict: 'E',
                require: ['mstarComponentId', '^?ecSection', 'ecContainer'],
                scope: {},
                transclude: true,
                template: __webpack_require__(8),
                controller: controllerFn,
                link: linkFn
            };

            function controllerFn($scope, $element) {
                $scope.groups = [];
                $scope.sections = [];
                $scope.widthListeners = [];
                $scope.breakpointListeners = [];

                var parentSection = $element.parent().controller('ecSection');
                $scope.parent = parentSection;

                var configEvaluator = null;
                var mstarComponent = $element.controller('mstarComponentId');

                /* jshint validthis: true */
                this.trigger = function trigger() {
                    return mstarComponent.getComponentInstance().trigger.apply(mstarComponent.getComponentInstance(), arguments);
                };

                this.registerSection = function registerSection(section, showFlagSetter) {
                    configEvaluator = configEvaluator || new morningstar.asterix.ConfigEvaluator(mstarComponent.getComponentId(), morningstar.asterix.instanceRegistry);

                    this.preProcessSettings();

                    var i = 0;
                    while (section.element.parent('div[data-ng-transclude]').length === 0) {
                        section.element = section.element.parent();
                        if (i++ > 20) {
                            break;
                        }
                    }

                    $scope.sections.push(section);
                    section.config = section.sectionId && $scope.sectionSettings[section.sectionId] ? $scope.sectionSettings[section.sectionId] : {};

                    helper.evaluateShowExpression(configEvaluator, section.config.show, mstarComponent, showFlagSetter);

                    var defaultSectionCopy = getSettingCopyOrDefault($scope.settings.get('defaultSection'));
                    section.config = morningstar.asterix.util.merge({}, defaultSectionCopy, section.config);
                    section.originalConfig = morningstar.asterix.util.merge({}, section.config);

                    if (section.title) {
                        section.headerId = $scope.namespaceId('sectionHeader-' + (section.sectionId || section.$id));
                    }
                    section.panelId = $scope.namespaceId('sectionPanel-' + (section.sectionId || section.$id));

                    if (section.config.hasOwnProperty('titleTemplate')) {
                        if (!section.config.titleTemplate) {
                            section.title = null;
                        } else {
                            // hack: see if $parent has "instance", otherwise use own scope
                            $scope.$watch(function () {
                                return $interpolate(section.config.titleTemplate)($scope.$parent.instance ? $scope.$parent : $scope);
                            }, function (value) {
                                section.title = value;
                                section.element.removeClass('ec-section--no-title');
                                if (!section.headerId) {
                                    section.headerId = $scope.namespaceId('sectionHeader-' + (section.sectionId || section.$id));
                                }
                            });
                        }
                    }

                    if (section.config.hasOwnProperty('titleTooltipLabelId')) {
                        section.titleTooltipLabelId = section.config.titleTooltipLabelId;
                    }

                    $scope.hasUnprocessedSections = true;
                    $scope.scheduleSetup();
                };

                this.unregisterSection = function unregisterSection(section) {
                    $scope.sections.splice($scope.sections.indexOf(section), 1);
                    $scope.hasUnprocessedSections = true;
                    $scope.scheduleSetup();
                };

                var hasPreProcessedSettings = false;

                this.preProcessSettings = function preProcessSettings() {
                    if (hasPreProcessedSettings) {
                        return;
                    }

                    hasPreProcessedSettings = true;

                    $scope.sectionSettings = getSettingCopyOrDefault($scope.settings.get('sections'));

                    for (var sectionKey in $scope.sectionSettings) {
                        var section = $scope.sectionSettings[sectionKey];
                        section.breakpoints = section.breakpoints || {};

                        for (var breakpointKey in $scope.viewBreakpoints) {
                            section.breakpoints[breakpointKey] = getBreakpointDefinition(breakpointKey, section.breakpoints);

                            if (section.breakpoints.defaults) {
                                section.breakpoints[breakpointKey] = morningstar.asterix.util.merge({}, section.breakpoints.defaults, section.breakpoints[breakpointKey]);
                            }
                        }
                    }

                    $scope.breakpointSettings = getSettingCopyOrDefault($scope.settings.get('breakpoints'));

                    for (var _breakpointKey in $scope.viewBreakpoints) {
                        var breakpointSetting = getBreakpointDefinition(_breakpointKey, $scope.breakpointSettings);

                        if ($scope.breakpointSettings.defaults) {
                            if (!breakpointSetting.groups && $scope.breakpointSettings.defaults.groups) {
                                // no groups specified - inherit from defaults
                                breakpointSetting.groups = morningstar.asterix.util.merge({}, $scope.breakpointSettings.defaults.groups);
                            }

                            breakpointSetting.collapserPosition = breakpointSetting.collapserPosition || $scope.breakpointSettings.defaults.collapserPosition;
                            breakpointSetting.autoCollapseMode = breakpointSetting.autoCollapseMode || $scope.breakpointSettings.defaults.autoCollapseMode;
                        }

                        $scope.breakpointSettings[_breakpointKey] = breakpointSetting;
                    }

                    function getBreakpointDefinition(key, breakpoints, attempt) {
                        //find the breakpoint definition
                        //breakpoint reference by string - inherit some other breakpoint setting
                        var definition;
                        attempt = attempt || 1;

                        //this prevents an infinite loop of lookups
                        if (attempt > Object.keys(breakpoints).length) {
                            definition = {};
                        } else if (morningstar.asterix.util.isString(breakpoints[key])) {
                            attempt++;
                            definition = getBreakpointDefinition(breakpoints[key], breakpoints, attempt);
                        } else {
                            definition = morningstar.asterix.util.merge({}, breakpoints[key] || {});
                        }

                        return definition;
                    }
                };

                this.collapseAllSectionsAndGroups = function collapseAllSectionsAndGroups(currentSectionOrGroup) {
                    morningstar.asterix.util.each($scope.groups, function (group) {
                        var groupScope = $scope.useCalculatedWidth ? group.scope : group.groupElement.scope();
                        if (!groupScope.isExpanded) {
                            return;
                        }
                        if (currentSectionOrGroup !== groupScope && groupScope.collapsible) {
                            groupScope.close();
                            morningstar.asterix.instanceRegistry.get($scope.instance.modulePath).trigger(_eventTopicCollapsed, ['group', groupScope.groupId]);
                        }
                        _.each(group.sections, function (section) {
                            if (section.isExpanded && section !== currentSectionOrGroup && section.col !== 0 && section.title) {
                                section.close();
                                morningstar.asterix.instanceRegistry.get($scope.instance.modulePath).trigger(_eventTopicCollapsed, ['section', section.sectionId]);
                            }
                        });
                    });
                };

                this.toggle = function toggle(section) {
                    var isExpanded = section.isExpanded;
                    if ($scope.settings.get('enableToggleForExpand')) {
                        this.collapseAllSectionsAndGroups(section);
                    }

                    morningstar.asterix.util.each(section.config.triggerSections, function (innerSection) {
                        if (!isExpanded) {
                            innerSection.open();
                        } else {
                            innerSection.close();
                        }
                    });
                };

                this.getLevel = function getLevel() {
                    return parentSection ? parentSection.getLevel() + 1 : 0;
                };

                this.addWidthListener = function addWidthListener(callback) {
                    $scope.widthListeners.push(callback);

                    return function unregister() {
                        $scope.widthListeners.splice($scope.widthListeners.indexOf(callback), 1);
                    };
                };

                this.addBreakpointListener = function addBreakpointListener(callback) {
                    $scope.breakpointListeners.push(callback);

                    return function unregister() {
                        $scope.breakpointListeners.splice($scope.breakpointListeners.indexOf(callback), 1);
                    };
                };

                this.scheduleSetup = function scheduleSetup() {
                    $scope.scheduleSetup();
                };

                $scope.level = this.getLevel();
            }

            function linkFn(scope, elem, attr, controllers) {
                var mstarComponent = controllers[0],
                    container = controllers[2];
                var attachTo = elem.children('[data-ng-transclude]').eq(0);

                scope.show = true;

                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                scope.viewBreakpoints = scope.settings.get('viewBreakpoints');
                scope.useCalculatedWidth = scope.settings.get('useCalculatedWidth') || false;

                var configEvaluator = new morningstar.asterix.ConfigEvaluator(scope.instance.modulePath, morningstar.asterix.instanceRegistry);
                var prevWidth = null;
                var prevBreakpoint = null;
                var dimensionsInstance = mstarDimensions(scope, elem);

                if (scope.useCalculatedWidth) {
                    scope.scheduleSetup = mstarDebounce(function scheduleSetup() {
                        if (!scope.parentWidth) {
                            scope.parentWidth = elem.width();
                        }

                        scope.$applyAsync(function () {
                            handleWidthChange(helper.MAX_COLS, scope.parentWidth);
                        });
                    });

                    if (scope.parent == null) {
                        dimensionsInstance.addListener(function (dimensions) {
                            var width = Math.min(dimensions.width, helper.MAX_WIDTH);
                            if (prevWidth === width) {
                                return;
                            }

                            prevWidth = width;

                            scope.parentWidth = width;
                            scope.scheduleSetup();
                        });
                    } else {
                        mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function (parentWidth) {
                            scope.parentWidth = parentWidth;
                            scope.scheduleSetup();
                        }));

                        scope.parentWidth = scope.parent.getWidth();
                        scope.scheduleSetup();
                    }
                } else {
                    if (scope.parent == null) {
                        dimensionsInstance.addListener(function (dimensions) {
                            scope.$apply(function () {
                                handleDimensions(dimensions);
                            });
                        });
                    } else {
                        mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function () {
                            handleDimensions({
                                width: elem.width()
                            });
                        }));
                    }

                    scope.scheduleSetup = mstarDebounce(function scheduleSetup() {
                        if (scope.level < 2) {
                            scope.$evalAsync(function () {
                                handleDimensions({
                                    width: elem.width()
                                }, true);
                            });
                            return;
                        }

                        if (scope.hasScheduledSetup === true) {
                            return;
                        }

                        scope.hasScheduledSetup = true;
                        dimensionsInstance.requestDimensions(function (dimensions) {
                            scope.$evalAsync(function () {
                                handleDimensions(dimensions, true);
                                scope.hasScheduledSetup = false;
                            });
                        });
                    }, 1);
                }

                var containerShowExpression = scope.settings.contains('show') ? scope.settings.get('show') : null;
                helper.evaluateShowExpression(configEvaluator, containerShowExpression, mstarComponent, function (showFlag) {
                    scope.show = showFlag;
                });

                setupNgRepeatWatch();

                function findSection(sectionId) {
                    return _.find(scope.sections, function (section) {
                        return section.sectionId === sectionId;
                    });
                }

                function getGroupDefinitionSections(groupDefinition) {
                    return groupDefinition.sections === 'all' ? _.map(scope.sections, function (section, key) {
                        return section.sectionId;
                    }) : groupDefinition.sections;
                }

                function createGroup(groupDefinition, parentWidth) {
                    if (groupDefinition.cols == null) {
                        throw new Error('Missing cols for group definition: ' + groupDefinition.id);
                    }

                    if (groupDefinition.cols > 0 || morningstar.asterix.util.isString(groupDefinition.cols) && groupDefinition.cols.indexOf('{{') !== -1) {
                        var groupScope = scope.$new();

                        groupScope.show = true;

                        groupScope.collapsible = groupDefinition.collapsible;
                        groupScope.groupId = groupDefinition.id;
                        if (groupScope.collapsible) {
                            // this is an ugly hack to force child sections not to be collapsible
                            scope.$applyAsync(function () {
                                _.each(group.sections, function (section) {
                                    section.isExpanded = groupScope.isExpanded;
                                    section.collapsible = false;
                                });
                            });
                        }

                        if (groupDefinition.titleLabelId) {
                            scope.$watch(function () {
                                return $interpolate(scope.labels.get(groupDefinition.titleLabelId))(scope);
                            }, function (value) {
                                groupScope.title = value;
                            }, true);
                        }

                        groupScope.titleTooltipLabelId = groupDefinition.titleTooltipLabelId;

                        if (groupDefinition.autoCollapseMode === 'collapse') {
                            groupScope.isExpanded = false;
                        } else if (groupDefinition.autoCollapseMode === 'expand') {
                            groupScope.isExpanded = true;
                        } else {
                            groupScope.isExpanded = true; // not sure about this default behavior, should probably check breakpoint's setting instead
                        }

                        groupScope.classSuffix = morningstar.asterix.util.string.dashCase(groupDefinition.id);
                        groupScope.groupSectionPanelId = scope.namespaceId('groupSectionPanel-' + (groupScope.groupId || groupScope.$id));

                        groupScope.open = function openGroup() {
                            groupScope.isExpanded = true;
                        };

                        groupScope.close = function closeGroup() {
                            groupScope.isExpanded = false;
                        };

                        groupScope.classWithModifier = function classWithModifier(baseClass) {
                            return !groupScope.classSuffix ? baseClass : baseClass + ' ' + baseClass + '--' + groupScope.classSuffix;
                        };

                        groupScope.toggle = function toggleGroup() {
                            if (scope.settings.get('enableToggleForExpand')) {
                                container.collapseAllSectionsAndGroups(groupScope);
                            }
                            groupScope.isExpanded = !groupScope.isExpanded;
                            _.each(group.sections, function (section) {
                                section.isExpanded = groupScope.isExpanded;
                            });
                            mstarComponent.getComponentInstance().trigger(groupScope.isExpanded ? _eventTopicExpanded : _eventTopicCollapsed, ['group', groupDefinition.id]);
                        };

                        groupScope.breakpoint = scope.breakpoint;
                        var unregisterCallbacks = [];
                        if (scope.useCalculatedWidth) {
                            groupScope.$on('$destroy', function () {
                                _.each(unregisterCallbacks, function (cb) {
                                    cb();
                                });
                            });
                        }
                        groupScope.cols = groupDefinition.cols;

                        helper.evaluateShowExpression(configEvaluator, groupDefinition.show, mstarComponent, function (showFlag) {
                            if (!showFlag) {
                                groupScope.cols = 0;
                            } else {
                                groupScope.cols = groupDefinition.cols;
                            }
                            groupScope.show = showFlag;
                        });

                        var groupElement = $compile(helper.getGroupElementClone())(groupScope);

                        var group;

                        if (scope.useCalculatedWidth) {
                            group = {
                                cols: groupDefinition.cols,
                                groupElement: groupElement,
                                scope: groupScope,
                                sections: [],
                                sectionDefinitions: [],
                                order: groupDefinition.order,
                                defaultSection: groupDefinition.defaultSection || {},
                                unregisterCallbacks: unregisterCallbacks,
                                destroy: function destroy() {
                                    groupScope.$destroy();
                                }
                            };
                        } else {
                            group = {
                                groupElement: groupElement,
                                sections: [],
                                sectionDefinitions: [],
                                order: groupDefinition.order,
                                defaultSection: morningstar.asterix.extend(true, {}, groupDefinition.defaultSection),
                                destroy: function destroy() {
                                    groupScope.$destroy();
                                }
                            };
                        }

                        helper.evaluateColsExpression(configEvaluator, groupDefinition.cols, mstarComponent, function (cols) {
                            groupScope.cols = cols;
                            if (scope.useCalculatedWidth) {
                                processGroup(group, parentWidth);
                            }
                        });

                        morningstar.asterix.util.each(getGroupDefinitionSections(groupDefinition), function (s) {
                            var sectionId = null;
                            if (morningstar.asterix.util.isPlainObject(s)) {
                                sectionId = s.sectionId;
                                if (scope.useCalculatedWidth) {
                                    s = morningstar.asterix.util.merge({}, s);
                                    if (s.cols) {
                                        s.cols = helper.evaluateCols(configEvaluator, s.cols, function colsChanged(cols) {
                                            s.cols = cols;
                                            processGroup(group, parentWidth);
                                        }, unregisterCallbacks);
                                    }
                                }
                            } else if (morningstar.asterix.util.isString(s)) {
                                sectionId = s;
                                s = {
                                    sectionId: s
                                };
                            }

                            var section = findSection(sectionId);
                            if (section) {
                                if (groupScope.collapsible) {
                                    section.isInCollapsibleGroup = true;
                                } else {
                                    section.isInCollapsibleGroup = false;
                                }

                                var appendTo = group.groupElement.find('> section > .ec-section__content');
                                section.element.appendTo(appendTo);
                                group.sections.push(section);
                                group.sectionDefinitions.push(s);
                            }
                        });

                        if (scope.useCalculatedWidth) {
                            processGroup(group, parentWidth);
                        }

                        return group;
                    } else {
                        morningstar.asterix.util.each(getGroupDefinitionSections(groupDefinition), function (s) {
                            var sectionId = null;
                            if (morningstar.asterix.util.isPlainObject(s)) {
                                sectionId = s.sectionId;
                            } else if (morningstar.asterix.util.isString(s)) {
                                sectionId = s;
                                if (!scope.useCalculatedWidth) {
                                    s = {
                                        sectionId: s
                                    };
                                }
                            }

                            var section = findSection(sectionId);
                            if (section) {
                                section.element.detach();
                            }
                        });

                        return null;
                    }
                }

                function processGroup(group, parentWidth) {
                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, parentWidth, function (breakpoint) {
                        group.breakpoint = breakpoint.name;
                        group.width = helper.calculateSelfWidth(group.cols, parentWidth);
                        _.each(group.sections, function (section, i) {
                            morningstar.asterix.util.merge(section.config.breakpoints[breakpoint.name], group.defaultSection, group.sectionDefinitions[i]);
                        });
                    });

                    processSections(group.sections, group.breakpoint, scope.breakpointSettings[group.breakpoint], group.width);
                }

                function setScopeBreakpoint(width) {
                    elem.removeClass(_.map(scope.viewBreakpoints, function (bp, key) {
                        return 'ec-container--' + key;
                    }).join(' '));

                    //Original call was with a dimensions object instead of width
                    //so check if param is object and get width value from it if it is
                    if (morningstar.asterix.util.isPlainObject(width)) {
                        width = width.width;
                    }

                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, width, function (breakpoint) {
                        scope.breakpoint = breakpoint.name;
                    });

                    elem.addClass('ec-container--' + scope.breakpoint);
                }

                function createGroups(groupDefinitions, parentWidth) {
                    var newGroups = [];
                    var groupsRow = angular.element('<div class="ms-neat-row"></div>');
                    var orphanSections = _.filter(_.pluck(scope.sections, 'sectionId'), function (id) {
                        return id;
                    });
                    _.chain(groupDefinitions).each(function (groupDefinition, key) {
                        _.each(getGroupDefinitionSections(groupDefinition), function (section) {
                            var sectionId = section.sectionId ? section.sectionId : section;
                            orphanSections.splice(orphanSections.indexOf(sectionId), 1);
                        });

                        groupDefinition.id = key;
                    }).sortBy(function (group) {
                        return group.order;
                    }).each(function (groupDefinition) {
                        var group = createGroup(groupDefinition, parentWidth);
                        if (group) {
                            newGroups.push(group);
                            groupsRow.append(group.groupElement);
                        }
                    });

                    _.each(orphanSections, function (sectionId) {
                        var section = findSection(sectionId);
                        section.show = false;
                        section.element.detach();
                    });

                    if (orphanSections.length > 0) {
                        morningstar.asterix.instrumentation.logger.debug('Orphan sections: ' + orphanSections.join(', '));
                    }

                    attachTo.find('.ms-neat-row').remove();
                    attachTo.append(groupsRow);
                    if (scope.groupsRow) {
                        scope.groupsRow.remove();
                    }

                    scope.groupsRow = groupsRow;

                    if (!scope.useCalculatedWidth) {
                        helper.callWithActiveBreakpoint(scope.viewBreakpoints, {
                            width: attachTo.width()
                        }, function (breakpoint) {
                            _.each(newGroups, function (group) {
                                group.breakpoint = breakpoint.name;
                                _.each(group.sections, function (section, i) {
                                    section.config.breakpoints[breakpoint.name] = morningstar.asterix.extend(true, {}, section.config.breakpoints[breakpoint.name], group.defaultSection, group.sectionDefinitions[i]);

                                    var expression = group.sectionDefinitions[i].show;

                                    if (group.defaultSection.show || morningstar.asterix.util.isBoolean(group.defaultSection.show)) {
                                        expression = group.defaultSection.show;
                                    }
                                    if (section.config.show || morningstar.asterix.util.isBoolean(section.config.show)) {
                                        expression = section.config.show;
                                    }
                                    helper.evaluateShowExpression(configEvaluator, expression, mstarComponent, function (flag) {
                                        section.updateShow(flag);
                                    });
                                });
                            });
                        });
                    }

                    return newGroups;
                }

                function handleDimensions(dimensions, force) {
                    if (dimensions.width <= 0) {
                        return;
                    }
                    prevWidth = dimensions.width;

                    setScopeBreakpoint(dimensions);
                    if (prevBreakpoint === scope.breakpoint && !force) {
                        helper.triggerWidthListeners(scope, dimensions);
                        return;
                    }

                    prevBreakpoint = scope.breakpoint;

                    if (!scope.breakpointSettings) {
                        scope.breakpointSettings = getSettingCopyOrDefault(scope.settings.get('breakpoints'));
                    }

                    var breakpointConfig = scope.breakpointSettings[scope.breakpoint];
                    if (breakpointConfig.collapserPosition === 'none') {
                        morningstar.asterix.util.each(scope.sections, function (section) {
                            section.collapsible = false;
                            section.isExpanded = true;
                        });
                    }

                    var groupDefinitions = breakpointConfig.groups;

                    morningstar.asterix.util.each(scope.groups, function (group) {
                        group.destroy();
                    });

                    var newGroups = [];
                    if (groupDefinitions && Object.keys(groupDefinitions).length > 0) {
                        newGroups = createGroups(groupDefinitions);
                    } else if (scope.groups && scope.groups.length) {
                        morningstar.asterix.util.each(scope.sections, function (section) {
                            // reset section settings to non-group values
                            section.config.breakpoints[scope.breakpoint] = morningstar.asterix.extend(true, {}, section.originalConfig.breakpoints[scope.breakpoint]);
                            attachTo.append(section.element);
                        });

                        scope.groupsRow.remove();
                        scope.groupsRow = null;
                    } else {
                        // reset section settings to non-group values
                        morningstar.asterix.util.each(scope.sections, function (section) {
                            section.isInCollapsibleGroup = false;
                            section.config.breakpoints[scope.breakpoint] = morningstar.asterix.extend(true, {}, section.originalConfig.breakpoints[scope.breakpoint]);
                        });
                    }

                    scope.groups = newGroups;

                    if (scope.groups.length) {
                        _.each(scope.groups, function (group) {
                            processSections(group.sections, group.breakpoint, breakpointConfig);
                        });
                    } else {
                        processSections(scope.sections, scope.breakpoint, breakpointConfig);
                    }

                    helper.triggerWidthListeners(scope, dimensions);
                    helper.triggerBreakpointListeners(scope);
                }

                function handleWidthChange(cols, parentWidth) {
                    if (parentWidth <= 0) {
                        return;
                    }

                    container.preProcessSettings();
                    var selfWidth = helper.calculateSelfWidth(cols, parentWidth);

                    setScopeBreakpoint(selfWidth);
                    if (prevBreakpoint === scope.breakpoint && !scope.hasUnprocessedSections) {
                        return;
                    }

                    prevBreakpoint = scope.breakpoint;

                    if (!scope.breakpointSettings) {
                        scope.breakpointSettings = getSettingCopyOrDefault(scope.settings.get('breakpoints'));
                    }

                    var breakpointConfig = scope.breakpointSettings[scope.breakpoint];
                    if (breakpointConfig.collapserPosition === 'none') {
                        morningstar.asterix.util.each(scope.sections, function (section) {
                            section.collapsible = false;
                            section.isExpanded = true;
                        });
                    }

                    var groupDefinitions = breakpointConfig.groups;

                    if (scope.groups) {
                        _.each(scope.groups, function (group) {
                            _.each(group.sections, function (section) {
                                section.element.detach();
                            });
                            group.scope.$destroy();
                        });
                    }

                    var newGroups = [];
                    if (groupDefinitions && Object.keys(groupDefinitions).length > 0) {
                        newGroups = createGroups(groupDefinitions, selfWidth);
                    } else if (scope.groups && scope.groups.length) {
                        morningstar.asterix.util.each(scope.sections, function (section) {
                            // reset section settings to non-group values
                            section.config.breakpoints[scope.breakpoint] = getSettingCopyOrDefault(section.originalConfig.breakpoints[scope.breakpoint]);
                            attachTo.append(section.element);
                        });

                        scope.groupsRow.remove();
                        scope.groupsRow = null;
                    } else {
                        // reset section settings to non-group values
                        morningstar.asterix.util.each(scope.sections, function (section) {
                            section.isInCollapsibleGroup = false;
                            section.config.breakpoints[scope.breakpoint] = getSettingCopyOrDefault(section.originalConfig.breakpoints[scope.breakpoint]);
                        });
                    }

                    scope.groups = newGroups;

                    if (!scope.groups.length) {
                        processSections(scope.sections, scope.breakpoint, breakpointConfig, selfWidth);
                    }

                    scope.hasUnprocessedSections = false;
                }

                function processSections(sections, breakpoint, breakpointConfig, parentWidth) {
                    var triggerSection = null,
                        prevTriggerSection = null,
                        colSum = 0,
                        triggerSections = [],
                        rowSections = [];

                    for (var index = 0; index < sections.length; index++) {
                        var section = sections[index],
                            isLast = index + 1 === sections.length,
                            sectionCols = section.config.breakpoints[breakpoint].cols;

                        triggerSections.push(section);
                        rowSections.push(section);
                        colSum += sectionCols;

                        if (!isLast) {
                            if (colSum + sections[index + 1].config.breakpoints[breakpoint].cols > helper.MAX_COLS) {
                                isLast = true;
                            }
                        }

                        section.setBreakpointClass(breakpoint, sectionCols);

                        if (isTriggerSection(breakpointConfig.collapserPosition, colSum, sectionCols, isLast)) {
                            triggerSection = section;

                            if (!prevTriggerSection) {
                                prevTriggerSection = triggerSection;
                            }

                            if (triggerSection !== prevTriggerSection) {
                                prevTriggerSection = triggerSection;
                                triggerSections.splice(triggerSections.indexOf(section), 1); //todo: check if this can be deleted
                                triggerSections = [section];
                            }

                            triggerSection.config.triggerSections = triggerSections;
                            var collapsible = triggerSection.config.breakpoints[breakpoint].collapsible;
                            triggerSection.collapsible = _.isUndefined(collapsible) ? true : collapsible;
                        } else if (colSum > helper.MAX_COLS) {
                            throw new Error('Invalid column sum');
                        } else {
                            section.collapsible = false;
                        }

                        if (!section.title && !section.isInCollapsibleGroup) {
                            section.isExpanded = true;
                        }

                        //todo: check if this is needed as it's done on line 765 too
                        if (triggerSection) {
                            triggerSection.config.triggerSections = triggerSections;
                        }

                        if (colSum === helper.MAX_COLS || isLast) {
                            if (!section.isInCollapsibleGroup) {
                                if (breakpointConfig.autoCollapseMode === 'collapse') {
                                    if (morningstar.asterix.util.any(triggerSections, function (c) {
                                        return c.config.breakpoints[breakpoint].autoCollapseMode === 'expand' || !c.title;
                                    })) {
                                        morningstar.asterix.util.each(triggerSections, function (c) {
                                            c.isExpanded = true;
                                        });
                                    } else {
                                        morningstar.asterix.util.each(triggerSections, function (c) {
                                            c.isExpanded = false;
                                        });
                                    }
                                } else if (morningstar.asterix.util.any(triggerSections, function (c) {
                                    return c.isExpanded === true;
                                }) || breakpointConfig.autoCollapseMode === 'expand') {
                                    if (morningstar.asterix.util.any(triggerSections, function (c) {
                                        return c.config.breakpoints[breakpoint].autoCollapseMode === 'collapse';
                                    })) {
                                        morningstar.asterix.util.each(triggerSections, function (c) {
                                            c.isExpanded = false;
                                        });
                                    } else {
                                        morningstar.asterix.util.each(triggerSections, function (c) {
                                            c.isExpanded = true;
                                        });
                                    }
                                }
                            }

                            morningstar.asterix.util.each(triggerSections, function (c) {
                                c.canBeCollapsed = breakpointConfig.collapserPosition != null && breakpointConfig.collapserPosition !== 'none' && !c.isInCollapsibleGroup;
                                c.config.triggerSections = triggerSections;
                            });

                            colSum = 0;
                            triggerSection = null;
                            prevTriggerSection = null;
                            var elems = angular.element(_.map(rowSections, function (c) {
                                return c.element[0];
                            }));
                            elems.filter('.ms-neat-row > *').unwrap();
                            elems.wrapAll('<div class=\'ms-neat-row\'/>');
                            triggerSections = [];
                            rowSections = [];
                        }

                        if (scope.useCalculatedWidth) {
                            section.handleWidthChange(section.config.breakpoints[breakpoint].cols, parentWidth);
                        }
                    }

                    attachTo.find('.ms-neat-row').filter(function () {
                        return !this.childNodes.length;
                    }).remove();

                    function isTriggerSection(collapserPosition, colSum, cols, isLast) {
                        return collapserPosition === 'individual' || collapserPosition === 'firstPerRow' && colSum - cols === 0 || collapserPosition === 'lastPerRow' && (colSum === helper.MAX_COLS || isLast);
                    }
                }

                /**
                 * This checks for sections created using ngRepeat and watches for changes in the data
                 * so that if there is a change the sections can be processed and set up again
                 */
                function setupNgRepeatWatch() {
                    var ngRepeatMatch = attachTo.html().match(/<!-- ngRepeat: (.*?) -->/);
                    if (ngRepeatMatch && ngRepeatMatch.length === 2) {
                        var match = ngRepeatMatch[1].match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
                        if (match.length >= 3) {
                            scope.$parent.$watchCollection(match[2], function () {
                                scope.hasUnprocessedSections = true;
                                scope.scheduleSetup();
                            });
                        }
                    }
                }
            }

            function getSettingCopyOrDefault(obj) {
                if (obj) {
                    return morningstar.asterix.util.cloneObject(obj);
                }
                return {};
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
        'use strict';

        section.$inject = ["$compile", "mstarDimensions", "$timeout"];
        var _eventTopicExpanded = 'ecContainerExpanded',
            _eventTopicCollapsed = 'ecContainerCollapsed';

        angular.module('ecContainer').directive('ecSection', section);

        function section($compile, mstarDimensions, $timeout) {
            // standalone sections claim their full available width
            controllerFn.$inject = ["$scope", "$element"];
            var sectionDefaults = {
                breakpoints: {
                    small: {
                        cols: helper.MAX_COLS
                    },
                    medium: {
                        cols: helper.MAX_COLS
                    },
                    large: {
                        cols: helper.MAX_COLS
                    },
                    xlarge: {
                        cols: helper.MAX_COLS
                    }
                }
            };

            return {
                restrict: 'E',
                require: ['^?ecContainer', '^?mstarComponentId'],
                scope: {
                    title: '@',
                    subTitle: '@',
                    sectionId: '@',
                    titleTooltipLabelId: '@'
                },
                transclude: true,
                template: function template(elem, attrs) {
                    if (!attrs.templateType || attrs.templateType === 'default') {
                        return __webpack_require__(13);
                    }

                    switch (attrs.templateType) {
                        case 'light':
                            return __webpack_require__(10);
                        default:
                            morningstar.asterix.instrumentation.logger.fatal(new Error('(ec-section) could not find template type: ' + attrs.templateType));
                    }
                },
                controller: controllerFn,
                link: linkFn
            };

            function controllerFn($scope, $element) {
                var parentContainer = $element.parent().controller('ecContainer'),
                    parentSection = $element.parent().controller('ecSection'),
                    parent = getParent();

                $scope.widthListeners = [];
                $scope.breakpointListeners = [];
                $scope.parent = parent;
                $scope.parentType = !parent ? null : parent === parentSection ? 'section' : 'container';

                /* jshint validthis: true */
                this.getLevel = function getLevel() {
                    return parent && parent.getLevel ? parent.getLevel() + 1 : 0;
                };

                $scope.level = this.getLevel();

                this.getWidth = function getWidth() {
                    return $scope.width;
                };

                this.addWidthListener = function addWidthListener(callback) {
                    $scope.widthListeners.push(callback);

                    return function unregister() {
                        $scope.widthListeners.splice($scope.widthListeners.indexOf(callback), 1);
                    };
                };

                this.addBreakpointListener = function addBreakpointListener(callback) {
                    $scope.breakpointListeners.push(callback);

                    return function unregister() {
                        $scope.breakpointListeners.splice($scope.breakpointListeners.indexOf(callback), 1);
                    };
                };

                function getParent() {
                    var parentObj;

                    if (parentContainer && parentSection) {
                        if (parentContainer.getLevel() > parentSection.getLevel()) {
                            parentObj = parentContainer;
                        } else {
                            parentObj = parentSection;
                        }
                    } else if (parentContainer) {
                        parentObj = parentContainer;
                    } else {
                        parentObj = parentSection;
                    }

                    return parentObj;
                }
            }

            function linkFn(scope, elem, attr, controllers) {
                var container = controllers[0],
                    mstarComponent = controllers[1],
                    breakpointClasses = {};

                elem.addClass('ec-section');
                scope.element = elem;

                if (mstarComponent) {
                    mstarComponent.bindConfig(scope);
                    scope.viewBreakpoints = scope.settings.get('viewBreakpoints');
                    scope.useCalculatedWidth = scope.settings.get('useCalculatedWidth') || false;
                } else {
                    scope.viewBreakpoints = morningstar.asterix.config.getBaseSettings().viewBreakpoints;
                    scope.useCalculatedWidth = morningstar.asterix.config.getBaseSettings().useCalculatedWidth || false;
                }

                scope.templates = _.assign({
                    containerSectionTitle: __webpack_require__(12),
                    containerSectionSubtitle: __webpack_require__(11)
                }, scope.templates);

                // by default section should be visible
                scope.show = true;
                //because cols is used in section.html it must be initialized,
                scope.cols = helper.MAX_COLS;

                if (!attr.sectionId) {
                    if (mstarComponent && mstarComponent.getComponentType() !== 'ecContainer') {
                        scope.sectionId = mstarComponent.getOwnComponentId();
                    }
                }

                if (scope.sectionId) {
                    scope.classSuffix = morningstar.asterix.util.string.dashCase(scope.sectionId);
                    elem.addClass('ec-section--' + scope.classSuffix);
                }

                scope.classWithModifier = function classWithModifier(baseClass) {
                    return !scope.classSuffix ? baseClass : baseClass + ' ' + baseClass + '--' + scope.classSuffix;
                };

                scope.toggle = function toggleSection() {
                    if (!scope.standalone) {
                        container.toggle(scope);
                    } else {
                        scope.isExpanded = !scope.isExpanded;
                    }
                    if (container) {
                        container.trigger(scope.isExpanded ? _eventTopicExpanded : _eventTopicCollapsed, ['section', scope.sectionId]);
                    }
                };

                scope.open = function open() {
                    scope.isExpanded = true;
                };

                scope.close = function close() {
                    scope.isExpanded = false;
                };
                scope.updateShow = function updateShow(newValue) {
                    scope.show = newValue;
                };
                scope.setBreakpointClass = function setBreakpointClass(breakpointName, cols) {
                    elem.removeClass(breakpointClasses[breakpointName]);
                    breakpointClasses[breakpointName] = 'ms-neat-' + breakpointName + '-' + cols;
                    elem.addClass(breakpointClasses[breakpointName]);
                };

                scope.config = morningstar.asterix.extend(true, {}, sectionDefaults);

                var prevWidth,
                    prevBreakpoint = null,
                    prevFooterTemplate = null;

                if (scope.parent == null) {
                    scope.standalone = true;
                    scope.isExpanded = true;
                    elem.addClass('ec-section--standalone');

                    if (scope.useCalculatedWidth) {
                        mstarDimensions(scope, elem).addListener(function (dimensions) {
                            var width = Math.min(dimensions.width, helper.MAX_WIDTH);
                            if (width === prevWidth) {
                                return;
                            }

                            prevWidth = width;

                            scope.$applyAsync(function () {
                                scope.width = width;
                                handleWidthChange(helper.MAX_COLS, scope.width);
                            });
                        });

                        scope.width = Math.min(elem.width(), helper.MAX_WIDTH);
                        handleWidthChange(helper.MAX_COLS, scope.width);
                    } else {
                        mstarDimensions(scope, elem).addListener(function (dimensions) {
                            scope.$evalAsync(function () {
                                handleDimensions(dimensions);
                            });
                        });
                    }

                    scope.headerId = getSectionHeaderId();
                    scope.panelId = getSectionPanelId();

                    init();
                } else {
                    if (!scope.useCalculatedWidth) {
                        mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function (dimensions) {
                            handleDimensions({
                                width: elem.width()
                            }, dimensions);
                        }));
                    }

                    if (scope.parentType === 'section') {
                        scope.isExpanded = true;
                        elem.addClass('ec-section--nested');

                        scope.headerId = getSectionHeaderId();
                        scope.panelId = getSectionPanelId();

                        init();

                        if (scope.useCalculatedWidth) {
                            mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function (parentWidth) {
                                handleWidthChange(helper.MAX_COLS, parentWidth);
                            }));

                            handleWidthChange(helper.MAX_COLS, scope.parent.getWidth());
                        }
                    } else if (scope.parentType === 'container') {
                        elem.addClass('ec-columns');
                        scope.$applyAsync(function () {
                            scope.$on('$destroy', function destroySection() {
                                container.unregisterSection(scope);
                            });

                            container.registerSection(scope, function showFlagSetter(showFlag) {
                                if (showFlag) {
                                    scope.cols = scope.previousCols || helper.MAX_COLS;
                                } else {
                                    scope.previousCols = scope.cols;
                                    scope.cols = 0;
                                }
                                scope.updateShow(showFlag);
                            });

                            init();
                        });
                    }
                }

                function getSectionHeaderId() {
                    return 'section-header-' + scope.$id;
                }

                function getSectionPanelId() {
                    return 'section-panel-' + scope.$id;
                }

                function handleDimensions(elemDimensions, parentDimensions) {
                    updateActiveSelfBreakpoint(elemDimensions);
                    updateScopeProperties(parentDimensions || elemDimensions);
                    helper.triggerWidthListeners(scope, elemDimensions);
                }

                function updateScopeProperties(dimensions) {
                    // will be based on parent dimensions, if a parent exists
                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, dimensions, function (breakpoint) {
                        scope.cols = scope.config.breakpoints[breakpoint.name].cols;
                        scope.footerTemplate = !scope.config.breakpoints[breakpoint.name].footerTemplate ? null : '<div>' + scope.config.breakpoints[breakpoint.name].footerTemplate + '</div>';
                        if (scope.footerTemplate !== prevFooterTemplate) {
                            prevFooterTemplate = scope.footerTemplate;
                            if (scope.footerTemplate && !scope.footerElement) {
                                // compile the footerTemplate using the transcluded scope
                                scope.footerElement = $compile(scope.footerTemplate)(scope.$parent);
                                //elem.find('.ec-section__footer').empty();
                                $timeout(function () {
                                    elem.find('.ec-section__footer').append(scope.footerElement);
                                }, 1000);
                            } else {
                                scope.footerElement = null;
                                $timeout(function () {
                                    elem.find('.ec-section__footer').empty();
                                }, 1000);
                            }
                        }
                    });
                }

                function handleWidthChange(cols, parentWidth) {
                    var selfWidth = scope.width = helper.calculateSelfWidth(cols, parentWidth);

                    scope.cols = cols;

                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, selfWidth, function (breakpoint) {
                        updateSelfBreakpoint(breakpoint.name);
                    });

                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, parentWidth, function (breakpoint) {
                        refreshFooter(breakpoint.name);
                    });

                    helper.triggerWidthListeners(scope, selfWidth);
                }

                scope.handleWidthChange = handleWidthChange;

                function refreshFooter(parentBreakpointName) {
                    scope.footerTemplate = !scope.config.breakpoints[parentBreakpointName].footerTemplate ? null : '<div>' + scope.config.breakpoints[parentBreakpointName].footerTemplate + '</div>';
                    if (scope.footerTemplate !== prevFooterTemplate) {
                        prevFooterTemplate = scope.footerTemplate;
                        if (scope.footerTemplate && !scope.footerElement) {
                            // compile the footerTemplate using the transcluded scope
                            scope.footerElement = $compile(scope.footerTemplate)(scope.$parent);
                            $timeout(function () {
                                elem.find('.ec-section__footer').append(scope.footerElement);
                            }, 1000);
                        } else {
                            scope.footerElement = null;
                            $timeout(function () {
                                elem.find('.ec-section__footer').empty();
                            }, 1000);
                        }
                    }
                }

                function updateActiveSelfBreakpoint(dimensions) {
                    if (prevWidth === dimensions.width || !dimensions.width) {
                        return;
                    }

                    prevWidth = dimensions.width;

                    elem.removeClass(_.map(scope.viewBreakpoints, function (bp, key) {
                        return 'ec-section--' + key;
                    }).join(' '));

                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, dimensions, function (breakpoint) {
                        scope.breakpoint = breakpoint.name;
                        elem.addClass('ec-section--' + breakpoint.name);
                    });

                    if (prevBreakpoint !== scope.breakpoint) {
                        helper.triggerBreakpointListeners(scope);
                        prevBreakpoint = scope.breakpoint;
                    }
                }

                function updateSelfBreakpoint(breakpointName) {
                    if (scope.breakpoint === breakpointName) {
                        return;
                    }

                    scope.breakpoint = breakpointName;

                    elem.removeClass(_.map(scope.viewBreakpoints, function (bp, key) {
                        return 'ec-section--' + key;
                    }).join(' '));

                    elem.addClass('ec-section--' + breakpointName);

                    helper.triggerBreakpointListeners(scope);
                }

                function init() {
                    if (!scope.useCalculatedWidth) {
                        morningstar.asterix.util.fastdom.measure(function () {
                            scope.$evalAsync(function () {
                                handleDimensions({
                                    width: elem.width()
                                });
                            });
                        });
                    }

                    morningstar.asterix.util.fastdom.mutate(function () {
                        morningstar.asterix.util.each(scope.viewBreakpoints, function (breakpoint, key) {
                            addBreakpointClasses(key, scope.config.breakpoints[key]);
                        });

                        if (!scope.title) {
                            elem.addClass('ec-section--no-title');
                        }
                    });
                }

                function addBreakpointClasses(breakpointName, breakpoint) {
                    scope.setBreakpointClass(breakpointName, breakpoint.cols);
                }
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 6 */
/***/function (module, exports) {

    module.exports = {
        "ecContainer": {
            "labels": {
                "close": {
                    "da-DK": "Luk",
                    "en": "Close",
                    "en-GB": null,
                    "fr": "Fermer",
                    "it": "Chiudi",
                    "ja": "閉じる",
                    "sv": "Stäng",
                    "sv-SE": null,
                    "zh-CN": "关闭",
                    "zh-HK": "關閉"
                },
                "open": {
                    "da-DK": "Åbn",
                    "en": "Open",
                    "en-GB": null,
                    "fr": "Ouvrir",
                    "it": "Aperto",
                    "ja": "開く",
                    "sv": "Öppna",
                    "sv-SE": null,
                    "zh-CN": "打开",
                    "zh-HK": "打開"
                }
            },
            "settings": {
                "_templates": {
                    "containerSectionSubtitle": "<h2 class=\"{{ :: classWithModifier('ec-section__subtitle') }}\" data-ng-if=\"subTitle\">{{ subTitle }}</h2>\r\n",
                    "containerSectionTitle": "<h1 id=\"{{ :: headerId }}\" class=\"{{ :: classWithModifier('ec-section__title') }}\">\r\n    <span mstar-tooltip-content=\"{{ :: titleTooltipLabelId && labels.contains(titleTooltipLabelId) ? labels.get(titleTooltipLabelId) : '' }}\" mstar-tooltip data-ng-bind-html=\"title\"></span>\r\n</h1>\r\n"
                },
                "breakpoints": {
                    "defaults": {
                        "autoCollapseMode": "expand",
                        "collapserPosition": "none"
                    },
                    "large": {},
                    "medium": {},
                    "small": {},
                    "xlarge": {}
                },
                "debugMode": false,
                "defaultSection": {
                    "breakpoints": {
                        "defaults": {
                            "cols": null
                        },
                        "large": {
                            "autoCollapseMode": "none",
                            "cols": 12
                        },
                        "medium": {
                            "autoCollapseMode": "none",
                            "cols": 12
                        },
                        "small": {
                            "autoCollapseMode": "none",
                            "cols": 12
                        },
                        "xlarge": {
                            "autoCollapseMode": "none",
                            "cols": 12
                        }
                    },
                    "show": null
                },
                "enableToggleForExpand": false,
                "sections": null,
                "show": null
            },
            "type": "ecContainer"
        }
    };

    /***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecContainer', __webpack_require__(6).ecContainer);
        morningstar.asterix.meta.register('ecContainer', 'skipInFullIdentifier', true);
        morningstar.asterix.meta.register('ecContainer', 'allowedEvents', ['ecContainerExpanded', 'ecContainerCollapsed']);

        __webpack_require__(4);
        __webpack_require__(5);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 8 */
/***/function (module, exports) {

    module.exports = "<div data-ng-if=\"settings.get('debugMode') == true\">\r\n    <section>\r\n        <header>\r\n            <h1>Debug info</h1>\r\n        </header>\r\n        <div>\r\n            <h2>Sections</h2>\r\n            <ul>\r\n                <li data-ng-repeat=\"section in sections\">\r\n                    {{ section.sectionId }}\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </section>\r\n</div>\r\n<div data-ng-show=\"show\" data-ng-transclude>\r\n</div>\r\n";

    /***/
},
/* 9 */
/***/function (module, exports) {

    module.exports = "<div data-ng-show=\"show\" class=\"{{ :: classWithModifier('ec-section') }} ec-columns {{ ::classWithModifier('ec-section__group') }} {{ 'ms-neat-' + breakpoint + '-' + cols }} {{ !title ? 'ec-section--no-title' : '' }}\">\r\n    <section class=\"{{ :: classWithModifier('ec-section__section') }}\">\r\n        <header data-ng-if=\"title || collapsible\" class=\"{{ :: classWithModifier('ec-section__header') }} {{ :: collapsible ? 'ec-section__header--collapsible' : '' }}\"\r\n            data-ng-click=\"collapsible && toggle()\"\r\n            aria-controls=\"{{ :: groupSectionPanelId }}\"\r\n            data-ng-attr-aria-expanded=\"{{ collapsible ? isExpanded : undefined }}\"\r\n            tabindex=\"{{ collapsible ? 0 : -1 }}\">\r\n            <button type=\"button\" data-ng-if=\"collapsible\" class=\"{{ :: classWithModifier('ec-section__toggle') }} {{ isExpanded ? 'ec-section__toggle--expanded' : '' }}\" tabindex=\"-1\">\r\n                <span class=\"{{ :: classWithModifier('ec-section__toggle-caption') }}\">{{isExpanded ? labels.get('close') : labels.get('open')}}</span>\r\n            </button>\r\n            <h1 class=\"{{ :: classWithModifier('ec-section__title') }}\">\r\n                <span mstar-tooltip-content=\"{{ :: titleTooltipLabelId && labels.contains(titleTooltipLabelId) ? labels.get(titleTooltipLabelId) : '' }}\" mstar-tooltip data-ng-bind-html=\"title\"></span>\r\n            </h1>\r\n        </header>\r\n        <div id=\"{{ :: groupSectionPanelId }}\" class=\"ec-section__content {{ :: classWithModifier('ec-section__content') }} {{ isExpanded ? 'ec-section__content--expanded' : '' }}\" data-ng-show=\"!collapsible || isExpanded\">\r\n        </div>\r\n    </section>\r\n</div>\r\n";

    /***/
},
/* 10 */
/***/function (module, exports) {

    module.exports = "<div class=\"{{ :: classWithModifier('ec-section__section') }} {{ :: classWithModifier('ec-section__content') }} ec-section--no-header\" data-ng-if=\"cols > 0 && show\" data-ng-transclude>\r\n</div>\r\n";

    /***/
},
/* 11 */
/***/function (module, exports) {

    module.exports = "<h2 class=\"{{ :: classWithModifier('ec-section__subtitle') }}\" data-ng-if=\"subTitle\">{{ subTitle }}</h2>\r\n";

    /***/
},
/* 12 */
/***/function (module, exports) {

    module.exports = "<h1 id=\"{{ :: headerId }}\" class=\"{{ :: classWithModifier('ec-section__title') }}\">\r\n    <span mstar-tooltip-content=\"{{ :: titleTooltipLabelId && labels.contains(titleTooltipLabelId) ? labels.get(titleTooltipLabelId) : '' }}\" mstar-tooltip data-ng-bind-html=\"title\"></span>\r\n</h1>\r\n";

    /***/
},
/* 13 */
/***/function (module, exports) {

    module.exports = "<section class=\"{{ :: classWithModifier('ec-section__section') }} {{ !title ? 'ec-section--no-header' : '' }}\" data-ng-if=\"cols > 0 && show\">\r\n    <header data-ng-if=\"title\" class=\"{{ :: classWithModifier('ec-section__header') }} {{ canBeCollapsed ? 'ec-section__header--collapsible' : '' }}\"\r\n        data-ng-click=\"canBeCollapsed && toggle()\"\r\n        aria-controls=\"{{ :: panelId }}\"\r\n        data-ng-attr-aria-expanded=\"{{ canBeCollapsed ? isExpanded : undefined }}\"\r\n        tabindex=\"{{ canBeCollapsed ? 0 : -1 }}\"\r\n        role=\"{{ canBeCollapsed ? 'button' : 'heading' }}\"\r\n        aria-labelledby=\"{{ :: headerId }}\">\r\n        <button type=\"button\" data-ng-if=\"collapsible\" class=\"{{ :: classWithModifier('ec-section__toggle') }} {{ isExpanded ? 'ec-section__toggle--expanded' : '' }}\" tabindex=\"-1\" aria-hidden=\"true\">\r\n            <span class=\"{{ :: classWithModifier('ec-section__toggle-caption') }}\">{{isExpanded ? labels.get('close') : labels.get('open')}}</span>\r\n        </button>\r\n        <div mstar-include=\"templates.containerSectionTitle\"></div>\r\n        <div mstar-include=\"templates.containerSectionSubtitle\"></div>\r\n    </header>\r\n    <div id=\"{{ :: panelId }}\" class=\"{{ :: classWithModifier('ec-section__content') }} {{ isExpanded ? 'ec-section__content--expanded' : '' }}\">\r\n        <div data-ng-if=\"isExpanded\">\r\n            <div data-ng-transclude></div>\r\n        </div>\r\n    </div>\r\n    <footer class=\"{{ :: classWithModifier('ec-section__footer') }}\" data-ng-show=\"isExpanded && footerElement\">\r\n    </footer>\r\n</section>\r\n";

    /***/
}]
/******/);
//# sourceMappingURL=ec-container.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};
	/******/
	/******/ // The require function
	/******/function __webpack_require__(moduleId) {
		/******/
		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId]) {
			/******/return installedModules[moduleId].exports;
			/******/
		}
		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/i: moduleId,
			/******/l: false,
			/******/exports: {}
			/******/ };
		/******/
		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ // Flag the module as loaded
		/******/module.l = true;
		/******/
		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}
	/******/
	/******/
	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;
	/******/
	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;
	/******/
	/******/ // identity function for calling harmony imports with the correct context
	/******/__webpack_require__.i = function (value) {
		return value;
	};
	/******/
	/******/ // define getter function for harmony exports
	/******/__webpack_require__.d = function (exports, name, getter) {
		/******/if (!__webpack_require__.o(exports, name)) {
			/******/Object.defineProperty(exports, name, {
				/******/configurable: false,
				/******/enumerable: true,
				/******/get: getter
				/******/ });
			/******/
		}
		/******/
	};
	/******/
	/******/ // getDefaultExport function for compatibility with non-harmony modules
	/******/__webpack_require__.n = function (module) {
		/******/var getter = module && module.__esModule ?
		/******/function getDefault() {
			return module['default'];
		} :
		/******/function getModuleExports() {
			return module;
		};
		/******/__webpack_require__.d(getter, 'a', getter);
		/******/return getter;
		/******/
	};
	/******/
	/******/ // Object.prototype.hasOwnProperty.call
	/******/__webpack_require__.o = function (object, property) {
		return Object.prototype.hasOwnProperty.call(object, property);
	};
	/******/
	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "build/";
	/******/
	/******/ // Load entry module and return exports
	/******/return __webpack_require__(__webpack_require__.s = 4);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

	module.exports = morningstar;

	/***/
},
/* 1 */
/***/function (module, exports) {

	module.exports = _;

	/***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(0), __webpack_require__(1), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
		'use strict';

		hypotheticalGrowth.$inject = ["mstarDebounce"];
		angular.module('ecHypotheticalGrowth', ['mstarCore', 'ecButton', 'ecContainer', 'ecInput', 'ecPerformanceGraph', 'ecPortfolioData', 'ecReportBuilder']).directive('ecHypotheticalGrowth', hypotheticalGrowth);

		function hypotheticalGrowth(mstarDebounce) {
			return {
				restrict: 'E',
				require: 'mstarComponentId',
				scope: {},
				template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
				link: linkFn
			};

			function linkFn(scope, elem, attr, mstarComponent) {
				// binds settings, labels, formatter and templates to scope properties
				mstarComponent.bindConfig(scope);

				// compiles the main template
				mstarComponent.compileTemplate(scope, '_templates.main');

				// binds parameters (two-way between the asterix instance's parameters and scope.parameters)
				mstarComponent.bindParameters(scope);

				// initiates our scope.model according to settings and two-way binds it to the asterix instance's model
				mstarComponent.bindModelData(scope, { editable: true });
				// ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

				var currentActiveView,
				    hypoTabsInstance = scope.instance.findRelative('performanceGraph.tabFrequency'),
				    hypoApplyButtonInstance = scope.instance.findRelative('hypoApplyButton'),
				    hypoDateInputInstance = scope.instance.findRelative('hypoDateInput'),
				    hypoFeesApplyChosenInstance = scope.instance.findRelative('hypoFeesApplyChosen'),
				    hypoReinvestChosenInstance = scope.instance.findRelative('hypoReinvestChosen'),
				    hypoSettingsButtonInstance = scope.instance.findRelative('hypoSettingsButton'),
				    hypoTimePeriodTrailingReturnChosenInstance = scope.instance.findRelative('hypoTimePeriodTrailingReturnChosen'),
				    portfolioDataInstance = scope.instance.findRelative('portfolioData');

				scope.isLoading = portfolioDataInstance.getModelProperty('securities')._$isLoading;

				initializeHypotheticalDataSettingsModel();

				scope.hypotheticalSettingsRenderStatus = false;

				scope.timePeriodRadioChange = function () {
					var illustrationTrailingTimePeriod = helper.getHypotheticalDataModelProperty(scope, 'timePeriod', 'illustrationTrailingTimePeriod');
					updateTimePeriodInstanceStatus(illustrationTrailingTimePeriod);
				};

				scope.selectHypoViewSection = function (activeView) {
					var newChosen = !helper.getHypotheticalDataModelProperty(scope, activeView, 'chosen'),
					    selectHypoViewSectionData = helper.generateSelectHypoViewSectionData(scope, activeView, newChosen);

					toggleCurrentActiveView(activeView, selectHypoViewSectionData.data, newChosen);
					setHypotheticalDataSettingsModelProperty(selectHypoViewSectionData, false);
				};

				scope.toggleActiveHypoViewSection = function (activeView) {
					var newToggle = !helper.getHypotheticalDataModelProperty(scope, activeView, 'toggle'),
					    toggleActiveHypoViewSectionData = helper.generateToggleActiveHypoViewSectionData(scope, activeView, newToggle);

					toggleCurrentActiveView(activeView, toggleActiveHypoViewSectionData.data, newToggle);
					setHypotheticalDataSettingsModelProperty(toggleActiveHypoViewSectionData, false);
				};

				mstarComponent.addUnregisterCallback(hypoTabsInstance.on('parameterChanged:selectedTabIndex', function (selectedTabIndex) {
					if (selectedTabIndex >= 0) {
						if (scope.model.sections.showHypotheticalSettings) {
							updateHypotheticalSettingsButton();
						}
						var timePeriodType = getTimePeriodType(selectedTabIndex);
						var hypotheticalDataSettings = {
							data: {
								all: {
									chosen: true
								},
								timePeriod: {
									toggle: true,
									chosen: true,
									illustrationTrailingTimePeriod: timePeriodType,
									trailingReturn: getTrailingReturnValue(selectedTabIndex, timePeriodType),
									startDate: null,
									endDate: null
								}
							},
							settings: {
								illustrationTrailingTimePeriod: timePeriodType
							}
						};
						if (currentActiveView && currentActiveView !== 'timePeriod') {
							hypotheticalDataSettings.data[currentActiveView] = {
								toggle: false
							};
						}
						currentActiveView = 'timePeriod';
						setHypotheticalDataSettingsModelProperty(hypotheticalDataSettings, false);
						updateTimePeriodInstanceStatus(timePeriodType);
						updateHypoSettingsToReportBuilderPortfolioData(helper.generateHypotheticalSettings(scope));
					}
				}));

				mstarComponent.addUnregisterCallback(portfolioDataInstance.on('modelPropertyChanged:securities', function (securities) {
					if (securities) {
						scope.isLoading = securities._$isLoading;
					}
				}));

				mstarComponent.addUnregisterCallback(hypoSettingsButtonInstance.on('click', function () {
					if (!scope.hypotheticalSettingsRenderStatus) {
						scope.hypotheticalSettingsRenderStatus = true;
					}
					updateHypotheticalSettingsButton();
				}));

				mstarComponent.addUnregisterCallback(hypoApplyButtonInstance.on('click', function () {
					updateHypotheticalSettingsButton();
					var hypotheticalSettings = helper.generateHypotheticalSettings(scope);
					updateHypoSettingsToReportBuilderPortfolioData(hypotheticalSettings);
					setActiveTabIndex(hypotheticalSettings.illustrationTrailingTimePeriod);
				}));

				mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoNumberInput').on('ecInputChanged', mstarDebounce(function (value) {
					var isInvalidValue = !_.isNumber(value) && _.isEmpty(value);
					hypoApplyButtonInstance.setParameter('disabled', isInvalidValue);
					if (!isInvalidValue) {
						var numperInputData = helper.validateNumperInputData(scope, scope.instance.getModelProperty('hypotheticalDataSettings.settings'));
						setHypotheticalDataSettingsModelProperty(numperInputData, false);
					}
				}, 1000)));

				mstarComponent.addUnregisterCallback(hypoDateInputInstance.on('ecInputChanged', mstarDebounce(function (date) {
					updateTimePeriodCustomDateStatus();
				}, 300)));

				mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoFilingStatusChosen').on('ecChosenItemSelected', function (filingStatus) {
					if (filingStatus) {
						var defaultTaxRateData = helper.generateDefaultTaxRateData(scope, filingStatus);
						setHypotheticalDataSettingsModelProperty(defaultTaxRateData, false);
					}
				}));

				mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoSubsequentInvestmentTypeChosen').on('ecChosenItemSelected', function (subsequentInvestmentType) {
					if (subsequentInvestmentType) {
						var subsequentInvestmentAmount = 0.00;
						if (subsequentInvestmentType === scope.settings.get('hypotheticalSettings').subsequentInvestmentType) {
							subsequentInvestmentAmount = scope.settings.get('hypotheticalSettings').subsequentInvestmentAmount;
						}
						setHypotheticalDataSettingsModelProperty({
							settings: {
								subsequentInvestmentAmount: scope.format.number(subsequentInvestmentAmount, 'shortDecimal')
							}
						}, false);
					}
				}));

				mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoFrontLoadTypeChosen').on('ecChosenItemSelected', function (frontLoadType) {
					if (frontLoadType) {
						updateFeesInstanceStatus(frontLoadType);
						var feesDataSettings = helper.generateFeesDataSettings(scope, frontLoadType);
						setHypotheticalDataSettingsModelProperty(feesDataSettings, false);
					}
				}));

				mstarComponent.addUnregisterCallback(hypoFeesApplyChosenInstance.on('ecChosenItemSelected', function (applies) {
					updateCheckboxChosenData(hypoFeesApplyChosenInstance, applies);
				}));

				mstarComponent.addUnregisterCallback(hypoReinvestChosenInstance.on('ecChosenItemSelected', function (applies) {
					updateCheckboxChosenData(hypoReinvestChosenInstance, applies);
				}));

				mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:hypotheticalSettings', function (hypotheticalSettings) {
					if (hypotheticalSettings) {
						var newHypotheticalDataSettings = helper.generateHypotheticalDataSettings(scope, hypotheticalSettings);
						setActiveTabIndex(newHypotheticalDataSettings.settings.illustrationTrailingTimePeriod);
						updateTimePeriodInstanceStatus(newHypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod);
						updateFeesInstanceStatus(newHypotheticalDataSettings.settings.frontLoadType);
						setHypotheticalDataSettingsModelProperty(newHypotheticalDataSettings, false);
						portfolioDataInstance.setParameter('hypotheticalSettings', helper.merge(scope.settings.get('hypotheticalSettings'), hypotheticalSettings));
					}
				}));

				function initializeHypotheticalDataSettingsModel() {
					var hypotheticalDataSettings = helper.generateDefaultHypotheticalDataSettings(scope, 'all', false);
					setHypotheticalDataSettingsModelProperty(hypotheticalDataSettings, true);
					setActiveTabIndex(hypotheticalDataSettings.settings.illustrationTrailingTimePeriod);
					updateTimePeriodInstanceStatus(hypotheticalDataSettings.settings.illustrationTrailingTimePeriod);
					updateFeesInstanceStatus(hypotheticalDataSettings.settings.frontLoadType);
					updateHypoSettingsToReportBuilderPortfolioData(hypotheticalDataSettings.settings);
				}

				function getTimePeriodType(index) {
					var timePeriodType;
					var isTrailingReturn = _.indexOf(scope.settings.get('trailingReturnDefinitions'), scope.parameters.displayFrequency[index].value);
					if (isTrailingReturn > -1) {
						timePeriodType = 'TrailingReturn';
					} else {
						timePeriodType = scope.parameters.displayFrequency[index].value;
					}
					return timePeriodType;
				}

				function getTrailingReturnValue(index, timePeriodType) {
					var trailingReturnValue;
					if (timePeriodType === 'TrailingReturn') {
						trailingReturnValue = scope.parameters.displayFrequency[index].value;
					} else {
						trailingReturnValue = '';
					}
					return trailingReturnValue;
				}

				function setHypotheticalDataSettingsModelProperty(hypotheticalDataSettings, reset) {
					if (hypotheticalDataSettings) {
						if (reset) {
							scope.instance.setModelProperty('hypotheticalDataSettings', helper.merge({}, hypotheticalDataSettings));
						} else {
							scope.instance.setModelProperty('hypotheticalDataSettings', helper.merge(scope.instance.getModelProperty('hypotheticalDataSettings'), hypotheticalDataSettings));
						}
					}
				}

				function setActiveTabIndex(illustrationTrailingTimePeriod) {
					var selectedTabIndex = -1;
					_.each(scope.parameters.displayFrequency, function (item, index) {
						if (item.value === illustrationTrailingTimePeriod) {
							selectedTabIndex = index;
							return;
						}
					});
					hypoTabsInstance.setParameter('selectedTabIndex', selectedTabIndex);
					if (selectedTabIndex === -1 && hypoTabsInstance.isActive) {
						hypoTabsInstance.setParameter('resetTabStatus', true);
					}
				}

				function updateFeesInstanceStatus(frontLoadType) {
					if (frontLoadType) {
						var listItems = hypoFeesApplyChosenInstance.getModelProperty('listItems') || [],
						    applySalesChargeItem = _.findWhere(listItems, { key: 'applySalesCharge' });
						if (applySalesChargeItem) {
							applySalesChargeItem.disabled = frontLoadType === 'Standard' || frontLoadType === 'LetterOfIntent';
							hypoFeesApplyChosenInstance.setModelProperty('listItems', listItems);
						}
					}
				}

				function updateCheckboxChosenData(chosenInstance, data) {
					var listItems = chosenInstance.getModelProperty('listItems') || [],
					    hypotheticalSettings = scope.instance.getModelProperty('hypotheticalDataSettings.settings');
					_.each(listItems, function (item) {
						hypotheticalSettings[item.key] = _.indexOf(data, item.key) > -1;
					});

					scope.instance.setModelProperty('hypotheticalDataSettings.settings', hypotheticalSettings);
				}

				function updateHypoSettingsToReportBuilderPortfolioData(hypotheticalSettings) {
					portfolioDataInstance.setParameter('hypotheticalSettings', hypotheticalSettings);
					scope.instance.findRelative('hypoReportBuilder').setModelProperty('reportInfo.reportSettings.RequestSettings.HypoCalculationSettings', hypotheticalSettings);
				}

				function updateTimePeriodInstanceStatus(illustrationTrailingTimePeriod) {
					if (illustrationTrailingTimePeriod) {
						hypoDateInputInstance.setParameter('disabled', true);
						hypoTimePeriodTrailingReturnChosenInstance.setParameter('disabled', true);
						hypoApplyButtonInstance.setParameter('disabled', false);
						if (illustrationTrailingTimePeriod === 'TrailingReturn') {
							hypoTimePeriodTrailingReturnChosenInstance.setParameter('disabled', false);
						} else if (illustrationTrailingTimePeriod === 'Customized') {
							hypoDateInputInstance.setParameter('disabled', false);
							updateTimePeriodCustomDateStatus();
						}
					}
				}

				function updateTimePeriodCustomDateStatus() {
					var timePeriodDateInputData = helper.validateTimePeriodDateInputData(scope, helper.getHypotheticalDataModelProperty(scope, 'timePeriod'));
					setHypotheticalDataSettingsModelProperty(timePeriodDateInputData, false);
					hypoApplyButtonInstance.setParameter('disabled', timePeriodDateInputData.data.timePeriod.showDateErrorMsg);
				}

				function toggleCurrentActiveView(activeView, data, status) {
					if (activeView !== 'all') {
						if (status) {
							if (currentActiveView) {
								data[currentActiveView] = data[currentActiveView] || {};
								data[currentActiveView].toggle = false;
							}
							currentActiveView = activeView;
						} else {
							currentActiveView = activeView !== currentActiveView ? currentActiveView : null;
						}
					} else {
						currentActiveView = null;
					}
				}

				function updateHypotheticalSettingsButton() {
					scope.model.sections.showHypotheticalSettings = !scope.model.sections.showHypotheticalSettings;

					var captionLabelKey;
					if (scope.model.sections.showHypotheticalSettings) {
						captionLabelKey = 'settingsHide';
					} else {
						captionLabelKey = 'settingsShow';
					}
					hypoSettingsButtonInstance.setParameter('captionLabelKey', captionLabelKey);
				}
			}
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 3 */
/***/function (module, exports) {

	module.exports = {
		"ecHypotheticalGrowth": {
			"components": {
				"containerHypo": {
					"settings": {
						"breakpoints": {
							"defaults": {
								"groups": {
									"all": {
										"cols": 12,
										"sections": [{
											"cols": 2,
											"sectionId": "hypoReportBuilder"
										}, {
											"cols": 2,
											"sectionId": "hypotheticalSettings"
										}, "performanceGraph"]
									}
								}
							},
							"small": {
								"groups": {
									"all": {
										"cols": 12,
										"sections": [{
											"cols": 0,
											"sectionId": "hypoReportBuilder"
										}, {
											"cols": 1,
											"sectionId": "hypotheticalSettings"
										}, "performanceGraph"]
									}
								}
							}
						}
					},
					"type": "ecContainer"
				},
				"hypoApplyButton": {
					"labels": {
						"caption": {
							"en": "Apply"
						}
					},
					"settings": {
						"buttonCSS": "ec-button__btn--apply"
					},
					"type": "ecButton"
				},
				"hypoChosenButton": {
					"labels": {
						"caption": {
							"en": " "
						}
					},
					"settings": {
						"buttonCSS": "ec-button__btn--on-off"
					},
					"type": "ecButton"
				},
				"hypoDateInput": {
					"labels": {
						"placeholder": {
							"en": "YYYY-MM-DD"
						}
					},
					"settings": {
						"inputType": "date"
					},
					"type": "ecInput"
				},
				"hypoFeesApplyChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"disabled": true,
								"key": "applySalesCharge",
								"value": "applySalesCharge"
							}, {
								"key": "applyFeeForRebalance",
								"value": "applyFeeForRebalance"
							}]
						},
						"controlType": "checkbox",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoFilingStatusChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "Single",
								"value": "single"
							}, {
								"key": "MarriedFilingJointly",
								"value": "marriedFilingJointly"
							}, {
								"key": "MarriedFilingSeparately",
								"value": "marriedFilingSeparately"
							}, {
								"key": "HeadOfHousehold",
								"value": "headOfHousehold"
							}]
						},
						"controlType": "radio",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoFrequencyChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "Monthly",
								"value": "monthly"
							}, {
								"key": "Quarterly",
								"value": "quarterly"
							}, {
								"key": "SemiAnnually",
								"value": "semiAnnually"
							}, {
								"key": "Annually",
								"value": "annually"
							}]
						},
						"controlType": "radio",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoFrontLoadTypeChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "Standard",
								"value": "standard"
							}, {
								"key": "Custom",
								"value": "customCurrency"
							}, {
								"key": "CustomEntry",
								"value": "customPercenatge"
							}, {
								"key": "LetterOfIntent",
								"value": "letterOfIntent"
							}]
						},
						"controlType": "radio",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoNumberInput": {
					"settings": {
						"_validation": {
							"rules": {
								"isRegex": {
									"labelKey": "numberInputErrorMsg",
									"pattern": "^[0-9.,]+$",
									"type": "regex"
								}
							},
							"tooltipWhen": "never"
						},
						"inputType": "text"
					},
					"type": "ecInput"
				},
				"hypoPayChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "OutOfPocket",
								"value": "outOfPocket"
							}, {
								"key": "SalesOfShares",
								"value": "saleOfShares"
							}]
						},
						"controlType": "radio",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoReinvestChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "reinvestDividends",
								"value": "reinvestDividends"
							}, {
								"key": "reinvestCapitalGains",
								"value": "reinvestCapitalGains"
							}]
						},
						"controlType": "checkbox",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoReportBuilder": {
					"blueprint": "standardUSHypo",
					"settings": {
						"_model": {
							"reportInfo": {
								"reportContents": ["historicalPerformance"],
								"reportPortfolios": {
									"dataSourceType": "selector",
									"selector": "{{_ model(_.portfolioData).securities.portfolio _}}"
								}
							}
						},
						"reportSettings": {
							"Config": {
								"Id": "PDF"
							},
							"View": {
								"Id": "PDF"
							}
						}
					},
					"type": "ecReportBuilder"
				},
				"hypoSettingsButton": {
					"labels": {
						"caption": {
							"en": "Show Settings"
						}
					},
					"settings": {
						"buttonCSS": "ec-button__btn--bar"
					},
					"type": "ecButton"
				},
				"hypoSubsequentInvestmentTypeChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "Invest",
								"value": "contribution"
							}, {
								"key": "Withdrawal",
								"value": "withdrawal"
							}, {
								"key": "WithdrawalPercentage",
								"value": "withdrawalPercentage"
							}]
						},
						"controlType": "radio",
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"hypoTimePeriodTrailingReturnChosen": {
					"settings": {
						"_model": {
							"listItems": [{
								"key": "Year1",
								"value": "oneYearTrailingReturn"
							}, {
								"key": "Year3",
								"value": "threeYearsTrailingReturn"
							}, {
								"key": "Year5",
								"value": "fiveYearsTrailingReturn"
							}, {
								"key": "Year10",
								"value": "tenYearsTrailingReturn"
							}]
						},
						"allowSingleDeselect": false,
						"disableSearch": true,
						"displayFirstEmptyOption": false,
						"width": "100%"
					},
					"type": "ecChosen"
				},
				"performanceGraph": {
					"components": {
						"annualPerformanceTable": {
							"components": {
								"paginator": {
									"type": "ecPaginator"
								},
								"paginatorSticky": {
									"type": "ecPaginator"
								},
								"paginatorTop": {
									"type": "ecPaginator"
								},
								"sortFieldsDropdown": {
									"type": "ecChosen"
								},
								"sortOrderRadio": {
									"type": "ecChosen"
								}
							},
							"type": "ecTable"
						},
						"graphContainer": {
							"settings": {
								"breakpoints": {
									"defaults": {
										"groups": {
											"main": {
												"sections": ["frequency", "graph"]
											}
										}
									}
								}
							},
							"type": "ecContainer"
						},
						"tabFrequency": {
							"settings": {
								"selectedTabIndex": -1
							},
							"type": "ecTabs"
						}
					},
					"labels": {
						"performanceGraph": {
							"en": " "
						}
					},
					"settings": {
						"_model": {
							"performanceChart": {
								"dataSourceType": "selector",
								"selector": "{{_ model(_.portfolioData).securities.performanceChart _}}"
							}
						},
						"_parameters": {
							"displayFrequency": {
								"binding": "{{_ parameters(_).displayFrequency _}}"
							}
						},
						"chartType": "price",
						"colorPalettes": {
							"lineChart": ["#A50032", "#006098"]
						},
						"lineChartSettings": {
							"legendValuesFormatAlias": "currencyDecimal",
							"showsCurrency": true
						}
					},
					"type": "ecPerformanceGraph"
				},
				"portfolioData": {
					"blueprint": "standardHypo",
					"settings": {
						"_parameters": {
							"portfolio": {
								"binding": "{{_ parameters(_).portfolio _}}"
							}
						}
					},
					"type": "ecPortfolioData"
				}
			},
			"labels": {
				"amount": {
					"en": "Amount",
					"en-GB": null,
					"sv-SE": null
				},
				"annually": {
					"en": "Annually",
					"en-GB": null,
					"sv-SE": null
				},
				"applyFeeForRebalance": {
					"en": "Apply Fees for Rebalancing",
					"en-GB": null,
					"sv-SE": null
				},
				"applySalesCharge": {
					"en": "Redemption/Deferred Sales Charge",
					"en-GB": null,
					"sv-SE": null
				},
				"assetBasedAnnualFee": {
					"en": "Asset-Based Annual Fee %",
					"en-GB": null,
					"sv-SE": null
				},
				"benchmark": {
					"en": "Benchmark"
				},
				"capitalGain": {
					"en": "Capital Gain %",
					"en-GB": null,
					"sv-SE": null
				},
				"contribution": {
					"en": "Contribution",
					"en-GB": null,
					"sv-SE": null
				},
				"custom": {
					"en": "Custom",
					"en-GB": null,
					"sv-SE": null
				},
				"customCurrency": {
					"en": "Custom Currency",
					"en-GB": null,
					"sv-SE": null
				},
				"customDateErrorMsg": {
					"en": "Start date must be less than End date",
					"en-GB": null,
					"sv-SE": null
				},
				"customPercenatge": {
					"en": "Custom Percenatge",
					"en-GB": null,
					"sv-SE": null
				},
				"earliestAvailable": {
					"en": "Earliest Available",
					"en-GB": null,
					"sv-SE": null
				},
				"earliestCommon": {
					"en": "Earliest Common",
					"en-GB": null,
					"sv-SE": null
				},
				"endDate": {
					"en": "End Date",
					"en-GB": null,
					"sv-SE": null
				},
				"federalIncome": {
					"en": "Federal Income %",
					"en-GB": null,
					"sv-SE": null
				},
				"fees": {
					"en": "Fees",
					"en-GB": null,
					"sv-SE": null
				},
				"filingStatus": {
					"en": "Filing Status",
					"en-GB": null,
					"sv-SE": null
				},
				"fiveYears": {
					"da-DK": "5 År",
					"en": "5Y",
					"en-GB": null,
					"fr": "5A",
					"sv-SE": null,
					"zh-CN": "5年",
					"zh-HK": "5年"
				},
				"fiveYearsTrailingReturn": {
					"en": "5-Year Trailing Return",
					"en-GB": null,
					"sv-SE": null
				},
				"frequency": {
					"en": "Frequency",
					"en-GB": null,
					"sv-SE": null
				},
				"frontLoadType": {
					"en": "Front Load Type",
					"en-GB": null,
					"sv-SE": null
				},
				"headOfHousehold": {
					"en": "Head Of Household",
					"en-GB": null,
					"sv-SE": null
				},
				"inceptionDate": {
					"en": "Inception Date",
					"en-GB": null,
					"sv-SE": null
				},
				"investmentType": {
					"en": "Investment Type",
					"en-GB": null,
					"sv-SE": null
				},
				"letterOfIntent": {
					"en": "Letter Of Intent",
					"en-GB": null,
					"sv-SE": null
				},
				"marriedFilingJointly": {
					"en": "Married, Filed Jointly",
					"en-GB": null,
					"sv-SE": null
				},
				"marriedFilingSeparately": {
					"en": "Married, Filed Separately",
					"en-GB": null,
					"sv-SE": null
				},
				"monthly": {
					"en": "Monthly",
					"en-GB": null,
					"sv-SE": null
				},
				"numberInputErrorMsg": {
					"en": "Please input a valid value. Such as 123.00 or 123,123.00",
					"en-GB": null,
					"sv-SE": null
				},
				"oneYear": {
					"da-DK": "1 År",
					"en": "1Y",
					"en-GB": null,
					"fr": "1A",
					"sv-SE": null,
					"zh-CN": "1年",
					"zh-HK": "1年"
				},
				"oneYearTrailingReturn": {
					"en": "1-Year Trailing Return",
					"en-GB": null,
					"sv-SE": null
				},
				"outOfPocket": {
					"en": "Out Of Pocket",
					"en-GB": null,
					"sv-SE": null
				},
				"payFees": {
					"en": "How to Pay Fees",
					"en-GB": null,
					"sv-SE": null
				},
				"payTaxes": {
					"en": "Pay Taxes",
					"en-GB": null,
					"sv-SE": null
				},
				"percentage": {
					"en": "%",
					"en-GB": null,
					"sv-SE": null
				},
				"performanceChartInstruction": {
					"en": "Press T to bypass chart and read the corresponding table.",
					"en-GB": null,
					"fr": "Appuyez sur la touche T pour contourner le graphique et lire le tableau correspondant.",
					"sv-SE": null
				},
				"portfolio": {
					"en": "Portfolio",
					"en-GB": null,
					"sv-SE": null
				},
				"quarterly": {
					"en": "Quarterly",
					"en-GB": null,
					"sv-SE": null
				},
				"rebalancingReinvestment": {
					"en": "Rebalancing / Reinvestment",
					"en-GB": null,
					"sv-SE": null
				},
				"reinvestCapitalGains": {
					"en": "Reinvest Capital Gains",
					"en-GB": null,
					"sv-SE": null
				},
				"reinvestDividends": {
					"en": "Reinvest Dividends",
					"en-GB": null,
					"sv-SE": null
				},
				"reportOptions": {
					"en": "Report Options",
					"en-GB": null,
					"sv-SE": null
				},
				"saleOfShares": {
					"en": "Sale Of Shares",
					"en-GB": null,
					"sv-SE": null
				},
				"semiAnnually": {
					"en": "Semi-annually",
					"en-GB": null,
					"sv-SE": null
				},
				"settingsHide": {
					"en": "Hide Settings",
					"en-GB": null,
					"sv-SE": null
				},
				"settingsShow": {
					"en": "Show Settings",
					"en-GB": null,
					"sv-SE": null
				},
				"settingsTitle": {
					"en": "Custom Settings",
					"en-GB": null,
					"sv-SE": null
				},
				"sinceInception": {
					"en": "Since Inception",
					"en-GB": null,
					"sv-SE": null
				},
				"single": {
					"en": "Single",
					"en-GB": null,
					"sv-SE": null
				},
				"standard": {
					"en": "Standard",
					"en-GB": null,
					"sv-SE": null
				},
				"startDate": {
					"en": "Start Date",
					"en-GB": null,
					"sv-SE": null
				},
				"state": {
					"en": "State %",
					"en-GB": null,
					"sv-SE": null
				},
				"symbol": {
					"en": "€",
					"en-GB": null,
					"en-US": "$",
					"sv-SE": null
				},
				"taxInformation": {
					"en": "Tax Information",
					"en-GB": null,
					"sv-SE": null
				},
				"taxableIncome": {
					"en": "Taxable Income",
					"en-GB": null,
					"sv-SE": null
				},
				"tenYears": {
					"da-DK": "10 År",
					"en": "10Y",
					"en-GB": null,
					"fr": "10A",
					"sv-SE": null,
					"zh-CN": "10年",
					"zh-HK": "10年"
				},
				"tenYearsTrailingReturn": {
					"en": "10-Year Trailing Return",
					"en-GB": null,
					"sv-SE": null
				},
				"threeYears": {
					"da-DK": "3 År",
					"en": "3Y",
					"en-GB": null,
					"fr": "3A",
					"sv-SE": null,
					"zh-CN": "3年",
					"zh-HK": "3年"
				},
				"threeYearsTrailingReturn": {
					"en": "3-Year Trailing Return",
					"en-GB": null,
					"sv-SE": null
				},
				"timePeriod": {
					"en": "Time Period",
					"en-GB": null,
					"sv-SE": null
				},
				"title": {
					"en": "Hypothetical Growth",
					"en-GB": null,
					"sv-SE": null
				},
				"withdrawal": {
					"en": "Withdrawal",
					"en-GB": null,
					"sv-SE": null
				},
				"withdrawalPercentage": {
					"en": "Withdrawal%",
					"en-GB": null,
					"sv-SE": null
				}
			},
			"settings": {
				"_model": {
					"hypoDates": {
						"dataSourceType": "selector",
						"selector": "{{_ model(portfolioData).securities.hypoDates _}}"
					},
					"hypotheticalDataSettings": null,
					"sections": {
						"showHypotheticalSettings": false
					}
				},
				"_parameters": {
					"displayFrequency": {},
					"hypotheticalSettings": {},
					"portfolio": {}
				},
				"_templates": {
					"fees": "<div class=\"{{::namespaceClass('__hypothetical-settings--fees')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('assetBasedAnnualFee')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.assetBasedAnnualFee\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.assetBasedAnnualFee\">\r\n                {{::labels.get('numberInputErrorMsg')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('frequency')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFrequencyChosen[fees]\" data-ng-model=\"model.hypotheticalDataSettings.settings.assetFeeFrequency\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('payFees')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoPayChosen[fees]\" data-ng-model=\"model.hypotheticalDataSettings.settings.payFeeOptions\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('frontLoadType')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFrontLoadTypeChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.frontLoadType\"></ec-chosen>\r\n        </div>\r\n        <div data-ng-show=\"model.hypotheticalDataSettings.settings.frontLoadType !=='Standard' && model.hypotheticalDataSettings.settings.frontLoadType !=='LetterOfIntent'\" class=\"{{::namespaceClass('__hypothetical-settings--fees-front-load-type-amount')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n                {{::labels.get('amount')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n                <label data-ng-if=\"model.hypotheticalDataSettings.settings.frontLoadType ==='Custom'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                    {{::labels.get('symbol')}}\r\n                </label>\r\n                <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.salesFeeAmount\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n                <label data-ng-if=\"model.hypotheticalDataSettings.settings.frontLoadType ==='CustomEntry'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                    {{::labels.get('percentage')}}\r\n                </label>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.salesFeeAmount\">\r\n                {{::labels.get('numberInputErrorMsg')}}\r\n            </div>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--checkbox')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFeesApplyChosen\" data-ng-model=\"model.hypotheticalDataSettings.data.fees.applies\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n</div>",
					"investmentType": "<div class=\"{{::namespaceClass('__hypothetical-settings--investment-type')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n                <ec-chosen mstar-component-id=\"hypoSubsequentInvestmentTypeChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.subsequentInvestmentType\"></ec-chosen>\r\n            </div>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--investment-type-amount')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--title')}} {{::namespaceClass('__hypothetical-settings--investment-type-amount-title')}}\">\r\n                {{::labels.get('amount')}}\r\n            </label>\r\n            <label data-ng-if=\"model.hypotheticalDataSettings.settings.subsequentInvestmentType !=='WithdrawalPercentage'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('symbol')}}\r\n            </label>\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.subsequentInvestmentAmount\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label data-ng-if=\"model.hypotheticalDataSettings.settings.subsequentInvestmentType ==='WithdrawalPercentage'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.subsequentInvestmentAmount\">\r\n                {{::labels.get('numberInputErrorMsg')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n                {{::labels.get('frequency')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n                <ec-chosen mstar-component-id=\"hypoFrequencyChosen[investmentType]\" data-ng-model=\"model.hypotheticalDataSettings.settings.subsequentInvestmentWithdrawalFrequency\"></ec-chosen>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>",
					"main": "<ec-section title=\"{{::labels.get('title')}}\">\r\n    <div class=\"{{::namespaceClass('__hidden-text')}}\" tabindex=\"0\">{{::labels.get('performanceChartInstruction')}}</div>\r\n    <ec-container mstar-component-id=\"containerHypo\" mstar-loader=\"settings.get('showLoading') && isLoading\">\r\n        <ec-report-builder mstar-component-id=\"hypoReportBuilder\"></ec-report-builder>\r\n        <ec-section data-template-type=\"light\" section-id=\"hypotheticalSettings\">\r\n            <ec-button mstar-component-id=\"hypoSettingsButton\" class=\"{{model.sections.showHypotheticalSettings ? 'ec-button__btn--icon-arrow-right' : 'ec-button__btn--icon-arrow-left'}}\"></ec-button>\r\n        </ec-section>\r\n        <div data-ng-if=\"hypotheticalSettingsRenderStatus\" data-ng-show=\"model.sections.showHypotheticalSettings\" class=\"{{ ::namespaceClass('__hypothetical-settings--content') }}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--group')}} {{::namespaceClass('__hypothetical-settings--group-settings')}}\">\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-left')}}\">\r\n                    <div class=\"{{::namespaceClass('__hypothetical-settings--group-settings-title')}}\">\r\n                        {{::labels.get('settingsTitle')}}\r\n                    </div>\r\n                </div>\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-right')}}\">\r\n                    <ec-button mstar-component-id=\"hypoChosenButton[all]\" data-ng-click=\"selectHypoViewSection('all')\" class=\"{{ ::namespaceClass('__hypothetical-settings--chosen') }} {{namespaceClass('__hypothetical-settings--chosen-'+ (model.hypotheticalDataSettings.data.all.chosen ? 'on' : 'off')) }}\"></ec-button>\r\n                </div>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--group')}}\" data-ng-repeat=\"view in ::settings.get('hypoViews') track by $index\">\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-left')}}\">\r\n                    <span class=\"{{::namespaceClass('__hypothetical-settings--group-title')}} {{namespaceClass('__hypothetical-settings--group-title-'+ (model.hypotheticalDataSettings.data[view].toggle ? 'open':'close'))}}\" data-ng-click=\"toggleActiveHypoViewSection(view)\">\r\n                            {{::labels.get(view)}}\r\n                        </span>\r\n                    <div data-ng-show=\"model.hypotheticalDataSettings.data[view].toggle\" mstar-include=\"templates[view]\" class=\"{{::namespaceClass('__hypothetical-settings--view')}}\"></div>\r\n                </div>\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-right')}}\">\r\n                    <ec-button mstar-component-id=\"hypoChosenButton[view]\" data-ng-click=\"selectHypoViewSection(view)\" class=\"{{ ::namespaceClass('__hypothetical-settings--chosen') }} {{namespaceClass('__hypothetical-settings--chosen-'+ (model.hypotheticalDataSettings.data[view].chosen ? 'on' : 'off')) }}\"></ec-button>\r\n                </div>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--group')}} {{::namespaceClass('__hypothetical-settings--group-apply')}}\">\r\n                <ec-button mstar-component-id=\"hypoApplyButton\"></ec-button>\r\n            </div>\r\n        </div>\r\n        <ec-performance-graph mstar-component-id=\"performanceGraph\"></ec-performance-graph>\r\n    </ec-container>\r\n</ec-section>\r\n<ec-portfolio-data mstar-component-id=\"portfolioData\"></ec-portfolio-data>",
					"rebalancingReinvestment": "<div class=\"{{::namespaceClass('__hypothetical-settings--rebalancing-reinvestment')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <ec-chosen mstar-component-id=\"hypoFrequencyChosen[rebalancing-reinvestment]\" data-ng-model=\"model.hypotheticalDataSettings.settings.rebalanceFrequency\"></ec-chosen>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--checkbox')}}\">\r\n        <ec-chosen mstar-component-id=\"hypoReinvestChosen\" data-ng-model=\"model.hypotheticalDataSettings.data.rebalancingReinvestment.reinvests\"></ec-chosen>\r\n    </div>\r\n</div>",
					"reportOptions": "<div class=\"{{::namespaceClass('__hypothetical-settings--report-options')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <ec-chosen mstar-component-id=\"hypoFrequencyChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.investmentDetailReturnsFrequency\"></ec-chosen>\r\n    </div>\r\n</div>",
					"taxInformation": "<div class=\"{{::namespaceClass('__hypothetical-settings--tax-information')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('filingStatus')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFilingStatusChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.filingStatus\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('federalIncome')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.federalIncomeTaxRate\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.federalIncomeTaxRate\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('capitalGain')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.capitalGainTaxRate\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.capitalGainTaxRate\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('state')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.stateIncomeTaxRate\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.stateIncomeTaxRate\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('taxableIncome')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('symbol')}}\r\n            </label>\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.taxableIncome\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.taxableIncome\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('payTaxes')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoPayChosen[taxes]\" data-ng-model=\"model.hypotheticalDataSettings.settings.payTaxes\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n</div>",
					"timePeriod": "<div class=\"{{::namespaceClass('__hypothetical-settings--time-period')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"EarliestCommon\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('earliestCommon')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-start-date')}}\">\r\n                {{::labels.get('startDate')}}: {{format.date(model.hypoDates.earliestCommonDate,'yyyy-mm-dd')}}\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-end-date')}}\">\r\n                {{::labels.get('endDate')}}: {{format.date(model.hypoDates.asOfDate,'yyyy-mm-dd')}}\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"EarliestAvailable\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('earliestAvailable')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-start-date')}}\">\r\n                {{::labels.get('startDate')}}:{{format.date(model.hypoDates.earliestAvailableDate,'yyyy-mm-dd')}}\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-end-date')}}\">\r\n                {{::labels.get('endDate')}}: {{format.date(model.hypoDates.asOfDate,'yyyy-mm-dd')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"SinceInception\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('sinceInception')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-since-inception-date')}}\">\r\n                {{::labels.get('inceptionDate')}}: {{format.date(model.hypoDates.sinceInceptionDate,'yyyy-mm-dd')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--time-period-trailing-return')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"TrailingReturn\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--time-period-trailing-return-chosen')}}\">\r\n                <ec-chosen mstar-component-id=\"hypoTimePeriodTrailingReturnChosen\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.trailingReturn\"></ec-chosen>\r\n            </span>\r\n        </label>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--time-period-custom')}}\">\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"Customized\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('custom')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-custom-start-date')}}\">\r\n                <lable> {{::labels.get('startDate')}} </lable>\r\n                <ec-input mstar-component-id=\"hypoDateInput\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.startDate\" class=\"{{::namespaceClass('__hypothetical-settings--date-input')}}\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-custom-end-date')}}\">\r\n                <lable>{{::labels.get('endDate')}}</lable>\r\n                <ec-input mstar-component-id=\"hypoDateInput\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.endDate\" class=\"{{::namespaceClass('__hypothetical-settings--date-input')}}\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"model.hypotheticalDataSettings.data.timePeriod.showDateErrorMsg\">\r\n                {{::labels.get('customDateErrorMsg')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"
				},
				"displayFrequency": [{
					"labelKey": "oneYear",
					"value": "Year1"
				}, {
					"labelKey": "threeYears",
					"value": "Year3"
				}, {
					"labelKey": "fiveYears",
					"value": "Year5"
				}, {
					"labelKey": "tenYears",
					"value": "Year10"
				}],
				"hypoViewDefinitions": {
					"fees": {
						"dataPoints": ["assetBasedAnnualFee", "salesFeeAmount", "assetFeeFrequency", "payFees", "payFeeOptions", "frontLoadType", "customFeeType", "applySalesCharge", "applyFeeForRebalance"],
						"validation": {
							"assetBasedAnnualFee": {
								"dataPoints": ["assetBasedAnnualFee"],
								"max": 100,
								"min": 0
							},
							"custom": {
								"dataPoints": ["salesFeeAmount"],
								"min": 0
							},
							"customEntry": {
								"dataPoints": ["salesFeeAmount"],
								"max": 100,
								"min": 0
							}
						}
					},
					"investmentType": {
						"dataPoints": ["subsequentInvestmentType", "subsequentInvestmentAmount", "subsequentInvestmentWithdrawalFrequency"],
						"validation": {
							"invest": {
								"dataPoints": ["subsequentInvestmentAmount"],
								"min": 0
							},
							"withdrawal": {
								"dataPoints": ["subsequentInvestmentAmount"],
								"min": 0
							},
							"withdrawalPercentage": {
								"dataPoints": ["subsequentInvestmentAmount"],
								"max": 100,
								"min": 0
							}
						}
					},
					"rebalancingReinvestment": {
						"dataPoints": ["rebalanceFrequency", "reinvestDividends", "reinvestCapitalGains"]
					},
					"reportOptions": {
						"dataPoints": ["investmentDetailReturnsFrequency"]
					},
					"taxInformation": {
						"dataPoints": ["filingStatus", "taxableIncome", "federalIncomeTaxRate", "capitalGainTaxRate", "stateIncomeTaxRate", "payTaxes"],
						"defaultTaxRateData": [{
							"capitalGainTaxRate": 0,
							"federalIncomeTaxRate": 0,
							"stateIncomeTaxRate": 0,
							"type": "NoTaxes"
						}, {
							"capitalGainTaxRate": 15,
							"federalIncomeTaxRate": 25,
							"stateIncomeTaxRate": 0,
							"type": "Single"
						}, {
							"capitalGainTaxRate": 5,
							"federalIncomeTaxRate": 15,
							"stateIncomeTaxRate": 0,
							"type": "MarriedFilingJointly"
						}, {
							"capitalGainTaxRate": 15,
							"federalIncomeTaxRate": 25,
							"stateIncomeTaxRate": 0,
							"type": "MarriedFilingSeparately"
						}, {
							"capitalGainTaxRate": 15,
							"federalIncomeTaxRate": 25,
							"stateIncomeTaxRate": 0,
							"type": "HeadOfHousehold"
						}],
						"validation": [{
							"dataPoints": ["federalIncomeTaxRate", "capitalGainTaxRate", "stateIncomeTaxRate"],
							"max": 100,
							"min": 0
						}, {
							"dataPoints": ["taxableIncome"],
							"min": 0
						}]
					},
					"timePeriod": {
						"dataPoints": ["illustrationTrailingTimePeriod", "startDate", "endDate"]
					}
				},
				"hypoViews": ["timePeriod", "investmentType", "fees", "rebalancingReinvestment", "taxInformation", "reportOptions"],
				"hypotheticalSettings": {
					"applyFeeForRebalance": false,
					"applySalesCharge": true,
					"assetBasedAnnualFee": 0,
					"assetFeeFrequency": "Annually",
					"assetFeeType": "Percentage",
					"capitalGainTaxRate": 0,
					"customFeeType": "Amount",
					"dividendTaxRate": 0,
					"entryExitFeeType": "CustomEntry",
					"federalIncomeTaxRate": 0,
					"filingStatus": "NoTaxes",
					"frontLoadType": "Standard",
					"illustrationTrailingTimePeriod": "EarliestCommon",
					"investmentDetailReturnsFrequency": "Monthly",
					"liquidateOnEndDate": false,
					"payFeeOptions": "OutOfPocket",
					"payFees": "SalesOfSharesEnding",
					"payFeesUseCashFirst": true,
					"payTaxes": "OutOfPocket",
					"rebalanceFrequency": "None",
					"rebalanceThreshold": 0,
					"reinvestCapitalGains": true,
					"reinvestDividends": true,
					"salesFeeAmount": 0,
					"stateIncomeTaxRate": 0,
					"subsequentInvestmentAmount": 0,
					"subsequentInvestmentType": "Invest",
					"subsequentInvestmentWithdrawalFrequency": "Monthly",
					"synchronizePortfolioStartDate": true,
					"taxableIncome": 50000
				},
				"namespaceClass": "ec-hypothetical-growth",
				"portfolio": null,
				"showLoading": true,
				"trailingReturnDefinitions": ["Year1", "Year3", "Year5", "Year10"]
			},
			"type": "ecHypotheticalGrowth"
		}
	};

	/***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
		'use strict';

		morningstar.asterix.ng.register('ecHypotheticalGrowth', __webpack_require__(3).ecHypotheticalGrowth);

		morningstar.asterix.meta.register('ecHypotheticalGrowth', 'usageTracking', {
			componentLoad: {
				endsWhen: 'dataLoaded'
			}
		});

		__webpack_require__(2);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
		'use strict';

		return {
			generateDefaultHypotheticalDataSettings: generateDefaultHypotheticalDataSettings,
			generateDefaultTaxRateData: generateDefaultTaxRateData,
			generateFeesDataSettings: generateFeesDataSettings,
			generateHypotheticalDataSettings: generateHypotheticalDataSettings,
			generateHypotheticalSettings: generateHypotheticalSettings,
			generateSelectHypoViewSectionData: generateSelectHypoViewSectionData,
			generateToggleActiveHypoViewSectionData: generateToggleActiveHypoViewSectionData,
			getHypotheticalDataModelProperty: getHypotheticalDataModelProperty,
			merge: merge,
			validateNumperInputData: validateNumperInputData,
			validateTimePeriodDateInputData: validateTimePeriodDateInputData
		};

		//external
		function generateDefaultHypotheticalDataSettings(scope, view, chosen) {
			var hypotheticalDataSettings = {
				data: {},
				settings: {}
			},
			    hypoViewDefinitions = {};

			if (view === 'all') {
				hypoViewDefinitions = scope.settings.get('hypoViewDefinitions');
				hypotheticalDataSettings.data.all = {
					chosen: chosen
				};
			} else {
				hypoViewDefinitions[view] = scope.settings.get('hypoViewDefinitions')[view];
			}

			_.each(hypoViewDefinitions, function (data, key) {
				hypotheticalDataSettings.data[key] = {
					chosen: chosen,
					toggle: false
				};
				if (!chosen) {
					hypotheticalDataSettings.data = merge(hypotheticalDataSettings.data, generateHypotheticalDataViewValue(scope, key, scope.settings.get('hypotheticalSettings')));
					hypotheticalDataSettings.settings = merge(hypotheticalDataSettings.settings, generateHypotheticalSettingViewValue(scope, key, scope.settings.get('hypotheticalSettings')));
				}
			});

			return hypotheticalDataSettings;
		}

		function generateDefaultTaxRateData(scope, filingStatus) {
			var capitalGainTaxRate = 0.00,
			    federalIncomeTaxRate = 0.00,
			    stateIncomeTaxRate = 0.00;
			if (filingStatus === scope.settings.get('hypotheticalSettings').filingStatus) {
				capitalGainTaxRate = scope.settings.get('hypotheticalSettings').capitalGainTaxRate;
				federalIncomeTaxRate = scope.settings.get('hypotheticalSettings').federalIncomeTaxRate;
				stateIncomeTaxRate = scope.settings.get('hypotheticalSettings').stateIncomeTaxRate;
			} else {
				var defaultTaxRateData = morningstar.asterix.util.parse('taxInformation.defaultTaxRateData')(scope.settings.get('hypoViewDefinitions')),
				    taxRateData = _.findWhere(defaultTaxRateData, { type: filingStatus });
				if (taxRateData) {
					capitalGainTaxRate = taxRateData.capitalGainTaxRate;
					federalIncomeTaxRate = taxRateData.federalIncomeTaxRate;
					stateIncomeTaxRate = taxRateData.stateIncomeTaxRate;
				}
			}

			return {
				settings: {
					federalIncomeTaxRate: formatNumberValue(scope, federalIncomeTaxRate),
					capitalGainTaxRate: formatNumberValue(scope, capitalGainTaxRate),
					stateIncomeTaxRate: formatNumberValue(scope, stateIncomeTaxRate)
				}
			};
		}

		function generateFeesDataSettings(scope, frontLoadType) {
			var hypotheticalDataSettings;
			if (frontLoadType === 'Standard' || frontLoadType === 'LetterOfIntent') {
				var feesApplies = getHypotheticalDataModelProperty(scope, 'fees', 'applies');
				if (_.indexOf(feesApplies, 'applySalesCharge') === -1) {
					feesApplies.push('applySalesCharge');
					hypotheticalDataSettings = {
						data: {
							fees: {
								applies: feesApplies
							}
						},
						settings: {
							salesFeeAmount: formatNumberValue(scope, 0)
						}
					};
				}
			} else {
				hypotheticalDataSettings = {
					settings: {
						salesFeeAmount: formatNumberValue(scope, frontLoadType === scope.settings.get('hypotheticalSettings').frontLoadType ? scope.settings.get('hypotheticalSettings').salesFeeAmount : 0),
						customFeeType: frontLoadType === 'Custom' ? 'Amount' : 'Percentage'
					}
				};
			}

			return morningstar.asterix.util.isEmptyObject(hypotheticalDataSettings) ? null : hypotheticalDataSettings;
		}

		function generateHypotheticalDataSettings(scope, hypotheticalSettings) {
			var hypotheticalDataSettings = {
				data: {
					all: {
						chosen: false
					}
				},
				settings: {}
			},
			    newHypotheticalSettings = merge(scope.settings.get('hypotheticalSettings'), hypotheticalSettings);

			_.each(scope.settings.get('hypoViews'), function (view) {
				hypotheticalDataSettings.data = merge(hypotheticalDataSettings.data, generateHypotheticalDataViewValue(scope, view, newHypotheticalSettings));
				hypotheticalDataSettings.settings = merge(hypotheticalDataSettings.settings, generateHypotheticalSettingViewValue(scope, view, newHypotheticalSettings));

				var dataPoints = morningstar.asterix.util.parse(view + '.dataPoints')(scope.settings.get('hypoViewDefinitions')) || [];
				_.each(dataPoints, function (dataPoint) {
					if (!_.isUndefined(hypotheticalSettings[dataPoint]) && hypotheticalSettings[dataPoint] !== scope.settings.get('hypotheticalSettings')[dataPoint]) {
						hypotheticalDataSettings.data[view] = {
							chosen: true
						};
						hypotheticalDataSettings.data.all.chosen = true;
					}
				});
			});

			return hypotheticalDataSettings;
		}

		function generateHypotheticalSettings(scope) {
			var hypotheticalSettings = merge(scope.settings.get('hypotheticalSettings'), getHypotheticalSettingsModelProperty(scope)),
			    validations = getAllValidations(scope, hypotheticalSettings);

			if (getHypotheticalDataModelProperty(scope, 'timePeriod', 'chosen')) {
				hypotheticalSettings.illustrationTrailingTimePeriod = getHypotheticalDataModelProperty(scope, 'timePeriod', 'illustrationTrailingTimePeriod');
				if (hypotheticalSettings.illustrationTrailingTimePeriod !== 'Customized') {
					hypotheticalSettings.startDate = null;
					hypotheticalSettings.endDate = null;
					if (hypotheticalSettings.illustrationTrailingTimePeriod === 'TrailingReturn') {
						hypotheticalSettings.illustrationTrailingTimePeriod = getHypotheticalDataModelProperty(scope, 'timePeriod', 'trailingReturn');
					}
				}
			}
			morningstar.asterix.util.each(validations, function (validation) {
				if (validation) {
					morningstar.asterix.util.each(validation.dataPoints, function (dataPoint) {
						if (!morningstar.asterix.util.isNumber(hypotheticalSettings[dataPoint])) {
							hypotheticalSettings[dataPoint] = Number(escapeSquareCommaDot(hypotheticalSettings[dataPoint]));
						}
					});
				}
			});

			return hypotheticalSettings;
		}

		function generateSelectHypoViewSectionData(scope, activeView, chosen) {
			var hypotheticalDataSettings = generateDefaultHypotheticalDataSettings(scope, activeView, chosen);
			if (activeView !== 'all') {
				hypotheticalDataSettings.data[activeView].toggle = chosen;
				hypotheticalDataSettings.data.all = {
					chosen: chosen
				};
				if (chosen) {
					if (activeView === 'taxInformation') {
						hypotheticalDataSettings.settings = {
							filingStatus: 'Single'
						};
					}
				} else {
					_.each(scope.settings.get('hypoViews'), function (view) {
						if (view !== activeView) {
							hypotheticalDataSettings.data.all.chosen = hypotheticalDataSettings.data.all.chosen || getHypotheticalDataModelProperty(scope, view, 'chosen');
						}
					});
				}
			}

			return hypotheticalDataSettings;
		}

		function generateToggleActiveHypoViewSectionData(scope, activeView, toggle) {
			var hypotheticalDataSettings = {
				data: {}
			};
			hypotheticalDataSettings.data[activeView] = {
				toggle: toggle
			};
			if (toggle) {
				hypotheticalDataSettings.data = merge(hypotheticalDataSettings.data, {
					all: {
						chosen: true
					}
				});
				hypotheticalDataSettings.data[activeView].chosen = true;
				if (activeView === 'taxInformation' && getHypotheticalSettingsModelProperty(scope, 'filingStatus') === 'NoTaxes') {
					hypotheticalDataSettings.settings = {
						filingStatus: 'Single'
					};
				}
			}

			return hypotheticalDataSettings;
		}

		function getHypotheticalDataModelProperty(scope, view, dataPoint) {
			if (view && dataPoint) {
				return scope.instance.getModelProperty('hypotheticalDataSettings.data.' + view + '.' + dataPoint);
			} else if (view) {
				return scope.instance.getModelProperty('hypotheticalDataSettings.data.' + view);
			} else {
				return scope.instance.getModelProperty('hypotheticalDataSettings.data');
			}
		}

		function merge(target, source) {
			return morningstar.asterix.util.merge({}, target, source, mergeCustomizer);
		}

		function validateNumperInputData(scope, hypotheticalSettings) {
			var validations = getAllValidations(scope, hypotheticalSettings),
			    settings = {};

			_.each(validations, function (validation) {
				if (validation) {
					_.each(validation.dataPoints, function (dataPoint) {
						var value = escapeSquareCommaDot(hypotheticalSettings[dataPoint]);
						if (!_.isEmpty(value)) {
							if (!morningstar.asterix.util.isUndefinedOrNull(validation.min) && Number(value) < validation.min) {
								settings[dataPoint] = null;
							} else if (!morningstar.asterix.util.isUndefinedOrNull(validation.max) && Number(value) > validation.max) {
								settings[dataPoint] = formatNumberValue(scope, validation.max);
							} else {
								settings[dataPoint] = formatNumberValue(scope, value);
							}
						}
					});
				}
			});

			return morningstar.asterix.util.isEmptyObject(settings) ? null : {
				settings: settings
			};
		}

		/**
   * @param {*} scope 
   * @param {*} timePeriod startdate and endDate must be date object
   */
		function validateTimePeriodDateInputData(scope, timePeriod) {
			var newTimePeriod = {
				showDateErrorMsg: false
			},
			    startDate = timePeriod.startDate,
			    endDate = timePeriod.endDate;
			var illustrationTrailingTimePeriod = getHypotheticalDataModelProperty(scope, 'timePeriod', 'illustrationTrailingTimePeriod');
			if ((startDate || endDate) && illustrationTrailingTimePeriod === 'Customized') {
				var earliestAvailableDate = new Date(scope.model.hypoDates.earliestAvailableDate),
				    asOfDate = new Date(scope.model.hypoDates.asOfDate);

				if (startDate && endDate && endDate <= startDate) {
					newTimePeriod.showDateErrorMsg = true;
				} else if (startDate && !endDate && startDate > asOfDate) {
					newTimePeriod.showDateErrorMsg = true;
				} else {
					if (startDate && startDate < earliestAvailableDate) {
						timePeriod.startDate = earliestAvailableDate; // correct date in UI
						startDate = earliestAvailableDate;
					}
					if (endDate && endDate > asOfDate) {
						timePeriod.endDate = asOfDate; // correct date in UI
						endDate = asOfDate;
					}
				}
			}
			return {
				data: {
					timePeriod: newTimePeriod
				},
				settings: {
					startDate: !newTimePeriod.showDateErrorMsg && startDate ? morningstar.asterix.util.date.convertToUTC(startDate) : null,
					endDate: !newTimePeriod.showDateErrorMsg && endDate ? morningstar.asterix.util.date.convertToUTC(endDate) : null
				}
			};
		}

		//internal
		function escapeSquareCommaDot(value) {
			//Such as '123,456,789.00' -> '123456789.00'
			//Such as '123.456.789,00' -> '123456789.00'
			if (!morningstar.asterix.util.isUndefinedOrNull(value)) {
				return value.toString().replace(/[.,](?=.*[,.])/g, '').replace(',', '.');
			}
		}

		function formatNumberValue(scope, value) {
			return scope.format.number(value, 'shortDecimal');
		}

		function getAllValidations(scope, hypotheticalSettings) {
			var feesValidation = morningstar.asterix.util.parse('fees.validation')(scope.settings.get('hypoViewDefinitions')),
			    investmentTypeValidation = morningstar.asterix.util.parse('investmentType.validation')(scope.settings.get('hypoViewDefinitions')),
			    taxInformationValidation = morningstar.asterix.util.parse('taxInformation.validation')(scope.settings.get('hypoViewDefinitions')),
			    validations = [];

			validations = validations.concat(taxInformationValidation);
			validations.push(feesValidation.assetBasedAnnualFee);
			validations.push(feesValidation[morningstar.asterix.util.string.firstLowerCase(hypotheticalSettings.frontLoadType)]);
			validations.push(investmentTypeValidation[morningstar.asterix.util.string.firstLowerCase(hypotheticalSettings.subsequentInvestmentType)]);
			return validations;
		}

		function generateHypotheticalDataViewValue(scope, view, hypotheticalSettings) {
			var data;
			switch (view) {
				case 'timePeriod':
					data = generateTimePeriodHypotheticalData(scope, hypotheticalSettings);
					break;
				case 'fees':
					data = generateViewArrayObjectData(scope, hypotheticalSettings, view, 'applies', ['applySalesCharge', 'applyFeeForRebalance']);
					break;
				case 'rebalancingReinvestment':
					data = generateViewArrayObjectData(scope, hypotheticalSettings, view, 'reinvests', ['reinvestDividends', 'reinvestCapitalGains']);
					break;
			}
			return data;
		}

		function generateHypotheticalSettingViewValue(scope, view, hypotheticalSettings) {
			hypotheticalSettings = hypotheticalSettings || {};

			var dataPoints = morningstar.asterix.util.parse(view + '.dataPoints')(scope.settings.get('hypoViewDefinitions')) || [],
			    settings = {};
			_.each(dataPoints, function (dataPoint) {
				if (!_.isUndefined(hypotheticalSettings[dataPoint])) {
					settings[dataPoint] = hypotheticalSettings[dataPoint];
				}
			});

			return settings;
		}

		function generateTimePeriodHypotheticalData(scope, hypotheticalSettings) {
			var timePeriod = {};
			if (hypotheticalSettings.illustrationTrailingTimePeriod) {
				if (_.indexOf(scope.settings.get('trailingReturnDefinitions'), hypotheticalSettings.illustrationTrailingTimePeriod) !== -1) {
					timePeriod.illustrationTrailingTimePeriod = 'TrailingReturn';
					timePeriod.trailingReturn = hypotheticalSettings.illustrationTrailingTimePeriod;
				} else {
					timePeriod.illustrationTrailingTimePeriod = hypotheticalSettings.illustrationTrailingTimePeriod;
					timePeriod.trailingReturn = 'Year1';
				}
			}

			_.each(['startDate', 'endDate'], function (item) {
				if (hypotheticalSettings[item]) {
					timePeriod[item] = new Date(hypotheticalSettings[item]);
				}
			});

			return morningstar.asterix.util.isEmptyObject(timePeriod) ? null : {
				timePeriod: timePeriod
			};
		}

		function getHypotheticalSettingsModelProperty(scope, dataPoint) {
			if (dataPoint) {
				return scope.instance.getModelProperty('hypotheticalDataSettings.settings.' + dataPoint);
			} else {
				return scope.instance.getModelProperty('hypotheticalDataSettings.settings');
			}
		}

		function generateViewArrayObjectData(scope, hypotheticalSettings, view, name, dataPoints) {
			var data = {};
			data[view] = {};
			data[view][name] = [];
			_.each(dataPoints, function (dataPoint) {
				if (hypotheticalSettings[dataPoint]) {
					data[view][name].push(dataPoint);
				}
			});

			return data;
		}

		function mergeCustomizer(a, b, key) {
			if (morningstar.asterix.util.isArray(b)) {
				return b;
			}
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 6 */
/***/function (module, exports) {

	module.exports = angular;

	/***/
}]
/******/);
//# sourceMappingURL=ec-hypothetical-growth.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};
	/******/
	/******/ // The require function
	/******/function __webpack_require__(moduleId) {
		/******/
		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId]) {
			/******/return installedModules[moduleId].exports;
			/******/
		}
		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/i: moduleId,
			/******/l: false,
			/******/exports: {}
			/******/ };
		/******/
		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ // Flag the module as loaded
		/******/module.l = true;
		/******/
		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}
	/******/
	/******/
	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;
	/******/
	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;
	/******/
	/******/ // identity function for calling harmony imports with the correct context
	/******/__webpack_require__.i = function (value) {
		return value;
	};
	/******/
	/******/ // define getter function for harmony exports
	/******/__webpack_require__.d = function (exports, name, getter) {
		/******/if (!__webpack_require__.o(exports, name)) {
			/******/Object.defineProperty(exports, name, {
				/******/configurable: false,
				/******/enumerable: true,
				/******/get: getter
				/******/ });
			/******/
		}
		/******/
	};
	/******/
	/******/ // getDefaultExport function for compatibility with non-harmony modules
	/******/__webpack_require__.n = function (module) {
		/******/var getter = module && module.__esModule ?
		/******/function getDefault() {
			return module['default'];
		} :
		/******/function getModuleExports() {
			return module;
		};
		/******/__webpack_require__.d(getter, 'a', getter);
		/******/return getter;
		/******/
	};
	/******/
	/******/ // Object.prototype.hasOwnProperty.call
	/******/__webpack_require__.o = function (object, property) {
		return Object.prototype.hasOwnProperty.call(object, property);
	};
	/******/
	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "build/";
	/******/
	/******/ // Load entry module and return exports
	/******/return __webpack_require__(__webpack_require__.s = 6);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

	module.exports = morningstar;

	/***/
},
/* 1 */
/***/function (module, exports) {

	module.exports = jQuery;

	/***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(0), __webpack_require__(8), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, $) {
		'use strict';

		inputDirective.$inject = ["$timeout", "mstarDimensions"];
		angular.module('ecInput', ['mstarCore']).directive('ecInput', inputDirective);

		var archetypeMapping = {
			date: 'date',
			time: 'date',
			'datetime-local': 'date',
			month: 'date',
			week: 'date',

			number: 'number',
			numberLocalized: 'number',

			text: 'text',
			password: 'text',
			email: 'text',
			search: 'text',
			select: 'select',
			url: 'text',

			textarea: 'textarea',

			switchToggle: 'switchToggle',
			checkbox: 'checkbox',
			checkboxGroup: 'checkboxGroup',
			radioGroup: 'radioGroup'
		};

		function inputDirective($timeout, mstarDimensions) {

			return {
				restrict: 'E',
				require: ['ngModel', 'mstarComponentId'],
				scope: {
					ariaAutocomplete: '@?',
					ariaDescribedby: '@?',
					ariaLabel: '@?',
					ariaOwns: '@?',
					name: '@?',
					ngModel: '=',
					ngReadonly: '=?',
					ngDisabled: '=?',
					ngConfig: '=?',
					label: '@?',
					model: '=?inputData',
					onRadioChange: '&?',
					role: '@?'
				},
				template: __webpack_require__(7),
				link: linkFn
			};

			function linkFn(scope, elem, attrs, controllers) {
				var mstarComponent = controllers[1],
				    validate;

				// binds settings, labels, formatter and templates to scope properties
				mstarComponent.bindConfig(scope);

				// compiles the main template
				mstarComponent.compileTemplate(scope, '_templates.main');

				// binds parameters (two-way between the asterix instance's parameters and scope.parameters)
				mstarComponent.bindParameters(scope);

				mstarComponent.bindValue(scope);

				if (attrs.inputData) {
					scope.instance.setModel(scope.model);
				} else {
					mstarComponent.bindModelData(scope);
				}

				// use for dynamic instance to update the parameters passed from config
				if (attrs.ngConfig) {
					var parameters = scope.instance.getParameters(),
					    keys = _.keys(scope.ngConfig);

					_.each(keys, function (key) {
						if (parameters.hasOwnProperty(key)) {
							scope.instance.setParameter(key, scope.ngConfig[key]);
						}
					});
				}

				var inputType = scope.$eval('parameters.inputType'),
				    enableDatepicker = inputType === 'date' && !Modernizr.inputtypes.date,
				    languageId = scope.settings.get('languageId'),
				    dashIndex = languageId.indexOf('-');

				scope.numberInputType = 'number';
				if (inputType === 'numberLocalized') {
					// Only do this for IE and Edge
					var msie = ['Edge', 'MSIE', 'Trident'];
					_.each(msie, function (ua) {
						if (navigator.userAgent.indexOf(ua) > -1) {
							scope.numberInputType = 'text';
							var nf = morningstar.asterix.formatting.getFormatter(languageId).number(1.1).toString();
							var decimalSeparator = nf.indexOf(',') > -1 ? ',' : '.';
							scope.numberInputPattern = scope.settings.get('numberInputPattern').replace('{decimalSeparator}', decimalSeparator);
						}
					});
				}

				var regionalSettings = void 0,
				    dateFormat = void 0;

				if (enableDatepicker) {
					regionalSettings = $.datepicker.regional[languageId] || dashIndex > -1 && $.datepicker.regional[languageId.substr(0, dashIndex)] || $.datepicker.regional[''];

					if (languageId === 'en-CA') {
						// special case, doesn't exist in jqueryUI, same as en-US (default) with the exception of this override
						regionalSettings.dateFormat = 'yy-mm-dd';
					}

					dateFormat = scope.settings.get('datepickerOptions').dateFormat || regionalSettings.dateFormat;

					scope.archetype = 'datepicker';
				} else {
					scope.archetype = archetypeMapping[inputType];
				}

				scope.$watch('parameters.inputType', function (newValue, oldValue) {
					if (newValue === oldValue) {
						return;
					}

					if (enableDatepicker) {
						scope.archetype = 'datepicker';
					} else {
						scope.archetype = archetypeMapping[newValue];
					}
				});

				scope.$watch('ngModel', function (value) {
					if (enableDatepicker) {
						setDatePickerValue(value);
					}
					scope.instance.trigger('ecInputChanged', [value]);
				});

				function setDatePickerValue(value) {
					elem.find('input[type="date"]').val($.datepicker.formatDate(dateFormat, value));
				}

				if (scope.archetype === 'checkboxGroup') {
					scope.checkboxChange = function () {
						var checkedItems = [];
						for (var key in scope.checkboxStatus) {
							var value = scope.checkboxStatus[key];
							if (value) {
								checkedItems.push(value);
							}
						}
						scope.ngModel = checkedItems;
					};
				}

				scope.$evalAsync(function () {
					// Handle checkbox model
					if (scope.archetype === 'checkboxGroup') {
						scope.checkboxStatus = {};
						morningstar.asterix.util.each(scope.ngModel, function (value) {
							scope.checkboxStatus[value] = value;
						});
					}

					// Validation
					validate = elem.find('[mstar-validate]').controller('mstarValidate');
					if (validate) {
						validate.getTooltip().setAnchor(elem);
					}
				});

				$timeout(function () {
					if (enableDatepicker) {
						var inputtedValue = '';

						elem.find('input[type="date"]').datepicker(_.extend({}, regionalSettings, scope.settings.get('datepickerOptions'))).on('paste', function (e) {
							e.preventDefault();
						}).on('keydown', function (e) {
							if (e.which === 13) {
								// Enter
								$(this).blur();
							}
						}).on('input', function (e) {
							inputtedValue = $(this).val();
						}).on('change', function (e) {
							try {
								scope.ngModel = $.datepicker.parseDate(dateFormat, inputtedValue || $.datepicker.formatDate(dateFormat, $(this).datepicker('getDate')));
								scope.$apply();
								elem.find('#invalid-date').hide();
								scope.invalidDateMessage = '';
							} catch (error) {
								scope.invalidDateMessage = scope.labels.get('invalidDate');
								elem.find('#invalid-date').show();
								$(this).val('');
								scope.ngModel = null;
								scope.$apply();
							}
							inputtedValue = '';
						});

						/** convert from jquery-UI specific format
       *  y - year (two digit)
       *  yy - year (four digit)
       */
						scope.dateFormat = dateFormat.toUpperCase().replace(/Y/g, 'YY');

						// Set the default value to fix a bug where the default value
						// isn't set because the input element isn't available initially
						setDatePickerValue(scope.ngModel);
					}
				}, 0);

				scope.$on('$destroy', function () {
					if (enableDatepicker) {
						elem.find('input[type="date"]').datepicker('destroy');
					}
				});

				mstarDimensions(scope, elem).addListener(function () {
					if (enableDatepicker) {
						elem.find('input[type="date"]').datepicker('hide');
					}
				}, {
					width: true,
					height: true,
					offset: true,
					visibility: true
				});
			}
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
		return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
		return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	};

	/*! jQuery UI - v1.12.1 - 2018-01-02
 * http://jqueryui.com
 * Includes: keycode.js, widgets/datepicker.js
 * Copyright jQuery Foundation and other contributors; Licensed MIT */

	(function (factory) {
		if (true) {

			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // jsilva: Changed from jquery to jQuery
		} else {

			// Browser globals
			factory(jQuery);
		}
	})(function ($) {

		$.ui = $.ui || {};

		var version = $.ui.version = "1.12.1";

		/*!
   * jQuery UI Keycode 1.12.1
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

		//>>label: Keycode
		//>>group: Core
		//>>description: Provide keycodes as keynames
		//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/


		var keycode = $.ui.keyCode = {
			BACKSPACE: 8,
			COMMA: 188,
			DELETE: 46,
			DOWN: 40,
			END: 35,
			ENTER: 13,
			ESCAPE: 27,
			HOME: 36,
			LEFT: 37,
			PAGE_DOWN: 34,
			PAGE_UP: 33,
			PERIOD: 190,
			RIGHT: 39,
			SPACE: 32,
			TAB: 9,
			UP: 38
		};

		// jscs:disable maximumLineLength
		/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
		/*!
   * jQuery UI Datepicker 1.12.1
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

		//>>label: Datepicker
		//>>group: Widgets
		//>>description: Displays a calendar from an input or inline for selecting dates.
		//>>docs: http://api.jqueryui.com/datepicker/
		//>>demos: http://jqueryui.com/datepicker/
		//>>css.structure: ../../themes/base/core.css
		//>>css.structure: ../../themes/base/datepicker.css
		//>>css.theme: ../../themes/base/theme.css


		$.extend($.ui, { datepicker: { version: "1.12.1" } });

		var datepicker_instActive;

		function datepicker_getZindex(elem) {
			var position, value;
			while (elem.length && elem[0] !== document) {

				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css("position");
				if (position === "absolute" || position === "relative" || position === "fixed") {

					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt(elem.css("zIndex"), 10);
					if (!isNaN(value) && value !== 0) {
						return value;
					}
				}
				elem = elem.parent();
			}

			return 0;
		}
		/* Date picker manager.
     Use the singleton instance of this class, $.datepicker, to interact with the date picker.
     Settings for (groups of) date pickers are maintained in an instance object,
     allowing multiple different settings on the same page. */

		function Datepicker() {
			this._curInst = null; // The current instance in use
			this._keyEvent = false; // If the last event was a key event
			this._disabledInputs = []; // List of date picker inputs that have been disabled
			this._datepickerShowing = false; // True if the popup picker is showing , false if not
			this._inDialog = false; // True if showing within a "dialog", false if not
			this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
			this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
			this._appendClass = "ui-datepicker-append"; // The name of the append marker class
			this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
			this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
			this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
			this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
			this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
			this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
			this.regional = []; // Available regional settings, indexed by language code
			this.regional[""] = { // Default regional settings
				closeText: "Done", // Display text for close link
				prevText: "Prev", // Display text for previous month link
				nextText: "Next", // Display text for next month link
				currentText: "Today", // Display text for current month link
				monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], // Names of months for drop-down and formatting
				monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
				dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
				dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
				dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], // Column headings for days starting at Sunday
				weekHeader: "Wk", // Column header for week of the year
				dateFormat: "mm/dd/yy", // See format options on parseDate
				firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
				isRTL: false, // True if right-to-left language, false if left-to-right
				showMonthAfterYear: false, // True if the year select precedes month, false for month then year
				yearSuffix: "" // Additional text to append to the year in the month headers
			};
			this._defaults = { // Global defaults for all the date picker instances
				showOn: "focus", // "focus" for popup on focus,
				// "button" for trigger button, or "both" for either
				showAnim: "fadeIn", // Name of jQuery animation for popup
				showOptions: {}, // Options for enhanced animations
				defaultDate: null, // Used when field is blank: actual date,
				// +/-number for offset from today, null for today
				appendText: "", // Display text following the input box, e.g. showing the format
				buttonText: "...", // Text for trigger button
				buttonImage: "", // URL for trigger button image
				buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
				hideIfNoPrevNext: false, // True to hide next/previous month links
				// if not applicable, false to just disable them
				navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
				gotoCurrent: false, // True if today link goes back to current selection instead
				changeMonth: false, // True if month can be selected directly, false if only prev/next
				changeYear: false, // True if year can be selected directly, false if only prev/next
				yearRange: "c-10:c+10", // Range of years to display in drop-down,
				// either relative to today's year (-nn:+nn), relative to currently displayed year
				// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
				showOtherMonths: false, // True to show dates in other months, false to leave blank
				selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
				showWeek: false, // True to show week of the year, false to not show it
				calculateWeek: this.iso8601Week, // How to calculate the week of the year,
				// takes a Date and returns the number of the week for it
				shortYearCutoff: "+10", // Short year values < this are in the current century,
				// > this are in the previous century,
				// string value starting with "+" for current year + value
				minDate: null, // The earliest selectable date, or null for no limit
				maxDate: null, // The latest selectable date, or null for no limit
				duration: "fast", // Duration of display/closure
				beforeShowDay: null, // Function that takes a date and returns an array with
				// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
				// [2] = cell title (optional), e.g. $.datepicker.noWeekends
				beforeShow: null, // Function that takes an input field and
				// returns a set of custom settings for the date picker
				onSelect: null, // Define a callback function when a date is selected
				onChangeMonthYear: null, // Define a callback function when the month or year is changed
				onClose: null, // Define a callback function when the datepicker is closed
				numberOfMonths: 1, // Number of months to show at a time
				showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
				stepMonths: 1, // Number of months to step back/forward
				stepBigMonths: 12, // Number of months to step back/forward for the big links
				altField: "", // Selector for an alternate field to store selected dates into
				altFormat: "", // The date format to use for the alternate field
				constrainInput: true, // The input is constrained by the current date format
				showButtonPanel: false, // True to show button panel, false to not show it
				autoSize: false, // True to size the input for the date format, false to leave as is
				disabled: false // The initial disabled state
			};
			$.extend(this._defaults, this.regional[""]);
			this.regional.en = $.extend(true, {}, this.regional[""]);
			this.regional["en-US"] = $.extend(true, {}, this.regional.en);
			this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
		}

		$.extend(Datepicker.prototype, {
			/* Class name added to elements to indicate already configured with a date picker. */
			markerClassName: "hasDatepicker",

			//Keep track of the maximum number of rows displayed (see #7043)
			maxRows: 4,

			// TODO rename to "widget" when switching to widget factory
			_widgetDatepicker: function _widgetDatepicker() {
				return this.dpDiv;
			},

			/* Override the default settings for all instances of the date picker.
    * @param  settings  object - the new settings to use as defaults (anonymous object)
    * @return the manager object
    */
			setDefaults: function setDefaults(settings) {
				datepicker_extendRemove(this._defaults, settings || {});
				return this;
			},

			/* Attach the date picker to a jQuery selection.
    * @param  target	element - the target input field or division or span
    * @param  settings  object - the new settings to use for this date picker instance (anonymous)
    */
			_attachDatepicker: function _attachDatepicker(target, settings) {
				var nodeName, inline, inst;
				nodeName = target.nodeName.toLowerCase();
				inline = nodeName === "div" || nodeName === "span";
				if (!target.id) {
					this.uuid += 1;
					target.id = "dp" + this.uuid;
				}
				inst = this._newInst($(target), inline);
				inst.settings = $.extend({}, settings || {});
				if (nodeName === "input") {
					this._connectDatepicker(target, inst);
				} else if (inline) {
					this._inlineDatepicker(target, inst);
				}
			},

			/* Create a new instance object. */
			_newInst: function _newInst(target, inline) {
				var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
				return { id: id, input: target, // associated target
					selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
					drawMonth: 0, drawYear: 0, // month being drawn
					inline: inline, // is datepicker inline or not
					dpDiv: !inline ? this.dpDiv : // presentation div
					datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) };
			},

			/* Attach the date picker to an input field. */
			_connectDatepicker: function _connectDatepicker(target, inst) {
				var input = $(target);
				inst.append = $([]);
				inst.trigger = $([]);
				if (input.hasClass(this.markerClassName)) {
					return;
				}
				this._attachments(input, inst);
				input.addClass(this.markerClassName).on("keydown", this._doKeyDown).on("keypress", this._doKeyPress).on("keyup", this._doKeyUp);
				this._autoSize(inst);
				$.data(target, "datepicker", inst);

				//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
				if (inst.settings.disabled) {
					this._disableDatepicker(target);
				}
			},

			/* Make attachments based on settings. */
			_attachments: function _attachments(input, inst) {
				var showOn,
				    buttonText,
				    buttonImage,
				    appendText = this._get(inst, "appendText"),
				    isRTL = this._get(inst, "isRTL");

				if (inst.append) {
					inst.append.remove();
				}
				if (appendText) {
					inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
					input[isRTL ? "before" : "after"](inst.append);
				}

				input.off("focus", this._showDatepicker);

				if (inst.trigger) {
					inst.trigger.remove();
				}

				showOn = this._get(inst, "showOn");
				if (showOn === "focus" || showOn === "both") {
					// pop-up date picker when in the marked field
					input.on("focus", this._showDatepicker);
				}
				if (showOn === "button" || showOn === "both") {
					// pop-up date picker when button clicked
					buttonText = this._get(inst, "buttonText");
					buttonImage = this._get(inst, "buttonImage");
					inst.trigger = $(this._get(inst, "buttonImageOnly") ? $("<img/>").addClass(this._triggerClass).attr({ src: buttonImage, alt: buttonText, title: buttonText }) : $("<button type='button'></button>").addClass(this._triggerClass).html(!buttonImage ? buttonText : $("<img/>").attr({ src: buttonImage, alt: buttonText, title: buttonText })));
					input[isRTL ? "before" : "after"](inst.trigger);
					inst.trigger.on("click", function () {
						if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
							$.datepicker._hideDatepicker();
						} else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
							$.datepicker._hideDatepicker();
							$.datepicker._showDatepicker(input[0]);
						} else {
							$.datepicker._showDatepicker(input[0]);
						}
						return false;
					});
				}
			},

			/* Apply the maximum length for the date format. */
			_autoSize: function _autoSize(inst) {
				if (this._get(inst, "autoSize") && !inst.inline) {
					var findMax,
					    max,
					    maxI,
					    i,
					    date = new Date(2009, 12 - 1, 20),

					// Ensure double digits
					dateFormat = this._get(inst, "dateFormat");

					if (dateFormat.match(/[DM]/)) {
						findMax = function findMax(names) {
							max = 0;
							maxI = 0;
							for (i = 0; i < names.length; i++) {
								if (names[i].length > max) {
									max = names[i].length;
									maxI = i;
								}
							}
							return maxI;
						};
						date.setMonth(findMax(this._get(inst, dateFormat.match(/MM/) ? "monthNames" : "monthNamesShort")));
						date.setDate(findMax(this._get(inst, dateFormat.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - date.getDay());
					}
					inst.input.attr("size", this._formatDate(inst, date).length);
				}
			},

			/* Attach an inline date picker to a div. */
			_inlineDatepicker: function _inlineDatepicker(target, inst) {
				var divSpan = $(target);
				if (divSpan.hasClass(this.markerClassName)) {
					return;
				}
				divSpan.addClass(this.markerClassName).append(inst.dpDiv);
				$.data(target, "datepicker", inst);
				this._setDate(inst, this._getDefaultDate(inst), true);
				this._updateDatepicker(inst);
				this._updateAlternate(inst);

				//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
				if (inst.settings.disabled) {
					this._disableDatepicker(target);
				}

				// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
				// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
				inst.dpDiv.css("display", "block");
			},

			/* Pop-up the date picker in a "dialog" box.
    * @param  input element - ignored
    * @param  date	string or Date - the initial date to display
    * @param  onSelect  function - the function to call when a date is selected
    * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
    * @param  pos int[2] - coordinates for the dialog's position within the screen or
    *					event - with x/y coordinates or
    *					leave empty for default (screen centre)
    * @return the manager object
    */
			_dialogDatepicker: function _dialogDatepicker(input, date, onSelect, settings, pos) {
				var id,
				    browserWidth,
				    browserHeight,
				    scrollX,
				    scrollY,
				    inst = this._dialogInst; // internal instance

				if (!inst) {
					this.uuid += 1;
					id = "dp" + this.uuid;
					this._dialogInput = $("<input type='text' id='" + id + "' style='position: absolute; top: -100px; width: 0px;'/>");
					this._dialogInput.on("keydown", this._doKeyDown);
					$("body").append(this._dialogInput);
					inst = this._dialogInst = this._newInst(this._dialogInput, false);
					inst.settings = {};
					$.data(this._dialogInput[0], "datepicker", inst);
				}
				datepicker_extendRemove(inst.settings, settings || {});
				date = date && date.constructor === Date ? this._formatDate(inst, date) : date;
				this._dialogInput.val(date);

				this._pos = pos ? pos.length ? pos : [pos.pageX, pos.pageY] : null;
				if (!this._pos) {
					browserWidth = document.documentElement.clientWidth;
					browserHeight = document.documentElement.clientHeight;
					scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
					scrollY = document.documentElement.scrollTop || document.body.scrollTop;
					this._pos = // should use actual width/height below
					[browserWidth / 2 - 100 + scrollX, browserHeight / 2 - 150 + scrollY];
				}

				// Move input on screen for focus, but hidden behind dialog
				this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px");
				inst.settings.onSelect = onSelect;
				this._inDialog = true;
				this.dpDiv.addClass(this._dialogClass);
				this._showDatepicker(this._dialogInput[0]);
				if ($.blockUI) {
					$.blockUI(this.dpDiv);
				}
				$.data(this._dialogInput[0], "datepicker", inst);
				return this;
			},

			/* Detach a datepicker from its control.
    * @param  target	element - the target input field or division or span
    */
			_destroyDatepicker: function _destroyDatepicker(target) {
				var nodeName,
				    $target = $(target),
				    inst = $.data(target, "datepicker");

				if (!$target.hasClass(this.markerClassName)) {
					return;
				}

				nodeName = target.nodeName.toLowerCase();
				$.removeData(target, "datepicker");
				if (nodeName === "input") {
					inst.append.remove();
					inst.trigger.remove();
					$target.removeClass(this.markerClassName).off("focus", this._showDatepicker).off("keydown", this._doKeyDown).off("keypress", this._doKeyPress).off("keyup", this._doKeyUp);
				} else if (nodeName === "div" || nodeName === "span") {
					$target.removeClass(this.markerClassName).empty();
				}

				if (datepicker_instActive === inst) {
					datepicker_instActive = null;
				}
			},

			/* Enable the date picker to a jQuery selection.
    * @param  target	element - the target input field or division or span
    */
			_enableDatepicker: function _enableDatepicker(target) {
				var nodeName,
				    inline,
				    $target = $(target),
				    inst = $.data(target, "datepicker");

				if (!$target.hasClass(this.markerClassName)) {
					return;
				}

				nodeName = target.nodeName.toLowerCase();
				if (nodeName === "input") {
					target.disabled = false;
					inst.trigger.filter("button").each(function () {
						this.disabled = false;
					}).end().filter("img").css({ opacity: "1.0", cursor: "" });
				} else if (nodeName === "div" || nodeName === "span") {
					inline = $target.children("." + this._inlineClass);
					inline.children().removeClass("ui-state-disabled");
					inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", false);
				}
				this._disabledInputs = $.map(this._disabledInputs, function (value) {
					return value === target ? null : value;
				}); // delete entry
			},

			/* Disable the date picker to a jQuery selection.
    * @param  target	element - the target input field or division or span
    */
			_disableDatepicker: function _disableDatepicker(target) {
				var nodeName,
				    inline,
				    $target = $(target),
				    inst = $.data(target, "datepicker");

				if (!$target.hasClass(this.markerClassName)) {
					return;
				}

				nodeName = target.nodeName.toLowerCase();
				if (nodeName === "input") {
					target.disabled = true;
					inst.trigger.filter("button").each(function () {
						this.disabled = true;
					}).end().filter("img").css({ opacity: "0.5", cursor: "default" });
				} else if (nodeName === "div" || nodeName === "span") {
					inline = $target.children("." + this._inlineClass);
					inline.children().addClass("ui-state-disabled");
					inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", true);
				}
				this._disabledInputs = $.map(this._disabledInputs, function (value) {
					return value === target ? null : value;
				}); // delete entry
				this._disabledInputs[this._disabledInputs.length] = target;
			},

			/* Is the first field in a jQuery collection disabled as a datepicker?
    * @param  target	element - the target input field or division or span
    * @return boolean - true if disabled, false if enabled
    */
			_isDisabledDatepicker: function _isDisabledDatepicker(target) {
				if (!target) {
					return false;
				}
				for (var i = 0; i < this._disabledInputs.length; i++) {
					if (this._disabledInputs[i] === target) {
						return true;
					}
				}
				return false;
			},

			/* Retrieve the instance data for the target control.
    * @param  target  element - the target input field or division or span
    * @return  object - the associated instance data
    * @throws  error if a jQuery problem getting data
    */
			_getInst: function _getInst(target) {
				try {
					return $.data(target, "datepicker");
				} catch (err) {
					throw "Missing instance data for this datepicker";
				}
			},

			/* Update or retrieve the settings for a date picker attached to an input field or division.
    * @param  target  element - the target input field or division or span
    * @param  name	object - the new settings to update or
    *				string - the name of the setting to change or retrieve,
    *				when retrieving also "all" for all instance settings or
    *				"defaults" for all global defaults
    * @param  value   any - the new value for the setting
    *				(omit if above is an object or to retrieve a value)
    */
			_optionDatepicker: function _optionDatepicker(target, name, value) {
				var settings,
				    date,
				    minDate,
				    maxDate,
				    inst = this._getInst(target);

				if (arguments.length === 2 && typeof name === "string") {
					return name === "defaults" ? $.extend({}, $.datepicker._defaults) : inst ? name === "all" ? $.extend({}, inst.settings) : this._get(inst, name) : null;
				}

				settings = name || {};
				if (typeof name === "string") {
					settings = {};
					settings[name] = value;
				}

				if (inst) {
					if (this._curInst === inst) {
						this._hideDatepicker();
					}

					date = this._getDateDatepicker(target, true);
					minDate = this._getMinMaxDate(inst, "min");
					maxDate = this._getMinMaxDate(inst, "max");
					datepicker_extendRemove(inst.settings, settings);

					// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
					if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
						inst.settings.minDate = this._formatDate(inst, minDate);
					}
					if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
						inst.settings.maxDate = this._formatDate(inst, maxDate);
					}
					if ("disabled" in settings) {
						if (settings.disabled) {
							this._disableDatepicker(target);
						} else {
							this._enableDatepicker(target);
						}
					}
					this._attachments($(target), inst);
					this._autoSize(inst);
					this._setDate(inst, date);
					this._updateAlternate(inst);
					this._updateDatepicker(inst);
				}
			},

			// Change method deprecated
			_changeDatepicker: function _changeDatepicker(target, name, value) {
				this._optionDatepicker(target, name, value);
			},

			/* Redraw the date picker attached to an input field or division.
    * @param  target  element - the target input field or division or span
    */
			_refreshDatepicker: function _refreshDatepicker(target) {
				var inst = this._getInst(target);
				if (inst) {
					this._updateDatepicker(inst);
				}
			},

			/* Set the dates for a jQuery selection.
    * @param  target element - the target input field or division or span
    * @param  date	Date - the new date
    */
			_setDateDatepicker: function _setDateDatepicker(target, date) {
				var inst = this._getInst(target);
				if (inst) {
					this._setDate(inst, date);
					this._updateDatepicker(inst);
					this._updateAlternate(inst);
				}
			},

			/* Get the date(s) for the first entry in a jQuery selection.
    * @param  target element - the target input field or division or span
    * @param  noDefault boolean - true if no default date is to be used
    * @return Date - the current date
    */
			_getDateDatepicker: function _getDateDatepicker(target, noDefault) {
				var inst = this._getInst(target);
				if (inst && !inst.inline) {
					this._setDateFromField(inst, noDefault);
				}
				return inst ? this._getDate(inst) : null;
			},

			/* Handle keystrokes. */
			_doKeyDown: function _doKeyDown(event) {
				var onSelect,
				    dateStr,
				    sel,
				    inst = $.datepicker._getInst(event.target),
				    handled = true,
				    isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

				inst._keyEvent = true;
				if ($.datepicker._datepickerShowing) {
					switch (event.keyCode) {
						case 9:
							$.datepicker._hideDatepicker();
							handled = false;
							break; // hide on tab out
						case 13:
							sel = $("td." + $.datepicker._dayOverClass + ":not(." + $.datepicker._currentClass + ")", inst.dpDiv);
							if (sel[0]) {
								$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
							}

							onSelect = $.datepicker._get(inst, "onSelect");
							if (onSelect) {
								dateStr = $.datepicker._formatDate(inst);

								// Trigger custom callback
								onSelect.apply(inst.input ? inst.input[0] : null, [dateStr, inst]);
							} else {
								$.datepicker._hideDatepicker();
							}

							return false; // don't submit the form
						case 27:
							$.datepicker._hideDatepicker();
							break; // hide on escape
						case 33:
							$.datepicker._adjustDate(event.target, event.ctrlKey ? -$.datepicker._get(inst, "stepBigMonths") : -$.datepicker._get(inst, "stepMonths"), "M");
							break; // previous month/year on page up/+ ctrl
						case 34:
							$.datepicker._adjustDate(event.target, event.ctrlKey ? +$.datepicker._get(inst, "stepBigMonths") : +$.datepicker._get(inst, "stepMonths"), "M");
							break; // next month/year on page down/+ ctrl
						case 35:
							if (event.ctrlKey || event.metaKey) {
								$.datepicker._clearDate(event.target);
							}
							handled = event.ctrlKey || event.metaKey;
							break; // clear on ctrl or command +end
						case 36:
							if (event.ctrlKey || event.metaKey) {
								$.datepicker._gotoToday(event.target);
							}
							handled = event.ctrlKey || event.metaKey;
							break; // current on ctrl or command +home
						case 37:
							if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, isRTL ? +1 : -1, "D");
							}
							handled = event.ctrlKey || event.metaKey;

							// -1 day on ctrl or command +left
							if (event.originalEvent.altKey) {
								$.datepicker._adjustDate(event.target, event.ctrlKey ? -$.datepicker._get(inst, "stepBigMonths") : -$.datepicker._get(inst, "stepMonths"), "M");
							}

							// next month/year on alt +left on Mac
							break;
						case 38:
							if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, -7, "D");
							}
							handled = event.ctrlKey || event.metaKey;
							break; // -1 week on ctrl or command +up
						case 39:
							if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, isRTL ? -1 : +1, "D");
							}
							handled = event.ctrlKey || event.metaKey;

							// +1 day on ctrl or command +right
							if (event.originalEvent.altKey) {
								$.datepicker._adjustDate(event.target, event.ctrlKey ? +$.datepicker._get(inst, "stepBigMonths") : +$.datepicker._get(inst, "stepMonths"), "M");
							}

							// next month/year on alt +right
							break;
						case 40:
							if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, +7, "D");
							}
							handled = event.ctrlKey || event.metaKey;
							break; // +1 week on ctrl or command +down
						default:
							handled = false;
					}
				} else if (event.keyCode === 36 && event.ctrlKey) {
					// display the date picker on ctrl+home
					$.datepicker._showDatepicker(this);
				} else {
					handled = false;
				}

				if (handled) {
					event.preventDefault();
					event.stopPropagation();
				}
			},

			/* Filter entered characters - based on date format. */
			_doKeyPress: function _doKeyPress(event) {
				var chars,
				    chr,
				    inst = $.datepicker._getInst(event.target);

				if ($.datepicker._get(inst, "constrainInput")) {
					chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
					chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
					return event.ctrlKey || event.metaKey || chr < " " || !chars || chars.indexOf(chr) > -1;
				}
			},

			/* Synchronise manual entry and field/alternate field. */
			_doKeyUp: function _doKeyUp(event) {
				var date,
				    inst = $.datepicker._getInst(event.target);

				if (inst.input.val() !== inst.lastVal) {
					try {
						date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"), inst.input ? inst.input.val() : null, $.datepicker._getFormatConfig(inst));

						if (date) {
							// only if valid
							$.datepicker._setDateFromField(inst);
							$.datepicker._updateAlternate(inst);
							$.datepicker._updateDatepicker(inst);
						}
					} catch (err) {}
				}
				return true;
			},

			/* Pop-up the date picker for a given input field.
    * If false returned from beforeShow event handler do not show.
    * @param  input  element - the input field attached to the date picker or
    *					event - if triggered by focus
    */
			_showDatepicker: function _showDatepicker(input) {
				input = input.target || input;
				if (input.nodeName.toLowerCase() !== "input") {
					// find from button/image trigger
					input = $("input", input.parentNode)[0];
				}

				if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) {
					// already here
					return;
				}

				var inst, beforeShow, beforeShowSettings, isFixed, offset, showAnim, duration;

				inst = $.datepicker._getInst(input);
				if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
					$.datepicker._curInst.dpDiv.stop(true, true);
					if (inst && $.datepicker._datepickerShowing) {
						$.datepicker._hideDatepicker($.datepicker._curInst.input[0]);
					}
				}

				beforeShow = $.datepicker._get(inst, "beforeShow");
				beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
				if (beforeShowSettings === false) {
					return;
				}
				datepicker_extendRemove(inst.settings, beforeShowSettings);

				inst.lastVal = null;
				$.datepicker._lastInput = input;
				$.datepicker._setDateFromField(inst);

				if ($.datepicker._inDialog) {
					// hide cursor
					input.value = "";
				}
				if (!$.datepicker._pos) {
					// position below input
					$.datepicker._pos = $.datepicker._findPos(input);
					$.datepicker._pos[1] += input.offsetHeight; // add the height
				}

				isFixed = false;
				$(input).parents().each(function () {
					isFixed |= $(this).css("position") === "fixed";
					return !isFixed;
				});

				offset = { left: $.datepicker._pos[0], top: $.datepicker._pos[1] };
				$.datepicker._pos = null;

				//to avoid flashes on Firefox
				inst.dpDiv.empty();

				// determine sizing offscreen
				inst.dpDiv.css({ position: "absolute", display: "block", top: "-1000px" });
				$.datepicker._updateDatepicker(inst);

				// fix width for dynamic number of date pickers
				// and adjust position before showing
				offset = $.datepicker._checkOffset(inst, offset, isFixed);
				inst.dpDiv.css({ position: $.datepicker._inDialog && $.blockUI ? "static" : isFixed ? "fixed" : "absolute", display: "none",
					left: offset.left + "px", top: offset.top + "px" });

				if (!inst.inline) {
					showAnim = $.datepicker._get(inst, "showAnim");
					duration = $.datepicker._get(inst, "duration");
					inst.dpDiv.css("z-index", datepicker_getZindex($(input)) + 1);
					$.datepicker._datepickerShowing = true;

					if ($.effects && $.effects.effect[showAnim]) {
						inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
					} else {
						inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
					}

					if ($.datepicker._shouldFocusInput(inst)) {
						inst.input.trigger("focus");
					}

					$.datepicker._curInst = inst;
				}
			},

			/* Generate the date picker content. */
			_updateDatepicker: function _updateDatepicker(inst) {
				this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
				datepicker_instActive = inst; // for delegate hover events
				inst.dpDiv.empty().append(this._generateHTML(inst));
				this._attachHandlers(inst);

				var origyearshtml,
				    numMonths = this._getNumberOfMonths(inst),
				    cols = numMonths[1],
				    width = 17,
				    activeCell = inst.dpDiv.find("." + this._dayOverClass + " a");

				if (activeCell.length > 0) {
					datepicker_handleMouseover.apply(activeCell.get(0));
				}

				inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
				if (cols > 1) {
					inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", width * cols + "em");
				}
				inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") + "Class"]("ui-datepicker-multi");
				inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl");

				if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput(inst)) {
					inst.input.trigger("focus");
				}

				// Deffered render of the years select (to avoid flashes on Firefox)
				if (inst.yearshtml) {
					origyearshtml = inst.yearshtml;
					setTimeout(function () {

						//assure that inst.yearshtml didn't change.
						if (origyearshtml === inst.yearshtml && inst.yearshtml) {
							inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
						}
						origyearshtml = inst.yearshtml = null;
					}, 0);
				}
			},

			// #6694 - don't focus the input if it's already focused
			// this breaks the change event in IE
			// Support: IE and jQuery <1.9
			_shouldFocusInput: function _shouldFocusInput(inst) {
				return inst.input && inst.input.is(":visible") && !inst.input.is(":disabled") && !inst.input.is(":focus");
			},

			/* Check positioning to remain on screen. */
			_checkOffset: function _checkOffset(inst, offset, isFixed) {
				var dpWidth = inst.dpDiv.outerWidth(),
				    dpHeight = inst.dpDiv.outerHeight(),
				    inputWidth = inst.input ? inst.input.outerWidth() : 0,
				    inputHeight = inst.input ? inst.input.outerHeight() : 0,
				    viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
				    viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());

				offset.left -= this._get(inst, "isRTL") ? dpWidth - inputWidth : 0;
				offset.left -= isFixed && offset.left === inst.input.offset().left ? $(document).scrollLeft() : 0;
				offset.top -= isFixed && offset.top === inst.input.offset().top + inputHeight ? $(document).scrollTop() : 0;

				// Now check if datepicker is showing outside window viewport - move to a better place if so.
				offset.left -= Math.min(offset.left, offset.left + dpWidth > viewWidth && viewWidth > dpWidth ? Math.abs(offset.left + dpWidth - viewWidth) : 0);
				offset.top -= Math.min(offset.top, offset.top + dpHeight > viewHeight && viewHeight > dpHeight ? Math.abs(dpHeight + inputHeight) : 0);

				return offset;
			},

			/* Find an object's position on the screen. */
			_findPos: function _findPos(obj) {
				var position,
				    inst = this._getInst(obj),
				    isRTL = this._get(inst, "isRTL");

				while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
					obj = obj[isRTL ? "previousSibling" : "nextSibling"];
				}

				position = $(obj).offset();
				return [position.left, position.top];
			},

			/* Hide the date picker from view.
    * @param  input  element - the input field attached to the date picker
    */
			_hideDatepicker: function _hideDatepicker(input) {
				var showAnim,
				    duration,
				    postProcess,
				    onClose,
				    inst = this._curInst;

				if (!inst || input && inst !== $.data(input, "datepicker")) {
					return;
				}

				if (this._datepickerShowing) {
					showAnim = this._get(inst, "showAnim");
					duration = this._get(inst, "duration");
					postProcess = function postProcess() {
						$.datepicker._tidyDialog(inst);
					};

					// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
					if ($.effects && ($.effects.effect[showAnim] || $.effects[showAnim])) {
						inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
					} else {
						inst.dpDiv[showAnim === "slideDown" ? "slideUp" : showAnim === "fadeIn" ? "fadeOut" : "hide"](showAnim ? duration : null, postProcess);
					}

					if (!showAnim) {
						postProcess();
					}
					this._datepickerShowing = false;

					onClose = this._get(inst, "onClose");
					if (onClose) {
						onClose.apply(inst.input ? inst.input[0] : null, [inst.input ? inst.input.val() : "", inst]);
					}

					this._lastInput = null;
					if (this._inDialog) {
						this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
						if ($.blockUI) {
							$.unblockUI();
							$("body").append(this.dpDiv);
						}
					}
					this._inDialog = false;
				}
			},

			/* Tidy up after a dialog display. */
			_tidyDialog: function _tidyDialog(inst) {
				inst.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar");
			},

			/* Close date picker if clicked elsewhere. */
			_checkExternalClick: function _checkExternalClick(event) {
				if (!$.datepicker._curInst) {
					return;
				}

				var $target = $(event.target),
				    inst = $.datepicker._getInst($target[0]);

				if ($target[0].id !== $.datepicker._mainDivId && $target.parents("#" + $.datepicker._mainDivId).length === 0 && !$target.hasClass($.datepicker.markerClassName) && !$target.closest("." + $.datepicker._triggerClass).length && $.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) || $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst) {
					$.datepicker._hideDatepicker();
				}
			},

			/* Adjust one of the date sub-fields. */
			_adjustDate: function _adjustDate(id, offset, period) {
				var target = $(id),
				    inst = this._getInst(target[0]);

				if (this._isDisabledDatepicker(target[0])) {
					return;
				}
				this._adjustInstDate(inst, offset + (period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
				period);
				this._updateDatepicker(inst);
			},

			/* Action for current link. */
			_gotoToday: function _gotoToday(id) {
				var date,
				    target = $(id),
				    inst = this._getInst(target[0]);

				if (this._get(inst, "gotoCurrent") && inst.currentDay) {
					inst.selectedDay = inst.currentDay;
					inst.drawMonth = inst.selectedMonth = inst.currentMonth;
					inst.drawYear = inst.selectedYear = inst.currentYear;
				} else {
					date = new Date();
					inst.selectedDay = date.getDate();
					inst.drawMonth = inst.selectedMonth = date.getMonth();
					inst.drawYear = inst.selectedYear = date.getFullYear();
				}
				this._notifyChange(inst);
				this._adjustDate(target);
			},

			/* Action for selecting a new month/year. */
			_selectMonthYear: function _selectMonthYear(id, select, period) {
				var target = $(id),
				    inst = this._getInst(target[0]);

				inst["selected" + (period === "M" ? "Month" : "Year")] = inst["draw" + (period === "M" ? "Month" : "Year")] = parseInt(select.options[select.selectedIndex].value, 10);

				this._notifyChange(inst);
				this._adjustDate(target);
			},

			/* Action for selecting a day. */
			_selectDay: function _selectDay(id, month, year, td) {
				var inst,
				    target = $(id);

				if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
					return;
				}

				inst = this._getInst(target[0]);
				inst.selectedDay = inst.currentDay = $("a", td).html();
				inst.selectedMonth = inst.currentMonth = month;
				inst.selectedYear = inst.currentYear = year;
				this._selectDate(id, this._formatDate(inst, inst.currentDay, inst.currentMonth, inst.currentYear));
			},

			/* Erase the input field and hide the date picker. */
			_clearDate: function _clearDate(id) {
				var target = $(id);
				this._selectDate(target, "");
			},

			/* Update the input field with the selected date. */
			_selectDate: function _selectDate(id, dateStr) {
				var onSelect,
				    target = $(id),
				    inst = this._getInst(target[0]);

				dateStr = dateStr != null ? dateStr : this._formatDate(inst);
				if (inst.input) {
					inst.input.val(dateStr);
				}
				this._updateAlternate(inst);

				onSelect = this._get(inst, "onSelect");
				if (onSelect) {
					onSelect.apply(inst.input ? inst.input[0] : null, [dateStr, inst]); // trigger custom callback
				} else if (inst.input) {
					inst.input.trigger("change"); // fire the change event
				}

				if (inst.inline) {
					this._updateDatepicker(inst);
				} else {
					this._hideDatepicker();
					this._lastInput = inst.input[0];
					if (_typeof(inst.input[0]) !== "object") {
						inst.input.trigger("focus"); // restore focus
					}
					this._lastInput = null;
				}
			},

			/* Update any alternate field to synchronise with the main field. */
			_updateAlternate: function _updateAlternate(inst) {
				var altFormat,
				    date,
				    dateStr,
				    altField = this._get(inst, "altField");

				if (altField) {
					// update alternate field too
					altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
					date = this._getDate(inst);
					dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
					$(altField).val(dateStr);
				}
			},

			/* Set as beforeShowDay function to prevent selection of weekends.
    * @param  date  Date - the date to customise
    * @return [boolean, string] - is this date selectable?, what is its CSS class?
    */
			noWeekends: function noWeekends(date) {
				var day = date.getDay();
				return [day > 0 && day < 6, ""];
			},

			/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
    * @param  date  Date - the date to get the week for
    * @return  number - the number of the week within the year that contains this date
    */
			iso8601Week: function iso8601Week(date) {
				var time,
				    checkDate = new Date(date.getTime());

				// Find Thursday of this week starting on Monday
				checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

				time = checkDate.getTime();
				checkDate.setMonth(0); // Compare with Jan 1
				checkDate.setDate(1);
				return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
			},

			/* Parse a string value into a date object.
    * See formatDate below for the possible formats.
    *
    * @param  format string - the expected format of the date
    * @param  value string - the date in the above format
    * @param  settings Object - attributes include:
    *					shortYearCutoff  number - the cutoff year for determining the century (optional)
    *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
    *					dayNames		string[7] - names of the days from Sunday (optional)
    *					monthNamesShort string[12] - abbreviated names of the months (optional)
    *					monthNames		string[12] - names of the months (optional)
    * @return  Date - the extracted date value or null if value is blank
    */
			parseDate: function parseDate(format, value, settings) {
				if (format == null || value == null) {
					throw "Invalid arguments";
				}

				value = (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" ? value.toString() : value + "";
				if (value === "") {
					return null;
				}

				var iFormat,
				    dim,
				    extra,
				    iValue = 0,
				    shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
				    shortYearCutoff = typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp : new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10),
				    dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
				    dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
				    monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
				    monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
				    year = -1,
				    month = -1,
				    day = -1,
				    doy = -1,
				    literal = false,
				    date,


				// Check whether a format character is doubled
				lookAhead = function lookAhead(match) {
					var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
					if (matches) {
						iFormat++;
					}
					return matches;
				},


				// Extract a number from the string value
				getNumber = function getNumber(match) {
					var isDoubled = lookAhead(match),
					    size = match === "@" ? 14 : match === "!" ? 20 : match === "y" && isDoubled ? 4 : match === "o" ? 3 : 2,
					    minSize = match === "y" ? size : 1,
					    digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
					    num = value.substring(iValue).match(digits);
					if (!num) {
						throw "Missing number at position " + iValue;
					}
					iValue += num[0].length;
					return parseInt(num[0], 10);
				},


				// Extract a name from the string value and convert to an index
				getName = function getName(match, shortNames, longNames) {
					var index = -1,
					    names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
						return [[k, v]];
					}).sort(function (a, b) {
						return -(a[1].length - b[1].length);
					});

					$.each(names, function (i, pair) {
						var name = pair[1];
						if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
							index = pair[0];
							iValue += name.length;
							return false;
						}
					});
					if (index !== -1) {
						return index + 1;
					} else {
						throw "Unknown name at position " + iValue;
					}
				},


				// Confirm that a literal character matches the string value
				checkLiteral = function checkLiteral() {
					if (value.charAt(iValue) !== format.charAt(iFormat)) {
						throw "Unexpected literal at position " + iValue;
					}
					iValue++;
				};

				for (iFormat = 0; iFormat < format.length; iFormat++) {
					if (literal) {
						if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
							literal = false;
						} else {
							checkLiteral();
						}
					} else {
						switch (format.charAt(iFormat)) {
							case "d":
								day = getNumber("d");
								break;
							case "D":
								getName("D", dayNamesShort, dayNames);
								break;
							case "o":
								doy = getNumber("o");
								break;
							case "m":
								month = getNumber("m");
								break;
							case "M":
								month = getName("M", monthNamesShort, monthNames);
								break;
							case "y":
								year = getNumber("y");
								break;
							case "@":
								date = new Date(getNumber("@"));
								year = date.getFullYear();
								month = date.getMonth() + 1;
								day = date.getDate();
								break;
							case "!":
								date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
								year = date.getFullYear();
								month = date.getMonth() + 1;
								day = date.getDate();
								break;
							case "'":
								if (lookAhead("'")) {
									checkLiteral();
								} else {
									literal = true;
								}
								break;
							default:
								checkLiteral();
						}
					}
				}

				if (iValue < value.length) {
					extra = value.substr(iValue);
					if (!/^\s+/.test(extra)) {
						throw "Extra/unparsed characters found in date: " + extra;
					}
				}

				if (year === -1) {
					year = new Date().getFullYear();
				} else if (year < 100) {
					year += new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100);
				}

				if (doy > -1) {
					month = 1;
					day = doy;
					do {
						dim = this._getDaysInMonth(year, month - 1);
						if (day <= dim) {
							break;
						}
						month++;
						day -= dim;
					} while (true);
				}

				date = this._daylightSavingAdjust(new Date(year, month - 1, day));
				if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
					throw "Invalid date"; // E.g. 31/02/00
				}
				return date;
			},

			/* Standard date formats. */
			ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
			COOKIE: "D, dd M yy",
			ISO_8601: "yy-mm-dd",
			RFC_822: "D, d M y",
			RFC_850: "DD, dd-M-y",
			RFC_1036: "D, d M y",
			RFC_1123: "D, d M yy",
			RFC_2822: "D, d M yy",
			RSS: "D, d M y", // RFC 822
			TICKS: "!",
			TIMESTAMP: "@",
			W3C: "yy-mm-dd", // ISO 8601

			_ticksTo1970: ((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000,

			/* Format a date object into a string value.
    * The format can be combinations of the following:
    * d  - day of month (no leading zero)
    * dd - day of month (two digit)
    * o  - day of year (no leading zeros)
    * oo - day of year (three digit)
    * D  - day name short
    * DD - day name long
    * m  - month of year (no leading zero)
    * mm - month of year (two digit)
    * M  - month name short
    * MM - month name long
    * y  - year (two digit)
    * yy - year (four digit)
    * @ - Unix timestamp (ms since 01/01/1970)
    * ! - Windows ticks (100ns since 01/01/0001)
    * "..." - literal text
    * '' - single quote
    *
    * @param  format string - the desired format of the date
    * @param  date Date - the date value to format
    * @param  settings Object - attributes include:
    *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
    *					dayNames		string[7] - names of the days from Sunday (optional)
    *					monthNamesShort string[12] - abbreviated names of the months (optional)
    *					monthNames		string[12] - names of the months (optional)
    * @return  string - the date in the above format
    */
			formatDate: function formatDate(format, date, settings) {
				if (!date) {
					return "";
				}

				var iFormat,
				    dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
				    dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
				    monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
				    monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,


				// Check whether a format character is doubled
				lookAhead = function lookAhead(match) {
					var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
					if (matches) {
						iFormat++;
					}
					return matches;
				},


				// Format a number, with leading zero if necessary
				formatNumber = function formatNumber(match, value, len) {
					var num = "" + value;
					if (lookAhead(match)) {
						while (num.length < len) {
							num = "0" + num;
						}
					}
					return num;
				},


				// Format a name, short or long as requested
				formatName = function formatName(match, value, shortNames, longNames) {
					return lookAhead(match) ? longNames[value] : shortNames[value];
				},
				    output = "",
				    literal = false;

				if (date) {
					for (iFormat = 0; iFormat < format.length; iFormat++) {
						if (literal) {
							if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
								literal = false;
							} else {
								output += format.charAt(iFormat);
							}
						} else {
							switch (format.charAt(iFormat)) {
								case "d":
									output += formatNumber("d", date.getDate(), 2);
									break;
								case "D":
									output += formatName("D", date.getDay(), dayNamesShort, dayNames);
									break;
								case "o":
									output += formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
									break;
								case "m":
									output += formatNumber("m", date.getMonth() + 1, 2);
									break;
								case "M":
									output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
									break;
								case "y":
									output += lookAhead("y") ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100;
									break;
								case "@":
									output += date.getTime();
									break;
								case "!":
									output += date.getTime() * 10000 + this._ticksTo1970;
									break;
								case "'":
									if (lookAhead("'")) {
										output += "'";
									} else {
										literal = true;
									}
									break;
								default:
									output += format.charAt(iFormat);
							}
						}
					}
				}
				return output;
			},

			/* Extract all possible characters from the date format. */
			_possibleChars: function _possibleChars(format) {
				var iFormat,
				    chars = "",
				    literal = false,


				// Check whether a format character is doubled
				lookAhead = function lookAhead(match) {
					var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
					if (matches) {
						iFormat++;
					}
					return matches;
				};

				for (iFormat = 0; iFormat < format.length; iFormat++) {
					if (literal) {
						if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
							literal = false;
						} else {
							chars += format.charAt(iFormat);
						}
					} else {
						switch (format.charAt(iFormat)) {
							case "d":case "m":case "y":case "@":
								chars += "0123456789";
								break;
							case "D":case "M":
								return null; // Accept anything
							case "'":
								if (lookAhead("'")) {
									chars += "'";
								} else {
									literal = true;
								}
								break;
							default:
								chars += format.charAt(iFormat);
						}
					}
				}
				return chars;
			},

			/* Get a setting value, defaulting if necessary. */
			_get: function _get(inst, name) {
				return inst.settings[name] !== undefined ? inst.settings[name] : this._defaults[name];
			},

			/* Parse existing date and initialise date picker. */
			_setDateFromField: function _setDateFromField(inst, noDefault) {
				if (inst.input.val() === inst.lastVal) {
					return;
				}

				var dateFormat = this._get(inst, "dateFormat"),
				    dates = inst.lastVal = inst.input ? inst.input.val() : null,
				    defaultDate = this._getDefaultDate(inst),
				    date = defaultDate,
				    settings = this._getFormatConfig(inst);

				try {
					date = this.parseDate(dateFormat, dates, settings) || defaultDate;
				} catch (event) {
					dates = noDefault ? "" : dates;
				}
				inst.selectedDay = date.getDate();
				inst.drawMonth = inst.selectedMonth = date.getMonth();
				inst.drawYear = inst.selectedYear = date.getFullYear();
				inst.currentDay = dates ? date.getDate() : 0;
				inst.currentMonth = dates ? date.getMonth() : 0;
				inst.currentYear = dates ? date.getFullYear() : 0;
				this._adjustInstDate(inst);
			},

			/* Retrieve the default date shown on opening. */
			_getDefaultDate: function _getDefaultDate(inst) {
				return this._restrictMinMax(inst, this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
			},

			/* A date may be specified as an exact value or a relative one. */
			_determineDate: function _determineDate(inst, date, defaultDate) {
				var offsetNumeric = function offsetNumeric(offset) {
					var date = new Date();
					date.setDate(date.getDate() + offset);
					return date;
				},
				    offsetString = function offsetString(offset) {
					try {
						return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"), offset, $.datepicker._getFormatConfig(inst));
					} catch (e) {

						// Ignore
					}

					var date = (offset.toLowerCase().match(/^c/) ? $.datepicker._getDate(inst) : null) || new Date(),
					    year = date.getFullYear(),
					    month = date.getMonth(),
					    day = date.getDate(),
					    pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					    matches = pattern.exec(offset);

					while (matches) {
						switch (matches[2] || "d") {
							case "d":case "D":
								day += parseInt(matches[1], 10);break;
							case "w":case "W":
								day += parseInt(matches[1], 10) * 7;break;
							case "m":case "M":
								month += parseInt(matches[1], 10);
								day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
								break;
							case "y":case "Y":
								year += parseInt(matches[1], 10);
								day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
								break;
						}
						matches = pattern.exec(offset);
					}
					return new Date(year, month, day);
				},
				    newDate = date == null || date === "" ? defaultDate : typeof date === "string" ? offsetString(date) : typeof date === "number" ? isNaN(date) ? defaultDate : offsetNumeric(date) : new Date(date.getTime());

				newDate = newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate;
				if (newDate) {
					newDate.setHours(0);
					newDate.setMinutes(0);
					newDate.setSeconds(0);
					newDate.setMilliseconds(0);
				}
				return this._daylightSavingAdjust(newDate);
			},

			/* Handle switch to/from daylight saving.
    * Hours may be non-zero on daylight saving cut-over:
    * > 12 when midnight changeover, but then cannot generate
    * midnight datetime, so jump to 1AM, otherwise reset.
    * @param  date  (Date) the date to check
    * @return  (Date) the corrected date
    */
			_daylightSavingAdjust: function _daylightSavingAdjust(date) {
				if (!date) {
					return null;
				}
				date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
				return date;
			},

			/* Set the date(s) directly. */
			_setDate: function _setDate(inst, date, noChange) {
				var clear = !date,
				    origMonth = inst.selectedMonth,
				    origYear = inst.selectedYear,
				    newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));

				inst.selectedDay = inst.currentDay = newDate.getDate();
				inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
				inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
				if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
					this._notifyChange(inst);
				}
				this._adjustInstDate(inst);
				if (inst.input) {
					inst.input.val(clear ? "" : this._formatDate(inst));
				}
			},

			/* Retrieve the date(s) directly. */
			_getDate: function _getDate(inst) {
				var startDate = !inst.currentYear || inst.input && inst.input.val() === "" ? null : this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
				return startDate;
			},

			/* Attach the onxxx handlers.  These are declared statically so
    * they work with static code transformers like Caja.
    */
			_attachHandlers: function _attachHandlers(inst) {
				var stepMonths = this._get(inst, "stepMonths"),
				    id = "#" + inst.id.replace(/\\\\/g, "\\");
				inst.dpDiv.find("[data-handler]").map(function () {
					var handler = {
						prev: function prev() {
							$.datepicker._adjustDate(id, -stepMonths, "M");
						},
						next: function next() {
							$.datepicker._adjustDate(id, +stepMonths, "M");
						},
						hide: function hide() {
							$.datepicker._hideDatepicker();
						},
						today: function today() {
							$.datepicker._gotoToday(id);
						},
						selectDay: function selectDay() {
							$.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
							return false;
						},
						selectMonth: function selectMonth() {
							$.datepicker._selectMonthYear(id, this, "M");
							return false;
						},
						selectYear: function selectYear() {
							$.datepicker._selectMonthYear(id, this, "Y");
							return false;
						}
					};
					$(this).on(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
				});
			},

			/* Generate the HTML for the current state of the date picker. */
			_generateHTML: function _generateHTML(inst) {
				var maxDraw,
				    prevText,
				    prev,
				    nextText,
				    next,
				    currentText,
				    gotoDate,
				    controls,
				    buttonPanel,
				    firstDay,
				    showWeek,
				    dayNames,
				    dayNamesMin,
				    monthNames,
				    monthNamesShort,
				    beforeShowDay,
				    showOtherMonths,
				    selectOtherMonths,
				    defaultDate,
				    html,
				    dow,
				    row,
				    group,
				    col,
				    selectedDate,
				    cornerClass,
				    calender,
				    thead,
				    day,
				    daysInMonth,
				    leadDays,
				    curRows,
				    numRows,
				    printDate,
				    dRow,
				    tbody,
				    daySettings,
				    otherMonth,
				    unselectable,
				    tempDate = new Date(),
				    today = this._daylightSavingAdjust(new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())),

				// clear time
				isRTL = this._get(inst, "isRTL"),
				    showButtonPanel = this._get(inst, "showButtonPanel"),
				    hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
				    navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
				    numMonths = this._getNumberOfMonths(inst),
				    showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
				    stepMonths = this._get(inst, "stepMonths"),
				    isMultiMonth = numMonths[0] !== 1 || numMonths[1] !== 1,
				    currentDate = this._daylightSavingAdjust(!inst.currentDay ? new Date(9999, 9, 9) : new Date(inst.currentYear, inst.currentMonth, inst.currentDay)),
				    minDate = this._getMinMaxDate(inst, "min"),
				    maxDate = this._getMinMaxDate(inst, "max"),
				    drawMonth = inst.drawMonth - showCurrentAtPos,
				    drawYear = inst.drawYear;

				if (drawMonth < 0) {
					drawMonth += 12;
					drawYear--;
				}
				if (maxDate) {
					maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(), maxDate.getMonth() - numMonths[0] * numMonths[1] + 1, maxDate.getDate()));
					maxDraw = minDate && maxDraw < minDate ? minDate : maxDraw;
					while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
						drawMonth--;
						if (drawMonth < 0) {
							drawMonth = 11;
							drawYear--;
						}
					}
				}
				inst.drawMonth = drawMonth;
				inst.drawYear = drawYear;

				prevText = this._get(inst, "prevText");
				prevText = !navigationAsDateFormat ? prevText : this.formatDate(prevText, this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)), this._getFormatConfig(inst));

				prev = this._canAdjustMonth(inst, -1, drawYear, drawMonth) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" + " title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" : hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "e" : "w") + "'>" + prevText + "</span></a>";

				nextText = this._get(inst, "nextText");
				nextText = !navigationAsDateFormat ? nextText : this.formatDate(nextText, this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)), this._getFormatConfig(inst));

				next = this._canAdjustMonth(inst, +1, drawYear, drawMonth) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" + " title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" : hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + (isRTL ? "w" : "e") + "'>" + nextText + "</span></a>";

				currentText = this._get(inst, "currentText");
				gotoDate = this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today;
				currentText = !navigationAsDateFormat ? currentText : this.formatDate(currentText, gotoDate, this._getFormatConfig(inst));

				controls = !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(inst, "closeText") + "</button>" : "";

				buttonPanel = showButtonPanel ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") + (this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" + ">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";

				firstDay = parseInt(this._get(inst, "firstDay"), 10);
				firstDay = isNaN(firstDay) ? 0 : firstDay;

				showWeek = this._get(inst, "showWeek");
				dayNames = this._get(inst, "dayNames");
				dayNamesMin = this._get(inst, "dayNamesMin");
				monthNames = this._get(inst, "monthNames");
				monthNamesShort = this._get(inst, "monthNamesShort");
				beforeShowDay = this._get(inst, "beforeShowDay");
				showOtherMonths = this._get(inst, "showOtherMonths");
				selectOtherMonths = this._get(inst, "selectOtherMonths");
				defaultDate = this._getDefaultDate(inst);
				html = "";

				for (row = 0; row < numMonths[0]; row++) {
					group = "";
					this.maxRows = 4;
					for (col = 0; col < numMonths[1]; col++) {
						selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
						cornerClass = " ui-corner-all";
						calender = "";
						if (isMultiMonth) {
							calender += "<div class='ui-datepicker-group";
							if (numMonths[1] > 1) {
								switch (col) {
									case 0:
										calender += " ui-datepicker-group-first";
										cornerClass = " ui-corner-" + (isRTL ? "right" : "left");break;
									case numMonths[1] - 1:
										calender += " ui-datepicker-group-last";
										cornerClass = " ui-corner-" + (isRTL ? "left" : "right");break;
									default:
										calender += " ui-datepicker-group-middle";cornerClass = "";break;
								}
							}
							calender += "'>";
						}
						calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" + (/all|left/.test(cornerClass) && row === 0 ? isRTL ? next : prev : "") + (/all|right/.test(cornerClass) && row === 0 ? isRTL ? prev : next : "") + this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate, row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
						"</div><table class='ui-datepicker-calendar'><thead>" + "<tr>";
						thead = showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "";
						for (dow = 0; dow < 7; dow++) {
							// days of the week
							day = (dow + firstDay) % 7;
							thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
						}
						calender += thead + "</tr></thead><tbody>";
						daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
						if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
							inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
						}
						leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
						curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
						numRows = isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows; //If multiple months, use the higher number of rows (see #7043)
						this.maxRows = numRows;
						printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
						for (dRow = 0; dRow < numRows; dRow++) {
							// create date picker rows
							calender += "<tr>";
							tbody = !showWeek ? "" : "<td class='ui-datepicker-week-col'>" + this._get(inst, "calculateWeek")(printDate) + "</td>";
							for (dow = 0; dow < 7; dow++) {
								// create date picker days
								daySettings = beforeShowDay ? beforeShowDay.apply(inst.input ? inst.input[0] : null, [printDate]) : [true, ""];
								otherMonth = printDate.getMonth() !== drawMonth;
								unselectable = otherMonth && !selectOtherMonths || !daySettings[0] || minDate && printDate < minDate || maxDate && printDate > maxDate;
								tbody += "<td class='" + ((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + ( // highlight weekends
								otherMonth ? " ui-datepicker-other-month" : "") + ( // highlight days from other months
								printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent || // user pressed key
								defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ?

								// or defaultDate is current printedDate and defaultDate is selectedDate
								" " + this._dayOverClass : "") + ( // highlight selected day
								unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "") + ( // highlight unselectable days
								otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + ( // highlight custom dates
								printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + ( // highlight selected day
								printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + ( // highlight today (if different)
								(!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + ( // cell title
								unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + ( // actions
								otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
								unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" + (printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") + (printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + ( // highlight selected day
								otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
								"' href='#'>" + printDate.getDate() + "</a>") + "</td>"; // display selectable date
								printDate.setDate(printDate.getDate() + 1);
								printDate = this._daylightSavingAdjust(printDate);
							}
							calender += tbody + "</tr>";
						}
						drawMonth++;
						if (drawMonth > 11) {
							drawMonth = 0;
							drawYear++;
						}
						calender += "</tbody></table>" + (isMultiMonth ? "</div>" + (numMonths[0] > 0 && col === numMonths[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
						group += calender;
					}
					html += group;
				}
				html += buttonPanel;
				inst._keyEvent = false;
				return html;
			},

			/* Generate the month and year header. */
			_generateMonthYearHeader: function _generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate, secondary, monthNames, monthNamesShort) {

				var inMinYear,
				    inMaxYear,
				    month,
				    years,
				    thisYear,
				    determineYear,
				    year,
				    endYear,
				    changeMonth = this._get(inst, "changeMonth"),
				    changeYear = this._get(inst, "changeYear"),
				    showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
				    html = "<div class='ui-datepicker-title'>",
				    monthHtml = "";

				// Month selection
				if (secondary || !changeMonth) {
					monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
				} else {
					inMinYear = minDate && minDate.getFullYear() === drawYear;
					inMaxYear = maxDate && maxDate.getFullYear() === drawYear;
					monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
					for (month = 0; month < 12; month++) {
						if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
							monthHtml += "<option value='" + month + "'" + (month === drawMonth ? " selected='selected'" : "") + ">" + monthNamesShort[month] + "</option>";
						}
					}
					monthHtml += "</select>";
				}

				if (!showMonthAfterYear) {
					html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
				}

				// Year selection
				if (!inst.yearshtml) {
					inst.yearshtml = "";
					if (secondary || !changeYear) {
						html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
					} else {

						// determine range of years to display
						years = this._get(inst, "yearRange").split(":");
						thisYear = new Date().getFullYear();
						determineYear = function determineYear(value) {
							var year = value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) : value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) : parseInt(value, 10);
							return isNaN(year) ? thisYear : year;
						};
						year = determineYear(years[0]);
						endYear = Math.max(year, determineYear(years[1] || ""));
						year = minDate ? Math.max(year, minDate.getFullYear()) : year;
						endYear = maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear;
						inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
						for (; year <= endYear; year++) {
							inst.yearshtml += "<option value='" + year + "'" + (year === drawYear ? " selected='selected'" : "") + ">" + year + "</option>";
						}
						inst.yearshtml += "</select>";

						html += inst.yearshtml;
						inst.yearshtml = null;
					}
				}

				html += this._get(inst, "yearSuffix");
				if (showMonthAfterYear) {
					html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
				}
				html += "</div>"; // Close datepicker_header
				return html;
			},

			/* Adjust one of the date sub-fields. */
			_adjustInstDate: function _adjustInstDate(inst, offset, period) {
				var year = inst.selectedYear + (period === "Y" ? offset : 0),
				    month = inst.selectedMonth + (period === "M" ? offset : 0),
				    day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
				    date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));

				inst.selectedDay = date.getDate();
				inst.drawMonth = inst.selectedMonth = date.getMonth();
				inst.drawYear = inst.selectedYear = date.getFullYear();
				if (period === "M" || period === "Y") {
					this._notifyChange(inst);
				}
			},

			/* Ensure a date is within any min/max bounds. */
			_restrictMinMax: function _restrictMinMax(inst, date) {
				var minDate = this._getMinMaxDate(inst, "min"),
				    maxDate = this._getMinMaxDate(inst, "max"),
				    newDate = minDate && date < minDate ? minDate : date;
				return maxDate && newDate > maxDate ? maxDate : newDate;
			},

			/* Notify change of month/year. */
			_notifyChange: function _notifyChange(inst) {
				var onChange = this._get(inst, "onChangeMonthYear");
				if (onChange) {
					onChange.apply(inst.input ? inst.input[0] : null, [inst.selectedYear, inst.selectedMonth + 1, inst]);
				}
			},

			/* Determine the number of months to show. */
			_getNumberOfMonths: function _getNumberOfMonths(inst) {
				var numMonths = this._get(inst, "numberOfMonths");
				return numMonths == null ? [1, 1] : typeof numMonths === "number" ? [1, numMonths] : numMonths;
			},

			/* Determine the current maximum date - ensure no time components are set. */
			_getMinMaxDate: function _getMinMaxDate(inst, minMax) {
				return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
			},

			/* Find the number of days in a given month. */
			_getDaysInMonth: function _getDaysInMonth(year, month) {
				return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
			},

			/* Find the day of the week of the first of a month. */
			_getFirstDayOfMonth: function _getFirstDayOfMonth(year, month) {
				return new Date(year, month, 1).getDay();
			},

			/* Determines if we should allow a "next/prev" month display change. */
			_canAdjustMonth: function _canAdjustMonth(inst, offset, curYear, curMonth) {
				var numMonths = this._getNumberOfMonths(inst),
				    date = this._daylightSavingAdjust(new Date(curYear, curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));

				if (offset < 0) {
					date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
				}
				return this._isInRange(inst, date);
			},

			/* Is the given date in the accepted range? */
			_isInRange: function _isInRange(inst, date) {
				var yearSplit,
				    currentYear,
				    minDate = this._getMinMaxDate(inst, "min"),
				    maxDate = this._getMinMaxDate(inst, "max"),
				    minYear = null,
				    maxYear = null,
				    years = this._get(inst, "yearRange");
				if (years) {
					yearSplit = years.split(":");
					currentYear = new Date().getFullYear();
					minYear = parseInt(yearSplit[0], 10);
					maxYear = parseInt(yearSplit[1], 10);
					if (yearSplit[0].match(/[+\-].*/)) {
						minYear += currentYear;
					}
					if (yearSplit[1].match(/[+\-].*/)) {
						maxYear += currentYear;
					}
				}

				return (!minDate || date.getTime() >= minDate.getTime()) && (!maxDate || date.getTime() <= maxDate.getTime()) && (!minYear || date.getFullYear() >= minYear) && (!maxYear || date.getFullYear() <= maxYear);
			},

			/* Provide the configuration settings for formatting/parsing. */
			_getFormatConfig: function _getFormatConfig(inst) {
				var shortYearCutoff = this._get(inst, "shortYearCutoff");
				shortYearCutoff = typeof shortYearCutoff !== "string" ? shortYearCutoff : new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10);
				return { shortYearCutoff: shortYearCutoff,
					dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
					monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames") };
			},

			/* Format the given date for display. */
			_formatDate: function _formatDate(inst, day, month, year) {
				if (!day) {
					inst.currentDay = inst.selectedDay;
					inst.currentMonth = inst.selectedMonth;
					inst.currentYear = inst.selectedYear;
				}
				var date = day ? (typeof day === "undefined" ? "undefined" : _typeof(day)) === "object" ? day : this._daylightSavingAdjust(new Date(year, month, day)) : this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
				return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
			}
		});

		/*
   * Bind hover events for datepicker elements.
   * Done via delegate so the binding only occurs once in the lifetime of the parent div.
   * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
   */
		function datepicker_bindHover(dpDiv) {
			var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
			return dpDiv.on("mouseout", selector, function () {
				$(this).removeClass("ui-state-hover");
				if (this.className.indexOf("ui-datepicker-prev") !== -1) {
					$(this).removeClass("ui-datepicker-prev-hover");
				}
				if (this.className.indexOf("ui-datepicker-next") !== -1) {
					$(this).removeClass("ui-datepicker-next-hover");
				}
			}).on("mouseover", selector, datepicker_handleMouseover);
		}

		function datepicker_handleMouseover() {
			if (!$.datepicker._isDisabledDatepicker(datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
				$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
				$(this).addClass("ui-state-hover");
				if (this.className.indexOf("ui-datepicker-prev") !== -1) {
					$(this).addClass("ui-datepicker-prev-hover");
				}
				if (this.className.indexOf("ui-datepicker-next") !== -1) {
					$(this).addClass("ui-datepicker-next-hover");
				}
			}
		}

		/* jQuery extend now ignores nulls! */
		function datepicker_extendRemove(target, props) {
			$.extend(target, props);
			for (var name in props) {
				if (props[name] == null) {
					target[name] = props[name];
				}
			}
			return target;
		}

		/* Invoke the datepicker functionality.
     @param  options  string - a command, optionally followed by additional parameters or
  					Object - settings for attaching new datepicker functionality
     @return  jQuery object */
		$.fn.datepicker = function (options) {

			/* Verify an empty collection wasn't passed - Fixes #6976 */
			if (!this.length) {
				return this;
			}

			/* Initialise the date picker. */
			if (!$.datepicker.initialized) {
				$(document).on("mousedown", $.datepicker._checkExternalClick);
				$.datepicker.initialized = true;
			}

			/* Append datepicker main container to body if not exist. */
			if ($("#" + $.datepicker._mainDivId).length === 0) {
				$("body").append($.datepicker.dpDiv);
			}

			var otherArgs = Array.prototype.slice.call(arguments, 1);
			if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
				return $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [this[0]].concat(otherArgs));
			}
			if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
				return $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [this[0]].concat(otherArgs));
			}
			return this.each(function () {
				typeof options === "string" ? $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [this].concat(otherArgs)) : $.datepicker._attachDatepicker(this, options);
			});
		};

		$.datepicker = new Datepicker(); // singleton instance
		$.datepicker.initialized = false;
		$.datepicker.uuid = new Date().getTime();
		$.datepicker.version = "1.12.1";

		var widgetsDatepicker = $.datepicker;
	});

	/***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
		return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
		return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	};

	/*! modernizr 3.5.0 (Custom Build) | MIT *
  * https://modernizr.com/download/?-inputtypes-setclasses !*/
	!function (e, t, n) {
		function a(e, t) {
			return (typeof e === "undefined" ? "undefined" : _typeof(e)) === t;
		}function s() {
			var e, t, n, s, i, o, c;for (var u in r) {
				if (r.hasOwnProperty(u)) {
					if (e = [], t = r[u], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) {
						e.push(t.options.aliases[n].toLowerCase());
					}for (s = a(t.fn, "function") ? t.fn() : t.fn, i = 0; i < e.length; i++) {
						o = e[i], c = o.split("."), 1 === c.length ? Modernizr[c[0]] = s : (!Modernizr[c[0]] || Modernizr[c[0]] instanceof Boolean || (Modernizr[c[0]] = new Boolean(Modernizr[c[0]])), Modernizr[c[0]][c[1]] = s), l.push((s ? "" : "no-") + c.join("-"));
					}
				}
			}
		}function i(e) {
			var t = u.className,
			    n = Modernizr._config.classPrefix || "";if (f && (t = t.baseVal), Modernizr._config.enableJSClass) {
				var a = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");t = t.replace(a, "$1" + n + "js$2");
			}Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), f ? u.className.baseVal = t : u.className = t);
		}function o() {
			return "function" != typeof t.createElement ? t.createElement(arguments[0]) : f ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
		}var l = [],
		    r = [],
		    c = { _version: "3.5.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {
				var n = this;setTimeout(function () {
					t(n[e]);
				}, 0);
			}, addTest: function addTest(e, t, n) {
				r.push({ name: e, fn: t, options: n });
			}, addAsyncTest: function addAsyncTest(e) {
				r.push({ name: null, fn: e });
			} },
		    Modernizr = function Modernizr() {};Modernizr.prototype = c, Modernizr = new Modernizr();var u = t.documentElement,
		    f = "svg" === u.nodeName.toLowerCase(),
		    p = o("input"),
		    d = "search tel url email datetime date month week time datetime-local number range color".split(" "),
		    m = {};Modernizr.inputtypes = function (e) {
			for (var a, s, i, o = e.length, l = "1)", r = 0; o > r; r++) {
				p.setAttribute("type", a = e[r]), i = "text" !== p.type && "style" in p, i && (p.value = l, p.style.cssText = "position:absolute;visibility:hidden;", /^range$/.test(a) && p.style.WebkitAppearance !== n ? (u.appendChild(p), s = t.defaultView, i = s.getComputedStyle && "textfield" !== s.getComputedStyle(p, null).WebkitAppearance && 0 !== p.offsetHeight, u.removeChild(p)) : /^(search|tel)$/.test(a) || (i = /^(url|email)$/.test(a) ? p.checkValidity && p.checkValidity() === !1 : p.value != l)), m[e[r]] = !!i;
			}return m;
		}(d), s(), i(l), delete c.addTest, delete c.addAsyncTest;for (var h = 0; h < Modernizr._q.length; h++) {
			Modernizr._q[h]();
		}e.Modernizr = Modernizr;
	}(window, document);

	/***/
},
/* 5 */
/***/function (module, exports) {

	module.exports = {
		"ecInput": {
			"labels": {
				"ariaText": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				},
				"checkboxText": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				},
				"invalidDate": {
					"en": "Invalid Date!",
					"en-GB": null,
					"it": "La data non è valida!",
					"sv": "Ogiltigt datum",
					"sv-SE": null
				},
				"placeholder": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				},
				"placeholderTextSingle": {
					"da-DK": "Indtast et emne",
					"en": "Enter an item",
					"fr": "Entrer un élément",
					"it": "Inserisci una voce",
					"sv": "Skriv in ett värde",
					"zh-CN": "输入项目",
					"zh-HK": "輸入項目"
				},
				"selectboxText": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				},
				"switchText": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				}
			},
			"settings": {
				"_model": {
					"listItems": null
				},
				"_parameters": {
					"autocomplete": null,
					"autofocus": null,
					"cols": null,
					"disabled": null,
					"form": null,
					"horizontal": null,
					"inputType": null,
					"name": null,
					"nameField": null,
					"readonly": null,
					"rows": null,
					"size": null,
					"wrap": null
				},
				"_templates": {
					"checkbox": "<div class=\"ec-form__checkbox\">\r\n    <label class=\"ec-form__label ec-form__label--checkbox\">\r\n        <input type=\"checkbox\"\r\n           data-ng-disabled=\"ngDisabled || parameters.disabled\"\r\n           data-ng-attr-name=\"{{ parameters.name || undefined }}\"\r\n           data-ng-model=\"ngModel\"\r\n           class=\"ec-form__input ec-form__input--checkbox\"\r\n           id=\"{{namespaceId('checkbox')}}\" />\r\n        <span class=\"ec-form__checkbox-text\">\r\n            {{ label || labels.get(\"checkboxText\") }}\r\n        </span>\r\n    </label>\r\n</div>\r\n",
					"checkboxGroup": "<fieldset data-ng-disabled=\"parameters.disabled\"\r\n          class=\"ec-form__fieldset ec-form__fieldset--checkbox\"\r\n          data-ng-class=\"{'ec-form__fieldset--horizontal': {{ ::settings.get('horizontal') }}}\" role=\"group\">\r\n    <legend data-ng-if=\"labels.contains('fieldsetLegend')\" class=\"ec-form__legend\">\r\n        <span>{{ ::labels.get('fieldsetLegend') }}</span>\r\n    </legend>\r\n    <div data-ng-repeat=\"listItem in model.listItems track by $index\" class=\"{{ ::namespaceClass('__checkbox') }}\">\r\n        <label class=\"{{ ::namespaceClass('__checkbox-labels') }}\">\r\n            <input type=\"checkbox\"\r\n               data-ng-model=\"checkboxStatus[listItem[settings.get('keyField')]]\"\r\n               data-ng-change=\"checkboxChange()\"\r\n               data-ng-true-value=\"'{{ ::listItem[settings.get('keyField')] }}'\"\r\n               data-ng-false-value=\"null\"\r\n               class=\"{{ ::namespaceClass('__checkbox-input') }}\"\r\n               name=\"{{ ::namespaceId('buttonName') }}\"\r\n               value=\"{{listItem[settings.get('keyField')]}}\" >\r\n               <span class=\"{{ ::namespaceClass('__checkbox-text') }}\">{{ labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]}}</span>\r\n               <span class=\"{{ ::namespaceClass('__checkbox-microcopy') }}\">{{ labels.contains(listItem[settings.get('microValueField')]) ? labels.get(listItem[settings.get('microValueField')]) : listItem[settings.get('microValueField')]}}</span>\r\n        </label>\r\n    </div>\r\n</fieldset>\r\n",
					"date": "<input\r\n    type=\"{{parameters.inputType}}\"\r\n    data-ng-disabled=\"parameters.disabled\"\r\n    data-ng-attr-name=\"{{ parameters.name || undefined }}\"\r\n    data-ng-readonly=\"ngReadonly || parameters.readonly || undefined\"\r\n    data-ng-attr-autofocus=\"{{ parameters.autofocus || undefined }}\"\r\n    data-mstar-validate\r\n    data-ng-model=\"ngModel\"\r\n    class=\"ec-form__input ec-form__input--date\"\r\n    data-ng-attr-aria-label=\"{{ labels.contains('ariaText') ? labels.get('ariaText') : undefined }}\"\r\n    id=\"{{namespaceId('date')}}\" />\r\n",
					"datepicker": "<input\r\n    type=\"date\"\r\n    data-ng-disabled=\"parameters.disabled\"\r\n    data-ng-attr-name=\"{{ parameters.name || undefined }}\"\r\n    data-ng-attr-placeholder=\"{{ dateFormat }}\"\r\n    data-ng-readonly=\"ngReadonly || parameters.readonly || undefined\"\r\n    data-ng-attr-autofocus=\"{{ parameters.autofocus || undefined }}\"\r\n    class=\"ec-form__input ec-form__input--date\"\r\n    aria-label=\"{{ labels.contains('ariaText') ? labels.get('ariaText') : dateFormat }}\"\r\n    id=\"{{ namespaceId('date') }}\" />\r\n<input\r\n    type=\"hidden\"\r\n    data-ng-model=\"ngModel\"\r\n    data-mstar-validate\r\n    mstar-tooltip\r\n    id=\"actual-date\"/>\r\n<div id=\"invalid-date\" class=\"{{ ::namespaceClass('__error-message') }}\">{{ invalidDateMessage }}</div>\r\n",
					"main": null,
					"number": "<input type=\"{{::numberInputType}}\"\r\n    data-ng-disabled=\"parameters.disabled\"\r\n    data-ng-attr-name=\"{{ :: parameters.name || undefined }}\"\r\n    data-ng-attr-placeholder=\"{{ :: labels.contains('placeholder') ? labels.get('placeholder') : undefined }}\"\r\n    data-ng-readonly=\"ngReadonly || parameters.readonly || undefined\"\r\n    data-ng-attr-autofocus=\"{{ :: parameters.autofocus || undefined }}\"\r\n    data-mstar-validate\r\n    data-ng-model=\"ngModel\"\r\n    data-ng-attr-aria-label=\"{{ :: labels.contains('ariaText') ? labels.get('ariaText') : undefined }}\"\r\n    data-ng-attr-step=\"{{ :: numberInputType === 'number' ? 'any' : undefined}}\"\r\n    data-ng-attr-pattern=\"{{::numberInputPattern}}\"\r\n    class=\"ec-form__input ec-form__input--number\"\r\n    id=\"{{namespaceId('number')}}\" />\r\n",
					"radioGroup": "<fieldset data-ng-disabled=\"parameters.disabled\"\r\n          class=\"ec-form__fieldset ec-form__fieldset--radio\"\r\n          data-ng-class=\"{'ec-form__fieldset--horizontal': parameters.horizontal,\r\n          '{{ ::namespaceClass('--radio-disabled') }}': parameters.disabled}\">\r\n    <legend data-ng-if=\"labels.contains('fieldsetLegend')\" class=\"ec-form__legend\">\r\n        <span>{{ ::labels.get('fieldsetLegend') }}</span>\r\n    </legend>\r\n    <div data-ng-repeat=\"listItem in model.listItems track by $index\" class=\"{{ ::namespaceClass('__radio') }}\">\r\n        <label class=\"{{ ::namespaceClass('__radio-labels') }}\">\r\n            <input type=\"radio\"\r\n               data-ng-model=\"$parent.ngModel\"\r\n               data-ng-change=\"onRadioChange()\"\r\n               class=\"{{ ::namespaceClass('__radio-button-input') }}\"\r\n               id=\"{{ ::namespaceId('-') + listItem[settings.get('keyField')] }}\"\r\n               name=\"{{ ::namespaceClass('__') + parameters.nameField }}\"\r\n               value=\"{{listItem[settings.get('keyField')]}}\" >\r\n               <span class=\"{{ ::namespaceClass('__radio-button-text') }}\">\r\n                  {{ labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]}}\r\n                </span>\r\n        </label>\r\n    </div>\r\n</fieldset>\r\n",
					"select": "<div class=\"{{ ::namespaceClass('__select') }}\"\r\n    data-ng-class=\"{'{{ ::namespaceClass('--disabled') }}': parameters.disabled}\">\r\n    <select\r\n    \tdata-ng-if=\"!settings.get('keyFieldInModel')\"\r\n    \tdata-ng-model=\"$parent.ngModel\"\r\n        data-ng-disabled=\"parameters.disabled\"\r\n        data-ng-attr-aria-label=\"{{ :: labels.contains('ariaText') ? labels.get('ariaText') : undefined }}\"\r\n        class=\"{{ ::namespaceClass('__select-box') }}\"\r\n        data-ng-options=\"listItem as labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')] for listItem in model['listItems'] track by listItem[settings.get('keyField')]\"\r\n        id=\"{{ ::namespaceId('select') }}\">\r\n        <option value=\"\" data-ng-if=\"::labels.get('selectboxText') !== 'selectboxText'\" >{{::labels.get('selectboxText')}}</option>\r\n    </select>\r\n    <select\r\n    \tdata-ng-if=\"settings.get('keyFieldInModel')\"\r\n    \tdata-ng-model=\"$parent.ngModel\"\r\n        data-ng-disabled=\"parameters.disabled\"\r\n        data-ng-attr-aria-label=\"{{ :: labels.contains('ariaText') ? labels.get('ariaText') : undefined }}\"\r\n        class=\"{{ ::namespaceClass('__select-box') }}\"\r\n        id=\"{{ ::namespaceId('select') }}\">\r\n        <option value=\"\" data-ng-if=\"::labels.get('selectboxText') !== 'selectboxText'\" >{{::labels.get('selectboxText')}}</option>\r\n        <option data-ng-repeat=\"listItem in model['listItems']\" value=\"{{listItem[settings.get('keyField')]}}\">{{ labels.contains(listItem[settings.get('valueField')]) ? labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]}}</option>\r\n    </select>\r\n    <i class=\"{{ ::namespaceClass('__select-arrow') }}\"></i>\r\n</div>\r\n",
					"switchToggle": "<div data-ng-disabled=\"parameters.disabled\" class=\"ec-form__switch\">\r\n    <input type=\"checkbox\"\r\n           name=\"{{namespaceId('switch')}}\"\r\n           data-ng-model=\"ngModel\"\r\n           class=\"ec-form__input ec-form__input--switch\"\r\n           id=\"{{namespaceId('switch')}}\" />\r\n    <label class=\"ec-form__label ec-form__label--switch\" for=\"{{namespaceId('switch')}}\">\r\n        {{ labels.get(\"switchText\") }}\r\n    </label>\r\n</div>\r\n",
					"text": "<input\r\n    type=\"{{ :: parameters.inputType}}\"\r\n    data-ng-disabled=\"parameters.disabled\"\r\n    data-ng-attr-name=\"{{ :: parameters.name || name || undefined }}\"\r\n    data-ng-attr-placeholder=\"{{ :: labels.contains('placeholder') ? labels.get('placeholder') : undefined }}\"\r\n    data-ng-attr-autocomplete=\"{{ :: (!parameters.name && !name) ? undefined : parameters.autocomplete || undefined }}\"\r\n    data-ng-attr-size=\"{{ :: parameters.size || undefined }}\"\r\n    data-ng-readonly=\"ngReadonly || parameters.readonly || undefined\"\r\n    data-ng-attr-autofocus=\"{{ :: parameters.autofocus || undefined }}\"\r\n    data-ng-class=\"{'ec-form__input--disabled': parameters.disabled}\"\r\n    data-mstar-validate\r\n    data-ng-model=\"ngModel\"\r\n    data-ng-attr-role=\"{{ :: role ? role : undefined }}\"\r\n    data-ng-attr-aria-label=\"{{ :: ariaLabel ? ariaLabel : labels.contains('ariaText') ? labels.get('ariaText') : undefined }}\"\r\n    data-ng-attr-aria-autocomplete=\"{{ :: ariaAutocomplete ? ariaAutocomplete : undefined }}\"\r\n    data-ng-attr-aria-owns=\"{{ :: ariaOwns ? ariaOwns : undefined }}\"\r\n    data-ng-attr-aria-describedby=\"{{ :: ariaDescribedby ? ariaDescribedby : undefined }}\"\r\n    class=\"ec-form__input ec-form__input--textbox\"\r\n    id=\"{{namespaceId('textbox')}}\" />\r\n",
					"textarea": "<textarea\r\n    data-ng-attr-placeholder=\"{{ labels.contains('placeholder') ? labels.get('placeholder') : undefined }}\"\r\n    data-ng-attr-autocomplete=\"{{ autocomplete || undefined }}\"\r\n    data-ng-disabled=\"parameters.disabled\"\r\n    data-ng-attr-name=\"{{ parameters.name || undefined }}\"\r\n    data-ng-attr-cols=\"{{ parameters.cols || undefined }}\"\r\n    data-ng-attr-rows=\"{{ parameters.rows || undefined }}\"\r\n    data-ng-readonly=\"ngReadonly || parameters.readonly || undefined\"\r\n    data-ng-attr-autofocus=\"{{ parameters.autofocus || undefined }}\"\r\n    data-mstar-validate\r\n    data-ng-model=\"ngModel\"\r\n    data-ng-attr-aria-label=\"{{ :: labels.contains('ariaText') ? labels.get('ariaText') : undefined }}\"\r\n    class=\"ec-form__input ec-form__input--textarea\"\r\n    id=\"{{namespaceId('textarea')}}\"></textarea>\r\n"
				},
				"_validation": {
					"dataType": null,
					"messageWhen": "always",
					"modelRules": {},
					"rules": {},
					"tooltipWhen": "touched",
					"validationMessageHandlerType": "self"
				},
				"autocomplete": "off",
				"autofocus": false,
				"cols": null,
				"datepickerOptions": {
					"altField": "#actual-date",
					"changeMonth": true,
					"changeYear": true,
					"yearRange": "1950:+10"
				},
				"disabled": false,
				"form": null,
				"horizontal": false,
				"inputType": "text",
				"keyField": "key",
				"keyFieldInModel": false,
				"microValueField": "value",
				"name": null,
				"nameField": "button",
				"namespaceClass": "ec-input",
				"numberInputPattern": "[0-9]*[{decimalSeparator}]?[0-9]*",
				"readonly": false,
				"rows": null,
				"size": 20,
				"valueField": "value",
				"wrap": null
			},
			"type": "ecInput"
		}
	};

	/***/
},
/* 6 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
		'use strict';

		morningstar.asterix.ng.register('ecInput', __webpack_require__(5).ecInput);
		morningstar.asterix.meta.register('ecInput', 'allowedEvents', ['ecInputChanged']);
		__webpack_require__(4); // form input types functionality only
		__webpack_require__(3); // datepicker functionality only
		__webpack_require__(2);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 7 */
/***/function (module, exports) {

	module.exports = "<div mstar-include=\"templates[archetype]\" class=\"ec-form__input--container\"></div>\r\n";

	/***/
},
/* 8 */
/***/function (module, exports) {

	module.exports = _;

	/***/
},
/* 9 */
/***/function (module, exports) {

	module.exports = angular;

	/***/
}]
/******/);
//# sourceMappingURL=ec-input.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';
    /* inject requires for bower dependencies */
    // bower:

    __webpack_require__(5);

    __webpack_require__(3);

    __webpack_require__(7);

    __webpack_require__(6);

    __webpack_require__(8);

    __webpack_require__(9);

    __webpack_require__(11);

    __webpack_require__(10);

    __webpack_require__(0);

    __webpack_require__(27);

    __webpack_require__(28);

    __webpack_require__(12);

    __webpack_require__(4);

    __webpack_require__(14);

    __webpack_require__(15);

    __webpack_require__(22);

    __webpack_require__(20);

    __webpack_require__(17);

    __webpack_require__(18);

    __webpack_require__(19);

    __webpack_require__(30);

    __webpack_require__(23);

    __webpack_require__(25);

    __webpack_require__(26);

    __webpack_require__(16);

    __webpack_require__(29);

    __webpack_require__(24);

    __webpack_require__(21);

    // endbower

    var morningstar = __webpack_require__(1);

    morningstar.initBundle = function (appConfigOverrides, configOptions) {

        var appConfig = {};

        morningstar.asterix.bootstrap.init({
            appConfig: morningstar.asterix.extend(true, {}, appConfig, appConfigOverrides),
            configOptions: configOptions || {}
        });
    };

    __webpack_require__(13);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*
 The MIT License (MIT)
 Copyright (c) 2013 Asaf David

 Permission is hereby granted, free of charge, to any person obtaining a copy of
 this software and associated documentation files (the "Software"), to deal in
 the Software without restriction, including without limitation the rights to
 use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 the Software, and to permit persons to whom the Software is furnished to do so,
 subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
    'use strict';

    angular.module('ecMultipleChart').service('CSV', ['$q', function ($q) {

        var EOL = '\r\n';
        var BOM = '\uFEFF';

        /**
         * Stringify one field
         *
         * @param {*} data
         * @param {Object} options
         * @returns {*}
         */
        this.stringifyField = function (data, options) {
            if (options.decimalSep === 'locale' && this.isFloat(data)) {
                return data.toLocaleString();
            }

            if (options.decimalSep !== '.' && this.isFloat(data)) {
                return data.toString().replace('.', options.decimalSep);
            }

            if (typeof data === 'string') {
                data = data.replace(/"/g, '""'); // Escape double qoutes

                // keep leading 0 for numberString
                // refers https://superuser.com/questions/318420/formatting-a-comma-delimited-csv-to-force-excel-to-interpret-value-as-a-string
                if (/^[-]?[0-9]+[\.\,]?[0-9]+?$/.test(data)) {
                    data = '"=""' + data + '"""';
                } else if (options.quoteStrings || data.indexOf(',') > -1 || data.indexOf('\n') > -1 || data.indexOf('\r') > -1) {
                    data = options.txtDelim + data + options.txtDelim;
                }

                return data;
            }

            if (typeof data === 'boolean') {
                return data ? 'TRUE' : 'FALSE';
            }

            return data;
        };

        /**
         * Helper function to check if input is float
         *
         * @param {*} input
         * @returns {boolean}
         */
        this.isFloat = function (input) {
            return +input === input && (!isFinite(input) || Boolean(input % 1));
        };

        /**
         * Creates a csv from a data array
         *
         * @param {Object} data
         * @param {Object} options
         *  * header - Provide the first row (optional)
         *  * fieldSep - Field separator, default: ',',
         *  * addByteOrderMarker - Add Byte order mark, default(false)
         */
        this.stringify = function (data, options) {
            var def = $q.defer();

            var that = this;
            var csv = '';
            var csvContent = '';

            var dataPromise = $q.when(data).then(function (responseData) {
                // Check if there's a provided title
                if (angular.isDefined(options.title) && options.title) {
                    csvContent += options.title + EOL;
                }

                // Check if there's a provided header array
                if (angular.isDefined(options.header) && options.header) {
                    var encodingArray, headerString;

                    encodingArray = [];
                    angular.forEach(options.header, function (title, key) {
                        this.push(that.stringifyField(title, options));
                    }, encodingArray);

                    headerString = encodingArray.join(options.fieldSep ? options.fieldSep : ',');
                    csvContent += headerString + EOL;
                }

                var arrData = [];

                if (angular.isArray(responseData)) {
                    arrData = responseData;
                } else if (angular.isFunction(responseData)) {
                    arrData = responseData();
                }

                // Check if using keys as labels
                if (angular.isDefined(options.label) && options.label && typeof options.label === 'boolean') {
                    var labelArray, labelString;

                    labelArray = [];

                    var iterator = !!options.columnOrder ? options.columnOrder : arrData[0];
                    angular.forEach(iterator, function (value, label) {
                        var val = !!options.columnOrder ? value : label;
                        this.push(that.stringifyField(val, options));
                    }, labelArray);
                    labelString = labelArray.join(options.fieldSep ? options.fieldSep : ',');
                    csvContent += labelString + EOL;
                }

                angular.forEach(arrData, function (oldRow, index) {
                    var row = angular.copy(arrData[index]);
                    var dataString, infoArray;

                    infoArray = [];

                    var iterator = !!options.columnOrder ? options.columnOrder : row;
                    angular.forEach(iterator, function (field, key) {
                        var val = !!options.columnOrder ? row[field] : field;
                        this.push(that.stringifyField(val, options));
                    }, infoArray);

                    dataString = infoArray.join(options.fieldSep ? options.fieldSep : ',');
                    csvContent += index < arrData.length ? dataString + EOL : dataString;
                });

                // Add BOM if needed
                if (options.addByteOrderMarker) {
                    csv += BOM;
                }

                // Append the content and resolve.
                csv += csvContent;
                def.resolve(csv);
            });

            if (typeof dataPromise['catch'] === 'function') {
                dataPromise['catch'](function (err) {
                    def.reject(err);
                });
            }

            return def.promise;
        };
    }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* jshint browser: true */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
    'use strict';

    angular.module('ecMultipleChart').factory('exportCSV', ['CSV', '$document', '$timeout', exportCSV]);

    function exportCSV(CSV, $document, $timeout) {

        var createFile = function createFile(result, charset, fileName) {

            if (!Blob) {
                throw new Error('Blob is not supported by your browser');
            }

            result = '\uFEFF' + result;

            var blob = new Blob([result], {
                type: 'text/csv;charset=' + charset + ';'
            });

            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                var downloadContainer = angular.element('<div data-tap-disabled="true"><a></a></div>'),
                    downloadLink = angular.element(downloadContainer.children()[0]);
                downloadLink.attr('href', window.URL.createObjectURL(blob));
                downloadLink.attr('download', fileName);
                downloadLink.attr('target', '_blank');

                $document.find('body').append(downloadContainer);
                $timeout(function () {
                    downloadLink.get(0).click();
                    downloadLink.remove();
                }, 0);
            }
        };

        var exportData = function exportData(dataObject, optionsObject) {
            var options = optionsObject || {};

            options.header = options.header || null;
            options.decimalSep = options.decimalSep || '.';
            options.label = options.keysToHeaders || false;
            options.columnOrder = options.columnOrder || null;
            options.fileName = options.fileName || 'download.csv';
            options.charset = options.charset || 'utf-8';
            options.txtDelim = options.txtDelim || '"';

            if (dataObject) {
                CSV.stringify(dataObject, options).then(function (result) {
                    createFile(result, options.charset, options.fileName);
                });
            } else {
                throw new Error('Data to export is missing');
            }
        };

        return {
            exportData: exportData
        };
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(1), __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, dateHelper) {
    'use strict';

    multipleChart.$inject = ["mstarModelValidate", "mstarValidationMessageContainers", "exportCSV"];
    angular.module('ecMultipleChart', ['ecAutocomplete', 'ecButton', 'ecChosen', 'ecComboBox', 'ecContainer', 'ecHypotheticalGrowth', 'ecInput', 'ecPerformanceGraph', 'ecTable', 'ecTabs', 'mstarCore']).directive('ecMultipleChart', multipleChart);

    function multipleChart(mstarModelValidate, mstarValidationMessageContainers, exportCSV) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope, { editable: true });
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var inputStartDateInstance = scope.instance.findRelative('inputStartDate');
            var inputEndDateInstance = scope.instance.findRelative('inputEndDate');
            var autocompletePrimaryFund = scope.instance.findRelative('autocompletePrimaryFund');
            var autocompleteComparisonFund = scope.instance.findRelative('autocompleteComparisonFund');
            var chosenReinvestDistributions = scope.instance.findRelative('chosenReinvestDistributions');
            var buttonExport = scope.instance.findRelative('buttonExport');

            initialChartSettings();

            mstarModelValidate.bind(scope.instance);
            scope.validationContainer = mstarValidationMessageContainers.register(scope.instance, function handleMessages(validationMessages) {
                scope.getErrorMessage(validationMessages, validationMessages.getErrors().length);
                var primaryFundsecId = scope.model.chartSettings.primaryFund.secId;
                if (!primaryFundsecId) {
                    scope.model.securities.priceTableData = [];
                    scope.showPriceTable = false;
                }
            });

            var formElements = {};

            scope.getErrorMessage = function (validationMessages, length) {
                scope.validationErrors = null;
                var form = elem.find('form[name="enterData"]').scope();
                form = form && form.enterData || {};

                var obj = {};

                _.each(validationMessages._messages, function (item, key) {
                    var reference = key.split('_');
                    var component = reference[reference.length - 1];

                    formElements[component] = formElements[component] || form[component] || {
                        $setValidity: angular.noop
                    };
                    formElements[component].$setValidity(item.rule.labelKey, item.returnValue);

                    if (length > 0 && !item.returnValue) {
                        obj[item.rule.labelKey] = item.label;
                    }
                });

                var startDate = scope.model.chartSettings.startDate;
                var endDate = scope.model.chartSettings.endDate;
                if (startDate && endDate && startDate >= endDate) {
                    obj.startDateRequired = scope.labels.get('maxStartDate');
                    formElements.inputStartDate.$setValidity('startDateRequired', false);
                }
                if (endDate && endDate > new Date()) {
                    obj.endDateRequired = scope.labels.get('maxEndDate');
                    formElements.inputEndDate.$setValidity('endDateRequired', false);
                }

                var initialInvestmentAmount = scope.model.chartSettings.initialInvestmentAmount;
                if (morningstar.asterix.util.isUndefinedOrNull(initialInvestmentAmount) || initialInvestmentAmount < 0 || morningstar.asterix.util.isNumber(initialInvestmentAmount) && initialInvestmentAmount.toString().indexOf('.') > -1) {
                    obj.initialAmountRequired = scope.labels.get('fieldShouldBeInteger');
                    formElements.inputInitialAmount.$setValidity('initialAmountRequired', false);
                }

                var amount = scope.model.chartSettings.amount;
                if (morningstar.asterix.util.isUndefinedOrNull(amount) || amount < 0 || morningstar.asterix.util.isNumber(amount) && amount.toString().indexOf('.') > -1) {
                    obj.amountRequired = scope.labels.get('fieldShouldBeInteger');
                    formElements.inputAmount.$setValidity('amountRequired', false);
                }
                if (obj.amountRequired && scope.activeType === 'priceChart') {
                    delete obj.amountRequired;
                    formElements.inputAmount.$setValidity('amountRequired', true);
                }
                if (obj.initialAmountRequired && scope.activeType === 'priceChart') {
                    delete obj.initialAmountRequired;
                    formElements.inputInitialAmount.$setValidity('initialAmountRequired', true);
                }
                scope.validationErrors = obj;
            };

            scope.setActiveView = function (index) {
                setActiveView(index);
            };

            function setActiveView(index) {
                var view = scope.settings.get('views')[index];
                if (view) {
                    scope.activeType = view;
                }
            }

            function setInceptionDate() {
                var timeFrame = scope.model.chartSettings.timeFrame;
                if (timeFrame && timeFrame.key === 'sinceInception') {
                    var primaryFund = scope.model.chartSettings.primaryFund;
                    var comparisonFund = scope.model.chartSettings.comparisonFund;
                    scope.model.chartSettings.startDate = scope.inceptionDate = _.max([dateHelper.toDateObject(primaryFund.performanceStartDate) || primaryFund.inceptionDate, dateHelper.toDateObject(comparisonFund.performanceStartDate) || comparisonFund.inceptionDate || null]);
                }
            }

            function setDisplayFrequency() {
                var tabFrequencyInstance = scope.instance.findRelative('hypotheticalGrowthChart.performanceGraph.tabFrequency');
                if (tabFrequencyInstance.parameters.selectedTabIndex > -1) {
                    tabFrequencyInstance.setParameter('selectedTabIndex', -1);
                    tabFrequencyInstance.setParameter('resetTabStatus', true);
                }

                var displayFrequency = [{
                    labelKey: 'oneYear',
                    value: 'Year1',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'threeYears',
                    value: 'Year3',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'fiveYears',
                    value: 'Year5',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'tenYears',
                    value: 'Year10',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'inception',
                    value: 'EarliestCommon',
                    dataType: 'TrailingReturn'
                }];
                var monthCount = morningstar.asterix.util.date.monthDiff(scope.inceptionDate, new Date());
                var commonYear = Math.floor(monthCount / 12);
                _.each(displayFrequency, function (item) {
                    item.value = commonYear < Number(item.value.replace(/Year/, '')) ? 'EarliestCommon' : item.value;
                });
                scope.instance.findRelative('hypotheticalGrowthChart').setParameter('displayFrequency', displayFrequency);
            }

            scope.reset = function () {
                initialChartSettings();
                autocompletePrimaryFund.setParameter('search', '');
                autocompleteComparisonFund.setParameter('search', '');
                chosenReinvestDistributions.setParameter('buttonItemSelected', scope.model.chartSettings.reinvestDistributions);
                scope.validationErrors = {};
                scope.validationContainer.deactivate(false);
                scope.model.securities.priceTableData = [];
                scope.showPriceTable = false;
                scope.showHypoGrowthChart = false;
            };

            function initialChartSettings() {
                scope.model.chartSettings = {
                    primaryFund: {},
                    comparisonFund: {},
                    timeFrame: {
                        key: 'sinceInception',
                        value: 'sinceInception',
                        timeFrame: 'sinceInception',
                        list: 1
                    },
                    startDate: null,
                    endDate: new Date(),
                    initialInvestmentAmount: 10000,
                    investmentType: {
                        key: 'invest',
                        value: 'contribution',
                        investmentType: 'contribution',
                        list: 1
                    },
                    amount: 0,
                    frequency: {
                        key: 'annually',
                        value: 'annually',
                        frequency: 'annually',
                        list: 1
                    },
                    reinvestDistributions: 'yes'
                };
            }

            scope.parameters.readyForAPI = false;
            scope.export = function () {
                scope.parameters.readyForAPI = true;
            };

            scope.isLoading = false;
            scope.isSubmit = false;
            scope.showHypoGrowthChart = false;
            scope.submit = function () {
                scope.validationContainer.activate(true);

                if (Object.keys(scope.validationErrors).length < 1) {
                    scope.isSubmit = true;
                    var primaryFundsecId = scope.model.chartSettings.primaryFund.secId;
                    var comparisonFundsecId = scope.model.chartSettings.comparisonFund.secId;
                    var startDate = scope.model.chartSettings.startDate;
                    var endDate = scope.model.chartSettings.endDate;
                    if (scope.activeType === 'hypotheticalGrowthChart') {
                        getHypoGrowthChart(primaryFundsecId, comparisonFundsecId, startDate, endDate);
                    } else {
                        getPriceChart(primaryFundsecId, comparisonFundsecId, startDate, endDate);
                    }
                }
            };

            function getPriceChart(primaryFundsecId, comparisonFundsecId, startDate, endDate) {
                var secIds = comparisonFundsecId ? primaryFundsecId + ',' + comparisonFundsecId : primaryFundsecId;
                scope.instance.setParameter('secIds', secIds);
                scope.instance.setParameter('inceptionDate', scope.inceptionDate);
                scope.instance.setParameter('startDate', startDate);
                scope.instance.setParameter('endDate', endDate);
                if (scope.instance.findRelative('priceChart.tabFrequency').parameters.selectedTabIndex > -1) {
                    scope.instance.findRelative('priceChart.tabFrequency').setParameter('resetTabStatus', true);
                }
                scope.showPriceTable = true;
            }

            function getHypoGrowthChart(primaryFundsecId, comparisonFundsecId, startDate, endDate) {
                setDisplayFrequency();

                scope.model.performanceData.rows = [];
                var primaryFund = scope.model.chartSettings.primaryFund;
                var comparisonFund = '';
                scope.model.performanceData.rows.push({
                    name: !primaryFund.currency ? primaryFund.name : primaryFund.name + ' ' + primaryFund.currency,
                    universe: primaryFund.universe,
                    returnM12: primaryFund.returnM12,
                    returnM36: primaryFund.returnM36,
                    returnM60: primaryFund.returnM60,
                    returnM120: primaryFund.returnM120,
                    returnM255UA: primaryFund.returnM255UA,
                    marketTrailing1YearReturn: primaryFund.marketTrailing1YearReturn,
                    marketTrailing3YearReturn: primaryFund.marketTrailing3YearReturn,
                    marketTrailing5YearReturn: primaryFund.marketTrailing5YearReturn,
                    marketTrailing10YearReturn: primaryFund.marketTrailing10YearReturn,
                    marketSinceInceptionReturn: primaryFund.marketSinceInceptionReturn,
                    inceptionDate: morningstar.asterix.util.date.convertToStandard(dateHelper.toDateObject(primaryFund.performanceStartDate) || primaryFund.inceptionDate)
                });
                if (comparisonFundsecId) {
                    comparisonFund = scope.model.chartSettings.comparisonFund;
                    scope.model.performanceData.rows.push({
                        name: !comparisonFund.currency ? comparisonFund.name : comparisonFund.name + ' ' + comparisonFund.currency,
                        universe: comparisonFund.universe,
                        returnM12: comparisonFund.returnM12,
                        returnM36: comparisonFund.returnM36,
                        returnM60: comparisonFund.returnM60,
                        returnM120: comparisonFund.returnM120,
                        returnM255UA: comparisonFund.returnM255UA,
                        marketTrailing1YearReturn: comparisonFund.marketTrailing1YearReturn,
                        marketTrailing3YearReturn: comparisonFund.marketTrailing3YearReturn,
                        marketTrailing5YearReturn: comparisonFund.marketTrailing5YearReturn,
                        marketTrailing10YearReturn: comparisonFund.marketTrailing10YearReturn,
                        marketSinceInceptionReturn: comparisonFund.marketSinceInceptionReturn,
                        inceptionDate: morningstar.asterix.util.date.convertToStandard(dateHelper.toDateObject(comparisonFund.performanceStartDate) || comparisonFund.inceptionDate)
                    });
                }
                var portfolio = comparisonFundsecId ? {
                    current: {
                        name: !primaryFund.currency ? primaryFund.name : primaryFund.name + ' ' + primaryFund.currency,
                        currencyId: primaryFund.currency,
                        holdings: [{
                            identifier: primaryFundsecId,
                            identifierType: 'SecurityId',
                            amount: scope.model.chartSettings.initialInvestmentAmount
                        }]
                    },
                    proposed: {
                        name: !comparisonFund.currency ? comparisonFund.name : comparisonFund.name + ' ' + comparisonFund.currency,
                        currencyId: comparisonFund.currency,
                        holdings: [{
                            identifier: comparisonFundsecId,
                            identifierType: 'SecurityId',
                            amount: scope.model.chartSettings.initialInvestmentAmount
                        }]
                    }
                } : {
                    name: !primaryFund.currency ? primaryFund.name : primaryFund.name + ' ' + primaryFund.currency,
                    currencyId: primaryFund.currency,
                    holdings: [{
                        identifier: primaryFundsecId,
                        identifierType: 'SecurityId',
                        amount: scope.model.chartSettings.initialInvestmentAmount
                    }]
                };
                var hypotheticalSettings = {
                    illustrationTrailingTimePeriod: 'customized',
                    startDate: dateHelper.toUTCDateObject(_.max([scope.inceptionDate, startDate])),
                    endDate: dateHelper.toUTCDateObject(endDate),
                    subsequentInvestmentType: scope.model.chartSettings.investmentType.key || scope.settings.get('defaultInvestmentType'),
                    subsequentInvestmentAmount: scope.model.chartSettings.amount,
                    subsequentInvestmentWithdrawalFrequency: scope.model.chartSettings.frequency.key || scope.settings.get('defaultFrequency'),
                    reinvestDividends: scope.model.chartSettings.reinvestDistributions === 'yes',
                    initialInvestmentAmount: scope.model.chartSettings.initialInvestmentAmount
                };

                var hypotheticalGrowthChart = scope.instance.findRelative('hypotheticalGrowthChart');
                hypotheticalGrowthChart.setParameter('portfolio', portfolio);
                hypotheticalGrowthChart.setParameter('hypotheticalSettings', hypotheticalSettings);
            }

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:chartSettings.timeFrame', function (newTimeFrame) {
                if (newTimeFrame && newTimeFrame.key) {
                    var disable = newTimeFrame.key === 'sinceInception';
                    inputStartDateInstance.setParameter('disabled', disable);
                    inputEndDateInstance.setParameter('disabled', disable);

                    if (disable) {
                        scope.model.chartSettings.endDate = new Date();
                    }
                    if (scope.model.chartSettings.primaryFund && newTimeFrame.key === 'sinceInception') {
                        setInceptionDate();
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(chosenReinvestDistributions.on('parameterChanged:buttonItemSelected', function (newValue) {
                if (newValue) {
                    scope.model.chartSettings.reinvestDistributions = newValue;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('priceTable').on('modelPropertyChanged:rows', function (rows) {
                if (rows) {
                    scope.isLoading = rows._$isLoading && scope.isSubmit;
                    scope.showPriceTable = rows.length > 0;
                }
                buttonExport.setParameter('disabled', !scope.showPriceTable);
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypotheticalGrowthChart.portfolioData').on('modelPropertyChanged:securities', function (securities) {
                if (securities) {
                    scope.isLoading = securities._$isLoading && scope.isSubmit;
                    if (securities.performanceChart) {
                        scope.showHypoGrowthChart = true;
                    }

                    if (securities.hypoDates) {
                        scope.model.performanceData.asofDate = securities.hypoDates.asOfDate;
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:priceAndDistributions', function (securities) {
                if (securities.name) {
                    var exportSettings = scope.settings.get('exportSettings');
                    var headers = [];
                    _.each(exportSettings.columnOrder, function (item) {
                        var header = morningstar.asterix.util.string.format(scope.labels.get(item), scope.format.currencySymbol(scope.model.currencyId));
                        headers.push(header);
                    });
                    var options = {
                        title: securities.name,
                        header: headers,
                        columnOrder: exportSettings.columnOrder
                    };
                    exportCSV.exportData(securities.rows, options);
                    scope.parameters.readyForAPI = false;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:chartSettings.primaryFund.secId', function (primaryFundSecId) {
                if (primaryFundSecId) {
                    setInceptionDate();
                    buttonExport.setParameter('disabled', true);
                }
            }));
            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:chartSettings.comparisonFund.secId', function (comparisonFundSecId) {
                if (comparisonFundSecId) {
                    setInceptionDate();
                    buttonExport.setParameter('disabled', true);
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:startDate', function (newValue) {
                if (newValue && scope.instance.findRelative('priceChart.tabFrequency').parameters.selectedTabIndex !== 5) {
                    scope.model.chartSettings.startDate = newValue;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:endDate', function (newValue) {
                if (newValue && scope.instance.findRelative('priceChart.tabFrequency').parameters.selectedTabIndex !== 5) {
                    scope.model.chartSettings.endDate = newValue;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('priceChart.tabFrequency').on('parameterChanged:selectedTabIndex', function (newValue) {
                if (newValue >= 0) {
                    if (newValue === 5) {
                        scope.model.chartSettings.timeFrame = { key: 'sinceInception', value: 'sinceInception' };
                    } else {
                        scope.model.chartSettings.timeFrame = { key: 'customized', value: 'custom' };
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypotheticalGrowthChart.performanceGraph.tabFrequency').on('parameterChanged:selectedTabIndex', function (newValue) {
                scope.instance.findRelative('hypotheticalGrowthChart').setParameter('hypotheticalSettings', null);
                if (newValue >= 0) {
                    if (newValue === 4) {
                        scope.model.chartSettings.timeFrame = { key: 'sinceInception', value: 'sinceInception' };
                    } else {
                        scope.model.chartSettings.timeFrame = { key: 'customized', value: 'custom' };
                    }
                }
            }));
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, dateHelper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromMarketsPriceAndDistributions', function (data) {
        var context = this.context,
            chartSettings = context.instance.model.chartSettings;
        if (!data || !data.Data || !chartSettings) {
            return;
        }

        var primaryData = _.findWhere(data.Data, { Ticker: chartSettings.primaryFund.secId });
        return getPriceAndDistributions(primaryData, context, chartSettings);
    });

    function getPriceAndDistributions(data, context, chartSettings) {
        var formatter = context.instance.getFormatter(),
            exportSettings = context.instance.getSettings().exportSettings,
            newData = { name: chartSettings.primaryFund.name, rows: [] },
            priceList = morningstar.asterix.util.parse('DailyData[3244]')(data).reverse(),
            distributionList = morningstar.asterix.util.parse('DailyData.TotalDist')(data);
        _.each(priceList, function (item) {
            var distributionData = _.findWhere(distributionList, { Date: item.Date }),
                distribution = distributionData ? distributionData.Last : 0;
            newData.rows.push({
                date: formatter.date(dateHelper.toDateObject(item.Date), exportSettings.dateFormatAlias),
                price: formatter.number(item.Last, exportSettings.priceFormatAlias),
                distribution: formatter.number(distribution, exportSettings.distributionFormatAlias)
            });
        });
        return newData;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, dateHelper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromMarkets', function (data) {
        var chartSettings = this.context.instance.model.chartSettings;
        if (!data || !data.Data || !chartSettings) {
            return;
        }
        var priceData = {};
        var priceTableData = getPriceTableData(data.Data, chartSettings);
        var priceChartData = getPriceChartData(data.Data, chartSettings);
        priceData = {
            priceTableData: priceTableData,
            priceChartData: priceChartData
        };
        return priceData;
    });

    function getPriceTableData(data, chartSettings) {
        var priceTableData = [];
        var asOfDate = chartSettings.comparisonFund.asOfDate ? _.max([chartSettings.comparisonFund.asOfDate, chartSettings.primaryFund.asOfDate]) : chartSettings.primaryFund.asOfDate;
        asOfDate = dateHelper.toDateObject(asOfDate);
        var inputStartDate = chartSettings.startDate;
        var inputEndDate = chartSettings.endDate;
        var startDate = '';
        var endDate = '';
        var dateList1 = data[0].DailyData.HS538;
        var dateList2 = data[1] ? data[1].DailyData.HS538 : '';
        var comparisonInceptionDate = chartSettings.comparisonFund.inceptionDate || '';
        var primaryInceptionDate = chartSettings.primaryFund.inceptionDate;
        var funds = chartSettings.comparisonFund.name ? [chartSettings.primaryFund, chartSettings.comparisonFund] : [chartSettings.primaryFund];
        if (dateList1.length > 0 && dateList2.length > 0) {
            startDate = _.max([inputStartDate, comparisonInceptionDate, primaryInceptionDate, dateHelper.toDateObject(dateList1[0].Date), dateHelper.toDateObject(dateList2[0].Date)]);
            endDate = _.min([inputEndDate, dateHelper.toDateObject(dateList1[dateList1.length - 1].Date), dateHelper.toDateObject(dateList2[dateList2.length - 1].Date)]);
        } else if (dateList1.length > 0 && dateList2.length === 0) {
            startDate = _.max([inputStartDate, primaryInceptionDate, dateHelper.toDateObject(dateList1[0].Date)]);
            endDate = _.min([inputEndDate, dateHelper.toDateObject(dateList1[dateList1.length - 1].Date)]);
        }

        _.each(funds, function (fund) {
            var priceChangePer = getPriceChangePer(fund, data, startDate, endDate);
            priceTableData.push({
                secId: fund.secId,
                name: !fund.currency ? fund.name : fund.name + ' ' + fund.currency,
                startDate: morningstar.asterix.util.date.convertToStandard(startDate),
                endDate: morningstar.asterix.util.date.convertToStandard(endDate),
                priceChangePer: priceChangePer,
                currentPrice: parseFloat(fund.closePrice).toFixed(2),
                inceptionDate: morningstar.asterix.util.date.convertToStandard(fund.inceptionDate),
                asOfDate: asOfDate
            });
        });

        return priceTableData;
    }

    function getPriceChartData(data, chartSettings) {
        var priceChartData = {
            series: []
        };

        var dataList = [];
        _.each([chartSettings.primaryFund, chartSettings.comparisonFund], function (fund) {
            _.each(data, function (item) {
                if (fund.secId === item.Ticker && item.DailyData.HS538.length > 0) {
                    _.each(item.DailyData.HS538, function (i) {
                        dataList.push({
                            date: morningstar.asterix.util.date.convertToStandard(dateHelper.toDateObject(i.Date)),
                            close: Number(i.Last)

                        });
                    });
                    priceChartData.series.push({
                        name: !fund.currency ? fund.name : fund.name + ' ' + fund.currency,
                        data: dataList
                    });
                    dataList = [];
                }
            });
        });

        return priceChartData;
    }

    function getPriceChangePer(fund, data, startDate, endDate) {
        var priceChangePer = 0;
        var priceFirst;
        var priceLast;
        _.each(data, function (item) {
            if (fund.secId === item.Ticker) {
                var dataList = item.DailyData.HS538;
                if (dataList.length > 0) {
                    _.each(dataList, function (i) {
                        if (dateHelper.toDateObject(i.Date) <= startDate) {
                            priceFirst = i.Last;
                        }
                        if (dateHelper.toDateObject(i.Date) <= endDate) {
                            priceLast = i.Last;
                        }
                    });
                    priceChangePer = ((priceLast - priceFirst) / priceFirst * 100).toFixed(2) + '%';
                }
            }
        });
        return priceChangePer;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromPAAPIHypoToGrowthTable', function (securities) {
        var rows = [];
        if (!securities._$isLoading && securities.originalData) {
            var hypoData = securities.originalData.Hypo || [],
                chartSettings = this.context.instance.model.chartSettings;
            rows = generateHypotheticalGrowthTableModel(hypoData, chartSettings);
        }
        return rows;
    });

    function generateHypotheticalGrowthTableModel(hypoData, chartSettings) {
        var tableData = [],
            subsequentInvestmentType = chartSettings.investmentType.key.toLowerCase(),
            initialInvestmentAmount = chartSettings.initialInvestmentAmount;
        morningstar.asterix.util.each(hypoData, function (item) {
            var totalWithdrawal = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalDistributionAndWithdrawal')(item) || 0,
                totalNewInvestment = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalNewInvestment')(item) || initialInvestmentAmount,
                finalMarketValue = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.FinalMarketValue')(item) || 0,
                totalContributionAmounts = totalNewInvestment,
                totalGain = 0;
            if (subsequentInvestmentType === 'withdrawal') {
                totalGain = finalMarketValue - initialInvestmentAmount + totalWithdrawal;
            } else {
                totalGain = finalMarketValue - totalNewInvestment;
            }
            var earliestInceptionDate = morningstar.asterix.util.parse('PerformanceDate.EarliestInceptionDate')(item);
            tableData.push({
                name: item.PortfolioName,
                asOfDate: morningstar.asterix.util.parse('PortfolioSummary.AsOfDate')(item) || '',
                totalContributionAmounts: totalContributionAmounts,
                marketValue: finalMarketValue,
                totalGain: totalGain,
                cumulativeReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.CumulativeReturn')(item) || 0,
                avgAnnualizedReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.AverageAnnualizedReturn')(item) || 0,
                inceptionDate: earliestInceptionDate ? morningstar.asterix.util.date.convertToStandard(new Date(earliestInceptionDate)) : ''
            });
        });
        return tableData;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, dateHelper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toMarketsPriceAndDistributions', function () {
        var parameters = this.context.parameters;
        if (!parameters.secIds) {
            return;
        }
        var marketsApiToken = morningstar.asterix.context.getToken('marketsApiToken');
        var startDate = _.max([parameters.startDate, parameters.inceptionDate]);
        var endDate = parameters.endDate;

        var result = {
            baseUrl: this.context.settings.get('baseUrlQuoteSpeed'),
            startDate: dateHelper.toDateString(startDate),
            endDate: dateHelper.toDateString(endDate),
            secIds: parameters.secIds,
            sessionId: marketsApiToken
        };
        return result;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, dateHelper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toMarkets', function () {
        var parameters = this.context.parameters;
        if (!parameters.secIds) {
            return;
        }
        var marketsApiToken = morningstar.asterix.context.getToken('marketsApiToken');
        var startDate = _.max([parameters.startDate, parameters.inceptionDate]);
        var endDate = parameters.endDate;
        var beforeEndDate20Y = new Date(endDate.getFullYear() - 20, endDate.getMonth(), endDate.getDate());
        var dataType = startDate <= beforeEndDate20Y ? 'w' : 'd';
        parameters.dataType = dataType;

        var result = {
            baseUrl: this.context.settings.get('baseUrlQuoteSpeed'),
            dataType: dataType,
            startDate: dateHelper.toDateString(startDate),
            endDate: dateHelper.toDateString(endDate),
            secIds: parameters.secIds,
            sessionId: marketsApiToken
        };
        return result;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 3);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 1 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(0), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
        'use strict';

        paginator.$inject = ["mstarDimensions"];
        angular.module('ecPaginator', ['mstarCore', 'ecContainer']).directive('ecPaginator', paginator);

        function paginator(mstarDimensions) {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {},
                template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main', {
                    preProcessElement: function preProcessElement() {
                        this.removeUnlessSettingIn('.ec-paginator--show-first-and-last', 'showFirstAndLast', [true]);
                        this.removeUnlessSettingIn('.ec-paginator--show-page-numbers', 'showPageNumbers', [true]);
                    }
                }),
                link: linkFn
            };

            function linkFn(scope, elem, attr, mstarComponent) {
                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // compiles the main template
                mstarComponent.compileTemplate(scope, '_templates.main');

                mstarComponent.bindParameters(scope);

                // uses elem.find('ec-section') instead of elem in mstarDimensions to fix a bug in Chrome, which returning 0 width and height regardless the actual size
                var mstarDimensionsInstance = mstarDimensions(scope, elem.find('ec-section'));

                if (scope.settings.get('adaptivePagination')) {
                    handleDimensionsChange(mstarDimensionsInstance.getDimensions());

                    mstarDimensionsInstance.addListener(function (dimensions) {
                        scope.$evalAsync(function () {
                            handleDimensionsChange(dimensions);
                        });
                    });
                }

                scope.instance.on('parameterChanged:page', function (newValue) {
                    if (newValue < 1) {
                        scope.parameters.page = 1;
                    } else if (scope.parameters.lastPage && newValue > scope.parameters.lastPage) {
                        scope.parameters.page = scope.parameters.lastPage;
                    }
                });

                scope.$watchCollection('[parameters.totalRows, parameters.perPage, parameters.page, parameters.paginationWindowSize]', function (newValue, oldValue) {
                    if (!scope.parameters.perPage || !scope.parameters.totalRows && !oldValue[0]) {
                        return;
                    }
                    var paginationWindowSize = scope.parameters.paginationWindowSize || scope.parameters.perPage;
                    if (paginationWindowSize > scope.parameters.perPage) {
                        scope.logger.error(new Error('paginationWindowSize should not be greater than perPage value.'));
                    }
                    scope.parameters.lastPage = scope.parameters.totalRows > scope.parameters.perPage ? Math.ceil((scope.parameters.totalRows - scope.parameters.perPage) / paginationWindowSize) + 1 : 1;

                    if (scope.parameters.lastPage < scope.parameters.page) {
                        scope.parameters.page = scope.parameters.lastPage || 1;
                    }

                    scope.pages = getPages();
                });

                scope.setPage = function (page) {

                    if (page > scope.parameters.lastPage || page < 1) {
                        return;
                    }

                    scope.parameters.page = page;
                    scope.instance.trigger('ecPaginatorPageChanged', [scope.parameters.page]);
                };

                function handleDimensionsChange(dimensions) {
                    if (scope.settings.get('adaptivePagination')) {
                        _.each(scope.settings.get('adaptivePaginationRanges'), function (range) {
                            if (dimensions.width <= range.endPoint && dimensions.width > range.startPoint) {
                                scope.parameters.perPage = range.perPage;
                                return true;
                            }
                        });
                    }
                }

                function getPages() {
                    var pages = [];
                    var numberOfWrappingPageLinks = scope.settings.get('numberOfWrappingPageLinks'),
                        beforeRemaining = Math.min(0, scope.parameters.page - numberOfWrappingPageLinks - 1),
                        afterRemaining = Math.min(0, scope.parameters.lastPage - (scope.parameters.page + numberOfWrappingPageLinks)),
                        start = Math.max(1, scope.parameters.page - numberOfWrappingPageLinks + afterRemaining),
                        end = Math.min(scope.parameters.lastPage, scope.parameters.page + numberOfWrappingPageLinks - beforeRemaining);
                    for (var i = start; i <= end; i++) {
                        pages.push(i);
                    }

                    return pages;
                }

                scope.hasPage = function (page) {
                    return scope.getPages().indexOf(page) > -1;
                };
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 2 */
/***/function (module, exports) {

    module.exports = {
        "ecPaginator": {
            "labels": {
                "first": {
                    "da-DK": "Første",
                    "en": "First",
                    "en-GB": null,
                    "fr": "Premier",
                    "it": "Primo",
                    "ja": "先頭",
                    "sv": "Första",
                    "sv-SE": null,
                    "zh-CN": "首项",
                    "zh-HK": "首項"
                },
                "last": {
                    "da-DK": "Sidste",
                    "en": "Last",
                    "en-GB": null,
                    "fr": "Dernier",
                    "it": "Ultimo",
                    "ja": "最後",
                    "sv": "Sista",
                    "sv-SE": null,
                    "zh-CN": "最后一项",
                    "zh-HK": "最後一項"
                },
                "next": {
                    "da": "Næste",
                    "de": "Nächste",
                    "en": "Next",
                    "en-GB": null,
                    "es": "Siguiente",
                    "fr": "Suivant",
                    "fr-FR": "Prochain",
                    "it": "Avanti",
                    "ja": "次へ",
                    "sv": "Nästa",
                    "sv-SE": null,
                    "zh-CN": "下一页",
                    "zh-HK": "下一頁"
                },
                "previous": {
                    "da": "Forrige",
                    "de": "Bisherige",
                    "en": "Previous",
                    "en-GB": null,
                    "es": "Anterior",
                    "fr": "Précédent",
                    "it": "Indietro",
                    "ja": "前へ",
                    "sv": "Föregående",
                    "sv-SE": null,
                    "zh-CN": "上一页",
                    "zh-HK": "上一頁"
                }
            },
            "settings": {
                "_parameters": {
                    "page": null,
                    "paginationWindowSize": {},
                    "perPage": null,
                    "totalRows": {
                        "binding": "{{_ parameters(_).totalRows _}}"
                    }
                },
                "_templates": {
                    "main": "<ec-section>\r\n    <div data-ng-show=\"parameters.lastPage > 1\">\r\n        <ul class=\"ec-pagination\">\r\n            <li class=\"ec-pagination__item ec-pagination__item--first ec-paginator--show-first-and-last\"\r\n                data-ng-if=\"settings.get('showFirstAndLast')\" data-ng-class=\"{ 'ec-pagination__item--disabled': parameters.page == 1 }\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\" data-ng-disabled=\"parameters.page == 1\"\r\n                    data-ng-click=\"setPage(1)\">{{ labels.get('first') }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--previous\"\r\n                data-ng-class=\"{ 'ec-pagination__item--disabled': !(parameters.page > 1) }\"\r\n                data-ng-if=\"!settings.get('dynamicPrevNext') || parameters.page > 1\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\" data-ng-disabled=\"!(parameters.page > 1)\"\r\n                    data-ng-click=\"setPage(parameters.page - 1)\">{{\r\n                    labels.get('previous') }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--number ec-paginator--show-page-numbers\" data-ng-if=\"settings.get('showPageNumbers')\"\r\n                data-ng-class=\"{ 'ec-pagination__item--active': parameters.page == page }\"\r\n                data-ng-repeat=\"page in pages track by $index\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\" data-ng-click=\"setPage(page)\">{{ page }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--next\"\r\n                data-ng-class=\"{ 'ec-pagination__item--disabled': parameters.page >= parameters.lastPage}\"\r\n                data-ng-if=\"!settings.get('dynamicPrevNext') || parameters.page < parameters.lastPage\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\"\r\n                    data-ng-click=\"setPage(parameters.page + 1)\">{{\r\n                    labels.get('next') }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--last ec-paginator--show-first-and-last\"\r\n                data-ng-if=\"settings.get('showFirstAndLast')\"\r\n                data-ng-class=\"{ 'ec-pagination__item--disabled': parameters.page >= parameters.lastPage }\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\"\r\n                    data-ng-disabled=\"parameters.page >= parameters.lastPage\"\r\n                    data-ng-click=\"setPage(parameters.lastPage)\">\r\n                    {{ labels.get('last') }}</a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</ec-section>\r\n"
                },
                "adaptivePagination": false,
                "adaptivePaginationRanges": null,
                "dynamicPrevNext": true,
                "numberOfWrappingPageLinks": 5,
                "page": 1,
                "paginationWindowSize": null,
                "perPage": 10,
                "showFirstAndLast": false,
                "showPageNumbers": true,
                "totalRows": null
            },
            "type": "ecPaginator"
        }
    };

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecPaginator', __webpack_require__(2).ecPaginator);
        morningstar.asterix.meta.register('ecPaginator', 'allowedEvents', ['ecPaginatorPageChanged']);
        __webpack_require__(1);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 5 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
}]
/******/);
//# sourceMappingURL=ec-paginator.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(d3, _) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 9);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["mbc-core"] = factory();else root["mbc-core"] = factory();
    })(this, function () {
        return (/******/function (modules) {
                // webpackBootstrap
                /******/ // The module cache
                /******/var installedModules = {};
                /******/
                /******/ // The require function
                /******/function __webpack_require__(moduleId) {
                    /******/
                    /******/ // Check if module is in cache
                    /******/if (installedModules[moduleId]) {
                        /******/return installedModules[moduleId].exports;
                        /******/
                    }
                    /******/ // Create a new module (and put it into the cache)
                    /******/var module = installedModules[moduleId] = {
                        /******/i: moduleId,
                        /******/l: false,
                        /******/exports: {}
                        /******/ };
                    /******/
                    /******/ // Execute the module function
                    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                    /******/
                    /******/ // Flag the module as loaded
                    /******/module.l = true;
                    /******/
                    /******/ // Return the exports of the module
                    /******/return module.exports;
                    /******/
                }
                /******/
                /******/
                /******/ // expose the modules object (__webpack_modules__)
                /******/__webpack_require__.m = modules;
                /******/
                /******/ // expose the module cache
                /******/__webpack_require__.c = installedModules;
                /******/
                /******/ // identity function for calling harmony imports with the correct context
                /******/__webpack_require__.i = function (value) {
                    return value;
                };
                /******/
                /******/ // define getter function for harmony exports
                /******/__webpack_require__.d = function (exports, name, getter) {
                    /******/if (!__webpack_require__.o(exports, name)) {
                        /******/Object.defineProperty(exports, name, {
                            /******/configurable: false,
                            /******/enumerable: true,
                            /******/get: getter
                            /******/ });
                        /******/
                    }
                    /******/
                };
                /******/
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/__webpack_require__.n = function (module) {
                    /******/var getter = module && module.__esModule ?
                    /******/function getDefault() {
                        return module['default'];
                    } :
                    /******/function getModuleExports() {
                        return module;
                    };
                    /******/__webpack_require__.d(getter, 'a', getter);
                    /******/return getter;
                    /******/
                };
                /******/
                /******/ // Object.prototype.hasOwnProperty.call
                /******/__webpack_require__.o = function (object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/
                /******/ // __webpack_public_path__
                /******/__webpack_require__.p = "";
                /******/
                /******/ // Load entry module and return exports
                /******/return __webpack_require__(__webpack_require__.s = 117);
                /******/
            }(
            /************************************************************************/
            /******/{

                /***/10:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    function _defineProperty(obj, key, value) {
                        if (key in obj) {
                            Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
                        } else {
                            obj[key] = value;
                        }return obj;
                    }

                    var Base = __webpack_require__(6);
                    var Classes = __webpack_require__(8);
                    var Config = __webpack_require__(49);

                    /**
                     * Canvas is in charge of create and calculate dimensions of the svg container where the chart is going to be rendered.
                     * Also creates layers that holds chart's parts (axis, chart area, etc.)
                     * @constructor
                     * @param {D3.selection} container
                     * @param {Object} margin
                     */
                    var Canvas = Base.extend(
                    /**
                     *  @lends Canvas.prototype
                     **/
                    {
                        /** @type {D3 selection} */
                        selection: null,
                        /** @type {Object} */
                        margin: Config.canvasDefaults.margin,
                        /** @type {Number} */
                        axesSpacing: Config.canvasDefaults.axesSpacing,
                        /** @type {Number} */
                        axesPadding: 0,
                        /** @type {DOM element} */
                        container: null,
                        /** @type {DOM element} */
                        svg: null,
                        /** @type {Number} */
                        yAxesLabelWidth: 10,

                        /**
                         * Sets up the canvas object
                         */
                        initializer: function initializer() {
                            var template = this.get("template");

                            if (template && (typeof template === "string" || typeof template === "function")) {
                                this.get("selection").html(template);
                                this.set("container", this.get("selection").select("." + Classes.INNER)[0][0]);
                                this.set("inner", true);
                            } else {
                                this.set("container", this.get("selection")[0][0]);
                            }

                            this.calculate();
                            this.buildSVG();
                        },

                        /**
                         * Update the canvas.
                         * @return {Canvas} this Canvas object.
                         */
                        update: function update() {
                            this.calculate();
                            this.buildSVG();
                            return this;
                        },

                        /**
                         * Returns the width of chart inner container.
                         * @return {Number} Inner container width.
                         */
                        width: function width() {
                            return this.get("width");
                        },

                        /**
                         * Returns the inner container height.
                         * @return {Number} Inner container height.
                         */
                        height: function height() {
                            return this.get("height");
                        },

                        /**
                         * Returns the outer container width.
                         * @return {Number} Outer container width.
                         */
                        outerWidth: function outerWidth() {
                            return this.get("outerWidth");
                        },

                        /**
                         * Returns the outer container height.
                         * @return {Number} Outer container height.
                         */
                        outerHeight: function outerHeight() {
                            return this.get("outerHeight");
                        },

                        /**
                         * Calculates width and height of chart's area.
                         */
                        calculate: function calculate() {
                            var selection = this.get("selection")[0][0];
                            var container = this.get("container");
                            var margin = this.get("margin");

                            this.set("width", container.offsetWidth - margin.left - margin.right);
                            this.set("height", container.offsetHeight - margin.top - margin.bottom);
                            this.set("outerWidth", selection.offsetWidth);
                            this.set("outerHeight", selection.offsetHeight);
                        },

                        /**
                         * Appends the SVG Elements and set its dimensions.
                         * @private
                         */
                        buildSVG: function buildSVG() {
                            var svg = this.get("svg");
                            var margin = this.get("margin");

                            if (!svg) {
                                svg = d3.select(this.get("container")).append("svg").attr("role", "chart").classed(Classes.CANVAS, true);
                                this.set("svg", svg);
                            }

                            this.buildContainerGroups();
                            svg.attrs({
                                width: this.get("width") + margin.left + margin.right,
                                height: this.get("height") + margin.top + margin.bottom
                            });
                        },

                        /**
                         * Build layered contaiers for each charts components in this order:.
                         *
                         * <li> Axes layer. </li>
                         * <li> Behind chart layer. </li>
                         * <li> Chart layer. </li>
                         * <li> Front Chart layer. </li>
                         * @private
                         */
                        buildContainerGroups: function buildContainerGroups() {
                            var margin = this.get("margin");
                            var svg = this.get("svg");
                            var groups = svg.select("." + Classes.LAYERS);

                            if (groups.empty()) {
                                groups = svg.append("g").classed(Classes.LAYERS, true);

                                this.set("axesGroup", groups.append("g").classed(Classes.AXES, true));
                                this.set("backGroup", groups.append("g").classed(Classes.BACK, true));
                                this.set("chartGroup", groups.append("g").classed(Classes.CHART_GROUP, true));
                                this.set("frontGroup", groups.append("g").classed(Classes.FRONT, true));
                            }

                            groups.attrs({
                                transform: "translate(" + margin.left + "," + margin.top + ")"
                            });
                        },

                        /**
                         * Returns a layer inside the chart area, if it does not exist creates it unless avoidCreate is true.
                         *
                         * @param {String} layerName
                         * @param {String} groupName axes, back, front, chart.
                         * @param {Boolean} avoidCreate
                         * @returns {D3.Selection}
                         */
                        layer: function layer(layerName, groupName, avoidCreate) {
                            groupName = (groupName || "chart") + "Group";
                            var group = this.get(groupName);
                            var layer = group.select("." + layerName);

                            if (!avoidCreate && layer.empty()) {
                                layer = group.append("g").classed(layerName, true);
                            }

                            return layer;
                        },

                        /**
                         * Removes a layer inside the given group.
                         *
                         * @param {String} layerName
                         * @param {String} groupName axes, back, front, chart.
                         * @returns {D3.Selection}
                         */
                        removeLayer: function removeLayer(layerName, groupName) {
                            groupName = (groupName || "chart") + "Group";
                            var group = this.get(groupName);
                            group.select("." + layerName).remove();
                        },

                        /**
                         * Remove the old axes (if they exist) and add the new axes into the axes layer.
                         *
                         * @param {AxesManager} axesManager AxesManager containing updated axes.
                         */
                        drawAxes: function drawAxes(axesManager) {
                            var axes = axesManager.axes();
                            var axesCount = {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            };
                            var axesGroup = this.get("axesGroup");
                            var yAxesLabelWidth = this.get("yAxesLabelWidth");
                            var axesSpacing = this.get("axesSpacing") + yAxesLabelWidth;
                            var axesPadding = this.get("axesPadding");
                            var key, axis, translate, orient, count, tickSize, calc;

                            axesGroup.selectAll("." + Classes.AXIS).remove();
                            for (key in axes) {
                                var _axesGroup$append$cla;

                                axis = axes[key];
                                orient = axis.orient();
                                count = axesCount[orient];
                                tickSize = axis.tickSize();

                                switch (orient) {
                                    case "bottom":
                                        translate = "translate(0, " + this.get("height") + ")";
                                        break;
                                    case "right":
                                        calc = axesPadding + (this.get("width") + count * (axesSpacing + tickSize));
                                        translate = "translate(" + calc + ", 0)";
                                        break;
                                    case "top":
                                        translate = "translate(0, 0)";
                                        break;
                                    case "left":
                                        calc = 0 - axesPadding - count * (axesSpacing + tickSize);
                                        translate = "translate(" + calc + ", 0)";
                                        break;
                                    default:
                                        break;
                                }
                                axesCount[orient]++;
                                axesGroup.append("g").classed((_axesGroup$append$cla = {}, _defineProperty(_axesGroup$append$cla, Classes.AXIS, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + key, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + orient, true), _axesGroup$append$cla)).attr("transform", translate).call(axis);
                            }
                        },
                        /**
                         * Removes the canvas from the container and reset the watchers object.
                         */
                        remove: function remove() {
                            this.unwatchAll();
                            this.get("selection").selectAll("*").remove();
                        }
                    });

                    module.exports = Canvas;

                    /***/
                },

                /***/11:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var Utils = __webpack_require__(3);

                    /**
                     * Creates a new DataManager instance.
                     * @example
                     * var dataManager = new DataManager();
                     * @constructor
                     */
                    function DataManager() {
                        /**
                         * @type {Array}
                         * @private
                         */
                        this._data = [];
                        /**
                         * @type {Object}
                         * @private
                         */
                        this._parsers = {};
                        /**
                         * @type {Number} Integer that holds the next index to assign
                         * @private
                         */
                        this._nextIndex = 0;
                    }

                    /**
                     * Gets all series attributes as parameters and returns a series object. This is intended to mantain legacy with previos versions.
                     *
                     * @param {String} seriesName Identifier for the series. Required.
                     * @param {Array} series Array containing the series values. Required.
                     * @param {String} groupName Identifier used to group series.
                     * @param {Boolean} notIndexable If it is true the series is not indexed into the data manager.
                     * @param {String} displayName String to be displayed.
                     * @returns {Object} Series object
                     */
                    function getSetAttributes(args) {
                        var seriesName, series, groupName, notIndexable, displayName;
                        seriesName = args[0];
                        series = args[1];
                        groupName = args[2];
                        notIndexable = args[3];
                        displayName = args[4];

                        if (!seriesName || !series) {
                            return;
                        }

                        return {
                            name: seriesName,
                            series: series,
                            group: groupName,
                            notIndexable: notIndexable,
                            display: displayName
                        };
                    }

                    /**
                     * Recalculate indexed series indexes.
                     *
                     * @param {Array} data Array of series object.
                     */
                    function recalcIndexes(data) {
                        data.forEach(function (dataItem, i) {
                            if (dataItem.index !== -1) {
                                dataItem.index = i;
                            }
                        });
                    }

                    /**
                     * Recalculate in-group indexes.
                     *
                     * @param {any} groupArray
                     */
                    function recalcGroupIndexes(groupArray) {
                        groupArray.forEach(function (item, i) {
                            item.groupIndex = i;
                        });
                    }

                    /**
                     * Adds a series to the data manager. Receives an <i>Options Object</i> this way:
                     * <br><br>
                     * <code>
                     * {
                     *   name: "green_apples" // String
                     *   series: [10, 20, 30, 40], // Array
                     *   group: "Fruits",
                     *   display: "Green Apples",
                     *   notIndexable: false
                     * }
                     * </code>
                     * <br>The <b>name</b> is the identifier for each series.
                     * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
                     * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
                     * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
                     * <br>If <b>notIndexable</b> is false, then the series is being indexed, non indexed series has index equals to -1.
                     * <br><br>
                     * For each series the datamanager creates a <i>Series Object</i> like:
                     * <code>
                     * {
                     *   name: "green_apples",
                     *   series: [10, 20, 30, 40],
                     *   groupName: "Fruits",
                     *   displayName: "Green Apples",
                     *   index: 0,
                     *   groupIndex: 0
                     * }
                     * </code>
                     * @example
                     * var dataManager = new DataManager();
                     * // Minimal
                     * dataManager.set({
                     *   name: "Bar Chart Data",
                     *   series: [40, 50, 60, 25]
                     * });
                     *
                     * // If you need grouped data for a grouped bar chart for example.
                     *
                     * dataManager.set(
                     *   name: "apples",
                     *   display: "Apples",
                     *   series: [25, 45, 43, 20],
                     *   group: "grouped-bar-chart-data"
                     * });
                     *
                     * dataManager.set({
                     *   name: "oranges",
                     *   display: "Oranges",
                     *   series: [5, 20, 16, 27],
                     *   group: "grouped-bar-chart-data"
                     * });
                     *
                     * @param {Object} options Set of options.
                     */
                    DataManager.prototype.set = function (options) {
                        var groupName, groupIndex;
                        if (!options) {
                            return;
                        }

                        // For legacy purposes.
                        if (typeof options === "string") {
                            options = getSetAttributes(arguments);
                            if (typeof options === "undefined") {
                                return;
                            }
                        }

                        groupName = options.group || options.name;
                        groupIndex = this.queryGroup(groupName).length;

                        this._data.push({
                            name: options.name,
                            series: options.series,
                            groupName: groupName,
                            displayName: options.display || options.name,
                            index: !options.notIndexable ? this._nextIndex++ : -1,
                            groupIndex: groupIndex,
                            color: options.color
                        });
                    };

                    /**
                     * Unindexed Set, Same of set method but without set index to data, assing index = -1
                     * Adds an unindexed series to the data manager. Receives an <i>Options Object</i> this way:
                     * <br><br>
                     * <code>
                     * {
                     *   name: "green_apples" // String
                     *   series: [10, 20, 30, 40], // Array
                     *   group: "Fruits",
                     *   display: "Green Apples",
                     * }
                     * </code>
                     * <br>The <b>name</b> is the identifier for each series.
                     * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
                     * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
                     * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
                     * @see set
                     * @param {Object} options Set of options.
                     */
                    DataManager.prototype.uset = function (options) {
                        if (typeof options === "string") {
                            options = getSetAttributes(arguments);
                            if (typeof options === "undefined") {
                                return;
                            }
                        }

                        options.notIndexable = true;
                        this.set(options);
                    };

                    /**
                     * Update the series data specified by <i>seriesName</i>.
                     * @example
                     * dataManager.update("Apples", [2, 4, 6, 8]);
                     * @param {String} seriesName Name of the series to update.
                     * @param {Array} series Array of data to update.
                     */
                    DataManager.prototype.update = function (seriesName, series) {
                        var query = this._data.filter(function (series) {
                            return series.name === seriesName;
                        });

                        var item;

                        if (query.length) {
                            item = query[0];
                            item.series = series;
                        }
                    };

                    /**
                     * Removes a series from the data manager based on the series name.
                     *
                     * @param {String} seriesName Identifier of the series to remove.
                     *
                     * @return {Object} Removed Series Object.
                     */
                    DataManager.prototype.remove = function (seriesName) {
                        var index = Utils.array.indexOf(this._data, "name", seriesName);
                        this._nextIndex = 0;
                        var removed;
                        if (index !== -1) {
                            removed = this._data.splice(index, 1);

                            // Recalculate general indexes
                            recalcIndexes(this._data);

                            // Recalculate group indexes
                            recalcGroupIndexes(this.queryGroup(removed[0].groupName));
                        }

                        return removed;
                    };

                    /**
                     * Resets the Datamanager.
                     */
                    DataManager.prototype.clean = function () {
                        this._data = [];
                        this._parsers = {};
                        this._nextIndex = 0;
                    };

                    /**
                     * Search for the series in a determined group.
                     *
                     * @param {String} groupName Name of the group to search.
                     * @returns {Array<Object>} Series in the group
                     */
                    DataManager.prototype.queryGroup = function (groupName) {
                        return this._data.filter(function (series) {
                            return series.groupName === groupName;
                        });
                    };

                    /**
                     * If no parser is setted for the group then returns the raw data array from the store.
                     * <br><br>
                     * If parser is setted, then returns the data parsed by the function.
                     *
                     * @example
                     * function parser(data, domain) {
                     *   // data contains an array of series objects {}
                     *   // domain is an argument
                     *   var map = domain.map(function (point, i) {
                     *       var obj = { point: point };
                     *
                     *       obj.values = data.map(function (value) {
                     *           return {
                     *               series: value.name,
                     *               value: value.series[i]
                     *           };
                     *       });
                     *       return obj;
                     *   });
                     *   return map;
                     * }
                     *
                     * dataManager.parser("grouped-bar-chart-data", parser, ["Mon", "Tue", "Wed", "Thu"]);
                     * var data = dataManager.get("grouped-bar-chart-data";
                     * //  Resultingdata:
                     * //  [{
                     * //      point: "Mon",
                     * //      values: {[
                     * //          series: "Apples",
                     * //          value: 25
                     * //      ],[
                     * //          series: "Oranges",
                     * //          value: 5
                     * //      ]...}
                     * //  } ...]
                     *
                     * @param {any} groupName
                     * @returns {Array} Array that contains data.
                     */
                    DataManager.prototype.get = function (groupName) {
                        if (!groupName) {
                            return;
                        }

                        var data = this.queryGroup(groupName);
                        var parser = this._parsers[groupName];
                        var args;

                        if (!parser) {
                            return data;
                        } else {
                            args = [data].concat(parser.arguments);
                            return parser.fn.apply(this, args);
                        }
                    };

                    /**
                     * Calculates the domain for the groups in _groupArray_, if not _groupArray_ is specified calculates for all data in the store.
                     * <br><br>
                     * Also rounds the domains to the nearest tenth (by default) or by the value specified in _roundDomainTo_.
                     * @example
                     * // There are 3 data groups: datagroup-1, datagroup-2 and datagroup-3.
                     *
                     * // Calculates domain only for groups datagroup-1 and datagroup-3.
                     * var domain = dataManager.calculateDomain({
                     *    groups: ["datagroup-1", "datagroup-2"]
                     * });
                     *
                     * // Calculates domain for all groups.
                     * var domain = dataManager.calculateDomain();
                     *
                     * // Calculates domain for all groups and round it to hundreds.
                     * var domain = dataManager.calculateDomain({
                     *  roundTo: 100
                     *});
                     *
                     * // Calculates domain only for datagroup-3 and round it to hundreds.
                     * var domain = dataManager.calculateDomain({
                     *   groups: ["datagroup-3"],
                     *   roundTo: 1000
                     * });
                     * @param {Object}? options Options available:
                     * <li><b>groups:</b> Optional. Array of names of the data groups to include in the domain calculation.
                     * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
                     * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
                     * <li><b>symmetrical:</b> Optional.
                     * <li><b>steps:</b> Optional. Intended ticks number.
                     * <li><b>accessor:</b> Optional. To access data.
                     * <li><b>raw:</b> Optional. Force the domain calculation using unrounded values.
                     *
                     * @returns {Array} An array of length 2 with the calculated domain
                     */
                    DataManager.prototype.calculateDomain = function (options) {
                        options = options || {};
                        var _this = this;
                        var values = [];
                        var groupArray = options.groups;
                        var domainOptions = {
                            forceNegative: options.forceNegative,
                            symmetrical: options.symmetrical,
                            steps: options.steps,
                            integers: options.integers,
                            raw: options.raw
                        };

                        // If not defined get all groups
                        if (!groupArray) {
                            groupArray = Utils.array.removeDuplicates(this._data.map(function (data) {
                                return data.groupName;
                            }));
                        }

                        groupArray.forEach(function (group) {
                            var query = _this.queryGroup(group);
                            var series;

                            var accessorMap = function accessorMap(item, accessor) {
                                return item.series.map(function (d) {
                                    return Utils.object.extract(d, accessor);
                                });
                            };

                            if (options.stacked) {
                                series = query.map(function (item) {
                                    if (options.accessor) {
                                        return accessorMap(item, options.accessor);
                                    } else {
                                        return item.series;
                                    }
                                });

                                values = values.concat(Utils.array.getStackedValues(series));
                            } else {
                                query.forEach(function (item) {
                                    if (options.accessor) {
                                        values = values.concat(accessorMap(item, options.accessor));
                                    } else {
                                        values = values.concat(item.series);
                                    }
                                });
                            }
                        });

                        // check values
                        values = values.map(function (value) {
                            return typeof value !== "undefined" ? value : 0;
                        });

                        var min = d3.min(values);
                        var max = d3.max(values);
                        var highest;
                        var forceNegative = options.forceNegative;

                        if (min === 0 && max === 0) {
                            return forceNegative ? [-1, 1] : [0, 1];
                        }

                        if (max % 10 === 0) {
                            values.push(max + 10);
                        }

                        if (min < 0 && min % 10 === 0) {
                            values.push(min - 10);
                        }

                        if (typeof options.roundTo === "number") {
                            domainOptions.roundTo = options.roundTo;
                        } else if (min > -1 && max < 1) {
                            return min < 0 || forceNegative ? [-1, 1] : [0, 1];
                        } else if (max < 10 && min > -10) {
                            highest = Math.max(Math.abs(min), Math.abs(max));
                            domainOptions.roundTo = highest % 2 === 0 ? highest % 6 === 0 ? 4 : 3 : 2;
                        } else {
                            domainOptions.roundTo = Utils.array.getRoundToUnits(values);
                        }

                        domainOptions.values = values;
                        return Utils.chart.getDomain(domainOptions);
                    };

                    /**
                     * Sets a parser (formatter) function for a determined group of data. If arguments are passed they are passed too to the parser function as parameters.
                     *
                     * @param {any} groupName
                     * @param {any} parser
                     * @returns {Function} If only one argument is passed
                     */
                    DataManager.prototype.parser = function (groupName, parser) {
                        var newParser;
                        if (!groupName) {
                            return;
                        }

                        if (!parser) {
                            return this._parsers[groupName];
                        }

                        newParser = {};
                        newParser.fn = parser;
                        newParser.arguments = Array.prototype.slice.call(arguments, 2);

                        this._parsers[groupName] = newParser;
                        return parser;
                    };

                    /**
                     * Returns all data combined
                     * @example
                     *  dataManager.set("Cars", [10, 20], "vehicles");
                     *  dataManager.set("Planes", [30, 40], "vehicles");
                     *  dataManager.set("Tricycle", [5, 15], "tricycle");
                     *
                     *  dataManager.combine("tricycle")
                     *  dataManager.combine(["vehicles", "tricycle"])
                     *
                     * @param {Array|String} groupNames The name of a group name or an array containing all group names you want to get data combined.
                     * @return {Array} Data combined.
                     */
                    DataManager.prototype.combine = function (groupNames) {
                        var metadataArray = [];
                        var seriesArray = [];
                        var combined = [];
                        var i = 0;
                        var j = 0;
                        var len, pointObj, seriesLength, metadata, value;
                        groupNames = typeof groupNames === "string" ? [groupNames] : groupNames;
                        groupNames.forEach(function (seriesObject) {
                            this.queryGroup(seriesObject).forEach(function (point) {
                                seriesArray.push(point.series);
                                metadataArray.push({
                                    name: point.name,
                                    groupName: point.groupName,
                                    displayName: point.displayName,
                                    index: point.index,
                                    groupIndex: point.groupIndex
                                });
                            });
                        }.bind(this));

                        len = seriesArray[0].length;
                        seriesLength = seriesArray.length;

                        for (; i < len; i++) {
                            pointObj = [];
                            j = 0;
                            for (; j < seriesLength; j++) {
                                value = seriesArray[j][i];
                                metadata = metadataArray[j];
                                pointObj.push({
                                    name: metadata.name,
                                    groupName: metadata.groupName,
                                    displayName: metadata.displayName,
                                    index: metadata.index,
                                    value: value,
                                    groupIndex: metadata.groupIndex
                                });
                            }

                            combined.push(pointObj);
                        }

                        return combined;
                    };

                    /**
                     * Returns <b>true</b> if a series is contained in a give group.
                     * @param {String} seriesName
                     * @param {String} groupName
                     * @returns {Boolean}
                     */
                    DataManager.prototype.inGroup = function (seriesName, groupName) {
                        var group = this.queryGroup(groupName);
                        var len = group.length;
                        var i;

                        for (i = 0; i < len; i++) {
                            if (group[i].name === seriesName) {
                                return true;
                            }
                        }

                        return false;
                    };

                    module.exports = DataManager;

                    /***/
                },

                /***/117:
                /***/function _(module, exports, __webpack_require__) {

                    module.exports = __webpack_require__(16);

                    /***/
                },

                /***/12:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    /**
                     * Creates a new ScaleManager instance.
                     *
                     * @constructor
                     * @param {Object} scales
                     */

                    function ScaleManager(scales) {
                        this._scales = scales || {};
                    }

                    /**
                     * Sets a new scale, if no <i>scale</i> is passed then returns the scale object.
                     *
                     * @param {String} scaleName Name for the scale.
                     * @param {D3.scale} scale
                     * @returns {D3.scale}
                     */
                    ScaleManager.prototype.scale = function (scaleName, scale) {
                        if (!scaleName) {
                            return;
                        }

                        if (!scale) {
                            return this._scales[scaleName];
                        }

                        this._scales[scaleName] = scale;
                    };

                    /**
                     * Sets the scale's domain, if no <i>domain</i> is passed returns it.
                     *
                     * @param {String} scaleName
                     * @param {Array} domain
                     * @returns {Array} Domain for a specific scale.
                     */
                    ScaleManager.prototype.domain = function (scaleName, domain) {
                        if (!scaleName) {
                            return;
                        }

                        if (!domain) {
                            return this._scales[scaleName].domain();
                        }

                        this._scales[scaleName].domain(domain);
                    };

                    /**
                     * Sets the scale's range, if no _range_ is passed returns it.
                     *
                     * @param {String} scaleName
                     * @param {Array} range
                     * @returns Range for a specific scale.
                     */
                    ScaleManager.prototype.range = function (scaleName, range) {
                        if (!scaleName) {
                            return;
                        }

                        if (!range) {
                            return this._scales[scaleName].range();
                        }

                        this._scales[scaleName].range(range);
                    };

                    /**
                     * Remove a scale from the hashmap.
                     * @param {String} scaleName Scale to remove.
                     */
                    ScaleManager.prototype.remove = function (scaleName) {
                        delete this._scales[scaleName];
                    };

                    module.exports = ScaleManager;

                    /***/
                },

                /***/13:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    /** @module Core */

                    var AxesManager = __webpack_require__(9);
                    var Canvas = __webpack_require__(10);
                    var Chart = __webpack_require__(38);
                    var DataManager = __webpack_require__(11);
                    var Base = __webpack_require__(6);
                    var ScalesManager = __webpack_require__(12);
                    var Utils = __webpack_require__(3);
                    var Classes = __webpack_require__(8);
                    var d3Overrides = __webpack_require__(50);
                    var Axes = __webpack_require__(40);

                    // D3 overrides
                    d3Overrides();

                    module.exports = {
                        /**
                         * @see AxesManager
                         */
                        AxesManager: AxesManager,
                        /**
                         * @see Canvas
                         */
                        Canvas: Canvas,
                        /**
                         * @see Chart
                         */
                        Chart: Chart,
                        /**
                         * @see Base
                         */
                        Base: Base,
                        /**
                         * @see ScalesManager
                         */
                        ScalesManager: ScalesManager,
                        /**
                         * @see DataManager
                         */
                        DataManager: DataManager,
                        /**
                        * @see Utils
                        */
                        Utils: Utils,
                        /**
                         * @see Classes
                         */
                        Classes: Classes,
                        /**
                        * @see Axes
                        */
                        Axes: Axes
                    };

                    /***/
                },

                /***/14:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var extract = __webpack_require__(2).extract;
                    /**
                     * Returns true if an array contains just null values. If the parameter is a falsey value returns undefined.
                     * @example
                     * Util.array.hasNulls([null, null, null]) // returns true
                     *  @param {Array} arr Array to inspect.
                     * @return {Boolean} true means that the array contains null values.
                     **/
                    var hasNulls = function hasNulls(arr) {
                        if (!arr) return;
                        var len = arr.length;
                        var i = 0;
                        for (; i < len; i++) {
                            if (arr[i] !== null) {
                                return false;
                            }
                        }

                        return true;
                    };

                    /**
                     * Returns false if the array passed contains negative values.
                     *
                     * @param {Array<Number>} allValues Numeric array.
                     * @return {Boolean} Boolean indicating if the array contains at least one negative value.
                     */
                    var hasNegative = function hasNegative(allValues) {
                        if (!allValues) return;
                        return d3.min(allValues) < 0;
                    };

                    /**
                     * Return a new array with absolute numbers.
                     * @param {Array<Number>} allValues Input array of numbers.
                     */
                    var getAllPositives = function getAllPositives(allValues) {
                        return allValues.map(function (val) {
                            return Math.abs(val);
                        });
                    };

                    /**
                     * Rmoves duplicates from an array.
                     *
                     * @export
                     * @param {Array} array Source array.
                     * @returns {Array} Array without duplicates.
                     */
                    var removeDuplicates = function removeDuplicates(array) {
                        if (!array) return;
                        return array.filter(function (elem, index, _this) {
                            return index === _this.indexOf(elem);
                        });
                    };

                    var indexOf = function indexOf(array, property, search) {
                        var i, len;
                        for (i = 0, len = array.length; i < len; i++) {
                            if (array[i][property] === search) return i;
                        }

                        return -1;
                    };

                    /**
                     * Returns and array with all values stacked by index, it includes negative and positive values
                     * @param {Array} arrays Array of arrays containig series values.
                     * @return {Array} Array with all values.
                     */
                    var getStackedValues = function getStackedValues(arrays) {
                        var i = 0;
                        var j = 0;
                        var arrLength = arrays.length;
                        var length = -1;
                        var positive = 0;
                        var negative = 0;
                        var stacked = [];
                        var actualLength, value;

                        // Check array lengths
                        for (; i < arrLength; i++) {
                            actualLength = arrays[i].length;
                            if (length !== -1 && actualLength !== length) {
                                throw new Error("Arrays must have the same length");
                            }

                            length = actualLength;
                        }

                        i = 0;
                        for (; i < length; i++) {
                            for (; j < arrLength; j++) {
                                value = arrays[j][i];
                                if (value >= 0) {
                                    positive += value;
                                } else {
                                    negative += value;
                                }
                            }

                            stacked.push(Math.round(positive));
                            if (negative !== 0) stacked.push(Math.round(negative));
                            positive = 0;
                            negative = 0;
                            j = 0;
                        }

                        return stacked;
                    };

                    /**
                     * It searches for the min and max value inside an array.
                     *
                     * @param {any} array
                     * @param {any} accesor
                     * @returns Object
                     */
                    function minmax(array, accesor) {
                        var len = array.length;
                        var i = 0;
                        var obj, value, min, max, minValue, maxValue;
                        for (; i < len; i++) {
                            obj = array[i];
                            value = extract(obj, accesor);

                            if (typeof minValue === "undefined" || value < minValue) {
                                minValue = value;
                                min = array[i];
                            }

                            if (typeof maxValue === "undefined" || value > maxValue) {
                                maxValue = value;
                                max = array[i];
                            }
                        }

                        return { min: min, max: max };
                    }

                    /**
                     * It returns the thousandths, hundredths, tenths, hundred, thousands to round the domain.
                     *
                     * @param {Number[]} array Array of numbers.
                     * @return {Number} 0.001, 0.01, 0.1, 1, 10, 100, 1000, ...
                     */
                    function getRoundToUnits(array) {
                        if (!array || !array.length) return 1;
                        var absMean = d3.mean(array, function (d) {
                            return Math.abs(d);
                        });

                        if (absMean === 0) return 1;
                        if (absMean >= 1) {
                            absMean = Math.ceil(absMean / 10);
                            return Math.pow(10, ("" + absMean).length);
                        } else {
                            var decimals = ("" + absMean).split(".")[1];
                            var match = decimals.match(/[^0]/);
                            return 1 / Math.pow(10, match.index + 1);
                        }
                    }

                    module.exports = {
                        getAllPositives: getAllPositives,
                        getRoundToUnits: getRoundToUnits,
                        getStackedValues: getStackedValues,
                        hasNegative: hasNegative,
                        hasNulls: hasNulls,
                        indexOf: indexOf,
                        minmax: minmax,
                        removeDuplicates: removeDuplicates
                    };

                    /***/
                },

                /***/16:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    __webpack_require__(98);

                    var _core = __webpack_require__(13);

                    var _core2 = _interopRequireDefault(_core);

                    function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : { default: obj };
                    }

                    /** @module Core */

                    module.exports = _core2.default;

                    /***/
                },

                /***/2:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    /**
                     * Given a path it extract a value from a complex deep object.
                     *
                     * @param {Object} obj
                     * @param {String} path
                     * @returns Object's value found in the given path.
                     */

                    function getPath(obj, path) {
                        var index, prefix, subpath;
                        if (!obj || !path || typeof path !== "string" || path === "") {
                            return;
                        }

                        index = path.indexOf(".");
                        if (index === -1) {
                            return obj[path];
                        } else {
                            prefix = path.substring(0, index);
                            subpath = path.substring(index + 1);
                            return getPath(obj[prefix], subpath);
                        }
                    }

                    /**
                     * Copy source object properties into a target one.
                     *
                     * @export
                     * @param {Object} target Target object.
                     * @param {Object} source Source Object
                     */
                    var copy = function copy(target) {
                        var key, source;

                        if (!target) {
                            return;
                        }

                        for (var i = 1; i < arguments.length; i++) {
                            source = arguments[i];
                            for (key in source) {
                                if (source.hasOwnProperty(key)) {
                                    target[key] = source[key];
                                }
                            }
                        }

                        return target;
                    };

                    /**
                     * Extracts a value using an accessor or the same value if no accessor.
                     * @param {Object} item Contains the value.
                     * @param {Function|String}? accessor Accesor function or field that contains the value.
                     * @param {Object} params Parameters to pass to the accesor function.
                     * @return {Object} Value.
                     */
                    var extract = function extract(item, accessor, params) {
                        var value;
                        if (typeof accessor === "undefined") {
                            value = item;
                        } else if (typeof accessor === "function") {
                            value = accessor(item, params);
                        } else if (typeof accessor === "string") {
                            value = item[accessor];
                        }

                        return value;
                    };

                    /**
                     * Clones and object.
                     *
                     * @export
                     * @param {Object} target Object toclone.
                     * @returns {Object} Cloned object.
                     */
                    var clone = function clone(target) {
                        if (target === undefined || target === null) {
                            throw new TypeError("Cannot convert first argument to object");
                        }

                        var to = Object(target);
                        for (var i = 1; i < arguments.length; i++) {
                            var nextSource = arguments[i];
                            if (nextSource === undefined || nextSource === null) {
                                continue;
                            }

                            var keysArray = Object.keys(Object(nextSource));
                            for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                                var nextKey = keysArray[nextIndex];
                                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                                if (desc !== undefined && desc.enumerable) {
                                    to[nextKey] = nextSource[nextKey];
                                }
                            }
                        }

                        return to;
                    };

                    /**
                     * If just the value is passed return a boolean indicated is the value is undefined.
                     * If the second parameter exists if value is undefined retunrs the second parameter, if not returns the value.
                     * @param {Obect} value Object to evaluate.
                     * @param {Object} defaultValue Object to return in case vale¡ue is undefined.
                     */
                    var isUndefined = function isUndefined(value, defaultValue) {
                        if (typeof defaultValue !== "undefined") return typeof value === "undefined" ? defaultValue : value;else return typeof value === "undefined";
                    };

                    /**
                     * Check if the given value is not a number then return null, if it is a number return the number.
                     * @param {Object} val Value to check.
                     * @returns {undefined|Number}
                     */
                    var NaNtoNull = function NaNtoNull(val) {
                        if (typeof val !== "number" || isNaN(val) || val === Infinity) {
                            return null;
                        } else {
                            return val;
                        }
                    };

                    /**
                     * Method to get the boolean value, if not it returnd a default value.
                     * @param {Object} value Value to check if it is a boolean.
                     * @param {Boolean} defaultValue Default value in case value is not a boolean.
                     * @returns {Boolean}
                     */
                    var getBoolean = function getBoolean(value, defaultValue) {
                        return typeof value === "boolean" ? value : defaultValue;
                    };

                    var assign = function assign(target) {
                        // .length of function is 2
                        if (target == null) {
                            // TypeError if undefined or null
                            throw new TypeError('Cannot convert undefined or null to object');
                        }

                        var to = Object(target);

                        for (var index = 1; index < arguments.length; index++) {
                            var nextSource = arguments[index];

                            if (nextSource != null) {
                                // Skip over if undefined or null
                                for (var nextKey in nextSource) {
                                    // Avoid bugs when hasOwnProperty is shadowed
                                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                        to[nextKey] = nextSource[nextKey];
                                    }
                                }
                            }
                        }
                        return to;
                    };

                    module.exports = {
                        clone: clone,
                        copy: copy,
                        extract: extract,
                        getBoolean: getBoolean,
                        isUndefined: isUndefined,
                        NaNtoNull: NaNtoNull,
                        path: getPath,
                        assign: assign
                    };

                    /***/
                },

                /***/3:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var array = __webpack_require__(14);
                    var chart = __webpack_require__(41);
                    var fn = __webpack_require__(45);
                    var object = __webpack_require__(2);
                    var str = __webpack_require__(47);
                    var svg = __webpack_require__(48);
                    var colors = __webpack_require__(42);
                    var number = __webpack_require__(46);
                    var generators = __webpack_require__(44);

                    /** @module Core/Utils */

                    module.exports = {
                        assign: object.assign,
                        callFn: fn.call,
                        clone: object.clone,
                        convertDashToEnDash: str.convertDashToEnDash,
                        copy: object.copy,
                        dashify: str.dashify,
                        extract: object.extract,
                        getBoolean: object.getBoolean,
                        getDomain: chart.getDomain,
                        getGreaterSVGTextWidth: svg.getGreaterSVGTextWidth,
                        getRoundToUnits: array.getRoundToUnits,
                        getStackedValues: array.getStackedValues,
                        getSVGTextWidth: svg.getSVGTextWidth,
                        getTickValues: chart.getTickValues,
                        hasNegative: array.hasNegative,
                        indexOf: array.indexOf,
                        isUndefined: object.isUndefined,
                        minmax: array.minmax,
                        NaNtoNull: object.NaNtoNull,
                        removeDuplicates: array.removeDuplicates,
                        template: str.template,
                        UID: str.UID,

                        array: array,
                        chart: chart,
                        fn: fn,
                        object: object,
                        string: str,
                        svg: svg,
                        colors: colors,
                        number: number,
                        generators: generators
                    };

                    /***/
                },

                /***/38:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    function _defineProperty(obj, key, value) {
                        if (key in obj) {
                            Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
                        } else {
                            obj[key] = value;
                        }return obj;
                    }

                    var AxesManager = __webpack_require__(9);
                    var Base = __webpack_require__(6);
                    var Canvas = __webpack_require__(10);
                    var DataManager = __webpack_require__(11);
                    var ScalesManager = __webpack_require__(12);
                    var Utils = __webpack_require__(3);
                    var Classes = __webpack_require__(8);

                    /**
                     * A foundation for all axed charts.
                     * The renderng cycle is:
                     * <em><br>0- setData() Data is initialized.
                     * <br>1- beforeDraw() method is called. Event <i>beforeDraw</i> is triggered.
                     * <br>2- draw() method is called.
                     * <br>3- afterDraw() method called. Event <i>afterDraw</i> is triggered.</em>
                     * <br><br><small>Methods setData() and draw() MUST be implemented</small>
                     * @example
                     * var BarChart = Chart.extend({
                     *  ...
                     * })
                     * @param {Object} options
                     * @class
                     * @extends Base
                     */
                    var Chart = Base.extend(
                    /**
                     * A foundation for all axed charts.
                     *  @lends Chart.prototype
                     **/
                    {
                        /** @type {String} */
                        UID: null,
                        /** @type {AxisManager} */
                        axes: null,
                        /** @type {Canvas} */
                        canvas: null,
                        /** @type {DataManager} */
                        data: null,
                        /** @type {Array} */
                        colors: Utils.colors.combined,
                        /** @type {D3.dispatch} */
                        dispatch: null,
                        /** @type {ScaleManager} */
                        scales: null,
                        /** @type {Object} */
                        margins: { top: 20, right: 40, bottom: 30, left: 40 },
                        /** @type {String} */
                        canvasTemplate: null,
                        /** @type {Number} */
                        yAxesLabelWidth: 0,
                        /** @type {String} */
                        legendPopoverParentElement: 'body', // pass string selector id including # (e.g. '#line-chart-container') or class including . (e.g. '.mbc-line-chart') of element to append popover

                        /**
                         * Initializes the chart.
                         */
                        initializer: function initializer() {
                            this.set("UID", "mbc" + Utils.string.UID());
                            this.set("axes", new AxesManager());
                            this.set("data", new DataManager());
                            this.set("dispatch", d3.dispatch("hover", "click", "afterDraw", "beforeDraw", "mouseout"));
                            this.set("scales", new ScalesManager());
                            d3.rebind(this, this.get("dispatch"), "on");
                        },

                        /**
                         * Returns the function D3 calls to set the data.
                         * @example
                         * container.datum(dataset).call(chart.init());
                         *
                         * @returns {Function}
                         */
                        init: function init() {
                            return this._createChart.bind(this);
                        },
                        /**
                         * Adds a new Canvas object and calls the _prepare function for each selection
                         * @param {D3.Selection} name Selection where the charts are going to be created.
                         * @private
                         */
                        _createChart: function _createChart(selection) {
                            var _selection$classed;

                            this.set("selection", selection);
                            selection.classed((_selection$classed = {}, _defineProperty(_selection$classed, this.get("id") || "", true), _defineProperty(_selection$classed, this.get("UID"), true), _selection$classed));
                            this._createCanvas();
                            selection.each(this._prepare.bind(this));
                        },

                        /**
                         * Create and set a new canvas instance.
                         */
                        _createCanvas: function _createCanvas() {
                            var selection = this.get("selection");
                            // beforeCanvas method is called if exists.
                            Utils.fn.call(this, this.beforeCanvas, selection);
                            this.set("canvas", new Canvas({
                                selection: selection,
                                margin: this.get("margins"),
                                template: this.get("canvasTemplate"),
                                yAxesLabelWidth: this.get("yAxesLabelWidth"),
                                UID: this.get("UID")
                            }));
                        },

                        /**
                         * Calls the setData or/and setup function if they exist and calls the rendering cycle if the data is valid.
                         * @private
                         */
                        _prepare: function _prepare(data) {
                            var invalidData = false;
                            invalidData = Utils.fn.call(this, this.setup, data);
                            /* FIXME: remove setData call next major version */
                            invalidData = invalidData || Utils.fn.call(this, this.setData, data);
                            if (!invalidData) this.update();
                        },

                        /**
                         * Executes the rendering cycle in this order
                         * <li> beforeDraw
                         * <li> draw
                         * <li> afterDraw
                         */
                        update: function update(options) {
                            this.get("dispatch").beforeDraw();
                            var updateCanvas = Utils.fn.call(this, this.beforeDraw, options);
                            if (typeof updateCanvas === "undefined" || updateCanvas) this.get("canvas").update();
                            this.draw(options);
                            Utils.fn.call(this, this.afterDraw, options);
                            this.get("dispatch").afterDraw();
                        },

                        /**
                         * Returns the index *n* color from the *colors* attribute array
                         * @param {Number} index Index of color to return
                         */
                        color: function color(index) {
                            var colors = this.get("colors");
                            return colors[index % colors.length];
                        },

                        /**
                         * Returns a closure function with a formatter within.
                         * @param {Function|String} format If it is a string uses d3.format.
                         */
                        tickFormat: function tickFormat(format) {
                            return function (d, i) {
                                if (!format) {
                                    return d;
                                }

                                return typeof format === "function" ? format(d, i) : d3.format(format)(d);
                            };
                        },

                        /**
                         * @abstract
                         * @deprecated Use setup method instead.
                         * Prepare the data for the chart and all the initial values prior to start rendering. Legacy.
                         */
                        setData: function setData() {},

                        /**
                         * @abstract
                         * Prepare the data for the chart and all the initial values prior to start rendering.
                         */
                        setup: function setup() {},

                        /**
                         * @abstract
                         * This method is called before creating the canvas instance, is useful to change the template before.
                         */
                        beforeCanvas: function beforeCanvas() {},

                        /**
                         * @abstract
                         * This method is called before drawing the chart. Useful to prepare data when the SVG element is already inserted into the dom.
                         */
                        beforeDraw: function beforeDraw() {},

                        /**
                         * @abstract
                         * Used to draw the chart into the SVG element.
                         */
                        draw: function draw() {
                            console.error(new Error("draw method is not defined"));
                        },

                        /**
                         * @abstract
                         * Called after the chart is rendered. Useful to make post-render modifications.
                         */
                        afterDraw: function afterDraw() {},

                        /**
                         * Returns an id based class.
                         * @param {String} suffix Suffix to add to the id.
                         * @return {String} The class name (id + suffix).
                         */
                        getId: function getId(suffix) {
                            return this.get("id") + "-" + suffix;
                        },

                        /**
                         * @adjustYLabels
                         * Visual adjustments after the chart has been rendered
                         * appendYAbbreviation and adjustYAxisLabel
                         */
                        adjustYLabels: function adjustYLabels() {
                            var axes = this.get("canvas").get("axesGroup");

                            axes.selectAll(".x-alternative-first, .x-alternative-last").remove();

                            axes.selectAll("." + Classes.AXIS + "-left .tick text, ." + Classes.AXIS + "-right .tick text").attrs({ x: 0, y: 12 });

                            var y1Ticks = axes.selectAll("." + Classes.AXIS + "-y1 .tick");
                            y1Ticks.first().classed("dark", true).select("text").attr("y", -10);

                            y1Ticks.last().classed("dark", true);

                            var y2Ticks = axes.selectAll("." + Classes.AXIS + "-y2 .tick");
                            y2Ticks.first().classed("dark", true).select("text").attr("y", -10);

                            y2Ticks.last().classed("dark", true);

                            var y1TicksAlign = this.get("y1TicksAlign");
                            var y1AxisOrient = this.get("y1AxisOrient");
                            var y1Texts = axes.selectAll("." + Classes.AXIS + "-y1 text");
                            if (y1TicksAlign === "right" && y1AxisOrient === "right") {
                                y1Texts.attr("x", this.get("yTickSize")).style("text-anchor", "end");
                            }

                            if (y1TicksAlign === "left" && y1AxisOrient === "left") {
                                y1Texts.attr("x", this.get("yTickSize") * -1).style("text-anchor", "start");
                            }

                            if (this.get("y2TicksAlign") === "right" && this.get("y2AxisOrient") === "right") {
                                axes.selectAll("." + Classes.AXIS + "-y2 text").attr("x", this.get("yTickSize")).style("text-anchor", "end");
                            }

                            this.appendYAbbreviation(axes);

                            this.adjustYAxisLabel("y1");
                            if (this.get("y2")) {
                                this.adjustYAxisLabel("y2");
                            }
                        },

                        /**
                         * Appends Y axes abbreviations under the up most tick.
                         * Checks for 'y1Abbreviation' and 'y2Abbreviation.
                         */
                        appendYAbbreviation: function appendYAbbreviation(axes) {
                            var appendAbbrev = function appendAbbrev(tick, abbrev, align) {
                                var lastText = tick.select("text");
                                tick.append("text").attrs({
                                    "text-anchor": align === "right" ? "end" : "start",
                                    x: lastText.attr("x"),
                                    y: lastText.attr("y") * 2 + 4,
                                    dy: lastText.attr("dy")
                                }).classed("mbc-tick-abbreviation", true).text(abbrev);
                            };

                            var lastTick, textAlign;
                            var y1Abbrev = this.get("y1Abbreviation"),
                                y2Abbrev = this.get("y2Abbreviation");
                            if (y1Abbrev) {
                                lastTick = axes.selectAll("." + Classes.AXIS + "-y1 .tick").last();
                                textAlign = this.get("y1TicksAlign");
                                appendAbbrev(lastTick, y1Abbrev, textAlign);
                            }

                            if (this.get("y2") && y2Abbrev) {
                                lastTick = axes.selectAll("." + Classes.AXIS + "-y2 .tick").last();
                                textAlign = this.get("y2TicksAlign");
                                appendAbbrev(lastTick, y2Abbrev, textAlign);
                            }
                        },

                        /**
                         * @adjustYAxisLabel
                         * dynamic hide Y labels to avoid overlap
                         * @param {String} yAxisName: "y1" or "y2"
                         */
                        adjustYAxisLabel: function adjustYAxisLabel(yAxisName) {
                            var axes = this.get("canvas").get("axesGroup"),
                                tickValues = this.get("axes").axis(yAxisName).tickValues(),
                                axesTicks = axes.selectAll("." + Classes.AXIS + "-" + yAxisName + " .tick"),
                                textSpacing = 23; // the height of tick text(18 + 0.32em)

                            var lastPosition = 0,
                                beforeLastPosition = 0,
                                beforeLastShowedTickIndex = 0,
                                lastShowedTickIndex = 0,
                                showLastShowedTick = true,
                                showBeforeLastShowedTick = true;

                            axesTicks.style({
                                opacity: function opacity(d, i) {
                                    var opacity = 0;
                                    var tickPosition = d3.transform(this.getAttribute("transform")).translate[1];
                                    var textTotalDy = parseFloat(this.lastChild.attributes.dy.value) * (this.childNodes.length - 1) * 14;
                                    var textDistance = +this.lastChild.attributes.y.value + textTotalDy;
                                    var currentPosition = tickPosition + textDistance;
                                    var distance = Math.abs(currentPosition - lastPosition);
                                    if (distance > textSpacing) {
                                        opacity = 1;
                                        beforeLastShowedTickIndex = lastShowedTickIndex;
                                        lastShowedTickIndex = i;
                                        beforeLastPosition = lastPosition;
                                        lastPosition = currentPosition;
                                    }

                                    if (i === tickValues.length - 1 && opacity === 0) {
                                        opacity = 1;
                                        showLastShowedTick = false;
                                        if (Math.abs(currentPosition - beforeLastPosition) < textSpacing) {
                                            showBeforeLastShowedTick = false;
                                        }
                                    }
                                    return opacity;
                                }
                            });

                            if (!showLastShowedTick && showLastShowedTick !== 0) {
                                d3.select(axesTicks[0][lastShowedTickIndex]).style({ opacity: 0 });
                            }

                            if (!showBeforeLastShowedTick && beforeLastShowedTickIndex !== 0) {
                                d3.select(axesTicks[0][beforeLastShowedTickIndex]).style({ opacity: 0 });
                            }
                        },

                        /**
                         * Appends a Y axis label.
                         * @param {Object} layer: "y1" or "y2"
                         * @param {String} axisName: "y1" or "y2"
                         * @param {String} text: y1AxisLabel or y2AxisLabel
                         */
                        appendYLabel: function appendYLabel(layer, axisName, text) {
                            var yTickSize = this.get("yTickSize");
                            var canvas = this.get("canvas");
                            var axis = this.get("axes").axis(axisName);
                            var isLeft = axis.orient() === "left";
                            var axisSelector = Classes.AXIS + "-" + axisName;
                            var anchor = isLeft ? "start" : "end";
                            var rotation = isLeft ? 270 : 90;
                            var axisLayer, translate, x, y, yLabel, svgText;
                            var yAxesLabelPadding = this.get("yAxesLabelPadding");

                            // Calculating
                            axisLayer = canvas.layer(axisSelector, "axes", true);
                            translate = d3.transform(axisLayer.attr("transform")).translate;
                            x = isLeft ? translate[0] - yAxesLabelPadding - yTickSize : translate[0] + yTickSize + yAxesLabelPadding;
                            y = canvas.height();

                            yLabel = layer.append("g").attr(axisSelector + "-label", "axes").attr("transform", "translate(" + x + ", " + y + ")");

                            svgText = yLabel.append("text").text(text).classed(axisSelector + "-label-text", "true").classed("mbc-y-axis-text", "true").attrs({
                                "text-anchor": anchor,
                                transform: "rotate(" + rotation + ")"
                            });

                            // dynamic abbreviate yAxisLabel if it is higher than container
                            var labelText = svgText[0][0];
                            var textHeight = Math.abs(labelText.clientWidth);
                            if (textHeight > y) {
                                var maxNum = Math.floor(y / (textHeight / text.length));
                                labelText.innerHTML = text.substr(0, maxNum - 2) + "...";
                            }
                        }
                    });

                    module.exports = Chart;

                    /***/
                },

                /***/39:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var Core = __webpack_require__(13);
                    var Utils = __webpack_require__(3);
                    var Base = __webpack_require__(6);

                    var DateAxis = Base.extend({
                        /*axis data*/
                        domain: [],
                        range: [0, 0],
                        subLabels: [],

                        /*axis style*/
                        orient: 'bottom',
                        labelSpacing: 10,
                        font: '14px helvetica neue',
                        rangeBandsPadding: 0.00,
                        rangeBandsOuterPadding: 0.00,

                        /*label format*/
                        labelFormat: '%b',
                        subLabelFormat: '%Y',
                        subLabelDx: '-0.75em',
                        tickFormat: null,

                        timeLevel: 'monthly',

                        //======================= initialize ==========================

                        initializer: function initializer() {
                            this._initData();
                            this._initScale();
                            this._initAxis();
                        },

                        _initData: function _initData() {

                            var opDomain = this.get('domain');
                            var labelInterval = this._calcLabelInterval();
                            var subLabels = this._calcSubLabels(opDomain, labelInterval);

                            this.set('labelInterval', labelInterval);
                            this.set('subLabels', subLabels);

                            //temporary handle way, will set a map to contain yearly, quarterly, monthly
                            var timeLevel = this.get('timeLevel').toLowerCase();
                            switch (timeLevel) {
                                case 'quarterly':
                                    this.set('tickFormat', this.quarterlyTickFormat);
                                    this.set('subLabelDx', '-0.5em');
                                    break;

                                case 'yearly':
                                    this.set('tickFormat', d3.time.format('%Y'));
                                    this.set('subLabels', []);
                                    break;

                                default:
                                    this.set('tickFormat', d3.time.format(this.get('labelFormat')));
                                    break;
                            }
                        },

                        _initScale: function _initScale() {
                            var domain = this.get('domain'),
                                range = this.get('range');

                            var scale = d3.scale.ordinal().domain(domain).rangeBands(range, this.get('rangeBandsPadding'), this.get('rangeBandsOuterPadding'));

                            this.set('scale', scale);
                        },

                        _initAxis: function _initAxis() {
                            var scale = this.getScale(),
                                orient = this.get('orient'),
                                formatFun = this.get('tickFormat'),
                                labelInterval = this.get('labelInterval'),
                                getDate = this.getDate;

                            var axis = d3.svg.axis().scale(scale).orient(orient).tickFormat(function (d, i) {

                                if (i % labelInterval !== 0) {
                                    return '';
                                }

                                if (typeof formatFun === 'function') {
                                    return formatFun(getDate(d));
                                }

                                return d;
                            });

                            this.set('axis', axis);
                        },

                        _calcLabelInterval: function _calcLabelInterval() {
                            var opDomain = this.get('domain'),
                                range = this.get('range'),
                                axisWidth = range[1] - range[0],
                                spacing = this.get('labelSpacing'),
                                labelFormat = d3.time.format(this.get('labelFormat')),
                                getDate = this.getDate,
                                maxTextWidth,
                                maxLabelCount,
                                labelInterval;

                            maxTextWidth = this.calcMaxTextWidth(opDomain.map(function (item) {
                                return labelFormat(getDate(item));
                            }));

                            //maxText * n + spacing * (n-1) < width;
                            maxLabelCount = Math.floor((axisWidth + spacing) / (maxTextWidth + spacing));

                            labelInterval = Math.ceil(opDomain.length / maxLabelCount);

                            return labelInterval;
                        },

                        _calcSubLabels: function _calcSubLabels(domain, labelInterval) {
                            if (!Array.isArray(domain)) {
                                return [];
                            }

                            var subLabels = [];
                            var timeFormat = d3.time.format;
                            var subLabelFormat = timeFormat(this.get('subLabelFormat'));
                            var getDate = this.getDate;

                            domain.forEach(function (item, index) {
                                var date = getDate(item);
                                var label = subLabelFormat(date);

                                if (index % labelInterval === 0 && subLabels.indexOf(label) === -1) {
                                    subLabels.push(label);
                                } else {
                                    subLabels.push(null);
                                }
                            });

                            return subLabels;
                        },

                        //======================== public methods ======================

                        draw: function draw(selection) {
                            var axis = this.getAxis();
                            selection.call(axis);
                        },

                        drawSubLabels: function drawSubLabels(canvas) {
                            var xScale = this.get("scale");
                            var xAxisOrient = this.get("orient");
                            var subLabels = this.get("subLabels");
                            var xlayer = canvas.layer("mbc-axes-xlabels", "axes");
                            var xTexts;

                            xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
                            xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
                                var x = xScale(d) + xScale.rangeBand() / 2;
                                var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
                                return "translate(" + x + ", " + y + ")";
                            }).append("text").text(function (d, i) {
                                var label = "";
                                if (i < subLabels.length) {
                                    label = subLabels[i] || "";
                                }

                                return label;
                            }).attrs({
                                "text-anchor": "start",
                                "dx": this.get("subLabelDx")
                            });
                        },

                        getScale: function getScale() {
                            return this.get('scale');
                        },

                        getAxis: function getAxis() {
                            return this.get('axis');
                        },

                        //=================== util methods ============================

                        isInvalidDate: function isInvalidDate(date) {
                            if (date instanceof Date && date.toString() !== 'Invalid Date') {
                                return false;
                            }

                            return true;
                        },

                        checkLabelsWidth: function checkLabelsWidth(labelList, axisWidth, spacing, font) {
                            var totalSpacing = spacing * (labelList.length - 1);
                            var totalWidth = this.getTextWidth({
                                font: font,
                                text: labelList.join('')
                            });

                            //axis can show all labels well.
                            if (axisWidth > totalWidth + totalSpacing) {
                                return true;
                            }

                            return false;
                        },

                        getTextWidth: function getTextWidth(option) {

                            var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
                            var context = canvas.getContext('2d');

                            context.font = option.font;

                            var dimension = context.measureText(option.text);

                            return dimension.width;
                        },

                        calcMaxTextWidth: function calcMaxTextWidth(texts) {
                            var _this = this;
                            var font = this.get('font');
                            var maxTextWidth = d3.max(texts.map(function (text) {
                                return _this.getTextWidth({
                                    font: font,
                                    text: text
                                });
                            }));

                            return maxTextWidth;
                        },

                        getDate: function getDate(maskDate) {
                            return new Date(Utils.string.unmask(maskDate));
                        },

                        quarterlyTickFormat: function quarterlyTickFormat(date) {
                            var month = +d3.time.format('%m')(date);
                            var quarterly = [3, 6, 9, 12];

                            if (quarterly.indexOf(month) === -1) {
                                return;
                            }

                            return "Q" + month / 3;
                        },

                        //========================= getter & setter ============================

                        get: function get(key) {
                            return this.__attributes[key];
                        },

                        set: function set(key, value) {
                            this.__attributes[key] = value;
                        }

                    });

                    module.exports = DateAxis;

                    /***/
                },

                /***/40:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var DateAxis = __webpack_require__(39);

                    module.exports = {
                        DateAxis: DateAxis
                    };

                    /***/
                },

                /***/41:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var array = __webpack_require__(14);
                    var object = __webpack_require__(2);

                    /**
                     * Calculate tickvalues for a given dataset.
                     *
                     * @param {Array} domain Two values array.
                     * @param {Number} ticksNumber Number of ticks to show.
                     *
                     * @return {Array} Containing the ticks to include in the chart's axis.
                     */
                    var getTickValues = function getTickValues(domain, ticksNumber) {
                        ticksNumber = ticksNumber || 4;
                        var distance = Math.abs(domain[0] - domain[1]);
                        var domainStep = distance / ticksNumber;
                        var min = domain[0];
                        var max = domain[1];
                        var tickValues = [];

                        while (min < max) {
                            tickValues.push(min);
                            min += domainStep;
                        }

                        tickValues.push(min);

                        return tickValues;
                    };

                    function ensureGreaterThanOne(num) {
                        var power = 0;
                        while (num < 10) {
                            num = num * 10;
                            power++;
                        }

                        return { number: num, power: power };
                    }

                    /**
                     * Returns a domain with positive numbers starting from 0 based on the chart values.
                     *
                     * @param {Array} allValues Array of numbers containing values used to caculate the domain.
                     * @param {Number} roundTo Tenths, hundreds, thousands,...
                     * @param {boolean} integers Show only integer numbers, without decimal.
                     * @param {Number} steps Numbers of intended steps into the domain.
                     * @returns {Array} Two values array with the domain.
                     */
                    function getPositiveDomain(allValues, roundTo, integers, steps) {
                        var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
                        if (max === 0) return [0, 1];
                        var ensured = ensureGreaterThanOne(max);
                        var mod, power;

                        max = ensured.number;
                        power = ensured.power;
                        roundTo *= Math.pow(10, power);

                        if (integers) {
                            mod = max % steps;
                            while (mod !== 0) {
                                max += roundTo;
                                mod = max % steps;
                            }
                        }

                        max = max / Math.pow(10, power);

                        return [0, max];
                    }

                    /**
                     * Returns a Symmetrical domain based on the chart values.
                     *
                     * @param {Array} allValues Array of numbers containing values used to caculate the domain.
                     * @param {Number} roundTo Tenths, hundreds, thousands,...
                     * @returns
                     */
                    function getSymmetricalDomain(allValues, roundTo, integers, steps) {
                        var allPositive = array.getAllPositives(allValues);
                        var max = Math.ceil(d3.max(allPositive) / roundTo) * roundTo;
                        if (max === 0) return [-1, 1];
                        var ensured = ensureGreaterThanOne(max);
                        var min, mod, power;

                        max = ensured.number;
                        power = ensured.power;
                        min = max * -1;
                        roundTo *= Math.pow(10, power);

                        if (integers) {
                            mod = max * 2 % steps;
                            while (mod !== 0) {
                                max += roundTo;
                                mod = max * 2 % steps;
                            }

                            min = max * -1;
                        }

                        min = min / Math.pow(10, power);
                        max = max / Math.pow(10, power);

                        return [min, max];
                    }

                    /**
                     * Returns an Asymmetrical domain based on the chart values.
                     *
                     * @param {Array} allValues Array of numbers containing values used to caculate the domain.
                     * @param {Number} roundTo Tenths, hundreds, thousands,...
                     * @returns
                     */
                    function getAsymmetricalDomain(allValues, roundTo) {
                        var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
                        var min = Math.floor(d3.min(allValues) / roundTo) * roundTo;

                        return [min, max];
                    }

                    /**
                     * Calculates the domain for a certain dataset.
                     *
                     * @param {Object}? options Options available:
                     * <li><b>values:</b> Required. Array of values.
                     * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
                     * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
                     * <li><b>symmetrical:</b> Optional.
                     * <li><b>steps:</b> Optional. Intended ticks number.
                     *
                     * @return {Array} Two values array indicating the domain.
                     */
                    var getDomain = function getDomain(options) {
                        options = options || {};
                        var allValues = options.values;
                        var roundTo = options.roundTo || 10;
                        var integers = object.getBoolean(options.integers, false);
                        var forceNegative = object.getBoolean(options.forceNegative, false);
                        var symmetrical = object.getBoolean(options.symmetrical, true);
                        var raw = object.getBoolean(options.raw, false);
                        var steps = options.steps || 4;
                        var negatives;

                        if (!allValues || allValues.length === 0) {
                            return [0, 1];
                        }

                        negatives = array.hasNegative(allValues);
                        allValues = array.removeDuplicates(allValues);

                        if (raw) {
                            return [d3.min(allValues), d3.max(allValues)];
                        }

                        if (!negatives && !forceNegative) {
                            return getPositiveDomain(allValues, roundTo, integers, steps);
                        } else if (symmetrical) {
                            return getSymmetricalDomain(allValues, roundTo, integers, steps);
                        } else {
                            return getAsymmetricalDomain(allValues, roundTo, integers, steps);
                        }
                    };

                    /**
                     * Returns the index of a given value into a range array.
                     * @param {Number} val Value to find index into range array.
                     * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
                     * @return {Number} The range index or -1.
                     */
                    function getRangeIndex(val, range) {
                        for (var i = 0; i < range.length; i++) {
                            if (val > range[i][0] && (val <= range[i][1] || range[i][1] === undefined)) {
                                return i;
                            }
                        }

                        return -1;
                    }

                    /**
                     * Returns the value of a given value into a values array.
                     * @param {Number} val Value to find index into range array.
                     * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
                     * @param {Array} values Values to return
                     * @return {Object} The value that matches range index or `undefined`.
                     */
                    function getRangeValue(val, range, values) {
                        var index = getRangeIndex(val, range);
                        if (index !== -1) return values[index];
                    }

                    /**
                     * Returns the calculated padding between bars
                     * @param {Array} num the number of bars
                     * @param {Number} dim the height or width of the canvas
                     * @param {String} orient whether horizontal or vertical bar chart
                     * @return {String} type whether standard or grouped bars
                     */
                    function getBarPadding(num, dim, orient) {
                        var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "standard";

                        var padding = 9;
                        var ratio = dim / num;

                        if (orient === "horizontal" || orient === "vertical" && type === "standard") {

                            if (ratio > 21) {
                                return padding;
                            } else if (ratio <= 21 && ratio > 14) {
                                padding = 6;
                            } else if (ratio <= 14 && ratio > 7) {
                                padding = 3;
                            } else {
                                padding = 1;
                            }
                        } else if (orient === "vertical" && type === "grouped") {

                            if (ratio > 16.5) {
                                return padding;
                            } else if (ratio <= 16.5 && ratio > 11) {
                                padding = 6;
                            } else if (ratio <= 11 && ratio > 5.5) {
                                padding = 3;
                            } else {
                                padding = 1;
                            }
                        }

                        return padding;
                    }

                    module.exports = {
                        getTickValues: getTickValues,
                        getDomain: getDomain,
                        getRangeIndex: getRangeIndex,
                        getRangeValue: getRangeValue,
                        getBarPadding: getBarPadding
                    };

                    /***/
                },

                /***/42:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var mds_constants = __webpack_require__(7).constants;
                    var mds_chart_color = mds_constants["chart-color"];

                    /**
                     * deprecating `var colors` in v3.0.0
                     */
                    var colors = {
                        "blue": mds_chart_color["1"],
                        "maroon": mds_chart_color["2"],
                        "teal": mds_chart_color["8"],
                        "orange": mds_chart_color["7"],
                        "green": mds_chart_color["9"],
                        "violet": mds_chart_color["6"],
                        "yellow": mds_chart_color["3"],
                        "cyan": mds_chart_color["5"],
                        "dark-green": mds_chart_color["4"],
                        "red": mds_constants["color"]["red"]["50"],
                        "light-red": mds_chart_color["10"],
                        "dark-violet": mds_chart_color["11"],
                        "dark-yellow": mds_chart_color["12"],
                        "aqua": mds_chart_color["13"],
                        "bright-orange": mds_chart_color["14"],
                        "light-green": mds_chart_color["15"],
                        "white": mds_constants["color"].white,
                        "grey1": mds_constants["color"]["neutral"]["90"],
                        "grey2": mds_constants["background-color"].light,
                        "grey3": mds_constants["color"]["neutral"]["80"],
                        "grey4": mds_constants["color"]["neutral"]["80"],
                        "grey5": mds_constants["color"]["neutral"]["50"],
                        "grey6": mds_constants["color"]["neutral"]["37"],
                        "grey7": mds_constants["color"]["neutral"]["12"],
                        "black": mds_constants["color"].black
                    };

                    var primary = [mds_chart_color["1"], mds_chart_color["2"], mds_chart_color["3"], mds_chart_color["4"], mds_chart_color["5"], mds_chart_color["6"], mds_chart_color["7"], mds_chart_color["8"], mds_chart_color["9"]];

                    var secondary = [mds_chart_color["10"], mds_chart_color["11"], mds_chart_color["12"], mds_chart_color["13"], mds_chart_color["14"], mds_chart_color["15"]];

                    var palettes = [primary, secondary];

                    var combined = palettes.reduce(function (a, b) {
                        return a.concat(b);
                    }, []);

                    module.exports = {
                        colors: colors,
                        primary: primary,
                        secondary: secondary,
                        combined: combined,
                        mds_constants: mds_constants,
                        mds_chart_color: mds_chart_color
                    };

                    /***/
                },

                /***/43:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var names = ["Asia/Pacific Long-Short Equity", "Bear-Market Equity", "China Long-Short Equity", "Convertible Arbitrage", "Currency", "Debt Arbitage", "Distressed Securities", "Diversified Arbitage", "Emrg-Mkta Long-Short Equity", "Equity Market Neutral", "Europe Long-Short Equity", "Event Driven", "Global Long-Short Equity", "Global Macro", "Long-Short Debt", "Merger Arbitage", "Multistrategy", "Systematic Futures", "U.S. Long-Short Equity", "U.S. Sm-Cap Lg-Short Equity", "Volatility"];

                    function getDummyArray(n) {
                        var i = 0;
                        var arr = [];
                        var sign;
                        for (; i < n; i++) {
                            sign = Math.random() < 0.5 ? -1 : 1;
                            arr.push(Math.random() * sign);
                        }

                        return arr;
                    }

                    function getRandomName() {
                        return names[Math.floor(names.length * Math.random())];
                    }

                    function getDummyRows(num) {
                        var length = num || 3 + Math.floor(Math.random() * 47);
                        var i = 0;
                        var rows = [];
                        var name;

                        for (; i < length; i++) {
                            name = getRandomName();
                            rows.push(name);
                        }

                        return rows;
                    }

                    function getDummyMatrix(num) {
                        var i;
                        var j;
                        var matrix = [];
                        var length = num || 3 + Math.floor(Math.random() * 47);
                        var sign, value;

                        // for (i = 0; i < num; i++) {
                        //     matrix[i] = [];
                        // }

                        for (i = 0; i < length; i++) {
                            for (j = 0; j < length; j++) {
                                if (!matrix[i]) matrix[i] = [];
                                if (!matrix[j]) matrix[j] = [];

                                sign = Math.random() < 0.5 ? -1 : 1;
                                value = Math.random() * sign;
                                if (j < i) {
                                    matrix[i][j] = value;
                                    matrix[j][i] = value;
                                } else if (i === j) {
                                    matrix[i][j] = 1;
                                    break;
                                }
                            }
                        }

                        return matrix;
                    }

                    function grow(matrix) {
                        var arr = getDummyArray(matrix.length);
                        arr.forEach(function (val, i) {
                            matrix[i].push(val);
                        });

                        arr.push(1);
                        matrix.push(arr);
                        return matrix;
                    }

                    function dataset(num) {
                        var length = num || 3 + Math.floor(Math.random() * 47);
                        var dummyRows = getDummyRows(length);
                        var dummyMatrix = getDummyMatrix(length);

                        return {
                            rows: dummyRows,
                            matrix: dummyMatrix
                        };
                    }

                    module.exports = {
                        matrix: getDummyMatrix,
                        rows: getDummyRows,
                        array: getDummyArray,
                        dataset: dataset,
                        grow: grow,
                        name: getRandomName
                    };

                    /***/
                },

                /***/44:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var crmatrix = __webpack_require__(43);
                    /**
                     * @fileOverview Generates "Lorem ipsum" style text.
                     * @author rviscomi@gmail.com Rick Viscomi,
                     * 		tinsley@tinsology.net Mathew Tinsley
                     * @version 1.0
                     */

                    /**
                     *	Copyright (c) 2009, Mathew Tinsley (tinsley@tinsology.net)
                     *	All rights reserved.
                     *
                     *	Redistribution and use in source and binary forms, with or without
                     *	modification, are permitted provided that the following conditions are met:
                     *		* Redistributions of source code must retain the above copyright
                     *		  notice, this list of conditions and the following disclaimer.
                     *		* Redistributions in binary form must reproduce the above copyright
                     *		  notice, this list of conditions and the following disclaimer in the
                     *		  documentation and/or other materials provided with the distribution.
                     *		* Neither the name of the organization nor the
                     *		  names of its contributors may be used to endorse or promote products
                     *		  derived from this software without specific prior written permission.
                     *
                     *	THIS SOFTWARE IS PROVIDED BY MATHEW TINSLEY ""AS IS"" AND ANY
                     *	EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                     *	WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                     *	DISCLAIMED. IN NO EVENT SHALL <copyright holder> BE LIABLE FOR ANY
                     *	DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                     *	(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                     *	LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                     *	ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                     *	(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                     *	SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                     */

                    /**
                     * @class Jibborish generator.
                     */
                    var LoremIpsum = function LoremIpsum() {};

                    /**
                     * Average number of words per sentence.
                     * @constant {number}
                     */
                    LoremIpsum.WORDS_PER_SENTENCE_AVG = 24.460;

                    /**
                     * Standard deviation of the number of words per sentence.
                     * @constant {number}
                     */
                    LoremIpsum.WORDS_PER_SENTENCE_STD = 5.080;

                    /**
                     * List of possible words.
                     * @constant {Array.string}
                     */
                    LoremIpsum.WORDS = ["lorem", "ipsum", "dolor", "sit", "amet", "consectetur", "adipiscing", "elit", "curabitur", "vel", "hendrerit", "libero", "eleifend", "blandit", "nunc", "ornare", "odio", "ut", "orci", "gravida", "imperdiet", "nullam", "purus", "lacinia", "a", "pretium", "quis", "congue", "praesent", "sagittis", "laoreet", "auctor", "mauris", "non", "velit", "eros", "dictum", "proin", "accumsan", "sapien", "nec", "massa", "volutpat", "venenatis", "sed", "eu", "molestie", "lacus", "quisque", "porttitor", "ligula", "dui", "mollis", "tempus", "at", "magna", "vestibulum", "turpis", "ac", "diam", "tincidunt", "id", "condimentum", "enim", "sodales", "in", "hac", "habitasse", "platea", "dictumst", "aenean", "neque", "fusce", "augue", "leo", "eget", "semper", "mattis", "tortor", "scelerisque", "nulla", "interdum", "tellus", "malesuada", "rhoncus", "porta", "sem", "aliquet", "et", "nam", "suspendisse", "potenti", "vivamus", "luctus", "fringilla", "erat", "donec", "justo", "vehicula", "ultricies", "varius", "ante", "primis", "faucibus", "ultrices", "posuere", "cubilia", "curae", "etiam", "cursus", "aliquam", "quam", "dapibus", "nisl", "feugiat", "egestas", "class", "aptent", "taciti", "sociosqu", "ad", "litora", "torquent", "per", "conubia", "nostra", "inceptos", "himenaeos", "phasellus", "nibh", "pulvinar", "vitae", "urna", "iaculis", "lobortis", "nisi", "viverra", "arcu", "morbi", "pellentesque", "metus", "commodo", "ut", "facilisis", "felis", "tristique", "ullamcorper", "placerat", "aenean", "convallis", "sollicitudin", "integer", "rutrum", "duis", "est", "etiam", "bibendum", "donec", "pharetra", "vulputate", "maecenas", "mi", "fermentum", "consequat", "suscipit", "aliquam", "habitant", "senectus", "netus", "fames", "quisque", "euismod", "curabitur", "lectus", "elementum", "tempor", "risus", "cras"];

                    /**
                     * Generate "Lorem ipsum" style words.
                     * @param numWords {number} Number of words to generate.
                     * @return {string} "Lorem ipsum..."
                     */
                    LoremIpsum.prototype.generate = function (numWords, punctuate) {
                        var words, ii, position, word, current, sentences, sentenceLength, sentence;

                        /**
                        * @default 100
                        */
                        numWords = numWords || 100;

                        words = [LoremIpsum.WORDS[0], LoremIpsum.WORDS[1]];
                        numWords -= 2;

                        for (ii = 0; ii < numWords; ii++) {
                            position = Math.floor(Math.random() * LoremIpsum.WORDS.length);
                            word = LoremIpsum.WORDS[position];

                            if (ii > 0 && words[ii - 1] === word) {
                                ii -= 1;
                            } else {
                                words[ii] = word;
                            }
                        }

                        sentences = [];
                        current = 0;

                        while (numWords > 0) {
                            sentenceLength = this.getRandomSentenceLength();

                            if (numWords - sentenceLength < 4) {
                                sentenceLength = numWords;
                            }

                            numWords -= sentenceLength;

                            sentence = [];

                            for (ii = current; ii < current + sentenceLength; ii++) {
                                sentence.push(words[ii]);
                            }

                            if (punctuate) {
                                sentence = this.punctuate(sentence);
                            }

                            current += sentenceLength;
                            sentences.push(sentence.join(" "));
                        }

                        return sentences.join(" ");
                    };

                    /**
                     * Insert commas and periods in the given sentence.
                     * @param {Array.string} sentence List of words in the sentence.
                     * @return {Array.string} Sentence with punctuation added.
                     */
                    LoremIpsum.prototype.punctuate = function (sentence) {
                        var wordLength, numCommas, ii, position;

                        wordLength = sentence.length;

                        /* End the sentence with a period. */
                        sentence[wordLength - 1] += ".";

                        if (wordLength < 4) {
                            return sentence;
                        }

                        numCommas = this.getRandomCommaCount(wordLength);

                        for (ii = 0; ii <= numCommas; ii++) {
                            position = Math.round(ii * wordLength / (numCommas + 1));

                            if (position < wordLength - 1 && position > 0) {
                                /* Add the comma. */
                                sentence[position] += ",";
                            }
                        }

                        /* Capitalize the first word in the sentence. */
                        sentence[0] = sentence[0].charAt(0).toUpperCase() + sentence[0].slice(1);

                        return sentence;
                    };

                    /**
                     * Produces a random number of commas.
                     * @param {number} wordLength Number of words in the sentence.
                     * @return {number} Random number of commas
                     */
                    LoremIpsum.prototype.getRandomCommaCount = function (wordLength) {
                        var base, average, standardDeviation;

                        /* Arbitrary. */
                        base = 6;

                        average = Math.log(wordLength) / Math.log(base);
                        standardDeviation = average / base;

                        return Math.round(this.gaussMS(average, standardDeviation));
                    };

                    /**
                     * Produces a random sentence length based on the average word length
                     * of an English sentence.
                     * @return {number} Random sentence length
                     */
                    LoremIpsum.prototype.getRandomSentenceLength = function () {
                        return Math.round(this.gaussMS(LoremIpsum.WORDS_PER_SENTENCE_AVG, LoremIpsum.WORDS_PER_SENTENCE_STD));
                    };

                    /**
                     * Produces a random number.
                     * @return {number} Random number
                     */
                    LoremIpsum.prototype.gauss = function () {
                        return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
                    };

                    /**
                     * Produces a random number with Gaussian distribution.
                     * @param {number} mean
                     * @param {number} standardDeviation
                     * @return {number} Random number
                     */
                    LoremIpsum.prototype.gaussMS = function (mean, standardDeviation) {
                        return Math.round(this.gauss() * standardDeviation + mean);
                    };

                    function Tickers() {}

                    Tickers.TICKERS = ["PIH", "FLWS", "FCCY", "SRCE", "VNET", "TWOU", "JOBS", "CAFD", "EGHT", "AVHI", "SHLM", "AAON", "ABAX", "ABEO", "ABEOW", "ABIL", "ABMD", "AXAS", "ACIU", "ACIA", "ACTG", "ACHC", "ACAD", "ACST", "AXDX", "XLRN", "ANCX", "ARAY", "ACRX", "ACET", "AKAO", "ACHN", "ACIW", "ACRS", "ACNB", "ACOR", "ACTS", "ACPW", "ATVI", "ACTA", "ACUR", "ACXM", "ADMS", "ADMP", "ADAP", "ADUS", "AEY", "IOTS", "ADMA", "ADBE", "ADTN", "ADRO", "AAAP", "ADES", "AEIS", "AMD", "ADXS", "ADXSW", "ADVM", "MAUI", "AEGR", "AEGN", "AGLE", "AEHR", "AMTX", "AEPI", "AERI", "AVAV", "AEZS", "AEMD", "AFMD", "AGEN", "AGRX", "AGYS", "AGIO", "AGNC", "AGNCB", "AGNCP", "AGFS", "AGFSW", "AIMT", "AIRM", "AIRT", "ATSG", "AIRG", "AMCN", "AIXG", "AKAM", "AKTX", "AKBA", "AKER", "AKRX", "ALRM", "ALSK", "AMRI", "ALBO", "ABDC", "ADHD", "ALDR", "ALDX", "ALXN", "ALCO", "ALGN", "ALIM", "ALJJ", "ALKS", "ABTX", "ALGT", "AIQ", "AHGP", "AMMA", "ARLP", "AHPI", "AMOT", "ALQA", "ALLT", "MDRX", "AFAM", "ALNY", "AOSL", "GOOG", "GOOGL", "SMCP", "ATEC", "ASPS", "AIMC", "AMAG", "AMRN", "AMRK", "AYA", "AMZN", "AMBC", "AMBCW", "AMBA", "AMCX", "DOX", "AMDA", "AMED", "UHAL", "ATAX", "AMOV", "AAL", "ACSF", "ACAS", "AETI", "AMNB", "ANAT", "APEI", "ARII", "AMRB", "AMSWA", "AMSC", "AMWD", "CRMT", "ABCB", "AMSF", "ASRV", "ASRVP", "ATLO", "AMGN", "FOLD", "AMKR", "AMPH", "IBUY", "AMSG", "AMSGP", "ASYS", "AFSI", "AMRS", "ADI", "ALOG", "AVXL", "ANCB", "ANDA", "ANDAR", "ANDAU", "ANDAW", "ANGI", "ANGO", "ANIP", "ANIK", "ANSS", "ATRS", "ANTH", "ABAC", "APOG", "APOL", "AINV", "APPF", "AAPL", "ARCI", "APDN", "APDNW", "AGTC", "AMAT", "AMCC", "AAOI", "AREX", "APTI", "APRI", "APVO", "APTO", "AQMS", "AQXP", "ARDM", "ARLZ", "PETX", "ABUS", "ARCW", "ABIO", "RKDA", "ARCB", "ACGL", "ACGLP", "APLP", "ACAT", "ARDX", "ARNA", "ARCC", "AGII", "AGIIL", "ARGS", "ARIS", "ARIA", "ARKR", "ARTX", "ARWA", "ARWAR", "ARWAU", "ARWAW", "ARQL", "ARRY", "ARRS", "DWAT", "AROW", "ARWR", "ARTNA", "ARTW", "ASBB", "ASNA", "ASND", "ASCMA", "APWC", "ASML", "AZPN", "ASMB", "ASFI", "ASTE", "ATRO", "ALOT", "ASTC", "ASUR", "ATAI", "ATRA", "ATHN", "ATHX", "AAPC", "AAME", "ACBI", "ACFC", "ABY", "ATLC", "AAWW", "AFH", "TEAM", "ATNI", "ATOM", "ATOS", "ATRC", "ATRI", "ATTU", "LIFE", "AUBN", "BOLD", "AUDC", "AUPH", "EARS", "ABTL", "ADSK", "ADP", "AVEO", "AVXS", "AVNW", "AVID", "AVGR", "AVIR", "CAR", "AHPAU", "AWRE", "AXAR", "AXARU", "AXARW", "ACLS", "AXGN", "AXSM", "AXTI", "AZRX", "BCOM", "RILY", "RILYL", "BOSC", "BEAV", "BIDU", "BCPC", "BWINA", "BWINB", "BLDP", "BANF", "BANFP", "BCTF", "BKMU", "BOCH", "BMRC", "BKSC", "BOTJ", "OZRK", "BFIN", "BWFG", "BANR", "BZUN", "TAPR", "DLBL", "BHAC", "BHACR", "BHACU", "BHACW", "BBSI", "BSET", "BYBK", "BV", "BCBP", "BECN", "BSF", "BBGI", "BEBE", "BBBY", "BGNE", "BELFA", "BELFB", "BLPH", "BLCM", "BNCL", "BNFT", "BNTC", "BNTCW", "BGCP", "BGFV", "BASI", "ORPN", "BIOC", "BCRX", "BDSI", "BIIB", "BIOL", "BLFS", "BLRX", "BMRN", "BMRA", "BVXV", "BVXVW", "BPTH", "BIOS", "BBC", "BBP", "BSTC", "BSTG", "BSPM", "TECH", "BEAT", "BJRI", "BBOX", "BDE", "BLKB", "BBRY", "HAWK", "BL", "BKCC", "ADRA", "ADRD", "ADRE", "ADRU", "BLMN", "BCOR", "BLBD", "BUFF", "BHBK", "NILE", "BLUE", "BKEP", "BKEPP", "BPMC", "ITEQ", "BMCH", "BNCN", "BOBE", "BOFI", "BOFIL", "WIFI", "BOJA", "BOKF", "BOKFL", "BNSO", "BPFH", "BPFHP", "BPFHW", "EPAY", "BLVD", "BLVDU", "BLVDW", "BCLI", "BBRG", "BDGE", "BLIN          ", "BRID", "BCOV", "AVGO", "BSFT", "BVSN", "BYFC", "BWEN", "BRCD", "BRKL", "BRKS", "BRKR", "BMTC", "BLMT", "BSQR", "BWLD", "BLDR", "BMLA", "BUR", "CFFI", "CHRW", "CA", "CCMP", "CDNS", "CDZI", "CACQ", "CZR", "CSTE", "PRSS", "CLBS", "CLMS", "CHY", "CHI", "CCD", "CHW", "CGO", "CSQ", "CAMP", "CVGW", "CFNB", "CALA", "CALD", "CALM", "CLMT", "ABCD", "CAC", "CAMT", "CSIQ", "CGIX", "CPHC", "CPLA", "CBF", "CCBG", "CPLP", "CSWC", "CPTA", "CLAC", "CLACU", "CLACW", "CFFN", "CAPN", "CAPNW", "CAPR", "CSTR", "CPST", "CARA", "CARB", "CCN", "CCNWW", "CFNL", "CRME", "CSII", "CATM", "CDNA", "CECO", "CTRE", "CKEC", "CLBH", "CARO", "CART", "CRZO", "TAST", "CRTN", "CARV", "CASM", "CACB", "CASC", "CWST", "CASY", "CASI", "CASS", "CATB", "CBIO", "CPRX", "CATY", "CATYW", "CVCO", "CAVM", "CBFV", "CBOE", "CDK", "CDW", "CECE", "CELG", "CELGZ", "CLDX", "APOP", "APOPW", "CLRB", "CLRBW", "CLRBZ", "CLLS", "CBMG", "CLSN", "CYAD", "CEMP", "CETX", "CDEV", "CDEVW", "CSFL", "CETV", "CFBK", "CENT", "CENTA", "CVCY", "CFCB", "CENX", "CNBKA", "CNTY", "CRNT", "CERC", "CERCW", "CERCZ", "CERN", "CERU", "CERS", "KOOL", "CEVA", "CFCO", "CFCOU", "CFCOW", "CSBR", "CYOU", "HOTR", "HOTRW", "CTHR", "GTLS", "CHTR", "CHFN", "CHKP", "CHEK", "CHEKW", "CEMI", "CHFC", "CCXI", "CHMG", "CHKE", "CHMA", "PLCE", "CMRX", "CADC", "CALI", "CAAS", "CBAK", "CBPO", "CCCL", "CCCR", "CCRC", "JRJC", "HGSH", "CNIT", "CJJD", "CLDC", "CLDCW", "HTHT", "CHNR", "CREG", "CNTF", "CXDC", "CCIH", "CNET", "IMOS", "CDXC", "CHSCL", "CHSCM", "CHSCN", "CHSCO", "CHSCP", "CHDN", "CHUY", "CDTX", "CMCT", "CMPR", "CINF", "CIDM", "CTAS", "CPHR", "CRUS", "CSCO", "CTRN", "CZNC", "CZWI", "CZFC", "CIZN", "CTXS", "CHCO", "CIVB", "CIVBP", "CDTI", "CLNE", "CLNT", "CLFD", "CLRO", "CLSD", "CLIR", "CBLI", "CSBK", "CLVS", "CMFN", "CME", "CCNE", "CISG", "CNV", "CWAY", "COBZ", "COKE", "CDXS", "CVLY", "JVA", "CCOI", "CGNT", "COGT", "CGNX", "CTSH", "COHR", "CHRS", "COHU", "CLCT", "COLL", "CIGI", "CBAN", "CLCD", "COLB", "COLM", "CMCO", "CBMX", "CBMXW", "CMCSA", "CBSH", "CBSHP", "CUBN", "CHUBA", "CHUBK", "CVGI", "COMM", "CSAL", "JCS", "ESXB", "CYHHZ", "CTBI", "CWBC", "CVLT", "CGEN", "CPSI", "CTG", "SCOR", "CHCI", "CMTL", "CNAT", "CNCE", "CXRX", "CCUR", "CDOR", "CFMS", "CNFR", "CNMD", "CTWS", "CNOB", "CNXR", "CONN", "CNSL", "CWCO", "CPSS", "CFRX", "CFRXW", "CTRV", "CTRL", "CPAA", "CPAAU", "CPAAW", "CPRT", "COYN", "COYNW", "CRBP", "CORT", "CORE", "CORI", "CSOD", "CRVL", "CRVS", "CSGP", "COST", "CPAH", "ICBK", "COUP", "CVTI", "COVS", "COWN", "COWNL", "PMTS", "CPSH", "CRAI", "CBRL", "BREW", "CRAY", "CACC", "GLDI", "SLVO", "CREE", "CRESY", "CRSP", "CRTO", "CROX", "CCRN", "XRDC", "CRDS", "CRWS", "CYRX", "CYRXW", "CSGS", "CCLP", "CSPI", "CSWI", "CSX", "CTIC", "CTIB", "CTRP", "CUNB", "CUI", "CPIX", "CMLS", "CRIS", "CUTR", "CVBF", "CVV", "CYAN", "CYBR", "CYBE", "CYCC", "CYCCP", "CBAY", "CYNO", "CY", "CYRN", "CONE", "CYTK", "CTMX", "CYTX", "CYTXW", "CTSO", "CYTR", "DJCO", "DAKT", "DRIO", "DRIOW", "DZSI", "DAIO", "DTLK", "DRAM", "DWCH", "PLAY", "DTEA", "DWSN", "DBVT", "DFRG", "TACO", "TACOW", "DCTH", "DMPI", "DGAS", "DELT", "DELTW", "DENN", "XRAY", "DEPO", "DSCI", "DERM", "DEST", "DXLG", "DSWL", "DTRM", "DXCM", "DXTR", "DHXM", "DHIL", "FANG", "DCIX", "DRNA", "DFBG", "DFFN", "DGII", "DMRC", "DRAD", "DGLY", "APPS", "DCOM", "DMTX", "DIOD", "DPRX", "DISCA", "DISCB", "DISCK", "DISH", "DVCR", "SAUC", "DLHC", "BOOM", "DNBF", "DLTR", "DGICA", "DGICB", "DMLP", "DORM", "EAGL", "EAGLU", "EAGLW", "DRWI", "DRYS", "DSKX", "DSPG", "DTSI", "DLTH", "DNKN", "DRRX", "DXPE", "DYSL", "DYNT", "DVAX", "ETFC", "EBMT", "EGBN", "EGLE", "EGRX", "IGLEU", "ELNK", "EWBC", "EACQ", "EACQU", "EACQW", "EML", "EVBS", "EVGBC", "EVSTC", "EVLMC", "EBAY", "EBAYL", "EBIX", "ELON", "ECHO", "SATS", "EEI", "ECAC", "ECACR", "ECACU", "ESES", "EDAP", "EDGE", "EDGW", "EDIT", "EDUC", "EFUT", "EGAN", "EGLT", "EHTH", "EIGR", "EKSO", "LOCO", "EMITF", "ESLT", "ERI", "ESIO", "EA", "EFII", "ELSE", "ELEC", "ELECU", "ELECW", "EBIO", "DWAC", "CAPX", "ESBK", "ELTK", "EMCI", "EMCF", "EMKR", "EMMS", "NYNY", "ERS", "ENTA", "ECPG", "WIRE", "ENDP", "ECYT", "ELGX", "EIGI", "WATT", "EFOI", "ERII", "ENOC", "ENG", "ENPH", "ESGR", "ENFC", "ENTG", "ENTL", "ETRM", "EBTC", "EFSC", "EGT", "ENZY          ", "EPZM", "PLUS", "EQIX", "EQFN", "EQBK", "ERIC", "ERIE", "ESCA", "ESPR", "ESSA", "EPIX", "ESND", "UTES", "ETSY", "CLWT", "EEFT", "ESEA", "EVEP", "EVBG", "EVK", "MRAM", "EVLV", "EVOK", "EVOL", "EXA", "EXAS", "EXAC", "EXEL", "EXFO", "EXLS", "EXPE", "EXPD", "EXPO", "ESRX", "XOG", "EXTR", "EYEG", "EYEGW", "EZPW", "FFIV", "FB", "FRP", "FALC", "DAVE", "FARM", "FFKT", "FMNB", "FARO", "FAST", "FATE", "FBSS", "FBRC", "FDML", "FNHC", "FHCO", "FENX", "GSM", "FCSC", "FGEN", "ONEQ", "LION", "FDUS", "FRGI", "FSAM", "FSC", "FSCFL", "FSFR", "FITB", "FITBI", "FNGN", "FISI", "FNSR", "FNJN", "FEYE", "FBNC", "FNLC", "FRBA", "BUSE", "FBIZ", "FCAP", "FCFS", "FCNCA", "FCBC", "FCCO", "FCFP", "FBNK", "FDEF", "FFBC", "FFBCW", "FFIN", "THFF", "FFNW", "FFWM", "FGBI", "FHB", "INBK", "INBKL", "FIBK", "FRME", "FMBH", "FMBI", "FNBC", "FNWB", "FSFG", "FSLR", "FSBK", "FAAR", "FPA", "BICK", "FBZ", "FCAN", "FTCS", "FCEF", "FCA", "FDT", "FDTS", "FVC", "FV", "IFV", "FEM", "FEMB", "FEMS", "FTSM", "FEP", "FEUZ", "FGM", "FTGC", "FTHI", "HYLS", "FHK", "FTAG", "FTRI", "FPXI", "YDIV", "SKYY", "FJP", "FEX", "FTC", "FTA", "FLN", "FTLB", "LMBS", "FMB", "FMK", "FNX", "FNY", "FNK", "FAD", "FAB", "MDIV", "MCEF", "QABA", "FTXO", "QCLN", "GRID", "CIBR", "FTXG", "CARZ", "FTXN", "FTXH", "FTXD", "RDVY", "FTXL", "FONE", "TDIV", "FTXR", "QQEW", "QQXT", "QTEC", "AIRR", "QINC", "RFAP", "RFDI", "RFEM", "RFEU", "FTSL", "FYX", "FYC", "FYT", "FKO", "FCVT", "FDIV", "FSZ", "FTW", "TUSA", "FKU", "FUNC", "FUSB", "SVVC", "FSV", "FISV", "FIVE", "FPRX", "FVE", "FIVN", "FLML", "FLEX", "FLKS", "FLXN", "SKOR", "LKOR", "MBSD", "ASET", "ESGG", "ESG", "QLC", "FPAY", "FLXS", "FLIR", "FLDM", "FFIC", "FOMX", "FOGO", "FONR", "FH", "FORM", "FORTY", "FORR", "FRTA", "FTNT", "FBIO", "FWRD", "FORD", "FWP", "FOSL", "FMI", "FOXF", "FRAN", "FELE", "FRED", "RAIL", "FEIM", "FRPT", "FTEO", "FTR", "FTRPR", "FRPH", "FSBW", "FSBC", "FTD", "FTEK", "FCEL", "FLGT", "FORK", "FLL", "FULT", "FNCX", "FSNN", "FFHL", "FXCM", "GK", "WILC", "GAIA", "GLPG", "GALT", "GALTU", "GALTW", "GALE", "GLMD", "GLPI", "GPIC", "GRMN", "GARS", "GDS", "GEMP", "GENC", "GNCMA", "GFN", "GFNCP", "GFNSL", "GENE", "GNUS", "GNMK", "GNCA", "GHDX", "GNTX", "THRM", "GNVC", "GTWN", "GEOS", "GABC", "GERN", "GEVO", "ROCK", "GIGM", "GIGA", "GIII", "GILT", "GILD", "GBCI", "GLAD", "GLADO", "GOOD", "GOODM", "GOODO", "GOODP", "GAIN", "GAINM", "GAINN", "GAINO", "LAND", "LANDP", "GLBZ", "GBT", "ENT", "GBLI", "GBLIZ", "GPAC", "GPACU", "GPACW", "SELF", "GSOL", "GWRS", "KRMA", "FINX", "ACTX", "BFIT", "SNSR", "LNGR", "MILN", "EFAS", "QQQC", "BOTZ", "CATH", "SOCL", "ALTY", "SRET", "YLCO", "GLBS", "GLUU", "GLYC", "GOGO", "GLNG", "GMLP", "GDEN", "GOGL", "GBDC", "GTIM", "GPRO", "GMAN", "GOV", "GOVNI", "GPIA", "GPIAU", "GPIAW", "LOPE", "GRVY", "FULLL", "GECC", "GEC", "GLDD", "GSBC", "GNBC", "GRBK", "GPP", "GPRE", "GCBC", "GLRE", "GSUM", "GRIF", "GRFS", "GRPN", "OMAB", "GGAL", "GSIT", "GSVC", "GTXI", "GTYH", "GTYHU", "GTYHW", "GBNK", "GFED", "GUID", "GIFI", "GURE", "GPOR", "GWPH", "GWGH", "GYRO", "HEES", "HLG", "HNRG", "HALL", "HALO", "HBK", "HBHC", "HBHCL", "HNH", "HAFC", "HQCL", "HONE", "HDNG", "HLIT", "HRMN", "HRMNU", "HRMNW", "TINY", "HBIO", "HCAP", "HCAPL", "HAS", "HA", "HCOM", "HWKN", "HWBK", "HAYN", "HDS", "HIIQ", "HCSG", "HQY", "HSTM", "HWAY", "HTLD", "HTLF", "HTBX", "HSII", "HELE", "HMNY", "HMTV", "HNNA", "HCAC", "HCACU", "HCACW", "HSIC", "HTBK", "HFWA", "HEOP", "HCCI", "MLHR", "HRTX", "HSKA", "HIBB", "SNLN", "HPJ", "HIHO", "HIMX", "HIFS", "HSGX", "HMNF", "HMSY", "HOLI", "HOLX", "HBCP", "HOMB", "HFBL", "HMST", "HMTA", "HTBI", "HMU", "CETC", "HOFT", "HOPE", "HFBC", "HBNC", "HZNP", "HRZN", "HDP", "HPT", "HPTRP", "TWNK", "TWNKW", "HMHC", "HWCC", "HOVNP", "HBMD", "HSNI", "HTGM", "HUBG", "HSON", "HDSN", "HUNTU", "HBAN", "HBANN", "HBANO", "HBANP", "HURC", "HURN", "HCM", "HBP", "HDRA", "HDRAR", "HDRAU", "HDRAW", "HYGS", "IDSY", "IAC", "IKGH", "IBKC", "IBKCO", "IBKCP", "ICAD", "IEP", "ICFI", "ICLR", "ICON", "ICUI", "IPWR", "INVE", "IDRA", "IDXX", "IESC", "IROQ", "IRG", "RXDX", "INFO", "IIVI", "KANG", "IKNX", "ILG", "ILMN", "ISNS", "IMMR", "ICCC", "IMDZ", "IMNP          ", "IMGN", "IMMU", "IPXL", "PI", "IMMY", "INCR", "INCY", "INDB", "IBCP", "IBTX", "IDSA", "INFN", "INFI", "IPCC", "III", "IFON", "IMKTA", "INWK", "INNL", "INOD", "IPHS", "IOSP", "ISSC", "INVA", "INGN", "ITEK", "INOV", "INO", "INSG", "NSIT", "ISIG", "INSM", "IIIN", "PODD", "INSY", "NTEC", "IART", "IDTI", "INTC", "IQNT", "NTLA", "IPCI", "IPAR", "IBKR", "ININ", "ICPT", "IDCC", "TILE", "LINK", "IMI", "INAP", "IBOC", "ISCA", "IGLD", "IIJI", "IDXG", "XENT", "INTX", "ISIL", "IVAC", "INTL", "ITCI", "IIN", "INTU", "ISRG", "INVT", "SNAK", "ISTR", "ISBC", "ITIC", "NVIV", "IVTY", "IONS", "IPAS", "DTYS", "DTYL", "DTUS", "DTUL", "DFVS", "DFVL", "FLAT", "DLBS", "STPP", "IPGP", "IRMD", "IRTC", "IRIX", "IRDM", "IRDMB", "IRBT", "IRWD", "IRCP", "PMPT", "SLQD", "TLT", "AIA", "COMT", "IXUS", "FALN", "IFEU", "IFGL", "IGF", "GNMA", "HYXE", "JKI", "ACWX", "ACWI", "AAXJ", "EWZS", "MCHI", "ESGD", "SCZ", "ESGE", "EEMA", "EUFN", "IEUS", "MPCT", "ENZL", "QAT", "UAE", "IBB", "SOXX", "EMIF", "ICLN", "WOOD", "INDY", "ISHG", "IGOV", "ISLE", "ISRL", "ITI", "ITRI", "ITRN", "ITUS", "IVENC", "IVFGC", "IVFVC", "XXIA", "IXYS", "IZEA", "JJSF", "MAYS", "JBHT", "JCOM", "JASO", "JKHY", "JACK", "JXSB", "JAGX", "JAKK", "JMBA", "JRVR", "JSML", "JSMD", "JASN", "JASNW", "JAZZ", "JD", "JSYN", "JSYNR", "JSYNU", "JSYNW", "JBLU", "JTPY", "JCTCF", "JIVE", "WYIG", "WYIGU", "WYIGW", "JBSS", "JOUT", "JNP", "JUNO", "KTWO", "KALU", "KALV", "KMDA", "KNDI", "KPTI", "KBSF", "KCAP", "KRNY", "KELYA", "KELYB", "KMPH", "KFFB", "KERX", "KEQU", "KTEC", "KTCC", "KFRC", "KE", "KBAL", "KIN", "KGJI", "KINS", "KONE", "KNSL", "KIRK", "KITE", "KTOV", "KTOVW", "KLAC", "KLRE", "KLREU", "KLREW", "KLXI", "KONA", "KZ", "KOPN", "KRNT", "KOSS", "KWEB", "KTOS", "KLIC", "KURA", "KVHI", "FSTR", "LJPC", "LSBK", "LSBG", "LBAI", "LKFN", "LAKE", "LRCX", "LAMR", "LANC", "LCA", "LCAHU", "LCAHW", "LNDC", "LARK", "LMRK", "LMRKO", "LMRKP", "LE", "LSTR", "LNTH", "LTRX", "LSCC", "LAWS", "LAYN", "LCNB", "LBIX", "LGCY", "LGCYO", "LGCYP", "LTXB", "DDBI", "EDBI", "LVHD", "UDBI", "LMAT", "TREE", "LXRX", "LGIH", "LHCG", "LLIT", "LBRDA", "LBRDK", "LEXEA", "LEXEB", "LBTYA", "LBTYB", "LBTYK", "LILA", "LILAK", "LVNTA", "LVNTB", "QVCA", "QVCB", "BATRA", "BATRK", "LMCA", "LMCK", "LSXMA", "LSXMB", "LSXMK", "TAX", "LTRPA", "LTRPB", "LPNT", "LCUT", "LFVN", "LWAY", "LGND", "LTBR", "LPTH", "LMB", "LLNW", "LMNR", "LINC", "LECO", "LIND", "LINDW", "LLTC", "LBIO", "LIOX", "LPCN", "LQDT", "LFUS", "LIVN", "LOB", "LIVE", "LPSN", "LKQ", "LMFA", "LMFAW", "LMIA", "LOGI", "LOGM", "EVAR", "CNCR", "LONE", "LTEA", "LORL", "LOXO", "LPTN", "LPLA", "LRAD", "LYTS", "LULU", "LITE", "LMNX", "LMOS", "LUNA", "MBTF", "MACQ", "MACQU", "MACQW", "MIII", "MIIIU", "MIIIW", "MBVX", "MCBC", "MFNC", "MTSI", "MCUR", "MGNX", "MDGL", "MAGS", "MGLN", "MPET", "MGIC", "CALL", "MNGA", "MGYR", "MHLD", "MSFG", "COOL", "MMYT", "MBUU", "MLVF", "MAMS", "TUSK", "MANH", "LOAN", "MNTX", "MTEX", "MNKD", "MANT", "MARA", "MCHX", "MARPS", "MRNS", "MKTX", "MRLN", "MAR", "MBII", "MRTN", "MMLP", "MRVL", "MASI", "MTCH", "MATN", "MTLS", "MTRX", "MAT", "MATR", "MATW", "MXIM", "MXPT", "MXWL", "MZOR", "MBFI", "MBFIP", "MCFT", "MGRC", "MDCA", "MFIN", "MFINL", "MDGN", "MTBC", "MTBCP", "MNOV", "MDSO", "MDGS", "MDWD", "MDVX", "MDVXW", "MEDP", "MEET", "MEIP", "MPEL", "MLNX", "MELR", "MEMP", "MENT", "MTSL", "MELI", "MBWM", "MERC", "MBVT", "MRCY", "EBSB", "VIVO", "MMSI", "MACK", "MSLI", "MRUS", "MLAB", "MESO", "CASH", "MBLX", "MEOH", "MFRI", "MGCD", "MGEE", "MGPI", "MCHP", "MU", "MICT", "MICTW", "MSCC", "MSFT", "MSTR", "MVIS", "MPB", "MTP", "MCEP", "MBRG", "MBCN", "MSEX", "MSBI", "MOFG", "MIME", "MDXG", "MNDO", "MB", "NERV", "MRTX", "MIRN", "MSON", "MIND", "MINDP", "MITK", "MITL", "MKSI", "MMAC", "MINI", "MOBL", "MOCO", "MDSY", "MLNK", "MBRX", "MNTA", "MOMO", "MCRI", "MDLZ", "MGI", "MPWR", "TYPE", "MNRO", "MRCC", "MNST", "MSDI", "MSDIW", "MHGC", "MORN", "MOSY", "MTFB", "MTFBW", "MPAA", "MDM", "MOXC", "MRVC", "MSBF", "MSG", "MTGE", "MTGEP", "MTSC", "LABL", "MFSF", "MYSZ", "MYL", "MYOK", "MYOS", "MYRG", "MYGN", "NBRV", "NAKD", "NNDM", "NANO", "NSTG", "NH", "NK", "NSSC", "NDAQ", "NTRA", "NATH", "NAUH", "NKSH", "FIZZ", "NCMI", "NCOM", "NGHC", "NGHCN", "NGHCO", "NGHCP", "NGHCZ", "NHLD", "NATI", "NRCIA", "NRCIB", "NSEC", "NWLI", "NAII", "NHTC", "NATR", "BABY", "NAVI", "NBTB", "NCIT", "NKTR", "NEOG", "NEO", "NEON", "NEOS", "NEOT", "NVCN", "NEPT", "UEPS", "NETE", "NTAP", "NTES", "NFLX", "NTGR", "NLST", "NTCT", "NTWK", "CUR", "NBIX", "NDRM", "NURO", "NUROW", "NYMT", "NYMTO", "NYMTP", "NLNK", "NWS", "NWSA", "NEWS", "NEWT", "NEWTL", "NEWTZ", "NXEO", "NXEOU", "NXEOW", "NXST", "NVET", "NFEC", "EGOV", "NICE", "NICK", "NCBS", "NIHD", "NVLS", "NMIH", "NNBR", "NDLS", "NDSN", "NSYS", "NBN", "NTIC", "NTRS", "NTRSP", "NFBK", "NRIM", "NWBI", "NWBO", "NWBOW", "NWPX", "NCLH", "NWFL", "NVFY", "NVMI", "NVDQ", "NOVN", "NOVT", "NVAX", "NVCR", "NVGN", "NUAN", "NMRX", "NTNX", "NUTR", "NTRI", "NUVA", "NVTR", "QQQX", "NVEE", "NVEC", "NVDA", "NXPI", "NXTM", "NXTD", "NXTDW", "NYMX", "OIIM", "OVLY", "OASM", "OBLN", "OBCI", "OPTT", "ORIG", "OSHC", "OCFC", "OCRX", "OCLR", "OFED", "OCUL", "OCLS", "OCLSW", "OMEX", "ODP", "OFS", "OHAI", "OVBC", "OHRP", "ODFL", "OLBK", "ONB", "OPOF", "OSBC", "OSBCP", "OLLI", "ZEUS", "OFLX", "OMER", "OMCL", "ON", "OTIV", "ONS", "ONSIW", "ONSIZ", "OGXI", "OMED", "ONTX", "ONTXW", "ONCS", "OHGI", "ONVI", "OTEX", "OPXA", "OPXAW", "OPGN", "OPGNW", "OPHT", "OPK", "OBAS", "OCC", "OPHC", "OPB", "ORMP", "OSUR", "ORBC", "ORBK", "ORLY", "OREX", "ONVO", "SEED", "OACQ", "OACQR", "OACQU", "OACQW", "OESX", "ORIT", "ORRF", "OFIX", "OSIS", "OSIR", "OSN", "OTEL", "OTIC", "OTTW", "OTTR", "OVAS", "OSTK", "OXBR", "OXBRW", "OXFD", "OXLC", "OXLCN", "OXLCO", "PFIN", "PTSI", "PCAR", "PACE", "PACEU", "PACEW", "PACB", "PCBK", "PEIX", "PMBC", "PPBI", "PAAC", "PAACR", "PAACU", "PAACW", "PCRX", "PACW", "PTIE", "PAAS", "PNRA", "PANL", "PZZA", "FRSH", "PBNC", "PRTK", "PRXL", "PCYG", "PSTB", "PKBK", "PRKR", "PKOH", "PARN", "PTNR", "PBHC", "PATK", "PNBK", "PATI", "PEGI", "PDCO", "PTEN", "PAVM", "PAVMW", "PAYX", "PCTY", "PYDS", "PYPL", "PBBI", "CNXN", "PCMI", "PCTI", "PDCE", "PDFS", "PDLI", "PDVW", "SKIS", "PGC", "PEGA", "PCO", "PENN", "PFLT", "PNNT", "PWOD", "PTXP", "PEBO", "PEBK", "PFBX", "PFIS", "PBCT", "PUB", "PRCP", "PPHM", "PPHMP", "PRFT", "PFMT", "PERF", "PERI", "PESI", "PTX", "PERY", "PGLC", "PETS", "PFSW", "PGTI", "PZRX", "PHII", "PHIIK", "PAHC", "PHMD", "PLAB", "PICO", "PIRS", "PPC", "PME", "PNK", "PNFP", "PPSI", "PXLW", "PLPM", "PLXS", "PLUG", "PLBC", "PSTI", "PBSK", "PNTR", "PCOM", "POOL", "POPE", "PLKI", "BPOP", "BPOPM", "BPOPN", "PBIB", "PTLA", "PBPB", "PCH", "POWL", "POWI", "PSIX", "DWLV", "DWIN", "DWTR", "IDLB", "PRFZ", "PAGG", "PSAU", "IPKW", "LDRI", "LALT", "PNQI", "PDBC", "QQQ", "USLB", "PSCD", "PSCC", "PSCE", "PSCF", "PSCH", "PSCI", "PSCT", "PSCM", "PSCU", "VRIG", "PRAA", "PRAH", "PRAN", "PFBC", "PLPC", "PFBI", "PINC", "LENS", "PRGX", "PSMT", "PBMD", "PNRG", "PRMW", "PRIM", "BTEC", "GENY", "PSET", "PY", "PSC", "PRZM", "PVTB", "PVTBP", "PDEX", "IPDN", "PFIE", "PGNX", "PRGS", "DNAI", "PFPT", "PRPH", "PRQR", "BIB", "UBIO", "TQQQ", "ZBIO", "SQQQ", "BIS", "PSEC", "PTGX", "PRTO", "PTI", "PRTA", "PVBC", "PROV", "PBIP", "PSDV", "PMD", "PTC", "PTCT", "PULM", "PLSE", "PCYO", "IMED", "FINQ", "PXS", "QADA", "QADB", "QCRH", "QGEN", "QIWI", "QLTI", "QRVO", "QCOM", "QSII", "QBAK", "QLYS", "QTNA", "QRHC", "QUIK", "QDEL", "QPAC", "QPACU", "QPACW", "QNST", "QUMU", "QUNR", "QTNT", "RRD", "RARX", "RADA", "RDCM", "ROIA", "ROIAK", "RSYS", "RDUS", "RDNT", "RDWR", "RMBS", "RAND", "RLOG", "GOLD", "RNDB", "RPD", "RAVE", "RAVN", "ROLL", "TALL", "RICK", "RCMT", "RDI", "RDIB", "RGSE", "RELY", "RNWK", "RP", "RETA", "DAX", "QYLD", "RCON", "REPH", "RRGB", "RRR", "RDHL", "REGN", "RGNX", "RGLS", "REIS", "RELV", "MARK", "RNST", "REGI", "RNVA", "RNVAZ", "RCII", "RTK", "RGEN", "RPRX", "RBCAA", "FRBK", "REFR", "RESN", "RECN", "ROIC", "SALE", "RTRX", "RVNC", "RVEN", "RVLT", "RWLK", "REXX", "RFIL", "RGCO", "RIBT", "RIBTW", "RELL", "RIGL", "NAME", "RNET", "RTTR", "RVSB", "RLJE", "RMGN", "ROBO", "FUEL", "RMTI", "RCKY", "RMCF", "ROKA", "ROSG", "ROST", "RBPAA", "RGLD", "RPXC", "RTIX", "RBCN", "RUSHA", "RUSHB", "RUTH", "RXII", "RYAAY", "STBA", "SANW", "SCAC", "SCACU", "SCACW", "SBRA", "SBRAP", "SABR", "SAEX", "SAFT", "SAGE", "SAIA", "SAJA", "SALM", "SAL", "SAFM", "SASR", "SGMO", "SANM", "GCVRZ", "SPNS", "SRPT", "SBFG", "SBFGP", "SBAC", "SCSC", "SMIT", "SCHN", "SCHL", "SCLN", "SGMS", "SNI", "SCYX", "SEAC", "SBCF", "STX", "SHIP", "SRSC", "SHLD", "SHLDW", "SHOS", "SPNE", "SGEN", "EYES", "SCWX", "SNFCA", "SEIC", "SLCT", "SCSS", "SIR", "SELB", "SIGI", "LEDS", "SMTC", "SENEA", "SENEB", "SNH", "SNHNI", "SNHNL", "SNMX", "SRTS", "SRTSW", "SQBG", "MCRB", "SREV", "SFBS", "SEV", "SVBI", "SGOC", "SMED", "SHSP", "SHEN", "SHLO", "TYHT", "SHPG", "SCVL", "SHBI", "SHOR", "SFLY", "SIFI", "SIEB", "SIEN", "BSRR", "SWIR", "SIFY", "SIGM", "SGMA", "SGNL", "SBNY", "SBNYW", "SLGN", "SILC", "SLAB", "SIMO", "SPIL", "SSRI", "SAMG", "SFNC", "SLP", "SINA", "SBGI", "SINO", "SVA", "SIRI", "SITO", "SKYS", "SKLN", "SPU", "SKYW", "SWKS", "ISM", "JSM", "OSM", "SLM", "SLMAP", "SLMBP", "SND", "SMBK", "SWHC", "SMSI", "SMTX", "LNCE", "SRAX", "SCKT", "SODA", "SOHU", "SLRC", "SUNS", "SEDG", "SONC", "SOFO", "SONS", "SPHS", "SORL", "SRNE", "SOHO", "SOHOB", "SOHOM", "SFBC", "SSB", "SFST", "SMBC", "SONA", "SBSI", "OKSB", "SP", "SPAN", "SBSA", "SGRP", "SPKE", "ONCE", "SPAR", "SPTN", "DWFI", "SPPI", "ANY", "SPEX", "SPI", "SAVE", "SPLK", "SPOK", "SPWH", "SBPH", "FUND", "SFM", "SPSC", "SSNC", "STAA", "STAF", "STMP", "STLY", "SPLS", "SBLK", "SBLKL", "SBUX", "STRZA", "STRZB", "STFC", "STBZ", "SNC", "STDY", "GASS", "STLD", "SMRT", "STLR", "STLRU", "STLRW", "SBOT", "STEM", "STML", "SRCL", "SRCLP", "STRL", "SHOO", "SSFN", "SYBT", "BANX", "SGBK", "SSKN", "SSYS", "STRT", "STRS", "STRA", "STRM", "SBBP", "STB", "SCMP", "SUMR", "SMMF", "SSBI", "SMMT", "SNBC", "SNHY", "SNDE", "SEMI", "SNSS", "STKL", "SPWR", "RUN", "SBCP", "SSH", "SUNW", "SMCI", "SPCB", "SCON", "SGC", "SUPN", "SPRT", "SGRY", "SCAI", "SRDX", "SBBX", "SIVB", "SIVBO", "SYKE", "SYMC", "SYNC", "SYNL", "SYNA", "SNCR", "SNDX", "SGYP", "SGYPU", "SGYPW", "ELOS", "SNPS", "SYNT", "SYMX", "SYUT", "SYPR", "SYRS", "SYRX", "TROW", "TTOO", "TRHC", "TCMD", "TAIT", "TTWO", "TLND", "TNDM", "TLF", "TNGO", "TANH", "TPIV", "TEDU", "TASR", "TATT", "TAYD", "TCPC", "AMTD", "TEAR", "TECD", "TCCO", "TTGT", "TGLS", "TGEN", "TNAV", "TTEC", "TLGT", "TENX", "GLBL", "TERP", "TRTL", "TRTLU", "TRTLW", "TVIA", "TBNK", "TSRO", "TESO", "TSLA", "TESS", "TSRA", "TTEK", "TTPH", "TCBI", "TCBIL", "TCBIP", "TCBIW", "TXN", "TXRH", "TFSL", "TGTX", "ABCO", "ANDE", "TBBK", "BONT", "CG", "CAKE", "CHEF", "TCFC", "DSGX", "DXYN", "ENSG", "XONE", "FINL", "FBMS", "FLIC", "GT", "HABT", "HCKT", "HAIN", "FITS", "CUBA", "INTG", "JYNT", "KEYW", "KHC", "OLD", "MDCO", "MIK", "MIDD", "NAVG", "SLIM", "STKS", "ORG", "PCLN", "PRSC", "BITE", "RMR", "SPNC", "TTD", "ULTI", "YORW", "NCTY", "TBPH", "TST", "TCRD", "THLD", "TICC", "TTS", "TIL", "TSBK", "TIPT", "TITN", "TTNP", "TIVO", "TMUS", "TMUSP", "TKAI", "TNXP", "TISA", "TOPS", "TORM          ", "TRCH", "TSEM", "TWER", "CLUB", "TOWN", "TPIC", "TCON", "TSCO", "TWMC", "TACT", "TRNS", "TBIO", "TGA", "TA", "TANNI", "TANNL", "TANNZ", "TZOO", "TRVN", "TCBK", "TRIL", "TRS", "TRMB", "TRIB", "TRIP", "TSC", "TBK", "TRNC", "TROV", "TROVU", "TROVW", "TRUE", "THST", "TRUP", "TRST", "TRMK", "TSRI", "TTMI", "TUBE", "TCX", "TUES", "TOUR", "HEAR", "TUTI", "TUTT", "FOX", "FOXA", "TWIN", "TRCB", "USCR", "PRTS", "USEG", "GROW", "UBNT", "UFPT", "ULTA", "UCTT", "RARE", "ULBI", "UTEK", "UMBF", "UMPQ", "UNAM", "UNIS", "UBSH", "UNB", "UNXL", "QURE", "UBCP", "UBOH", "UBSI", "UCBA", "UCBI", "UCFC", "UBNK", "UFCS", "UIHC", "UNFI", "UBFO", "USLM", "UTHR", "UG", "UNTY", "OLED", "UEIC", "UFPI", "ULH", "USAP", "UVSP", "UPLD", "URRE", "URBN", "ECOL", "USAT", "USATP", "USAK", "UTMD", "UTSI", "VALX", "VALU", "VNDA", "BBH", "GNRX", "PPH", "VWOB", "VNQI", "VGIT", "VCIT", "VIGI", "VYMI", "VCLT", "VGLT", "VMBS", "VNR", "VNRAP", "VNRBP", "VNRCP", "VONE", "VONG", "VONV", "VTWO", "VTWG", "VTWV", "VTHR", "VCSH", "VGSH", "VTIP", "BNDX", "VXUS", "VRNS", "VDSI", "VBLT", "VASC", "VBIV", "WOOF", "VECO", "DGLD", "DSLV", "UGLD", "USLV", "TVIZ", "TVIX", "ZIV", "XIV", "VIIZ", "VIIX", "APPY", "VRA", "VCYT", "VSTM", "VCEL", "VRNT", "VRSN", "VRSK", "VBTX", "VRML", "VSAR", "VTNR", "VRTX", "VRTB", "VIA", "VIAB", "VSAT", "VIAV", "VICL", "VICR", "CIZ", "CEZ", "CID", "CIL", "CFO", "CFA", "CSF", "CDC", "CDL", "CSB", "CSA", "VBND", "VUSE", "VIDI", "VDTH", "VRAY", "VKTX", "VKTXW", "VBFC", "VLGEA", "VIP", "VNOM", "VIRC", "VA", "VIRT", "VRTS", "VRTU", "VISN", "VTGN", "VTL", "VIVE", "VVUS", "VOD", "VLTC", "VOXX", "VYGR", "VSEC", "VTVT", "VUZI", "VWR", "WGBS", "WBA", "WAFD", "WAFDW", "WASH", "WFBI", "WSBF", "WVE", "WAYN", "WSTG", "WCFB", "WDFC", "FLAG", "WEB", "WBMD", "WCST", "WB", "WEBK", "WEN", "WERN", "WSBC", "WTBA", "WSTC", "WMAR", "WABC", "WBB", "WSTL", "WDC", "WNEB", "WLB", "WPRT", "WEYS", "WHLR", "WHLRD", "WHLRP", "WHLRW", "WHF", "WHFBL", "WFM", "WILN", "WHLM", "WVVI", "WVVIP", "WLDN", "WLFC", "WLTW", "WIN", "WINT", "WING", "WINA", "WINS", "WTFC", "WTFCM", "WTFCW", "AGND", "AGZD", "HYND", "HYZD", "CXSE", "EMCG", "EMCB", "DGRE", "DXGE", "WETF", "DXJS", "DXKW", "GULF", "CRDT", "DGRW", "DGRS", "DXPS", "UBND", "WIX", "WMIH", "WBKC", "WWD", "WKHS", "WRLD", "JMU", "WPCS", "WPPGY", "WMGI", "WMGIZ", "WSFS", "WSFSL", "WSCI", "WVFC", "WYNN", "XBIT", "XELB", "XCRA", "XNCR", "XBIO", "XBKS", "XENE", "XGTI", "XGTIW", "XLNX", "XOMA", "XPLR", "XTLB", "XNET", "YHOO", "YNDX", "YIN", "YRCW", "YECO", "YY", "ZFGN", "ZAGG", "ZAIS", "ZBRA", "ZLTQ", "Z", "ZG", "ZN", "ZNWAA", "ZION", "ZIONW", "ZIONZ", "ZIOP", "ZIXI", "ZGNX", "ZSAN", "ZUMZ", "ZYNE", "ZNGA"];

                    Tickers.prototype.ticker = function () {
                        var length = Tickers.TICKERS.length;
                        var index = Math.floor(Math.random() * length);
                        return Tickers.TICKERS[index];
                    };

                    var tickers = new Tickers();
                    var lipsum = new LoremIpsum();

                    function getLipsum(num) {
                        var phrase = lipsum.generate(num + 2);
                        return phrase.substring(0, 1).toUpperCase() + phrase.substring(1);
                    }

                    function randomNumber(max, signed) {
                        var val = Math.random() * max;
                        if (signed) val *= Math.random() > 0.5 ? 1 : -1;
                        return val;
                    }

                    function randomSignedNumber(max, negative) {
                        var val = Math.random() * max;
                        return val * (negative ? -1 : 1);
                    }

                    function randomArray(length, max) {
                        var i = 0;
                        var arr = [];
                        var rnd = Math.random();
                        var num, sign;

                        if (rnd >= 0.2 && rnd < 0.7) {
                            sign = true;
                        } else if (rnd >= 0.7) {
                            sign = false;
                        }

                        for (; i < length; i++) {
                            if (typeof sign === "undefined") {
                                num = randomNumber(max, true);
                            } else {
                                num = randomSignedNumber(max, !sign);
                            }

                            arr[i] = num;
                        }

                        return arr;
                    }

                    var scatterplot = {
                        item: function item() {
                            var ticker = tickers.ticker();
                            return {
                                totalReturn: randomNumber(20, true),
                                standardDeviation: randomNumber(20, true),
                                weight: randomNumber(100),
                                ticker: ticker
                            };
                        },

                        category: function category() {
                            var arr = [];
                            var num = Math.ceil(Math.random() * 5);
                            var i = 0;
                            for (; i < num; i++) {
                                arr.push(scatterplot.item());
                            }

                            return {
                                category: getLipsum(2),
                                data: arr
                            };
                        },

                        data: function data() {
                            var dataset = [];
                            var num = Math.ceil(Math.random() * 5) + 1;
                            var i = 0;

                            for (; i < num; i++) {
                                dataset.push(scatterplot.category());
                            }

                            return {
                                benchmark: {
                                    totalReturn: randomNumber(20, true),
                                    standardDeviation: randomNumber(20, true)
                                },
                                data: dataset
                            };
                        }
                    };

                    var barchart = {
                        data: function data(howMany, maxValue) {
                            var dataset = [];
                            var num = Math.ceil(Math.random() * 5) + 1;
                            var i = 0;
                            howMany = howMany || 7;
                            maxValue = maxValue || 100;

                            for (; i < num; i++) {
                                dataset.push(barchart.series(howMany, maxValue));
                            }

                            return dataset;
                        },

                        data2: function data2(howMany, maxValue) {
                            var dataset = [];
                            var num = Math.ceil(Math.random() * 5) + 1;
                            var i = 0;
                            howMany = howMany || 7;
                            maxValue = maxValue || 100;

                            for (; i < num; i++) {
                                dataset.push({
                                    name: "Data " + (i + 1),
                                    values: randomArray(howMany, maxValue)
                                });
                            }

                            return dataset;
                        },

                        series: function series(howMany, maxValue) {
                            return {
                                name: getLipsum(2),
                                values: randomArray(howMany, maxValue)
                            };
                        },

                        categories: function categories(prefix, num) {
                            var arr = [];
                            var i = 0;
                            for (; i < num; i++) {
                                arr[i] = prefix + " " + (i + 1);
                            }

                            return arr;
                        },

                        xlabels: function xlabels(num) {
                            var i = 0;
                            var arr = [];
                            for (; i < num; i++) {
                                if (Math.random() > 0.7) {
                                    arr[i] = getLipsum(1);
                                } else {
                                    arr[i] = null;
                                }
                            }

                            return arr;
                        }
                    };

                    var getRandomDate = function getRandomDate(start, end) {
                        return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
                    };

                    var generateDates = function generateDates(range, amtOfDates) {
                        var dates = [];

                        var dateRange = void 0;
                        switch (range) {
                            case "hours":
                                dateRange = function dateRange() {
                                    return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 2));
                                };
                                break;
                            case "days":
                                dateRange = function dateRange() {
                                    return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 6));
                                };
                                break;
                            case "weeks":
                                dateRange = function dateRange() {
                                    return getRandomDate(new Date(2016, 0, 1), new Date(2016, 1, 28));
                                };
                                break;
                            case "months":
                                dateRange = function dateRange() {
                                    return getRandomDate(new Date(2016, 0, 1), new Date(2016, 11, 1));
                                };
                                break;
                            case "quarters":
                                dateRange = function dateRange() {
                                    return getRandomDate(new Date(2015, 0, 1), new Date(2016, 12, 31));
                                };
                                break;
                            case "years":
                                dateRange = function dateRange() {
                                    return getRandomDate(new Date(2010, 0, 1), new Date(2016, 11, 0));
                                };
                                break;
                            default:
                                console.error("range required to generate dates");
                                break;
                        }

                        for (var i = 0; i < amtOfDates; i++) {
                            dates.push(dateRange());
                        }

                        return dates;
                    };

                    function getIncrementalValue(increment) {
                        var positive = Math.floor(Math.random() * 2 + 1) === 1 ? false : true;

                        if (positive) {
                            return Math.floor(Math.random() * increment);
                        } else {
                            return -Math.floor(Math.random() * increment);
                        }
                    }

                    //***** line chart *****/

                    var LineGenerator = function LineGenerator(dateRange) {
                        this.leng = 50;
                        this.dates = generateDates(dateRange, this.leng);
                    };

                    LineGenerator.prototype.generateDataset = function (opts) {
                        return {
                            y1: this.generateLineData(opts),
                            y2: this.generateLineData(opts)
                        };
                    };

                    LineGenerator.prototype.generateLineData = function (opts) {
                        var groupName = Math.floor(Math.random() * 2 + 1) === 1 ? "y2" : "y1";
                        var time = new Date();
                        var name = time.getMilliseconds() + Math.floor(Math.random() * 999).toString();
                        var segments = [];
                        var currentValue = Math.floor(Math.random() + opts.minValue);

                        for (var i = 0; i < opts.segments; i++) {
                            var newValue;
                            if (currentValue >= opts.maxValue || currentValue + opts.increment > opts.maxValue) {
                                newValue = currentValue - opts.increment;
                            } else {
                                newValue = currentValue + getIncrementalValue(opts.increment);
                            }

                            segments.push({
                                name: name,
                                value: newValue,
                                date: this.dates[i],
                                groupName: groupName
                            });
                            currentValue = newValue;
                        }
                        return segments;
                    };

                    /**** end linechart */

                    module.exports = {
                        ticker: tickers.ticker,
                        lipsum: getLipsum,
                        number: randomNumber,
                        array: randomArray,
                        scatterplot: scatterplot,
                        barchart: barchart,
                        getRandomDate: getRandomDate,
                        generateDates: generateDates,
                        linechart: LineGenerator,
                        crmatrix: crmatrix
                    };

                    /***/
                },

                /***/45:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    /**
                     * Calls a function if exists. The first argument should be the function to call followed by the arguments.
                     *
                     * @return {Object} Undefined if there is no function to call or what the function returns.
                     */

                    var callFn = function callFn() {
                        var args = Array.prototype.slice.call(arguments, 2);
                        var context = arguments[0];
                        var fn = arguments[1];

                        if (fn) {
                            return fn.apply(context, args);
                        }
                    };

                    module.exports = {
                        call: callFn
                    };

                    /***/
                },

                /***/46:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    module.exports = {
                        /**
                         * Returns how many digits have a number.
                         * @param {number} number Number to inspect. Rquired.
                         * @param {Number} base Numeric base.
                         * @returns {Number}
                         */
                        digits: function digits(number) {
                            var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

                            var digits = 0;

                            while (number >= 1) {
                                number = number / base;
                                digits++;
                            }

                            return digits;
                        },
                        /**
                        * @method isNumber
                        * @desc Judge if a value is a valid number or a valid string number
                        * @param literals value
                        * Return Boolean
                        */
                        isNumber: function isNumber(value) {
                            if (typeof value === "number" && isFinite(value)) {
                                return true;
                            }
                            if (typeof value === "string" && value !== "" && !isNaN(value - 0)) {
                                return true;
                            }
                            return false;
                        }

                    };

                    /***/
                },

                /***/47:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var CARDINAL_STR = "$$";

                    /**
                     * It returns either the original value if zero or positive, or, if negative or NaN, the value with an em dash.
                     *
                     * @param {Number} A single number.
                     * @return {Number || String} 10, "—10", "NaN", ...
                     */
                    function convertDashToEnDash(val) {
                        var stringed = val.toString();

                        if (stringed === "NaN") {
                            return '\u2013';
                        }

                        if (stringed[0] === "-") {
                            var sliced = stringed.slice(1);
                            sliced = '\u2013' + sliced;
                            return sliced;
                        }

                        return val;
                    }
                    /**
                     * Generates a Unique ID.
                     * @returns {String} New unique ID.
                     */
                    var UID = function UID() {
                        return "_" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5));
                    };

                    /**
                     * Converts a string in dashed format.
                     *
                     * @param {String} str String to convert.
                     * @returns {String}
                     */
                    function dashify(str) {
                        str = str.replace(/\s+/g, "-").toLowerCase();
                        return str;
                    }

                    /**
                     * Compiles a string template agains a context and returns a new string.
                     * <code>
                     * var template =
                     * 'My skills:' +
                     * '<%if(this.showSkills) {%>' +
                     *    '<%for(var index in this.skills) {%>' +
                     *    '<a href="#"><%this.skills[index]%></a>' +
                     *   '<%}%>' +
                     * '<%} else {%>' +
                     *    '<p>none</p>' +
                     * '<%}%>';
                     * console.log(TemplateEngine(template, {
                     *    skills: ["js", "html", "css"],
                     *    showSkills: true
                     * }));
                     * </code>
                     * @param {String} html Template string.
                     * @param {Object} data Context object that contains the data.
                     * @returns {String}
                     */
                    var template = function template(html, data) {
                        var re = /<%([^%>]+)?%>/g;
                        var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
                        var code = "var r=[];\n";
                        var cursor = 0;
                        var match;

                        var add = function add(line, js) {
                            js ? code += line.match(reExp) ? line + "\n" : "r.push(" + line + ");\n" : code += line !== "" ? "r.push('" + line.replace(/"/g, "\\'") + "');\n" : ""; //jshint ignore:line
                            return add;
                        };

                        match = re.exec(html);
                        while (match) {
                            add(html.slice(cursor, match.index))(match[1], true);
                            cursor = match.index + match[0].length;
                            match = re.exec(html);
                        }

                        add(html.substr(cursor, html.length - cursor));
                        code += "return r.join('');";
                        return new Function(code.replace(/[\r\t\n]/g, "")).apply(data); // jshint ignore:line
                    };

                    /**
                     * Adds a prefix based on an index.
                     *
                     * @param {String} str
                     * @param {Number} index
                     * @returns {String}
                     */
                    function mask(str, index) {
                        return index + CARDINAL_STR + str;
                    }

                    /**
                     * Remove index based prefix.
                     *
                     * @param {String} str
                     * @returns {String}
                     */
                    function unmask(str) {
                        var indx = str.indexOf(CARDINAL_STR);
                        return str.substr(indx + CARDINAL_STR.length);
                    }

                    /**
                     * Get pixel with of string appended to the DOM
                     *
                     * @param {String} txt
                     * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
                     * @param {Number} fontsize, e.g., 16
                     * @returns {String}
                     */
                    function getTextWidth(txt, fontname, fontsize) {
                        var e = document.createElement('span');
                        e.style.fontSize = fontsize;
                        e.style.fontFamily = fontname;
                        e.innerHTML = txt;
                        document.body.appendChild(e);
                        var w = e.getBoundingClientRect().width;
                        document.body.removeChild(e);
                        return w;
                    }

                    /**
                     * To get the pixel width of the longest string in the data set
                     *
                     * @param {String} txt
                     * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
                     * @param {Number} fontsize, e.g., 16
                     * @returns {String}
                     */
                    function getLongestTextStringWidth(data, font, size) {

                        font = font || "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif";
                        size = size || 16;

                        var longest = 0;
                        var value;

                        data.forEach(function (obj) {
                            if (obj.value != null && obj.value.toString().length > longest) {
                                longest = obj.value.toString().length;
                                value = obj.value;
                            }
                        });

                        var w = getTextWidth(value, font, size);
                        return w;
                    }

                    module.exports = {
                        convertDashToEnDash: convertDashToEnDash,
                        dashify: dashify,
                        template: template,
                        UID: UID,
                        mask: mask,
                        unmask: unmask,
                        getLongestTextStringWidth: getLongestTextStringWidth
                    };

                    /***/
                },

                /***/48:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var object = __webpack_require__(2);

                    /**
                     * Returns the path for a rounded rectangle.
                     * @param {Number} x X position.
                     * @param {Number} y Y position.
                     * @param {Number} w Width.
                     * @param {Number} h Heigth.
                     * @param {Number} r Radius.
                     * @param {Boolean} tl Top-Left.
                     * @param {Boolean} tr Top-Right.
                     * @param {Boolean} bl Bottom-Left.
                     * @param {Boolean} br Bottom-Right.
                     * @returns {String} Rounded Rectangle path.
                     */
                    var roundedRect = function roundedRect(x, y, w, h, r, tl, tr, bl, br) {
                        var result;
                        result = "M" + (x + r) + "," + y;
                        result += "h" + (w - 2 * r);
                        if (tr) {
                            result += "a" + r + "," + r + " 0 0 1 " + r + "," + r;
                        } else {
                            result += "h" + r;result += "v" + r;
                        }

                        result += "v" + (h - 2 * r);
                        if (br) {
                            result += "a" + r + "," + r + " 0 0 1 " + -r + "," + r;
                        } else {
                            result += "v" + r;result += "h" + -r;
                        }

                        result += "h" + (2 * r - w);
                        if (bl) {
                            result += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r;
                        } else {
                            result += "h" + -r;result += "v" + -r;
                        }

                        result += "v" + (2 * r - h);
                        if (tl) {
                            result += "a" + r + "," + r + " 0 0 1 " + r + "," + -r;
                        } else {
                            result += "v" + -r;result += "h" + r;
                        }

                        result += "z";
                        return result;
                    };

                    /**
                     * Get an SVG Text width by adding it, getting the width and removing it.
                     * @param {D3.Object} svgContainer Container where the text is gonna be attached.
                     * @param {String} text Text to test width.
                     * @return {Number} Calculated width.
                     */
                    var getSVGTextWidth = function getSVGTextWidth(svgContainer, text, className) {
                        var el = svgContainer.append("text").classed(className, true && className).text(text);
                        var width = el.node().getBoundingClientRect().width;
                        el.remove();
                        return width;
                    };

                    /**
                     * Get the longest String in pixels from a given array of data.
                     * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
                     * @param {Array} data Array containig the texts.
                     * @param {String|Function}? accessor description
                     */
                    var getGreaterSVGTextWidth = function getGreaterSVGTextWidth(svgContainer, data, accessor) {
                        var greatest = 0;
                        var text, width;
                        data.forEach(function (item, i) {
                            text = object.extract(item, accessor, i);
                            width = getSVGTextWidth(svgContainer, text);
                            greatest = width > greatest ? width : greatest;
                        });

                        return greatest;
                    };

                    /**
                     * Get the total width of all Strings in pixels from a given array of data.
                     * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
                     * @param {Array} data Array containig the texts.
                     * @param {String|Function}? accessor description
                     */
                    var getTotalSVGTextWidth = function getTotalSVGTextWidth(svgContainer, data, accessor) {
                        var total = 0;
                        var text, width;
                        data.forEach(function (item, i) {
                            var itemStr = " legend-";
                            var itemName = String(item.className["baseVal"]).indexOf("legend-item") !== -1 ? String(item.className["baseVal"]).split(itemStr)[0] : String(item.className["baseVal"]); //for IE spacing
                            text = item[0] ? item[0].classList[0] : itemName;
                            var current = item.classList ? item.classList[0] : text;
                            width = getSVGTextWidth(svgContainer, current) + 15;
                            if (item instanceof SVGElement) {
                                width = item.getBoundingClientRect().width > width ? item.getBoundingClientRect().width : width;
                            }
                            total += width;
                        });
                        return total;
                    };

                    module.exports = {
                        roundedRect: roundedRect,
                        getSVGTextWidth: getSVGTextWidth,
                        getGreaterSVGTextWidth: getGreaterSVGTextWidth,
                        getTotalSVGTextWidth: getTotalSVGTextWidth
                    };

                    /***/
                },

                /***/49:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    /**
                     * morningstar-base-charts
                     *
                     * Copyright © 2016 . All rights reserved.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE.txt file in the root directory of this source tree.
                     */

                    var mds_constants = __webpack_require__(7).constants;
                    var mds_chart_color = mds_constants["chart-color"];

                    module.exports = {
                        colors: [mds_chart_color["1"], mds_chart_color["2"], mds_chart_color["3"], mds_chart_color["4"], mds_chart_color["5"], mds_chart_color["6"], mds_chart_color["7"]],
                        canvasDefaults: {
                            axesSpacing: 5,
                            margin: { top: 20, right: 20, bottom: 20, left: 20 }
                        }
                    };

                    /***/
                },

                /***/50:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    module.exports = function () {
                        // d3 overrides
                        //----------------------------------

                        d3.selection.prototype.first = function () {
                            if (!this[0]) {
                                return d3.select();
                            }

                            return d3.select(this[0][0]);
                        };

                        d3.selection.prototype.last = function () {
                            if (!this[0]) {
                                return d3.select();
                            }

                            var last = this.size() - 1;
                            return d3.select(this[0][last]);
                        };
                        d3.selection.prototype.attrs = function (obj) {
                            for (var attr in obj) {
                                this.attr(attr, obj[attr]);
                            }

                            return this;
                        };

                        //---------------oOo-----------------
                    };

                    /***/
                },

                /***/6:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    // jscs:disable safeContextKeyword

                    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
                        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
                    } : function (obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
                    };

                    var Utils = __webpack_require__(3);

                    /**
                     * Base object. Provides a way to Class inheritance and use of mixins.
                     *
                     * @example {@lang javascript}
                     *  // Simple extension.
                     *
                     *  // Creates a Person class extending from Base.
                     *  var Person = Base.extend({
                     *      name: "John",
                     *      greet: function () { return "Hello, my name is" + this.get("name") + ".";}
                     *  });
                     *  var person = new Person();
                     *  person.greet(); // "Hello, my name is John."
                     *
                     *  // Extending Person
                     *  var Musician = Person.extend({
                     *      name: "Wolfgang",
                     *      instrument: "Violin",
                     *      greet: function () { return this.__super__.greet.call(this) + " I play the " + this.get("instrument"); }
                     *  });
                     *
                     *  var mozart = new Musician();
                     *  mozart.greet()  // Hello, my name is Wolfgang. I play the Violin.
                     *
                     *  mozart.set("instrument", "Piano");
                     *  mozart.greet()  // Hello, my name is Wolfgang. I play the Piano.
                     * @example
                     *  // Extension with mixins
                     *
                     *  // Mixin definition
                     *  function DriverMixin () {}
                     *  DriverMixin.prototype.drive = function() { return this.get("name") + "is driving a" + this.get("vehicle"); };
                     *
                     *  var Driver = Person.extend(DriverMixin, {
                     *      vehicle: "Motorcycle"
                     *  })
                     *
                     *  var juanPabloMontoya = new Driver();
                     *
                     *  juanPabloMontoya.drive(); // "John is driving a motorcycle"  <-- That's incorrect
                     *  juanPabloMontoya.set("name", "Juan Pablo");
                     *  juanPabloMontoya.set("vehicle", "Formula Car");
                     *  juanPabloMontoya.drive(); // "Juan Pablo is driving a Formula Car"  <-- Now That's correct
                     * @param {Object} options Class' instance attributes to be setted. Overrides existing ones or create a new attribute if it does not exist.
                     * @constructor
                     */
                    var Base = function Base() {};

                    Base.prototype = {
                        __attributes: null,
                        __watchers: null,
                        /**
                         * Sets the <i>value</i> under the passed <i>key</i> into the attributes's store.
                         * @param {any} key Name of the attribute to store.
                         * @param {any} value Attribute's value.
                         * @returns {Base} object's instance to allow chainability.
                         */
                        set: function set(key, value) {
                            this.__attributes[key] = value;
                            this._checkWatcher(key, value);
                            return this;
                        },

                        /**
                         * Search the attribute's store and returns its value.
                         * @param {any} key Attribute's key to retrieve.
                         * @returns {Object} Attribute's value.
                         */
                        get: function get(key) {
                            return this.__attributes[key];
                        },

                        /**
                         * Initialize object attributes.
                         */
                        _initAttrs: function _initAttrs(options) {
                            for (var key in options) {
                                this.set(key, options[key]);
                            }
                        },

                        /**
                         * Set an attribute bound watcher.
                         * @param {String} attribute Attribute's name.
                         * @param {Function} handler Method to execute when the attribute changes.
                         */
                        watch: function watch(attribute, handler) {
                            var watcher = this.__watchers[attribute];
                            var handlers, length, value;

                            if (watcher) {
                                handlers = watcher.handlers;
                                length = handlers.filter(function (fn) {
                                    return "" + fn === "" + handler;
                                }).length;
                                if (!length) {
                                    handlers.push(handler);
                                }
                            } else {
                                value = this.__attributes ? this.__attributes[attribute] : undefined;
                                this.__watchers[attribute] = {
                                    oldValue: value,
                                    handlers: [handler]
                                };
                            }
                        },

                        /**
                         * Remove all handlers attached to an attribute key or just the one that contains the specified handler if it is passed as paramter
                         * @param {String} attribute Attribute's name.
                         * @param {Function} handler Optional. If not passed removes all handlers attached to the attribute.
                         */
                        unwatch: function unwatch(attribute, handler) {
                            var watcher = this.__watchers[attribute];
                            var handlers;

                            if (watcher) {
                                if (!handler) {
                                    delete this.__watchers[attribute];
                                } else {
                                    handlers = watcher.handlers;
                                    handlers.splice(handlers.indexOf(handler), 1);
                                }
                            }
                        },

                        /**
                         * Removes all attributes watchers.
                         */
                        unwatchAll: function unwatchAll() {
                            this.__watchers = {};
                        },

                        /**
                         * Checks if the attribute have been modified and execute the handler function.
                         * @param {String} attribute Attribute's name.
                         * @param {Object} newValue New attribute's value.
                         */
                        _checkWatcher: function _checkWatcher(attribute, newValue) {
                            var watcher = this.__watchers[attribute];

                            if (watcher && newValue !== watcher.oldValue) {
                                watcher.handlers.forEach(function (handler) {
                                    handler(newValue, watcher.oldValue);
                                    watcher.oldValue = newValue;
                                });
                            }
                        }

                    };

                    /**
                     * Method that returns a new class extending the class that calls it. If mixins are
                     * passed its methods are extended to the resultant class too.
                     * @static
                     * @returns {Class}
                     */
                    Base.extend = function () {
                        var properties = {};
                        var mixins = [];
                        var i = 0;
                        var arg = arguments[i++];
                        var parent = this;
                        var parentDefaults = parent.prototype.__defaults__ || {};
                        var defaults = {};
                        var child, key, value;

                        Utils.object.copy(defaults, parentDefaults);

                        while ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) !== "object") {
                            mixins.push(arg);
                            arg = arguments[i++];
                        }

                        properties = arg;

                        child = function child(options) {
                            parent.apply(this, arguments);

                            this.__attributes = this.__attributes || {
                                _id: new Date().getTime()
                            };
                            this.__watchers = {};
                            for (key in this.__defaults__) {
                                if (!this.__attributes[key]) {
                                    this.__attributes[key] = this.__defaults__[key];
                                }
                            }

                            // Apply options
                            if (options) {
                                this._initAttrs(options);
                            }

                            if (properties.initializer && typeof properties.initializer === "function") {
                                properties.initializer.call(this);
                            }

                            mixins.forEach(function (mixin) {
                                if (mixin.prototype.initializer) {
                                    mixin.prototype.initializer.call(this);
                                }
                            }.bind(this));
                        };

                        // Copying statics from old class to new one.
                        for (key in parent) {
                            if (parent.hasOwnProperty(key)) {
                                child[key] = parent[key];
                            }
                        }

                        child.prototype = Object.create(parent.prototype);

                        for (key in parent.prototype) {
                            value = parent.prototype[key];
                            if (typeof value !== "function") {
                                if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                                    defaults[key] = value;
                                }
                            }
                        }

                        // Adding/overwriting new properties into child prototype.
                        if (properties) {
                            for (key in properties) {
                                if (properties.hasOwnProperty(key)) {
                                    value = properties[key];
                                    if (typeof value === "function") {
                                        child.prototype[key] = value;
                                    } else if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                                        defaults[key] = value;
                                    }
                                }
                            }
                        }

                        mixins.forEach(function (mixin) {
                            Utils.object.copy(child.prototype, mixin.prototype);
                        });

                        child.prototype.__defaults__ = Utils.object.clone(defaults);

                        child.prototype.__super__ = parent.prototype;
                        return child;
                    };

                    module.exports = Base;

                    /***/
                },

                /***/7:
                /***/function _(module, exports) {

                    module.exports = { "constants": { "color": { "white": "#ffffff", "black": "#000000", "neutral": { "12": "#1e1e1e", "20": "#333333", "37": "#5e5e5e", "50": "#808080", "67": "#ababab", "80": "#cccccc", "90": "#e5e5e5", "95": "#f2f2f2" }, "blue": { "23": "#004376", "32": "#005ba1", "36": "#006fba", "38": "#1f55a5", "41": "#0077cf", "44": "#008dde" }, "green": { "34": "#00af41" }, "dark-green": { "34": "#518428" }, "teal": { "19": "#005f5f" }, "violet": { "46": "#6a4c9e" }, "cyan": { "44": "#00a8e1" }, "maroon": { "32": "#a50032" }, "red": { "50": "#ff0000" }, "yellow": { "48": "#f5c400" }, "orange": { "54": "#ef7622" }, "light-red": { "46": "#e60546" }, "dark-violet": { "32": "#7d256f" }, "dark-yellow": { "47": "#c19c31" }, "aqua": { "37": "#00beaf" }, "bright-orange": { "50": "#ff3c00" }, "light-green": { "50": "#89bd40" } }, "brand": { "blue": "#1f55a5", "cyan": "#00a8e1" }, "background-color": { "default": "#ffffff", "light": "#f2f2f2", "dark": "#1e1e1e", "black": "#000000", "alternative-row": { "default": "#e5e5e5", "on-light": "#e5e5e5", "on-dark": "#333333" }, "feedback": { "error": "#ff0000", "warning": "#f5c400" } }, "text-color": { "primary": { "default": "#1e1e1e", "on-light": "#1e1e1e", "on-dark": "#ffffff" }, "secondary": { "default": "#5e5e5e", "on-light": "#5e5e5e", "on-dark": "#ababab" }, "link": { "default": "#006fba", "on-light": "#006fba", "on-dark": "#008dde" }, "error": { "default": "#ff0000", "on-light": "#ff0000", "on-dark": "#ff0000" } }, "interactive-color": { "primary": { "default": "#0077cf", "hover": "#005ba1", "focus": "#005ba1", "active": "#004376" }, "secondary": { "primary": "transparent", "hover": "#5e5e5e", "focus": "#5e5e5e", "active": { "on-light": "#333333", "on-dark": "#e5e5e5" } }, "disabled": { "on-light": "#808080", "on-dark": "#ababab" } }, "visualization-color": { "asset-allocation": { "local-stocks": "#1f55a5", "non-local-stocks": "#8faad2", "stocks": "#1f55a5", "real-estate": "#a50032", "other": "#f5c400", "cash": "#518428", "bonds": "#ef7622", "not-classified": "#e5e5e5" }, "correlation": { "positive": "#1f55a5", "negative": "#ef7622" }, "sector": { "cyclical": "#ef7622", "sensitive": "#1f55a5", "defensive": "#518428" }, "sustainability": "#1f55a5", "valuation": { "under": "#00a8e1", "fair": "#e5efef", "over": "#ef7622" }, "performance": { "positive": "#00af41", "neutral-text": "#5e5e5e", "neutral-chart": "#cccccc", "negative": "#ff0000" } }, "chart-color": { "1": "#1f55a5", "2": "#a50032", "3": "#f5c400", "4": "#518428", "5": "#00a8e1", "6": "#6a4c9e", "7": "#ef7622", "8": "#005f5f", "9": "#00af41", "10": "#e60546", "11": "#7d256f", "12": "#c19c31", "13": "#00beaf", "14": "#ff3c00", "15": "#89bd40" }, "feedback-color": { "info": "#f2f2f2", "error": "#ff0000", "error-background": "#ffe5e5", "warning": "#f5c400", "warning-background": "#fef9e5", "success": "#00af41", "success-background": "#e5f7eb" }, "font": { "family": { "sans-serif": "'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif", "monospace": "'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace" }, "weight": { "thin": 200, "light": 300, "regular": 400, "bold": 600 }, "size": { "xs": "10px", "s": "14px", "m": "16px", "l": "20px", "base": "16px", "default": "16px", "heading-level-1": "45px", "heading-level-2": "32px", "heading-level-3": "28px", "heading-level-4": "23px", "heading-level-5": "20px", "heading-level-6": "18px", "code": "12px" }, "line-height": { "headings": 1.2, "body": 1.375 } }, "border": { "separator": { "default": "solid 1px #e5e5e5", "on-light": "solid 1px #cccccc", "on-dark": "solid 1px #333333", "on-title": "solid 2px #333333", "color-on-light": "#cccccc", "color-on-dark": "#333333" }, "control": { "default": "solid 1px #808080", "color": "#808080" }, "container": { "default": "solid 1px #e5e5e5", "color-default": "#e5e5e5" }, "disabled": "solid 1px #808080", "radius": { "panel": "12px", "pill": "24px", "round": "50%", "s": "2px" } }, "size": { "icon": { "s": "15px", "m": "23px" } }, "space": { "xs": "4px", "s": "6px", "m": "8px", "l": "12px", "xl": "16px", "quarter-x": "2px", "half-x": "4px", "three-quarter-x": "6px", "1-x": "8px", "1-and-a-half-x": "12px", "2-x": "16px", "3-x": "24px", "4-x": "32px", "8-x": "64px", "inset": { "xs": "4px", "s": "6px", "m": "8px", "l": "12px", "xl": "16px", "quarter-x": "2px", "half-x": "4px", "three-quarter-x": "6px", "1-x": "8px", "1-and-a-half-x": "12px", "2-x": "16px", "3-x": "24px", "4-x": "32px", "8-x": "64px", "stretch": { "s": "6px 12px", "m": "8px 16px", "l": "12px 24px" } }, "inline-left": { "xs": "0 4px 0 0", "s": "0 6px 0 0", "m": "0 8px 0 0", "l": "0 12px 0 0", "xl": "0 16px 0 0", "half-x": "0 4px 0 0", "three-quarter-x": "0 6px 0 0", "1-x": "0 8px 0 0", "1-and-a-half-x": "0 12px 0 0", "2-x": "0 16px 0 0" }, "inline-right": { "xs": "0 0 0 4px", "s": "0 0 0 6px", "m": "0 0 0 8px", "l": "0 0 0 12px", "xl": "0 0 0 16px", "half-x": "0 0 0 4px", "three-quarter-x": "0 0 0 6px", "1-x": "0 0 0 8px", "1-and-a-half-x": "0 0 0 12px", "2-x": "0 0 0 16px" }, "stack": { "s": "0 0 6px", "m": "0 0 8px", "l": "0 0 12px", "xl": "0 0 16px", "quarter-x": "0 0 2px", "half-x": "0 0 4px", "three-quarter-x": "0 0 6px", "1-x": "0 0 8px", "1-and-a-half-x": "0 0 12px", "2-x": "0 0 16px", "3-x": "0 0 24px", "4-x": "0 0 32px", "8-x": "0 0 64px" } }, "transition": { "color": { "link": "color, 300ms" } }, "opacity": { "disabled": ".4", "overlay": ".5" }, "box-shadow": { "drop": "0 2px 4px 0 rgba(0, 0, 0, .08)", "focus": "0 0 4px 2px rgba(#0077cf, .8)" }, "z-index": { "low": 1, "sticky": 100, "modal-overlay": 800, "modal-content": 810, "top-of-the-world": 900 }, "breakpoint": { "navigation": { "on-canvas-nav": "768px", "wide": "1024px" } }, "masthead": { "height": "50px", "height-tall": "70px" }, "site-navigation": { "height": "50px", "vertical-width": "230px" } }, "shared": [{ "utils": true }, { "color": true }, { "fonts": true }, { "accessibility": true }, { "animation": true }, { "size": true }, { "bubbles": true }, { "typography": true }], "components": [{ "link": true }, { "icon": true }, { "button": true }, { "button_group": true }, { "card": true }, { "navigation_container": true }, { "container": true }, { "data_table": true }, { "dialog": true }, { "form": true }, { "combo_box": true }, { "list_group": true }, { "loader": true }, { "modal": true }, { "menu": true }, { "notification": true }, { "pagination": true }, { "page_shell": true }, { "popover": true }, { "range_slider": true }, { "search_field": true }, { "stepper": true }, { "switch": true }, { "tag": true }, { "tooltip": true }, { "masthead": true }, { "site_navigation": true }, { "alert": true }, { "top_hat": true }, { "layout_grid": true }], "theme": "mds"

                        /***/ };
                },

                /***/8:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var BASE = "mbc";
                    var CHART = BASE + "-chart";

                    module.exports = {
                        AXES: BASE + "-axes",
                        AXIS: BASE + "-axis",
                        BACK: BASE + "-back-group",
                        CANVAS: BASE + "-canvas",
                        CHART_GROUP: CHART + "-group",
                        CHART: CHART,
                        CHARTS_AREA: CHART + "s-area",
                        CONTAINER: CHART + "-container",
                        DECK: CHART + "-deck",
                        FOCUS: CHART + "-focus",
                        FRONT: BASE + "-front-group",
                        GRID: BASE + "-grid",
                        GRID_LINE: BASE + "-grid-line",
                        INNER: CHART + "-inner",
                        LAYERS: BASE + "-layers",
                        LEGEND_ITEM: CHART + "-legend-item",
                        LEGEND: CHART + "-legend",
                        TITLE: CHART + "-title",
                        TOOLTIP: CHART + "-tooltip",
                        TOOLTIP_CONTAINER: CHART + "-tooltip-container",
                        ZONES: CHART + "-zones",
                        ZONE: CHART + "-zone"
                    };

                    /***/
                },

                /***/9:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    /**
                     * Creates an AxesManager instance. AxesManagers centralize chart's axes
                     * in order to access them transversely.<br>
                     * @example
                     * var axesManager = new AxesManager({"x", d3.svg.axis()})
                     * @constructor
                     * @param {object} axes <i>Optional</i>. A hashmap with chart's axes.
                     */

                    function AxesManager(axes) {
                        this._axes = axes || {};
                    }
                    /**
                     * Sets or returns an axis. If no axis object is passsed then sets the axis.
                     * @param  {String} axisName
                     * @param  {D3.axis} axis
                     *
                     * @return {D3.axis}
                     */
                    AxesManager.prototype.axis = function (axisName, axis) {
                        if (!axisName) {
                            return;
                        }

                        if (!axis) {
                            return this._axes[axisName];
                        }

                        this._axes[axisName] = axis;
                        return axis;
                    };

                    /**
                     * Remove an axis from the collection.
                     * @param {String} axisName Axis to remove.
                     */
                    AxesManager.prototype.remove = function (axisName) {
                        delete this._axes[axisName];
                    };

                    /**
                     * Return the axes store object.
                     *
                     * @returns {Object} Hashmap that containing the axes.
                     */
                    AxesManager.prototype.axes = function () {
                        return this._axes;
                    };

                    module.exports = AxesManager;

                    /***/
                },

                /***/98:
                /***/function _(module, exports) {

                    // removed by extract-text-webpack-plugin

                    /***/}

                /******/ })
        );
    });

    /***/
},
/* 1 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    /* jshint browser: true */
    /* globals d3 */
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(8), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, TimeSeriesLineChart, MBCCore) {
        'use strict';

        return {
            getFrequencySeriesData: getFrequencySeriesData,
            getDateRangeSeriesData: getDateRangeSeriesData,
            getLineChartData: getLineChartData,
            initializeLineChart: initializeLineChart,
            drawLineChart: drawLineChart,
            resize: resize
        };

        //Data Service
        //external function
        function getFrequencySeriesData(graphBaseValue, seriesData, monthCount) {
            var earliestCommonSeriesData = getEarliestCommonSeriesData(seriesData);
            var frequencyData = [];
            var handleSeriesData = function handleSeriesData(item) {
                var data = spliceSeriesData(graphBaseValue, item.data, monthCount),
                    newFrequencyData = {
                    name: item.name,
                    data: rebasedSeriesData(graphBaseValue, data)
                },
                    useLabel = item.useLabel;

                if (!morningstar.asterix.util.isUndefinedOrNull(useLabel)) {
                    newFrequencyData.useLabel = useLabel;
                }

                frequencyData.push(newFrequencyData);
            };

            _.each(earliestCommonSeriesData, handleSeriesData);

            return frequencyData;
        }

        function getDateRangeSeriesData(graphBaseValue, seriesData, startDate, endDate) {
            var earliestCommonSeriesData = getEarliestCommonSeriesData(seriesData);

            var dateRangeData = [];

            var handleSeriesData = function handleSeriesData(item) {
                var data = sliceSeriesData(graphBaseValue, item.data, startDate, endDate),
                    newDateRangeData = {
                    name: item.name,
                    data: rebasedSeriesData(graphBaseValue, data)
                },
                    useLabel = item.useLabel;

                if (!morningstar.asterix.util.isUndefinedOrNull(useLabel)) {
                    newDateRangeData.useLabel = useLabel;
                }

                dateRangeData.push(newDateRangeData);
            };

            _.each(earliestCommonSeriesData, handleSeriesData);

            return dateRangeData;
        }

        function getLineChartData(seriesData, labels) {
            var lineChartData = [];
            _.each(seriesData, function (item) {
                var obj = [],
                    useLabel = morningstar.asterix.util.isUndefinedOrNull(item.useLabel) || item.useLabel,
                    name = useLabel ? labels.get(item.name) : item.name;
                _.each(item.data, function (data) {
                    obj.push({
                        name: name,
                        value: data.close,
                        date: morningstar.asterix.util.date.utcToStandard(new Date(data.date)),
                        groupName: 'y1'
                    });
                });
                lineChartData.push(obj);
            });
            return lineChartData;
        }

        //internal function
        function addGraphBaseValueAsFirstDataToSeriesData(graphBaseValue, date, seriesData) {
            var firstData = {};
            firstData.endDate = translateDateToUTCLocalISOString(date);
            firstData.value = graphBaseValue;

            seriesData.unshift(firstData);

            return seriesData;
        }

        function getEarliestCommonSeriesData(seriesData) {
            if (seriesData.length === 0) {
                return seriesData;
            } else {
                var earliestCommonSeriesData = [];
                var count = _.min(seriesData, function (item) {
                    return item.data.length;
                }).data.length;
                morningstar.asterix.util.each(seriesData, function (item) {
                    var newEarliestCommonSeriesData = {
                        name: item.name,
                        data: item.data.slice(item.data.length - count)
                    },
                        useLabel = item.useLabel;

                    if (!morningstar.asterix.util.isUndefinedOrNull(useLabel)) {
                        newEarliestCommonSeriesData.useLabel = useLabel;
                    }

                    earliestCommonSeriesData.push(newEarliestCommonSeriesData);
                });
                return earliestCommonSeriesData;
            }
        }

        function translateDateToUTCLocalISOString(date) {
            var newDate = morningstar.asterix.util.date.convertToStandard(new Date(date));
            newDate = morningstar.asterix.util.date.addMonths(newDate, -1);
            return morningstar.asterix.util.date.toUTCLocalISOString(newDate);
        }

        function spliceSeriesData(graphBaseValue, seriesData, monthCount) {
            var newSeriesData = [];

            if (seriesData && seriesData.length > 0) {
                newSeriesData = _.extend([], seriesData);
                var spliceIndex = newSeriesData.length - monthCount - 1;
                if (spliceIndex < 0) {
                    newSeriesData = addGraphBaseValueAsFirstDataToSeriesData(graphBaseValue, _.first(newSeriesData).endDate, newSeriesData);
                } else {
                    newSeriesData = newSeriesData.splice(spliceIndex);
                }
            }

            return newSeriesData;
        }

        function sliceSeriesData(graphBaseValue, seriesData, startDate, endDate) {
            var newSeriesData = [];

            if (seriesData && seriesData.length > 0) {
                newSeriesData = _.extend([], seriesData);
                var lastDate = morningstar.asterix.util.date.convertToStandard(new Date(_.last(newSeriesData).endDate));

                var monthCount = 0;
                if (endDate < lastDate) {
                    newSeriesData = newSeriesData.slice(0, newSeriesData.length - morningstar.asterix.util.date.monthDiff(endDate, lastDate));
                }
                monthCount = morningstar.asterix.util.date.monthDiff(startDate, endDate);
                newSeriesData = spliceSeriesData(graphBaseValue, newSeriesData, monthCount);
            }

            return newSeriesData;
        }

        function rebasedSeriesData(graphBaseValue, seriesData) {
            var currentValue = null,
                rebasedData = [];

            _.each(seriesData, function (data, index) {
                var newData = {};

                if (index === 0) {
                    newData.close = graphBaseValue;
                    currentValue = graphBaseValue;
                } else {
                    currentValue = currentValue * (1 + data.value / 100.0);
                    newData.close = currentValue;
                }
                newData.date = data.endDate;
                if (!morningstar.asterix.util.isUndefinedOrNull(data.value)) {
                    rebasedData.push(newData);
                }
            });

            return rebasedData;
        }

        //Line chart service
        function initializeLineChart(scope) {
            var lineChartSettings = scope.settings.get('lineChartSettings');
            var customSettings = {
                y1Abbreviation: lineChartSettings.showsCurrency ? scope.settings.get('currencyId') : null,
                tooltipTimeFormat: function tooltipTimeFormat(date) {
                    return scope.format.date(date, lineChartSettings.tooltipTimeFormatAlias);
                },
                legendValuesFormat: function legendValuesFormat(value) {
                    var newValue = value;
                    if (scope.settings.get('chartType') === 'growth') {
                        var graphBaseValue = scope.settings.get('graphBaseValue');
                        newValue = (newValue - graphBaseValue) / graphBaseValue * 100.0;
                    }
                    return scope.format.number(newValue, lineChartSettings.legendValuesFormatAlias);
                },
                xTickFormat: function xTickFormat(date) {
                    return scope.format.date(date, lineChartSettings.xTickFormatAlias);
                },
                y1TickFormat: function y1TickFormat(value) {
                    return scope.format.number(value, lineChartSettings.y1TickFormatAlias);
                },
                colors: scope.instance.getDefaultColorPalette()
            };

            var TimeSeriesLineChartExtended = TimeSeriesLineChart.extend({
                id: 'mbc-time-series-line-chart',
                setCanvasTemplate: function setCanvasTemplate(width) {
                    var template;
                    if (this.get('legend')) {
                        if (width > this.get('breakpoint') && this.get('legendPosition') === 'right') {
                            template = '<div class="' + MBCCore.Classes.INNER + ' ' + MBCCore.Classes.INNER + '-right"></div>\n                            <div class="' + MBCCore.Classes.LEGEND + ' ' + MBCCore.Classes.LEGEND + '-right"><div class="' + MBCCore.Classes.LEGEND + '-inner"></div></div>';
                        } else {
                            template = '<div class="' + MBCCore.Classes.LEGEND + ' ' + MBCCore.Classes.LEGEND + '-top"><div class="' + MBCCore.Classes.LEGEND + '-inner"></div></div>\n                        <div class="' + MBCCore.Classes.INNER + ' ' + MBCCore.Classes.INNER + '-top"></div>';
                        }
                    }
                    this.set('canvasTemplate', template);
                }
            });

            var chart = new TimeSeriesLineChartExtended(morningstar.asterix.extend(true, {}, customSettings, lineChartSettings));
            chart.isDatumInited = false;
            return chart;
        }

        function drawLineChart(scope, chart, timelineLevel, lineChartData) {
            chart.set('timelineLevel', timelineLevel);
            var index = 0;
            _.each(lineChartData, function (data) {
                if (data && data.length > 0) {
                    if (index === 0) {
                        if (!chart.isDatumInited) {
                            chart.isDatumInited = true;
                            chart.get('data').clean();
                            d3.select('#' + scope.namespaceId('line-chart')).datum({ y1: data }).call(chart.init());
                        } else {
                            chart.data({ y1: data });
                        }
                    } else {
                        chart.add(data[0].name, data, data[0].groupName);
                    }
                    index++;
                }
            });

            if (chart.get('showDottedLines') || chart.get('dottedLineIndexes').length > 0) {
                setDottedLines(chart);
            }
        }

        function resize(chart) {
            if (chart.isDatumInited) {
                var chartTooltipClass = 'mbc-time-series-line-chart-tooltip';
                var chartTooltip = document.getElementsByClassName(chartTooltipClass);
                if (chartTooltip.length > 0) {
                    angular.element(chartTooltip[0]).remove();
                }
                chart.update();
            }
        }

        function setDottedLines(chart) {
            var y1DomainDataset = chart.get('y1DomainDataset');
            var dataManager = chart.get('data');
            var linesData = dataManager.get(y1DomainDataset);
            var dottedLineIndexes = chart.get('dottedLineIndexes'); // set dotted line index, such as [1], priority higher than showDottedLines
            var linesName = [];
            _.each(linesData, function (data) {
                if (dottedLineIndexes.length > 0) {
                    if (dottedLineIndexes.indexOf(data.index) > -1) {
                        linesName.push(data.name);
                    }
                } else {
                    if (linesName.indexOf(data.name) === -1) {
                        linesName.push(data.name);
                    }
                }
            });
            chart.set('dottedLines', linesName);
            chart.update();
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 3 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(1), __webpack_require__(3), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
        'use strict';

        performanceGraph.$inject = ["mstarDimensions"];
        angular.module('ecPerformanceGraph', ['ecContainer', 'ecTabs', 'ecTable', 'ecInput', 'mstarCore']).directive('ecPerformanceGraph', performanceGraph);

        function performanceGraph(mstarDimensions) {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {},
                template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
                link: linkFn
            };

            function linkFn(scope, elem, attr, mstarComponent) {
                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // compiles the main template
                mstarComponent.compileTemplate(scope, '_templates.main');

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
                mstarComponent.bindModelData(scope);
                // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

                var selectedTabIndex = 0;
                var timelineLevelDefinitions = scope.settings.get('timelineLevelDefinitions');
                var chart = helper.initializeLineChart(scope);
                var sectionClass = '.ec-section__content--' + morningstar.asterix.util.string.dashCase(mstarComponent.getOwnComponentId());
                var mstarDimensionsElem = mstarDimensions(scope, elem);
                var tabInstance = scope.instance.findRelative('tabFrequency');
                var isValidSvgElem;

                scope.setActiveTab = function (index, tab) {
                    selectedTabIndex = index;
                    if (chart.isDatumInited && scope.settings.get('chartType') !== 'price') {
                        drawGraphByFrequency(scope.model.performanceChart, selectedTabIndex);
                    }
                    tabInstance.setParameter('selectedTabIndex', index);
                    if (scope.settings.get('enableCustomDate')) {
                        var monthCount = scope.parameters.displayFrequency[index].value;
                        scope.parameters.endDate = new Date();
                        scope.parameters.startDate = morningstar.asterix.util.date.addMonths(new Date(), -monthCount);
                        scope.parameters.dataType = scope.parameters.displayFrequency[index].dataType;
                    }
                };
                mstarDimensionsElem.addListener(function (value) {
                    mstarDimensions(scope, elem.find(sectionClass)).addListener(function (value) {
                        // height=0 means the child elements are removed.
                        if (value.height === 0) {
                            chart.isDatumInited = false;
                        } else {
                            if (!chart.isDatumInited) {
                                drawGraph(scope.model.performanceChart);
                            } else if (isValidSvgElem) {
                                helper.resize(chart);
                            }
                        }
                    });
                    mstarDimensionsElem.destroy();
                });

                mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:performanceChart', function (performanceChart) {
                    if (performanceChart) {
                        drawGraph(performanceChart);
                    }
                }));

                mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:startDate', function (startDate) {
                    drawGraphByDateRange(scope.model.performanceChart, startDate, scope.parameters.endDate);
                }));

                mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:endDate', function (endDate) {
                    drawGraphByDateRange(scope.model.performanceChart, scope.parameters.startDate, endDate);
                }));

                function drawGraph(performanceChart) {
                    if (morningstar.asterix.util.isDate(scope.parameters.startDate) && morningstar.asterix.util.isDate(scope.parameters.endDate)) {
                        drawGraphByDateRange(performanceChart, scope.parameters.startDate, scope.parameters.endDate);
                    } else if (morningstar.asterix.util.isArray(scope.parameters.displayFrequency)) {
                        drawGraphByFrequency(performanceChart, selectedTabIndex);
                    }
                }

                function drawGraphByFrequency(performanceChart, index) {
                    if (scope.settings.get('chartType') === 'price') {
                        drawPriceLineChart(performanceChart);
                    } else {
                        var monthCount = scope.parameters.displayFrequency[index].value;
                        if (monthCount > 0) {
                            var seriesData = validateSeriesData(morningstar.asterix.util.parse('monthly.series')(performanceChart));
                            if (seriesData.length > 0) {
                                var frequencySeriesData = helper.getFrequencySeriesData(scope.settings.get('graphBaseValue'), seriesData, monthCount);
                                drawLineChart(frequencySeriesData);
                            } else {
                                emptyChartElement();
                            }
                            updateTabStatus(seriesData.length > 0);
                        }
                    }
                }

                function drawGraphByDateRange(performanceChart, startDate, endDate) {
                    if (morningstar.asterix.util.isDate(scope.parameters.startDate) && morningstar.asterix.util.isDate(endDate) && startDate < endDate) {
                        if (scope.settings.get('chartType') === 'price') {
                            drawPriceLineChart(performanceChart);
                        } else {
                            var seriesData = validateSeriesData(morningstar.asterix.util.parse('monthly.series')(performanceChart));
                            if (seriesData.length > 0) {
                                var dateRangeSeriesData = helper.getDateRangeSeriesData(scope.settings.get('graphBaseValue'), seriesData, startDate, endDate);
                                drawLineChart(dateRangeSeriesData);
                            } else {
                                emptyChartElement();
                            }
                        }
                    }
                }

                function drawPriceLineChart(performanceChart) {
                    var seriesData = validateSeriesData(morningstar.asterix.util.parse('series')(performanceChart));
                    if (seriesData.length > 0) {
                        drawLineChart(seriesData);
                    } else {
                        emptyChartElement();
                    }
                }

                function drawLineChart(seriesData) {
                    if (isValidElem()) {
                        var maxDataLength = 0;
                        if (seriesData.length > 0 && scope.settings.get('chartType') === 'price') {
                            _.each(seriesData, function (item) {
                                var firstDate = item.data[0].date;
                                firstDate = morningstar.asterix.util.isDate(firstDate) ? firstDate : new Date(firstDate);
                                var lastDate = item.data[item.data.length - 1].date;
                                lastDate = morningstar.asterix.util.isDate(lastDate) ? lastDate : new Date(lastDate);
                                var dayNum = (lastDate - firstDate) / 1000 / 60 / 60 / 24;
                                if (dayNum > maxDataLength) {
                                    maxDataLength = dayNum;
                                }
                            });
                        } else {
                            maxDataLength = seriesData.length > 0 ? seriesData[0].data.length : 0;
                        }

                        var timelineLevel = getTimelineLevel(maxDataLength);
                        var lineChartData = helper.getLineChartData(seriesData, scope.labels);
                        helper.drawLineChart(scope, chart, timelineLevel, lineChartData);
                        isValidSvgElem = true;
                    }
                }

                function getTimelineLevel(value) {
                    var timelineLevel = null;
                    var definitions = morningstar.asterix.util.cloneObject(timelineLevelDefinitions);
                    if (definitions[scope.parameters.dataType]) {
                        definitions = definitions[scope.parameters.dataType];
                    }
                    _.each(definitions, function (data, key) {
                        if (value >= data[0] && value <= data[1]) {
                            timelineLevel = key;
                            return;
                        }
                    });
                    return timelineLevel;
                }

                function isValidElem() {
                    var chartElem = elem.find('#' + scope.namespaceId('line-chart'));
                    return chartElem.length > 0 && chartElem[0].offsetWidth > 0 && chartElem[0].offsetHeight > 0;
                }

                function updateTabStatus(status) {
                    if (status) {
                        if (tabInstance.getParameter('selectedTabIndex') !== selectedTabIndex) {
                            tabInstance.setParameter('selectedTabIndex', selectedTabIndex);
                        }
                    } else {
                        if (tabInstance.isActive) {
                            tabInstance.setParameter('resetTabStatus', true);
                            tabInstance.setParameter('selectedTabIndex', -1);
                        }
                    }
                }

                function validateSeriesData(seriesData) {
                    var newSeriesData = [];
                    _.each(seriesData, function (item) {
                        if (item.data.length > 0) {
                            newSeriesData.push(item);
                        }
                    });
                    return newSeriesData;
                }

                function emptyChartElement() {
                    var chartElem = elem.find('#' + scope.namespaceId('line-chart'));
                    if (chartElem.length > 0) {
                        isValidSvgElem = false;
                        chartElem.html('<div class="' + scope.namespaceClass('__data-unavailable') + '">' + scope.labels.get('dataUnavailable') + '</div>');
                    }
                }
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 5 */
/***/function (module, exports) {

    module.exports = {
        "ecPerformanceGraph": {
            "blueprints": {
                "withTrailingPerformanceTable": {
                    "components": {
                        "annualPerformanceTable": {
                            "components": {
                                "paginatorSticky": {
                                    "settings": {
                                        "dynamicPrevNext": false
                                    },
                                    "type": "ecPaginator"
                                }
                            },
                            "settings": {
                                "fields": ["name", "portfolio", "benchmark"],
                                "orientation": "horizontal",
                                "perPage": 6
                            },
                            "type": "ecTable"
                        },
                        "graphContainer": {
                            "settings": {
                                "breakpoints": {
                                    "defaults": {
                                        "groups": {
                                            "main": {
                                                "cols": 12,
                                                "sections": ["frequency", "graph", "annualPerformanceTable"]
                                            }
                                        }
                                    }
                                }
                            },
                            "type": "ecContainer"
                        }
                    },
                    "lables": {
                        "annualPerformancePercentage": {
                            "en": "Performance (%)"
                        }
                    }
                }
            },
            "components": {
                "annualPerformanceTable": {
                    "components": {
                        "paginator": {
                            "type": "ecPaginator"
                        },
                        "paginatorSticky": {
                            "type": "ecPaginator"
                        },
                        "paginatorTop": {
                            "type": "ecPaginator"
                        },
                        "sortFieldsDropdown": {
                            "type": "ecChosen"
                        },
                        "sortOrderRadio": {
                            "type": "ecChosen"
                        }
                    },
                    "settings": {
                        "_model": {
                            "footNotes": {
                                "dataSourceType": "selector",
                                "selector": "{{_ model(_).performanceChart.footNotes  _}}"
                            },
                            "rows": {
                                "dataSourceType": "selector",
                                "selector": "{{_ model(_).performanceChart.annual  _}}"
                            }
                        },
                        "caption": "annualPerformancePercentage",
                        "fieldDefinitions": {
                            "benchmark": {
                                "fieldName": "benchmark",
                                "format": "shortDecimal",
                                "headerLabelKey": "benchmark"
                            },
                            "periodInterval": {
                                "fieldName": "endDate",
                                "fieldSettings": {
                                    "itemTemplate": "<div class=\"ec__cell-content\")}}\"><div class=\"ec-table__cell-date  ec-table__cell-date--start\")}}\">{{ field.format( obj.startDate ) }}</div><div class=\"ec-table__cell-date ec-table__cell-date--end \">- {{ field.format(field.getter(obj))}}</div></div>"
                                },
                                "format": "yy-mmm-dd"
                            },
                            "portfolio": {
                                "fieldName": "portfolio",
                                "format": "shortDecimal",
                                "headerLabelKey": "portfolio"
                            }
                        },
                        "orientation": "horizontal"
                    },
                    "type": "ecTable"
                },
                "endDate": {
                    "labels": {
                        "ariaText": {
                            "en": "End date",
                            "fr": "Date de fin",
                            "it": "Data finale",
                            "sv": "Slutdatum"
                        },
                        "placeholder": {
                            "en": "YYYY-MM-DD",
                            "it": "GG-MM-AAAA",
                            "sv": "YYYY-MM-DD"
                        }
                    },
                    "settings": {
                        "inputType": "date"
                    },
                    "type": "ecInput"
                },
                "graphContainer": {
                    "settings": {
                        "breakpoints": {
                            "defaults": {
                                "groups": {
                                    "main": {
                                        "cols": 12,
                                        "defaultSection": {
                                            "cols": 12
                                        },
                                        "sections": ["frequency", "graph"]
                                    }
                                }
                            }
                        }
                    },
                    "type": "ecContainer"
                },
                "startDate": {
                    "labels": {
                        "ariaText": {
                            "en": "Start date",
                            "fr": "Date de début",
                            "it": "Data iniziale",
                            "sv": "Startdatum"
                        },
                        "placeholder": {
                            "en": "YYYY-MM-DD",
                            "it": "GG-MM-AAAA",
                            "sv": "YYYY-MM-DD"
                        }
                    },
                    "settings": {
                        "inputType": "date"
                    },
                    "type": "ecInput"
                },
                "tabFrequency": {
                    "settings": {
                        "selectedTabIndex": 0
                    },
                    "type": "ecTabs"
                }
            },
            "labels": {
                "annualPerformancePercentage": {
                    "en": "Annual performance (%)",
                    "en-GB": null,
                    "it": "Performance annuale (%)",
                    "sv": "Årlig avkastning (%)",
                    "sv-SE": null
                },
                "dataUnavailable": {
                    "en": "Data Unavailable",
                    "en-GB": null,
                    "it": "Dati non disponibili",
                    "sv": "Data saknas",
                    "sv-SE": null,
                    "zh-CN": "没有数据"
                },
                "dateRangeInterval": {
                    "en": "-",
                    "en-GB": null,
                    "sv-SE": null
                },
                "dateRangeTitle": {
                    "da-DK": "Datointerval:",
                    "en": "Date Range:",
                    "en-GB": null,
                    "it": "Intervallo di dati:",
                    "sv": "Datumintervall",
                    "sv-SE": null
                },
                "fiveYears": {
                    "da-DK": "5 År",
                    "en": "5Y",
                    "en-GB": null,
                    "fr": "5A",
                    "fr-CA": "5a",
                    "it": "5 A",
                    "sv": "5 år",
                    "sv-SE": null,
                    "zh-CN": "5年",
                    "zh-HK": "5年"
                },
                "fiveYearsAria": {
                    "en": "5 Years",
                    "en-GB": null,
                    "sv-SE": null
                },
                "oneMonth": {
                    "en": "1 Month",
                    "it": "1 mese",
                    "sv": "1 månad"
                },
                "oneYear": {
                    "da-DK": "1 År",
                    "en": "1Y",
                    "en-GB": null,
                    "fr": "1A",
                    "fr-CA": "1a",
                    "it": "1 A",
                    "sv": "1 år",
                    "sv-SE": null,
                    "zh-CN": "1年",
                    "zh-HK": "1年"
                },
                "oneYearAria": {
                    "en": "1 Years",
                    "en-GB": null,
                    "sv-SE": null
                },
                "performanceGraph": {
                    "da-DK": "Performance Graf",
                    "en": "Performance Graph",
                    "en-GB": null,
                    "fr": "Graphique de performances",
                    "fr-CA": "Graphique des rendements",
                    "it": "Grafico della performance",
                    "sv": "Utvecklingsgraf",
                    "sv-SE": null,
                    "zh-CN": "表现图表",
                    "zh-HK": "表現圖表"
                },
                "sixMonths": {
                    "da-DK": "6M",
                    "en": "6M",
                    "en-GB": null,
                    "fr": "6M",
                    "fr-CA": "6m",
                    "it": "6 M",
                    "sv": "6m",
                    "sv-SE": null,
                    "zh-CN": "6个月",
                    "zh-HK": "6個月"
                },
                "tenYears": {
                    "da-DK": "10 År",
                    "en": "10Y",
                    "en-GB": null,
                    "fr": "10A",
                    "fr-CA": "10a",
                    "it": "10 A",
                    "sv": "10 år",
                    "sv-SE": null,
                    "zh-CN": "10年",
                    "zh-HK": "10年"
                },
                "tenYearsAria": {
                    "en": "10 Years",
                    "en-GB": null,
                    "sv-SE": null
                },
                "threeMonths": {
                    "da-DK": "3M",
                    "en": "3M",
                    "en-GB": null,
                    "fr": "3M",
                    "fr-CA": "3m",
                    "it": "3 M",
                    "sv": "3m",
                    "sv-SE": null,
                    "zh-CN": "3个月",
                    "zh-HK": "3個月"
                },
                "threeYears": {
                    "da-DK": "3 År",
                    "en": "3Y",
                    "en-GB": null,
                    "fr": "3A",
                    "fr-CA": "3a",
                    "it": "3 A",
                    "sv": "3 år",
                    "sv-SE": null,
                    "zh-CN": "3年",
                    "zh-HK": "3年"
                },
                "threeYearsAria": {
                    "en": "3 Years",
                    "en-GB": null,
                    "sv-SE": null
                },
                "twoYears": {
                    "da-DK": "2 År",
                    "en": "2Y",
                    "en-GB": null,
                    "fr": "2A",
                    "fr-CA": "2a",
                    "it": "2 A",
                    "sv": "2 år",
                    "sv-SE": null,
                    "zh-CN": "2年",
                    "zh-HK": "2年"
                },
                "twoYearsAria": {
                    "en": "2 Years",
                    "en-GB": null,
                    "sv-SE": null
                }
            },
            "settings": {
                "_model": {
                    "asOfDate": null,
                    "performanceChart": null
                },
                "_parameters": {
                    "dataType": {},
                    "displayFrequency": {},
                    "endDate": {},
                    "startDate": {}
                },
                "_templates": {
                    "custom": {
                        "annualPerformanceTable": "<ec-table template-type=\"light\" mstar-component-id=\"annualPerformanceTable\"></ec-table>"
                    },
                    "main": "<ec-section title=\"{{::settings.get(showTitle) ? labels.get('performanceGraph') : undefined}}\" sub-title=\"{{ model.asOfDate && model.asOfDate.length !== 0 ? format.date(model.asOfDate) : null }}\">\r\n    <ec-container mstar-component-id=\"graphContainer\">\r\n        <ec-section data-template-type=\"light\" section-id=\"frequency\">\r\n            <div class=\"{{::namespaceClass('__title')}}\">{{::labels.get('performanceGraph')}} </div>\r\n            <div class=\"{{::namespaceClass('__tab-frequency')}}\">\r\n                <ec-tabs mstar-component-id=\"tabFrequency\">\r\n                    <ec-tab-action data-ng-repeat=\"frequency in parameters.displayFrequency track by $index\" name=\"{{labels.get(frequency.labelKey)}}\" aria-label=\"{{labels.get(frequency.labelKey+'Aria')}}\" on-active=\"setActiveTab(index, tab)\">\r\n                    </ec-tab-action>\r\n                </ec-tabs>\r\n            </div>\r\n            <div data-ng-if=\"model.asOfDate && model.asOfDate.length !== 0\" class=\"{{::namespaceClass('__subtitle')}}\">{{ format.date(model.asOfDate) }} </div>\r\n        </ec-section>\r\n        <ec-section data-template-type=\"light\" section-id=\"dateRange\">\r\n            <fieldset class=\"{{::namespaceClass('__date-range')}}\">\r\n                <legend class=\"{{::namespaceClass('__date-range--title')}}\">{{::labels.get('dateRangeTitle')}}</legend>\r\n                <ec-input mstar-component-id=\"startDate\" data-ng-model=\"parameters.startDate\"></ec-input>\r\n                <span class=\"{{::namespaceClass('__date-range--interval')}}\">{{::labels.get('dateRangeInterval')}}</span>\r\n                <ec-input mstar-component-id=\"endDate\" data-ng-model=\"parameters.endDate\"></ec-input>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section data-template-type=\"light\" section-id=\"graph\">\r\n            <div id=\"{{::namespaceId('line-chart')}}\" class=\"{{::namespaceClass('__graph')}}\">\r\n            </div>\r\n        </ec-section>\r\n        <ec-section data-ng-repeat=\"(key,value) in templates.custom track by $index\" section-id=\"{{key}}\" title=\"{{ labels.contains(key) ? labels.get(key) : undefined }}\">\r\n            <div mstar-include=\"value\"></div>\r\n        </ec-section>\r\n    </ec-container>\r\n</ec-section>"
                },
                "chartType": "growth",
                "colorPaletteName": "lineChart",
                "colorPalettes": {
                    "lineChart": ["#006098", "#151515"]
                },
                "dataType": null,
                "displayFrequency": [{
                    "dataType": "m",
                    "labelKey": "oneYear",
                    "value": 12
                }, {
                    "dataType": "m",
                    "labelKey": "twoYears",
                    "value": 24
                }, {
                    "dataType": "m",
                    "labelKey": "threeYears",
                    "value": 36
                }, {
                    "dataType": "m",
                    "labelKey": "fiveYears",
                    "value": 60
                }, {
                    "dataType": "m",
                    "labelKey": "tenYears",
                    "value": 120
                }],
                "enableCustomDate": false,
                "endDate": null,
                "graphBaseValue": 10000,
                "lineChartSettings": {
                    "dottedLineIndexes": [],
                    "firstTickDate": true,
                    "legendPosition": "right",
                    "legendValuesFormatAlias": "shortDecimal",
                    "showDottedLines": false,
                    "showLegendValues": true,
                    "showToolTip": true,
                    "showsCurrency": false,
                    "timelineLevel": "month",
                    "tooltipTimeFormatAlias": "yyyy-mm-dd",
                    "useDefaultParsers": false,
                    "xAxisOrient": "bottom",
                    "xTickFormatAlias": "mm",
                    "y1AxisOrient": "left",
                    "y1Bubbled": false,
                    "y1TickFormatAlias": "thousandsDecimal",
                    "y1TickSymbol": null,
                    "y2": false
                },
                "namespaceClass": "ec-performance-graph",
                "showTitle": true,
                "startDate": null,
                "timelineLevelDefinitions": {
                    "month": [0, 13],
                    "quarter": [14, 37],
                    "year": [38, 2000]
                }
            },
            "type": "ecPerformanceGraph"
        }
    };

    /***/
},
/* 6 */
/***/function (module, exports, __webpack_require__) {

    (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory(__webpack_require__(0));else if (typeof define === 'function' && define.amd) define(["mbc-core"], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["mbc-flag"] = factory(require("mbc-core"));else root["mbc-flag"] = factory(root["mbc-core"]);
    })(this, function (__WEBPACK_EXTERNAL_MODULE_0__) {
        return (/******/function (modules) {
                // webpackBootstrap
                /******/ // The module cache
                /******/var installedModules = {};
                /******/
                /******/ // The require function
                /******/function __webpack_require__(moduleId) {
                    /******/
                    /******/ // Check if module is in cache
                    /******/if (installedModules[moduleId]) {
                        /******/return installedModules[moduleId].exports;
                        /******/
                    }
                    /******/ // Create a new module (and put it into the cache)
                    /******/var module = installedModules[moduleId] = {
                        /******/i: moduleId,
                        /******/l: false,
                        /******/exports: {}
                        /******/ };
                    /******/
                    /******/ // Execute the module function
                    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                    /******/
                    /******/ // Flag the module as loaded
                    /******/module.l = true;
                    /******/
                    /******/ // Return the exports of the module
                    /******/return module.exports;
                    /******/
                }
                /******/
                /******/
                /******/ // expose the modules object (__webpack_modules__)
                /******/__webpack_require__.m = modules;
                /******/
                /******/ // expose the module cache
                /******/__webpack_require__.c = installedModules;
                /******/
                /******/ // identity function for calling harmony imports with the correct context
                /******/__webpack_require__.i = function (value) {
                    return value;
                };
                /******/
                /******/ // define getter function for harmony exports
                /******/__webpack_require__.d = function (exports, name, getter) {
                    /******/if (!__webpack_require__.o(exports, name)) {
                        /******/Object.defineProperty(exports, name, {
                            /******/configurable: false,
                            /******/enumerable: true,
                            /******/get: getter
                            /******/ });
                        /******/
                    }
                    /******/
                };
                /******/
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/__webpack_require__.n = function (module) {
                    /******/var getter = module && module.__esModule ?
                    /******/function getDefault() {
                        return module['default'];
                    } :
                    /******/function getModuleExports() {
                        return module;
                    };
                    /******/__webpack_require__.d(getter, 'a', getter);
                    /******/return getter;
                    /******/
                };
                /******/
                /******/ // Object.prototype.hasOwnProperty.call
                /******/__webpack_require__.o = function (object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/
                /******/ // __webpack_public_path__
                /******/__webpack_require__.p = "";
                /******/
                /******/ // Load entry module and return exports
                /******/return __webpack_require__(__webpack_require__.s = 120);
                /******/
            }(
            /************************************************************************/
            /******/{

                /***/0:
                /***/function _(module, exports) {

                    module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

                    /***/
                },

                /***/101:
                /***/function _(module, exports) {

                    // removed by extract-text-webpack-plugin

                    /***/},

                /***/120:
                /***/function _(module, exports, __webpack_require__) {

                    module.exports = __webpack_require__(19);

                    /***/
                },

                /***/19:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    __webpack_require__(101);

                    var _flag = __webpack_require__(59);

                    var _flag2 = _interopRequireDefault(_flag);

                    function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : { default: obj };
                    }

                    module.exports = _flag2.default;

                    /***/
                },

                /***/57:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    Object.defineProperty(exports, "__esModule", {
                        value: true
                    });
                    var ToolTipConfig = function ToolTipConfig() {

                        this._DEFAULT_CONFIG = {
                            template: function template(d) {
                                return "<div class='tooltip-inner'>" + d.value + "</div>";
                            }
                        };

                        this._config = this._DEFAULT_CONFIG;
                    };

                    ToolTipConfig.prototype.configuration = function (v) {
                        if (arguments.length === 0) {
                            return this._config;
                        }

                        // Polyfill for ES6 assign method
                        if (typeof Object.assign !== "function") {
                            Object.assign = function (target) {
                                /*jshint maxcomplexity:6 */
                                if (target === null) {
                                    throw new TypeError("Cannot convert undefined or null to object");
                                }

                                target = Object(target);
                                for (var index = 1; index < arguments.length; index++) {
                                    var source = arguments[index];
                                    if (source !== null) {
                                        for (var key in source) {
                                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                                target[key] = source[key];
                                            }
                                        }
                                    }
                                }

                                return target;
                            };
                        }

                        this._config = Object.assign({}, this._DEFAULT_CONFIG, v);
                        return this;
                    };

                    ToolTipConfig.prototype.template = function (v) {
                        if (arguments.length === 0) {
                            return this._config.template;
                        }

                        this._config.template = v;

                        return this;
                    };

                    var configuration = exports.configuration = new ToolTipConfig();

                    /***/
                },

                /***/58:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    function getPositionTop(ttClientRect, canvas, mousePosition, position) {
                        var tooFarLeft, tooFarRight, tooLow, tooHigh;
                        tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
                        tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
                        tooHigh = mousePosition[1] < ttClientRect.height;
                        tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
                        if (tooHigh && !tooFarLeft && tooFarRight) {
                            position = "bottom-left";
                        } else if (tooHigh && tooFarLeft && !tooFarRight) {
                            position = "bottom-right";
                        } else if (tooHigh) {
                            position = "bottom";
                        } else if (!tooFarLeft && tooFarRight) {
                            position = "top-left";
                        } else if (tooFarLeft && !tooFarRight) {
                            position = "top-right";
                        }

                        return position;
                    }

                    function getPositionBottom(ttClientRect, canvas, mousePosition, position) {
                        var tooFarLeft, tooFarRight, tooLow, tooHigh;
                        tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
                        tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
                        tooHigh = mousePosition[1] < ttClientRect.height;
                        tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
                        if (tooLow && !tooFarLeft && tooFarRight) {
                            position = "top-left";
                        } else if (tooLow && tooFarLeft && !tooFarRight) {
                            position = "top-right";
                        } else if (tooLow) {
                            position = "top";
                        } else if (!tooFarLeft && tooFarRight) {
                            position = "bottom-left";
                        } else if (tooFarLeft && !tooFarRight) {
                            position = "bottom-right";
                        }

                        return position;
                    }

                    function getPositionTopRight(ttClientRect, canvas, mousePosition, position, isLine) {
                        var tooFarLeft, tooFarRight, tooLow, tooHigh;
                        var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
                        tooFarRight = mousePosition[0] >= canvas.width() - width;
                        tooFarLeft = mousePosition[0] < width;
                        tooHigh = mousePosition[1] < ttClientRect.height;
                        tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
                        if (tooHigh && tooLow) {
                            tooHigh = false;
                        }
                        if (tooHigh && !tooLow && !tooFarRight) {
                            position = "bottom-right";
                        } else if (tooHigh && !tooLow && tooFarRight) {
                            position = "bottom-left";
                        } else if (!tooHigh && tooFarRight) {
                            position = "top-left";
                        }

                        return position;
                    }

                    function getRightTop(ttClientRect, canvas, mousePosition, position, isLine) {
                        var tooFarRight, tooLow;
                        var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
                        tooFarRight = mousePosition[0] >= canvas.width() - width;
                        tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
                        if (tooFarRight && tooLow) {
                            position = "left-bottom";
                        } else if (tooFarRight) {
                            position = "left-top";
                        } else if (tooLow) {
                            position = "right-bottom";
                        }

                        return position;
                    }

                    module.exports = {
                        top: getPositionTop,
                        bottom: getPositionBottom,
                        topRight: getPositionTopRight,
                        rightTop: getRightTop
                    };

                    /***/
                },

                /***/59:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var _mbcCore = __webpack_require__(0);

                    var _mbcCore2 = _interopRequireDefault(_mbcCore);

                    function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : { default: obj };
                    }

                    var configuration = __webpack_require__(57).configuration;
                    var positioning = __webpack_require__(58);

                    var Classes = _mbcCore2.default.Classes;
                    var Utils = _mbcCore2.default.Utils;

                    /**
                     * D3 tooltip plugin
                     * Modification of https://github.com/roncr/d3-tooltip-box
                     * @class Tooltip
                     */
                    var ToolTip = function ToolTip(options) {

                        options = options || {};
                        this.__OPTIONS = options;
                        this._tooltipMap = {
                            top: { top: true },
                            "top-left": { top: true, "top-left": true },
                            "top-right": { top: true, "top-right": true },
                            bottom: { bottom: true },
                            "bottom-left": { bottom: true, "bottom-left": true },
                            "bottom-right": { bottom: true, "bottom-right": true },
                            left: { left: true },
                            "left-top": { left: true, "left-top": true },
                            "left-bottom": { left: true, "left-bottom": true },
                            right: { right: true },
                            "right-top": { right: true, "right-top": true },
                            "right-bottom": { right: true, "right-bottom": true }
                        };

                        var defaultOptions = {
                            position: "top-right",
                            delay: 250,
                            transitionDuration: 20,
                            opacity: 0.95,
                            transition: true
                        };

                        Utils.object.copy(defaultOptions, options);

                        this._options = defaultOptions;

                        // Constants
                        this._DEFAULT_POSITION_OFFSET = { top: 0, left: 0 };

                        // Variables
                        this._tooltipClass = Classes.TOOLTIP_CONTAINER;
                        this._parent = d3.select("body");
                        this._dataAccessor = function (d) {
                            return d;
                        };

                        this._template = configuration.template();
                        this._positionOffset = this._DEFAULT_POSITION_OFFSET;
                    };

                    /**
                     * Initializes the tooltip container, if there is already
                     * a container, reuses the same tooltip, otherwise creates
                     * a new <div> container
                     * @returns {d3.selection} tooltip container
                     * @private
                     */
                    ToolTip.prototype._initTooltip = function () {
                        var tooltipEl = d3.select("." + this._tooltipClass);
                        if (tooltipEl.empty()) {
                            tooltipEl = this._createTooltip(this._options);
                        }

                        return tooltipEl;
                    };

                    /**
                     * Creates a new <div> as the container of the tooltip
                     * @returns {d3.selection} new tooltip container
                     * @private
                     */
                    ToolTip.prototype._createTooltip = function (options) {
                        var positionClass = this._tooltipMap[options.position];
                        var tooltip = this.parent().append("div").attr("class", this._tooltipClass).classed("tooltip", true).classed(positionClass).style('display', 'none').classed("in", true).classed("fade", true);

                        if (this._options && this._options.namespace && typeof this._options.namespace === "string") {
                            tooltip.classed(this._options.namespace + "-tooltip", true);
                        }

                        return tooltip;
                    };

                    /**
                     * Gets the content of the tooltip by either
                     * compiling a static template or invoking the
                     * function of a dynamic template
                     * @param d the associated data
                     * @returns {ELEMENT_NODE} content of the tooltip as HTML
                     * @private
                     */
                    ToolTip.prototype._getContent = function (d) {
                        var template = this._template;

                        var compileTemplate = function compileTemplate(template, data) {
                            for (var prop in data) {
                                var regex = new RegExp("\\@\\{" + prop + "}", "gi");
                                template = template.replace(regex, data[prop]);
                            }

                            return template;
                        };

                        if (typeof template === "function") {
                            return template(d);
                        } else {
                            var data = this._dataAccessor(d);
                            return compileTemplate(template, data);
                        }
                    };

                    /**
                     * Parent getter/setter
                     * @param v the parent to set
                     * @returns {d3.selection} the current parent (returned only if
                     * invoked with no parameters)
                     */
                    ToolTip.prototype.parent = function (v) {

                        var isD3Selection = function isD3Selection(obj) {
                            return obj instanceof d3.selection;
                        };

                        if (arguments.length === 0) {
                            return this._parent;
                        }

                        if (!isD3Selection(v)) {
                            v = d3.select(v);
                        }

                        this._parent = v;
                        return this;
                    };

                    /**
                     * Position offset getter/setter, the offset must
                     * be in the shape of {left: 0, top: 0}
                     * @param v the offset to set
                     * @returns {Object} current offset (returned only if invoked with
                     * not parameters)
                     */
                    ToolTip.prototype.positionOffset = function (v) {
                        if (arguments.length === 0) {
                            return this._positionOffset;
                        }

                        this._positionOffset = {};
                        Utils.object.copy(this._positionOffset, this._DEFAULT_POSITION_OFFSET, v);
                        return this;
                    };

                    /**
                     * Data accessor getter/setter
                     * @param v the accessor function to set
                     * @returns {Function} the current accessor function (returned only if
                     * invoked with no parameters)
                     */
                    ToolTip.prototype.data = function (v) {
                        if (arguments.length === 0) {
                            return this._dataAccessor;
                        }

                        this._dataAccessor = v;
                        return this;
                    };

                    /**
                     * Template getter/setter
                     * @param v the template to set, if string it is considered
                     * static template, if function it is considered dynamic template
                     * and will be invoked with the associated data as parameter
                     * @returns {*} the current template string or factory function
                     * (returned only if invoked with no parameters)
                     */
                    ToolTip.prototype.template = function (v) {
                        if (arguments.length === 0) {
                            return this._template;
                        }

                        this._template = v;
                        return this;
                    };

                    /**
                     * Makes the tooltip visible
                     * @param d the associated data of the selection
                     */
                    ToolTip.prototype.show = function (d, changes) {
                        var html, options;
                        if (!this._tooltipEl) {

                            if (changes) {

                                var defaultOptions = { position: "top-right" };
                                Utils.object.copy(defaultOptions, changes);
                                this._options = defaultOptions;
                            }

                            this._tooltipEl = this._initTooltip();
                        }

                        options = this._options;

                        if (!this._disabled) {
                            html = this._getContent(d);

                            if (html !== null && typeof html !== "undefined") {
                                html += "<div class='tooltip-arrow'></div>";
                                this._tooltipEl.html(html);
                                if (options.transition) {
                                    this._tooltipEl.style({
                                        opacity: 0,
                                        display: "inline-block"
                                    }).transition().duration(options.transitionDuration).delay(options.delay).style({
                                        opacity: options.opacity
                                    });
                                } else {
                                    this._tooltipEl.style({
                                        opacity: options.opacity,
                                        display: "inline-block"
                                    });
                                }
                            }
                        }
                    };

                    ToolTip.prototype.disabled = function (disabled) {
                        this._disabled = disabled;
                    };

                    // This method calculates the flag positioning inside the chart canvas based on its initial position.
                    function calcPosition(tooltip, canvas, position, mousePosition, isLine) {
                        var ttClientRect = tooltip.node().getBoundingClientRect();

                        // TODO: Other automatic positionings.
                        switch (position) {
                            case "top":
                                position = positioning.top(ttClientRect, canvas, mousePosition, position);
                                break;

                            case "top-left":
                                break;

                            case "top-right":
                                position = positioning.topRight(ttClientRect, canvas, mousePosition, position, isLine);
                                break;

                            case "bottom":
                                position = positioning.bottom(ttClientRect, canvas, mousePosition, position);
                                break;

                            case "bottom-left":
                                break;

                            case "bottom-right":
                                break;

                            case "left":
                                break;

                            case "left-top":
                                break;

                            case "left-bottom":
                                break;

                            case "right":
                                break;

                            case "right-top":
                                position = positioning.rightTop(ttClientRect, canvas, mousePosition, position, isLine);
                                break;

                            case "right-bottom":
                                break;

                            default:
                                break;
                        }

                        return position;
                    }

                    /**
                     * Moves the tooltip to the mouse position
                     */
                    ToolTip.prototype.move = function (d, mousePosition) {

                        // If the tooltip is not shown already, show it
                        if (!this._tooltipEl) this.show(d);

                        var autoposition = this._options.autoposition;
                        var _this = this;
                        var positionClass;
                        var isLine = _this.__OPTIONS.chart === "line";
                        var isTimeSeries = _this.__OPTIONS.chart === "time-series";

                        var getOffset = function getOffset(ctx) {
                            var tooltipEl = ctx._tooltipEl;
                            var clientRect = tooltipEl.node().getBoundingClientRect();
                            var height = clientRect.height;
                            var width = clientRect.width;
                            var position = ctx._options.position;
                            var top = 0;
                            var left = 0;

                            if (autoposition) {
                                position = calcPosition(tooltipEl, autoposition, position, mousePosition, isLine);
                            }

                            positionClass = ctx._tooltipMap[position];

                            tooltipEl.classed({
                                top: false,
                                "top-left": false,
                                "top-right": false,
                                bottom: false,
                                "bottom-left": false,
                                "bottom-right": false,
                                left: false,
                                "left-top": false,
                                "left-bottom": false,
                                right: false,
                                "right-top": false,
                                "right-bottom": false
                            }).classed(positionClass);

                            switch (position) {
                                case "top":
                                    top = height;
                                    left = width / 2;
                                    break;

                                case "top-left":
                                    top = height;
                                    left = width;
                                    break;

                                case "top-right":
                                    top = height;
                                    break;

                                case "bottom":
                                    left = width / 2;
                                    top = -10;
                                    break;

                                case "bottom-left":
                                    left = width;
                                    top = -10;
                                    break;

                                case "bottom-right":
                                    top = -10;
                                    break;

                                case "left":
                                    top = height / 2;
                                    left = width;
                                    break;

                                case "left-top":
                                    left = width;
                                    break;

                                case "left-bottom":
                                    left = width;
                                    top = height;
                                    break;

                                case "right":
                                    top = height / 2;
                                    left = -5;
                                    break;

                                case "right-top":
                                    left = -5;
                                    break;

                                case "right-bottom":
                                    left = -5;
                                    top = height;
                                    break;

                                default:
                                    break;
                            }

                            return { top: top, left: left };
                        };

                        var clientRect = _this._tooltipEl.node().getBoundingClientRect();

                        _this._clientRect = clientRect;
                        _this._positionOffset = getOffset(_this);

                        if (isLine) {
                            var select = document.querySelector(".mbc-line-chart-tooltip");
                            var mouse = d3.mouse(select);
                            var closestLine = _this.getCalculation();
                            var zoneWidth = _this.__OPTIONS.flagZoneWidth;
                        }

                        var formatPx = function formatPx(value) {
                            return value + "px";
                        };
                        var padding = -5;

                        if (_this.hasPositionLeft(positionClass)) {
                            padding = clientRect.width + 5;
                        }

                        if (isTimeSeries) {
                            var closestLine = _this._options.hoverLeft - _this._positionOffset.left;
                            padding = 3;
                        }

                        _this._tooltipEl.style({
                            position: "absolute",
                            left: isLine || isTimeSeries ? formatPx(closestLine - padding) : formatPx(d3.event.pageX - _this._positionOffset.left),
                            top: formatPx(d3.event.pageY - _this._positionOffset.top)
                        });
                    };

                    ToolTip.prototype.hasPositionLeft = function (pos) {
                        return pos.hasOwnProperty("top-left") || pos.hasOwnProperty("bottom-left") || pos.hasOwnProperty("left-top") || pos.hasOwnProperty("left-bottom");
                    };

                    ToolTip.prototype.getCalculation = function () {
                        var isTimeSeries = this.__OPTIONS.chart === "time-series";
                        var select = document.querySelector("body");
                        var lines = Array.prototype.slice.call(document.querySelectorAll(".mouse-line")).map(function (line) {
                            return line.getBoundingClientRect().left;
                        });

                        var position;
                        var mouse = d3.mouse(select)[0];

                        var zoneWidth = this.__OPTIONS.flagZoneWidth;
                        var canvasWidth = this.__OPTIONS.canvasWidth;
                        var zones = Math.round(canvasWidth / zoneWidth);
                        var findRange = function findRange() {
                            var w = Math.floor(zoneWidth / 2);
                            lines.forEach(function (line, idx) {
                                if (mouse >= line - w && mouse <= line + w) {
                                    position = line;
                                    return false;
                                }
                            });
                        };

                        findRange();

                        return position;
                    };

                    /**
                     * Hides the tooltip
                     */
                    ToolTip.prototype.hide = function () {
                        if (this._tooltipEl) {
                            this._tooltipEl.transition();
                        }

                        var container = d3.select(".mbc-chart-tooltip-container");
                        container.remove();
                        this._tooltipEl = null;
                    };

                    /**
                     * Attaches the tooltip event listeners to
                     * the current selection
                     * @returns {Function} function to be used for the
                     * d3.selection.call method
                     */
                    ToolTip.prototype.bind = function () {
                        var _this = this;

                        return function (selection) {
                            selection.each(function () {
                                var element = d3.select(this);

                                element.on("mousemove.tooltip-container", function (d) {
                                    return _this.move(d, d3.mouse(this));
                                }).on("mousewheel.tooltip-container", function () {
                                    return _this.hide();
                                }).on("mouseout.tooltip-container", function () {
                                    return _this.hide();
                                });
                            });
                        };
                    };

                    /**
                     * Tooltip factory, creates new instances of the tooltip
                     * @returns {Tooltip} the new tooltip instance
                     */
                    function create(options) {
                        var instance = new ToolTip(options);
                        return instance;
                    }

                    module.exports = create;

                    /***/
                }

                /******/ })
        );
    });

    /***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

    (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory(__webpack_require__(0));else if (typeof define === 'function' && define.amd) define(["mbc-core"], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["mbc-legend"] = factory(require("mbc-core"));else root["mbc-legend"] = factory(root["mbc-core"]);
    })(this, function (__WEBPACK_EXTERNAL_MODULE_0__) {
        return (/******/function (modules) {
                // webpackBootstrap
                /******/ // The module cache
                /******/var installedModules = {};
                /******/
                /******/ // The require function
                /******/function __webpack_require__(moduleId) {
                    /******/
                    /******/ // Check if module is in cache
                    /******/if (installedModules[moduleId]) {
                        /******/return installedModules[moduleId].exports;
                        /******/
                    }
                    /******/ // Create a new module (and put it into the cache)
                    /******/var module = installedModules[moduleId] = {
                        /******/i: moduleId,
                        /******/l: false,
                        /******/exports: {}
                        /******/ };
                    /******/
                    /******/ // Execute the module function
                    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                    /******/
                    /******/ // Flag the module as loaded
                    /******/module.l = true;
                    /******/
                    /******/ // Return the exports of the module
                    /******/return module.exports;
                    /******/
                }
                /******/
                /******/
                /******/ // expose the modules object (__webpack_modules__)
                /******/__webpack_require__.m = modules;
                /******/
                /******/ // expose the module cache
                /******/__webpack_require__.c = installedModules;
                /******/
                /******/ // identity function for calling harmony imports with the correct context
                /******/__webpack_require__.i = function (value) {
                    return value;
                };
                /******/
                /******/ // define getter function for harmony exports
                /******/__webpack_require__.d = function (exports, name, getter) {
                    /******/if (!__webpack_require__.o(exports, name)) {
                        /******/Object.defineProperty(exports, name, {
                            /******/configurable: false,
                            /******/enumerable: true,
                            /******/get: getter
                            /******/ });
                        /******/
                    }
                    /******/
                };
                /******/
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/__webpack_require__.n = function (module) {
                    /******/var getter = module && module.__esModule ?
                    /******/function getDefault() {
                        return module['default'];
                    } :
                    /******/function getModuleExports() {
                        return module;
                    };
                    /******/__webpack_require__.d(getter, 'a', getter);
                    /******/return getter;
                    /******/
                };
                /******/
                /******/ // Object.prototype.hasOwnProperty.call
                /******/__webpack_require__.o = function (object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/
                /******/ // __webpack_public_path__
                /******/__webpack_require__.p = "";
                /******/
                /******/ // Load entry module and return exports
                /******/return __webpack_require__(__webpack_require__.s = 123);
                /******/
            }(
            /************************************************************************/
            /******/{

                /***/0:
                /***/function _(module, exports) {

                    module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

                    /***/
                },

                /***/104:
                /***/function _(module, exports) {

                    // removed by extract-text-webpack-plugin

                    /***/},

                /***/114:
                /***/function _(module, exports) {

                    module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAwIDE1MDAiPjxwYXRoIGQ9Ik02OTguNSA3OTguNWgxMDB2LTEwMGgtMTAwdjEwMHptLTMwMCAwaDEwMHYtMTAwaC0xMDB2MTAwem0zNTAtODAwYy00MTAgMC03NTAgMzQwLTc1MCA3NTBzMzQwIDc1MCA3NTAgNzUwIDc1MC0zNDAgNzUwLTc1MC0zNDAtNzUwLTc1MC03NTB6bTAgMTQwMGMtMzYwIDAtNjUwLTI5MC02NTAtNjUwczI5MC02NTAgNjUwLTY1MCA2NTAgMjkwIDY1MCA2NTAtMjkwIDY1MC02NTAgNjUwem0yNTAtNjAwaDEwMHYtMTAwaC0xMDB2MTAweiIvPjwvc3ZnPjwhLS0gbW9ybmluZ3N0YXItZGVzaWduLXN5c3RlbSB2MS4xNi4xIC0tPg==";

                    /***/
                },

                /***/123:
                /***/function _(module, exports, __webpack_require__) {

                    module.exports = __webpack_require__(22);

                    /***/
                },

                /***/22:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    __webpack_require__(104);

                    var _legend = __webpack_require__(69);

                    var _legend2 = _interopRequireDefault(_legend);

                    function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : { default: obj };
                    }

                    module.exports = _legend2.default;

                    /***/
                },

                /***/68:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var core = __webpack_require__(0);
                    var Utils = core.Utils;

                    /**
                     * @method addItemsSVG
                     * Creates svg items within legend on right side of chart
                     * Key and Item name
                     */
                    function addItemsSVG(params) {
                        var names = [];
                        var items = params.items;
                        var firstPass;
                        var lineHeight = 17;
                        var keyPadding = 5;
                        var linePadding = 3;
                        var timeSeriesNoValueLinePadding = 8;
                        var wrapVars = {
                            params: params,
                            container: params.container,
                            names: names,
                            firstPass: firstPass
                        };
                        var rangeLength = items.length * lineHeight + keyPadding; //line height + padding
                        var y = d3.scale.linear().range([0, rangeLength]);
                        var isLineChart = function isLineChart() {
                            return params.chartType === 'lineChart';
                        };
                        var isTimeSeries = function isTimeSeries() {
                            return params.chartType === 'time-series';
                        };
                        var isBenchmark = function isBenchmark(d) {
                            return d.groupName === "Benchmarks";
                        };

                        items.selectAll("*").remove();
                        items.enter().append("g").attr("class", function (d) {
                            return d.name ? Utils.string.dashify(d.name) : Utils.string.dashify(d.displayName);
                        }).classed("legend-item", true);
                        if (isTimeSeries()) {
                            var legendValuesFormat = Utils.string.convertDashToEnDash(params.legendValuesFormat);
                            items.append("text").attr("class", function (d, i) {
                                return "mbc-time-series_dataKey";
                            }).attr("x", 0).text(function (d) {
                                return d.displayName;
                            }).call(wrap, wrapVars).attr("y", function (d, i) {
                                var yValue = y(i) + lineHeight + lineHeight * i;
                                yValue = yValue + keyPadding * i;
                                if (items[0][i - 1]) {
                                    var valueLine = params.legendShowValue ? linePadding / 2 * lineHeight : 5.5;
                                    yValue = getElementY(items[0][i - 1], 0) + getNumTspan(items[0][i - 1], params.chartType) * lineHeight + linePadding + valueLine;
                                }
                                return yValue;
                            });
                            if (params.legendShowValue) {
                                items.append("text").attr("class", "mbc-time-series_dataValue").attr("x", 0).attr("y", function (d, i) {
                                    var yValue = y(i) + lineHeight * 2 + lineHeight * i;
                                    yValue = yValue + keyPadding * i + 3;
                                    if (items[0][i]) {
                                        yValue = getNumTspan(items[0][i], params.chartType) * lineHeight + linePadding + getElementY(items[0][i], 0);
                                    }
                                    return yValue;
                                }).text(function (d) {
                                    names.push(legendValuesFormat(d.value));
                                    return legendValuesFormat(d.value);
                                });
                            }
                            items.append("line").attr("x1", 0).attr("y1", function (d, i) {
                                var yValue = y(i) + lineHeight * i;
                                yValue = yValue + 5 * i;
                                if (items[0][i - 1]) {
                                    var index = params.legendShowValue ? 1 : 0;
                                    var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                                    yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index;
                                }
                                return yValue;
                            }).attr("x2", function (d) {
                                var svg = params.container.append("svg");
                                var largestWidth = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + 21;
                                svg.remove();
                                var width = largestWidth - params.legendWidth >= 1 ? largestWidth : params.legendWidth - 1;
                                return scrollbarPresent(params.container) ? width + 15 : width;
                            }).attr("y2", function (d, i) {
                                var yValue = y(i) + lineHeight * i;
                                yValue = yValue + 5 * i;
                                if (items[0][i - 1]) {
                                    var index = params.legendShowValue ? 1 : 0;
                                    var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                                    yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index;
                                }
                                return yValue;
                            }).attr("stroke", function (d) {
                                return d.color || params.colors[d.index % params.colors.length];
                            }).attr("stroke-dasharray", function (d) {
                                var lineIsDotted = params.dottedLines.indexOf(d.displayName) > -1;
                                return lineIsDotted ? "2,2" : "transparent";
                            }).attr("stroke-width", "2");
                        } else {
                            items.append("text").attr("class", function (d, i) {
                                return "dataName" + i;
                            }).text(function (d) {
                                return d.displayName;
                            }).attr("x", 15).call(wrap, wrapVars).attr("y", function (d, i) {
                                var yValue = y(i) + 10;
                                if (items[0][i - 1]) {
                                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) : yValue;
                                }
                                return yValue;
                            });
                            items.append("line").attr("x1", 0).attr("y1", function (d, i) {
                                var yValue = y(i) + 5;
                                if (items[0][i - 1]) {
                                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
                                }
                                return yValue;
                            }).attr("x2", 10).attr("y2", function (d, i) {
                                var yValue = y(i) + 5;
                                if (items[0][i - 1]) {
                                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
                                }
                                return yValue;
                            }).attr("stroke", function (d, i) {
                                if (isLineChart()) {
                                    return d.color || params.colors[i % params.colors.length];
                                }
                                return isBenchmark(d) ? params.benchmarkColor : "transparent";
                            }).attr("stroke-dasharray", function (d) {
                                if (params.lineStyles[d.displayName]) {
                                    return "2,2";
                                }
                                return isBenchmark(d) && params.dottedBenchmark ? "2,2" : "transparent";
                            }).attr("stroke-width", "2");

                            items.append("rect").attr("x", 0).attr("y", function (d, i) {
                                var yValue = y(i);
                                if (items[0][i - 1]) {
                                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 10 : yValue;
                                }
                                return yValue;
                            }).attr("width", 10).attr("height", 10).attr("fill", function (d, i) {
                                return isBenchmark(d) || isLineChart() ? "transparent" : d.color || params.colors[i % params.colors.length];
                            }).attr("fill-opacity", 0.8);
                        }
                        items.exit().remove();

                        adjustSVGHeight(params, items);
                        setLegendWidth(wrapVars);
                    }

                    /**
                     * @method addTopItemsSVG
                     * Creates svg items within legend on top of chart
                     * Key and Item name
                     * Hides elements that scope beyond chart width
                     */
                    function addTopItemsSVG(params) {
                        var items = params.items;
                        var iconWithPadding = 16;
                        var overflowBtnWithSpace = 24;
                        var isBenchmark = function isBenchmark(d) {
                            return d.groupName === "Benchmarks";
                        };
                        var isLineChart = function isLineChart() {
                            return params.chartType === 'lineChart';
                        };
                        var isTimeSeries = function isTimeSeries() {
                            return params.chartType === 'time-series';
                        };
                        var isLineTime = function isLineTime() {
                            return isLineChart() || isTimeSeries();
                        };

                        items.enter().append("g").attr("class", function (d) {
                            return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
                        }).style("display", function (d, i) {
                            var svg = params.container.append("svg");
                            var textWidth = Utils.svg.getSVGTextWidth(svg, d.displayName);
                            svg.remove();
                            var textX = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName') + i * iconWithPadding + (iconWithPadding - 1) + overflowBtnWithSpace; //item spacing + overflow button spacing and width

                            return textWidth + textX > params.legendWidth ? "none" : "";
                        }).classed("legend-item", true);

                        items.append("rect").attr("x", function (d, i) {
                            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
                            if (i == 0) {
                                return width;
                            }
                            return width + i * iconWithPadding;
                        }).attr("y", function (d, i) {
                            return isBenchmark(d) || isLineTime() ? 4 : 0;
                        }).attr("width", 10).attr("height", function (d, i) {
                            return isBenchmark(d) || isLineTime() ? 1 : 10;
                        }).attr("fill", function (d, i) {
                            return isBenchmark(d) || isLineTime() ? "transparent" : params.colors[i % params.colors.length];
                        }).attr("fill-opacity", 0.8).attr("stroke", function (d, i) {
                            if (isLineChart()) {
                                return d.color || params.colors[i % params.colors.length];
                            }
                            if (isTimeSeries()) {
                                return d.color || params.colors[d.index % params.colors.length];
                            }
                            return isBenchmark(d) ? params.benchmarkColor : "transparent";
                        }).attr("stroke-dasharray", function (d) {
                            if (isTimeSeries()) {
                                return params.dottedLines.indexOf(d.displayName) > -1 ? "3,3" : "transparent";
                            }
                            if (params.lineStyles[d.displayName]) {
                                return "3,3";
                            }
                            return isBenchmark(d) && params.dottedBenchmark ? "3,3" : "transparent";
                        }).attr("stroke-width", "1");

                        items.append("text").attr("x", function (d, i) {
                            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
                            if (i == 0) {
                                return width + (iconWithPadding - 1);
                            }
                            return width + i * iconWithPadding + (iconWithPadding - 1);
                        }).attr("y", 10).text(function (d) {
                            return d.displayName;
                        });

                        items.exit().remove();
                    }

                    /**
                     * @method getLegendWidth
                     * Get Legend Width
                     * @param container, @param data
                     * @return {Number}
                     */
                    function getTotalItemsWidth(container, data, accessor) {
                        var svg = container.append("svg");
                        var width = Utils.svg.getTotalSVGTextWidth(svg, data, accessor);
                        svg.remove();
                        return width;
                    }

                    /**
                     * @method getNumTspan
                     * Gets number of lines text element wraps to
                     * Line returns next line y-position
                     * Time Series returns number of lines for element
                     * @param element, @param chartType
                     * @return {Number}
                     */
                    function getNumTspan(element, chartType) {
                        var numLines = 1;
                        var prevY = getElementY(element, 0);

                        if (typeof element !== 'undefined') {
                            numLines = element.childNodes[0].childNodes.length;
                            if (chartType === 'time-series') {
                                return numLines > 1 ? numLines : 1;
                            }
                        }
                        return numLines * 17 + prevY + 5;
                    }

                    /**
                     * @method getElementY
                     * Gets y attribute of elements child i
                     * @param element, @param i
                     * @return {Number}
                     */
                    function getElementY(element, i) {
                        return typeof element !== 'undefined' ? parseFloat(d3.select(element.childNodes[i]).attr("y")) : 0;
                    }

                    /**
                     * @method wrap
                     * Wraps text to multiple lines as needed according to legend width
                     * @param text, @param container
                     */
                    function wrap(text, wrapVars) {
                        var legendMaxWidth = 120;
                        var scrollbarWidth = 17;
                        var iconWithPadding = 21;
                        text.each(function () {
                            var text = d3.select(this),
                                words = text.text().split(/\s+/).reverse(),
                                word,
                                line = [],
                                lineHeight = 1,

                            // ems
                            x = text.attr("x"),
                                y = text.attr("y"),
                                tspan = text.text(null).append("tspan").attr("x", x).attr("y", y);
                            if (words.length < 2) wrapVars.names.push(word);
                            while (word = words.pop()) {
                                line.push(word);
                                tspan.text(line.join(" "));
                                var scrollbar = scrollbarPresent(wrapVars.container) ? scrollbarWidth : 0;
                                wrapVars.firstPass = scrollbarPresent(wrapVars.container);
                                if (tspan.node().getComputedTextLength() + iconWithPadding + scrollbar > legendMaxWidth && line.length > 1) {
                                    line.pop();
                                    tspan.text(line.join(" "));
                                    wrapVars.names.push(line.pop());
                                    line = [word];
                                    tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 * lineHeight + 0.25 + "em").text(word);
                                    text.attr("id", "double");
                                    wrapVars.names.push(word);
                                } else {
                                    wrapVars.names.push(line.join(" "));
                                }
                            }
                        });
                    }

                    /**
                     * @method adjustSVGHeight
                     * Sets legend svg height according to last item in data
                     * @param items
                     * @return {Number}
                     */
                    function adjustSVGHeight(params, items) {
                        var parentID = params.parentID;
                        var isTimeSeries = params.chartType === "time-series";
                        var lastElement = items[0][items[0].length - 1];
                        var lastelemIndex = isTimeSeries && params.legendShowValue ? 1 : 0;
                        var lastElementY = parseFloat(d3.select(lastElement.childNodes[lastelemIndex]).attr("y"));
                        var lastElementH = lastElement.childNodes[lastelemIndex].getBoundingClientRect().height;
                        var newLegendHeight = lastElementH + lastElementY;
                        d3.select("#svgcontainer_" + parentID).select("svg").attr("height", newLegendHeight);
                    }

                    /**
                     * @method scrollbarPresent
                     * Get Legend Height compare to chart height
                     * @param container
                     * @return {Number}
                     */
                    function scrollbarPresent(container) {
                        return parseFloat(container[0][0].children[1].style.height) <= container[0][0].children[1].getElementsByClassName("mbc-legend")[0].clientHeight;
                    }

                    /**
                    * @method setLegendWidth
                    * Get Legend Width
                    * @param container, @param data
                    * @return {Number}
                    */
                    function setLegendWidth(wrapVars) {
                        var params = wrapVars.params;
                        var parentID = params.parentID;
                        var legendMaxWidth = 120;
                        var scrollbarWidth = 17;
                        var iconWithPadding = 21;
                        var svg = params.container.append("svg");
                        var width = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + iconWithPadding; // icon and padding
                        svg.remove();
                        if (scrollbarPresent(wrapVars.params.container)) {
                            //Scrollbar space
                            width = width > legendMaxWidth - scrollbarWidth ? legendMaxWidth - scrollbarWidth : width;
                        }
                        d3.select("#svgcontainer_" + parentID).select("svg").attr("width", width);

                        if (scrollbarPresent(params.container) !== wrapVars.firstPass) {
                            addItemsSVG(params);
                        }
                    }

                    module.exports = {
                        addItemsSVG: addItemsSVG,
                        addTopItemsSVG: addTopItemsSVG
                    };

                    /***/
                },

                /***/69:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var mds_constants = __webpack_require__(7).constants;
                    var mds_space = mds_constants["space"];
                    var mds_size_icon = mds_constants["size"]["icon"];
                    var core = __webpack_require__(0);
                    var Utils = core.Utils;
                    var Classes = core.Classes;
                    var mds_constants = Utils.colors.mds_constants;
                    var drawSVG = __webpack_require__(68);
                    var icon_mds_ellipsis_circle_s = __webpack_require__(114);

                    function Legend() {}
                    /**
                     * @class Legend
                     * instantiates legend object with necessary variable and constants
                     * defaultOptions consistent across charts unless otherwise defined in specific chart
                     * @param options Contains any chart specific options declared in chart
                     */
                    Legend.prototype.invokeLegend = function (options) {
                        var canvas = this.get("canvas"),
                            _this = this;
                        options = options || {};
                        this.__OPTIONS = options;

                        var defaultOptions = {
                            container: this.get("selection").select("." + Classes.LEGEND),
                            legend: this.get("selection").select("." + Classes.LEGEND).select("." + Classes.LEGEND + "-inner"),
                            data: this.get("data"),
                            benchmark: this.get("data").get("benchmark"),
                            benchmarkColor: mds_constants["color"].black,
                            benchmarkStyle: false,
                            benchmarkSpan: "benchmark",
                            mouseover: true
                        };

                        Utils.object.copy(defaultOptions, options);
                        this._options = defaultOptions;

                        // Variables
                        this._canvas = canvas;
                        var parentClassList = this._options.container[0][0].parentElement.classList;
                        var arr = [].slice.call(parentClassList);
                        arr.forEach(function (pClass, idx) {
                            if (pClass.indexOf('mbc_') >= 0) {
                                _this.set('parentID', pClass);
                            }
                        });
                        var parentID = this.get('parentID');
                        this._container = this._options.container.attr("id", "svgcontainer_" + parentID);
                        this._data = this._options.data;
                        this._legend = this._options.legend;
                        this._benchmarkColor = this._options.benchmarkColor;
                        this._benchmarkStyle = this._options.benchmarkStyle;
                        this._benchmarkSpan = this._options.benchmarkSpan;

                        this._margin = canvas.get("margin");
                        this._legendTitle = this.get("legendTitle");
                        this._benchmarkLabel = this.get("benchmarkLabel");
                        this._legendMaxWidth = this.get("legendMaxWidth");

                        var id = "mbc-mds-popover--" + this.generateID();
                        if (this.get('popoverID') == null) {
                            _this.set('popoverID', id);
                        }
                        this._createLegend();
                    };

                    /**
                     * @method _createLegend
                     * Create legend div container
                     * Includes the title
                     */
                    Legend.prototype._createLegend = function () {
                        this._legend.remove();
                        var parentID = this.get('parentID');

                        // Adding Title
                        if (this._legendTitle) {
                            var title = this._legend.append("span").classed("mbc-legend-title", true);
                            title.html(this._legendTitle);
                        }

                        this._setLegendHeightWidth();
                        this.getDottedLines();

                        if (this._options.chart === "verticalBar" || this._options.chart === "lineChart" || this._options.chart === "time-series") {
                            var id = this.get('popoverID');
                            var iconBtn = document.getElementsByClassName('mbc-mds-popover__trigger');
                            var child = this._container[0][0].parentElement.children;
                            var arr = [].slice.call(child);
                            arr.forEach(function (div, idx) {
                                d3.select(div).attr('popoverID', id);
                            });
                            this.makeSVGContainer();
                            this.drawSVGLegend();
                            this.adjustLegendWidth(parseFloat(d3.select("#svgcontainer_" + parentID).select("svg").attr("width")));
                            if (iconBtn != null && iconBtn.length > 0) {
                                this.setPopoverPosition(id);
                            }
                        } else {
                            this._addLegendItems();
                        }

                        // removes empty elements from inner chart svg
                        // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
                        if (d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item") !== null) {
                            var arr = d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item");
                            if (typeof arr[0] !== 'undefined') {
                                arr[0].forEach(function (gElem) {
                                    if (gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                                        gElem.remove();
                                    }
                                    // for IE remove polyfill
                                    if (!gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                                        Object.defineProperty(gElem, 'remove', {
                                            configurable: true,
                                            enumerable: true,
                                            writable: true,
                                            value: function remove() {
                                                if (this.parentNode !== null) this.parentNode.removeChild(this);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    };

                    /**
                     * @method makeSVGContainer
                     * Create svg legend container
                     * Includes width and height
                     */
                    Legend.prototype.makeSVGContainer = function () {
                        var legendWidth = this.get("legendWidth");
                        var parentID = this.get('parentID');
                        var textWidth = this._container.classed(Classes.LEGEND + "-right") ? legendWidth : this._container[0][0].offsetWidth - 20; // padding left + icon margin + icon width vertical
                        var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

                        if (legendHeight < this._legend[0][0].scrollHeight) {
                            //Scrollbar space
                            textWidth += 12;
                        }

                        this.set("legendWidth", textWidth);
                        var svgHeight = legendHeight > this._data.length * 22 + 5 ? legendHeight : this._data.length * 22 + 5;
                        var numHeight = this._container.classed(Classes.LEGEND + "-right") ? svgHeight : 20; // 17 line height + 5 padding
                        var svg = d3.select("#svgcontainer_" + parentID).append("svg").attr("role", "legend").attr("class", "mbc-legend").attr("height", numHeight);
                        this.set("legendSVG", svg);
                    };

                    Legend.prototype.getDottedLines = function () {
                        var arr = [].slice.call(this._data);
                        var dotted = this.get("dottedLineNames");
                        var lineStyles = {};
                        arr.forEach(function (data, idx) {
                            if (dotted) {
                                var group = data.groupName;
                                var name = data.displayName;
                                var dottedLineNames = !(group === "benchmark") ? dotted[group] : null;
                                lineStyles[name] = dottedLineNames;
                            }
                        });
                        this.set('lineStyles', lineStyles);
                    };

                    /**
                     * @method drawSVGLegend
                     * Adds legend items to svg container
                     * Includes right and top positioning
                     */
                    Legend.prototype.drawSVGLegend = function () {
                        var y1Axis = this.get("axes").axis("y1");
                        this._clearPopoversOverlays();
                        if (y1Axis) {
                            var legendSVG = this.get("legendSVG");
                            var legendWidth = this.get("legendWidth");
                            var isTimeSeries = this._options.chart === "time-series";
                            if (legendSVG[0][0].childNodes.length < 1) {
                                this.set("legendfrontGroup", legendSVG.append("g").classed(Classes.LEGEND + "-inner", true));
                            }
                            if (isTimeSeries) {
                                this._data = this._sortLegendData();
                            }
                            var endPadding = legendWidth - 6; // SVG specific '7' - padding + borders
                            var innerGroup = this.get("legendfrontGroup");
                            var items = innerGroup.selectAll(".legend-item").data(this._data);
                            var benchmarkColor = this.get("benchmarksColor");
                            var dottedBenchmark = this.get("dottedBenchmarks");
                            var dottedLines = this.get('dottedLines');
                            var colors = this.get("colors");
                            var legendWidth = this.get("legendWidth");
                            var legendValuesFormat = this.get("legendValuesFormat");
                            var legendShowValue = this.get("showLegendValues");
                            var parentID = this.get('parentID');
                            var lineStyles = this.get('lineStyles');
                            var chartType = this._options.chart;
                            var legendContainer = typeof container !== "undefined" ? container : this.get("selection");
                            var params = {
                                items: items,
                                endPadding: endPadding,
                                benchmarkColor: benchmarkColor,
                                dottedBenchmark: dottedBenchmark,
                                dottedLines: dottedLines,
                                colors: colors,
                                legendWidth: legendWidth,
                                legendValuesFormat: legendValuesFormat,
                                legendShowValue: legendShowValue,
                                container: legendContainer,
                                parentID: parentID,
                                chartType: chartType,
                                lineStyles: lineStyles
                            };
                            if (this._container.classed(Classes.LEGEND + "-right")) {
                                drawSVG.addItemsSVG(params);
                                var id = this.get('popoverID');
                                if (document.getElementById(id) !== null) {
                                    document.getElementById(id).parentElement.classList.remove('mbc-mds-popover__wrapper--visible');
                                    if (document.querySelector('[data-mbc-mds-popover="' + id + '"]') !== null) {
                                        document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'false');
                                    }
                                }
                            } else {
                                drawSVG.addTopItemsSVG(params);
                                this.createLegendPopoverSVG();
                            }
                        }
                    };

                    /**
                     * @method _clearPopoverWrapperOverlays
                     * Removes existed popover wrappers and overlays
                     */
                    Legend.prototype._clearPopoversOverlays = function () {
                        if (document.getElementsByClassName('mbc-mds-popover__overlay').length != 0) {
                            var overlays = document.getElementsByClassName('mbc-mds-popover__overlay');
                            var arr = [].slice.call(overlays);
                            arr.forEach(function (overlay) {
                                overlay.parentElement.removeChild(overlay);
                            });
                        }
                        if (document.getElementsByClassName('mbc-mds-popover').length != 0) {
                            var popovers = document.getElementsByClassName('mbc-mds-popover');
                            var arr = [].slice.call(popovers);
                            arr.forEach(function (popover) {
                                popover.parentElement.removeChild(popover);
                            });
                        }
                    };

                    /**
                     * @method _addLegendItems
                     * Add Items to legend container both benchmark and data
                     * sets identifier and styles for items
                     * maintains current chart specific css
                     */
                    Legend.prototype._addLegendItems = function (container) {
                        var _this = this;
                        var enter;
                        var isTimeSeries = this._options.chart === "time-series";
                        var mainDiv = container !== null && typeof container !== 'undefined' ? container : this._legend;

                        if (this.get("benchmark") && this._options.benchmark) {
                            this._data = this.get("data").get("benchmark").concat(this._data);
                        }

                        if (isTimeSeries) {
                            this._data = this._sortLegendData();
                        }

                        var isLineBenchmark = function isLineBenchmark(d) {
                            return _this._options.chart === "verticalBar" && d.index === -1;
                        };

                        var isBenchmarkFirst = function isBenchmarkFirst(d) {
                            return d.index === -1 && _this.get("_showBenchmark");
                        };

                        var lineStyle = function lineStyle(d) {
                            var dottedLines = _this.get('dottedLines');
                            var color = _this._color(d.index);
                            var lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
                            var style = lineIsDotted ? "2px dotted " + color : "2px solid " + color;
                            return style;
                        };
                        enter = d3.select(mainDiv[0][0]).selectAll("div").data(this._data).enter().append("div").attr("class", function (d) {
                            return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
                        }).classed("mbc-chart-legend-item", true);
                        if (this._options.mouseover) {
                            enter.on("mouseover", function (d) {
                                isBenchmarkFirst(d) ? _this.legendBenchmarkMouseover(d) : _this.legendMouseover(d);
                            }).on("mouseout", function (d) {
                                isBenchmarkFirst(d) ? _this.legendBenchmarkMouseout(d) : _this.legendMouseout(d);
                            });
                        }
                        if (isTimeSeries && this._container.classed(Classes.LEGEND + "-right")) {
                            var legendValuesFormat = Utils.string.convertDashToEnDash(this.get("legendValuesFormat"));

                            enter.append("p").attr("class", Classes.LEGEND_ITEM + "__label--right").text(function (d) {
                                return d.displayName;
                            }).style("border-top", function (d) {
                                return lineStyle(d);
                            }.bind(this));

                            if (this.get("showLegendValues")) {
                                enter.append("p").attr("class", Classes.LEGEND_ITEM + "__value--right").text(function (d) {
                                    return legendValuesFormat(d.value);
                                });
                            }
                        } else {

                            enter.append("span").classed(this._benchmarkSpan, function (d) {
                                return isBenchmarkFirst(d) || isLineBenchmark(d);
                            }).classed(this._benchmarkSpan + "--dotted", function (d) {
                                return isLineBenchmark(d) && this._benchmarkStyle;
                            }).classed(Classes.LEGEND_ITEM + "__key", function (d) {
                                return isTimeSeries;
                            }).classed("square", function (d) {
                                return _this._options.chart === "verticalBar" && !isLineBenchmark(d);
                            }).style("background-color", function (d, i) {
                                if (isTimeSeries) {
                                    return 'transparent';
                                }
                                if (isLineBenchmark(d)) {
                                    return this._benchmarkStyle ? 'transparent' : this._benchmarkColor;
                                }
                                if (isBenchmarkFirst(d)) {
                                    return this._benchmarkColor;
                                }
                                if (this._isScatterPlot()) {
                                    return this._color(d.groupIndex);
                                }
                                return !this._isDottedLine(d.groupName, d.displayName) ? this._color(i) : null;
                            }.bind(this)).style("border-top", function (d, i) {
                                if (isLineBenchmark(d) && this._benchmarkStyle) {
                                    return "2px dotted " + this._benchmarkColor;
                                }
                                return this._isDottedLine(d.groupName, d.displayName) ? "2px dotted " + this._color(i) : null;
                            }.bind(this)).style("border-bottom", function (d) {
                                if (isTimeSeries) {
                                    return lineStyle(d);
                                }
                                return 'transparent';
                            }.bind(this)).style("opacity", this.get("opacity"));

                            enter.append("p").text(function (d) {
                                return isBenchmarkFirst(d) && d.index === -1 ? _this._benchmarkLabel : d.displayName;
                            });
                        }
                    };

                    /**
                     * @method generateID
                     * Returns 5 digit id for legend popover created
                     */
                    Legend.prototype.generateID = function () {
                        return Math.floor(Math.random() * 90000) + 10000;
                    };

                    /**
                     * @method addPopoverContent
                     * Sets title and adds legend items to popover
                     * @param id ID of popover generated at instantiation
                     */
                    Legend.prototype.addPopoverContent = function (id) {
                        var popOverElem = document.getElementById(id);
                        if (popOverElem.getElementsByClassName("mbc-mds-popover__header").length !== 0) {
                            var currentHeader = popOverElem.getElementsByClassName("mbc-mds-popover__header");
                            currentHeader[0].parentNode.removeChild(currentHeader[0]);
                        }
                        if (popOverElem.getElementsByClassName("mbc-mds-popover__content").length !== 0) {
                            var oldContent = popOverElem.getElementsByClassName("mbc-mds-popover__content");
                            oldContent[0].parentNode.removeChild(oldContent[0]);
                        }
                        var headerElem = d3.select(popOverElem).append('header').attr('class', 'mbc-mds-popover__header');
                        var titleElem = headerElem.append('h2').attr('class', 'mbc-mds-popover__title');
                        titleElem[0][0].innerHTML = "Legend";

                        var contentElem = d3.select(popOverElem).append('div').attr('class', 'mbc-mds-popover__content').style('overflow', 'auto');
                        var chartInners = document.getElementsByClassName('mbc-chart-inner');
                        var chartTop = document.getElementsByClassName('mbc-chart-inner')[0].getBoundingClientRect().top;
                        var arr = [].slice.call(chartInners);
                        arr.forEach(function (inner) {
                            if (d3.select(inner).attr('popoverID') == id) {
                                chartTop = inner.getBoundingClientRect().top;
                            }
                        });
                        var legendMax = window.innerHeight - chartTop - headerElem[0][0].clientHeight;
                        var calcMax = legendMax - 120 < 120 ? 120 : legendMax - 120;
                        var maxHeight = calcMax > 250 ? 250 : calcMax;
                        contentElem[0][0].style.maxHeight = maxHeight + "px"; //minus container bottom padding and title
                        this._addLegendItems(contentElem);
                    };

                    /**
                     * @method createOverlayDismiss
                     * Adds popover overlay for dismissal
                     * @param parentID ID of popover chart parent to get popover wrapper
                     */
                    Legend.prototype.createOverlayDismiss = function (id) {
                        var popoverParentSelector = this.get('legendPopoverParentElement');
                        var popoverParent = document.querySelector(popoverParentSelector);
                        if (popoverParent === null) {
                            console.error("Chart parameter legendPopoverParentElement must be a class or id selector, invalid value is '%s'", popoverParentSelector);
                        }
                        var overLay = document.createElement('div');
                        overLay.setAttribute('class', "mbc-mds-popover__overlay mbc-overlay_" + id);
                        overLay.style.width = '100%';
                        overLay.style.height = '100%';
                        overLay.style.display = 'block';
                        overLay.addEventListener('click', function () {
                            var popovers = document.querySelectorAll('.mbc-mds-popover');
                            for (var m = 0; m < popovers.length; m++) {
                                // Close currently opened popovers outside of current selected
                                popovers[m].classList.remove('mbc-legend-popover--visible');
                                popoverParent.removeChild(popovers[m]);
                                var arr = [].slice.call(popovers[m].classList);
                                arr.forEach(function (popOverClass) {
                                    if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                                        var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                                        if (document.getElementsByClassName(chartClass)[0].children[0].classList.contains(Classes.LEGEND + "-top")) {
                                            document.querySelector('[data-mbc-mds-popover="' + popovers[m].id + '"]').setAttribute('aria-expanded', 'false');
                                        }
                                    }
                                });
                            }
                            popoverParent.removeChild(overLay);
                        }, false);
                        popoverParent.appendChild(overLay);
                    };

                    /**
                     * @method createLegendPopoverSVG
                     * Build MDS popover using MDS icon see docs
                     * http://designsystem.morningstar.com/components/popovers.html#css-class-references
                     * http://designsystem.morningstar.com/visual-language/iconography.html
                     */
                    Legend.prototype.createLegendPopoverSVG = function () {
                        var id = this.get('popoverID');
                        var parentID = this.get('parentID');
                        var _this = this;
                        var popoverParentSelector = this.get('legendPopoverParentElement');
                        var popoverParent = document.querySelector(popoverParentSelector);
                        this._container.style('overflow', 'visible');
                        this._container.style('position', 'relative');

                        var buttonDiv = this._container.append('button').attr('class', "mbc-mds-button mbc-mds-button--small mbc-mds-popover__trigger mbc-mds-button--icon-only").attr('type', 'button').attr('data-mbc-mds-popover', id).style('top', '0px').style('right', '6px').style('position', 'absolute').style('visibility', 'hidden').attr('aria-controls', id).attr('aria-haspopup', "true").attr('aria-expanded', 'false');
                        var btnImage = buttonDiv.append("svg").attr("class", "mbc-mds-icon--s mbc-mds-button__icon");
                        btnImage.attr('viewBox', '0 0 1500 1500').append('path').attr('d', 'M698.5 798.5h100v-100h-100v100zm-300 0h100v-100h-100v100zm350-800c-410 0-750 340-750 750s340 750 750 750 750-340 750-750-340-750-750-750zm0 1400c-360 0-650-290-650-650s290-650 650-650 650 290 650 650-290 650-650 650zm250-600h100v-100h-100v100z'); // draws ellipses icon from morningstar-design-system/dist/src/icons/ellipsis-circle--s.svg

                        if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
                            document.querySelector('[data-mbc-mds-popover="' + id + '"]').addEventListener('click', function () {
                                var popOver = document.getElementById(id);
                                if (popOver === null) {
                                    popOver = document.createElement('div');
                                    popOver.setAttribute('id', "" + id);
                                    popOver.setAttribute('class', "mbc-mds-popover mbc-mds-popover--width-200px mbc-mds-legend-popover_" + parentID);
                                    popOver.setAttribute('role', 'tooltip');
                                    popoverParent.appendChild(popOver);
                                }

                                _this.addPopoverContent(id);
                                var popOverElem = document.getElementById(id);
                                var popovers = document.querySelectorAll('.mbc-mds-popover');
                                for (var m = 0; m < popovers.length; m++) {
                                    // Close currently opened popovers outside of current selected
                                    if (!popovers[m].isSameNode(popOverElem)) {
                                        popovers[m].classList.remove('mbc-legend-popover--visible');
                                        document.getElementsByClassName("" + parentID)[0].getElementsByClassName('mbc-mds-button--icon-only')[0].setAttribute('aria-expanded', 'false');
                                    }
                                }
                                var setPopover = _this.setPopoverPosition(id);
                                setPopover.setPosition(popOverElem);
                                popOverElem.classList.add('mbc-legend-popover--visible'); // Open currently selected popover
                                document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'true');
                                _this.createOverlayDismiss(id);
                            });
                        }
                        this.showOverflowBtn(id);
                    };

                    /**
                     * @method showOverflowBtn
                     * Sets MDS popover wrapper to visible which shows only button in unselected state
                     */
                    Legend.prototype.showOverflowBtn = function (id) {
                        var parentID = this.get('parentID');
                        var chartContainerElem = document.getElementsByClassName("" + parentID);
                        var currentInner = chartContainerElem[0].getElementsByClassName('mbc-chart-legend-inner');

                        if (currentInner[0].lastElementChild.style.display === 'none') {
                            document.querySelector('[data-mbc-mds-popover="' + id + '"]').style.visibility = 'visible';
                        }
                    };

                    /**
                     * @method setPopoverPosition
                     * Sets position of popovers on window scroll
                     * Based on current overflow btn position and chart container position in window
                     * @param id ID of popover generated at instantiation
                     */
                    Legend.prototype.setPopoverPosition = function (id) {
                        var _this = this;
                        var parentID = this.get('parentID');
                        var popoverWidth = 200;
                        var currentPopover = document.getElementById(id);
                        var popovers = document.querySelectorAll('.mbc-mds-popover');
                        var chartContainerElem = document.getElementsByClassName("" + parentID);

                        var iconBtns = document.querySelectorAll('.mbc-mds-popover__trigger');
                        if (iconBtns.length > 0) {
                            setPosition(currentPopover);
                            window.onscroll = function () {
                                var arr = [].slice.call(popovers);
                                arr.forEach(function (popOverElem) {
                                    setPosition(popOverElem);
                                    if (!(popOverElem.getBoundingClientRect().top >= 0 || popOverElem.getBoundingClientRect().bottom >= 0) || !(popOverElem.getBoundingClientRect().left >= 0 || popOverElem.getBoundingClientRect().right >= 0)) {
                                        //if out of viewport then remove popover and overlay
                                        var popoverParentSelector = _this.get('legendPopoverParentElement');
                                        var popoverParent = document.querySelector(popoverParentSelector);
                                        var overLay = document.querySelector(".mbc-overlay_" + popOverElem.id);
                                        var popoverBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                                        popOverElem.classList.remove('mbc-legend-popover--visible');
                                        popoverBtn.blur();
                                        popoverParent.removeChild(popOverElem);
                                        popoverParent.removeChild(overLay);
                                        popoverBtn.setAttribute('aria-expanded', 'false');
                                    }
                                });
                            };
                        }

                        function setPosition(popOverElem) {
                            if (typeof popOverElem !== 'undefined' && popOverElem !== null) {
                                var chartElem = chartContainerElem[0];
                                var arr = [].slice.call(popOverElem.classList);
                                arr.forEach(function (popOverClass) {
                                    if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                                        var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                                        chartElem = document.querySelector("." + chartClass);
                                    }
                                });
                                if (popOverElem !== null && chartElem.children[0].classList.contains(Classes.LEGEND + "-top")) {
                                    removePopoverPosition(popOverElem);

                                    var iconBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                                    var bodyRect = document.body.getBoundingClientRect(),
                                        btnRect = iconBtn.getBoundingClientRect(),
                                        offsetTop = btnRect.top - bodyRect.top,
                                        offsetLeft = btnRect.left - bodyRect.left,
                                        offsetLegendLeft = iconBtn.parentElement.getBoundingClientRect().left - bodyRect.left;
                                    var popOverHeight = popOverElem.getBoundingClientRect().height;

                                    if (window.innerWidth - iconBtn.getBoundingClientRect().right >= popoverWidth) {
                                        //room on right of icon
                                        popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + "px";
                                        popOverElem.style.left = offsetLeft + iconBtn.getBoundingClientRect().width + "px";
                                        popOverElem.classList.add('mbc-mds-popover--right-bottom');
                                        return;
                                    }

                                    if (iconBtn.getBoundingClientRect().top >= popOverElem.getBoundingClientRect().height) {
                                        //room top of icon
                                        popOverElem.style.top = offsetTop - popOverHeight - iconBtn.getBoundingClientRect().height / 2 + "px";
                                        popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                                        popOverElem.style.bottom = 'auto';
                                        popOverElem.classList.add('mbc-mds-popover--top-left');
                                        return;
                                    }

                                    if (iconBtn.parentElement.getBoundingClientRect().left >= popoverWidth) {
                                        //container left is >= the width of popover 200 place left of chart
                                        popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + "px";
                                        popOverElem.style.left = offsetLegendLeft - popoverWidth - 10 + "px";
                                        popOverElem.classList.add('mbc-mds-popover--left-bottom');
                                        return;
                                    }

                                    popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height + "px";
                                    popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                                    popOverElem.classList.add('mbc-mds-popover--bottom-left');
                                }
                            }
                        }
                        return {
                            setPosition: setPosition
                        };

                        function removePopoverPosition(popOverElem) {
                            popOverElem.removeAttribute("style");
                            if (popOverElem.classList.contains('mbc-mds-popover--top-left')) {
                                popOverElem.classList.remove('mbc-mds-popover--top-left');
                            }
                            if (popOverElem.classList.contains('mbc-mds-popover--bottom-left')) {
                                popOverElem.classList.remove('mbc-mds-popover--bottom-left');
                            }
                            if (popOverElem.classList.contains('mbc-mds-popover--right-bottom')) {
                                popOverElem.classList.remove('mbc-mds-popover--right-bottom');
                            }
                            if (popOverElem.classList.contains('mbc-mds-popover--left-bottom')) {
                                popOverElem.classList.remove('mbc-mds-popover--left-bottom');
                            }
                        }
                    };

                    /**
                     * @method getLegendWidth
                     * Get Legend Width
                     * @param container, @param data
                     * @return {Number}
                     */
                    Legend.prototype.getLegendWidth = function (container, data) {
                        var svg = container.append("svg");
                        var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
                        svg.remove();
                        return width;
                    };

                    Legend.prototype.getItemsWidth = function (container, data) {
                        var svg = container.append("svg");
                        var width = Utils.svg.getTotalSVGTextWidth(svg, data, "displayName");
                        svg.remove();
                        return width;
                    };

                    /**
                     * @method _setLegendHeightWidth
                     * Set Legend width/height
                     * Set Chart Container Width/Height
                     * based on 'right' or 'top' attribute of legend container
                     */
                    Legend.prototype._setLegendHeightWidth = function () {
                        var chartContainer = this._canvas.get("container");
                        var textWidth = this.getLegendWidth(this._container, this._data) + 15 + 6; // padding left + icon margin + icon width
                        var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule
                        var marginLeft = 0;

                        this.set("legendHeight", legendHeight);
                        this.adjustLegendWidth(textWidth);

                        if (!this._container.classed(Classes.LEGEND + "-right")) {
                            //When legend is placed at top of chart
                            legendHeight = this._container[0][0].offsetHeight;
                            marginLeft = this.get("yAxisOrient") === "left" ? this.get("yAxesLabelWidth") + this.get("yAxesLabelPadding") : 0;

                            this._container.style("margin-left", marginLeft + "px");

                            if (!this._isScatterPlot(this._data[0].groupName) && this._data[0].groupName !== "benchmark") {
                                this._container.style("margin-left", this.get("yAxesLabelWidth") + "px");
                            } else {
                                d3.select(chartContainer).style("height", "calc(100% - " + legendHeight + "px)");
                            }
                        }

                        this.set("legendContainer", this._container);
                    };

                    /**
                     * @method adjustLegendHeight
                     * @desc adjusts the legend height after the chart has been rendered
                     * used within time-series chart currently
                     */
                    Legend.prototype.adjustLegendHeight = function () {
                        var container = this.get("selection").selectAll("." + Classes.LEGEND);
                        var canvas = this.get("canvas");

                        if (container.classed(Classes.LEGEND + "-right")) {
                            container.style({
                                height: canvas.height() + "px"
                            });
                        }
                    };

                    /**
                     * @method adjustLegendWidth
                     * @desc adjusts the legend height after the chart has been rendered
                     * used within time-series chart currently
                     */
                    Legend.prototype.adjustLegendWidth = function (textWidth) {
                        var canvas = this._canvas;
                        var parentID = this.get('parentID');
                        var chartContainer = canvas.get("container");
                        var isTimeSeries = this._options.chart === "time-series";
                        var scrollbarWithPadding = 17;
                        var iconWidth = 40;
                        var legendHeight = typeof this._container[0][0].children[0] !== 'undefined' ? this._container[0][0].children[0].clientHeight : this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule
                        if (this._container.classed(Classes.LEGEND + "-right")) {
                            var legendMaxWidth = this._legendMaxWidth;
                            if (legendHeight > this._container[0][0].offsetHeight) {
                                //Scrollbar space
                                textWidth = textWidth + scrollbarWithPadding;
                                if (isTimeSeries) {
                                    d3.select(this._container[0][0].children[0]).attr('width', textWidth - 2 + 'px');
                                } //show item line full width of container
                            }
                            textWidth = textWidth > legendMaxWidth ? legendMaxWidth : textWidth;

                            this._legend.style("height", legendHeight + "px");
                            this._container.style("width", textWidth + "px");
                            var chartWidth = this.get("selection")[0][0].offsetWidth - textWidth - 13;
                            d3.select(chartContainer).style("width", chartWidth + "px");
                            this.set("legendWidth", textWidth);

                            if (!this._isScatterPlot() && this._data[0].groupName !== "benchmark") {
                                this._container.style({
                                    height: canvas.height() - 5 + "px", //SVG Specific
                                    width: textWidth + "px",
                                    "margin-top": canvas.get("margin").top + "px" //SVG Specific
                                });

                                chartContainer = d3.select(canvas.get("container"));
                                var chartWidth = chartContainer.node().clientWidth;

                                //calc was not working properly on IE 11, set width based on client instead
                                chartContainer.style("width", "calc(100% - " + textWidth + "px)");
                            }
                        } else {
                            chartContainer = d3.select(canvas.get("container"));
                            var chartWidth = chartContainer.node().clientWidth;
                            d3.select("#svgcontainer_" + parentID).select("svg").attr("width", chartWidth - iconWidth - 8); //overflow button - medium space
                        }
                    };

                    /**
                      * @method _color
                      * Returns the index *n* color from the *colors* attribute array
                      * @param {Number} index Index of color to return
                      * scatterplot uses plot colors different array than colors
                      * @return {Array}
                      */
                    Legend.prototype._color = function (index) {
                        var plotColors;
                        var colors = this.get("colors");
                        if (this.get("plotColors")) {
                            if (this.get("plotColors").length === 0) {
                                plotColors = [colors[0], colors[2]];
                            }
                            plotColors = plotColors.concat(colors.slice(3));
                            return plotColors[index % colors.length];
                        }
                        return colors[index % colors.length];
                    };

                    /**
                      * @method _isDottedLine
                      * Returns whether current key is dotted line
                      * @param {String} group Chart group set
                      * @param {String} name Current data value name
                      * when adding legend item determines whether a {background-color, dotted line, or border} needed
                      * @return {Boolean}
                      */
                    Legend.prototype._isDottedLine = function (group, name) {
                        if (this.get("dottedLineNames")) {
                            var dottedLineNames = !(this._isScatterPlot(group) || group === "benchmark") ? this.get("dottedLineNames")[group] : null;
                            if (dottedLineNames instanceof Array) {
                                return dottedLineNames.indexOf(name) > -1;
                            } else {
                                return dottedLineNames;
                            }
                        }
                        return group === "benchmark" && this._benchmarkStyle;
                    };

                    /**
                      * @method _isScatterPlot
                      * Returns whether chart option is scatterplot
                      * @return {Boolean}
                      */
                    Legend.prototype._isScatterPlot = function () {
                        return this._options.chart === "scatterplot";
                    };

                    /**
                      * @method _isBenchmark
                      * Returns whether current data is in benchmark group
                      * @return {Boolean}
                      */
                    Legend.prototype._isBenchmark = function (groupName) {
                        return groupName === "benchmark";
                    };

                    /**
                     * @method sortLegendData
                     * @param {Array} groups
                     * @desc Takes an array of group names and creates a new data object sorted in descending order by value
                     * @return {Array} sortedArray
                     */
                    Legend.prototype._sortLegendData = function () {
                        var dataManager = this.get("data");
                        var sortedArr = [];

                        var _this = this;
                        var addLegendSet = function addLegendSet(group) {
                            group.forEach(function (dataset) {
                                var value = _this.getValidEndValue(dataset.series);
                                var displayName = dataset.displayName;
                                var index = dataset.index;
                                sortedArr.push({ value: value, displayName: displayName, index: index });
                            });
                        };

                        var y1DomainDataset = this.get("y1DomainDataset");
                        var groups = [y1DomainDataset];
                        if (this.get("y2")) {
                            var y2DomainDataset = this.get("y2DomainDataset");
                            groups = groups.concat(y2DomainDataset);
                        }

                        groups.forEach(function (name) {
                            addLegendSet(dataManager.get(name));
                        });

                        // sort legend items by the end value of series line
                        sortedArr = this.sortDataByEndValue(sortedArr);

                        return sortedArr;
                    };

                    /**
                     * Mouse Listeners
                     */
                    Legend.prototype.legendFocusIn = function (group) {
                        this.get("legendContainer").selectAll("." + Classes.LEGEND_ITEM).filter(function () {
                            return !d3.select(this).classed(group);
                        }).classed("unfocused", true);
                    };

                    Legend.prototype.legendFocusOut = function () {
                        this.get("legendContainer").selectAll("." + Classes.LEGEND_ITEM).classed("unfocused", false);
                    };

                    Legend.prototype.legendMouseover = function (d) {
                        var group = Utils.string.dashify(d.name);
                        var canvas = this.get("canvas");
                        canvas.layer("chart-layer").selectAll("g.dot").filter(function () {
                            return !d3.select(this).classed(group);
                        }).classed({
                            unfocused: true,
                            less: true
                        });
                        canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
                            unfocused: true
                        });
                        this.legendFocusIn(group);
                    };

                    Legend.prototype.legendMouseout = function () {
                        var canvas = this.get("canvas");
                        canvas.layer("chart-layer").selectAll("g.dot").classed({
                            unfocused: false,
                            less: false
                        });
                        canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
                            unfocused: false
                        });
                        this.legendFocusOut();
                    };

                    Legend.prototype.getLegendWidth = function (container, data) {
                        var svg = container.append("svg");
                        var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
                        svg.remove();
                        return width;
                    };

                    Legend.prototype.legendBenchmarkMouseover = function (d) {
                        var canvas = this.get("canvas");
                        canvas.layer("chart-layer").selectAll("g.dot").classed({
                            unfocused: true,
                            less: true
                        });
                        canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
                            focused: true
                        });
                        this.legendFocusIn("benchmark");
                    };

                    Legend.prototype.legendBenchmarkMouseout = function () {
                        var canvas = this.get("canvas");
                        canvas.layer("chart-layer").selectAll("g.dot").classed({
                            unfocused: false,
                            less: false
                        });
                        canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
                            focused: false
                        });
                        this.legendFocusOut();
                    };

                    module.exports = Legend;

                    /***/
                },

                /***/7:
                /***/function _(module, exports) {

                    module.exports = { "constants": { "color": { "white": "#ffffff", "black": "#000000", "neutral": { "12": "#1e1e1e", "20": "#333333", "37": "#5e5e5e", "50": "#808080", "67": "#ababab", "80": "#cccccc", "90": "#e5e5e5", "95": "#f2f2f2" }, "blue": { "23": "#004376", "32": "#005ba1", "36": "#006fba", "38": "#1f55a5", "41": "#0077cf", "44": "#008dde" }, "green": { "34": "#00af41" }, "dark-green": { "34": "#518428" }, "teal": { "19": "#005f5f" }, "violet": { "46": "#6a4c9e" }, "cyan": { "44": "#00a8e1" }, "maroon": { "32": "#a50032" }, "red": { "50": "#ff0000" }, "yellow": { "48": "#f5c400" }, "orange": { "54": "#ef7622" }, "light-red": { "46": "#e60546" }, "dark-violet": { "32": "#7d256f" }, "dark-yellow": { "47": "#c19c31" }, "aqua": { "37": "#00beaf" }, "bright-orange": { "50": "#ff3c00" }, "light-green": { "50": "#89bd40" } }, "brand": { "blue": "#1f55a5", "cyan": "#00a8e1" }, "background-color": { "default": "#ffffff", "light": "#f2f2f2", "dark": "#1e1e1e", "black": "#000000", "alternative-row": { "default": "#e5e5e5", "on-light": "#e5e5e5", "on-dark": "#333333" }, "feedback": { "error": "#ff0000", "warning": "#f5c400" } }, "text-color": { "primary": { "default": "#1e1e1e", "on-light": "#1e1e1e", "on-dark": "#ffffff" }, "secondary": { "default": "#5e5e5e", "on-light": "#5e5e5e", "on-dark": "#ababab" }, "link": { "default": "#006fba", "on-light": "#006fba", "on-dark": "#008dde" }, "error": { "default": "#ff0000", "on-light": "#ff0000", "on-dark": "#ff0000" } }, "interactive-color": { "primary": { "default": "#0077cf", "hover": "#005ba1", "focus": "#005ba1", "active": "#004376" }, "secondary": { "primary": "transparent", "hover": "#5e5e5e", "focus": "#5e5e5e", "active": { "on-light": "#333333", "on-dark": "#e5e5e5" } }, "disabled": { "on-light": "#808080", "on-dark": "#ababab" } }, "visualization-color": { "asset-allocation": { "local-stocks": "#1f55a5", "non-local-stocks": "#8faad2", "stocks": "#1f55a5", "real-estate": "#a50032", "other": "#f5c400", "cash": "#518428", "bonds": "#ef7622", "not-classified": "#e5e5e5" }, "correlation": { "positive": "#1f55a5", "negative": "#ef7622" }, "sector": { "cyclical": "#ef7622", "sensitive": "#1f55a5", "defensive": "#518428" }, "sustainability": "#1f55a5", "valuation": { "under": "#00a8e1", "fair": "#e5efef", "over": "#ef7622" }, "performance": { "positive": "#00af41", "neutral-text": "#5e5e5e", "neutral-chart": "#cccccc", "negative": "#ff0000" } }, "chart-color": { "1": "#1f55a5", "2": "#a50032", "3": "#f5c400", "4": "#518428", "5": "#00a8e1", "6": "#6a4c9e", "7": "#ef7622", "8": "#005f5f", "9": "#00af41", "10": "#e60546", "11": "#7d256f", "12": "#c19c31", "13": "#00beaf", "14": "#ff3c00", "15": "#89bd40" }, "feedback-color": { "info": "#f2f2f2", "error": "#ff0000", "error-background": "#ffe5e5", "warning": "#f5c400", "warning-background": "#fef9e5", "success": "#00af41", "success-background": "#e5f7eb" }, "font": { "family": { "sans-serif": "'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif", "monospace": "'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace" }, "weight": { "thin": 200, "light": 300, "regular": 400, "bold": 600 }, "size": { "xs": "10px", "s": "14px", "m": "16px", "l": "20px", "base": "16px", "default": "16px", "heading-level-1": "45px", "heading-level-2": "32px", "heading-level-3": "28px", "heading-level-4": "23px", "heading-level-5": "20px", "heading-level-6": "18px", "code": "12px" }, "line-height": { "headings": 1.2, "body": 1.375 } }, "border": { "separator": { "default": "solid 1px #e5e5e5", "on-light": "solid 1px #cccccc", "on-dark": "solid 1px #333333", "on-title": "solid 2px #333333", "color-on-light": "#cccccc", "color-on-dark": "#333333" }, "control": { "default": "solid 1px #808080", "color": "#808080" }, "container": { "default": "solid 1px #e5e5e5", "color-default": "#e5e5e5" }, "disabled": "solid 1px #808080", "radius": { "panel": "12px", "pill": "24px", "round": "50%", "s": "2px" } }, "size": { "icon": { "s": "15px", "m": "23px" } }, "space": { "xs": "4px", "s": "6px", "m": "8px", "l": "12px", "xl": "16px", "quarter-x": "2px", "half-x": "4px", "three-quarter-x": "6px", "1-x": "8px", "1-and-a-half-x": "12px", "2-x": "16px", "3-x": "24px", "4-x": "32px", "8-x": "64px", "inset": { "xs": "4px", "s": "6px", "m": "8px", "l": "12px", "xl": "16px", "quarter-x": "2px", "half-x": "4px", "three-quarter-x": "6px", "1-x": "8px", "1-and-a-half-x": "12px", "2-x": "16px", "3-x": "24px", "4-x": "32px", "8-x": "64px", "stretch": { "s": "6px 12px", "m": "8px 16px", "l": "12px 24px" } }, "inline-left": { "xs": "0 4px 0 0", "s": "0 6px 0 0", "m": "0 8px 0 0", "l": "0 12px 0 0", "xl": "0 16px 0 0", "half-x": "0 4px 0 0", "three-quarter-x": "0 6px 0 0", "1-x": "0 8px 0 0", "1-and-a-half-x": "0 12px 0 0", "2-x": "0 16px 0 0" }, "inline-right": { "xs": "0 0 0 4px", "s": "0 0 0 6px", "m": "0 0 0 8px", "l": "0 0 0 12px", "xl": "0 0 0 16px", "half-x": "0 0 0 4px", "three-quarter-x": "0 0 0 6px", "1-x": "0 0 0 8px", "1-and-a-half-x": "0 0 0 12px", "2-x": "0 0 0 16px" }, "stack": { "s": "0 0 6px", "m": "0 0 8px", "l": "0 0 12px", "xl": "0 0 16px", "quarter-x": "0 0 2px", "half-x": "0 0 4px", "three-quarter-x": "0 0 6px", "1-x": "0 0 8px", "1-and-a-half-x": "0 0 12px", "2-x": "0 0 16px", "3-x": "0 0 24px", "4-x": "0 0 32px", "8-x": "0 0 64px" } }, "transition": { "color": { "link": "color, 300ms" } }, "opacity": { "disabled": ".4", "overlay": ".5" }, "box-shadow": { "drop": "0 2px 4px 0 rgba(0, 0, 0, .08)", "focus": "0 0 4px 2px rgba(#0077cf, .8)" }, "z-index": { "low": 1, "sticky": 100, "modal-overlay": 800, "modal-content": 810, "top-of-the-world": 900 }, "breakpoint": { "navigation": { "on-canvas-nav": "768px", "wide": "1024px" } }, "masthead": { "height": "50px", "height-tall": "70px" }, "site-navigation": { "height": "50px", "vertical-width": "230px" } }, "shared": [{ "utils": true }, { "color": true }, { "fonts": true }, { "accessibility": true }, { "animation": true }, { "size": true }, { "bubbles": true }, { "typography": true }], "components": [{ "link": true }, { "icon": true }, { "button": true }, { "button_group": true }, { "card": true }, { "navigation_container": true }, { "container": true }, { "data_table": true }, { "dialog": true }, { "form": true }, { "combo_box": true }, { "list_group": true }, { "loader": true }, { "modal": true }, { "menu": true }, { "notification": true }, { "pagination": true }, { "page_shell": true }, { "popover": true }, { "range_slider": true }, { "search_field": true }, { "stepper": true }, { "switch": true }, { "tag": true }, { "tooltip": true }, { "masthead": true }, { "site_navigation": true }, { "alert": true }, { "top_hat": true }, { "layout_grid": true }], "theme": "mds"

                        /***/ };
                }

                /******/ })
        );
    });

    /***/
},
/* 8 */
/***/function (module, exports, __webpack_require__) {

    (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory(__webpack_require__(0), __webpack_require__(6), __webpack_require__(7));else if (typeof define === 'function' && define.amd) define(["mbc-core", "mbc-flag", "mbc-legend"], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["mbc-time-series-line"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));else root["mbc-time-series-line"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
    })(this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__) {
        return (/******/function (modules) {
                // webpackBootstrap
                /******/ // The module cache
                /******/var installedModules = {};
                /******/
                /******/ // The require function
                /******/function __webpack_require__(moduleId) {
                    /******/
                    /******/ // Check if module is in cache
                    /******/if (installedModules[moduleId]) {
                        /******/return installedModules[moduleId].exports;
                        /******/
                    }
                    /******/ // Create a new module (and put it into the cache)
                    /******/var module = installedModules[moduleId] = {
                        /******/i: moduleId,
                        /******/l: false,
                        /******/exports: {}
                        /******/ };
                    /******/
                    /******/ // Execute the module function
                    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                    /******/
                    /******/ // Flag the module as loaded
                    /******/module.l = true;
                    /******/
                    /******/ // Return the exports of the module
                    /******/return module.exports;
                    /******/
                }
                /******/
                /******/
                /******/ // expose the modules object (__webpack_modules__)
                /******/__webpack_require__.m = modules;
                /******/
                /******/ // expose the module cache
                /******/__webpack_require__.c = installedModules;
                /******/
                /******/ // identity function for calling harmony imports with the correct context
                /******/__webpack_require__.i = function (value) {
                    return value;
                };
                /******/
                /******/ // define getter function for harmony exports
                /******/__webpack_require__.d = function (exports, name, getter) {
                    /******/if (!__webpack_require__.o(exports, name)) {
                        /******/Object.defineProperty(exports, name, {
                            /******/configurable: false,
                            /******/enumerable: true,
                            /******/get: getter
                            /******/ });
                        /******/
                    }
                    /******/
                };
                /******/
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/__webpack_require__.n = function (module) {
                    /******/var getter = module && module.__esModule ?
                    /******/function getDefault() {
                        return module['default'];
                    } :
                    /******/function getModuleExports() {
                        return module;
                    };
                    /******/__webpack_require__.d(getter, 'a', getter);
                    /******/return getter;
                    /******/
                };
                /******/
                /******/ // Object.prototype.hasOwnProperty.call
                /******/__webpack_require__.o = function (object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/
                /******/ // __webpack_public_path__
                /******/__webpack_require__.p = "";
                /******/
                /******/ // Load entry module and return exports
                /******/return __webpack_require__(__webpack_require__.s = 131);
                /******/
            }(
            /************************************************************************/
            /******/{

                /***/0:
                /***/function _(module, exports) {

                    module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

                    /***/
                },

                /***/1:
                /***/function _(module, exports) {

                    module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

                    /***/
                },

                /***/112:
                /***/function _(module, exports) {

                    // removed by extract-text-webpack-plugin

                    /***/},

                /***/131:
                /***/function _(module, exports, __webpack_require__) {

                    module.exports = __webpack_require__(30);

                    /***/
                },

                /***/30:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    __webpack_require__(112);

                    var _timeSeriesLine = __webpack_require__(93);

                    var _timeSeriesLine2 = _interopRequireDefault(_timeSeriesLine);

                    function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : { default: obj };
                    }

                    module.exports = _timeSeriesLine2.default;

                    /***/
                },

                /***/4:
                /***/function _(module, exports) {

                    module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

                    /***/
                },

                /***/91:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var ToolTip = __webpack_require__(1);
                    var Core = __webpack_require__(0);
                    var Utils = Core.Utils;
                    var mds_constants = Utils.colors.mds_constants;

                    function ToolTipMixin() {}
                    /**
                     * To configure the tooltip template function;
                     * The template outer div must be given the "tooltip-inner" class;
                     * The template outer div must also be given the "tooltip-flag" class;
                     * The toolTipTemplate method must accept "d" as a parameter;
                     * The toolTipTemplate method must return a template string
                     * @type {Function}
                     */

                    /* private methods */

                    /**
                     * _currentDate
                     * @private
                     **/
                    var _currentDate = null;

                    /**
                     * @method _getCurrentDate
                     * @private
                     * @desc returns the current mouse coordinate date
                     * @example
                     * var currentDate = _getCurrentDate();
                     *
                     * @return {Object} Date object
                    **/
                    var _getCurrentDate = function _getCurrentDate() {
                        return _currentDate;
                    };

                    /**
                     * @method _setCurrentDate
                     * @private
                     * @param {Object} - Date object
                     * @desc Expects a Date object and sets it as the current date
                     * @example
                     * _setCurrentDate(new Date())
                     *
                     * @return undefined
                    **/
                    var _setCurrentDate = function _setCurrentDate(date) {
                        if (Object.prototype.toString.call(date) !== "[object Date]") {
                            console.warn("Can't update date: not a date object!");
                            return;
                        }

                        _currentDate = date;
                    };

                    /**
                     * @method _generateCells
                     * @param {Array} colors - color codes to style each dash per line
                     * @desc  Generates the cells of the template for each line on the chart.
                     * @example
                     * var cells = _generateCells(["#FF0000"]);
                     *
                     * @return {String} Concatenated template string of the cells
                    **/

                    ToolTipMixin.prototype.generateCells = function () {
                        var data = this.get("tooltipData");
                        var colors = this.get("colors");
                        var dottedLines = this.get("dottedLines");
                        var maxWidthTextCell = 164 - Utils.string.getLongestTextStringWidth(data); // 200 max width - 10 icon with - 26 in total padding

                        return data.map(function (item) {
                            var line = item.name;
                            var color = colors[item.index] || mds_constants["color"].black;
                            var showDots = dottedLines.indexOf(line) !== -1;
                            var benchmarkStyle = showDots ? "border-top:2px dotted " + color : "border-top:2px solid " + color;
                            return "<div class=\"cell tooltip-row\">\n                        <div class=\"tip-cell-icon tooltip-cell\" style=\"" + benchmarkStyle + "\"> </div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\"> " + line + " </div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + item.value + "</div>\n                    </div>";
                        }).join("");
                    };

                    /**
                     * @method _getLineData
                     * @private
                     * @desc Retrieve and concatenate the line data for the given context's data manager '
                     * @example
                     * var lines = _getLineData();
                     *
                     * @return {Array} Concatenated array of line data for y1 and y2 groups
                    **/
                    var _getLineData = function _getLineData() {
                        if (!this) {
                            throw new Error("Context required to find line data");
                        }

                        var dataManager = this.get("data");
                        var y1DomainDataset = this.get("y1DomainDataset");
                        var lines = dataManager.get(y1DomainDataset);
                        var hasY2 = this.get("y2");

                        if (hasY2) {
                            var y2DomainDataset = this.get("y2DomainDataset");
                            lines = lines.concat(dataManager.get(y2DomainDataset));
                        }

                        return lines;
                    };

                    /* end private methods */

                    /**
                     * @method updateTooltipData
                     * @param {String} name
                     * @param {Number} value
                     * @param {Number} index
                     * @desc Sets or updates data for one of the lines on the chart.
                     * @example
                     * this.updateTooltipData("602107", -47, 1)
                     *
                     * @return undefined
                    **/
                    ToolTipMixin.prototype.updateTooltipData = function (series, mouseObjects) {
                        if (!series.length) {
                            console.warn("Can't update data: missing information");
                            return;
                        }

                        // sort tooltip items by the end value of series line
                        series = this.sortDataByEndValue(series);

                        // format tooltipData value
                        var y1FormatFn = this.tickFormat(this.get("y1TickFormat"));
                        var y2FormatFn = this.tickFormat(this.get("y2TickFormat"));
                        var dataManager = this.get("data");

                        var tooltipData = [];
                        series.forEach(function (item) {
                            var value = null;
                            var name = item.name;
                            var data = mouseObjects[name];
                            if (data) {
                                value = data.value;
                            }
                            var formatter = dataManager.inGroup(name, "y1") ? y1FormatFn : y2FormatFn;
                            var formattedValue = Utils.string.convertDashToEnDash(formatter(value));
                            var transformedValue = formattedValue == null || formattedValue == "" ? "N/A" : formattedValue;
                            tooltipData.push({
                                name: name,
                                index: item.index,
                                value: transformedValue
                            });
                        });

                        this.set("tooltipData", tooltipData);
                    };

                    /**
                     * @method toolTipTemplate
                     * @desc Either uses the custom template added by the user or generates a default one.
                     *       Used to draw the tooltip later.
                     * @example
                     * chart.toolTipTemplate()
                     *
                     *
                     * @return {String} template for tooltip
                    **/
                    ToolTipMixin.prototype.toolTipTemplate = function () {
                        var customTemplate = this.get("tooltipCustomTemplate");
                        if (customTemplate) {
                            return customTemplate;
                        } else {
                            var format, title;
                            var cells = this.generateCells.call(this);
                            var date = _getCurrentDate();

                            if (date) {
                                format = this.get("tooltipTimeFormat") || d3.time.format("%x");
                                title = this.get("tooltipTitle") || format(date);
                            } else {
                                title = this.get("tooltipTitle") || "Securities";
                            }

                            return "<div class=\"tooltip-inner tooltip-flag\">\n                    <div class=\"tooltip-title\">\n                        <p>" + title + "</p>\n                    </div>\n\n                    <div class=\"tooltip-body tooltip-table\">\n                        " + cells + "\n                    </div>\n                </div>";
                        }
                    };

                    /**
                     * @method drawToolTip
                     * @desc Binds the tooltip to the tooltip transparent canvas
                     * @example
                     * chart.drawToolTip()
                     *
                     *
                     * @return undefined
                     **/
                    ToolTipMixin.prototype.drawToolTip = function (options) {

                        this.set("showToolTip", true);

                        var defaultOpts = {
                            transition: false,
                            namespace: this.get("id"),
                            chart: "time-series"
                        };

                        Utils.object.copy(defaultOpts, options);

                        var t = this.toolTipTemplate.bind(this);
                        var tooltip = ToolTip(defaultOpts).template(t);
                        var canvas = this.get("canvas");
                        var svg = canvas.layer("top-layer", "front").select("rect");

                        svg.call(tooltip.bind());

                        this.set("tooltipInfo", tooltip);
                    };

                    /**
                     * @method removeToolTip
                     * @desc Removes the tooltip and the tooltip canvas
                     * @example
                     * chart.removeToolTip()
                     *
                     *
                     * @return undefined
                    **/
                    ToolTipMixin.prototype.removeToolTip = function () {

                        this.set("showToolTip", false);

                        var canvas = this.get("canvas");
                        var layer = canvas.layer("front-group");

                        layer.remove();
                        this.update();
                    };

                    /**
                     * @method validateTooltipDirection
                     * @desc Determines if the tooltip needs to change positions based on where it is on the canvas and update it.
                     *
                     * @param {Array} mouse - d3 selection
                     * @example
                     * var mouse = d3.mouse(this)
                     * chart.validateTooltipDirection(mouse)
                     *
                     *
                     * @return undefined
                     **/
                    ToolTipMixin.prototype.validateTooltipDirection = function (mouse) {
                        var coords = {};
                        var canvas = this.get("canvas");
                        var tooltipData = this.get("tooltipData");

                        coords.tooltip = this.get("tooltipInfo")._clientRect;
                        coords.mouse = mouse;
                        coords.canvasWidth = canvas.width();
                        coords.canvasHeight = canvas.height();
                        coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();

                        this.getHoverLineLeft();
                        this.changeToolTipDirection(coords);

                        if (this.get("tooltipHidden")) {
                            this.get("tooltipInfo").show(tooltipData, {
                                position: this.get("direction"),
                                namespace: this.get("id"),
                                hoverLeft: this.get("hoverLineLeft")
                            });
                            this.set("tooltipHidden", false);
                        }
                    };

                    /**
                     * @method changeToolTipDirection
                     * @desc Uses the coordinate information to decide how the tooltip should be positioned in the canvas. Determines top and bottom boundry when size of flag exceeds size of canvas.
                     *
                     * @param {Object} coords - mouse and tooltip positional information
                     * @example
                     * var coords = {};
                     * coords.tooltip = this.get("tooltipInfo")._clientRect;
                     * coords.mouse = mouse;
                     * coords.canvasWidth = canvas.width();
                     * coords.canvasHeight = canvas.height();
                     * coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();
                     * chart.changeToolTipDirection(coords)
                     *
                     * @return undefined
                     **/
                    ToolTipMixin.prototype.changeToolTipDirection = function (coords) {
                        var tooltip = this.get("tooltipInfo"); //Reference to tooltip
                        var canvasWidth = coords.canvasWidth; // Chart plotted width
                        var canvasHeight = coords.canvasHeight; // Chart plotted height

                        var hoverLineToLeft = this.get("hoverLineLeft") - coords.canvasPositioning.left; //The distance between hoverLine and left side of canvas
                        var tooFarRight = coords.tooltip && coords.mouse[0] >= canvasWidth - coords.tooltip.width && hoverLineToLeft >= coords.tooltip.width; //Boolean for right canvas boundry
                        var tooFarLeft = coords.tooltip && (coords.mouse[0] < canvasWidth - coords.tooltip.width ? true : hoverLineToLeft < coords.tooltip.width); //Boolean for left canvas boundry
                        var tooHigh = coords.tooltip && coords.mouse[1] <= coords.tooltip.height; //Boolean for top canvas boundry
                        var tooLow = coords.tooltip && coords.mouse[1] >= canvasHeight - coords.tooltip.height; //Boolean for bottom canvas boundry

                        var windowtHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
                        var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
                        var exceedsViewportTop = coords.tooltip && coords.tooltip.height - coords.mouse[1] > coords.canvasPositioning.top; //Boolean check if tooltip exceeds beyond viewport top
                        var exceedsViewportBottom = coords.tooltip && viewportMousePositionY + coords.tooltip.height > windowtHeight; //Boolean check if tooltip exceeds beyond viewport bottom

                        // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
                        if (tooHigh && tooLow) {

                            // Check collision to viewport, default to display flag down if conditions both fail
                            tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
                            tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
                        }

                        // If flag exceeds neither the top or bottom of canvas default the position
                        if (!tooHigh && !tooLow) {
                            tooLow = true;
                        }

                        if (tooFarRight && tooLow) {

                            tooltip.hide();
                            this.set("tooltipHidden", true);
                            this.set("direction", "left-bottom");
                            return;
                        }

                        if (tooFarLeft && tooLow) {

                            tooltip.hide();
                            this.set("tooltipHidden", true);
                            this.set("direction", "right-bottom");
                            return;
                        }

                        if (tooFarRight && tooHigh) {

                            tooltip.hide();
                            this.set("tooltipHidden", true);
                            this.set("direction", "left-top");
                            return;
                        }

                        if (tooFarLeft && tooHigh) {

                            tooltip.hide();
                            this.set("tooltipHidden", true);
                            this.set("direction", "right-top");
                            return;
                        }

                        return;
                    };

                    /**
                         * @method getHoverLineLeft
                         * @desc Set the left px position of the current selected data line
                         * @return undefined
                    **/
                    ToolTipMixin.prototype.getHoverLineLeft = function () {
                        var canvas = this.get("canvas");
                        var mouseRect = canvas.layer('front-group').select(".mouse-rect-line");
                        this.set("hoverLineLeft", mouseRect[0][0].getBoundingClientRect().left);
                    };

                    /**
                         * @method createMouseRect
                         * @desc Create the area on the canvas that listens to mouse events for the tooltip
                         *
                         * @example
                         * chart.this.createMouseRect();
                         *
                         *
                         * @return undefined
                        **/
                    ToolTipMixin.prototype.createMouseRect = function () {
                        var _this = this;
                        var canvas = this.get("canvas");
                        var scales = this.get("scales");

                        var yPadding = this.get("yPadding");
                        var width = canvas.width() - yPadding * 2;
                        var height = canvas.height();
                        var topLayer = canvas.layer("top-layer", "front");
                        var x = scales.scale("x");
                        var rectMouse = topLayer.append("rect"); // append a rect to catch mouse movements on canvas

                        rectMouse.attr("x", yPadding).attr("width", width).attr("height", height).attr("fill", "none").attr("pointer-events", "all").classed({
                            "rect__event-area": true
                        }).on("mouseleave", function () {
                            // on mouse leave hide line
                            canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "0");

                            var agileStyle = _this.get("agileStyle");
                            if (!agileStyle.bubbleOpacity) {
                                var layer = canvas.layer("line-chart-layer");
                                layer.selectAll(".line-bubbles").attr("opacity", 0);
                            }
                        }).on("mouseover", function () {
                            // on mouse in show line
                            canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "1");
                        }).on("mousemove", function () {
                            // mouse moving over canvas
                            var frontGroup = canvas.layer('front-group');
                            var mouse = d3.mouse(this);

                            var seriesData = [];
                            var series = [];
                            // build seriesData at the same time when get translate
                            frontGroup.selectAll(".mouse-per-line").attr("transform", function (d) {
                                seriesData = seriesData.concat(d.series);
                                series.push({
                                    name: d.displayName,
                                    index: d.index,
                                    value: _this.getValidEndValue(d.series)
                                });
                                return "translate(" + mouse[0] + "," + mouse[1] + ")";
                            });

                            // sort all seriesData by date
                            seriesData.sort(function (a, b) {
                                return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
                            });

                            var xDate = x.invert(mouse[0]);
                            var bisect = d3.bisector(function (d) {
                                return d.date;
                            }).right;
                            var idx = bisect(seriesData, xDate) - 1;
                            idx = idx >= seriesData.length ? seriesData.length - 1 : idx;
                            idx = idx < 0 ? 0 : idx;
                            // find out the date at which mouse place, it will be used in the following
                            var mouseDate = seriesData[idx].date;

                            // find out items at the mouseDate,
                            // Notice: if a series have no data on the day, mouseItems will not catains this series data
                            // this is why we need seriesNames to record whole series
                            var mouseItems = seriesData.filter(function (item) {
                                return item.date.toString() === mouseDate.toString();
                            });
                            // convert to a object to make data more easy to be found
                            var mouseObjects = {};
                            mouseItems.forEach(function (item) {
                                mouseObjects[item.name] = item;
                            });

                            /**
                             * make sure tooltip use this data
                             */
                            _this.updateTooltipData(series, mouseObjects);

                            /**
                             * snap scrubber line to relevant hover data point
                             */
                            frontGroup.select(".mouse-rect-line").attr("d", function () {
                                var d = "M" + x(mouseDate) + "," + height;
                                d += " " + x(mouseDate) + "," + 0;
                                return d;
                            });

                            _setCurrentDate(mouseDate);
                            _this.validateTooltipDirection(mouse);
                            _this.handleAgileStyle(mouseDate);
                        }); //end mousemove
                    };

                    /**
                    * @method handleAgileStyle
                    * @desc Display bubbles which has the same date as mouseDate, hide other bubbles.
                    * @param {Date} mouseDate: the closest calculated date with mouse position
                    */
                    ToolTipMixin.prototype.handleAgileStyle = function (mouseDate) {
                        var agileStyle = this.get("agileStyle");
                        if (!agileStyle.bubbleOpacity) {
                            var canvas = this.get("canvas");
                            var layer = canvas.layer("line-chart-layer");
                            layer.selectAll(".line-bubbles").attr("opacity", 0);
                            layer.selectAll(".line-bubbles.date" + mouseDate.getTime()).attr("opacity", 1);
                        }
                    };

                    /**
                     * @method renderToolTip
                     * @desc Takes all the necessary steps to display the tooltip flag as long as the proper conditions are met
                     *
                     * @example
                     * chart.renderToolTip();
                     *
                     *
                     * @return undefined
                     **/
                    ToolTipMixin.prototype.renderToolTip = function () {
                        if (this.get("showToolTip") && !this.get("initialized")) {
                            this.set("tooltipData", []);
                            this.set("tooltipHidden", true); //initializes the property used to show tooltip
                            this.createTooltip();
                            this.drawToolTip({
                                namespace: this.get("id")
                            });
                            this.set("direction", "right-top");
                            this.set("initialized", true);
                        }
                    };

                    /**
                     * @method createTooltip
                     * @desc Takes each line of the chart and calculates necessary tooltip data including timestamp, value, and name
                     *       depending on where the mouse is on the canvas.
                     *
                     * @example
                     * chart.renderToolTip();
                     *
                     *
                     * @return undefined
                     **/
                    ToolTipMixin.prototype.createTooltip = function () {
                        var canvas = this.get("canvas");
                        var lineData = _getLineData.bind(this);

                        var layer = canvas.layer("front-group");

                        var mouseG = layer.append("g").attr("class", "mouse-over-effects");

                        mouseG.append("path") // this is the black vertical line to follow mouse
                        .attr("class", "mouse-rect-line").style("stroke", "black").style("stroke-width", "1px").style("stroke-dasharray", "3,3").style("opacity", "0").style("pointer-events", "all");

                        var mousePerLine = mouseG.selectAll(".mouse-per-line").data(lineData);

                        mousePerLine.attr("class", "mouse-per-line");

                        mousePerLine.enter().append("g").attr("class", "mouse-per-line");

                        mousePerLine.exit().remove();

                        this.createMouseRect();
                    };

                    module.exports = ToolTipMixin;

                    /***/
                },

                /***/92:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
                        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
                    } : function (obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
                    };

                    var YEAR_FORMAT = "%Y";

                    /**
                     * Ticks period configuration. '_sm' suffix stands for small screens (breakpoint).
                     */
                    var TICKS_DEF = {
                        year: [d3.time.years, 1],
                        year_sm: [d3.time.years, 2],
                        quarter: [d3.time.months, 3],
                        quarter_sm: [d3.time.months, 6],
                        month: [d3.time.months, 1],
                        month_sm: [d3.time.months, 2],
                        week: [d3.time.weeks, 1],
                        week_sm: [d3.time.weeks, 2],
                        day: [d3.time.days, 1],
                        day_sm: [d3.time.days, 2],
                        hour: [d3.time.hours, 4],
                        hour_sm: [d3.time.hours, 4]
                    };

                    /**
                     * Map that holds the timeline sub level for each period.
                     */
                    var LEVEL_MAPPER = {
                        year: "year",
                        quarter: "quarter",
                        month: "month",
                        week: "week",
                        day: "day",
                        hour: "hour"
                    };

                    /**
                     * Returns the tick period parameters for a given period and screen type.
                     * @param {*} period
                     * @param {*} smallScreen
                     * @returns {Array} Array that holds the tick configuration for the x axis label.
                     */
                    var getTickParameters = function getTickParameters(period, smallScreen) {
                        period = period + (smallScreen ? "_sm" : "");
                        return TICKS_DEF[period];
                    };

                    function Helper() {}

                    /**
                     * Returns an array that contains the years within the domain.
                     * @method getYear
                     * @param {Array} domain
                     * @returns {Array}
                     */
                    var getYear = function getYear(domain) {
                        var date = domain[0];
                        var endDate = domain[1];
                        var dateArr = [];
                        dateArr.push(date);
                        var newDate = new Date(date.toString());
                        var yr = Math.floor(date.getFullYear());
                        newDate.setYear(++yr);

                        while (newDate.getTime() < endDate.getTime()) {
                            newDate.setHours(0);
                            newDate.setMinutes(0);
                            newDate.setSeconds(0);
                            newDate.setMilliseconds(0);
                            newDate.setDate(1);
                            dateArr.push(newDate);
                            newDate = new Date(newDate.toString());
                            yr = Math.floor(newDate.getFullYear());
                            newDate.setYear(++yr);
                        }
                        return dateArr;
                    };

                    /**
                     * Returns an array that contains the quarters within the domain.
                     * @method getQuarter
                     * @param {Array} domain
                     * @returns {Array}
                     */
                    var getQuarter = function getQuarter(domain) {
                        var date = domain[0];
                        var endDate = domain[1];
                        var dateArr = [];
                        dateArr.push(date);
                        var newDate = new Date(date.toString());
                        var qtr = Math.floor(date.getMonth() / 3);
                        newDate.setMonth(++qtr * 3);

                        while (newDate.getTime() < endDate.getTime()) {
                            newDate.setHours(0);
                            newDate.setMinutes(0);
                            newDate.setSeconds(0);
                            newDate.setMilliseconds(0);
                            newDate.setDate(1);
                            dateArr.push(newDate);
                            newDate = new Date(newDate.toString());
                            qtr = Math.floor(newDate.getMonth() / 3);
                            newDate.setMonth(++qtr * 3);
                        }
                        return dateArr;
                    };

                    /**
                     * Returns an array that contains the months within the domain.
                     * @method getMonth
                     * @param {Array} domain
                     * @returns {Array}
                     */
                    var getMonth = function getMonth(domain) {
                        var date = domain[0];
                        var endDate = domain[1];
                        var dateArr = [];
                        dateArr.push(date);
                        var newDate = new Date(date.toString());
                        var nextMonth = date.getMonth() + 1;
                        newDate.setMonth(nextMonth);

                        while (newDate.getTime() < endDate.getTime()) {
                            newDate.setHours(0);
                            newDate.setMinutes(0);
                            newDate.setSeconds(0);
                            newDate.setMilliseconds(0);
                            newDate.setDate(1);
                            dateArr.push(newDate);
                            newDate = new Date(newDate.toString());
                            nextMonth = newDate.getMonth() + 1;
                            newDate.setMonth(nextMonth);
                        }

                        return dateArr;
                    };

                    /**
                     * Returns the next week first day.
                     * @param {Date} date
                     * @returns {Date}
                     */
                    var getNextWeekStartDate = function getNextWeekStartDate(date) {
                        var newDate = new Date(date.toString());
                        var day = newDate.getDate();
                        var weekDay = newDate.getDay();
                        newDate.setDate(day + (7 - weekDay));
                        return newDate;
                    };

                    /**
                     * Returns an array that contains the weeks within the domain.
                     * @method getWeek
                     * @param {Array} domain
                     * @returns {Array}
                     */
                    var getWeek = function getWeek(domain) {
                        var date = domain[0];
                        var endDate = domain[1];
                        var dateArr = [];
                        dateArr.push(date);
                        var newDate = getNextWeekStartDate(date);
                        while (newDate.getTime() < endDate.getTime()) {
                            newDate.setHours(0);
                            newDate.setMinutes(0);
                            newDate.setSeconds(0);
                            newDate.setMilliseconds(0);
                            dateArr.push(newDate);
                            newDate = getNextWeekStartDate(newDate);
                        }

                        return dateArr;
                    };

                    /**
                     * Returns an array that contains the days within the domain.
                     * @method getDay
                     * @param {Array} domain
                     * @returns {Array}
                     */
                    var getDay = function getDay(domain) {
                        var date = domain[0];
                        var endDate = domain[1];
                        var dateArr = [];
                        dateArr.push(date);
                        var newDate = new Date(date.toString());
                        var nextDay = date.getDate() + 1;
                        newDate.setDate(nextDay);

                        while (newDate.getTime() < endDate.getTime()) {
                            newDate.setHours(0);
                            newDate.setMinutes(0);
                            newDate.setSeconds(0);
                            newDate.setMilliseconds(0);
                            dateArr.push(newDate);
                            newDate = new Date(newDate.toString());
                            nextDay = newDate.getDate() + 1;
                            newDate.setDate(nextDay);
                        }

                        return dateArr;
                    };

                    /**
                     * Returns an array that contains the hours within the domain.
                     * @method getHour
                     * @param {Array} domain
                     * @returns {Array}
                     */
                    var getHour = function getHour(domain) {
                        var date = domain[0];
                        var endDate = domain[1];
                        var dateArr = [];
                        dateArr.push(date);
                        var newDate = new Date(date.toString());
                        var nextHour = date.getHours() + 1;
                        newDate.setHours(nextHour);

                        while (newDate.getTime() < endDate.getTime()) {
                            newDate.setMinutes(0);
                            newDate.setSeconds(0);
                            newDate.setMilliseconds(0);
                            dateArr.push(newDate);
                            newDate = new Date(newDate.toString());
                            nextHour = newDate.getHours() + 1;
                            newDate.setHours(nextHour);
                        }

                        return dateArr;
                    };

                    /**
                     * Gets the first visible tick from the ticks array.
                     * @param {D3 Selection} allTicks Must contain a selection of ticks. Required.
                     * @returns {D3 Selection}
                     */
                    var getNextVisible = function getNextVisible(allTicks) {
                        var next;
                        allTicks.each(function () {
                            var el = d3.select(this);
                            if (!next && el.style("display") !== "none") {
                                next = el;
                            }
                        });

                        return next || d3.select();
                    };

                    /**
                     * Used to make the domain symmetrical bc line chart doesn't use calculateDomain method in Core
                     * @method makeSymmetrical
                     * @param {Array} domain containing min and max values
                     */
                    Helper.prototype.makeSymmetrical = function (arr) {
                        var p0 = arr[0] < 0 ? arr[0] * -1 : arr[0];
                        var p1 = arr[1] < 1 ? arr[1] * -1 : arr[1];

                        if (p0 > p1) {
                            return [p0 * -1, p0];
                        } else {
                            return [p1 * -1, p1];
                        }
                    },

                    /**
                     * Sets the x axis ticks funtion depending on the timeline level.
                     * @method helperSetTicks
                     * @param {Boolean} smallScreen
                     */
                    Helper.prototype.helperSetTicks = function (smallScreen) {
                        var timelineLevel = this.get("timelineLevel");
                        var greyBandLevel = LEVEL_MAPPER[timelineLevel];

                        var xTicks = getTickParameters(timelineLevel, smallScreen);

                        var subLabelFormat = YEAR_FORMAT;

                        this.set("_xTicks", xTicks);
                        this.set("subLabelFormat", subLabelFormat);
                        this.set("greyBandLevel", greyBandLevel);
                    };

                    /**
                     * Sets the x axis sub labels array.
                     * @method helperSetSublabels
                     */
                    Helper.prototype.helperSetSublabels = function () {
                        var axes = this.get("canvas").get("axesGroup");
                        var xDomain = this.get("xDomain");
                        var subLabelFormat = this.get("subLabelFormat") || "%Y";

                        var ticks = [];
                        var subLabels = [];
                        var previous = d3.time.format(subLabelFormat)(xDomain[0]);

                        axes.selectAll(".mbc-axis-x .tick").each(function (d) {
                            ticks.push(d);
                        });

                        ticks.forEach(function (tick) {
                            var formatted = d3.time.format(subLabelFormat)(tick);
                            if (previous === formatted) {
                                subLabels.push(null);
                            } else {
                                subLabels.push(formatted);
                                previous = formatted;
                            }
                        });

                        this.set("xSubLabels", subLabels);
                    };

                    /**
                     * Adds the first and last date x axes ticks.
                     * @method helperAddFirstLabel
                     * @param {Canvas} canvas Canvas containing the chart.
                     */
                    Helper.prototype.helperAddFirstLabel = function (canvas) {

                        var xDomain = this.get("xDomain");
                        var subLabelFormat = d3.time.format(this.get("subLabelFormat") || YEAR_FORMAT);
                        var yPadding = this.get("yPadding");
                        var xTickFormat = this.get("_xTickFormat");
                        var axes = canvas.get("axesGroup").select(".mbc-axis-x");
                        var xAxisOrient = this.get("xAxisOrient");
                        var xScale = this.get("scales").scale("x");
                        var allTicks, firstTick, lastTick, tick, tickLast, firstRect, lastRect, tickRect, x, showLastSublabel, lastSublabel, diff;

                        axes.selectAll("g.artificial").remove();
                        allTicks = axes.selectAll(".tick").filter(function () {
                            return !d3.select(this).classed("artificial");
                        }).style("display", "");

                        firstTick = getNextVisible(allTicks); //allTicks.first();
                        lastTick = allTicks.last();

                        // First one
                        tick = axes.append("g").classed({
                            tick: true,
                            artificial: true,
                            first: true
                        }).attr("transform", "translate(0, 0)");

                        tick.append("text").attrs({
                            x: yPadding,
                            y: xAxisOrient === "bottom" ? 3 : -3,
                            "text-anchor": "start",
                            dy: xAxisOrient === "bottom" ? ".71em" : "0em"
                        }).text(xTickFormat(xDomain[0]));
                        tick.append("text").text(subLabelFormat(xDomain[0])).attr("transform", function () {
                            var y = xAxisOrient === "bottom" ? 28 : -18;
                            return "translate(" + yPadding + ", " + y + ")";
                        }).attr("class", "mbc-tick-abbreviation");

                        if (!firstTick.empty()) {
                            firstRect = firstTick.node().getBoundingClientRect();
                            tickRect = tick.node().getBoundingClientRect();

                            if (Math.abs(firstRect.left - tickRect.left) < tickRect.width + 10) {
                                firstTick.style("display", "none");
                            }
                        }

                        // Last Tick
                        if (!lastTick.empty()) {
                            lastRect = lastTick.node().getBoundingClientRect();
                            x = canvas.width() - yPadding * 2;

                            tickLast = axes.append("g").classed({
                                tick: true,
                                artificial: true,
                                last: true
                            }).attr("transform", "translate(" + x + ", 0)");

                            tickLast.append("text").attrs({
                                x: yPadding,
                                y: xAxisOrient === "bottom" ? 3 : -3,
                                "text-anchor": "end",
                                dy: xAxisOrient === "bottom" ? ".71em" : "0em",
                                class: "mbc-tick-label"
                            }).text(xTickFormat(xDomain[1]));

                            lastSublabel = tickLast.append("text").text(subLabelFormat(xDomain[1])).attrs({
                                class: "mbc-tick-abbreviation",
                                "text-anchor": "end",
                                transform: function transform() {
                                    var y = xAxisOrient === "bottom" ? 28 : -18;
                                    return "translate(" + yPadding + ", " + y + ")";
                                }
                            });

                            diff = tickLast.select(".mbc-tick-label").node().getBoundingClientRect().width - tickLast.select(".mbc-tick-abbreviation").node().getBoundingClientRect().width - 1;

                            lastSublabel.attr("dx", diff * -1 + "px");

                            tickRect = tickLast.node().getBoundingClientRect();

                            showLastSublabel = lastTick[0][0].__data__.getYear() !== xDomain[1].getYear();
                            if (xScale(lastTick[0][0].__data__) + lastRect.width - 2 > canvas.width() - yPadding) {
                                lastTick.style("display", "none");
                                showLastSublabel = lastTick[0][0].previousSibling && lastTick[0][0].previousSibling.__data__.getYear() !== xDomain[1].getYear();
                            }

                            if (!showLastSublabel) {
                                lastSublabel.style("display", "none");
                            } else {
                                lastSublabel.style("display", "");
                            }

                            tickLast.style("display", "none");
                        }
                    };

                    /**
                     *
                     * @method helperGetBackgroundArray
                     * @param {Array} domain Chart domain.
                     * @param {String} period Time period to generate the array for the background.
                     * @returns {Array} Array containing the dates for each period within the domain.
                     */
                    Helper.prototype.helperGetBackgroundArray = function (domain) {
                        var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "quarter";

                        var datesArray;
                        switch (period) {
                            case "year":
                                datesArray = getYear(domain);
                                break;
                            case "quarter":
                                datesArray = getQuarter(domain);
                                break;
                            case "month":
                                datesArray = getMonth(domain);
                                break;
                            case "week":
                                datesArray = getWeek(domain);
                                break;
                            case "day":
                                datesArray = getDay(domain);
                                break;
                            case "hour":
                                datesArray = getHour(domain);
                                break;
                            default:
                                break;
                        }
                        return datesArray;
                    };

                    /**
                     * @method helperXBuffer
                     * @desc set buffer for xAxis
                     * @param {Date} original - original date to be buffered
                     * @param {Object} options - options for how much to buffer
                     * @example
                     *  this.helperXBuffer(new Date(), {level: 'hour', amount: 5})
                     *
                     * @return {Date} buffered date object
                     */
                    Helper.prototype.helperXBuffer = function (original, options) {
                        var level = LEVEL_MAPPER[options.level];
                        var buffered;

                        if (typeof d3.time[level] === "function") {
                            buffered = d3.time[level].offset(original, options.amount);
                        }

                        return (typeof buffered === "undefined" ? "undefined" : _typeof(buffered)) === "object" ? buffered : original;
                    };

                    /**
                     * @method sortDataByEndValue
                     * @desc sort data by series end value
                     * @example {Array} data
                     *  [{name: "name", index: "2", endValue: 1345.002}, ...]
                     * @return {Array} data
                     */
                    Helper.prototype.sortDataByEndValue = function (data) {
                        // tooltip items' order, legend items' order
                        var linesOrder = this.get("linesOrder");
                        data.sort(function (a, b) {
                            var value = b.value - a.value;
                            if (linesOrder === 'asc') {
                                return -value;
                            } else if (linesOrder === 'desc') {
                                return value;
                            } else {
                                return 0;
                            }
                        });

                        return data;
                    };

                    /**
                     * @method getValidEndValue
                     * @desc get valid end value of lines
                     * @param {Array} series
                     */
                    Helper.prototype.getValidEndValue = function (series) {
                        var endValue;
                        if (!series || !(series instanceof Array && series.length)) {
                            return;
                        }
                        for (var i = series.length - 1; i >= 0; i--) {
                            var value = series[i].value;
                            if (value != null) {
                                endValue = value;
                                break;
                            }
                        }
                        return endValue;
                    };

                    module.exports = Helper;

                    /***/
                },

                /***/93:
                /***/function _(module, exports, __webpack_require__) {

                    "use strict";

                    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
                        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
                    } : function (obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
                    };

                    var Core = __webpack_require__(0);
                    var Legend = __webpack_require__(4);
                    var Tooltip = __webpack_require__(91);
                    var Helper = __webpack_require__(92);

                    var Chart = Core.Chart;
                    var Utils = Core.Utils;
                    var Classes = Core.Classes;

                    /**
                     * Time Series Line Chart.
                     *
                     * @example
                     * // Extension example:
                     * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
                     *
                     * var newExtendedTimeSeriesLineChart = TimeSeriesLineChart.extend({
                     *   ...
                     * });
                     *
                     * @examples
                     * // Use example:
                     * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
                     *
                     * var timeSeries = new TimeSeriesLineChart(<options>);
                     * d3Container.datum(data).call(timeSeries.init());
                     *
                     * @class
                     * @extends Chart
                     */
                    var TimeSeriesLineChart = Chart.extend(Helper, Legend, Tooltip,
                    /**
                     * @lends TimeSeriesLineChart.prototype
                     **/
                    {
                        id: "mbc-time-series-line-chart", // Also used as class for this chart type.
                        /** @type {Number} */
                        screenMinHeight: 100, // container min-height
                        breakpoint: 650,
                        smallBreakpoint: 400,
                        legend: true,
                        legendMaxWidth: 150,
                        legendPosition: "right",
                        ticksNumber: 4,
                        tickValues: null,
                        xAxisOrient: "bottom",
                        xDomain: null,
                        xDomainDataset: "x",
                        y1DomainDataset: "y1",
                        y2DomainDataset: "y2",
                        y1Abbreviation: null,
                        y1AxisLabel: false,
                        y1AxisOrient: "left",
                        y1TickValues: null,
                        y1TicksAlign: "right",
                        y1TickFormat: ",.2f",
                        y1TickSymbol: "$",
                        y1Bubbled: false,
                        y1Symmetrical: false,
                        y2Abbreviation: null,
                        y2AxisLabel: false,
                        y2AxisOrient: "left",
                        y2TickValues: null,
                        y2TicksAlign: "right",
                        y2TickFormat: ",.2f",
                        y2TickSymbol: "$",
                        y2Bubbled: false,
                        y2Symmetrical: false,
                        lineStrokeWidth: 2,
                        dottedDashDimensions: "1, 5",
                        bubbleRadius: 4,
                        bubbleStrokeWidth: 2,
                        yAxesLabelWidth: 20,
                        yAxesLabelPadding: 6,
                        yAxesSpacing: 5,
                        yDomain: null,
                        yPadding: 12,
                        yPaddingBig: 12,
                        yPaddingSmall: 6,
                        yTickMargin: 6,
                        yTickSize: 35,
                        xTickFormat: null,
                        xTicks: null, // Optional now and exclusive with timelineLevel for legacy
                        xTickSize: null,
                        showLegendValues: false, // Boolean
                        greyBandLevel: null,
                        timelineLevel: null, // year, quarter, month, week, day. Exclusive with xTicks
                        firstTickDate: true, // true or false
                        xAxisBuffer: null, // Optional Object
                        xAxisStart: null, //Optional Date Object
                        xAxisEnd: null, // Optional Date Object
                        legendValueFont: "bold 18px helvetica neue",
                        legendLabelFont: "14px helvetica neue",
                        linesOrder: null, // asc/desc/null, will be used to sort the items order in legend and tooltip by the end value of series line
                        dottedLines: [], //set dotted line key, such as ['line1Key','line2Key']
                        /**
                         * Prepare the data for the chart.
                         * @method setData
                         * @param {Object} data
                         */
                        setData: function setData(data) {
                            var dataManager = this.get("data");
                            var y1DomainDataset = this.get("y1DomainDataset");
                            var y2DomainDataset = this.get("y2DomainDataset");
                            var parseFormat = this.get("parseFormat") || null;

                            /* set up lines in y1 and y2 groups */
                            var y1Lines = d3.nest().key(function (d) {
                                return d.name;
                            }).entries(data[y1DomainDataset]);

                            y1Lines.forEach(function (line) {
                                line.values.forEach(function (segment) {
                                    if (parseFormat && _typeof(segment.date) !== "object") {
                                        segment.date = parseFormat(segment.date);
                                    }
                                });

                                dataManager.set(line.key, line.values, y1DomainDataset);
                            });

                            if (this.get("y2")) {
                                var y2Lines = d3.nest().key(function (d) {
                                    return d.name;
                                }).entries(data[y2DomainDataset]);

                                y2Lines.forEach(function (line) {
                                    line.values.forEach(function (segment) {
                                        if (parseFormat && _typeof(segment.date) !== "object") {
                                            segment.date = parseFormat(segment.date);
                                        }
                                    });

                                    dataManager.set(line.key, line.values, y2DomainDataset);
                                });
                            }

                            this.setParsers();
                        },
                        /**
                         * @method checkForDataIslands
                         * @param {Array} data
                         * @param {String} yAxis
                         * @desc Determine if dataset includes any datapoints surrounded by null or undefined values
                         * @return undefined
                         */
                        checkForDataIslands: function checkForDataIslands(data, yAxis) {
                            var hasIslands = false;
                            var indexes = [];
                            var vals = data[0].series;
                            for (var i = 0; i < vals.length; i++) {
                                var lastVal = vals[i - 1] ? vals[i - 1].value : null,

                                // vals[0-1] === undefined
                                nextVal = vals[i + 1] ? vals[i + 1].value : null; // vals[(vals.length-1)+1] === undefined
                                if (vals[i].value != null && lastVal == null && nextVal == null) {
                                    indexes.push(i);
                                    hasIslands = true;
                                }
                            }

                            if (hasIslands) {
                                this.drawIslandBubbles(data, indexes, yAxis);
                            }
                        },
                        /**
                         * @method drawIslandBubbles
                         * @param {Array} data
                         * @param {Array} indexes
                         * @param {String} yAxis
                         * @desc Render bubble dots for datapoints that are islands, i.e., surrounded by null or undefined values
                         * @return undefined
                         */
                        drawIslandBubbles: function drawIslandBubbles(data, indexes, yAxis) {

                            var _this = this;
                            var scales = this.get("scales");
                            var xScale = scales.scale("x");
                            var yScale = scales.scale(yAxis);
                            var canvas = this.get("canvas");
                            var layer = canvas.layer("line-chart-layer");
                            var dottedLines = this.get('dottedLines');
                            var agileStyle = this.get("agileStyle");
                            var bubbles;

                            data.forEach(function (item) {
                                bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
                                bubbles.attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                                    return xScale(d.date);
                                }).attr("cy", function (d, i) {
                                    return yScale(d.value) - 1;
                                }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                                    return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
                                }).attr("opacity", function (d, i) {
                                    if (indexes.indexOf(i) > -1) {
                                        return 1;
                                    } else {
                                        return 0;
                                    }
                                });

                                bubbles.enter().append('circle').attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                                    return xScale(d.date);
                                }).attr("cy", function (d, i) {
                                    return yScale(d.value) - 1;
                                }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                                    return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
                                }).attr("opacity", function (d, i) {
                                    if (indexes.indexOf(i) > -1) {
                                        return 1;
                                    } else {
                                        return 0;
                                    }
                                });

                                bubbles.exit().remove();
                            });
                        },

                        /**
                         * @method setParsers
                         * @desc Set default or user-specific parsers for datasets
                         * @example
                         * chart.setParsers()
                         *
                         *
                         * @return undefined
                         */
                        setParsers: function setParsers() {
                            var dataManager = this.get("data");
                            var y1DomainDataset = this.get("y1DomainDataset");
                            var y2DomainDataset = this.get("y2DomainDataset");
                            var parseFormat = this.get("parseFormat") || null;
                            var y1Parser = this.get("y1Parser");
                            var y2Parser = this.get("y2Parser");
                            var useDefaultParsers = this.get("useDefaultParsers");
                            var y2 = this.get("y2");

                            var defaultParser = function defaultParser(data) {

                                var map = data.map(function (line) {
                                    line.series.forEach(function (segment) {
                                        if (parseFormat && _typeof(segment.date) !== "object") {
                                            segment.date = parseFormat(segment.date);
                                        }
                                    });

                                    var sorted = line.series.sort(function (a, b) {
                                        return a.date - b.date;
                                    });

                                    line.series = sorted;
                                    return line;
                                });

                                return map;
                            };

                            if (useDefaultParsers) {
                                dataManager.parser(y1DomainDataset, defaultParser);
                                dataManager.parser(y2DomainDataset, defaultParser);
                            }

                            if (y1Parser && !useDefaultParsers) {
                                dataManager.parser(y1DomainDataset, y1Parser.bind(this));
                            }

                            if (y2 && y2Parser && !useDefaultParsers) {
                                dataManager.parser(y2DomainDataset, y2Parser.bind(this));
                            }
                        },

                        /**
                         * @override
                         * Set the tickSize, axesSpacing, padding, and margin
                         */
                        beforeDraw: function beforeDraw() {
                            this.redoCanvas();
                            this.checkBreakpoints();
                            var canvas = this.get("canvas");
                            var y1LabelText = this.get("y1AxisLabel");
                            var y2LabelText = this.get("y2AxisLabel");
                            var yAxesLabelWidth = this.get("yAxesLabelWidth");
                            var xTicks = this.get("xTicks");
                            var xTickFormat = this.get("xTickFormat");
                            var smallScreen = canvas.get("outerWidth") <= this.get("breakpoint");

                            if (!y1LabelText && !y2LabelText) {
                                canvas.set("yAxesLabelWidth", 0);
                            } else {
                                canvas.set("yAxesLabelWidth", yAxesLabelWidth);
                            }

                            canvas.set("tickSize", this.get("yTickSize"));
                            canvas.set("axesSpacing", this.get("yAxesSpacing"));
                            canvas.set("margin", this.getMargins());

                            if (!this.get("y2")) {
                                this.get("axes").remove("y2");
                            }

                            if (smallScreen) {
                                this.set("yPadding", this.get("yPaddingSmall"));
                            } else {
                                this.set("yPadding", this.get("yPaddingBig"));
                            }

                            // xTicks Legacy
                            if (xTicks) {
                                this.set("_xTicks", xTicks); // Private variable
                            } else {
                                if (!this.get("timelineLevel")) {
                                    this.set("timelineLevel", "year");
                                }

                                this.helperSetTicks(smallScreen);
                            }

                            if (!xTickFormat && !xTicks) {
                                this.set("_xTickFormat", d3.time.format("%Y"));
                            }

                            if (!xTickFormat && this.get("timelineLevel")) {
                                this.set("_xTickFormat", d3.time.format("%b %e"));
                            } else {
                                this.set("_xTickFormat", xTickFormat);
                            }

                            if (this.get("legend")) {
                                this.invokeLegend({
                                    chart: "time-series",
                                    data: this.get('data')._data,
                                    mouseover: false
                                });
                            }
                        },

                        /**
                         * @override
                         * Visual adjustments after the chart has been rendered
                         */
                        afterDraw: function afterDraw(options) {
                            var canvas = this.get("canvas");
                            var axes = canvas.get("axesGroup");
                            var noTicksRecalc = options && options.noTicksRecalc;
                            var tinyScreen = canvas.get("outerWidth") <= this.get("smallBreakpoint");
                            var xSubLabels = this.get("xSubLabels");
                            var xOriginalTicks, lastTick;
                            var showLegend = this.get("legend");

                            this.adjustYLabels();

                            var xTicks = axes.selectAll("." + Classes.AXIS + "-x text");

                            xTicks.style("text-anchor", "start");

                            if (showLegend) {
                                canvas.watch("outerWidth", function (newValue, oldValue) {
                                    this.checkBreakpoints(newValue, oldValue);
                                }.bind(this));
                            }

                            if (!noTicksRecalc) {
                                this.updateTickWidths();
                            }
                            if (this.get("timelineLevel") && this.get("firstTickDate")) {
                                this.helperAddFirstLabel(canvas);
                            }

                            if (Array.isArray(xSubLabels) && xSubLabels.length || this.get("timelineLevel")) {
                                this.appendAxisSubLabels();
                            }

                            lastTick = axes.select("." + Classes.AXIS + "-x g.tick.last");
                            if (tinyScreen) {
                                xOriginalTicks = axes.selectAll("." + Classes.AXIS + "-x g.tick").filter(function () {
                                    return !d3.select(this).classed("artificial");
                                });

                                xOriginalTicks.style("opacity", 0);
                                lastTick.style("display", "inline");
                            } else {
                                lastTick.style("display", "none");
                            }

                            this.renderToolTip();

                            if (this.get("legend")) {
                                this.adjustLegendHeight();
                            }
                        },

                        /**
                         * @method appendAxisSubLabels
                         * @desc Appends axis Sub Labels
                         */
                        appendAxisSubLabels: function appendAxisSubLabels() {
                            var canvas = this.get("canvas");
                            var axes = canvas.get("axesGroup");
                            var xAxis = axes.selectAll("." + Classes.AXIS + "-x g.tick");
                            var xSubLabels = this.get("xSubLabels");
                            var xAxisOrient = this.get("xAxisOrient");

                            xAxis[0].forEach(function (tick, idx) {
                                if (xSubLabels[idx]) {
                                    d3.select(tick).append("text").text(function () {
                                        return xSubLabels[idx];
                                    }).attr("transform", function () {
                                        var y = xAxisOrient === "bottom" ? 28 : -18;
                                        return "translate(0, " + y + ")";
                                    }).attr("class", "mbc-tick-abbreviation");
                                }
                            });
                        },

                        /**
                         * @method updateTickWidths
                         * @desc calculate and update the y axis tick width
                         * @example
                         *
                         * chart.updateTickWidths()
                         *
                         *
                         * @return undefined
                         */
                        updateTickWidths: function updateTickWidths() {
                            var maxWidth = 0;
                            var ticks = [];
                            var el;

                            d3.selectAll(".mbc-axis.mbc-axis-y1 .tick text").each(function () {
                                el = d3.select(this);
                                ticks.push(el.text());
                            });
                            maxWidth = Utils.svg.getGreaterSVGTextWidth(this.get("canvas").get("svg"), ticks);
                            this.set("yTickSize", maxWidth + this.get("yTickMargin"));
                            this.set("ticksUpdated", true);
                            this.update({ noTicksRecalc: true });
                        },

                        /**
                         * @override
                         * @method draw
                         */
                        draw: function draw() {
                            this.buildScales();
                            this.buildAxes();
                            this.drawAxes();
                            this.drawLines();
                            this.drawBubbles();
                            this.drawBackgroundBars();
                            this.drawGrid();
                            this.drawClipPath();

                            if (this.get("timelineLevel")) {
                                this.helperSetSublabels();
                            }
                        },

                        /**
                         * @method drawLines
                         * @desc Graph the lines onto the chart for each dataset (y1 and y2 if used)
                         * @example
                         *
                         * chart.drawLines()
                         *
                         * @return undefined
                         */
                        drawLines: function drawLines() {
                            var _this = this;
                            var dataManager = this.get("data");
                            var scales = this.get("scales");
                            var canvas = this.get("canvas");
                            var layer = canvas.layer("line-chart-layer");
                            var xScale = scales.scale("x");
                            var yScale = scales.scale("y1");
                            var y2Scale = scales.scale("y2");
                            var isY2 = false;
                            var dottedLines = this.get('dottedLines');
                            var agileStyle = this.calculateAgileStyle();

                            var generateLine = d3.svg.line().defined(function (d) {
                                return d.value != null;
                            }).x(function (d) {
                                return xScale(d.date);
                            }).y(function (d) {
                                return isY2 === false ? yScale(d.value) - 1 : y2Scale(d.value) - 1; // compensate for line thickness
                            }).interpolate("linear");

                            var y1DomainDataset = this.get("y1DomainDataset");

                            //clear old lines on update
                            var y1Lines = layer.selectAll("path").filter(".y1").data(dataManager.get(y1DomainDataset));
                            this.checkForDataIslands(dataManager.get(y1DomainDataset), "y1");

                            y1Lines.classed({
                                line: true,
                                y1: true
                            }).attr("d", function (d) {
                                return generateLine(d.series);
                            }).attr("stroke", function (d) {
                                return _this.color(d.index);
                            }).attr("stroke-dasharray", function (d) {
                                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
                            }).attr("stroke-linecap", function (d) {
                                return dottedLines.indexOf(d.name) > -1 ? "round" : null;
                            }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

                            y1Lines.enter().append("path").classed({
                                line: true,
                                y1: true
                            }).attr("d", function (d) {
                                return generateLine(d.series);
                            }).attr("stroke", function (d) {
                                return _this.color(d.index);
                            }).attr("stroke-dasharray", function (d) {
                                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
                            }).attr("stroke-linecap", function (d) {
                                return dottedLines.indexOf(d.name) > -1 ? "round" : null;
                            }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

                            y1Lines.exit().remove();

                            if (this.get("y2")) {
                                isY2 = true;
                                var y2DomainDataset = this.get("y2DomainDataset");
                                var y2Lines = layer.selectAll("path").filter(".y2").data(dataManager.get(y2DomainDataset));

                                this.checkForDataIslands(dataManager.get(y2DomainDataset), "y2");

                                y2Lines.classed({
                                    line: true,
                                    y2: true
                                }).attr("d", function (d) {
                                    return generateLine(d.series);
                                }).attr("stroke", function (d) {
                                    return _this.color(d.index);
                                }).attr("stroke-dasharray", function (d) {
                                    return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
                                }).attr("stroke-linecap", function (d) {
                                    return dottedLines.indexOf(d.name) > -1 ? "round" : null;
                                }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

                                y2Lines.enter().append("path").classed({
                                    line: true,
                                    y2: true
                                }).attr("d", function (d) {
                                    return generateLine(d.series);
                                }).attr("stroke", function (d) {
                                    return _this.color(d.index);
                                }).attr("stroke-dasharray", function (d) {
                                    return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
                                }).attr("stroke-linecap", function (d) {
                                    return dottedLines.indexOf(d.name) > -1 ? "round" : null;
                                }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

                                y2Lines.exit().remove();
                            }
                        },

                        /**
                        * @method calculateAgileStyle
                        * @desc Calculate agile style for chart based on container size
                        * @return {Object} the agile style for chart.
                        */
                        calculateAgileStyle: function calculateAgileStyle() {
                            var xScale = this.get("scales").scale("x");
                            var xDomain = this.get("xDomain");
                            var yPadding = this.get("yPadding");
                            var bandLevel = this.get("greyBandLevel");
                            var tickArr;
                            if (bandLevel) {
                                tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
                            } else {
                                tickArr = xScale.ticks.apply(this, this.get("xTicks"));
                            }

                            var bubbleSpacing = (this.get("canvas").get('width') - yPadding) / tickArr.length;

                            var bubbleRadius = this.get("bubbleRadius"); // default: 4
                            var lineStrokeWidth = this.get("lineStrokeWidth"); // default: 2
                            var bubbleStrokeWidth = this.get("bubbleStrokeWidth"); // default: 2
                            var dottedDashDimensions = this.get("dottedDashDimensions"); // default: "1, 5"

                            var showBigBubbleMinWidth = 2 * (bubbleRadius + 4); // 4px: dot marging
                            var showSmallBubbleMinWidth = 2 * (bubbleRadius / 2 + 2); // 2px: dot marging

                            var agileStyle;
                            if (bubbleSpacing >= showBigBubbleMinWidth) {
                                agileStyle = {
                                    dottedDashDimensions: dottedDashDimensions,
                                    lineStrokeWidth: lineStrokeWidth,
                                    bubbleRadius: bubbleRadius,
                                    bubbleStrokeWidth: bubbleStrokeWidth,
                                    bubbleHeight: bubbleRadius,
                                    bubbleOpacity: 1
                                };
                            } else if (bubbleSpacing >= showSmallBubbleMinWidth) {
                                agileStyle = {
                                    dottedDashDimensions: "1, 3",
                                    lineStrokeWidth: lineStrokeWidth / 2,
                                    bubbleRadius: bubbleRadius / 2,
                                    bubbleStrokeWidth: bubbleStrokeWidth / 2,
                                    bubbleHeight: bubbleRadius / 2,
                                    bubbleOpacity: 1
                                };
                            } else {
                                agileStyle = {
                                    dottedDashDimensions: "1, 3",
                                    lineStrokeWidth: lineStrokeWidth / 2,
                                    bubbleRadius: bubbleRadius / 2,
                                    bubbleStrokeWidth: bubbleStrokeWidth / 2,
                                    bubbleHeight: bubbleRadius / 2,
                                    bubbleOpacity: 0
                                };
                            }
                            this.set("agileStyle", agileStyle);
                            return agileStyle;
                        },

                        /**
                         * @method drawBubbles
                         * @desc Graph the bubbles onto the line for each dataset (y1 and y2 if used)
                         * @example
                         *
                         * chart.drawBubbles()
                         *
                         * @return undefined
                         */
                        drawBubbles: function drawBubbles() {
                            var dataManager = this.get("data");
                            var scales = this.get("scales");
                            var y1Bubbled = this.get("y1Bubbled");
                            var y2Bubbled = this.get("y2Bubbled");

                            if (y1Bubbled) {
                                var y1DomainDataset = this.get("y1DomainDataset");
                                var y1LinesData = dataManager.get(y1DomainDataset);
                                var yScale = scales.scale("y1");
                                this.generateBubbles(y1LinesData, yScale);
                            }

                            if (this.get("y2") && y2Bubbled) {
                                var y2DomainDataset = this.get("y2DomainDataset");
                                var y2LinesData = dataManager.get(y2DomainDataset);
                                var y2Scale = scales.scale("y2");
                                this.generateBubbles(y2LinesData, y2Scale);
                            }
                        },

                        /**
                         * @method generateBubbles
                         * @param   {Object} linesData
                         * @param   {Function} yScale
                         * @desc Render the bubble dots for each datapoint
                         * @return undefined
                         */
                        generateBubbles: function generateBubbles(linesData, yScale) {
                            var _this = this;
                            var scales = this.get("scales");
                            var xScale = scales.scale("x");
                            var canvas = this.get("canvas");
                            var layer = canvas.layer("line-chart-layer").attr("clip-path", "url(#mbc-time-series-clip-mask)");
                            var dottedLines = this.get('dottedLines');
                            var agileStyle = this.get('agileStyle');
                            var bubbles;
                            linesData.forEach(function (item) {
                                bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
                                bubbles.attr("class", function (d) {
                                    return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
                                }).attr("cx", function (d) {
                                    return xScale(d.date);
                                }).attr("cy", function (d, i) {
                                    return yScale(d.value) - 1;
                                }).attr("r", function (d) {
                                    return d.value == null ? 0 : agileStyle.bubbleRadius;
                                }).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                                    return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
                                }).attr("opacity", function (d) {
                                    if (d.value == null || !agileStyle.bubbleOpacity) {
                                        return 0;
                                    }
                                });

                                bubbles.enter().append('circle').attr("class", function (d) {
                                    return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
                                }).attr("cx", function (d) {
                                    return xScale(d.date);
                                }).attr("cy", function (d, i) {
                                    return yScale(d.value) - 1;
                                }).attr("r", function (d) {
                                    return d.value == null ? 0 : agileStyle.bubbleRadius;
                                }).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                                    return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
                                }).attr("opacity", function (d) {
                                    if (d.value == null || !agileStyle.bubbleOpacity) {
                                        return 0;
                                    }
                                });

                                bubbles.exit().remove();
                            });
                        },

                        /**
                         * @method drawAxes
                         * @desc Call on the canvas to draw the axes and calls to build the labels
                         * @example
                         *
                         * chart.drawAxes()
                         *
                         * @return undefined
                         */
                        drawAxes: function drawAxes() {
                            var axes = this.get("axes");
                            var canvas = this.get("canvas");

                            canvas.drawAxes(axes);
                            this.drawAxesLabels();
                        },

                        /**
                         * @method drawAxesLabels
                         * @desc Invoke the appendLabel method with the label text set in config and the correct axis layer
                         *
                         * chart.drawAxesLabels()
                         *
                         * @return undefined
                         */
                        drawAxesLabels: function drawAxesLabels() {
                            var canvas = this.get("canvas");
                            var y1LabelText = this.get("y1AxisLabel");
                            var y2LabelText = this.get("y2AxisLabel");

                            canvas.layer(Classes.AXES + "-labels").remove();

                            var layer = canvas.layer(Classes.AXES + "-labels");
                            var y1Orient = this.get("y1AxisOrient");
                            var y2Orient = this.get("y2AxisOrient");
                            var containerTop = d3.select(".mbc-chart-legend.mbc-chart-legend-top");
                            var innerContainerRight = d3.select(".mbc-chart-legend-right-inner-div");
                            var oneRight = (y1Orient === "right" || y2Orient === "right") && (y1Orient !== "right" || y2Orient !== "right");
                            var zeroRight = y1Orient !== "right" && y2Orient !== "right";
                            var twoRight = y1Orient === "right" && y2Orient === "right";

                            if (y1LabelText) {
                                this.appendYLabel(layer, "y1", y1LabelText);
                            }

                            if (this.get("y2") && y2LabelText) {
                                this.appendYLabel(layer, "y2", y2LabelText);
                            }

                            if (y1LabelText || y2LabelText) {
                                if (zeroRight || oneRight) {
                                    containerTop.style("margin-left", "20px");
                                }
                            }

                            if (oneRight || twoRight) {
                                innerContainerRight.style("margin-left", "12px");
                            }
                        },

                        /**
                         * @method drawGrid
                         * @desc Draw the grid lines with the y axis ticks
                         * @example
                         *
                         * chart.drawGrid()
                         *
                         * @return undefined
                         */
                        drawGrid: function drawGrid() {
                            var scales = this.get("scales");
                            var y1Scale = scales.scale("y1");
                            var y1Axis = this.get("axes").axis("y1");
                            var yPadding = this.get("yPadding");
                            var canvas = this.get("canvas");
                            var tickValues = y1Axis.tickValues();
                            var backGroup = canvas.get("backGroup");
                            var grid = backGroup.selectAll("." + Classes.GRID_LINE).data(tickValues);
                            var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");

                            var extractor = function extractor(d) {
                                return y1Scale(d);
                            };

                            grid.enter().append("line").attrs({
                                x1: yPadding,
                                x2: canvas.width() - yPadding,
                                y1: extractor,
                                y2: extractor,
                                class: function _class(d, i) {
                                    var appendClass = "";
                                    if (i === 0) {
                                        appendClass = "first";
                                    }
                                    if (i === tickValues.length - 1) {
                                        appendClass = "last";
                                    }
                                    return Classes.GRID_LINE + " " + appendClass;
                                },
                                opacity: function opacity(d, i) {
                                    // if container's height is small, only show first and last grid line
                                    return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
                                }
                            });

                            grid.attrs({
                                x1: yPadding,
                                x2: canvas.width() - yPadding,
                                y1: extractor,
                                y2: extractor,
                                opacity: function opacity(d, i) {
                                    // if container's height is small, only show first and last grid line
                                    return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
                                }
                            });

                            grid.exit().remove();
                        },

                        /**
                         * @method drawClipPath
                         * @desc Chart svg includes clipping layer, clips lines and bubbles at edge of chart area
                         * @example
                         *
                         * chart.drawClipPath()
                         *
                         * @return undefined
                         */
                        drawClipPath: function drawClipPath() {
                            var canvas = this.get("canvas");
                            var svg = canvas.get("svg");
                            var layer = svg.select("." + Classes.BACK);
                            var layerBBox = layer.node().getBBox();

                            svg.insert("defs", ":first-child").append("clipPath").attr("id", "mbc-time-series-clip-mask").append("rect").attr({
                                x: layerBBox.x,
                                y: layerBBox.y,
                                width: layerBBox.width,
                                height: layerBBox.height
                            });
                        },

                        /**
                         * @method drawBackgroundBars
                         * @desc Draw the alternating background bars that follow the x-axis ticks on the grid
                         * @example
                         *
                         * chart.drawBackgroundBars()
                         *
                         * @return undefined
                         */
                        drawBackgroundBars: function drawBackgroundBars() {
                            var scales = this.get("scales");
                            var canvas = this.get("canvas");
                            var backGroup = canvas.get("backGroup");
                            var xScale = scales.scale("x");
                            var xDomain = this.get("xDomain");
                            var yPadding = this.get("yPadding");
                            var bandLevel = this.get("greyBandLevel");
                            var tickArr;

                            if (bandLevel) {
                                tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
                            } else {
                                tickArr = xScale.ticks.apply(this, this.get("xTicks"));
                            }

                            var bars = backGroup.selectAll("rect").data(tickArr);
                            var fnWidth = function fnWidth(d, i) {
                                if (i + 1 === tickArr.length) {
                                    return canvas.width() - yPadding - xScale(tickArr[i]);
                                } else {
                                    return xScale(tickArr[i + 1]) - xScale(tickArr[i]);
                                }
                            };

                            // Update Selection
                            bars.attrs({
                                class: "grid__bars",
                                x: xScale,
                                y: 0,
                                height: canvas.height(),
                                width: fnWidth
                            }).style("overflow", "hidden");

                            // Enter Selection
                            bars.enter().append("rect").attrs({
                                class: "grid__bars",
                                x: xScale,
                                y: 0,
                                height: canvas.height(),
                                width: fnWidth
                            }).style("overflow", "hidden");

                            // Exit Selection
                            bars.exit().remove();
                        },

                        /**
                         * @method buildAxes
                         * @desc Build all of the axes
                         * @example
                         *
                         * chart.buildAxes()
                         *
                         * @return undefined
                         */
                        buildAxes: function buildAxes() {
                            var _this = this;
                            var scales = this.get("scales");
                            var axes = this.get("axes");
                            var calculatedTicksY1 = Utils.getTickValues(this.get("y1Domain"), this.get("ticksNumber"));
                            var y1TickValues = this.get("y1TickValues") || this.get("tickValues") || calculatedTicksY1;
                            var xScale = scales.scale("x");

                            var tickFormat = function tickFormat(symbol, length, formatFn) {
                                return function (d, i) {
                                    var value = _this.tickFormat(formatFn)(d);
                                    value = Utils.string.convertDashToEnDash(value);
                                    return symbol && i === length - 1 ? symbol + value : value;
                                };
                            };

                            var xAxis = d3.svg.axis().scale(xScale).orient(this.get("xAxisOrient")).tickSize(this.get("xTickSize")).tickFormat(this.get("_xTickFormat")).ticks.apply(this, this.get("_xTicks"));

                            var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y1TickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), y1TickValues.length, this.get("y1TickFormat")));

                            axes.axis("x", xAxis);
                            axes.axis("y1", yAxis);

                            if (this.get("y2")) {
                                var calculatedTicksY2 = Utils.getTickValues(this.get("y2Domain"), this.get("ticksNumber"));
                                var y2TickValues = this.get("y2TickValues") || this.get("tickValues") || calculatedTicksY2;

                                axes.axis("y2", d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y2TickValues).tickFormat(tickFormat(this.get("y2TickSymbol"), y2TickValues.length, this.get("y2TickFormat"))));
                            }
                        },

                        /**
                         * @method buildScales
                         * @desc Invoke the calculateDomain method and build all of the scales
                         * @example
                         *
                         * chart.buildScales()
                         *
                         * @return undefined
                         */
                        buildScales: function buildScales() {
                            this.calculateDomain();
                            var scales = this.get("scales");
                            var canvas = this.get("canvas");
                            var yPadding = this.get("yPadding");

                            var xScale = d3.time.scale().domain(this.get("xDomain")).rangeRound([yPadding, canvas.width() - yPadding - 1]);

                            var y1TickValues = this.get("y1TickValues") || this.get("tickValues");
                            var y1Domain = y1TickValues ? [d3.min(y1TickValues), d3.max(y1TickValues)] : this.get("y1Domain");
                            var yScale = d3.scale.linear().domain(y1Domain).range([canvas.height(), 0]);

                            scales.scale("x", xScale);
                            scales.scale("y1", yScale);

                            if (this.get("y2")) {
                                var y2TickValues = this.get("y2TickValues") || this.get("tickValues");
                                var y2Domain = y2TickValues ? [d3.min(y2TickValues), d3.max(y2TickValues)] : this.get("y2Domain");
                                scales.scale("y2", d3.scale.linear().domain(y2Domain).range([canvas.height(), 0]));
                            }
                        },

                        /**
                         * @method calculateDomain
                         * @desc Takes the values in the datasets and calculates the domain, setting them as:
                         * y1Domain, y2Domain, xDomain
                         *
                         * @example
                         *
                         * chart.calculateDomain()
                         *
                         * @return undefined
                         */
                        calculateDomain: function calculateDomain() {
                            var dataManager = this.get("data");
                            var y1DomainDataset = this.get("y1DomainDataset");
                            var y1 = dataManager.get(y1DomainDataset);
                            var y1Symmetrical = this.get("y1Symmetrical");
                            var y1DataSet = [];
                            var xDataSet = [];

                            y1.forEach(function (dataset) {
                                dataset.series.forEach(function (segment) {
                                    xDataSet.push(segment.date);
                                    y1DataSet.push(segment.value);
                                });
                            });

                            var adjustedY1Domain = this.adjustYDomain(y1DataSet, y1Symmetrical);
                            this.set("y1Domain", adjustedY1Domain);

                            if (this.get("y2")) {
                                var y2DomainDataset = this.get("y2DomainDataset");
                                var y2 = dataManager.get(y2DomainDataset);
                                var y2Symmetrical = this.get("y2Symmetrical");
                                var y2DataSet = [];

                                y2.forEach(function (dataset) {
                                    dataset.series.forEach(function (segment) {
                                        xDataSet.push(segment.date);
                                        y2DataSet.push(segment.value);
                                    });
                                });

                                var adjustedY2Domain = this.adjustYDomain(y2DataSet, y2Symmetrical);
                                this.set("y2Domain", adjustedY2Domain);
                            }

                            var adjustedXDomain = this.adjustXDomain(xDataSet);

                            this.set("xDomain", adjustedXDomain);
                        },

                        /**
                         * @method  adjustXDomain
                         * @desc    Calculate and return a buffer for the x domain
                         *
                         * @example
                         *      var adjustedY1Domain = this.adjustXDomain(dataset)
                         * @param   {Object} dataset
                         *
                         * @return  {Array} extent
                         */
                        adjustXDomain: function adjustXDomain(dataset) {
                            // add buffer spacing between datapoints and axix
                            var xAxisStart = this.get("xAxisStart");
                            var xAxisBuffer = this.get("xAxisBuffer");
                            var xAxisEnd = this.get("xAxisEnd");

                            var extent = d3.extent(dataset);

                            if (this.get("xAxisStart")) {
                                extent[0] = xAxisStart;
                            }

                            if (this.get("xAxisEnd")) {
                                extent[1] = xAxisEnd;
                            }

                            if (!xAxisBuffer) {
                                return extent;
                            }

                            if (xAxisBuffer.start) {
                                extent[0] = this.helperXBuffer(extent[0], xAxisBuffer.start);
                            }

                            if (xAxisBuffer.end) {
                                extent[1] = this.helperXBuffer(extent[1], xAxisBuffer.end);
                            }

                            return extent;
                        },

                        /**
                         * @method  adjustYDomain
                         * @desc    Calculate and return a buffer for the y domain
                         *
                         * @example
                         *      var adjustedY1Domain = this.adjustYDomain(dataset)
                         * @param   {Object} dataset
                         *
                         * @return  {Array} extent
                         */
                        adjustYDomain: function adjustYDomain(dataset, symmetrical) {
                            // add buffer spacing between datapoints and axix
                            var extent = d3.extent(dataset);
                            var range = extent[1] - extent[0];
                            var adjusted = [Math.floor(extent[0] - range * 0.05), Math.ceil(extent[1] + range * 0.05)];
                            if (symmetrical) {
                                return this.makeSymmetrical(adjusted);
                            }

                            return adjusted;
                        },

                        /**
                         * @method getMargins
                         * @desc Calculate and return the margins for the chart
                         *
                         * @example
                         *
                         * var margins = chart.getMargins();
                         * var leftMargin = margins.left;
                         * @return {Object}
                         */
                        getMargins: function getMargins() {
                            var y1AxisOrient = this.get("y1AxisOrient");
                            var y2AxisOrient = this.get("y2AxisOrient");
                            var yTickSize = this.get("yTickSize");
                            var canvas = this.get("canvas");
                            var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
                            var yAxesSpacing = this.get("yAxesSpacing");
                            var margin = {
                                top: 5,
                                right: 0,
                                bottom: 25,
                                left: yTickSize + yAxesLabelWidth
                            };

                            if (this.get("y2")) {
                                if (y1AxisOrient === "left" && y2AxisOrient === "left") {
                                    margin.left = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
                                } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
                                    margin.right = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
                                    margin.left = 0;
                                } else {
                                    margin.right = yTickSize + yAxesLabelWidth;
                                }
                            } else if (y1AxisOrient === "right") {
                                margin.right = yTickSize + yAxesLabelWidth;
                                margin.left = 0;
                            }

                            if (this.get("xAxisOrient") === "top") {
                                margin.top = 30;
                                margin.bottom = 0;
                            } else {
                                margin.top = 5;
                                margin.bottom = this.get("xLabels") ? 45 : 35;
                            }

                            return margin;
                        },

                        /**
                         * @method checkBreakpoints
                         * @desc Checks if a set breakpoint has been met with the grid and invokes the
                         * redoCanvas method if so
                         * @param {Number} newValue
                         * @param {Number} oldValue
                         *
                         * @example
                         *  canvas.watch("outerWidth", function (newValue, oldValue) {
                                this.checkBreakpoints(newValue, oldValue);
                            }.bind(this));
                          * @return undefined
                         */
                        checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
                            var dw = newValue > oldValue;
                            var breakpoint = this.get("breakpoint");
                            if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
                                this.redoCanvas();
                            }
                        },

                        /**
                         * @method setCanvasTemplate
                         * @desc set the canvas template which is used in beforeCanvas from grid core
                         * @param {Number} width
                         *
                         * @example
                         *
                         *  this.setCanvasTemplate(selection[0][0].offsetWidth);
                         * @return undefined
                         */
                        setCanvasTemplate: function setCanvasTemplate(width) {
                            var template;
                            if (this.get("legend")) {
                                if (width > this.get("breakpoint")) {
                                    template = "<div class=\"" + Classes.INNER + " " + Classes.INNER + "-right\"></div>\n                    <div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-right\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>";
                                } else {
                                    template = "<div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-top\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>\n                <div class=\"" + Classes.INNER + " " + Classes.INNER + "-top\"></div>";
                                }
                            }

                            this.set("canvasTemplate", template);
                        },

                        // @IMPLEMENTED
                        // Do something before canvas render.
                        beforeCanvas: function beforeCanvas(selection) {
                            this.setCanvasTemplate(selection[0][0].offsetWidth);
                        },

                        /**
                         * @method redoCanvas
                         * @desc Removes the canvas, resets the template, and then re-renders the canvas
                         *
                         * @example
                         *
                         *  chart.redoCanvas
                         * @return undefined
                         */
                        redoCanvas: function redoCanvas() {
                            var canvas = this.get("canvas");
                            canvas.remove();
                            this.set("initialized", false);

                            this.setCanvasTemplate();
                            this._createCanvas();
                        },

                        /**
                         * Reloads all the chart's data.
                         * @param {Object} dataset Initial dataset object.
                         */
                        data: function data(dataset) {
                            this.get("data").clean();
                            this.setData(dataset);
                            this.redoCanvas();
                            this.update();
                            return this;
                        },

                        /**
                         * @method add
                         * @description Add a series to the chart
                          * @param {Object} series Object {name: <name of the series>, values: <Array of values for the series>}
                         * @param {String} groupName - name of the dataset group
                         * @example
                         * chart.add({
                         *      name: "Apple Inc.",
                         *      values: [{}, {}]
                         * })
                         * @return {this}
                         */
                        add: function add(name, series, groupName) {
                            this.get("data").set(name, series, groupName);
                            this.redoCanvas();
                            this.update();

                            return this;
                        },

                        /**
                         * @method remove
                         * @description Removes a series from the chart.
                         * @param {String} seriesName Name of the series to remove from the chart.
                         * @return {this}
                         */
                        remove: function remove(seriesName) {
                            this.get("data").remove(seriesName);
                            this.redoCanvas();
                            this.update();
                            return this;
                        }

                    });

                    module.exports = TimeSeriesLineChart;

                    /***/
                }

                /******/ })
        );
    });

    /***/
},
/* 9 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecPerformanceGraph', __webpack_require__(5).ecPerformanceGraph);
        __webpack_require__(4);
        __webpack_require__(2);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 10 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
}]
/******/);
//# sourceMappingURL=ec-performance-graph.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 19);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 1 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(20), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, editHoldingsHelper, inputDatapointMapping) {
        'use strict';

        var transformHelper = {
            generateIWTPostData: generateIWTPostData,
            generateIWTFeesPostData: generateIWTFeesPostData,
            generatePAAPIPortfolios: generatePAAPIPortfolios,
            generateEditHoldings: generateEditHoldings,
            generateBaseUrl: generateBaseUrl,
            handleIWTReturnData: handleIWTReturnData,
            generatePAAPIUrlParameters: generatePAAPIUrlParameters,
            getAssetClassGroupId: getAssetClassGroupId,
            getBenchmarkId: getBenchmarkId,
            addAsOfDate: addAsOfDate,
            benchmarkHandlerOfUS: benchmarkHandlerOfUS
        };

        angular.module('ecPortfolioData').factory('portfolioDataTransformHelperService', function () {
            return transformHelper;
        });

        return transformHelper;

        function generateIWTPostData(context, parameters, type) {
            var portfolio = null;
            if (type) {
                portfolio = parameters.portfolio[type];
            } else {
                portfolio = parameters.portfolio;
            }

            return {
                parameters: formatIWTAPIParameters(context, portfolio),
                requestData: formatIWTAPIRequestData(context, portfolio)
            };
        }

        function generateIWTFeesPostData(context, parameters, type) {
            var portfolio = null;
            if (type) {
                portfolio = parameters.portfolio[type];
            } else {
                portfolio = parameters.portfolio;
            }

            var portfoliofeesSettings = parameters.feesSettings,
                holdings = portfolio.holdings || [],
                holdingType = editHoldingsHelper.generateHoldingType(holdings),
                totalAmount = editHoldingsHelper.calculateTotalAmount(holdings),
                newPortfolio = {
                id: type || 'default',
                amount: 10000,
                holdings: []
            };
            portfoliofeesSettings.portfolios = [];
            if (holdingType === 'amount') {
                _.each(holdings, function (holding) {
                    holding.weight = holding.amount / totalAmount * 100.0;
                });
            }
            updateCashFundAttributes(context, holdings);
            _.each(holdings, function (item) {
                var holding = {
                    identifier: item.identifier,
                    identifierType: item.identifierType,
                    weight: item.weight,
                    initial: item.initial || {},
                    ongoing: item.ongoing || [{
                        name: 'Ongoing'
                    }, {
                        name: 'Transaction'
                    }, {
                        name: 'Performance'
                    }]
                };
                newPortfolio.holdings.push(holding);
            });
            portfoliofeesSettings.portfolios.push(newPortfolio);

            return {
                parameters: formatIWTAPIParameters(context, portfolio),
                requestData: portfoliofeesSettings
            };
        }

        function formatIWTAPIParameters(context, portfolio) {
            var apiRunOption = 'RunInThread',
                portfolioDataPoints = [apiRunOption],
                holdingDataPoints = [apiRunOption],
                benchmarkDataPoints = [apiRunOption],
                apiDataPointsSchema = context.settings.get('apiDataPointsSchema') || [],
                apiDataPointsSchemaFields = context.settings.get('apiDataPointsSchemaFieldDefinitions') || {},
                hasBenchmark = isHasBenchmark(portfolio);
            morningstar.asterix.util.each(apiDataPointsSchema, function (item) {
                var data = apiDataPointsSchemaFields[item] || {};
                if (data.portfolioDataPoints) {
                    portfolioDataPoints.push(data.portfolioDataPoints);
                }

                if (data.holdingDataPoints) {
                    holdingDataPoints.push(data.holdingDataPoints);
                }

                if (data.benchmarkDataPoints && hasBenchmark) {
                    benchmarkDataPoints.push(data.benchmarkDataPoints);
                }
            });

            return {
                portfolioDataPoints: _.uniq(portfolioDataPoints).join(),
                holdingDataPoints: _.uniq(holdingDataPoints).join(),
                benchmarkDataPoints: _.uniq(benchmarkDataPoints).join(),
                urlKey: context.settings.get('urlKey'),
                languageId: context.settings.get('languageId'),
                baseUrl: generateBaseUrl(context, 'EU')
            };
        }

        function formatIWTAPIRequestData(context, portfolio) {
            var holdings = portfolio.holdings || [],
                holdingType = editHoldingsHelper.generateHoldingType(holdings),
                holdingTypeValue;

            if (holdingType === 'amount') {
                holdingTypeValue = 3;
            } else if (holdingType === 'units') {
                holdingTypeValue = 9;
            } else {
                holdingTypeValue = 2;
            }

            updateCashFundAttributes(context, holdings);

            return JSON.stringify(JSON.stringify({
                type: holdingTypeValue,
                benchmarkId: morningstar.asterix.util.parse('benchmark.holdings[0].identifier')(portfolio) || null,
                currencyId: portfolio.currencyId || context.settings.get('currencyId'),
                holdings: holdings
            }));
        }

        function generatePAAPIPortfolios(context, portfolio) {
            var portfolios = [];

            if (portfolio) {
                if (!portfolio.current && !portfolio.proposed) {
                    portfolios.push(formatPortfolio(context, portfolio));
                } else {
                    if (portfolio.current) {
                        portfolios.push(formatPortfolio(context, portfolio.current));
                    }
                    if (portfolio.proposed) {
                        portfolios.push(formatPortfolio(context, portfolio.proposed));
                    }
                }
            }

            return portfolios;
        }

        function formatHolding(holding, holdingType) {
            var newHolding,
                identifierTypeMapping = morningstar.asterix.util.filter(inputDatapointMapping.identifierTypePAAPI, function (e) {
                return e.key === holding.identifierType.toLowerCase();
            });

            if (holdingType === 'weight') {
                newHolding = {
                    Weight: holding.weight
                };
            } else if (holdingType === 'units') {
                newHolding = {
                    units: holding.units
                };
            } else {
                newHolding = {
                    Value: holding.amount
                };
            }

            if (identifierTypeMapping.length > 0) {
                newHolding[identifierTypeMapping[0].value] = holding.identifier;
            }

            return newHolding;
        }

        function formatPortfolio(context, portfolio) {
            var holdings = portfolio.holdings || [],
                benchmark = portfolio.benchmark,
                currencyId = portfolio.currencyId || context.settings.get('currencyId'),
                apiHoldings = [],
                apiBenchmark,
                holdingType = editHoldingsHelper.generateHoldingType(holdings);

            _.each(holdings, function (item) {
                apiHoldings.push(formatHolding(item, holdingType));
            });

            if (benchmark && benchmark.type) {
                if (benchmark.holdings && benchmark.holdings.length > 0) {
                    apiBenchmark = {
                        Type: benchmark.type,
                        Holdings: []
                    };
                    _.each(benchmark.holdings, function (item) {
                        apiBenchmark.Holdings.push(formatHolding(item, 'weight'));
                    });
                } else {
                    apiBenchmark = {
                        Type: benchmark.type
                    };
                }
            }

            return {
                Name: portfolio.name || 'Test Portfolio',
                TotalValue: portfolio.totalValue,
                Currency: currencyId,
                Holdings: apiHoldings,
                Benchmark: apiBenchmark
            };
        }

        function generateEditHoldings(context, editHoldings, portfolioType) {
            var portfolio = getPortfolio(context, portfolioType),
                holdingsType = editHoldingsHelper.generateHoldingType(portfolio.holdings),
                newEditHoldings = editHoldingsHelper.generateHoldings(editHoldings, holdingsType);

            updateCashFundAttributes(context, newEditHoldings);
            newEditHoldings.totalAmount = portfolio.totalValue;

            return newEditHoldings;
        }

        function updateCashFundAttributes(context, holdings) {
            var cashItem = _.find(holdings, function (item) {
                return item.identifier && item.identifier.toLowerCase().indexOf('cash') > -1;
            });
            if (cashItem) {
                cashItem.holdingTypeId = context.settings.get('cashHoldingTypeId');
                cashItem.securityType = context.settings.get('cashSecurityType');
            }
        }

        function generateBaseUrl(context, region) {
            if (morningstar.asterix.context.getToken('apiGatewayToken')) {
                return context.settings.get('baseUrlApiGateway' + region);
            } else {
                return context.settings.get('baseUrlMorningstar' + region);
            }
        }

        function handleIWTReturnData(context, retData, portfolioType) {
            // If there is no holdings in API input, just return empty object.
            var holdings = getPortfolio(context, portfolioType).holdings || [];
            if (holdings.length === 0) {
                return {};
            } else {
                return retData || {};
            }
        }

        function getPortfolio(context, portfolioType) {
            var portfolio = morningstar.asterix.extend(true, {}, morningstar.asterix.util.parse('parameters.portfolio')(context) || {});
            return portfolioType ? portfolio[portfolioType] || {} : portfolio;
        }

        function generatePAAPIUrlParameters(context) {
            var urlParameters = generateBaseUrlAndTokenParameters(context);
            urlParameters.languageId = context.settings.get('languageId');
            return urlParameters;
        }

        function getAssetClassGroupId(context) {
            var assetAllocationType = context.settings.get('assetAllocationType');
            return inputDatapointMapping.AssetClassGroupIdMapping[assetAllocationType] || assetAllocationType;
        }

        function generateBaseUrlAndTokenParameters(context) {
            var apiGatewayToken = morningstar.asterix.context.getToken('apiGatewayToken'),
                apiKey = morningstar.asterix.context.getToken('apiKey'),
                accessToken = morningstar.asterix.context.getToken('accessToken'),
                urlParameters = {};

            if (!(apiGatewayToken || apiKey || accessToken)) {
                context.instance.getLogger().fatal('Missing authentication key: apiGatewayToken or apiKey or accessToken.');
            }

            urlParameters.baseUrl = generateBaseUrl(context, 'US');
            if (apiGatewayToken) {
                urlParameters.apiTokenType = '';
                urlParameters.apiTokenValue = '';
            } else {
                if (accessToken) {
                    urlParameters.apiTokenType = 'access_token';
                    urlParameters.apiTokenValue = accessToken;
                } else if (apiKey) {
                    urlParameters.apiTokenType = 'apikey';
                    urlParameters.apiTokenValue = apiKey;
                }
            }
            return urlParameters;
        }

        function getBenchmarkId(portfolio) {
            return morningstar.asterix.util.parse('benchmarkId')(portfolio) || morningstar.asterix.util.parse('benchmark.holdings[0].identifier')(portfolio);
        }

        function addAsOfDate(context, data, asOfDate) {
            if (data && asOfDate) {
                var returnDataSections = context.settings.get('returnDataSections') || [];
                var date = morningstar.asterix.util.date.convertToStandard(new Date(asOfDate));
                if (data && _.indexOf(returnDataSections, 'asOfDate') > -1) {
                    _.each(data, function (value) {
                        if (_.isObject(value)) {
                            value.asOfDate = date;
                        }
                    });
                    data.asOfDate = date;
                }
            }
            return data;
        }

        function benchmarkHandlerOfUS(xray, securityReference, context, data, portfolioType) {
            if (!data) {
                return data;
            }
            // if there is no benchmark in API input, remove the response of benchmark from back end.
            var portfolio = getPortfolio(context, portfolioType);
            var hasBenchmark = isHasBenchmark(portfolio);
            if (!hasBenchmark) {
                _.each(data, function (value, key) {
                    switch (key) {
                        case 'assetAllocation':
                        case 'feesExpenses':
                        case 'interestRateRisk':
                        case 'sectorsBreakdown':
                        case 'stockRegions':
                        case 'stockStatistics':
                            value.benchmark = {};
                            break;
                        case 'performanceChart':
                            removePerformanceChartBenchmark(data[key]);
                            break;
                        case 'trailingPerformance':
                            removeTrailingPerBenchmark(data[key]);
                            break;
                        default:
                            break;
                    }
                });
            } else {
                var benchmarkId = morningstar.asterix.util.parse('PortfolioBenchmark.Holdings[0].SecurityId')(xray) || null;
                var benchmarkSecurity = _.find(securityReference, function (item) {
                    return item.SecurityId === benchmarkId;
                }) || {};
                var benchmarkName = benchmarkSecurity.Name;

                data.benchmark = {
                    benchmarkId: benchmarkId,
                    benchmarkName: benchmarkName || null
                };
                //add benchmarkName to performanceChart
                if (benchmarkName) {
                    var performanceChart = data.performanceChart;
                    if (performanceChart) {
                        var benchmark = performanceChart.monthly.series[1];
                        benchmark.name = benchmarkName;
                        benchmark.useLabel = false;
                    }
                }
            }
            return data;
        }

        function removePerformanceChartBenchmark(data) {
            if (data.monthly && data.monthly.series && data.monthly.series.length !== 0) {
                _.each(data.monthly.series, function (v) {
                    if (v.name === 'benchmark') {
                        v.data = [];
                    }
                });
            }
        }

        function removeTrailingPerBenchmark(data) {
            if (data && data.length !== 0) {
                _.each(data, function (v) {
                    v.benchmark = null;
                });
            }
        }

        function isHasBenchmark(portfolio) {
            return morningstar.asterix.util.parse('benchmark.holdings[0].identifier')(portfolio) ? true : false;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 3 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
        'use strict';

        angular.module('ecPortfolioData', ['mstarCore']).directive('ecPortfolioData', portfolioData);

        function portfolioData() {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {},
                template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
                link: linkFn
            };

            function linkFn(scope, elem, attr, mstarComponent) {
                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // compiles the main template
                mstarComponent.compileTemplate(scope, '_templates.main');

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
                mstarComponent.bindModelData(scope);

                // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
        'use strict';

        var usageTrackerHelper = {
            generateUsageTracker: generateUsageTracker,
            generateUsageTrackerForHoldings: generateUsageTrackerForHoldings
        };

        angular.module('ecPortfolioData').factory('portfolioDataUsageTrackerHelperService', function () {
            return usageTrackerHelper;
        });

        function getIdentifierWeightOrAmountVal(value) {
            var weightOrAmount = void 0,
                val = void 0;
            if (value.weight) {
                weightOrAmount = 'weight';
                val = value.weight;
            } else if (value.amount) {
                weightOrAmount = 'amount';
                val = value.amount;
            }
            return {
                weightOrAmount: weightOrAmount,
                val: val
            };
        }

        function getIdentifierWeightOrAmount(value) {
            var _getIdentifierWeightO = getIdentifierWeightOrAmountVal(value),
                weightOrAmount = _getIdentifierWeightO.weightOrAmount,
                val = _getIdentifierWeightO.val;

            return value.identifier + '|' + weightOrAmount + ':' + val;
        }

        function getUsageInfo(value) {
            var identifierWeightOrAmountList = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var v = _step.value;

                    identifierWeightOrAmountList.push(getIdentifierWeightOrAmount(v));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return identifierWeightOrAmountList.join(', ');
        }

        function generateUsageTracker(hitObj, value) {
            if (!hitObj || !value) {
                return hitObj || {};
            }
            var usageInfo = void 0;
            if (_.isString(value)) {
                usageInfo = value;
            } else if (_.isArray(value)) {
                usageInfo = getUsageInfo(value);
            } else if (_.isObject(value)) {
                var holdings = value.holdings;
                if (holdings && holdings.length) {
                    // generate pdf report, only recording holdings
                    usageInfo = getUsageInfo(holdings);
                } else {
                    usageInfo = getIdentifierWeightOrAmount(value);
                }
            }
            hitObj.value = usageInfo;
            return hitObj;
        }

        function generateUsageTrackerForHoldings(hitMap, newHoldings, oldHoldings, portfolioType) {
            var differenceHoldings,
                differenceIdentifiers,
                hitObj,
                newIdentifiers = _.map(newHoldings, function (holding) {
                return holding.identifier;
            }),
                oldIdentifiers = _.map(oldHoldings, function (holding) {
                return holding.identifier;
            });
            if (newHoldings.length === oldHoldings.length) {
                differenceIdentifiers = _.difference(newIdentifiers, oldIdentifiers);
                differenceHoldings = _.find(newHoldings, function (holding) {
                    return holding.identifier === differenceIdentifiers[0];
                });

                hitObj = generateUsageTracker(morningstar.asterix.util.parse(portfolioType ? portfolioType + 'InvestmentChanged' : 'investmentChanged')(hitMap), differenceHoldings);
            } else if (newHoldings.length > oldHoldings.length) {
                differenceIdentifiers = _.difference(newIdentifiers, oldIdentifiers);
                differenceHoldings = _.find(newHoldings, function (holding) {
                    return holding.identifier === differenceIdentifiers[0];
                });
                hitObj = generateUsageTracker(morningstar.asterix.util.parse(portfolioType ? portfolioType + 'InvestmentAdded' : 'investmentAdded')(hitMap), differenceHoldings);
            } else {
                differenceIdentifiers = _.difference(oldIdentifiers, newIdentifiers);
                differenceHoldings = _.find(oldHoldings, function (holding) {
                    return holding.identifier === differenceIdentifiers[0];
                });
                hitObj = generateUsageTracker(morningstar.asterix.util.parse(portfolioType ? portfolioType + 'InvestmentRemoved' : 'investmentRemoved')(hitMap), differenceHoldings);
            }
            return hitObj;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 6 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromIwtFees', function (feesDatas) {
            return formatIwtfeesData(this.context, feesDatas);
        });

        function formatIwtfeesData(context, feesDatas) {
            feesDatas = feesDatas || [];

            var fromFeesData = {
                portfolioFeesSummary: generatePortfolioFeesSummaryModel(feesDatas[0]),
                holdingsFeesSummary: {
                    holdings: generateHoldingsFeesSummaryModel(morningstar.asterix.util.parse('holdingFees')(feesDatas[0]))
                }
            };

            function findDataValue(datas, name, dataPoint) {
                var data = _.find(datas, function (item) {
                    return item.name === name;
                }) || {};
                return data[dataPoint] || null;
            }

            function formatFeesValue(value, formatOptions) {
                var numberFormat = context.format.number;
                return numberFormat(value, formatOptions || 'shortDecimal');
            }

            function generatePortfolioFeesSummaryModel(portfolioFeesData) {
                portfolioFeesData = portfolioFeesData || {};
                var portfolioFees = {
                    breakdown: []
                },
                    summary = portfolioFeesData.summary || {},
                    totalCosts = portfolioFeesData.totalCosts || {},
                    initialCosts = portfolioFeesData.initialCosts || {},
                    outputDataPoints = morningstar.asterix.util.parse('portfolioFees.outputDataPoints')(context.settings.get('apiDataPointsSchemaFieldDefinitions')) || {};

                _.each(outputDataPoints, function (item) {
                    portfolioFees.breakdown.push({
                        feesExpensesKey: item.key,
                        expenses: formatFeesValue(summary[item.key] || totalCosts[item.key] || initialCosts[item.key] || null, item.format)
                    });
                });

                return portfolioFees;
            }

            function generateHoldingsFeesSummaryModel(holdingFeesData) {
                var holdingFees = [];
                _.each(holdingFeesData, function (data) {
                    var recurringTotalBreakdown = morningstar.asterix.util.parse('breakdown.recurringTotal.breakdown')(data),
                        holdingFee = {
                        secId: data.secId || null,
                        name: data.name || null,
                        initialAmount: morningstar.asterix.util.parse('breakdown.initial.amount')(data) || null,
                        initialPercentage: morningstar.asterix.util.parse('breakdown.initial.percentage')(data) || null,
                        recurringFeeOngoingAmount: findDataValue(recurringTotalBreakdown, 'Ongoing', 'amount'),
                        recurringFeeOngoingPercentage: findDataValue(recurringTotalBreakdown, 'Ongoing', 'percentage'),
                        recurringFeeTransactionAmount: findDataValue(recurringTotalBreakdown, 'Transaction', 'amount'),
                        recurringFeeTransactionPercentage: findDataValue(recurringTotalBreakdown, 'Transaction', 'percentage'),
                        recurringFeePerformanceAmount: findDataValue(recurringTotalBreakdown, 'Performance', 'amount'),
                        recurringFeePerformancePercentage: findDataValue(recurringTotalBreakdown, 'Performance', 'percentage')
                    };
                    holdingFees.push(holdingFee);
                });
                return holdingFees;
            }

            return fromFeesData;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromIwtPortfolioComparisonReportInfo', function (parameters) {
            var reportPortfolios = [],
                context = this.context;

            _.each(['current', 'proposed'], function (portfolioType) {
                var postData = helper.generateIWTPostData(context, parameters, portfolioType) || {},
                    requestData = JSON.parse(JSON.parse(postData.requestData));
                reportPortfolios.push({
                    type: requestData.type,
                    holdings: requestData.holdings,
                    benchmarkId: requestData.benchmarkId,
                    currencyId: requestData.currencyId
                });
            });

            return reportPortfolios;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 8 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper, dataPointMapping) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromIwtXray', function (xrayData) {
            return formatIwtXrayData(this.context, xrayData);
        });

        morningstar.asterix.ng.transforms.register('fromIwtXrayCurrent', function (xrayData) {
            return formatIwtXrayData(this.context, xrayData, 'current');
        });

        morningstar.asterix.ng.transforms.register('fromIwtXrayProposed', function (xrayData) {
            return formatIwtXrayData(this.context, xrayData, 'proposed');
        });

        function formatIwtXrayData(context, xrayData, portfolioType) {
            if (!_.isObject(xrayData)) {
                xrayData = {};
            } else {
                xrayData = helper.handleIWTReturnData(context, xrayData, portfolioType);
            }

            var fromXrayData = {},
                returnDataSections = context.settings.get('returnDataSections'),
                holdingsData = getRawSectionData('holdings'),
                historicalPerformanceSeries = getRawSectionData('historicalPerformanceSeries');
            _.each(returnDataSections, function (section) {
                switch (section) {
                    case 'assetAllocation':
                        var assetAllocationData = getRawSectionData('assetAllocation');
                        fromXrayData.assetAllocation = generateAssetAllocationModel(assetAllocationData);
                        break;
                    case 'calendarYearsReturns':
                        fromXrayData.calendarYearsReturns = generateCalendarYearsReturnsModel(historicalPerformanceSeries, { timePeriod: 'M12', frequency: 'Annual' });
                        break;
                    case 'correlationMatrix':
                        var correlationMatrixData = getRawSectionData('correlationMatrix');
                        fromXrayData.correlationMatrix = generateCorrelationMatrixModel(correlationMatrixData.breakdown, holdingsData.breakdown);
                        break;
                    case 'creditQuality':
                        var creditQualityData = getRawSectionData('creditQuality');
                        fromXrayData.creditQuality = creditQualityData;
                        break;
                    case 'editHoldings':
                        fromXrayData.editHoldings = generateEditHoldingsModel(holdingsData.breakdown, portfolioType);
                        break;
                    case 'equityStyleBox':
                        var equityStyleBoxData = getRawSectionData('styleBox');
                        fromXrayData.equityStyleBox = generateStyleBoxModel(equityStyleBoxData.breakdown);
                        break;
                    case 'feesExpenses':
                        var feesExpensesData = getRawSectionData('fees');
                        fromXrayData.feesExpenses = generateFeesExpensesModel(feesExpensesData.breakdown, dataPointMapping.feesExpenses);
                        break;
                    case 'fixedIncomeStyleBox':
                        var fixedIncomeStyleBoxData = getRawSectionData('bondStyleBox');
                        fromXrayData.fixedIncomeStyleBox = generateStyleBoxModel(fixedIncomeStyleBoxData.breakdown);
                        break;
                    case 'interestRateRisk':
                        var interestRateRiskData = getRawSectionData('bondStatistics');
                        fromXrayData.interestRateRisk = interestRateRiskData;
                        break;
                    case 'performanceReturn':
                        var portfolio = portfolioType ? context.parameters.portfolio[portfolioType] : context.parameters.portfolio;
                        fromXrayData.performanceChart = generatePerformanceChartModel(historicalPerformanceSeries, {
                            portfolio: portfolio.name,
                            benchmark: xrayData.benchmarkName
                        });
                        break;
                    case 'stockStats':
                        var stockStatisticsData = getRawSectionData('equityStatistics');
                        stockStatisticsData.benchmarkName = xrayData.benchmarkName;
                        fromXrayData.stockStatistics = stockStatisticsData;
                        break;
                    case 'portfolioHoldings':
                        fromXrayData.holdings = generatePortfolioHoldingModel(holdingsData.breakdown, dataPointMapping.portfolioHoldings);
                        break;
                    case 'quarterEndYearsReturns':
                        fromXrayData.quarterEndYearsReturns = generateQuarterEndYearsReturnsModel(historicalPerformanceSeries, xrayData.benchmarkName);
                        break;
                    case 'riskRewardScatterplot':
                        var riskStatisticsData = getRawSectionData('riskStatistics');
                        fromXrayData.riskStatistics = generateRiskRewardScatterplotModel(riskStatisticsData, xrayData.holdings, xrayData.benchmarkName);
                        break;
                    case 'stockOverlap':
                        var holdingOverlapData = getRawSectionData('holdingOverlap');
                        var underlyHoldings = getRawSectionData('underlyHoldings');
                        fromXrayData.stockOverlap = generateStockOverlapDataModel(holdingOverlapData.breakdown, underlyHoldings.breakdown, holdingsData.breakdown, dataPointMapping.stockOverlap);
                        break;
                    case 'stockRegions':
                        var regionalExposureData = getRawSectionData('regionalExposure');
                        fromXrayData.stockRegions = regionalExposureData;
                        break;
                    case 'stockSectors':
                        var stockSectorData = getRawSectionData('globalStockSector', true);
                        stockSectorData.benchmarkName = xrayData.benchmarkName;
                        fromXrayData.sectorsBreakdown = stockSectorData;
                        break;
                    case 'timePeriodReturn':
                        fromXrayData.bestWorstPeriodData = morningstar.asterix.util.parse('bestWorstPeriods.returns')(xrayData) || [];
                        break;
                    case 'trailingPerformance':
                        var trailingPerformanceData = getRawSectionData('trailingPerformance');
                        fromXrayData.trailingPerformance = generateTrailingPerformanceModel(trailingPerformanceData);
                        break;
                    case 'riskStatistics':
                        fromXrayData.riskData = getRawSectionData('riskStatistics');
                        break;
                    case 'riskScore':
                        fromXrayData.riskScore = {
                            score: morningstar.asterix.util.parse('portfolioRiskScore.portfolios[0].riskScore')(xrayData) || null
                        };
                        break;
                    case 'topNetUnderlyingHoldings':
                        fromXrayData.topNetUnderlyingHoldings = getTopNetUnderlyingHoldings(context.settings);
                        break;
                }
            });

            fromXrayData.benchmark = {
                benchmarkId: xrayData.benchmarkId,
                benchmarkName: xrayData.benchmarkName
            };

            fromXrayData = helper.addAsOfDate(context, fromXrayData, morningstar.asterix.util.parse('trailingPerformance[0].endDate')(xrayData));

            function getTopNetUnderlyingHoldings(settings) {
                var underlyHoldings = xrayData.underlyHoldings || [];
                if (underlyHoldings.length) {
                    underlyHoldings.sort(function (v1, v2) {
                        var w1 = v1.weight;
                        var w2 = v2.weight;
                        if (w1 > w2) {
                            return -1;
                        } else if (w1 < w2) {
                            return 1;
                        }
                        return 0;
                    });
                    var topNetUnderlyingHoldingsAmount = settings.get("defaultTopNetUnderlyingHoldingsAmount");
                    return underlyHoldings.slice(0, topNetUnderlyingHoldingsAmount);
                }
            }

            function generateEditHoldingsModel(holdingsData, portfolioType) {
                var newHoldingsData = morningstar.asterix.extend(true, {}, holdingsData);
                _.each(newHoldingsData, function (holding) {
                    holding.amount = holding.initialAmount;
                    holding.identifier = holding.securityId;
                });
                return helper.generateEditHoldings(context, newHoldingsData, portfolioType);
            }

            function getRawSectionData(sectionName, modifyObject) {
                var data = {
                    benchmark: null,
                    breakdown: null
                };
                data.breakdown = morningstar.asterix.util.parse('breakdowns.' + sectionName)(xrayData) || xrayData[sectionName];
                var benchmarkArray = xrayData.benchmark || [];
                if (benchmarkArray.length > 0) {
                    var benchmark = benchmarkArray[0];
                    data.benchmark = benchmark[sectionName] || morningstar.asterix.util.parse('breakdowns.' + sectionName)(benchmark);
                }

                if (modifyObject) {
                    data.portfolio = data.breakdown ? data.breakdown[0] : null;
                    data.benchmark = data.benchmark ? data.benchmark[0] : null;
                    delete data.breakdown;
                }
                return data;
            }

            function generateAssetAllocationModel(assetAllocationData) {
                var newAssetAllocationData = {
                    benchmark: [],
                    breakdown: []
                };
                var salePositions = ['N', 'L', 'S'],
                    benchmark = assetAllocationData.benchmark || [],
                    breakdown = assetAllocationData.breakdown || [],
                    assetAllocationType = context.settings.get('assetAllocationType');
                _.each(salePositions, function (salePosition) {
                    newAssetAllocationData.benchmark.push(generateAssetAllocationValues(salePosition, assetAllocationType, benchmark));
                    newAssetAllocationData.breakdown.push(generateAssetAllocationValues(salePosition, assetAllocationType, breakdown));
                });

                return newAssetAllocationData;
            }

            function generateAssetAllocationValues(salePosition, assetAllocationType, data) {
                return _.findWhere(data, {
                    salePosition: salePosition,
                    type: assetAllocationType
                }) || {
                    salePosition: salePosition,
                    type: assetAllocationType,
                    values: {}
                };
            }

            function generateStyleBoxModel(styleBoxData) {
                if (styleBoxData) {
                    styleBoxData = _.toArray(styleBoxData[0].values);
                    styleBoxData.pop();
                }
                var newData = styleBoxData || [];
                for (var index = newData.length; index < 9; ++index) {
                    newData.push(0);
                }
                return newData;
            }

            function generatePortfolioHoldingModel(holdings) {
                var newHoldings = [];
                morningstar.asterix.util.each(holdings, function (holding) {
                    var holdingObject = {
                        isinMic: holding.iSIN && holding.exchangeCode ? holding.iSIN + String('XXXX' + holding.exchangeCode).slice(-4) : null
                    };

                    morningstar.asterix.util.each(holding, function (value, key) {
                        if (!morningstar.asterix.util.isObject(value)) {
                            holdingObject[key] = value;
                        }
                    });

                    var trailingPerformance = holding.trailingPerformance || [],
                        trailingPerformanceReturns = trailingPerformance.length > 0 ? holding.trailingPerformance[0].returns : [];
                    _.each(trailingPerformanceReturns, function (data) {
                        holdingObject['trailingReturn' + data.timePeriod] = data.value;
                    });

                    newHoldings.push(holdingObject);
                });

                return newHoldings;
            }

            function generateFeesExpensesModel(fees, keyMap) {
                var mockModel = {
                    Percent: 0,
                    breakdown: [],
                    Portfolio: morningstar.asterix.util.parse('ongoingCharge.value')(fees) || null
                },
                    outputDataPoints = morningstar.asterix.util.parse('feesExpenses.outputDataPoints')(context.settings.get('apiDataPointsSchemaFieldDefinitions'));
                _.each(outputDataPoints, function (key) {
                    mockModel.breakdown.push({
                        feesExpensesKey: key,
                        expenses: morningstar.asterix.util.parse(key + '.value')(fees) || null
                    });
                });
                return mockModel;
            }

            function transformPerformanceChartData(dataArr) {
                var transformedArr = [];

                _.each(dataArr, function (arrObj) {
                    var transformedObj = {};
                    transformedObj.endDate = morningstar.asterix.util.date.toLocalISOString(new Date(arrObj[0]));
                    transformedObj.value = arrObj[1];
                    transformedArr.push(transformedObj);
                });
                return transformedArr;
            }

            function generatePerformanceChartModel(historicalPerformanceSeries, name) {
                var mockModel = {
                    monthly: {
                        series: [{
                            name: name.portfolio || 'portfolio',
                            useLabel: name.portfolio ? false : true
                        }, {
                            name: name.benchmark || 'benchmark',
                            useLabel: name.benchmark ? false : true
                        }]
                    }
                },
                    portfolio = _.findWhere(historicalPerformanceSeries.breakdown, { timePeriod: 'M1' }) || {},
                    benchmark = _.findWhere(historicalPerformanceSeries.benchmark, { timePeriod: 'M1' }) || {};

                mockModel.monthly.series[0].data = portfolio ? transformPerformanceChartData(portfolio.returns) : [];
                mockModel.monthly.series[1].data = benchmark ? transformPerformanceChartData(benchmark.returns) : [];

                return mockModel;
            }

            function generateRiskRewardScatterplotModel(riskStatisticsData, holdings, benchmarkName) {
                if (!riskStatisticsData && !holdings) {
                    context.instance.getLogger().warn('There is no risk statistics data.');
                    return null;
                }
                var riskStatisticsModel = {
                    holdingsRiskStatistics: []
                };
                _.each(holdings, function (item) {
                    if (item.riskStatistics) {
                        riskStatisticsModel.holdingsRiskStatistics.push({
                            name: item.name,
                            weight: item.weight,
                            riskStatistics: changeRiskStatisticsTimePeriod(item.riskStatistics)
                        });
                    }
                });
                if (riskStatisticsData.benchmark) {
                    riskStatisticsModel.benchmarkRiskStatistics = {
                        name: benchmarkName,
                        weight: 100,
                        riskStatistics: changeRiskStatisticsTimePeriod(riskStatisticsData.benchmark)
                    };
                }
                if (riskStatisticsData.breakdown) {
                    riskStatisticsModel.portfolioRiskStatistics = {
                        name: 'Portfolio',
                        weight: 100,
                        riskStatistics: changeRiskStatisticsTimePeriod(riskStatisticsData.breakdown)
                    };
                }
                return riskStatisticsModel;
            }

            function changeRiskStatisticsTimePeriod(riskStatisticsData) {
                _.each(riskStatisticsData.arithmeticMean, function (item) {
                    if (item.timePeriod === 'M12') {
                        item.timePeriod = 'Year1';
                    } else if (item.timePeriod === 'M36') {
                        item.timePeriod = 'Year3';
                    } else if (item.timePeriod === 'M60') {
                        item.timePeriod = 'Year5';
                    } else if (item.timePeriod === 'M120') {
                        item.timePeriod = 'Year10';
                    }
                });
                _.each(riskStatisticsData.standardDeviation, function (item) {
                    if (item.timePeriod === 'M12') {
                        item.timePeriod = 'Year1';
                    } else if (item.timePeriod === 'M36') {
                        item.timePeriod = 'Year3';
                    } else if (item.timePeriod === 'M60') {
                        item.timePeriod = 'Year5';
                    } else if (item.timePeriod === 'M120') {
                        item.timePeriod = 'Year10';
                    }
                });
                return riskStatisticsData;
            }

            function generateStockOverlapDataModel(overlapHoldings, underlyHoldings, portfolioHoldings, keyMap) {
                var newStockOverlap = [];
                if (portfolioHoldings && overlapHoldings) {
                    var stockHoldingDatas = _.filter(overlapHoldings, function (item) {
                        return item.securityType === 'E';
                    });

                    _.each(stockHoldingDatas, function (stockHoldingData) {
                        var sectorKey = null;
                        if (stockHoldingData.globalSectorId) {
                            sectorKey = stockHoldingData.globalSectorId ? keyMap[stockHoldingData.globalSectorId] : null;
                        }

                        var symbolData = _.find(underlyHoldings, function (holding) {
                            return holding.holdingId === stockHoldingData.holdingId;
                        }) || {};

                        var stockOverlapObject = {
                            securityName: stockHoldingData.name,
                            symbol: symbolData.symbol,
                            percentOfInvestments: stockHoldingData.weight,
                            sector: context.labels.get(sectorKey),
                            type: stockHoldingData.securityType ? 'st' : null,
                            securityId: stockHoldingData.securityId,
                            holdingData: []
                        };

                        _.each(stockHoldingData.parentHoldings, function (parentHolding) {
                            var stockOverlapParentData = _.find(portfolioHoldings, function (portfolioHolding) {
                                var holdingId = portfolioHolding.holdingId + '';
                                return holdingId === parentHolding.holdingId;
                            }) || {};

                            var stockOverlapParentObject = {
                                securityName: stockOverlapParentData.name,
                                symbol: stockOverlapParentData.symbol,
                                percentOfInvestments: parentHolding.weight,
                                holdingPortfolioDate: stockOverlapParentData.portfolioDate,
                                sector: stockOverlapParentData.sectorName,
                                type: stockOverlapParentData.securityType && stockOverlapParentData.securityType.toLowerCase(),
                                securityId: stockOverlapParentData.securityId
                            };
                            stockOverlapObject.holdingData.push(stockOverlapParentObject);
                        });

                        newStockOverlap.push(stockOverlapObject);
                    });
                }
                return newStockOverlap;
            }

            function generateTrailingPerformanceModel(trailingPerformanceData) {
                var returnTrailingPerformanceData = [],
                    portfolio = morningstar.asterix.util.parse('breakdown[0].returns')(trailingPerformanceData),
                    benchmark = morningstar.asterix.util.parse('benchmark[0].returns')(trailingPerformanceData);

                _.each(portfolio, function (item) {
                    var obj = {
                        timePeriod: item.timePeriod,
                        portfolio: item.value
                    };

                    var returnData = _.find(benchmark, function (data) {
                        return data.timePeriod === item.timePeriod;
                    }) || {};
                    obj.benchmark = returnData.value;

                    returnTrailingPerformanceData.push(obj);
                });

                return returnTrailingPerformanceData;
            }

            function generateCorrelationMatrixModel(correlationMatrix, holdings) {
                if (!correlationMatrix || !correlationMatrix.length) {
                    context.instance.getLogger().warn('There is no correlation matrix data.');
                    return null;
                }
                var newCorrelationMatrix = {
                    timePeriod: correlationMatrix[0].timePeriod,
                    endDate: correlationMatrix[0].endDate,
                    correlationMatrixDetail: []
                };
                _.each(holdings, function (holdingsItem) {
                    var correlationMatrixDetailItem = _.find(correlationMatrix[0].correlationMatrixDetail, function (item) {
                        return item.id === holdingsItem.holdingId.toString();
                    });
                    /**
                     * if correlationMatrixDetailItem or its correlationDetail is not exist,
                     * mock up a fake data
                     */
                    if (!correlationMatrixDetailItem || !correlationMatrixDetailItem.correlationDetail) {
                        var correlationDetail = [];
                        for (var i = 0; i < holdings.length; i++) {
                            var correlationItem = {
                                id: i.toString(),
                                correlation: ''
                            };
                            correlationDetail.push(correlationItem);
                        }
                        correlationMatrixDetailItem = {
                            id: holdingsItem.holdingId.toString(),
                            correlationDetail: correlationDetail
                        };
                    } else {
                        var newCorrelationDetail = [];
                        _.each(holdings, function (newHoldingsItem) {
                            var correlationDetailItem = _.find(correlationMatrixDetailItem.correlationDetail, function (item) {
                                return item.id === newHoldingsItem.holdingId.toString();
                            });
                            /**
                             * if correlationDetailItem or its correlationDetail is not exist,
                             * mock up a fake data
                             */
                            if (!correlationDetailItem || !correlationDetailItem.correlation) {
                                correlationDetailItem = {
                                    id: newHoldingsItem.holdingId.toString(),
                                    correlation: ''
                                };
                            }
                            newCorrelationDetail.push(correlationDetailItem);
                        });
                        correlationMatrixDetailItem.correlationDetail = newCorrelationDetail;
                    }
                    correlationMatrixDetailItem.name = holdingsItem.name || '';
                    newCorrelationMatrix.correlationMatrixDetail.push(correlationMatrixDetailItem);
                });
                return newCorrelationMatrix;
            }

            function generateQuarterEndYearsReturnsModel(historicalPerformanceSeries, benchmarkName) {
                var data = generateCalendarYearsReturnsModel(historicalPerformanceSeries, { timePeriod: 'M12', frequency: 'TrailingAnnual' }) || [];
                var quarterEndYearsReturnsModel = {
                    benchmark: [{ content: benchmarkName, fieldName: 'benchmark', indicatorLabelKey: 'benchmarkName' }],
                    data: data.reverse()
                };
                return quarterEndYearsReturnsModel;
            }

            function generateCalendarYearsReturnsModel(historicalPerformanceSeries, filter) {
                var calendarYearsReturns = [],
                    portfolio = _.findWhere(historicalPerformanceSeries.breakdown, filter) || {},
                    benchmark = _.findWhere(historicalPerformanceSeries.benchmark, filter) || {},
                    portfolioReturns = portfolio.returns || [],
                    benchmarkReturns = benchmark.returns || [],
                    maxNoOfCalendarYearsReturns = Math.min(portfolioReturns.length, context.settings.get('maxNoOfCalendarYearsReturns')),
                    numberOfYearsReturns = context.settings.get('numberOfYearsReturns'),
                    returnEndDate = portfolio.endDate ? portfolio.endDate : morningstar.asterix.util.date.addMonths(new Date(), -12 * numberOfYearsReturns).toISOString();

                for (var index = 1; index <= maxNoOfCalendarYearsReturns; ++index) {
                    var returnData = portfolioReturns[portfolioReturns.length - index] || [];
                    if (returnData.length > 1) {
                        calendarYearsReturns.push({
                            name: context.labels.get('returnM12_' + index),
                            endDate: returnData[0],
                            startDate: morningstar.asterix.util.date.addMonths(new Date(returnData[0]), -12).toISOString(),
                            portfolio: returnData[1],
                            benchmark: generateCalendarYearsBenchmarkReturns(benchmarkReturns, new Date(returnData[0]))
                        });
                    }
                }
                if (numberOfYearsReturns > 0 && numberOfYearsReturns > portfolioReturns.length) {
                    var startIndex = portfolioReturns.length + 1;
                    for (var i = startIndex; i <= numberOfYearsReturns; ++i) {
                        var endDate = morningstar.asterix.util.date.addMonths(new Date(returnEndDate), -12 * (i - 1));
                        calendarYearsReturns.push({
                            name: context.labels.get('returnM12_' + i),
                            endDate: endDate,
                            startDate: morningstar.asterix.util.date.addMonths(new Date(returnEndDate), -12 * i).toISOString(),
                            portfolio: null,
                            benchmark: generateCalendarYearsBenchmarkReturns(benchmarkReturns, endDate)
                        });
                    }
                }
                return calendarYearsReturns;
            }

            function generateCalendarYearsBenchmarkReturns(benchmarkReturns, endDate) {
                var benchmark = _.find(benchmarkReturns, function (data) {
                    return data && new Date(data[0]).getTime() === endDate.getTime();
                }) || [];

                return benchmark[1];
            }

            return fromXrayData;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 9 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromPAAPIHypo', function (hypoData) {
            hypoData = hypoData || {};

            var fromHypoData = {
                originalData: hypoData
            },
                context = this.context,
                hypos = hypoData.Hypo || [],
                securities = hypoData.SecurityReference || [],
                subsequentInvestmentType = context.parameters.hypotheticalSettings.subsequentInvestmentType || 'Invest',
                initialInvestmentAmount = context.parameters.hypotheticalSettings.initialInvestmentAmount || 10000,
                returnDataSections = context.settings.get('returnDataSections');

            _.each(returnDataSections, function (section) {
                switch (section) {
                    case 'hypotheticalGrowth':
                        fromHypoData.performanceChart = generatePerformanceModel(hypos, securities);
                        break;
                    case 'hypoDates':
                        fromHypoData.hypoDates = {
                            asOfDate: morningstar.asterix.util.date.toUTCLocalISOString(morningstar.asterix.util.date.getMonthEndDate(morningstar.asterix.util.date.addMonths(new Date(), -1))),
                            earliestAvailableDate: morningstar.asterix.util.parse('PerformanceDate.EarliestAvailableDate')(hypos[0]),
                            earliestCommonDate: morningstar.asterix.util.parse('PerformanceDate.EarliestCommonDate')(hypos[0]),
                            sinceInceptionDate: morningstar.asterix.util.parse('PerformanceDate.EarliestInceptionDate')(hypos[0])
                        };
                        break;
                    case 'portfolio':
                        fromHypoData.portfolio = helper.generatePAAPIPortfolios(context, context.parameters.portfolio);
                        break;
                    case 'hypotheticalGrowthTable':
                        fromHypoData.hypotheticalGrowthTable = generateHypotheticalGrowthTableModel(hypos);
                        break;
                }
            });
            return fromHypoData;

            function generatePerformanceModel(hypoDataArray, securities) {
                var mockModel = { series: [] },
                    benchmarkId = morningstar.asterix.util.parse('parameters.portfolio.benchmark.holdings[0].identifier')(context) || morningstar.asterix.util.parse('parameters.portfolio.current.benchmark.holdings[0].identifier')(context) || morningstar.asterix.util.parse('parameters.portfolio.proposed.benchmark.holdings[0].identifier')(context);

                if (hypoDataArray.length !== 0) {
                    _.each(hypoDataArray, function (hypoData) {
                        var portfolio = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryChart.Portfolio')(hypoData) || {};
                        mockModel.series.push({
                            name: hypoData.PortfolioName || 'portfolio',
                            useLabel: hypoData.PortfolioName ? false : true,
                            data: transformPerformanceData(portfolio)
                        });
                        if (benchmarkId) {
                            var benchmark = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryChart.Benchmark')(hypoData) || {};
                            var benchmarkSecurity = _.findWhere(securities, { SecurityId: benchmarkId }) || {};
                            mockModel.series.push({
                                name: benchmarkSecurity.Name || 'benchmark',
                                useLabel: benchmarkSecurity.Name ? false : true,
                                data: transformPerformanceData(benchmark)
                            });
                        }
                    });
                } else {
                    mockModel.series = [{
                        name: 'portfolio',
                        useLabel: true,
                        data: []
                    }];
                }
                return mockModel;
            }

            /** direct use market value */
            function transformPerformanceData(performanceData) {
                if (morningstar.asterix.util.isEmptyObject(performanceData)) {
                    return [];
                }
                var chartData = [],
                    startDate = performanceData.StartDate,

                //API return ISO string without Z  e.g. 2001-08-24T00:00:00
                asOfDate = morningstar.asterix.util.parse('PortfolioSummary.AsOfDate')(hypos[0]),
                    monthEndDate = morningstar.asterix.util.date.getMonthEndDate(new Date(startDate)),
                    startDateIsMonthEnd = new Date(startDate).getDate() === monthEndDate.getDate();
                _.each(performanceData.Data, function (item, index) {
                    var value, newDate, newMonthEndDate, chartDateStr;
                    value = item.Value;
                    if (index > 0) {
                        newDate = morningstar.asterix.util.date.addMonths(new Date(startDate), startDateIsMonthEnd ? index : index - 1);
                        newMonthEndDate = morningstar.asterix.util.date.getMonthEndDate(newDate);
                        chartDateStr = newMonthEndDate < new Date(asOfDate) ? morningstar.asterix.util.date.toUTCLocalISOString(newMonthEndDate) : asOfDate;
                    } else {
                        chartDateStr = startDate;
                    }
                    chartData.push({ date: chartDateStr, close: value });
                });
                return chartData;
            }

            function generateHypotheticalGrowthTableModel(hypoData) {
                var tableData = [];
                _.each(hypoData, function (item) {
                    var totalWithdrawal = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalDistributionAndWithdrawal')(item) || 0,
                        totalNewInvestment = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalNewInvestment')(item) || initialInvestmentAmount,
                        finalMarketValue = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.FinalMarketValue')(item) || 0,
                        totalContributionAmounts = totalNewInvestment,
                        totalGain = 0;
                    if (subsequentInvestmentType.toLowerCase() === 'withdrawal') {
                        totalGain = finalMarketValue - initialInvestmentAmount + totalWithdrawal;
                    } else {
                        totalGain = finalMarketValue - totalNewInvestment;
                    }
                    tableData.push({
                        name: item.PortfolioName,
                        asOfDate: morningstar.asterix.util.parse('PortfolioSummary.AsOfDate')(item) || '',
                        totalContributionAmounts: totalContributionAmounts,
                        marketValue: finalMarketValue,
                        totalGain: totalGain,
                        cumulativeReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.CumulativeReturn')(item) || 0,
                        avgAnnualizedReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.AverageAnnualizedReturn')(item) || 0,
                        inceptionDate: morningstar.asterix.util.parse('PerformanceDate.EarliestInceptionDate')(item) || '',
                        initialInvestmentAmount: initialInvestmentAmount
                    });
                });
                return tableData;
            }
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 10 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromPAAPIPerformance', function (performanceData) {
            performanceData = performanceData || {};

            var fromPerformanceData = {},
                context = this.context,
                parameters = this.context.parameters,
                benchmark = morningstar.asterix.util.parse('portfolio.benchmark.holdings')(parameters),
                benchmarkId = benchmark.length > 0 ? benchmark[0].identifier : null,
                performance = performanceData.Performance && performanceData.Performance[0] || {},
                securityReference = performanceData.SecurityReference || [],
                RiskStatistics = morningstar.asterix.util.parse('Risks.RiskStatistics')(performance) || [],
                returnDataSections = context.settings.get('returnDataSections');

            _.each(returnDataSections, function (section) {
                switch (section) {
                    case 'riskRewardScatterplot':
                        fromPerformanceData.riskStatistics = generateRiskStatisticsModel(RiskStatistics, benchmarkId, securityReference);
                        break;
                }
            });

            return fromPerformanceData;

            function generateRiskStatisticsModel(riskStatisticsData, benchmarkId, securityReference) {
                if (!riskStatisticsData || !riskStatisticsData.length) {
                    return null;
                }
                var benchmarkData = _.find(securityReference, function (item) {
                    return item.SecurityId === benchmarkId;
                });
                var benchmarkName = null;
                if (benchmarkData) {
                    benchmarkName = benchmarkData.Name ? benchmarkData.Name : null;
                }
                var mockModel = {
                    holdingsRiskStatistics: []
                };
                var securityIdArr = [];
                _.each(riskStatisticsData, function (item) {
                    _.each(item.Security, function (securityItem) {
                        var securityId = _.find(securityIdArr, function (arrayItem) {
                            return securityItem.SecurityId === arrayItem.securityId;
                        });
                        if (!securityId) {
                            securityIdArr.push({
                                securityId: securityItem.SecurityId,
                                weight: securityItem.Weight
                            });
                        }
                    });
                });
                _.each(securityIdArr, function (securityItem) {
                    var security = _.find(securityReference, function (item) {
                        return item.SecurityId === securityItem.securityId;
                    });
                    var holdingRiskStatisticsItem;
                    if (security) {
                        holdingRiskStatisticsItem = {
                            name: security.Name ? security.Name : null,
                            weight: securityItem.weight,
                            riskStatistics: transformRiskStatisticsModel('Holdings', riskStatisticsData, securityItem.securityId)
                        };
                        mockModel.holdingsRiskStatistics.push(holdingRiskStatisticsItem);
                    }
                });
                mockModel.benchmarkRiskStatistics = {
                    name: benchmarkName,
                    weight: 100,
                    riskStatistics: transformRiskStatisticsModel('Benchmark', riskStatisticsData)
                };
                mockModel.portfolioRiskStatistics = {
                    name: 'Portfolio',
                    weight: 100,
                    riskStatistics: transformRiskStatisticsModel('Portfolio', riskStatisticsData)
                };
                return mockModel;
            }

            function transformRiskStatisticsModel(type, riskStatisticsData, holdingId) {
                var riskStatisticsModel = {
                    arithmeticMean: [],
                    standardDeviation: []
                };
                _.each(riskStatisticsData, function (item) {
                    var meanItem, standardDeviationItem;
                    var valueName;

                    if (type === 'Benchmark') {
                        valueName = item.Benchmark;
                    } else if (type === 'Holdings') {
                        var security = _.find(item.Security, function (securityItem) {
                            return securityItem.SecurityId === holdingId;
                        });
                        valueName = security.RiskStatisticsItem || {};
                    } else if (type === 'Portfolio') {
                        valueName = item.Portfolio;
                    }
                    meanItem = {
                        timePeriod: item.TrailingTimePeriod || null,
                        frequency: item.DataFrequency || null,
                        value: valueName.Mean || null
                    };
                    standardDeviationItem = {
                        timePeriod: item.TrailingTimePeriod || null,
                        frequency: item.DataFrequency || null,
                        value: valueName.StandardDeviation || null
                    };
                    riskStatisticsModel.arithmeticMean.push(meanItem);
                    riskStatisticsModel.standardDeviation.push(standardDeviationItem);
                });
                return riskStatisticsModel;
            }
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 11 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper, dataPointMapping) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromPAAPI', function (xrayData) {
            xrayData = xrayData || {};
            var fromXrayData = {},
                context = this.context,
                xrays = xrayData.XRay || [],
                hasCurrent = !_.isUndefined(context.parameters.portfolio.current),
                hasProposed = !_.isUndefined(context.parameters.portfolio.proposed);

            if (!hasCurrent && !hasProposed) {
                fromXrayData = generateXrayData(xrayData.SecurityReference, xrays[0]);
            } else {
                if (hasCurrent && hasProposed) {
                    fromXrayData.current = generateXrayData(xrayData.SecurityReference, xrays[0], 'current');
                    fromXrayData.proposed = generateXrayData(xrayData.SecurityReference, xrays[1], 'proposed');
                } else {
                    var retData = generateXrayData(xrayData.SecurityReference, xrays[0], hasCurrent ? 'current' : 'proposed');
                    if (hasCurrent) {
                        fromXrayData.current = retData;
                        fromXrayData.proposed = context.instance.model.securities.proposed;
                    } else {
                        fromXrayData.proposed = retData;
                        fromXrayData.current = context.instance.model.securities.current;
                    }
                }
            }

            function generateXrayData(securityReference, xray, portfolioType) {
                xray = xray || {};

                var retData = {},
                    returnDataSections = context.settings.get('returnDataSections');

                _.each(returnDataSections, function (section) {
                    switch (section) {
                        case 'assetAllocation':
                            retData.assetAllocation = generateAssetAllocationModel(xray, dataPointMapping.assetAllocation);
                            break;
                        case 'creditQuality':
                            retData.creditQuality = generateCreditQualityModel(xray, dataPointMapping.creditQuality);
                            break;
                        case 'editHoldings':
                            retData.editHoldings = generateEditHoldingsModel(securityReference, xray, portfolioType);
                            break;
                        case 'equityStyleBox':
                            retData.equityStyleBox = generateEquityStyleBoxModel(xray);
                            break;
                        case 'feesExpenses':
                            retData.feesExpenses = generateFeeExpensesModel(xray, dataPointMapping.feesExpenses);
                            break;
                        case 'fixedIncomeStyleBox':
                            retData.fixedIncomeStyleBox = generateFixedIncomeStyleBoxModel(xray);
                            break;
                        case 'interestRateRisk':
                            retData.interestRateRisk = generateInterestRateRiskModel(xray, dataPointMapping.bondStatistics);
                            break;
                        case 'performanceReturn':
                            var portfolio = portfolioType ? context.parameters.portfolio[portfolioType] : context.parameters.portfolio;
                            retData.performanceChart = generatePerformanceChartModel(xray, portfolio.name);
                            break;
                        case 'stockStats':
                            retData.stockStatistics = generateStockStatsModel(xray, dataPointMapping.equityStatistics);
                            break;
                        case 'portfolioHoldings':
                            retData.holdings = generatePortfolioHoldingModel(securityReference, xray);
                            break;
                        case 'stockOverlap':
                            retData.stockOverlap = generateStockOverlapModel(securityReference, xray, dataPointMapping.stockSectors);
                            break;
                        case 'stockRegions':
                            retData.stockRegions = generateRegionsModel(xray, dataPointMapping.regionalExposure);
                            break;
                        case 'stockSectors':
                            retData.sectorsBreakdown = generateSectorModel(xray, dataPointMapping.globalStockSectors);
                            break;
                        case 'trailingPerformance':
                            retData.trailingPerformance = generateTrailingPerformanceModel(xray);
                            break;
                        case 'topNetUnderlyingHoldings':
                            retData.topNetUnderlyingHoldings = generateTopNetUnderlyingHoldingsModel(securityReference, xray);
                            break;

                    }
                });
                retData = helper.benchmarkHandlerOfUS(xray, securityReference, context, retData, portfolioType);

                retData = helper.addAsOfDate(context, retData, morningstar.asterix.util.parse('Statistics.PortfolioSummary.PortfolioDate')(xray));

                return retData;
            }

            function generateEditHoldingsModel(securityReference, xray, portfolioType) {
                var securities = morningstar.asterix.util.parse('Holdings.PortfolioHoldings.Security')(xray) || [];
                var holdings = [];
                _.each(securities, function (security) {
                    var data = _.find(securityReference, function (item) {
                        if (item.SecurityId === security.SecurityId) {
                            return item;
                        }
                    });
                    holdings.push({
                        identifier: security.SecurityId,
                        securityType: data && data.Type || null,
                        name: data && data.Name || null,
                        units: security.Units || null,
                        weight: security.PercentAssets,
                        amount: security.MarketValue
                    });
                });
                return helper.generateEditHoldings(context, holdings, portfolioType);
            }

            function generateAssetAllocationModel(xray, keyMap) {
                var assetAllocationModel = {
                    benchmark: [],
                    breakdown: []
                },
                    assetAllocationArr = morningstar.asterix.util.parse('Analysis.AssetAllocation')(xray) || [],
                    assetAllocation = assetAllocationArr.length > 0 ? assetAllocationArr[0] : {},
                    assetAllocationID = assetAllocation.Id,
                    benchmark = morningstar.asterix.util.parse('Benchmark')(assetAllocation) || [],
                    portfolio = morningstar.asterix.util.parse('Portfolio')(assetAllocation) || [],
                    assetAllocationGroupMappingId = morningstar.asterix.util.parse('idMap.' + assetAllocationID)(keyMap) || 'MorningstarUSA',
                    assetAllocationElementModel = {
                    type: assetAllocationGroupMappingId,
                    salePosition: '',
                    values: {}
                };

                var salePositions = ['N', 'L', 'S'],
                    assetAllocationMap = keyMap[assetAllocationGroupMappingId];
                _.each(salePositions, function (salePosition) {
                    var portfolioAssetAllocation = generateAssetAllocationModelForSalePosition(assetAllocationElementModel, portfolio, assetAllocationMap, salePosition),
                        benchmarkAssetAllocation = generateAssetAllocationModelForSalePosition(assetAllocationElementModel, benchmark, assetAllocationMap, salePosition);
                    assetAllocationModel.benchmark.push(benchmarkAssetAllocation);
                    assetAllocationModel.breakdown.push(portfolioAssetAllocation);
                });
                return assetAllocationModel;
            }

            function generateAssetAllocationModelForSalePosition(assetAllocationElementModel, portfolio, assetAllocationMap, salePosition) {
                assetAllocationElementModel = JSON.parse(JSON.stringify(assetAllocationElementModel));
                var apiSalePositionName;

                if (salePosition === 'N') {
                    apiSalePositionName = 'Net';
                } else if (salePosition === 'L') {
                    apiSalePositionName = 'Long';
                } else if (salePosition === 'S') {
                    apiSalePositionName = 'Short';
                }

                _.each(portfolio, function (dataElementFromAPI) {
                    assetAllocationElementModel.salePosition = salePosition;
                    var mappedIdForAsset = assetAllocationMap[dataElementFromAPI.Id];
                    assetAllocationElementModel.values[mappedIdForAsset] = dataElementFromAPI[apiSalePositionName];
                });

                return assetAllocationElementModel;
            }

            function generateCreditQualityModel(xray, keyMap) {
                var mockModel = {
                    breakdown: []
                };
                var values = {};
                var portfolio = morningstar.asterix.util.parse('Analysis.FixedIncomeAnalysis.CreditQuality.Portfolio')(xray) || {};

                _.each(portfolio, function (value, key) {
                    if (keyMap[key]) {
                        values[keyMap[key]] = value;
                    }
                });

                mockModel.breakdown.push({ values: values });
                return mockModel;
            }

            function generateEquityStyleBoxModel(xRay) {
                var styleBoxData = morningstar.asterix.util.parse('Analysis.InvestmentStyle.EquityStyle.EquityStyleBreakdown.Portfolio')(xRay) || {};
                return generateStyleBoxModel(styleBoxData, 0, 9);
            }

            function generateFeeExpensesModel(xRay, keyMap) {
                var feeExpensesModel = {
                    category: null,
                    benchmark: null,
                    breakdown: [],
                    portfolio: null
                },
                    portfolio = morningstar.asterix.util.parse('Statistics.FundStatistics.Portfolio')(xRay) || {},
                    outputDataPoints = morningstar.asterix.util.parse('feesExpenses.outputDataPoints')(context.settings.get('apiDataPointsSchemaFieldDefinitions'));
                _.each(outputDataPoints, function (key) {
                    feeExpensesModel.breakdown.push({
                        expenses: portfolio[key] || null,
                        feesExpensesKey: morningstar.asterix.util.string.firstLowerCase(key)
                    });
                });

                return feeExpensesModel;
            }

            function generateFixedIncomeStyleBoxModel(xray) {
                var styleBoxData = morningstar.asterix.util.parse('Analysis.InvestmentStyle.FixedIncomeStyle.FixedIncomeStyleBreakdown')(xray) || {};
                return generateStyleBoxModel(styleBoxData, 1, 10);
            }

            function generateInterestRateRiskModel(xray, keyMap) {
                var mockModel = {
                    breakdown: {},
                    benchmark: {}
                };
                var interestRateRisk = morningstar.asterix.util.parse('Analysis.FixedIncomeAnalysis.InterestRateRisk')(xray) || {};
                var portfolio = interestRateRisk.Portfolio || {};
                var benchmark = interestRateRisk.Benchmark || {};

                _.each(keyMap, function (item, name) {
                    var breakdownItem = mockModel.breakdown[name] = {},
                        benchmarkItem = mockModel.benchmark[name] = {};

                    breakdownItem.value = portfolio[item] || null;
                    benchmarkItem.value = benchmark[item] || null;
                });

                return mockModel;
            }

            function generateTopNetUnderlyingHoldingsModel(securityReference, xray) {
                var mockModel = [];
                var securities = morningstar.asterix.util.parse('Holdings.TopNetUnderlyingHoldings.Security')(xray) || [];
                _.each(securities, function (security) {
                    var securityData = _.find(securityReference, function (item) {
                        if (item.SecurityId === security.SecurityId) {
                            return item;
                        }
                    }) || {};
                    var newSecurity = {
                        weight: security.PercentAssets,
                        sector: security.EquitySector ? context.labels.get(morningstar.asterix.util.string.firstLowerCase(security.EquitySector)) : null,
                        name: securityData.Name,
                        country: security.Country,
                        securityType: securityData.Type,
                        securityId: security.SecurityId
                    };
                    mockModel.push(newSecurity);
                });
                return mockModel;
            }

            function generatePortfolioHoldingModel(securityReference, xray) {
                var mockModel = [];
                var securities = morningstar.asterix.util.parse('Holdings.PortfolioHoldings.Security')(xray) || [];

                _.each(securities, function (security) {
                    var data = _.find(securityReference, function (item) {
                        if (item.SecurityId === security.SecurityId) {
                            return item;
                        }
                    }) || {};

                    var newSecurity = {
                        securityType: data.Type,
                        cusip: data.CUSIP,
                        name: data.Name,
                        symbol: data.TradingSymbol
                    };
                    _.each(security, function (value, key) {
                        if (!morningstar.asterix.util.isObject(value)) {
                            newSecurity[morningstar.asterix.util.string.firstLowerCase(key)] = value;
                        }
                    });

                    mockModel.push(newSecurity);
                });
                return mockModel;
            }

            function generateRegionsModel(xray, keyMap) {
                var benchmarkBreakdownModel = {
                    benchmark: [],
                    breakdown: []
                };

                var portfolio = morningstar.asterix.util.parse('Analysis.EquityAnalysis.WorldRegions.Portfolio')(xray) || [];
                var benchmark = morningstar.asterix.util.parse('Analysis.EquityAnalysis.WorldRegions.Benchmark')(xray) || [];

                benchmarkBreakdownModel.breakdown.push(generateRegionsElementModel(portfolio, keyMap));
                benchmarkBreakdownModel.benchmark.push(generateRegionsElementModel(benchmark, keyMap));
                return benchmarkBreakdownModel;
            }

            function generateRegionsElementModel(data, keyMap) {
                var regionsElementModel = {
                    salePosition: 'N',
                    values: {}
                };
                _.each(keyMap, function (mapRegionVal, mapRegionKey) {
                    var region = _.findWhere(data, { Id: mapRegionVal.name }) || {};
                    if (mapRegionVal.subRegions) {
                        _.each(mapRegionVal.subRegions, function (mapSubRegionVal, mapSubRegionKey) {
                            var subRegion = _.findWhere(region.ExposureItem, { Id: mapSubRegionKey }) || {};
                            regionsElementModel.values[mapSubRegionVal.name] = !_.isUndefined(subRegion.Value) ? subRegion.Value : null;
                        });
                    } else {
                        regionsElementModel.values[mapRegionVal.key] = !_.isUndefined(region.Value) ? region.Value : null;
                    }
                });

                return regionsElementModel;
            }

            function generateSectorModel(xray, keyMap) {
                var mockModel = {
                    benchmark: {
                        values: {}
                    },
                    portfolio: { values: {} }
                };
                var equitySectorArr = morningstar.asterix.util.parse('Analysis.EquityAnalysis.EquitySectors.EquitySector')(xray) || [];
                var equitySector = equitySectorArr.length > 0 ? equitySectorArr[0] : {};
                var portfolioData = equitySector.Portfolio || [];
                var benchmarkData = equitySector.Benchmark || [];

                mockModel.portfolio.values = generateSectorValues(portfolioData, keyMap);
                mockModel.benchmark.values = generateSectorValues(benchmarkData, keyMap);

                return mockModel;
            }

            function generateSectorValues(data, keyMap) {
                var values = {};
                _.each(data, function (item) {
                    if (keyMap[item.Id]) {
                        values[keyMap[item.Id]] = item.Value;
                    }
                });
                return values;
            }

            function generateStockOverlapModel(securityReference, xray, sectorMap) {
                var mockModel = [];
                var securities = morningstar.asterix.util.parse('Holdings.StockIntersection.Stock')(xray) || [];
                _.each(securities, function (stock) {
                    var stockOverlapObject = {
                        securityName: stock.SecurityName,
                        symbol: stock.TradingSymbol,
                        securityId: stock.SecurityId,
                        percentOfInvestments: stock.PercentOfInvestments,
                        sector: sectorMap[stock.StockSector] ? context.labels.get(sectorMap[stock.StockSector]) : null,
                        marketValue: stock.MarketValue,
                        type: 'st',
                        holdingData: []
                    };
                    _.each(stock.SourceOfStock, function (holding) {
                        var data = _.find(securityReference, function (item) {
                            if (item.SecurityId === holding.SecurityId) {
                                return item;
                            }
                        }) || {};
                        stockOverlapObject.holdingData.push({
                            securityName: data.Name,
                            symbol: data.TradingSymbol,
                            securityId: holding.SecurityId,
                            percentOfInvestments: holding.PercentOfInvestments,
                            sector: sectorMap[holding.StockSector] ? context.labels.get(sectorMap[holding.StockSector]) : null,
                            holdingPortfolioDate: holding.FundPortfolioDate
                        });
                    });
                    mockModel.push(stockOverlapObject);
                });
                return mockModel;
            }

            function generateStockStatsModel(xray, keyMap) {
                var mockModel = {
                    breakdown: {},
                    benchmark: {}
                };
                var equityAnalysis = morningstar.asterix.util.parse('Analysis.EquityAnalysis')(xray) || {};
                var priceRatios = equityAnalysis.PriceRatios || {};
                var profitability = equityAnalysis.Profitability || {};
                var priceRatioPortfolio = priceRatios.Portfolio || {};
                var profitabilityPortfolio = profitability.Portfolio || {};
                var priceRatioBenchmark = priceRatios.Benchmark || {};
                var profitabilityBenchmark = profitability.Benchmark || {};
                var portfolio = morningstar.asterix.util.merge({}, priceRatioPortfolio, profitabilityPortfolio);
                var benchmark = morningstar.asterix.util.merge({}, priceRatioBenchmark, profitabilityBenchmark);

                _.each(keyMap, function (item, name) {
                    var breakdownItem = mockModel.breakdown[name] = {},
                        benchmarkItem = mockModel.benchmark[name] = {};

                    breakdownItem.value = portfolio[item] || null;
                    benchmarkItem.value = benchmark[item] || null;
                });

                return mockModel;
            }

            function generateStyleBoxModel(styleBoxData, startIndex, endIndex) {
                var newData = [];

                _.each(styleBoxData, function (value, key) {
                    newData.push(value);
                });

                newData = newData.slice(startIndex, endIndex);
                for (var index = newData.length; index < 9; ++index) {
                    newData.push(0);
                }

                return newData;
            }

            function generatePerformanceChartModel(xray, portfolioName) {
                var mockModel = {
                    monthly: {
                        series: [{
                            name: portfolioName || 'portfolio',
                            useLabel: portfolioName ? false : true,
                            data: []
                        }, {
                            name: 'benchmark',
                            useLabel: true,
                            data: []
                        }]
                    }
                };
                var portfolio = morningstar.asterix.util.parse('Returns.InvestmentActivity.Portfolio')(xray) || [];
                mockModel.monthly.series[0].data = transformPerformanceChartData(portfolio);
                var benchmark = morningstar.asterix.util.parse('Returns.InvestmentActivity.Benchmark')(xray) || [];
                mockModel.monthly.series[1].data = transformPerformanceChartData(benchmark);
                return mockModel;
            }

            function generateTrailingPerformanceModel(xray) {
                var newTrailingReturns = [],
                    portfolioTimePeriod = morningstar.asterix.util.parse('Returns.TrailingReturns.Portfolio.TimePeriod')(xray) || [],
                    benchmarkTimePeriod = morningstar.asterix.util.parse('Returns.TrailingReturns.Benchmark.TimePeriod')(xray) || [];

                _.each(portfolioTimePeriod, function (data) {
                    var benchmarkData = _.find(benchmarkTimePeriod, function (timePeriod) {
                        return timePeriod.Id === data.Id;
                    }) || {};

                    newTrailingReturns.push({
                        portfolio: data.Value,
                        benchmark: benchmarkData.Value,
                        timePeriod: data.Id
                    });
                });

                return newTrailingReturns;
            }

            function transformPerformanceChartData(data) {
                var chartData = [];
                _.each(data, function (item) {
                    var value = (item.MarketValue - item.BeginningBalance) / item.BeginningBalance * 100.0;
                    var date = morningstar.asterix.util.date.toUTCLocalISOString(new Date(item.EndDate));
                    chartData.push({ endDate: date, value: value });
                });
                return chartData;
            }
            return fromXrayData;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 12 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper, dataPointMapping) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromPortfolioAPI', function (xrayData) {
            xrayData = xrayData || {};
            var fromXrayData = {},
                context = this.context,
                xrays = xrayData.data || [],
                hasCurrent = !_.isUndefined(context.parameters.portfolio.current),
                hasProposed = !_.isUndefined(context.parameters.portfolio.proposed);

            if (!hasCurrent && !hasProposed) {
                fromXrayData = generateXrayData(context, xrays[0], context.parameters.portfolio);
            } else {
                if (hasCurrent && hasProposed) {
                    fromXrayData.current = generateXrayData(context, xrays[0], context.parameters.portfolio.current);
                    fromXrayData.proposed = generateXrayData(context, xrays[1], context.parameters.portfolio.proposed);
                } else {
                    var retData = generateXrayData(context, xrays[0], context.parameters.portfolio[hasCurrent ? 'current' : 'proposed']);
                    if (hasCurrent) {
                        fromXrayData.current = retData;
                        fromXrayData.proposed = context.instance.model.securities.proposed;
                    } else {
                        fromXrayData.proposed = retData;
                        fromXrayData.current = context.instance.model.securities.current;
                    }
                }
            }
            return fromXrayData;
        });

        function generateXrayData(context, data, portfolio) {
            var returnDataSections = context.settings.get('returnDataSections'),
                holdings = generateHoldingsModel(context, data),
                newData = {
                benchmark: {
                    benchmarkId: helper.getBenchmarkId(portfolio)
                }
            };

            _.each(returnDataSections, function (section) {
                var sectionData = morningstar.asterix.util.parse(section + '.rows')(data) || [],
                    sectionDataPointMapping = dataPointMapping[section];
                switch (section) {
                    case 'assetAllocation':
                        var assetClassGroupId = helper.getAssetClassGroupId(context);
                        newData.assetAllocation = getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping[assetClassGroupId]);
                        break;
                    case 'equityStyleBox':
                        newData.equityStyleBox = generateEquityStyleBoxData(sectionData, sectionDataPointMapping);
                        break;
                    case 'portfolioHoldings':
                        newData.portfolioHoldings = {
                            holdings: _.map(morningstar.asterix.util.cloneObject(holdings), function (holding) {
                                if (holding.rowType === 'holding' || holding.rowType === 'cash') {
                                    holding.marketValue = parseFloat(holding.marketValue) * parseFloat(holding.marketValueRate);
                                    if (holding.rowType === 'cash') {
                                        holding.name = context.labels.get('cash');
                                    }
                                }
                                return holding;
                            })
                        };
                        break;
                    case 'stockRegions':
                        newData.stockRegions = getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping);
                        break;
                    case 'stockSectors':
                        newData.stockSectors = getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping);
                        break;
                    case 'trailingPerformance':
                        sectionData = morningstar.asterix.util.parse('portfolioHoldings.rows')(data) || [];
                        newData.trailingPerformance = generatePortfolioBenchmarkTableModel(getDataArrayByRowType(sectionData, sectionDataPointMapping, ['total', 'benchmark']), 'timePeriod');
                        break;
                    case 'stockStats':
                        newData.stockStats = getDataArrayByRowType(sectionData, sectionDataPointMapping, ['total', 'benchmark']);
                        break;
                    case 'performanceReturn':
                        var sectionDataNames = morningstar.asterix.util.parse(section + '.columns')(data) || [];
                        newData.performanceChart = generatePerformanceReturnModel(sectionData, sectionDataNames, portfolio);
                        break;
                    case 'editHoldings':
                        newData.editHoldings = generateEditHoldingsModel(context, holdings);
                        break;
                }
            });

            return newData;
        }

        function generatePortfolioBenchmarkTableModel(datas, dataPointKey) {
            var newModels = [],
                portfolioData = getRowTypeData(datas, 'total')[0] || {},
                benchmarkData = getRowTypeData(datas, 'benchmark')[0] || {},
                keys = _.uniq(_.keys(portfolioData).concat(_.keys(benchmarkData)));

            _.each(keys, function (key) {
                if (key !== 'rowType') {
                    var data = {
                        portfolio: portfolioData[key],
                        benchmark: benchmarkData[key]
                    };
                    data[dataPointKey] = key;
                    newModels.push(data);
                }
            });
            return newModels;
        }

        function generateEquityStyleBoxData(sectionData, sectionDataPointMapping) {
            var holdingStyleDatas = (_.values(sectionData[0])[0] || {}).holdingStyleDatas || [],
                newSectionData = [];

            _.each(sectionDataPointMapping, function (dataPoint) {
                var holdingStyleData = _.findWhere(holdingStyleDatas, { label: dataPoint }) || {};
                newSectionData.push(Number(holdingStyleData.totalWeight || 0));
            });

            return newSectionData;
        }

        function getRowTypeData(sectionData, rowTypes) {
            return _.filter(sectionData, function (item) {
                var rowType = item.rowType;
                if (_.isArray(rowTypes)) {
                    return item && _.find(rowTypes, function (type) {
                        return type === rowType;
                    });
                } else {
                    return item && rowType === rowTypes;
                }
            }) || [];
        }

        function getDataArrayByRowType(sectionData, dataPointMapping, rowTypes) {
            var rowTypeDataArr = getRowTypeData(sectionData, rowTypes),
                newSectionData = [];

            _.each(rowTypeDataArr, function (rowTypeData) {
                newSectionData.push(getDataFromRowTypeData(rowTypeData, dataPointMapping));
            });

            return newSectionData;
        }

        function getDataFromRowTypeData(rowTypeData, dataPointMapping) {
            var data = {};

            _.each(dataPointMapping, function (dataPoints, key) {
                var value = null;
                if (_.isString(dataPoints)) {
                    value = rowTypeData[dataPoints];
                } else if (_.isArray(dataPoints)) {
                    _.each(dataPoints, function (dataPoint) {
                        if (!morningstar.asterix.util.isUndefinedOrNull(rowTypeData[dataPoint])) {
                            value = value ? value : 0.0;
                            value += rowTypeData[dataPoint];
                        }
                    });
                }
                data[key] = morningstar.asterix.util.isUndefinedOrNull(value) ? null : value;
            });

            return data;
        }

        function getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping) {
            var retDataPointMapping = {
                portfolio: 'total',
                benchmark: 'benchmark'
            },
                newSectionData = {};

            _.each(retDataPointMapping, function (rowType, dataPoint) {
                var rowTypeData = getRowTypeData(sectionData, rowType)[0] || {},
                    newDataPointMapping = {},
                    retData = {};

                _.each(sectionDataPointMapping, function (dataPointMapping, key) {
                    if (_.isString(dataPointMapping) || _.isArray(dataPointMapping)) {
                        newDataPointMapping[key] = dataPointMapping;
                    } else if (_.isObject(dataPointMapping)) {
                        retData[key] = getDataFromRowTypeData(rowTypeData, dataPointMapping);
                    }
                });

                if (!_.isEmpty(newDataPointMapping)) {
                    morningstar.asterix.util.merge(retData, getDataFromRowTypeData(rowTypeData, newDataPointMapping));
                }

                newSectionData[dataPoint] = retData;
            });
            return newSectionData;
        }

        function generatePerformanceReturnModel(datas, performanceDataNames, portfolio) {
            var mockModel = {
                monthly: {
                    series: []
                }
            },
                portfolioSeriesData = {
                name: 'portfolio',
                useLabel: true,
                data: []
            },
                benchmarkSeriesData = {
                name: 'benchmark',
                useLabel: true,
                data: []
            },
                portfolioData = getRowTypeData(datas, 'total')[0] || {},
                benchmarkData = getRowTypeData(datas, 'benchmark')[0] || {},
                commonStartFlag = false;
            _.each(performanceDataNames, function (item) {
                var id = item.id;
                if (!benchmarkData.performanceId || !portfolioData.performanceId || id !== 'name' && !commonStartFlag && !morningstar.asterix.util.isUndefinedOrNull(portfolioData[id]) && !morningstar.asterix.util.isUndefinedOrNull(benchmarkData[id])) {
                    commonStartFlag = true;
                }
                if (commonStartFlag && item.endDate) {
                    if (portfolioData.performanceId) {
                        portfolioSeriesData.data.push({ endDate: item.endDate, value: portfolioData[id] });
                    }
                    if (benchmarkData.performanceId) {
                        benchmarkSeriesData.data.push({ endDate: item.endDate, value: benchmarkData[id] });
                    }
                }
            });
            if (portfolioData.performanceId) {
                var name = portfolio.name || portfolioData.name;
                if (name) {
                    portfolioSeriesData.name = name;
                    portfolioSeriesData.useLabel = false;
                }
                mockModel.monthly.series.push(portfolioSeriesData);
            }
            if (benchmarkData.performanceId) {
                var _name = benchmarkData.name;
                if (_name) {
                    benchmarkSeriesData.name = _name;
                    benchmarkSeriesData.useLabel = false;
                }
                benchmarkSeriesData.id = benchmarkData.performanceId;
                mockModel.monthly.series.push(benchmarkSeriesData);
            }
            return mockModel;
        }

        function generateHoldingsModel(context, data) {
            var sectionData = morningstar.asterix.util.parse('portfolioHoldings.rows')(data) || [];
            var holdings = getDataArrayByRowType(sectionData, dataPointMapping.portfolioHoldings, 'holding');
            var cash = getDataArrayByRowType(sectionData, dataPointMapping.portfolioHoldings, 'cash');
            return holdings.concat(cash);
        }

        function generateEditHoldingsModel(context, holdings) {
            var editHoldings = [];
            var totalAmount = 0;

            _.each(holdings, function (holding) {
                var newHolding = {
                    identifier: holding.secId,
                    performanceId: holding.performanceId,
                    name: holding.name,
                    units: parseFloat(holding.shares),
                    price: parseFloat(holding.price) * parseFloat(holding.priceRate),
                    weight: parseFloat(holding.weight),
                    amount: parseFloat(holding.marketValue),
                    identifierType: 'MSID'
                };
                totalAmount += holding.marketValue;
                if (holding.rowType.toLowerCase() === 'cash') {
                    newHolding.performanceId = context.settings.get('cashHoldingIdentifier');
                    newHolding.identifier = context.settings.get('cashHoldingIdentifier');
                    newHolding.holdingTypeId = context.settings.get('cashHoldingTypeId');
                    newHolding.securityType = context.settings.get('cashSecurityType');
                }
                editHoldings.push(newHolding);
            });

            return editHoldings;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 13 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.transforms.register('fromUsaReportInfo', function (pipedResult) {
            var reportPortfolios = morningstar.asterix.util.parse('requestData.Portfolios')(pipedResult) || [];
            reportPortfolios[0] = reportPortfolios[0] || {};
            reportPortfolios[0].reportName = morningstar.asterix.util.parse('portfolio.name')(this.origData) || morningstar.asterix.util.parse('portfolio.current.name')(this.origData);

            return reportPortfolios;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 14 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toEcBenchmarkAPI', function () {
            return {
                parameters: helper.generatePAAPIUrlParameters(this.context)
            };
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 15 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toIwtXray', function (parameters) {
            return helper.generateIWTPostData(this.context, parameters);
        });

        morningstar.asterix.ng.transforms.register('toIwtFees', function (parameters) {
            return helper.generateIWTFeesPostData(this.context, parameters);
        });

        morningstar.asterix.ng.transforms.register('toIwtXrayCurrent', function (parameters) {
            return helper.generateIWTPostData(this.context, parameters, 'current');
        });

        morningstar.asterix.ng.transforms.register('toIwtXrayProposed', function (parameters) {
            return helper.generateIWTPostData(this.context, parameters, 'proposed');
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 16 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toPAAPI', function (parameters) {
            var apiViewConfigDefinitions = this.context.settings.get('apiViewConfigDefinitions') || {},
                assetClassGroupId = helper.getAssetClassGroupId(this.context),
                portfolio = parameters.portfolio.current || parameters.portfolio.proposed || parameters.portfolio,
                currencyId = portfolio.currencyId || this.context.settings.get('currencyId'),
                postData = {
                parameters: helper.generatePAAPIUrlParameters(this.context),
                requestData: {
                    View: {
                        Id: apiViewConfigDefinitions.view
                    },
                    Config: {
                        Id: apiViewConfigDefinitions.config
                    },
                    RequestSettings: {
                        OutputCurrency: currencyId
                    },
                    Portfolios: helper.generatePAAPIPortfolios(this.context, parameters.portfolio)
                }
            };

            if (assetClassGroupId) {
                postData.requestData.RequestSettings.AssetClassGroupConfigs = {
                    AssetClassGroupConfig: [{
                        Id: assetClassGroupId
                    }]
                };
            }
            if (apiViewConfigDefinitions.endpoint === 'hypo') {
                postData.requestData.RequestSettings.hypoCalculationSettings = this.context.parameters.hypotheticalSettings || this.context.settings.get('hypotheticalSettings');
            }

            return postData;
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 17 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
        'use strict';

        morningstar.asterix.ng.transforms.register('toPortfolioAPIAdvanced', function (parameters) {
            return {
                parameters: helper.generatePAAPIUrlParameters(this.context),
                requestData: {
                    settings: generateSettings(this.context, parameters),
                    portfolios: generateAdvancedPortfolios(parameters)
                }
            };
        });

        morningstar.asterix.ng.transforms.register('toPortfolioAPIBasic', function (parameters) {
            return {
                parameters: helper.generatePAAPIUrlParameters(this.context),
                requestData: {
                    settings: generateSettings(this.context, parameters),
                    portfolios: generateBasicPortfolios(this.context, parameters)
                }
            };
        });

        function generateSettings(context, parameters) {
            var portfolio = parameters.portfolio || [],
                settings = morningstar.asterix.extend(true, {}, context.settings.get('portfolioApiSettings'));
            settings.assetClassGroupId = helper.getAssetClassGroupId(context);
            settings.benchmarkId = helper.getBenchmarkId(portfolio[0]);
            settings.returnDataSections = context.settings.get('returnDataSections');
            return settings;
        }

        function generateAdvancedPortfolios(parameters) {
            var newPortfolios = [],
                tempPortfolios = generateTempPortfolios(parameters.portfolio || {});

            _.each(tempPortfolios, function (portfolio) {
                newPortfolios.push({
                    investmentId: portfolio.investmentId,
                    name: portfolio.name,
                    currency: portfolio.currencyId,
                    benchmarkId: helper.getBenchmarkId(portfolio),
                    rebalanceFrequencyId: portfolio.rebalanceFrequencyId,
                    time: portfolio.time || new Date().getTime()
                });
            });

            return newPortfolios;
        }

        function generateBasicPortfolios(context, parameters) {
            var tempPortfolios = generateTempPortfolios(parameters.portfolio || {}),
                newPortfolios = [],
                defaultTotalAmount = context.settings.get('defaultTotalAmount'),
                identifierTypeMapping = context.settings.get('identifierTypeMapping');

            _.each(tempPortfolios, function (portfolio) {
                var newPortfolio = {
                    name: portfolio.name,
                    currency: portfolio.currencyId,
                    benchmarkId: helper.getBenchmarkId(portfolio),
                    rebalanceFrequencyId: portfolio.rebalanceFrequencyId,
                    holdings: []
                };

                _.each(portfolio.holdings, function (holding) {
                    if (holding.identifier) {
                        var newHolding = {
                            country: holding.country,
                            weight: holding.weight,
                            marketValue: holding.amount,
                            shares: holding.units
                        };

                        if (morningstar.asterix.util.isUndefinedOrNull(newHolding.marketValue) && !morningstar.asterix.util.isUndefinedOrNull(newHolding.weight)) {
                            newHolding.marketValue = defaultTotalAmount * newHolding.weight;
                        }

                        if (holding.identifier.toLowerCase().indexOf('cash') > -1) {
                            newHolding.performanceId = context.settings.get('cashHoldingIdentifier');
                            newHolding.holdingTypeId = 'C';
                        } else {
                            var identifierTypeData = _.find(identifierTypeMapping, { value: holding.identifierType }) || {};
                            newHolding[identifierTypeData.type || 'secId'] = holding.identifier;
                        }
                        newPortfolio.holdings.push(newHolding);
                    }
                });

                newPortfolios.push(newPortfolio);
            });

            return newPortfolios;
        }

        function generateTempPortfolios(portfolios) {
            var tempPortfolios = [];

            if (portfolios.current || portfolios.proposed) {
                if (portfolios.current) {
                    tempPortfolios.push(portfolios.current);
                }
                if (portfolios.proposed) {
                    tempPortfolios.push(portfolios.proposed);
                }
            } else {
                tempPortfolios.push(portfolios);
            }

            return tempPortfolios;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 18 */
/***/function (module, exports) {

    module.exports = {
        "ecPortfolioData": {
            "blueprints": {
                "basicDataApi": {
                    "settings": {
                        "_model": {
                            "benchmark": null,
                            "securities": {
                                "api": {
                                    "headers": {
                                        "access_token": "{{_ tokens().accessToken _}}",
                                        "apiKey": "{{_ tokens().apiKey _}}",
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toPortfolioAPIBasic"],
                                        "watchedPaths": ["portfolio"]
                                    },
                                    "url": "https://{{baseUrl}}/paapi/v2/xray",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromPortfolioAPI"]
                            }
                        },
                        "assetAllocationType": "FACT469"
                    },
                    "type": "ecPortfolioData"
                },
                "standard": {
                    "settings": {
                        "_model": {
                            "benchmark": null,
                            "securities": {
                                "api": {
                                    "headers": {
                                        "access_token": "{{_ tokens().accessToken _}}",
                                        "apiKey": "{{_ tokens().apiKey _}}",
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toPortfolioAPIAdvanced"],
                                        "watchedPaths": ["portfolio"]
                                    },
                                    "url": "https://{{baseUrl}}/paapi/v2/xray",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromPortfolioAPI"]
                            }
                        },
                        "assetAllocationType": "FACT469"
                    },
                    "type": "ecPortfolioData"
                },
                "standardHypo": {
                    "settings": {
                        "_model": {
                            "securities": {
                                "api": {
                                    "headers": {
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toPAAPI"],
                                        "watchedPaths": ["portfolio", "hypotheticalSettings"]
                                    },
                                    "url": "https://{{baseUrl}}/portfolioanalysis/v1/hypo?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromPAAPIHypo"]
                            }
                        },
                        "apiViewConfigDefinitions": {
                            "config": "Default",
                            "endpoint": "hypo",
                            "view": "Growth"
                        },
                        "hypotheticalSettings": {
                            "ApplyFeeForRebalance": false,
                            "ApplySalesCharge": true,
                            "AssetBasedAnnualFee": 0,
                            "AssetFeeFrequency": "Annually",
                            "AssetFeeType": "Percentage",
                            "CapitalGainTaxRate": 0,
                            "CustomFeeType": "Amount",
                            "DividendTaxRate": 0,
                            "EntryExitFeeType": "CustomEntry",
                            "FederalIncomeTaxRate": 0,
                            "FilingStatus": "NoTaxes",
                            "FrontLoadType": "Standard",
                            "HypoType": "Portfolio",
                            "IllustrationTrailingTimePeriod": "EarliestCommon",
                            "InvestmentDetailReturnsFrequency": "Monthly",
                            "LiquidateOnEndDate": false,
                            "PayFees": "SalesOfSharesEnding",
                            "PayFeesUseCashFirst": true,
                            "PayTaxes": "OutOfPocket",
                            "RebalanceFrequency": "None",
                            "RebalanceThreshold": 0,
                            "ReinvestCapitalGains": true,
                            "ReinvestDividends": true,
                            "SalesFeeAmount": 0,
                            "StateIncomeTaxRate": 0,
                            "SubsequentInvestmentAmount": 0,
                            "SubsequentInvestmentType": "Invest",
                            "SubsequentInvestmentWithdrawalFrequency": "Monthly",
                            "SynchronizePortfolioStartDate": true,
                            "TaxableIncome": 50000
                        },
                        "returnDataSections": ["hypotheticalGrowth", "hypoDates", "portfolio", "hypotheticalGrowthTable"]
                    },
                    "type": "ecPortfolioData"
                },
                "standardPCUK": {
                    "settings": {
                        "_model": {
                            "benchmark": {
                                "api": {
                                    "url": "https://{{_ settings().baseUrlMorningstarEU _}}/api/rest.svc/{{_ settings().urlKey _}}/security/screener?pageSize=999&outputType=json&universeIds={{_ settings().benchmarkUniverseId _}}&securityDataPoints=SecId|Name"
                                }
                            },
                            "securities": {
                                "current": {
                                    "api": {
                                        "method": "post",
                                        "parameters": {
                                            "deep": true,
                                            "throttleTime": 200,
                                            "transformPipeline": ["toIwtXrayCurrent"],
                                            "watchedPaths": ["portfolio"]
                                        },
                                        "url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
                                        "usePreviousDataOnError": false,
                                        "validationExpression": "!!parameters.portfolio.current === true"
                                    },
                                    "dataSourceType": "api",
                                    "transformPipeline": ["fromIwtXrayCurrent"]
                                },
                                "proposed": {
                                    "api": {
                                        "method": "post",
                                        "parameters": {
                                            "deep": true,
                                            "throttleTime": 200,
                                            "transformPipeline": ["toIwtXrayProposed"],
                                            "watchedPaths": ["portfolio"]
                                        },
                                        "url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
                                        "usePreviousDataOnError": false,
                                        "validationExpression": "!!parameters.portfolio.proposed === true"
                                    },
                                    "dataSourceType": "api",
                                    "defaults": null,
                                    "merge": false,
                                    "transformPipeline": ["fromIwtXrayProposed"]
                                }
                            }
                        },
                        "apiDataPointsSchemaFieldDefinitions": {
                            "assetAllocation": {
                                "benchmarkDataPoints": "ShowBreakdown",
                                "portfolioDataPoints": "AssetAllocationMorningstarEUR3"
                            },
                            "benchmark": {
                                "portfolioDataPoints": "BenchmarkId,BenchmarkName"
                            },
                            "feesExpenses": {
                                "outputDataPoints": ["hypoWeight", "managementFee"],
                                "portfolioDataPoints": "ManagementFee,ActualManagementFee,OngoingCharge"
                            },
                            "fixedIncomeDetails": {
                                "portfolioDataPoints": "BondStyleBox,EffectiveDuration,EffectiveMaturity,AverageCreditQuality,CreditQuality"
                            },
                            "performanceGraph": {
                                "benchmarkDataPoints": "HistoricalPerformanceSeries",
                                "portfolioDataPoints": "HistoricalPerformanceSeries|TotalReturn"
                            },
                            "portfolioHoldings": {
                                "holdingDataPoints": "HoldingId,SecurityId,Symbol,SectorName,ExchangeCode,SecurityType,HoldingType,UniverseId,SecurityToken,Name,ISIN,ClientFund,PortfolioDate,InitialAmount,InitialWeight,Units,MarketValue,Weight,EquityWeighting,BondWeighting,EquityWeightingLong,BondWeightingLong,CurrencyId,CategoryName,SectorName,StarRatingM255,MorningstarRiskM255,SustainabilityRank,AnalystRatingScale,showbreakdown,ShowPerformanceReturn,ShowRiskMeasure,OngoingCharge,PerformanceFee,ActualManagementFee,ActualPerformanceFee,FundShareClassId,ReturnM12,ReturnM36,ReturnM60,ReturnM120",
                                "portfolioDataPoints": "UnderlyingHolding|200|HoldingId|SecurityId|SecurityType|Name|MarketValue|Weight|Sector|SectorId|GlobalSectorId|ISIN|CountryId|Country|CurrencyId|CurrencyName|Symbol,HoldingOverlap"
                            },
                            "stockRegions": {
                                "benchmarkDataPoints": "ShowBreakdown",
                                "portfolioDataPoints": "RegionalExposure"
                            },
                            "stockSectors": {
                                "benchmarkDataPoints": "ShowBreakdown",
                                "portfolioDataPoints": "GlobalStockSector"
                            },
                            "stockStats": {
                                "portfolioDataPoints": "MarketCapital,ProspectiveEarningsYield,ProspectiveBookValueYield,ProspectiveCashFlowYield,ProspectiveRevenueYield"
                            },
                            "stockStyle": {
                                "portfolioDataPoints": "StyleBox"
                            },
                            "trailingReturns": {
                                "benchmarkDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120|M255|M255UA",
                                "portfolioDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120|M255|M255UA"
                            }
                        },
                        "assetAllocationType": "MorningstarEUR3"
                    },
                    "type": "ecPortfolioData"
                },
                "standardPerformanceUS": {
                    "settings": {
                        "_model": {
                            "securities": {
                                "api": {
                                    "headers": {
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toPAAPI"],
                                        "watchedPaths": ["portfolio"]
                                    },
                                    "url": "https://{{baseUrl}}/portfolioanalysis/v1/performance?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromPAAPIPerformance"]
                            }
                        },
                        "apiViewConfigDefinitions": {
                            "config": "QuickPortfolio",
                            "endpoint": "performance",
                            "view": "Snapshot"
                        },
                        "returnDataSections": ["riskRewardScatterplot"]
                    },
                    "type": "ecPortfolioData"
                },
                "standardRiskRewardUK": {
                    "settings": {
                        "_model": {
                            "securities": {
                                "api": {
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toIwtXray"],
                                        "watchedPaths": ["portfolio"]
                                    },
                                    "url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromIwtXray"]
                            }
                        },
                        "apiDataPointsSchemaFieldDefinitions": {
                            "riskRewardScatterplot": {
                                "benchmarkDataPoints": "ShowRiskMeasure",
                                "holdingDataPoints": "Name,Weight,ShowRiskMeasure",
                                "portfolioDataPoints": "BenchmarkName,StandardDeviation|M|M12|M36|M60|M120,ArithmeticMean|M|M12|M36|M60|M120"
                            }
                        },
                        "assetAllocationType": "MorningstarEUR3"
                    },
                    "type": "ecPortfolioData"
                },
                "standardUS": {
                    "settings": {
                        "_model": {
                            "benchmark": {
                                "api": {
                                    "parameters": {
                                        "transformPipeline": ["toEcBenchmarkAPI"]
                                    },
                                    "url": "https://{{baseUrl}}/portfolioanalysis/v1/benchmark?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}"
                                }
                            },
                            "securities": {
                                "api": {
                                    "headers": {
                                        "authorization": "{{_ tokens().apiGatewayToken _}}"
                                    },
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toPAAPI"],
                                        "watchedPaths": ["portfolio"]
                                    },
                                    "url": "https://{{baseUrl}}/portfolioanalysis/v1/xray?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromPAAPI"]
                            }
                        },
                        "apiDataPointsSchemaFieldDefinitions": {
                            "feesExpenses": {
                                "outputDataPoints": ["AverageGrossExpenseRatio", "AverageNetExpenseRatio", "PotentialCapGainsExposure"]
                            }
                        },
                        "apiViewConfigDefinitions": {
                            "config": "Default",
                            "endpoint": "xray",
                            "view": "XrayOverview"
                        }
                    },
                    "type": "ecPortfolioData"
                },
                "standardXrayUK": {
                    "settings": {
                        "_model": {
                            "benchmark": {
                                "api": {
                                    "url": "https://{{_ settings().baseUrlMorningstarEU _}}/api/rest.svc/{{_ settings().urlKey _}}/security/screener?pageSize=999&outputType=json&universeIds={{_ settings().benchmarkUniverseId _}}&securityDataPoints=SecId|Name"
                                }
                            },
                            "securities": {
                                "api": {
                                    "method": "post",
                                    "parameters": {
                                        "deep": true,
                                        "throttleTime": 200,
                                        "transformPipeline": ["toIwtXray"],
                                        "watchedPaths": ["portfolio"]
                                    },
                                    "url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
                                    "usePreviousDataOnError": false,
                                    "validationExpression": "!!parameters.portfolio === true"
                                },
                                "dataSourceType": "api",
                                "transformPipeline": ["fromIwtXray"]
                            }
                        },
                        "apiDataPointsSchemaFieldDefinitions": {
                            "assetAllocation": {
                                "benchmarkDataPoints": "ShowBreakdown",
                                "portfolioDataPoints": "AssetAllocationMorningstarEUR3"
                            },
                            "benchmark": {
                                "portfolioDataPoints": "BenchmarkId,BenchmarkName"
                            },
                            "correlationMatrix": {
                                "holdingDataPoints": "HoldingId,Name",
                                "portfolioDataPoints": "CorrelationMatrix|M12"
                            },
                            "feesExpenses": {
                                "outputDataPoints": ["managementFee"],
                                "portfolioDataPoints": "ManagementFee,ActualManagementFee,OngoingCharge"
                            },
                            "fixedIncomeDetails": {
                                "portfolioDataPoints": "BondStyleBox,EffectiveDuration,EffectiveMaturity,AverageCreditQuality,CreditQuality"
                            },
                            "performanceGraph": {
                                "benchmarkDataPoints": "HistoricalPerformanceSeries",
                                "portfolioDataPoints": "HistoricalPerformanceSeries|TotalReturn"
                            },
                            "portfolioFees": {
                                "outputDataPoints": [{
                                    "format": {
                                        "dataType": "number",
                                        "maximumFractionDigits": 2,
                                        "minimumFractionDigits": 2,
                                        "style": "currency"
                                    },
                                    "key": "startValue"
                                }, {
                                    "format": {
                                        "dataType": "number",
                                        "maximumFractionDigits": 2,
                                        "minimumFractionDigits": 2,
                                        "style": "currency"
                                    },
                                    "key": "returnIncludingFeesAmount"
                                }, {
                                    "format": {
                                        "dataType": "number",
                                        "maximumFractionDigits": 2,
                                        "minimumFractionDigits": 2,
                                        "style": "currency"
                                    },
                                    "key": "returnExcludingFeesAmount"
                                }, {
                                    "format": {
                                        "dataType": "number",
                                        "maximumFractionDigits": 2,
                                        "minimumFractionDigits": 2,
                                        "style": "currency"
                                    },
                                    "key": "reductionInReturnAmount"
                                }, {
                                    "format": {
                                        "dataType": "number",
                                        "maximumFractionDigits": 2,
                                        "minimumFractionDigits": 2,
                                        "suffix": "%"
                                    },
                                    "key": "reductionInReturnPercentage"
                                }, {
                                    "format": {
                                        "dataType": "number",
                                        "maximumFractionDigits": 2,
                                        "minimumFractionDigits": 2,
                                        "style": "currency"
                                    },
                                    "key": "grandTotal"
                                }]
                            },
                            "portfolioHoldings": {
                                "holdingDataPoints": "HoldingId,SecurityId,Symbol,SectorName,SecurityType,HoldingType,UniverseId,Name,ISIN,PortfolioDate,InitialAmount,InitialWeight,MarketValue,Weight,CurrencyId,StarRatingM255,MorningstarRiskM255,AnalystRatingScale,ShowRiskMeasure,OngoingCharge,FundShareClassId,ReturnM12,ReturnM36,ReturnM60,ReturnM120,ContributionReturn",
                                "portfolioDataPoints": "UnderlyingHolding|200|HoldingId|SecurityId|SecurityType|Name|MarketValue|Weight|Sector|SectorId|GlobalSectorId|ISIN|CountryId|Country|CurrencyId|CurrencyName|Symbol,HoldingOverlap"
                            },
                            "riskScore": {
                                "portfolioDataPoints": "PortfolioRiskScore"
                            },
                            "riskStatistics": {
                                "benchmarkDataPoints": "SharpeRatio|M|M12,SharpeRatio|M|M36,StandardDeviation|M|M12,StandardDeviation|M|M36,StandardDeviation|M|M60,ShowRiskMeasure",
                                "portfolioDataPoints": "SharpeRatio|M|M12,SharpeRatio|M|M36,StandardDeviation|M|M12,StandardDeviation|M|M36,StandardDeviation|M|M60"
                            },
                            "stockRegions": {
                                "benchmarkDataPoints": "ShowBreakdown",
                                "portfolioDataPoints": "RegionalExposure"
                            },
                            "stockSectors": {
                                "benchmarkDataPoints": "ShowBreakdown",
                                "portfolioDataPoints": "GlobalStockSector"
                            },
                            "stockStats": {
                                "portfolioDataPoints": "MarketCapital,ProspectiveEarningsYield,ProspectiveBookValueYield,ProspectiveCashFlowYield,ProspectiveRevenueYield"
                            },
                            "stockStyle": {
                                "portfolioDataPoints": "StyleBox"
                            },
                            "timePeriodReturn": {
                                "portfolioDataPoints": "BestWorstPeriods|M1|M3|M6|M12|M36|M60"
                            },
                            "trailingReturns": {
                                "benchmarkDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120",
                                "portfolioDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120"
                            }
                        },
                        "assetAllocationType": "MorningstarEUR3",
                        "feesSettings": {
                            "growthRatePercent": 5,
                            "yearsToCalculate": 5
                        }
                    },
                    "type": "ecPortfolioData"
                }
            },
            "labels": {
                "cash": {
                    "en": "Cash"
                }
            },
            "settings": {
                "_model": {
                    "benchmark": {
                        "api": {
                            "headers": {
                                "authorization": "{{_ tokens().apiGatewayToken _}}"
                            },
                            "method": "get",
                            "parameters": {
                                "deep": true,
                                "isTransformSync": false,
                                "throttleTime": 200,
                                "transformPipeline": [],
                                "watchedPaths": ["enabledBenchmarkRequest"]
                            },
                            "url": null,
                            "usePreviousDataOnError": true,
                            "validationExpression": "parameters.enabledBenchmarkRequest",
                            "validationExpressions": []
                        },
                        "dataSourceType": "api",
                        "defaults": null,
                        "merge": false,
                        "selector": null,
                        "transformPipeline": []
                    },
                    "fees": {
                        "api": {
                            "headers": {
                                "Content-Type": "text/plain;charset=UTF-8"
                            },
                            "method": "post",
                            "parameters": {
                                "deep": true,
                                "throttleTime": 200,
                                "transformPipeline": ["toIwtFees"],
                                "watchedPaths": ["portfolio"]
                            },
                            "url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/investment_fees/calculate",
                            "usePreviousDataOnError": false,
                            "validationExpression": "settings.get('enabledFeesDataRequest')===true  && !!parameters.portfolio === true"
                        },
                        "dataSourceType": "api",
                        "transformPipeline": ["fromIwtFees"]
                    },
                    "securities": {
                        "api": {
                            "method": "get",
                            "parameters": {
                                "deep": true,
                                "isTransformSync": false,
                                "throttleTime": 200,
                                "transformPipeline": []
                            },
                            "url": null,
                            "usePreviousDataOnError": true,
                            "validationExpression": "",
                            "validationExpressions": []
                        },
                        "dataSourceType": "",
                        "defaults": null,
                        "merge": false,
                        "selector": null,
                        "transformPipeline": []
                    }
                },
                "_parameters": {
                    "enabledBenchmarkRequest": {},
                    "feesSettings": {},
                    "hypotheticalSettings": {},
                    "portfolio": {}
                },
                "apiDataPointsSchema": ["benchmark", "assetAllocation", "stockRegions", "stockSectors", "performanceGraph", "stockStyle", "fixedIncomeDetails", "stockStats", "feesExpenses", "trailingReturns", "portfolioHoldings", "correlationMatrix"],
                "apiDataPointsSchemaFieldDefinitions": null,
                "apiViewConfigDefinitions": null,
                "assetAllocationType": null,
                "benchmarkUniverseId": null,
                "cashHoldingIdentifier": "CASH000000",
                "cashHoldingTypeId": 1,
                "cashSecurityType": "C0",
                "defaultTopNetUnderlyingHoldingsAmount": 10,
                "defaultTotalAmount": 10000,
                "enabledBenchmarkRequest": null,
                "enabledFeesDataRequest": false,
                "feesSettings": null,
                "hypotheticalSettings": null,
                "identifierTypeMapping": [{
                    "type": "secId",
                    "value": "MSID"
                }, {
                    "type": "performanceId",
                    "value": "PrefId"
                }, {
                    "type": "ticker",
                    "value": "Ticker"
                }, {
                    "type": "isin",
                    "value": "ISIN"
                }, {
                    "type": "cusip",
                    "value": "CUSIP"
                }, {
                    "type": "fundCode",
                    "value": "FundCode"
                }],
                "maxNoOfCalendarYearsReturns": 5,
                "numberOfYearsReturns": 0,
                "portfolio": null,
                "portfolioApiSettings": null,
                "returnDataSections": ["assetAllocation", "calendarYearsReturns", "creditQuality", "editHoldings", "equityStyleBox", "feesExpenses", "fixedIncomeStyleBox", "interestRateRisk", "performanceReturn", "stockStats", "portfolioHoldings", "stockOverlap", "stockRegions", "stockSectors", "trailingPerformance", "correlationMatrix", "topNetUnderlyingHoldings"],
                "urlKey": null
            },
            "type": "ecPortfolioData"
        }
    };

    /***/
},
/* 19 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecPortfolioData', __webpack_require__(18).ecPortfolioData);
        __webpack_require__(4);
        __webpack_require__(5);
        __webpack_require__(11);
        __webpack_require__(9);
        __webpack_require__(10);
        __webpack_require__(16);
        __webpack_require__(8);
        __webpack_require__(6);
        __webpack_require__(15);
        __webpack_require__(14);
        __webpack_require__(17);
        __webpack_require__(12);
        __webpack_require__(13);
        __webpack_require__(7);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 20 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
        'use strict';

        var editHoldingsHelper = {
            generateHoldings: generateHoldings,
            generateHoldingType: generateHoldingType,
            recalculateEditHoldingsWeight: recalculateEditHoldingsWeight,
            isValidTotalWeight: isValidTotalWeight,
            isEqualTo100: isEqualTo100,
            calculateTotalAmount: calculateTotalAmount,
            setEditHoldingsModel: setEditHoldingsModel
        };

        angular.module('ecPortfolioData').factory('portfolioDataEditHoldingsHelperService', function () {
            return editHoldingsHelper;
        });

        // keep this so we can use it in the transforms/helper.js
        return editHoldingsHelper;

        function generateHoldingType(holdings) {
            if (holdings && holdings[0]) {
                if (holdings[0].holdingType) {
                    return holdings[0].holdingType;
                } else if (holdings[0].amount) {
                    return 'amount';
                } else if (holdings[0].units) {
                    return 'units';
                } else {
                    return 'weight';
                }
            }
        }

        function generateHoldings(holdings, holdingType) {
            var newHoldings = [];
            if (holdingType) {
                _.each(holdings, function (holding) {
                    if (isValidHolding(holding, holdingType)) {
                        var newHolding = {
                            identifier: holding.identifier || null,
                            identifierType: 'MSID',
                            securityType: holding.securityType || null,
                            name: holding.name || null,
                            holdingType: holdingType,
                            weight: holding.weight || null
                        };
                        newHolding[holdingType] = holding[holdingType];
                        newHoldings.push(newHolding);
                    }
                });
            }
            return newHoldings;
        }

        function setEditHoldingsModel(editHoldingsInstance, securities, portfolioType) {
            var editHoldingsModel = morningstar.asterix.util.parse(portfolioType ? portfolioType + '.editHoldings' : 'editHoldings')(securities);
            if (editHoldingsModel) {
                editHoldingsInstance.setModelProperty('holdings', editHoldingsModel);
            }
        }

        function recalculateEditHoldingsWeight(editHoldings) {
            var totalAmount = 0;
            _.each(editHoldings.valid, function (holding) {
                totalAmount = totalAmount + holding.amount;
            });
            editHoldings.totalAmount = totalAmount;
            _.each(editHoldings, function (holding) {
                if (_.findWhere(editHoldings.valid, { identifier: holding.identifier })) {
                    holding.weight = holding.amount / totalAmount * 100.0;
                }
            });
        }

        function isValidTotalWeight(holdings) {
            var totalWeight = 0;
            _.each(holdings, function (holding) {
                if (isValidHolding(holding, 'weight')) {
                    totalWeight = totalWeight + holding.weight;
                }
            });
            return isEqualTo100(totalWeight);
        }

        function isEqualTo100(value) {
            return Math.round(value * 10) / 10 === 100;
        }

        function calculateTotalAmount(holdings) {
            var totalAmount = 0;
            _.each(holdings, function (holding) {
                if (isValidHolding(holding, 'amount')) {
                    totalAmount += holding.amount;
                }
            });
            return totalAmount;
        }

        function isValidHolding(holding, holdingType) {
            return holding && holding[holdingType] && holding.identifier && holding.identifier.indexOf('EMPTY_') === -1;
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 21 */
/***/function (module, exports) {

    module.exports = {
        "identifierTypePAAPI": [{
            "key": "securityid",
            "value": "SecurityId"
        }, {
            "key": "msid",
            "value": "SecurityId"
        }, {
            "key": "ticker",
            "value": "TradingSymbol"
        }, {
            "key": "cusip",
            "value": "CUSIP"
        }, {
            "key": "fundcode",
            "value": "FundCode"
        }],
        "AssetClassGroupIdMapping": {
            "MorningstarUSA": "ACG-USBROAD",
            "MorningstarCABroad": "ACG-CABROAD",
            "ACG-Detailed-NML2": "ACG-Detailed-NML2"
        }
    };

    /***/
},
/* 22 */
/***/function (module, exports) {

    module.exports = {
        "stockOverlap": {
            "101": "basicMaterials",
            "102": "consumerCyclical",
            "103": "financialServices",
            "104": "realEstate",
            "205": "consumerDefensive",
            "206": "healthcare",
            "207": "utilities",
            "308": "communicationServices",
            "309": "energy",
            "310": "industrials",
            "311": "technology"
        }
    };

    /***/
},
/* 23 */
/***/function (module, exports) {

    module.exports = {
        "assetAllocation": {
            "idMap": {
                "ACG-USBROAD": "MorningstarUSA",
                "ACG-CABROAD": "MorningstarCABroad",
                "ACG-Detailed-NML2": "ACG-Detailed-NML2"
            },
            "MorningstarUSA": {
                "AC-USEQ": "1",
                "AC-NUSEQ": "2",
                "AC-ALLBOND": "3",
                "AC-USCASH": "4",
                "AC-USBROAD-OTHER": "5"
            },
            "MorningstarCABroad": {
                "AC-CANCASH": "1",
                "AC-CANEQ": "2",
                "AC-USEQ-XOI": "3",
                "AC-NUSNCANEQ": "4",
                "AC-ALLBOND-XOI": "5",
                "AC-CANOTHER": "6"
            },
            "ACG-Detailed-NML2": {
                "AC-USLCEQ-NML": "1",
                "AC-USMCEQ-NML": "2",
                "AC-USSCEQ-NML": "3",
                "AC-NUSEQ-NML": "4",
                "AC-EMERGEQ-NML2": "5",
                "AC-REALESTATE-NML": "6",
                "AC-COMMODITIES-NML": "7",
                "AC-FIXEDINC-NML2": "8",
                "AC-USCASH-BROAD-PFS": "9",
                "AC-USOTHER-NML2": "10"
            }
        },
        "bondStatistics": {
            "averageCreditQuality": "AverageCreditQuality",
            "averageWtdCoupon": "WTDCoupon",
            "effectiveDuration": "EffectiveDuration",
            "effectiveMaturity": "Maturity"
        },
        "creditQuality": {
            "A": "4",
            "AA": "3",
            "AAA": "2",
            "B": "7",
            "BB": "6",
            "BBB": "5",
            "BelowB": "8",
            "NotRated": "9"
        },
        "equityStatistics": {
            "prospectiveEarningsYield": "PriceEarnings",
            "prospectiveBookValueYield": "PriceBook",
            "prospectiveRevenueYield": "PriceSales",
            "prospectiveCashFlowYield": "PriceCashFlow",
            "returnOnEquity": "ROE",
            "returnOnAssets": "ROA"
        },
        "globalStockSectors": {
            "BasicMaterials": "101",
            "CommunicationServices": "308",
            "ConsumerCyclical": "102",
            "ConsumerDefensive": "205",
            "Energy": "309",
            "FinancialServices": "103",
            "Healthcare": "206",
            "Industrials": "310",
            "RealEstate": "104",
            "Technology": "311",
            "Utilities": "207"
        },
        "regionalExposure": {
            "americas": {
                "name": "Americas",
                "subRegions": {
                    "LatinAmerica": {
                        "type": "americas",
                        "name": "3",
                        "key": "3"
                    },
                    "NorthAmerica": {
                        "type": "americas",
                        "name": "1",
                        "key": "1"
                    }
                }
            },
            "asia": {
                "name": "GreaterAsia",
                "subRegions": {
                    "AsiaDeveloped": {
                        "type": "asia",
                        "name": "12",
                        "key": "12"
                    },
                    "AsiaEmerging": {
                        "type": "asia",
                        "name": "13",
                        "key": "13"
                    },
                    "Australia": {
                        "type": "asia",
                        "name": "11",
                        "key": "11"
                    },
                    "Japan": {
                        "type": "asia",
                        "name": "10",
                        "key": "10"
                    }
                }
            },
            "europe": {
                "name": "GreaterEurope",
                "subRegions": {
                    "AfricaMiddleEast": {
                        "type": "europe",
                        "name": "8",
                        "key": "8"
                    },
                    "EuropeDeveloped": {
                        "type": "europe",
                        "name": "6",
                        "key": "6"
                    },
                    "EuropeEmerging": {
                        "type": "europe",
                        "name": "7",
                        "key": "7"
                    },
                    "UnitedKingdom": {
                        "type": "europe",
                        "name": "4",
                        "key": "4"
                    }
                }
            },
            "notClassified": {
                "name": "NotClassified",
                "key": "99"
            }
        },
        "stockSectors": {
            "a1": "basicMaterials",
            "a2": "consumerCyclical",
            "a3": "financialServices",
            "a4": "realEstate",
            "b1": "communicationServices",
            "b2": "energy",
            "b3": "industrials",
            "b4": "technology",
            "c1": "consumerDefensive",
            "c2": "healthcare",
            "c3": "utilities"
        }
    };

    /***/
},
/* 24 */
/***/function (module, exports) {

    module.exports = {
        "assetAllocation": {
            "FACT469": {
                "stock": {
                    "N": "FACT469_PARM38_OPTION105",
                    "L": "FACT469_PARM38_OPTION105_26056",
                    "S": "FACT469_PARM38_OPTION105_26057"
                },
                "bond": {
                    "N": "FACT469_PARM38_OPTION100",
                    "L": "FACT469_PARM38_OPTION100_26056",
                    "S": "FACT469_PARM38_OPTION100_26057"
                },
                "cash": {
                    "N": "FACT469_PARM38_OPTION101",
                    "L": "FACT469_PARM38_OPTION101_26056",
                    "S": "FACT469_PARM38_OPTION101_26057"
                },
                "pref": {
                    "N": "FACT469_PARM38_OPTION104",
                    "L": "FACT469_PARM38_OPTION104_26056",
                    "S": "FACT469_PARM38_OPTION104_26057"
                },
                "convert": {
                    "N": "FACT469_PARM38_OPTION102",
                    "L": "FACT469_PARM38_OPTION102_26056",
                    "S": "FACT469_PARM38_OPTION102_26057"
                },
                "other": {
                    "N": "FACT469_PARM38_OPTION103",
                    "L": "FACT469_PARM38_OPTION103_26056",
                    "S": "FACT469_PARM38_OPTION103_26057"
                }
            }
        },
        "stockRegions": {
            "americas": {
                "northAmerica": ["26729", "26718"],
                "latinAmerica": "26725"
            },
            "asia": {
                "asiaDeveloped": "26715",
                "asiaEmerging": "26716",
                "australasia": "26717",
                "japan": "26724"
            },
            "europe": {
                "africaMiddleEast": ["26714", "26726"],
                "europeDeveloped": ["26722", "26723"],
                "europeEmerging": "26721",
                "unitedKingdom": "26728"
            }
        },
        "equityStyleBox": ["large_value", "large_blend", "large_growth", "medium_value", "medium_blend", "medium_growth", "small_value", "small_blend", "small_growth"],
        "portfolioHoldings": {
            "clientSecurityId": "clientSecurityId",
            "date": "date",
            "marketValue": "marketValue",
            "marketValueRate": "marketValueRate",
            "morningstarAnalystRating": "FACT2319",
            "name": "name",
            "performanceId": "performanceId",
            "returnM1": "FACT830_1",
            "returnM3": "FACT830_2",
            "returnM6": "FACT830_3",
            "returnYTD": "FACT830_4",
            "returnY1": "FACT830_5",
            "returnY3": "FACT830_6",
            "secId": "secId",
            "sortValue": "sortValue",
            "styleBoxEQ": "FACT973_7",
            "styleBoxFI": "FACT973_8",
            "ticker": "ticker",
            "universe": "universe",
            "weight": "weight",
            "price": "price",
            "shares": "shares",
            "priceCurrency": "priceCurrency",
            "priceRate": "priceRate",
            "rowType": "rowType"
        },
        "trailingPerformance": {
            "marketValue": "marketValue",
            "rowType": "rowType",
            "M1": "FACT830_1",
            "M3": "FACT830_2",
            "M6": "FACT830_3",
            "M0": "FACT830_4",
            "M12": "FACT830_5",
            "M36": "FACT830_6"
        },
        "stockSectors": {
            "basic-materials": "FACT1106_PARM69_OPTION24076",
            "consumer-cyclical": "FACT1106_PARM69_OPTION24078",
            "financial-services": "FACT1106_PARM69_OPTION24081",
            "real-estate": "FACT1106_PARM69_OPTION24084",
            "consumer-defensive": "FACT1106_PARM69_OPTION24079",
            "healthcare": "FACT1106_PARM69_OPTION24082",
            "utilities": "FACT1106_PARM69_OPTION24086",
            "communication-services": "FACT1106_PARM69_OPTION24077",
            "energy": "FACT1106_PARM69_OPTION24080",
            "industrials": "FACT1106_PARM69_OPTION24083",
            "technology": "FACT1106_PARM69_OPTION24085"
        },
        "stockStats": {
            "marketCapital": "Average_Market_Cap_Long",
            "priceBookRatio": "P_B_Ratio_Long",
            "priceSalesRatio": "P_S_Ratio_Long",
            "priceCashRatio": "P_Cash_Flow_Ratio_Long",
            "netMarginLong": "Net_Margin_Long",
            "priceEarningsRatio": "P_E_Ratio_Long",
            "returnOnEquity": "ROE",
            "returnOnAssets": "ROA",
            "rowtype": "rowType"
        }
    };

    /***/
}]
/******/);
//# sourceMappingURL=ec-portfolio-data.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};
	/******/
	/******/ // The require function
	/******/function __webpack_require__(moduleId) {
		/******/
		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId]) {
			/******/return installedModules[moduleId].exports;
			/******/
		}
		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/i: moduleId,
			/******/l: false,
			/******/exports: {}
			/******/ };
		/******/
		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ // Flag the module as loaded
		/******/module.l = true;
		/******/
		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}
	/******/
	/******/
	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;
	/******/
	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;
	/******/
	/******/ // identity function for calling harmony imports with the correct context
	/******/__webpack_require__.i = function (value) {
		return value;
	};
	/******/
	/******/ // define getter function for harmony exports
	/******/__webpack_require__.d = function (exports, name, getter) {
		/******/if (!__webpack_require__.o(exports, name)) {
			/******/Object.defineProperty(exports, name, {
				/******/configurable: false,
				/******/enumerable: true,
				/******/get: getter
				/******/ });
			/******/
		}
		/******/
	};
	/******/
	/******/ // getDefaultExport function for compatibility with non-harmony modules
	/******/__webpack_require__.n = function (module) {
		/******/var getter = module && module.__esModule ?
		/******/function getDefault() {
			return module['default'];
		} :
		/******/function getModuleExports() {
			return module;
		};
		/******/__webpack_require__.d(getter, 'a', getter);
		/******/return getter;
		/******/
	};
	/******/
	/******/ // Object.prototype.hasOwnProperty.call
	/******/__webpack_require__.o = function (object, property) {
		return Object.prototype.hasOwnProperty.call(object, property);
	};
	/******/
	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "build/";
	/******/
	/******/ // Load entry module and return exports
	/******/return __webpack_require__(__webpack_require__.s = 7);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

	module.exports = morningstar;

	/***/
},
/* 1 */
/***/function (module, exports) {

	module.exports = _;

	/***/
},
/* 2 */
/***/function (module, exports) {

	module.exports = angular;

	/***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
		'use strict';

		reportBuilder.$inject = ["reportBuilderService"];
		angular.module('ecReportBuilder', ['mstarCore', 'ecButton', 'ecChosen', 'ecContainer', 'ecInput', 'ecPortfolioData']).directive('ecReportBuilder', reportBuilder);

		function reportBuilder(reportBuilderService) {
			return {
				restrict: 'E',
				require: 'mstarComponentId',
				scope: {},
				template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
				link: linkFn
			};

			function linkFn(scope, elem, attr, mstarComponent) {
				// binds settings, labels, formatter and templates to scope properties
				mstarComponent.bindConfig(scope);

				// compiles the main template
				mstarComponent.compileTemplate(scope, '_templates.main');

				// binds parameters (two-way between the asterix instance's parameters and scope.parameters)
				mstarComponent.bindParameters(scope);

				// initiates our scope.model according to settings and two-way binds it to the asterix instance's model
				mstarComponent.bindModelData(scope, { editable: true });
				// ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

				var languageId = scope.settings.get('languageId');
				var dateFormatter = morningstar.asterix.formatting.getFormatter(languageId).date;
				var todayDate = dateFormatter(new Date(), scope.settings.get('coverPageDateFormat'));
				scope.isLoading = false;
				scope.model.reportInfo = morningstar.asterix.extend(true, {}, {
					reportName: null,
					reportContents: [],
					reportCoverPage: {
						preparedBy: {},
						preparedFor: {},
						reportDate: todayDate,
						title: null
					},
					reportNotesPage: {
						notes: {}
					},
					reportPortfolios: []
				}, scope.model.reportInfo);

				scope.availableReportContents = [];
				scope.coverPagePreparedBy = getCoverPageFieldGroup('coverPagePreparedByFieldDefinition');
				scope.coverPagePreparedFor = getCoverPageFieldGroup('coverPagePreparedForFieldDefinition');
				scope.notes = getCoverPageFieldGroup('notesFieldDefinition');

				setCoverPagePreparedFieldValue(scope.model.reportInfo.reportCoverPage.preparedBy, scope.coverPagePreparedBy);
				setCoverPagePreparedFieldValue(scope.model.reportInfo.reportCoverPage.preparedFor, scope.coverPagePreparedFor);
				setCoverPagePreparedFieldValue(scope.model.reportInfo.reportNotesPage.notes, scope.notes);

				// listen to changes to contents listItem and update scope
				mstarComponent.addUnregisterCallback(scope.instance.findRelative('reportContents').on('modelPropertyChanged:listItems', function (listItems) {
					scope.availableReportContents = listItems;
				}));

				mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('modelChanged', function (model) {
					var reportContents = morningstar.asterix.util.parse('reportInfo.reportContents')(model) || [];
					scope.instance.findRelative('reportGenerateButton').setParameter('disabled', reportContents.length === 0);
					//Update selectedContents model so we can bind sections visibility to them more easily
					//selectedContens will hold an object that is the list of selected contents with "true" as their value (ie. { coverPage:true, ...})
					scope.model.selectedContents = {};
					_.each(reportContents, function (value, key) {
						scope.model.selectedContents[value] = true;
					});

					// Add class to "Select all" for partially selected options
					if (reportContents.length > 0 && reportContents.length < scope.availableReportContents.length) {
						scope.partialSelect = true;
					} else {
						scope.partialSelect = false;
					}
				}));

				mstarComponent.addUnregisterCallback(scope.instance.findRelative('reportGenerateButton').on('click', function (event) {
					reportBuilderService.generateReport(scope);
				}));

				// Checks if all checkboxes are selected or not
				// @return {Boolean}
				scope.allCheckboxesSelected = function () {
					return scope.model.reportInfo.reportContents && scope.model.reportInfo.reportContents.length === scope.availableReportContents.length;
				};

				// Handle click on "select all" checkbox
				// This basically just calls toggleAllOptions without bubbling down
				// and leaves toggleAllOptions clean for testing
				// @param {Event} $event The event that triggered the function
				scope.handleSelectAllClick = function ($event) {
					// avoid event bubbling down
					// will be called more than once otherwise (we do not want that)
					$event.preventDefault();
					$event.stopPropagation();

					scope.toggleAllOptions();
				};

				// Toggle all checkboxes on or off, depending on current state
				scope.toggleAllOptions = function () {
					// update scope with all or none of the options
					if (scope.allCheckboxesSelected()) {
						scope.model.reportInfo.reportContents = [];
					} else {
						// get all the available contents keys (in string format)
						var contentKeys = _.map(_.pluck(scope.availableReportContents, 'key'), function (key) {
							return key.toString();
						});
						scope.model.reportInfo.reportContents = contentKeys;
					}
				};

				function getCoverPageFieldGroup(key) {
					var retArray = [];
					_.each(scope.settings.get(key), function (item) {
						retArray.push({
							labelKey: item.labelKey,
							inputType: morningstar.asterix.util.string.firstUpperCase(item.inputType),
							className: morningstar.asterix.util.string.dashCase(item.labelKey)
						});
					});
					return retArray;
				}

				function setCoverPagePreparedFieldValue(reportPreparedField, preparedFieldDefinition) {
					_.each(preparedFieldDefinition, function (item) {
						reportPreparedField[item.labelKey] = reportPreparedField[item.labelKey] || null;
					});
				}
			}
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
		'use strict';

		var helper = {
			clickedReportBuilderButtonEvent: clickedReportBuilderButtonEvent,
			clickedCancelButtonEvent: clickedCancelButtonEvent,
			changedPdfStatusParameter: changedPdfStatusParameter
		};

		angular.module('ecReportBuilder').factory('reportBuilderHelperService', function () {
			return helper;
		});

		function clickedReportBuilderButtonEvent(context, instanceType) {
			if (context.settings.get('directlyGenerateReport')) {
				context.instance.findRelative('reportBuilder.reportGenerateButton').trigger('click');
			} else {
				checkHoldingsForCorrelationMatrix(context, instanceType);
				context.model.sections.showReportBuilder = !context.model.sections.showReportBuilder;
				context.model.sections.showToolBar = !context.model.sections.showReportBuilder;
				context.model.sections.showEditPortfolio = !context.model.sections.showReportBuilder;
			}
		}

		function checkHoldingsForCorrelationMatrix(context, instanceType) {
			//when portfolio holding length < 2, to disable correlation matrix report
			var reportContentsInstance = context.instance.findRelative('reportBuilder.reportContents'),
			    reportContentsItems = reportContentsInstance.model.listItems;
			var correlationMatrix = _.find(reportContentsItems, function (item) {
				return item.key === 'correlationMatrix';
			});
			if (correlationMatrix) {
				if (instanceType === 'xray') {
					correlationMatrix.disabled = context.parameters.portfolio.holdings.length < 2;
				} else if (instanceType === 'portfolioCompare') {
					correlationMatrix.disabled = context.parameters.portfolio.current.holdings.length < 2 || context.parameters.portfolio.proposed.holdings.length < 2;
				}
				reportContentsInstance.setModelProperty('listItems', reportContentsItems);

				//when correlation matrix report is checked but portfolio holding length change to < 2, uncheck it.
				var reportBuilderInstance = context.instance.findRelative('reportBuilder'),
				    reportBuilderModel = reportBuilderInstance.model,
				    reportContents = morningstar.asterix.util.parse('reportInfo.reportContents')(reportBuilderModel) || [];
				if (correlationMatrix.disabled) {
					reportBuilderInstance.setModelProperty('reportInfo.reportContents', _.without(reportContents, 'correlationMatrix'));
				}
			}
		}

		function clickedCancelButtonEvent(context) {
			context.model.sections.showToolBar = true;
			context.model.sections.showReportBuilder = false;
			context.model.sections.showEditPortfolio = true;
		}

		function changedPdfStatusParameter(context, pdfStatus) {
			if (context.model.sections.showReportBuilder && !pdfStatus) {
				context.model.sections.showReportBuilder = false;
				context.model.sections.showToolBar = true;
				context.model.sections.showEditPortfolio = true;
			}
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	/* jshint browser: true */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, dataPointMapping) {
		'use strict';

		angular.module('ecReportBuilder').factory('reportBuilderService', ['mstarAjax', '$window', 'portfolioDataTransformHelperService', function (mstarAjax, $window, portfolioDataTransformHelperService) {
			var COVER_PAGE = 'coverPage';

			function generateReport(scope) {
				var reportDataSource = scope.settings.get('reportDataSource') || {};
				var reportDataSettings = {
					requestMethod: reportDataSource.requestMethod,
					url: reportDataSource.url,
					reportCoverPage: morningstar.asterix.util.parse('model.reportInfo.reportCoverPage')(scope) || {},
					reportContents: morningstar.asterix.util.parse('model.reportInfo.reportContents')(scope) || [],
					reportName: morningstar.asterix.util.parse('model.reportInfo.reportPortfolios[0].reportName')(scope),
					reportSettings: morningstar.asterix.util.merge({}, scope.settings.get('reportSettings'), morningstar.asterix.util.parse('model.reportInfo.reportSettings')(scope)),
					portfolios: morningstar.asterix.util.parse('model.reportInfo.reportPortfolios')(scope) || [],
					languageId: scope.settings.get('languageId')
				};

				if (isValidReportDataSettings(reportDataSettings)) {
					if (reportDataSource.type === 'USAPI') {
						generateUsxRayReport(scope, reportDataSettings);
					} else if (reportDataSource.type === 'UKAPI') {
						generateUkxRayReport(scope, reportDataSettings);
					}
				}
			}

			// For US x-ray report
			function generateUsxRayReport(scope, reportDataSettings) {
				scope.parameters.isLoading = true;
				var urlParameters = portfolioDataTransformHelperService.generatePAAPIUrlParameters(scope);
				reportDataSettings.portfolios[0].Name = reportDataSettings.reportName;

				if (urlParameters.apiTokenType && urlParameters.apiTokenValue) {
					reportDataSettings.url = reportDataSettings.url + '&' + urlParameters.apiTokenType + '=' + urlParameters.apiTokenValue;
				}
				openPdf(scope, {
					requestMethod: reportDataSettings.requestMethod,
					url: morningstar.asterix.util.url.parameterize(reportDataSettings.url, {
						baseUrl: urlParameters.baseUrl,
						langcult: reportDataSettings.languageId
					}),
					requestData: morningstar.asterix.util.merge({}, reportDataSettings.reportSettings, {
						RequestSettings: generateUsRequestSettings(scope, reportDataSettings),
						portfolios: reportDataSettings.portfolios
					})
				});
			}

			function generateUsRequestSettings(scope, reportDataSettings) {
				var coverPageIndex = _.indexOf(reportDataSettings.reportContents, COVER_PAGE);
				var reportPages = morningstar.asterix.extend(true, [], reportDataSettings.reportContents);
				var requestSettings = {
					ReportSettings: {}
				};
				var preparedByDataPointDefinition = morningstar.asterix.util.parse('xray.us.coverPagePreparedByFieldDefinition')(dataPointMapping);
				var preparedForDataPointDefinition = morningstar.asterix.util.parse('xray.us.coverPagePreparedForFieldDefinition')(dataPointMapping);
				if (coverPageIndex > -1) {
					reportPages.splice(coverPageIndex, 1);
					requestSettings.ReportSettings.ReportPages = reportPages;
					requestSettings.ReportSettings.CoverPage = {
						ReportTitle: reportDataSettings.reportCoverPage.title,
						PreparedFor: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedFor, scope.settings.get('coverPagePreparedForFieldDefinition'), preparedForDataPointDefinition),
						PreparedBy: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedBy, scope.settings.get('coverPagePreparedByFieldDefinition'), preparedByDataPointDefinition)
					};
				} else {
					requestSettings.ReportSettings.ReportPages = reportPages;
				}
				return requestSettings;
			}

			// For Uk xRay Report
			function generateUkxRayReport(scope, reportDataSettings) {
				scope.parameters.isLoading = true;

				reportDataSettings.portfolios[0].name = reportDataSettings.reportName;

				openPdf(scope, {
					requestMethod: reportDataSettings.requestMethod,
					url: morningstar.asterix.util.url.parameterize(reportDataSettings.url, {
						baseUrl: scope.settings.get('baseUrlPdfServiceEU')
					}),

					requestData: {
						settings: {
							languageId: reportDataSettings.languageId,
							currencyId: reportDataSettings.portfolios[0].currencyId || scope.settings.get('currencyId')
						},
						components: generateUkComponents(scope, reportDataSettings)
					}
				});
			}

			function generateUkComponents(scope, reportDataSettings) {
				var components = {},
				    reportOrder = [],
				    reportType;

				morningstar.asterix.util.each(reportDataSettings.reportContents, function (item, index) {
					reportOrder.push({
						id: item
					});
				});

				if (reportDataSettings.reportSettings.xrayReport) {
					reportType = 'xrayReport';
				} else if (reportDataSettings.reportSettings.portfolioComparisonReport) {
					reportType = 'portfolioComparisonReport';
				}

				components[reportType] = {
					settings: {
						urlKey: scope.settings.get('urlKey'),
						reportOrder: reportOrder,
						_parameters: generateUkParameters(scope, reportDataSettings, reportType),
						pdfServer: scope.settings.get('pdfServer')
					}
				};
				return morningstar.asterix.util.merge({}, reportDataSettings.reportSettings, components);
			}

			function generateUkParameters(scope, reportDataSettings, reportType) {
				var parameters = {};
				if (reportType === 'xrayReport') {
					parameters.portfolio = reportDataSettings.portfolios[0];
				} else if (reportType === 'portfolioComparisonReport') {
					parameters.currentPortfolio = reportDataSettings.portfolios[0];
					parameters.proposedPortfolio = reportDataSettings.portfolios[1];
				}
				var preparedByDataPointDefinition = morningstar.asterix.util.parse('xray.uk.coverPagePreparedByFieldDefinition')(dataPointMapping);
				var preparedForDataPointDefinition = morningstar.asterix.util.parse('xray.uk.coverPagePreparedForFieldDefinition')(dataPointMapping);
				var coverPageIndex = _.indexOf(reportDataSettings.reportContents, COVER_PAGE);
				if (coverPageIndex > -1) {
					parameters.coverInfo = {
						title: reportDataSettings.reportCoverPage.title,
						reportDate: scope.format.date(new Date(), 'yyyy-mm-dd'),
						preparedBy: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedBy, scope.settings.get('coverPagePreparedByFieldDefinition'), preparedByDataPointDefinition),
						preparedFor: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedFor, scope.settings.get('coverPagePreparedForFieldDefinition'), preparedForDataPointDefinition)
					};
				}

				return parameters;
			}

			//commom function
			function generateCoverPagePreparedInfo(prepared, fieldDefinition, dataPointDefinition) {
				var obj = {};
				if (prepared && fieldDefinition) {
					var advisors = {};
					_.each(fieldDefinition, function (item) {
						if (prepared[item.labelKey]) {
							if (morningstar.asterix.util.parse('advisors.' + item.labelKey)(dataPointDefinition)) {
								advisors[dataPointDefinition.advisors[item.labelKey]] = prepared[item.labelKey];
							} else {
								obj[dataPointDefinition[item.labelKey]] = prepared[item.labelKey];
							}
						}
					});
					if (!_.isEmpty(advisors)) {
						obj.Advisors = [];
						obj.Advisors.push(advisors);
					}
				}
				return obj;
			}

			function isValidReportDataSettings(reportDataSettings) {
				if (!reportDataSettings.reportSettings) {
					morningstar.asterix.util.log.debug('Missing report settings in report-builder');
					return false;
				}
				if (reportDataSettings.portfolios.length === 0) {
					morningstar.asterix.util.log.debug('Missing portfolios in report-builder');
					return false;
				}
				return true;
			}

			function openPdf(scope, apiSettings) {
				var headers = {
					accept: 'application/pdf',
					authorization: morningstar.asterix.context.getToken('apiGatewayToken')
				};
				mstarAjax.api({
					method: apiSettings.requestMethod,
					url: apiSettings.url,
					headers: headers,
					responseType: 'arraybuffer'
				}, apiSettings.requestData).promise.then(function (response) {
					scope.parameters.isLoading = false;
					var blob = new Blob([response], {
						type: 'application/pdf'
					});
					if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
						$window.navigator.msSaveOrOpenBlob(blob); // for IE
					} else {
						var fileURL = URL.createObjectURL(blob);
						$window.open(fileURL);
					}
				});
			}

			return {
				generateReport: generateReport
			};
		}]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 6 */
/***/function (module, exports) {

	module.exports = {
		"ecReportBuilder": {
			"blueprints": {
				"plannerReportBuilder": {
					"blueprint": "standardPlanner",
					"components": {
						"reportContents": {
							"labels": {
								"coverPage": {
									"da-DK": "Forside",
									"en": "Cover Page",
									"fr": "Page de garde",
									"fr-CA": "Page de couverture",
									"it": "Copertina",
									"sv": "Framsida",
									"zh-CN": "封面",
									"zh-HK": "封面"
								},
								"goalAnalysis": {
									"da-DK": "Analyse af Mål",
									"en": "Goal Analysis",
									"fr": "Analyses de l'objectif",
									"fr-CA": "Analyse de l'objectif",
									"it": "Analisi degli obiettivi",
									"sv": "Målanalys",
									"zh-CN": "目标分析",
									"zh-HK": "目標分析"
								},
								"kiid": {
									"da-DK": "CI",
									"en": "KIID",
									"fr": "DICI",
									"it": "KIID",
									"sv": "KIID",
									"zh-CN": "KIID",
									"zh-HK": "KIID"
								},
								"proposedPortfolio": {
									"da-DK": "Foreslået Portefølje",
									"en": "Proposed Portfolio",
									"fr": "Portefeuille proposé",
									"it": "Portafoglio proposto",
									"sv": "Föreslagen portfölj",
									"zh-CN": "建议投资组合",
									"zh-HK": "建議投資組合"
								},
								"questionnaire": {
									"da-DK": "Spørgeskema",
									"en": "Questionnaire",
									"fr": "Questionnaire",
									"it": "Questionario",
									"sv": "Frågeformulär",
									"zh-CN": "调查问卷",
									"zh-HK": "調查問卷"
								}
							},
							"settings": {
								"_model": {
									"listItems": [{
										"key": "coverPage",
										"value": "coverPage"
									}, {
										"key": "goal",
										"value": "goalAnalysis"
									}, {
										"key": "rtqReport",
										"value": "questionnaire"
									}, {
										"key": "riskProfile",
										"value": "riskProfile"
									}, {
										"key": "proposedXrayReport",
										"value": "proposedPortfolio"
									}, {
										"key": "kiidDocuments",
										"value": "kiid"
									}]
								},
								"controlType": "checkbox"
							},
							"type": "ecChosen"
						}
					},
					"settings": {
						"_model": {
							"reportInfo": {
								"dataSourceType": "selector",
								"selector": "{{_ model(_).reportInfo _}}"
							}
						}
					},
					"type": "ecReportBuilder"
				},
				"standardPlanner": {
					"components": {
						"containerReportBuilder": {
							"settings": {
								"breakpoints": {
									"large": "medium",
									"medium": {
										"groups": {
											"left": {
												"cols": 4,
												"defaultSection": {
													"cols": 12
												},
												"order": 0,
												"sections": ["reportContents"]
											},
											"right": {
												"cols": 8,
												"defaultSection": {
													"cols": 12
												},
												"order": 1,
												"sections": ["reportCoverPageTitle", {
													"cols": 6,
													"sectionId": "reportCoverPagePreparedFor"
												}, {
													"cols": 6,
													"sectionId": "reportCoverPagePreparedBy"
												}, "reportNotes"]
											}
										}
									},
									"small": {
										"groups": {
											"all": {
												"defaultSection": {
													"cols": 12
												},
												"sections": ["reportCoverPageTitle", "reportContents", "reportCoverPagePreparedFor", "reportCoverPagePreparedBy", "reportNotes"]
											}
										}
									},
									"xlarge": "large"
								},
								"sections": {
									"reportCoverPagePreparedBy": {
										"show": "{{_ model(_).coverPageUserInput.show _}}"
									},
									"reportCoverPagePreparedFor": {
										"show": "{{_ model(_).coverPageUserInput.show _}}"
									},
									"reportNotes": {
										"show": "{{_ model(_).selectedContents.advisorNotes _}}"
									}
								}
							},
							"type": "ecContainer"
						},
						"reportContents": {
							"settings": {
								"_model": {
									"listItems": [{
										"key": "coverPage",
										"value": "coverPage"
									}, {
										"key": "rtqReport",
										"value": "questionnaire"
									}, {
										"key": "riskProfile",
										"value": "riskProfile"
									}, {
										"key": "currentXrayReport",
										"value": "currentPortfolio"
									}, {
										"key": "proposedXrayReport",
										"value": "proposedPortfolio"
									}, {
										"key": "portfolioComparisonReport",
										"value": "portfolioComparison"
									}, {
										"key": "assetAllocator",
										"value": "goalAnalysis"
									}, {
										"key": "suitability",
										"value": "suitabilitySummary"
									}, {
										"key": "costComparison",
										"value": "costAnalysis"
									}, {
										"key": "advisorNotes",
										"value": "advisorNotes"
									}, {
										"key": "kiidDocuments",
										"value": "keyInvestorInformationDocuments"
									}, {
										"key": "fundProfiles",
										"micro": "reportWarning",
										"value": "fundProfiles"
									}, {
										"key": "signOff",
										"value": "signOff"
									}]
								},
								"controlType": "checkbox",
								"microValueField": "micro"
							},
							"type": "ecChosen"
						}
					},
					"labels": {
						"advisorNotes": {
							"da-DK": "Rådgivers Noter",
							"en": "Advisor Notes",
							"fr": "Notes du conseiller",
							"it": "Note del consulente",
							"sv": "Rågivarens anteckningar",
							"zh-CN": "顾问笔记",
							"zh-HK": "顧問筆記"
						},
						"costAnalysis": {
							"da-DK": "Omkostningsanalyse",
							"en": "Cost Analysis",
							"fr": "Analyse des coûts",
							"fr-CA": "",
							"it": "Analisi dei costi",
							"sv": "Kostnadsanalys",
							"zh-CN": "成本分析",
							"zh-HK": "成本分析"
						},
						"coverPage": {
							"da-DK": "Forside",
							"en": "Cover Page",
							"fr": "Page de garde",
							"fr-CA": "Page de couverture",
							"it": "Copertina",
							"sv": "Framsida",
							"zh-CN": "封面",
							"zh-HK": "封面"
						},
						"currentPortfolio": {
							"da-DK": "Nuværende Portefølje",
							"en": "Current Portfolio",
							"fr-FR": "Portefeuille actuel",
							"it": "Portafoglio corrente",
							"sv": "Nuvarande portfölj"
						},
						"fundProfiles": {
							"da-DK": "Faktaark",
							"en": "Fund Profile",
							"fr": "Profil du fonds",
							"fr-CA": "Profil du fonds",
							"it": "Profilo del fondo",
							"sv": "Fund report PDF",
							"zh-CN": "基金简介",
							"zh-HK": "基金簡介"
						},
						"goalAnalysis": {
							"da-DK": "Analyse af Mål",
							"en": "Goal Analysis",
							"fr": "Analyses de l'objectif",
							"fr-CA": "Analyse de l'objectif",
							"it": "Analisi degli obiettivi",
							"sv": "Målanalys",
							"zh-CN": "目标分析",
							"zh-HK": "目標分析"
						},
						"keyInvestorInformationDocuments": {
							"da-DK": "CI",
							"en": "KIID",
							"fr": "DICI",
							"it": "KIID",
							"sv": "KIID",
							"zh-CN": "KIID",
							"zh-HK": "KIID"
						},
						"portfolioComparison": {
							"da-DK": "Porteføljesammenligning",
							"en": "Portfolio Comparison",
							"fr": "Comparaison de portefeuilles",
							"it": "Confronto portafoglio",
							"sv": "Portföljjämförelse"
						},
						"preparedByAddressLine1": {
							"da-DK": "Adresselinie 1",
							"en": "Address Line 1",
							"fr": "Adresse Ligne 1",
							"fr-CA": "Ligne 1 de l'adresse",
							"it": "Indirizzo riga 1",
							"sv": "Adress rad 1",
							"zh-CN": "地址行1",
							"zh-HK": "地址行1"
						},
						"preparedByAddressLine2": {
							"da-DK": "Adresselinje 2",
							"en": "Address Line 2",
							"fr": "Adresse Ligne 2",
							"fr-CA": "Ligne 2 de l'adresse",
							"it": "Indirizzo riga 2",
							"sv": "Adress rad 2",
							"zh-CN": "地址行2",
							"zh-HK": "地址行2"
						},
						"preparedByAdvisorEmail1": {
							"da-DK": "Rådgiver E-mail 1",
							"en": "Advisor Email 1",
							"fr": "Email du conseiller 1",
							"fr-CA": "Adresse courriel du conseiller 1",
							"it": "E-mail consulente 1",
							"sv": "Epost rådgivare 1",
							"zh-CN": "顾问电子邮件1",
							"zh-HK": "顧問電子郵件1"
						},
						"preparedByAdvisorEmail2": {
							"da-DK": "Rådgiver E-mail 2",
							"en": "Advisor Email 2",
							"fr": "Email du conseiller 2",
							"fr-CA": "Adresse courriel du conseiller 2",
							"it": "E-mail consulente 2",
							"sv": "Epost rådgivare 2",
							"zh-CN": "顾问电子邮件2",
							"zh-HK": "顧問電子郵件2"
						},
						"preparedByAdvisorName1": {
							"da-DK": "Rådgivernavn 1",
							"en": "Advisor Name 1",
							"fr": "Nom du conseiller 1",
							"it": "Nome consulente 1",
							"sv": "Namn på rådgivare 1",
							"zh-CN": "顾问名称1",
							"zh-HK": "顧問名稱1"
						},
						"preparedByAdvisorName2": {
							"da-DK": "Rådgivernavn 2",
							"en": "Advisor Name 2",
							"fr": "Nom du conseiller 2",
							"it": "Nome consulente 2",
							"sv": "Namn på rådgivare 2",
							"zh-CN": "顾问名称2",
							"zh-HK": "顧問名稱2"
						},
						"preparedByAdvisorTitle1": {
							"da-DK": "Rådgiver Titel 1",
							"en": "Advisor Title 1",
							"fr": "Titre du conseiller 1",
							"it": "Titolo consulente 1",
							"sv": "Titel för rådgivare 1",
							"zh-CN": "顾问职务1",
							"zh-HK": "顧問職務1"
						},
						"preparedByAdvisorTitle2": {
							"da-DK": "Rådgiver Titel 2",
							"en": "Advisor Title 2",
							"fr": "Titre du conseiller 2",
							"it": "Titolo consulente 2",
							"sv": "Titel för rådgivare 2",
							"zh-CN": "顾问职务2",
							"zh-HK": "顧問職務2"
						},
						"preparedByFirmName": {
							"da-DK": "Firmanavn",
							"en": "Firm Name",
							"fr": "Société",
							"fr-CA": "Nom de la firme",
							"it": "Nome società",
							"sv": "Företagets namn",
							"zh-CN": "公司名称",
							"zh-HK": "公司名稱"
						},
						"preparedByPhone": {
							"da-DK": "Telefonnummer ",
							"en": "Phone Number",
							"fr": "Téléphone",
							"it": "Numero di telefono",
							"sv": "Telefonnummer",
							"zh-CN": "电话号码",
							"zh-HK": "電話號碼"
						},
						"preparedByWebsite": {
							"da-DK": "Hjemmeside",
							"en": "Website",
							"fr": "Site Internet",
							"fr-CA": "Site Web",
							"it": "Sito web",
							"sv": "Webbsida",
							"zh-CN": "网站",
							"zh-HK": "網站"
						},
						"preparedForAddressLine1": {
							"da-DK": "Adresselinie 1",
							"en": "Address Line 1",
							"fr": "Adresse Ligne 1",
							"fr-CA": "Ligne 1 de l'adresse",
							"it": "Indirizzo riga 1",
							"sv": "Adress rad 1",
							"zh-CN": "地址行1",
							"zh-HK": "地址行1"
						},
						"preparedForAddressLine2": {
							"da-DK": "Adresselinje 2",
							"en": "Address Line 2",
							"fr": "Adresse Ligne 2",
							"fr-CA": "Ligne 2 de l'adresse",
							"it": "Indirizzo riga 2",
							"sv": "Adress rad 2",
							"zh-CN": "地址行2",
							"zh-HK": "地址行2"
						},
						"preparedForCity": {
							"da-DK": "By",
							"en": "City",
							"fr": "Ville",
							"it": "Città",
							"sv": "Stad",
							"zh-CN": "城市",
							"zh-HK": "城市"
						},
						"preparedForEmail": {
							"da-DK": "E-mail Adresse",
							"en": "Email Address",
							"fr": "E-Mail",
							"fr-CA": "Adresse courriel",
							"it": "Indirizzo e-mail",
							"sv": "Epostadress",
							"zh-CN": "电邮地址",
							"zh-HK": "電郵地址"
						},
						"preparedForName": {
							"da-DK": "Navn",
							"en": "Name",
							"fr": "Nom",
							"it": "Nome",
							"sv": "Namn",
							"zh-CN": "名称",
							"zh-HK": "名稱"
						},
						"preparedForPhone": {
							"da-DK": "Telefonnummer ",
							"en": "Phone Number",
							"fr": "Téléphone",
							"it": "Numero di telefono",
							"sv": "Telefonnummer",
							"zh-CN": "电话号码",
							"zh-HK": "電話號碼"
						},
						"proposedPortfolio": {
							"da-DK": "Foreslået Portefølje",
							"en": "Proposed Portfolio",
							"fr": "Portefeuille Proposé",
							"it": "Portafoglio proposto",
							"sv": "Föreslagen portfölj",
							"zh-CN": "建议投资组合",
							"zh-HK": "建議投資組合"
						},
						"questionnaire": {
							"da-DK": "Spørgeskema",
							"en": "Questionnaire",
							"fr": "Questionnaire",
							"it": "Questionario",
							"sv": "Frågeformulär",
							"zh-CN": "调查问卷",
							"zh-HK": "調查問卷"
						},
						"reportCoverPage": {
							"da-DK": "Rapportens Overskrift",
							"en": "Report Title",
							"fr": "Titre du rapport",
							"it": "Titolo Report",
							"sv": "Titel på rapporten",
							"zh-CN": "报告标题",
							"zh-HK": "報告標題"
						},
						"reportWarning": {
							"en": "Including this might take at least 1 minute for report processing.",
							"fr": "Inclure ceci peut augmenter le temps de génération de plus d'une minute.",
							"it": "In totale, l'elaborazione del report potrebbe durare almeno 1 minuto",
							"sv": "Att skapa rapporten tar minst 1 minut om dessa inkluderas."
						},
						"suitabilitySummary": {
							"da-DK": "Oversigt Over Egnethed",
							"en": "Suitability Summary",
							"fr": "Résumé de soutenabilité",
							"it": "Sintesi dell'idoneità",
							"sv": "Översikt över lämplighet"
						}
					},
					"settings": {
						"coverPagePreparedByFieldDefinition": [{
							"inputType": "text",
							"labelKey": "preparedByAdvisorTitle1"
						}, {
							"inputType": "text",
							"labelKey": "preparedByAdvisorName1"
						}, {
							"inputType": "email",
							"labelKey": "preparedByAdvisorEmail1"
						}, {
							"inputType": "text",
							"labelKey": "preparedByAdvisorTitle2"
						}, {
							"inputType": "text",
							"labelKey": "preparedByAdvisorName2"
						}, {
							"inputType": "email",
							"labelKey": "preparedByAdvisorEmail2"
						}, {
							"inputType": "text",
							"labelKey": "preparedByFirmName"
						}, {
							"inputType": "text",
							"labelKey": "preparedByAddressLine1"
						}, {
							"inputType": "text",
							"labelKey": "preparedByAddressLine2"
						}, {
							"inputType": "url",
							"labelKey": "preparedByWebsite"
						}, {
							"inputType": "text",
							"labelKey": "preparedByPhone"
						}],
						"coverPagePreparedForFieldDefinition": [{
							"inputType": "text",
							"labelKey": "preparedForName"
						}, {
							"inputType": "text",
							"labelKey": "preparedForAddressLine1"
						}, {
							"inputType": "text",
							"labelKey": "preparedForAddressLine2"
						}, {
							"inputType": "text",
							"labelKey": "preparedForPhone"
						}, {
							"inputType": "email",
							"labelKey": "preparedForEmail"
						}],
						"notesFieldDefinition": [{
							"inputType": "text",
							"labelKey": "advisorNotes"
						}]
					},
					"type": "ecReportBuilder"
				},
				"standardUK": {
					"components": {
						"containerReportBuilder": {
							"settings": {
								"breakpoints": {
									"large": "medium",
									"medium": "small",
									"small": {
										"groups": {
											"all": {
												"cols": 12,
												"defaultSection": {
													"cols": 2
												},
												"order": 0,
												"sections": [{
													"cols": 8,
													"sectionId": "reportName"
												}, "reportGenerateButton", "reportCancelButton"]
											},
											"coverPage": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 2,
												"sections": ["reportCoverPageTitle", "reportCoverPagePreparedFor", "reportCoverPagePreparedBy"],
												"show": "{{_ model(_).selectedContents.coverPage _}}"
											},
											"reportPages": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 1,
												"sections": ["reportContents"]
											}
										}
									},
									"xlarge": "large"
								}
							},
							"type": "ecContainer"
						},
						"reportContents": {
							"settings": {
								"_model": {
									"listItems": [{
										"key": "coverPage",
										"value": "coverPage"
									}, {
										"key": "xrayReportComponent",
										"value": "portfolioXRay"
									}]
								},
								"controlType": "checkbox"
							},
							"type": "ecChosen"
						}
					},
					"settings": {
						"__env": {
							"dev": {
								"pdfServer": "qa"
							},
							"production": {
								"pdfServer": "live"
							},
							"qa": {
								"pdfServer": "qa"
							},
							"stage": {
								"pdfServer": "qa"
							},
							"uat": {
								"pdfServer": "qa"
							}
						},
						"coverPagePreparedByFieldDefinition": [{
							"inputType": "text",
							"labelKey": "title"
						}, {
							"inputType": "text",
							"labelKey": "company"
						}, {
							"inputType": "text",
							"labelKey": "name"
						}, {
							"inputType": "text",
							"labelKey": "phone"
						}, {
							"inputType": "email",
							"labelKey": "email"
						}, {
							"inputType": "url",
							"labelKey": "website"
						}],
						"coverPagePreparedForFieldDefinition": [{
							"inputType": "text",
							"labelKey": "clientName"
						}, {
							"inputType": "text",
							"labelKey": "clientPhone"
						}, {
							"inputType": "text",
							"labelKey": "clientAddress"
						}, {
							"inputType": "email",
							"labelKey": "clientEmail"
						}],
						"reportDataSource": {
							"requestMethod": "post",
							"type": "UKAPI",
							"url": "//{{baseUrl}}/Report/Pdf"
						},
						"reportSettings": {
							"xrayReport": {
								"type": "xrayReport"
							}
						}
					},
					"type": "ecReportBuilder"
				},
				"standardUKPC": {
					"components": {
						"containerReportBuilder": {
							"settings": {
								"breakpoints": {
									"large": "medium",
									"medium": "small",
									"small": {
										"groups": {
											"all": {
												"cols": 12,
												"defaultSection": {
													"cols": 2
												},
												"order": 0,
												"sections": [{
													"cols": 8,
													"sectionId": "reportName"
												}, "reportGenerateButton", "reportCancelButton"]
											},
											"coverPage": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 2,
												"sections": ["reportCoverPageTitle", "reportCoverPagePreparedFor", "reportCoverPagePreparedBy"],
												"show": "{{_ model(_).selectedContents.coverPage _}}"
											},
											"reportPages": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 1,
												"sections": ["reportContents"]
											}
										}
									},
									"xlarge": "large"
								}
							},
							"type": "ecContainer"
						},
						"reportContents": {
							"settings": {
								"_model": {
									"listItems": [{
										"key": "coverPage",
										"value": "coverPage"
									}, {
										"key": "portfolioComparisonReport",
										"value": "portfolioComparison"
									}]
								},
								"controlType": "checkbox"
							},
							"type": "ecChosen"
						}
					},
					"settings": {
						"__env": {
							"dev": {
								"pdfServer": "qa"
							},
							"production": {
								"pdfServer": "live"
							},
							"qa": {
								"pdfServer": "qa"
							},
							"stage": {
								"pdfServer": "qa"
							},
							"uat": {
								"pdfServer": "qa"
							}
						},
						"coverPagePreparedByFieldDefinition": [{
							"inputType": "text",
							"labelKey": "title"
						}, {
							"inputType": "text",
							"labelKey": "company"
						}, {
							"inputType": "text",
							"labelKey": "name"
						}, {
							"inputType": "text",
							"labelKey": "phone"
						}, {
							"inputType": "email",
							"labelKey": "email"
						}, {
							"inputType": "url",
							"labelKey": "website"
						}],
						"coverPagePreparedForFieldDefinition": [{
							"inputType": "text",
							"labelKey": "clientName"
						}, {
							"inputType": "text",
							"labelKey": "clientPhone"
						}, {
							"inputType": "text",
							"labelKey": "clientAddress"
						}, {
							"inputType": "email",
							"labelKey": "clientEmail"
						}],
						"reportDataSource": {
							"requestMethod": "post",
							"type": "UKAPI",
							"url": "//{{baseUrl}}/Report/Pdf"
						},
						"reportSettings": {
							"portfolioComparisonReport": {
								"type": "portfolioPlannerReport"
							}
						}
					},
					"type": "ecReportBuilder"
				},
				"standardUS": {
					"components": {
						"containerReportBuilder": {
							"settings": {
								"breakpoints": {
									"large": "medium",
									"medium": "small",
									"small": {
										"groups": {
											"all": {
												"cols": 12,
												"defaultSection": {
													"cols": 2
												},
												"order": 0,
												"sections": [{
													"cols": 8,
													"sectionId": "reportName"
												}, "reportGenerateButton", "reportCancelButton"]
											},
											"coverPage": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 2,
												"sections": ["reportCoverPageTitle", "reportCoverPagePreparedFor", "reportCoverPagePreparedBy"],
												"show": "{{_ model(_).selectedContents.coverPage _}}"
											},
											"reportPages": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 1,
												"sections": ["reportContents"]
											}
										}
									},
									"xlarge": "large"
								}
							},
							"type": "ecContainer"
						},
						"reportContents": {
							"settings": {
								"_model": {
									"listItems": [{
										"key": "coverPage",
										"value": "coverPage"
									}, {
										"key": "portfolioXRay",
										"rearrangeEnabled": true,
										"value": "portfolioXRay"
									}, {
										"key": "portfolioSnapshot",
										"rearrangeEnabled": true,
										"value": "portfolioSnapshot"
									}, {
										"key": "historicalPerformance",
										"rearrangeEnabled": true,
										"value": "historicalPerformance"
									}, {
										"key": "stockIntersection",
										"rearrangeEnabled": true,
										"value": "stockIntersection"
									}, {
										"key": "correlationMatrix",
										"rearrangeEnabled": true,
										"value": "correlationMatrix"
									}, {
										"key": "rollingReturns",
										"rearrangeEnabled": true,
										"value": "rollingReturns"
									}, {
										"key": "priceAndDistribution",
										"rearrangeEnabled": true,
										"value": "priceAndDistribution"
									}, {
										"key": "investmentDetail",
										"rearrangeEnabled": true,
										"value": "investmentDetail"
									}, {
										"key": "individualInvestmentFee",
										"rearrangeEnabled": true,
										"value": "individualInvestmentFee"
									}, {
										"key": "portfolioFeeReport",
										"rearrangeEnabled": true,
										"value": "portfolioFeeReport"
									}, {
										"key": "disclosure",
										"value": "disclosure"
									}]
								},
								"controlType": "checkbox"
							},
							"type": "ecChosen"
						}
					},
					"settings": {
						"coverPagePreparedByFieldDefinition": [{
							"inputType": "text",
							"labelKey": "title"
						}, {
							"inputType": "text",
							"labelKey": "company"
						}, {
							"inputType": "text",
							"labelKey": "name"
						}, {
							"inputType": "text",
							"labelKey": "phone"
						}, {
							"inputType": "email",
							"labelKey": "email"
						}, {
							"inputType": "url",
							"labelKey": "website"
						}],
						"coverPagePreparedForFieldDefinition": [{
							"inputType": "text",
							"labelKey": "clientName"
						}, {
							"inputType": "text",
							"labelKey": "clientPhone"
						}, {
							"inputType": "text",
							"labelKey": "clientAddress"
						}, {
							"inputType": "email",
							"labelKey": "clientEmail"
						}],
						"reportDataSource": {
							"requestMethod": "post",
							"type": "USAPI",
							"url": "https://{{baseUrl}}/portfolioanalysis/v1/report?langcult={{langcult}}"
						},
						"reportSettings": {
							"RequestSettings": {
								"AnalysisDateTimePeriod": "MonthEnd",
								"AssetClassGroupConfigs": {
									"AssetClassGroupConfig": [{
										"Id": "ACG-USDETAILED-15"
									}, {
										"Id": "ACG-USBROAD"
									}]
								},
								"HypoCalculationSettings": {
									"ApplyFeeForRebalance": false,
									"ApplySalesCharge": true,
									"AssetBasedAnnualFee": 0,
									"AssetFeeFrequency": "Annually",
									"AssetFeeType": "Percentage",
									"CapitalGainTaxRate": 0,
									"CustomFeeType": "Amount",
									"DividendTaxRate": 0,
									"EntryExitFeeType": "CustomEntry",
									"FederalIncomeTaxRate": 0,
									"FilingStatus": "NoTaxes",
									"FrontLoadType": "Standard",
									"HypoType": "Portfolio",
									"IllustrationTrailingTimePeriod": "EarliestCommon",
									"InvestmentDetailReturnsFrequency": "Monthly",
									"LiquidateOnEndDate": false,
									"PayFees": "SalesOfSharesEnding",
									"PayFeesUseCashFirst": true,
									"PayTaxes": "OutOfPocket",
									"RebalanceFrequency": "None",
									"RebalanceThreshold": 0,
									"ReinvestCapitalGains": true,
									"ReinvestDividends": true,
									"SalesFeeAmount": 0,
									"StateIncomeTaxRate": 0,
									"SubsequentInvestmentAmount": 0,
									"SubsequentInvestmentType": "Invest",
									"SubsequentInvestmentWithdrawalFrequency": "Monthly",
									"SynchronizePortfolioStartDate": true,
									"TaxableIncome": 50000
								},
								"HypoReportType": "Portfolio",
								"IncludePortfolioInCorrelationMatrix": true,
								"OutputCurrency": "USD",
								"OutputReturnsFrequency": "Annually",
								"ReportSettings": {
									"IncludeDisclosure": true,
									"InvestmentPolicyAgreement": {
										"Name1": "Name1",
										"Name2": "Name2"
									},
									"ReportOrientation": "Portrait"
								},
								"RollingReturnFrequency": "Month3"
							}
						}
					},
					"type": "ecReportBuilder"
				},
				"standardUSHypo": {
					"components": {
						"containerReportBuilder": {
							"settings": {
								"breakpoints": {
									"large": "medium",
									"medium": "small",
									"small": {
										"groups": {
											"all": {
												"cols": 12,
												"defaultSection": {
													"cols": 12
												},
												"order": 0,
												"sections": ["reportGenerateButton"]
											}
										}
									},
									"xlarge": "large"
								}
							},
							"type": "ecContainer"
						},
						"reportGenerateButton": {
							"labels": {
								"caption": {
									"en": "PDF Report",
									"it": "Report PDF",
									"sv": "PDF-rapport"
								}
							},
							"settings": {
								"buttonCSS": "ec-button__btn--generate"
							},
							"type": "ecButton"
						}
					},
					"settings": {
						"reportDataSource": {
							"requestMethod": "post",
							"type": "USAPI",
							"url": "https://{{baseUrl}}/portfolioanalysis/v1?langcult={{langcult}}"
						},
						"reportSettings": {
							"RequestSettings": {
								"AnalysisDateTimePeriod": "MonthEnd",
								"AssetClassGroupConfigs": {
									"AssetClassGroupConfig": [{
										"Id": "ACG-USDETAILED-15"
									}, {
										"Id": "ACG-USBROAD"
									}]
								},
								"HypoReportType": "Portfolio",
								"IncludePortfolioInCorrelationMatrix": true,
								"OutputCurrency": "USD",
								"OutputReturnsFrequency": "Annually",
								"ReportSettings": {
									"IncludeDisclosure": true,
									"InvestmentPolicyAgreement": {
										"Name1": "Name1",
										"Name2": "Name2"
									},
									"ReportOrientation": "Portrait"
								},
								"RollingReturnFrequency": "Month3"
							}
						}
					},
					"type": "ecReportBuilder"
				}
			},
			"components": {
				"containerReportBuilder": {
					"settings": {
						"breakpoints": {
							"large": "medium",
							"medium": "small",
							"small": {
								"groups": {
									"all": {
										"cols": 12,
										"defaultSection": {
											"cols": 6
										},
										"sections": ["reportName", "reportContents"]
									}
								}
							},
							"xlarge": "large"
						},
						"sections": {
							"reportContents": {
								"breakpoints": {
									"large": "small",
									"medium": "small",
									"small": {
										"cols": 6
									},
									"xlarge": "small"
								}
							},
							"reportCoverPagePreparedBy": {
								"breakpoints": {
									"large": "small",
									"medium": "small",
									"small": {
										"cols": 6
									},
									"xlarge": "small"
								}
							},
							"reportCoverPagePreparedFor": {
								"breakpoints": {
									"large": "small",
									"medium": "small",
									"small": {
										"cols": 6
									},
									"xlarge": "small"
								}
							},
							"reportCoverPageTitle": {
								"breakpoints": {
									"large": "small",
									"medium": "small",
									"small": {
										"cols": 12
									},
									"xlarge": "small"
								}
							},
							"reportGenerateButton": {
								"breakpoints": {
									"large": "small",
									"medium": "small",
									"small": {
										"cols": 3
									},
									"xlarge": "small"
								}
							},
							"reportName": {
								"breakpoints": {
									"large": "small",
									"medium": "small",
									"small": {
										"cols": 6
									},
									"xlarge": "small"
								}
							}
						}
					},
					"type": "ecContainer"
				},
				"reportAllContents": {
					"labels": {
						"checkboxText": {
							"da-DK": "Vælg alle",
							"en": "Select all",
							"fr": "Tout sélectionner",
							"it": "Seleziona tutto",
							"sv": "Välj alla",
							"zh-CN": "全选",
							"zh-HK": "全選"
						}
					},
					"settings": {
						"inputType": "checkbox"
					},
					"type": "ecInput"
				},
				"reportCancelButton": {
					"labels": {
						"caption": {
							"da-DK": "Fortryd",
							"en": "Cancel",
							"fr": "Annuler",
							"it": "Cancella",
							"sv": "Ångra",
							"zh-CN": "取消",
							"zh-HK": "取消"
						}
					},
					"type": "ecButton"
				},
				"reportContents": {
					"labels": {
						"advisorNotes": {
							"da-DK": "Rådgivers Noter",
							"en": "Advisor Notes",
							"fr": "Notes du conseiller",
							"it": "Note del consulente",
							"sv": "Rågivarens anteckningar",
							"zh-CN": "顾问笔记",
							"zh-HK": "顧問筆記"
						},
						"clientDetails": {
							"da-DK": "Kundens Detaljer",
							"en": "Client Details",
							"fr": "Détails du client",
							"fr-CA": "Renseignements détaillés sur le client",
							"it": "Dettagli del cliente",
							"sv": "Kundinformation",
							"zh-CN": "客户详情",
							"zh-HK": "客戶詳情"
						},
						"clientGoal": {
							"da-DK": "Kundens Mål",
							"en": "Client Goal",
							"fr": "Objectif du client",
							"it": "Obiettivo del cliente",
							"sv": "Kundens mål",
							"zh-CN": "客户目标",
							"zh-HK": "客戶目標"
						},
						"currentPortfolioVSSelectedInvestment": {
							"da-DK": "Nuværende Portefølje v Valgte Investeringsløsning",
							"en": "Current Portfolio v Selected Investment Solution",
							"fr": "Portefeuille actuel v Solution d'investissement sélectionnée",
							"fr-CA": "Portefeuille actuel / Solution de placement sélectionnée",
							"it": "Portafoglio corrente vs. Soluzione investimento selezionata",
							"sv": "Nuvarande portfölj jämfört med Vald investeringslösning",
							"zh-CN": "目前投资组合v选择的投资解决方案",
							"zh-HK": "目前投資組合 v 選擇的投資解決方案"
						},
						"currentVSRiskProfileVSProposed": {
							"da-DK": "Nuværende v Risikoprofil v Anbefalede",
							"en": "Current v Risk Profile v Proposed",
							"fr": "Actuel v Profil de risque v Proposé",
							"fr-CA": "Actuel / Profil de risque / proposé",
							"it": "Profilo di rischio corrente vs Proposto",
							"sv": "Nuvarande jfr Riskprofil jfr Föreslag",
							"zh-CN": "目前v风险剖析v建议",
							"zh-HK": "目前 v 風險剖析 v 建議"
						},
						"keyInvestorInformationDocuments": {
							"da-DK": "CI",
							"en": "KIID",
							"fr": "DICI",
							"it": "KIID",
							"sv": "KIID",
							"zh-CN": "KIID",
							"zh-HK": "KIID"
						},
						"riskProfile": {
							"da-DK": "Risikoprofil",
							"en": "Risk Profile",
							"fr": "Profil de Risque",
							"fr-CA": "Profil de risque",
							"it": "Profilo di rischio",
							"sv": "Riskprofil",
							"zh-CN": "风险剖析",
							"zh-HK": "風險剖析"
						},
						"selectedInvestmentSolution": {
							"da-DK": "Vælg Investeringsløsning",
							"en": "Selected Investment Solution",
							"fr": "Solution d'investissement sélectionnée",
							"fr-CA": "Solution de placement sélectionnée",
							"it": "Soluzione investimento selezionata",
							"sv": "Välj investeringslösning",
							"zh-CN": "选择的投资解决方案",
							"zh-HK": "選擇的投資解決方案"
						},
						"signOff": {
							"en": "Sign Off",
							"it": "Esci",
							"sv": "Godkänn",
							"zh-CN": "签字",
							"zh-HK": "簽字"
						}
					},
					"settings": {
						"_model": {
							"listItems": [{
								"key": "clientDetails",
								"value": "clientDetails"
							}, {
								"key": "riskProfile",
								"value": "riskProfile"
							}, {
								"key": "clientGoal",
								"value": "clientGoal"
							}, {
								"key": "currentVSRiskProfileVSProposed",
								"value": "currentVSRiskProfileVSProposed"
							}, {
								"key": "selectedInvestmentSolution",
								"value": "selectedInvestmentSolution"
							}, {
								"key": "currentPortfolioVSSelectedInvestment",
								"value": "currentPortfolioVSSelectedInvestment"
							}, {
								"key": "advisorNotes",
								"value": "advisorNotes"
							}, {
								"key": "keyInvestorInformationDocuments",
								"value": "keyInvestorInformationDocuments"
							}, {
								"key": "signOff",
								"value": "signOff"
							}]
						},
						"controlType": "checkbox"
					},
					"type": "ecChosen"
				},
				"reportCoverPageTitle": {
					"settings": {
						"inputType": "text"
					},
					"type": "ecInput"
				},
				"reportGenerateButton": {
					"labels": {
						"caption": {
							"da-DK": "Generér",
							"en": "Generate",
							"fr": "Générer",
							"it": "Genera",
							"sv": "Generera",
							"zh-CN": "产生",
							"zh-HK": "產生"
						}
					},
					"settings": {
						"disabled": true
					},
					"type": "ecButton"
				},
				"reportName": {
					"type": "ecInput"
				},
				"reportNotesFieldText": {
					"settings": {
						"cols": 100,
						"inputType": "textarea",
						"rows": 10
					},
					"type": "ecInput"
				},
				"reportPortfolioName": {
					"settings": {
						"inputType": "text"
					},
					"type": "ecInput"
				},
				"reportPreparedFieldEmail": {
					"settings": {
						"inputType": "email"
					},
					"type": "ecInput"
				},
				"reportPreparedFieldNumber": {
					"settings": {
						"inputType": "number"
					},
					"type": "ecInput"
				},
				"reportPreparedFieldText": {
					"settings": {
						"inputType": "text"
					},
					"type": "ecInput"
				},
				"reportPreparedFieldUrl": {
					"settings": {
						"inputType": "url"
					},
					"type": "ecInput"
				}
			},
			"labels": {
				"address": {
					"da-DK": "Adresse",
					"en": "Address",
					"en-GB": null,
					"fr": "Adresse",
					"it": "Indirizzo",
					"sv": "Adress",
					"sv-SE": null,
					"zh-CN": "地址",
					"zh-HK": "地址"
				},
				"city": {
					"da-DK": "By",
					"en": "City",
					"en-GB": null,
					"fr": "Ville",
					"it": "Città",
					"sv": "Stad",
					"sv-SE": null,
					"zh-CN": "城市",
					"zh-HK": "城市"
				},
				"clientAddress": {
					"da-DK": "Kundens Adresselinje",
					"en": "Client Address Line",
					"en-GB": null,
					"fr": "Adresse du client",
					"fr-CA": "Ligne adresse du client",
					"it": "Indirizzo cliente riga",
					"sv": "Kundens adress",
					"sv-SE": null,
					"zh-CN": "客户地址",
					"zh-HK": "客戶地址"
				},
				"clientEmail": {
					"da-DK": "Kundens E-mail Adresse",
					"en": "Client Email Address",
					"en-GB": null,
					"fr": "Email du client",
					"fr-CA": "Adresse courriel du client",
					"it": "Indirizzo e-mail cliente",
					"sv": "Kundens epost",
					"sv-SE": null,
					"zh-CN": "客户电邮地址",
					"zh-HK": "客戶電郵地址"
				},
				"clientName": {
					"da-DK": "Kundens Navn",
					"en": "Client Name",
					"en-GB": null,
					"fr": "Nom du client",
					"it": "Nome cliente",
					"sv": "Kundens namn",
					"sv-SE": null,
					"zh-CN": "客户名称",
					"zh-HK": "客戶名稱"
				},
				"clientPhone": {
					"da-DK": "Kundens Telefonnummer",
					"en": "Client Phone Number",
					"en-GB": null,
					"fr": "Téléphone du client",
					"fr-CA": "Numéro de téléphone du client",
					"it": "Numero di telefono cliente",
					"sv": "Kundens telefonnummer",
					"sv-SE": null,
					"zh-CN": "客户电话号码",
					"zh-HK": "客戶電話號碼"
				},
				"company": {
					"da-DK": "Selskabs Navn",
					"en": "Company Name",
					"en-GB": null,
					"fr": "Nom de la société",
					"fr-CA": "Nom de la compagnie",
					"it": "Nome società",
					"sv": "Företagsnamn",
					"sv-SE": null,
					"zh-CN": "公司名称",
					"zh-HK": "公司名稱"
				},
				"correlationMatrix": {
					"da-DK": "Korrelationsmatrice",
					"en": "Correlation Matrix",
					"en-GB": null,
					"fr": "Matrice de corrélation",
					"it": "Matrice correlazione",
					"sv": "Korrelationsmatris",
					"sv-SE": null,
					"zh-CN": "相关性矩阵",
					"zh-HK": "相關性矩陣"
				},
				"costAnalysis": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				},
				"coverPage": {
					"da-DK": "Forside",
					"en": "Cover Page",
					"en-GB": null,
					"fr": "Page de garde",
					"fr-CA": "Page de couverture",
					"it": "Copertina",
					"sv": "Framsida",
					"sv-SE": null,
					"zh-CN": "封面",
					"zh-HK": "封面"
				},
				"disclosure": {
					"da-DK": "Offentliggørelse",
					"en": "Disclosure",
					"en-GB": null,
					"it": "Informativa",
					"sv": "Disclosure",
					"sv-SE": null
				},
				"email": {
					"da-DK": "E-mail Adresse",
					"en": "Email Address",
					"en-GB": null,
					"fr": "E-Mail",
					"fr-CA": "Adresse courriel",
					"it": "Indirizzo e-mail",
					"sv": "Epostadress",
					"sv-SE": null,
					"zh-CN": "电邮地址",
					"zh-HK": "電郵地址"
				},
				"historicalPerformance": {
					"da-DK": "Historisk Afkast",
					"en": "Historical Performance",
					"en-GB": null,
					"fr": "Performance historique",
					"it": "Performance storica",
					"sv": "Historisk utveckling",
					"sv-SE": null,
					"zh-CN": "历史表现",
					"zh-HK": "歷史表現"
				},
				"individualInvestmentFee": {
					"da-DK": "Individuel Investeringsomkostning",
					"en": "Individual Investment Fee",
					"en-GB": null,
					"it": "Commissione d'investimento individuale",
					"sv": "Individuell investeringsavgift",
					"sv-SE": null
				},
				"investmentDetail": {
					"da-DK": "Investeringsdetaljer",
					"en": "Investment Detail",
					"en-GB": null,
					"fr": "Détails de l'investissement",
					"fr-CA": "Renseignements sur les placements",
					"it": "Dettaglio dell'investimento",
					"sv": "Investeringsdetaljer",
					"sv-SE": null,
					"zh-CN": "投资详情",
					"zh-HK": "投資詳情"
				},
				"investmentPolicyAgreement": {
					"da-DK": "Aftale om Investeringspolitik",
					"en": "Investment Policy Agreement",
					"en-GB": null,
					"fr": "Accord sur la politique d'investissement",
					"fr-CA": "Accord sur la politique de placement",
					"it": "Accordo relativo alla politica d'investimento",
					"sv": "Investeringsavtal",
					"sv-SE": null,
					"zh-CN": "投资政策协议",
					"zh-HK": "投資政策協議"
				},
				"name": {
					"da-DK": "Navn",
					"en": "Name",
					"en-GB": null,
					"fr": "Nom",
					"it": "Nome",
					"sv": "Namn",
					"sv-SE": null,
					"zh-CN": "名称",
					"zh-HK": "名稱"
				},
				"notes": {
					"da-DK": "Noter",
					"en": "Notes",
					"fr": "Remarques",
					"it": "Note",
					"sv": "Anteckningar",
					"zh-CN": "备注",
					"zh-HK": "備註"
				},
				"phone": {
					"da-DK": "Telefonnummer ",
					"en": "Phone Number",
					"en-GB": null,
					"fr": "Téléphone",
					"it": "Numero di telefono",
					"sv": "Telefonnummer",
					"sv-SE": null,
					"zh-CN": "电话号码",
					"zh-HK": "電話號碼"
				},
				"portfolioComparison": {
					"en": "Portfolio Comparison",
					"en-GB": null,
					"it": "Confronto portafoglio",
					"sv": "Portföljjämförelse",
					"sv-SE": null
				},
				"portfolioComparisonFee": {
					"en": "Portfolio Comparison Fee",
					"en-GB": null,
					"it": "Confronto commissioni",
					"sv": "Portföljjämförelseavgift",
					"sv-SE": null
				},
				"portfolioFeeReport": {
					"da-DK": "Oversigt Over Porteføljeomkostninger",
					"en": "Portfolio Fee Report",
					"en-GB": null,
					"it": "Report commissioni di portafoglio",
					"sv": "Portföljavgiftsrapport",
					"sv-SE": null
				},
				"portfolioName": {
					"en": "Portfolio Name",
					"it": "Nome del portafoglio",
					"sv": "Portföljnamn"
				},
				"portfolioSnapshot": {
					"da-DK": "Portefølje Snapshot",
					"en": "Portfolio Snapshot",
					"en-GB": null,
					"fr": "Aperçu du portefeuille",
					"it": "Snapshot portafoglio",
					"sv": "Portfolio Snapshot",
					"sv-SE": null,
					"zh-CN": "投资组合摘要",
					"zh-HK": "投資組合摘要"
				},
				"portfolioXRay": {
					"da-DK": "Gennemlysning af Portefølje",
					"en": "Portfolio XRay",
					"en-GB": null,
					"fr": "Xray du portefeuille",
					"fr-CA": "Anatomie du portefeuille",
					"it": "Portafoglio Raggi-X",
					"sv": "Portföljanalys (X-Ray)",
					"sv-SE": null,
					"zh-CN": "投资组合透视",
					"zh-HK": "投資組合透視"
				},
				"priceAndDistribution": {
					"da-DK": "Pris og Distribution",
					"en": "Price And Distribution",
					"en-GB": null,
					"fr": "Prix et distribution",
					"it": "Prezzo e distribuzione",
					"sv": "Kostnader och distribution",
					"sv-SE": null,
					"zh-CN": "价格和派息",
					"zh-HK": "價格和派息"
				},
				"reportContents": {
					"da-DK": "Indhold",
					"en": "Contents",
					"en-GB": null,
					"fr": "Contenu",
					"it": "Indice",
					"sv": "Innehåll",
					"sv-SE": null,
					"zh-CN": "内容",
					"zh-HK": "內容"
				},
				"reportCoverPage": {
					"da-DK": "Forside",
					"en": "Cover Page",
					"en-GB": null,
					"fr": "Page de garde",
					"fr-CA": "Page de couverture",
					"it": "Copertina",
					"sv": "Framsida",
					"sv-SE": null,
					"zh-CN": "封面",
					"zh-HK": "封面"
				},
				"reportCoverPageTitle": {
					"da-DK": "Rapportens Overskrift",
					"en": "Report Title",
					"en-GB": null,
					"fr": "Titre du rapport",
					"it": "Titolo Report",
					"sv": "Titel på rapporten",
					"sv-SE": null,
					"zh-CN": "报告标题",
					"zh-HK": "報告標題"
				},
				"reportName": {
					"da-DK": "Foreslået navn",
					"en": "Proposal name",
					"en-GB": null,
					"fr": "Nom de la proposition",
					"it": "Nome della proposta",
					"sv": "Namn på förslag",
					"sv-SE": null,
					"zh-CN": "建议书名称",
					"zh-HK": "建議書名稱"
				},
				"reportPortfolioName": {
					"en": null,
					"en-GB": null,
					"sv-SE": null
				},
				"reportPreparedBy": {
					"da-DK": "Udarbejdet Af",
					"en": "Prepared By",
					"en-GB": null,
					"fr": "Préparé par",
					"it": "Preparato da",
					"sv": "Framtagen av",
					"sv-SE": null,
					"zh-CN": "由...编制",
					"zh-HK": "由...編制"
				},
				"reportPreparedFor": {
					"da-DK": "Udarbejdet For",
					"en": "Prepared For",
					"en-GB": null,
					"fr": "Préparé pour",
					"it": "Preparato per",
					"sv": "Framtagen för",
					"sv-SE": null,
					"zh-CN": "为...编制",
					"zh-HK": "為...編制"
				},
				"rollingReturns": {
					"da-DK": "Løbende Afkast",
					"en": "Rolling Returns",
					"en-GB": null,
					"fr": "Performances ",
					"fr-CA": "Rendements moyens",
					"it": "Rendimenti rolling",
					"sv": "Rullande avkastning",
					"sv-SE": null,
					"zh-CN": "滚动回报",
					"zh-HK": "滾動回報"
				},
				"stockIntersection": {
					"da-DK": "Aktie Skæringspunkt",
					"en": "Stock Intersection",
					"en-GB": null,
					"fr-CA": "Chevauchement des actions",
					"it": "Intersezione azionaria",
					"sv": "Stock Intersection",
					"sv-SE": null,
					"zh-CN": "股票交接点",
					"zh-HK": "股票交接點"
				},
				"title": {
					"da-DK": "Titel",
					"en": "Title",
					"en-GB": null,
					"fr": "Titre",
					"it": "Titolo",
					"sv": "Titel",
					"sv-SE": null,
					"zh-CN": "标题",
					"zh-HK": "標題"
				},
				"website": {
					"da-DK": "Hjemmeside",
					"en": "Web Address",
					"en-GB": null,
					"fr": "Site Internet",
					"fr-CA": "Addresse site Internet",
					"it": "Indirizzo web",
					"sv": "Webbsida",
					"sv-SE": null,
					"zh-CN": "网址",
					"zh-HK": "網址"
				}
			},
			"settings": {
				"_model": {
					"coverPageUserInput": {
						"calculated": {
							"properties": {
								"show": {
									"data": "{{_ model().selectedContents _}}",
									"transformPipeline": [{
										"name": "mapSingle",
										"options": {
											"criteria": {
												"args": [{
													"args": {
														"property": "coverPage",
														"value": true
													},
													"fn": "eq"
												}, {
													"args": {
														"property": "signOff",
														"value": true
													},
													"fn": "eq"
												}],
												"fn": "or"
											}
										}
									}]
								}
							}
						}
					},
					"reportInfo": {
						"api": {
							"method": "get",
							"parameters": {
								"deep": true,
								"isTransformSync": false,
								"throttleTime": 200,
								"transformPipeline": []
							},
							"url": null,
							"usePreviousDataOnError": true,
							"validationExpression": "",
							"validationExpressions": []
						},
						"dataSourceType": "",
						"defaults": null,
						"merge": false,
						"propagateChanges": {
							"trigger": "auto"
						},
						"selector": null,
						"transformPipeline": []
					},
					"selectedContents": null
				},
				"_parameters": {
					"isLoading": {},
					"urlKey": {}
				},
				"_templates": {
					"main": "<ec-section mstar-loader=\"parameters.isLoading\">\r\n    <ec-container mstar-component-id=\"containerReportBuilder\" class=\"{{::namespaceClass()}}\">\r\n        <ec-section data-ng-repeat=\"(key,value) in templates.custom track by $index\" section-id=\"{{key}}\" title=\"{{labels.get(key)}}\">\r\n            <div mstar-include=\"value\"></div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportName\" title=\"{{::labels.get('reportName')}}\">\r\n            <label for=\"{{::namespaceId('reportName')}}-textbox\" class=\"{{::namespaceClass('__report-name-label')}}\">{{::labels.get('reportName')}}</label>\r\n            <ec-input mstar-component-id=\"reportName\" data-ng-model=\"model.reportInfo.reportName\" class=\"{{::namespaceClass('__report-name-input')}}\"></ec-input>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportContents\" title=\"{{::labels.get('reportContents')}}\">\r\n            <div class=\"{{::namespaceClass('__report-contents-all')}}\">\r\n                <ec-input mstar-component-id=\"reportAllContents\" data-ng-model=\"allCheckboxesSelected\" data-ng-model-options=\"{getterSetter: true}\" data-ng-click=\"handleSelectAllClick($event)\" data-ng-class=\"partialSelect ? '{{namespaceClass('__input--mixed')}}' : ''\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__report-contents')}}\">\r\n                <ec-chosen mstar-component-id=\"reportContents\" data-ng-model=\"model.reportInfo.reportContents\"></ec-chosen>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportCoverPageTitle\" title=\"{{::labels.get('reportCoverPage')}}\">\r\n            <div class=\"{{::namespaceClass('__cover-page-title-wrapper')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-title')}}\">{{::labels.get('reportCoverPageTitle')}}</label>\r\n                <ec-input mstar-component-id=\"reportCoverPageTitle \" data-ng-model=\"model.reportInfo.reportCoverPage.title \" class=\"{{::namespaceClass( '__cover-page-title-input')}}\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__cover-page-portfolio-name')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-label-client-name')}}\">{{::labels.get('portfolioName')}}</label>\r\n                <ec-input mstar-component-id=\"reportPortfolioName\" data-ng-model=\"model.reportInfo.reportPortfolios[0].reportName\" class=\"{{::namespaceClass('__cover-page-title-input')}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportCoverPagePreparedFor\" title=\"{{::labels.get('reportPreparedFor')}}\">\r\n            <div data-ng-repeat=\"obj in coverPagePreparedFor track by $index \" class=\"{{::namespaceClass('__cover-page-prepared-for')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-label')}} {{::namespaceClass('__cover-page-label-'+obj.className)}}\">{{::labels.get(obj.labelKey)}}</label>\r\n                <ec-input mstar-component-id=\"reportPreparedField{{obj.inputType}}[{{$index}}]\" data-ng-model=\"model.reportInfo.reportCoverPage.preparedFor[obj.labelKey]\" class=\"{{::namespaceClass('__cover-page-prepared-for-input')}} {{::namespaceClass('__cover-page-prepared-for-input-' + obj.className)}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportCoverPagePreparedBy\" title=\"{{::labels.get('reportPreparedBy')}}\">\r\n            <div data-ng-repeat=\"obj in coverPagePreparedBy track by $index\" class=\"{{::namespaceClass('__cover-page-prepared-by')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-label')}} {{::namespaceClass('__cover-page-label-'+obj.className)}}\">{{::labels.get(obj.labelKey)}}</label>\r\n                <ec-input mstar-component-id=\"reportPreparedField{{obj.inputType}}[{{$index}}]\" data-ng-model=\"model.reportInfo.reportCoverPage.preparedBy[obj.labelKey]\" class=\"{{::namespaceClass('__cover-page-prepared-by-input')}} {{::namespaceClass('__cover-page-prepared-by-input-' + obj.className)}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportNotes\" title=\"{{::labels.get('advisorNotes')}}\">\r\n            <div data-ng-repeat=\"obj in notes track by $index\" class=\"{{::namespaceClass('__notes')}}\">\r\n                <label class=\"{{::namespaceClass('__notes-label')}} {{::namespaceClass('__notes-label-'+obj.className)}}\">{{::labels.get(obj.labelKey)}}</label>\r\n                <ec-input mstar-component-id=\"reportNotesField{{obj.inputType}}[{{$index}}]\" data-ng-model=\"model.reportInfo.reportNotesPage.notes[obj.labelKey]\" class=\"{{::namespaceClass('__notes-input')}} {{::namespaceClass('__notes-input-' + obj.className)}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section template-type=\"light\" section-id=\"reportGenerateButton\">\r\n            <ec-button mstar-component-id=\"reportGenerateButton\" class=\"{{parameters.isLoading ? namespaceClass('__report-generate-button--loading') : ''}}\"></ec-button>\r\n        </ec-section>\r\n        <ec-section template-type=\"light\" section-id=\"reportCancelButton\">\r\n            <ec-button mstar-component-id=\"reportCancelButton\"></ec-button>\r\n        </ec-section>\r\n    </ec-container>\r\n</ec-section>"
				},
				"coverPageDateFormat": null,
				"coverPagePreparedByFieldDefinition": null,
				"coverPagePreparedForFieldDefinition": null,
				"namespaceClass": "ec-report-builder",
				"notesFieldDefinition": null,
				"pdfServer": null,
				"reportDataSource": {
					"requestMethod": null,
					"type": null,
					"url": null
				},
				"reportSettings": null,
				"urlKey": null
			},
			"type": "ecReportBuilder"
		}
	};

	/***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

	"use strict";

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
		'use strict';

		morningstar.asterix.ng.register('ecReportBuilder', __webpack_require__(6).ecReportBuilder);

		__webpack_require__(3);
		__webpack_require__(5);
		__webpack_require__(4);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/***/
},
/* 8 */
/***/function (module, exports) {

	module.exports = {
		"xray": {
			"uk": {
				"coverPagePreparedForFieldDefinition": {
					"clientName": "preparedForName",
					"clientPhone": "preparedForPhone",
					"clientAddress": "preparedForAddressLine1",
					"clientEmail": "preparedForEmail"
				},
				"coverPagePreparedByFieldDefinition": {
					"name": "preparedByAdvisorName1",
					"phone": "preparedByPhone",
					"title": "preparedByAdvisorTitle1",
					"email": "preparedByAdvisorEmail1",
					"company": "preparedByFirmName",
					"website": "preparedByWebsite"
				}
			},
			"us": {
				"coverPagePreparedForFieldDefinition": {
					"clientName": "Name",
					"clientPhone": "Phone",
					"clientAddress": "Address",
					"clientEmail": "Email"
				},
				"coverPagePreparedByFieldDefinition": {
					"advisors": {
						"name": "Name",
						"title": "Title",
						"email": "Email"
					},
					"phone": "Phone",
					"company": "FirmName",
					"website": "Website"
				}
			}
		}
	};

	/***/
}]
/******/);
//# sourceMappingURL=ec-report-builder.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 0);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
}]
/******/);
//# sourceMappingURL=ec-style-base.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 0);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
}]
/******/);
//# sourceMappingURL=ec-style-grid.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 7);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 1 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar) {
        'use strict';

        angular.module('ecTable').directive('ecTableCellLight', ["$parse", "mstarTemplate", "$window", function ($parse, mstarTemplate, $window) {
            return {
                restrict: 'A',
                link: function link(scope, element, attr) {
                    var isHeader = element[0].tagName === 'TH';

                    scope.$evalAsync(function () {
                        var template = getTemplate(isHeader, scope.field.fieldSettings.headerTemplate, scope.field.fieldSettings.itemTemplate);

                        if (isHeader) {
                            element.addClass(scope.field.fieldSettings.headerClass);
                            if (!scope.field.fieldName) {
                                scope.field.sortingEnabled = false;
                            }

                            if (parseInt(scope.field.fieldSettings.headerRowspan, 10) > 0) {
                                element.attr('rowspan', scope.field.fieldSettings.headerRowspan);
                            }

                            if (parseInt(scope.field.fieldSettings.headerColspan, 10) > 0) {
                                element.attr('colspan', scope.field.fieldSettings.headerColspan);
                            }
                        } else {
                            element.addClass(scope.field.fieldSettings.itemClass);
                        }

                        if (template) {
                            scope.$$watchers = scope.$$asyncQueue = scope.$$postDigestQueue = [];
                            mstarTemplate.compile(scope, element, { template: template, keepRootElement: false });
                        }
                    });

                    function getTemplate(isHeader, headerTemplate, itemTemplate) {
                        var template;
                        if (isHeader) {
                            if (headerTemplate === 'checkbox') {
                                template = scope.field.fieldSettings.checkboxHeaderTemplate;
                                scope.field.sortingEnabled = false;
                                element.addClass(scope.namespaceClass('__cell--checkbox-header'));
                            } else if (itemTemplate === 'hyperlink') {
                                scope.field.sortingEnabled = false;
                                template = headerTemplate;
                            } else {
                                template = headerTemplate;
                            }
                        } else {
                            if (itemTemplate === 'checkbox') {
                                template = scope.field.fieldSettings.checkboxItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--checkbox'));
                            } else if (itemTemplate === 'radio') {
                                template = scope.field.fieldSettings.radioItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--radio'));
                            } else if (itemTemplate === 'hyperlink') {
                                template = scope.field.fieldSettings.hyperlinkItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--hyperlink'));
                            } else if (itemTemplate === 'button') {
                                template = scope.field.fieldSettings.buttonItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--button'));
                            } else {
                                template = itemTemplate;
                            }
                        }

                        return template;
                    }

                    // todo(slind): the below could be used for static data tables to remove watchers after first bind
                    // this does, however, require a track by keyFieldParsed in the table template
                    //scope.$watchCollection('[obj, field.header]', function(newValue) {
                    //    if ((isHeader || newValue[0]) && newValue[1]) {
                    //        scope.$applyAsync(function() {
                    //            scope.$destroy();
                    //        });
                    //    }
                    //});

                    scope.getHyperlinkText = function (obj, settings) {
                        var text = '';
                        if (settings.textField) {
                            text = morningstar.asterix.util.string.format(scope.labels.get(settings.text), obj[settings.textField]);
                        } else {
                            text = scope.labels.get(settings.text);
                        }

                        return text;
                    };

                    scope.getHyperlinkUrl = function (obj, settings) {
                        var url = '';
                        if (settings.urlFields) {
                            var args = [settings.url];
                            morningstar.asterix.util.each(settings.urlFields, function (field) {
                                args.push(encodeURIComponent(obj[field]));
                            });
                            url = morningstar.asterix.util.string.format.apply(this, args);
                        } else {
                            url = settings.url;
                        }

                        return url;
                    };

                    scope.openHyperlink = function (e) {
                        var a = element.find('a'),
                            url = a.attr('href'),
                            target = a.attr('target');
                        if (target) {
                            $window.open(url, target);
                        } else {
                            $window.open(url);
                        }
                        e.preventDefault();
                        e.stopPropagation();
                    };
                }
            };
        }]);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar) {
        'use strict';

        angular.module('ecTable').directive('ecTableCell', ["$compile", "$parse", "mstarTemplate", "$window", function ($compile, $parse, mstarTemplate, $window) {
            return {
                restrict: 'A',
                link: function link(scope, element, attr) {
                    var isHeader = element[0].tagName === 'TH';

                    scope.$evalAsync(function () {
                        element.addClass(scope.namespaceClass('__cell'));

                        // hacky, but currently necessary, if (due to some instances having stickyLeadEnabled === true without any defined breakpoints)
                        if (scope.settings.get('stickyLeadEnabled') && (scope.settings.get('stickyLeadBreakPoints') || scope.settings.contains('_parameters.stickyLeadBreakPoints.binding'))) {
                            element.addClass(scope.namespaceClass('__cell--out-of-range'));
                        }

                        var template = getTemplate(isHeader, scope.field.fieldSettings.headerTemplate, scope.field.fieldSettings.itemTemplate);

                        if (isHeader) {
                            element.addClass(scope.field.fieldSettings.headerClass);
                            if (!scope.field.fieldName) {
                                scope.field.sortingEnabled = false;
                            }

                            if (parseInt(scope.field.fieldSettings.headerRowspan, 10) > 0) {
                                element.attr('rowspan', scope.field.fieldSettings.headerRowspan);
                            }

                            if (parseInt(scope.field.fieldSettings.headerColspan, 10) > 0) {
                                element.attr('colspan', scope.field.fieldSettings.headerColspan);
                            }
                        } else {
                            element.addClass(scope.field.fieldSettings.itemClass);
                        }

                        if (template) {
                            scope.$$watchers = scope.$$asyncQueue = scope.$$postDigestQueue = [];
                            mstarTemplate.compile(scope, element, { template: template, keepRootElement: false });
                        }
                    });

                    function getTemplate(isHeader, headerTemplate, itemTemplate) {
                        var template;
                        if (isHeader) {
                            if (headerTemplate === 'checkbox') {
                                template = scope.field.fieldSettings.checkboxHeaderTemplate;
                                scope.field.sortingEnabled = false;
                                element.addClass(scope.namespaceClass('__cell--checkbox-header'));
                            } else if (itemTemplate === 'hyperlink') {
                                scope.field.sortingEnabled = false;
                                template = headerTemplate;
                            } else {
                                template = headerTemplate;
                            }
                        } else {
                            if (itemTemplate === 'checkbox') {
                                template = scope.field.fieldSettings.checkboxItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--checkbox'));
                            } else if (itemTemplate === 'radio') {
                                template = scope.field.fieldSettings.radioItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--radio'));
                            } else if (itemTemplate === 'hyperlink') {
                                template = scope.field.fieldSettings.hyperlinkItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--hyperlink'));
                            } else if (itemTemplate === 'button') {
                                template = scope.field.fieldSettings.buttonItemTemplate;
                                element.removeClass(scope.namespaceClass('__cell--data'));
                                element.addClass(scope.namespaceClass('__cell--button'));
                            } else {
                                template = itemTemplate;
                            }
                        }

                        return template;
                    }

                    // todo(slind): the below could be used for static data tables to remove watchers after first bind
                    // this does, however, require a track by keyFieldParsed in the table template
                    //scope.$watchCollection('[obj, field.header]', function(newValue) {
                    //    if ((isHeader || newValue[0]) && newValue[1]) {
                    //        scope.$applyAsync(function() {
                    //            scope.$destroy();
                    //        });
                    //    }
                    //});

                    scope.$watchCollection('[field.header, keyFieldParsed, $last, $index]', function () {
                        if (scope.$last && scope.obj) {
                            element.addClass(scope.namespaceClass('__cell--last'));
                        } else {
                            element.removeClass(scope.namespaceClass('__cell--last'));
                        }

                        if (scope.settings.get('orientation') !== 'horizontal' || !isHeader) {
                            element.attr('data-col-index', (scope.settings.get('orientation') === 'horizontal' ? 1 : 0) + scope.$index);
                        } else {
                            element.attr('data-col-index', 0);
                        }

                        if (scope.keyFieldParsed) {
                            element.attr('data-key', scope.keyFieldParsed(scope.obj));
                        }

                        element.attr('data-title', scope.field.header);
                    });

                    scope.registerStickyCallback(updateStickyClasses);

                    function updateStickyClasses() {
                        var stickyState = scope.parameters.stickyState;
                        if (stickyState && stickyState.stickyMode && stickyState.stickyColIndices) {
                            var colIndex = parseInt(element.attr('data-col-index'));
                            if (stickyState.stickyColIndices.indexOf(colIndex) >= 0) {
                                element.addClass(scope.namespaceClass('__cell--sticky'));
                                element.removeClass(scope.namespaceClass('__cell--unsticky'));
                                element.removeClass(scope.namespaceClass('__cell--out-of-range'));
                            } else {
                                if (stickyState.visibleIndices && stickyState.visibleIndices.indexOf(colIndex) >= 0) {
                                    element.addClass(scope.namespaceClass('__cell--unsticky'));
                                    element.removeClass(scope.namespaceClass('__cell--sticky'));
                                    element.removeClass(scope.namespaceClass('__cell--out-of-range'));
                                } else {
                                    element.removeClass(scope.namespaceClass('__cell--sticky'));
                                    element.removeClass(scope.namespaceClass('__cell--unsticky'));
                                    element.addClass(scope.namespaceClass('__cell--out-of-range'));
                                }
                            }
                        } else {
                            element.removeClass(scope.namespaceClass('__cell--sticky'));
                            element.removeClass(scope.namespaceClass('__cell--unsticky'));
                            element.removeClass(scope.namespaceClass('__cell--out-of-range'));
                        }
                    }

                    scope.getHyperlinkText = function (obj, settings) {
                        var text = '';
                        if (settings.textField) {
                            text = morningstar.asterix.util.string.format(scope.labels.get(settings.text), obj[settings.textField]);
                        } else {
                            text = scope.labels.get(settings.text);
                        }

                        return text;
                    };

                    scope.getHyperlinkUrl = function (obj, settings) {
                        var url = '';
                        if (settings.urlFields) {
                            var args = [settings.url];
                            morningstar.asterix.util.each(settings.urlFields, function (field) {
                                args.push(encodeURIComponent(obj[field]));
                            });
                            url = morningstar.asterix.util.string.format.apply(this, args);
                        } else {
                            url = settings.url;
                        }

                        return url;
                    };

                    scope.openHyperlink = function (e) {
                        var a = element.find('a'),
                            url = a.attr('href'),
                            target = a.attr('target');
                        if (target) {
                            $window.open(url, target);
                        } else {
                            $window.open(url);
                        }
                        e.preventDefault();
                        e.stopPropagation();
                    };
                }
            };
        }]);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar) {
        'use strict';

        angular.module('ecTable').directive('ecTableFootNote', ["$compile", "$parse", "mstarTemplate", "$window", "$timeout", "$sce", function ($compile, $parse, mstarTemplate, $window, $timeout, $sce) {
            return {
                restrict: 'E',
                require: '^mstarComponentId',
                link: function link(scope, element, attr, mstarComponent) {
                    // binds settings, labels, formatter and templates to scope properties
                    mstarComponent.bindConfig(scope);

                    scope.footNote.content = $sce.trustAsHtml(scope.footNote.content);
                    var template = scope.footNote.template || mstarComponent.getSettings().get('_templates.footNoteItemTemplate');
                    mstarTemplate.compile(scope, element, {
                        template: template,
                        keepRootElement: false
                    });
                }
            };
        }]);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(8), __webpack_require__(0), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, morningstar, $) {
        'use strict';

        table.$inject = ["$parse", "mstarSort", "$interpolate", "mstarDimensions", "$timeout"];
        angular.module('ecTable', ['mstarCore', 'ecButton', 'ecPaginator', 'ngTouch', 'ecChosen', 'ecContainer']).directive('ecTable', table);

        function table($parse, mstarSort, $interpolate, mstarDimensions, $timeout) {
            return {
                restrict: 'E',
                require: ['mstarComponentId'],
                scope: {
                    data: '=?tableData',
                    footNotes: '=?footNotes'
                },
                link: linkFn,
                controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
                    this.sort = function (field) {
                        $scope.instance.trigger('ecTableColumnSorted', [field]);
                        mstarSort.updateParameters($scope.parameters, field);
                    };

                    this.removeRow = function (row) {
                        $scope.data.splice($scope.data.indexOf(row), 1);
                    };

                    $scope.sort = this.sort;
                    $scope.removeRow = this.removeRow;
                }]
            };

            function linkFn(scope, elem, attr, controllers) {
                var mstarComponent = controllers[0];

                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                var mainTemplateName = '_templates.main';
                if (attr.templateType) {
                    switch (attr.templateType) {
                        case 'default':
                            break;
                        case 'light':
                            mainTemplateName = '_templates.light';
                            break;
                        default:
                            morningstar.asterix.instrumentation.logger.fatal(new Error('(ec-table) could not find template type: ' + attr.templateType));
                    }
                }

                // compiles the main template
                mstarComponent.compileTemplate(scope, mainTemplateName);

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                var _stickyCallbacks = [];
                scope.registerStickyCallback = function registerStickyCallback(cb) {
                    _stickyCallbacks.push(cb);
                };

                // use model binding if no table-data attribute given, otherwise use table-data
                if (!attr.tableData) {
                    mstarComponent.bindModelData(scope);
                    if (scope.model) {
                        if (scope.model.rows && scope.model.rows.length) {
                            scope.data = scope.model.rows;
                        }

                        if (scope.model.footNotes && scope.model.footNotes.length) {
                            scope.footNotes = scope.model.footNotes;
                        }
                    }
                } else {
                    mstarComponent.bindModel(scope);
                }
                if (scope.settings.get('stickyLeadEnabled')) {
                    stickyHandleNewSizeInDimensions();

                    mstarDimensions(scope, elem).addListener(function (dimensions) {
                        scope.$evalAsync(function () {
                            stickyHandleNewSize(dimensions);
                        });
                    });

                    mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:stickyState.currentPage', function (colIndex) {
                        if (colIndex) {
                            scope.$evalAsync(function () {
                                stickyUpdateVisibleIndices();
                                scope.parameters.stickyState.onUpdated();
                            });
                        }
                    }));

                    mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:stickyLeadBreakPoints', function () {
                        scope.$evalAsync(function () {
                            stickyHandleNewSize(mstarDimensions(scope, elem).getDimensions());
                        });
                    }));
                }

                scope.instance.setParameter('page', scope.instance.getParameter('defaultPage'));

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:defaultPage', function (page) {
                    if (page) {
                        scope.instance.setParameter('page', page);
                        if (scope.settings.get('stickyLeadEnabled')) {
                            scope.instance.setParameter('stickyState.currentPage', page);
                        }
                    }
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:page', function () {
                    stickyHandleNewSizeInDimensions();
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:totalRows', function () {
                    stickyHandleNewSizeInDimensions();
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:perPage', function () {
                    stickyHandleNewSizeInDimensions();
                }));

                function stickyHandleNewSizeInDimensions() {
                    mstarDimensions(scope, elem).requestDimensions(function (dimensions) {
                        scope.$evalAsync(function () {
                            stickyHandleNewSize(dimensions);
                        });
                    });
                }

                function update() {
                    // todo(slind): fixedTableHeader needs fixing
                    if (scope.settings.get('fixedTableHeaderEnabled')) {
                        var tableElement = elem.find('.table');
                        if (tableElement) {
                            var fixedTableHeaderScrollContainer = scope.settings.get('fixedTableHeaderScrollContainer');
                            if (fixedTableHeaderScrollContainer) {
                                tableElement.floatThead({
                                    scrollContainer: function scrollContainer(t) {
                                        return t.closest(fixedTableHeaderScrollContainer);
                                    }
                                });
                            } else {
                                tableElement.floatThead();
                            }
                        }
                    }

                    fixStickyStatus();
                }

                scope.fieldCount = function () {
                    return !scope.parameters.fields ? 0 : scope.parameters.fields.length;
                };

                scope.swipeLeft = function () {
                    if (scope.settings.get('swipeBehavior') === 'page' && scope.settings.get('paginationMode') !== 'none') {
                        scope.parameters.page += 1;
                    } else if (scope.settings.get('stickyLeadEnabled')) {
                        if (scope.parameters.stickyState && scope.parameters.stickyState.stickyMode) {
                            scope.parameters.stickyState.currentPage += 1;
                        }
                    }
                };

                scope.swipeRight = function () {
                    if (scope.settings.get('swipeBehavior') === 'page' && scope.settings.get('paginationMode') !== 'none') {
                        scope.parameters.page -= 1;
                    } else if (scope.settings.get('stickyLeadEnabled')) {
                        if (scope.parameters.stickyState && scope.parameters.stickyState.stickyMode) {
                            scope.parameters.stickyState.currentPage -= 1;
                        }
                    }
                };

                var _hasSetStickyOnUpdated = false;

                function stickyHandleNewSize(dimensions) {
                    if (!scope.settings.get('stickyLeadEnabled')) {
                        return;
                    }

                    var stickyLeadBreakPoints = scope.parameters.stickyLeadBreakPoints;
                    var stickyState = scope.parameters.stickyState = scope.parameters.stickyState || {};
                    if (!_hasSetStickyOnUpdated) {
                        _hasSetStickyOnUpdated = true;
                        stickyState.onUpdated = function onUpdated() {
                            _.each(_stickyCallbacks, function (cb) {
                                cb();
                            });
                        };
                    }

                    if (!stickyLeadBreakPoints) {
                        stickyState.onUpdated();
                        return;
                    }

                    stickyState.stickyMode = false;
                    for (var i = 0; i < stickyLeadBreakPoints.length; i++) {
                        if (dimensions.width >= stickyLeadBreakPoints[i].minWidth && dimensions.width <= stickyLeadBreakPoints[i].maxWidth) {
                            stickyState.stickyMode = true;
                            stickyState.columnsPerPage = stickyLeadBreakPoints[i].columnsPerPage;

                            stickyState.stickyColIndices = stickyLeadBreakPoints[i].stickyColIndices;
                        }
                    }

                    if (dimensions.width === 0) {
                        stickyState.stickyMode = true;
                    }

                    if (stickyState.stickyMode) {
                        if (!angular.isNumber(stickyState.currentPage)) {
                            stickyState.currentPage = scope.instance.getParameter('defaultPage') || 1;
                        }
                    }

                    stickyUpdateVisibleIndices();
                    stickyState.onUpdated();
                }

                function stickyUpdateVisibleIndices() {
                    var stickyState = scope.parameters.stickyState;
                    if (!stickyState || !stickyState.stickyMode || !stickyState.stickyColIndices) {
                        return;
                    }

                    var tableColumns;
                    if (scope.settings.get('orientation') === 'vertical') {
                        tableColumns = scope.parameters.fields;
                    } else {
                        tableColumns = _.clone(scope.model.rows && scope.model.rows.length ? scope.model.rows : []);
                        //since the header will also be a column so add a placeholder for that
                        tableColumns.push({});
                    }

                    stickyState.visibleIndices = _.chain(tableColumns).map(function (f, i) {
                        return i;
                    }).reject(function (n, i) {
                        return stickyState.stickyColIndices.indexOf(n) >= 0;
                    }).filter(function (n, i) {
                        // note(slind): we could potentially want to change this to display a minimum number of columns instead of "true" pagination
                        return i >= (stickyState.currentPage - 1) * stickyState.columnsPerPage && i < stickyState.currentPage * stickyState.columnsPerPage;
                    }).value();

                    stickyState.totalNonStickyColumns = _.chain(tableColumns).map(function (f, i) {
                        return i;
                    }).reject(function (n, i) {
                        return stickyState.stickyColIndices.indexOf(n) >= 0;
                    }).value().length;
                }

                scope.defaultFieldSettings = scope.settings.get('defaultFieldSettings');

                if (scope.parameters.fields) {
                    handleFields(scope.parameters.fields);
                }

                scope.$watchCollection('parameters.fields', handleFields);

                function handleFields(newValue) {
                    angular.forEach(newValue, function prepareField(field, key) {
                        scope.parameters.fields[key] = field = morningstar.asterix.util.field.applyDefinitionsAndAliases(field, scope.settings.get('fieldDefinitions'), scope.settings.get('formatAliases'));

                        if (!field.fieldName) {
                            throw new Error('Missing field name for field: ' + JSON.stringify(field));
                        }

                        field.getter = $parse(field.fieldName);
                        field.header = field.headerLabelKey ? $interpolate(scope.labels.get(field.headerLabelKey))(scope) : field.header;
                        field.sortingEnabled = field.hasOwnProperty('sortingEnabled') ? field.sortingEnabled : scope.settings.get('sortingEnabled');
                        field.rearrangeEnabled = field.hasOwnProperty('rearrangeEnabled') ? field.rearrangeEnabled : scope.settings.get('columnsRearrangeEnabled');
                        field.fieldSettings = morningstar.asterix.util.merge({}, scope.defaultFieldSettings, field.fieldSettings);

                        if (!morningstar.asterix.util.isFunction(field.format)) {
                            if (field.format) {
                                field._originalFormat = field.format;
                            }

                            var _format = field.format || field._originalFormat;
                            field.formatDataType = _format ? _format.dataType : '';

                            field.format = function formatField(value) {
                                if (value || _format && _format.dataType) {
                                    if (_format && _format.dataType === 'number') {
                                        return scope.format.number(value, _format);
                                    } else if (_format && _format.dataType === 'date') {
                                        return scope.format.date(value, _format);
                                    } else if (_format && _format.dataType === 'any') {
                                        return scope.format.any(value, _format);
                                    } else {
                                        // todo(slind): implement formatters for other types (e.g. string, bool)
                                        return value;
                                    }
                                } else {
                                    return scope.settings.get('format.nullString') || value;
                                }
                            };
                        }

                        field.toggleExpandedRow = function toggleExpandedRow(row) {
                            row._displayingExpandedView = !row._displayingExpandedView;

                            if (row._displayingExpandedView) {
                                scope.instance.trigger('ecTableRowExpanded', [row]);
                            } else {
                                scope.instance.trigger('ecTableRowCollapsed', [row]);
                            }
                        };
                    });

                    scope.visibleFields = scope.parameters.fields;
                    populateSortDropdown(scope.visibleFields);
                    update();
                }

                function parseKeyField(keyField) {
                    if (keyField && keyField.indexOf('{') > -1) {
                        scope.keyFieldParsed = $interpolate(keyField);
                    } else {
                        scope.keyFieldParsed = $parse(keyField);
                    }
                }

                var keyField = scope.instance.getParameter('keyField');
                parseKeyField(keyField);

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:keyField', function (newValue) {
                    parseKeyField(newValue);
                }));

                if (scope.settings.get('standalone')) {
                    var updateVisibleData = function updateVisibleData(newValue) {
                        if (angular.isUndefined(newValue)) {
                            return;
                        }

                        if (!scope.data || !angular.isArray(scope.data)) {
                            return;
                        }

                        if (scope.settings.get('expandAllRows')) {
                            expandAllRows();
                        }

                        scope.selectAll = false;

                        function checkIfFieldHasSortingEnabled(sortFieldName) {
                            var sortField = _.find(scope.parameters.fields, function (field) {
                                return field.fieldName === sortFieldName;
                            });
                            return sortField && sortField.sortingEnabled;
                        }

                        // need to be careful not to alter the watched properties here (will trigger double-updates)
                        var data = _.extend([], scope.data);
                        if (scope.settings.get('sortingEnabled') || checkIfFieldHasSortingEnabled(scope.parameters.sortField)) {
                            var sortFunc = scope.parameters.sortFunc;
                            if (sortFunc && scope.parameters.sortField) {
                                sortFunc = sortFunc[scope.parameters.sortField] || sortFunc;
                            }

                            if (morningstar.asterix.util.isFunction(sortFunc)) {
                                sortFunc(data, scope.parameters);
                            } else {
                                mstarSort.sort(data, scope.parameters, scope.settings.get('sortCaseInsensitive'));
                            }
                        }

                        scope.parameters.totalRows = data ? data.length : 0;
                        if (scope.settings.get('paginationMode') !== 'none') {
                            var paginationWindowSize = scope.parameters.paginationWindowSize || scope.parameters.perPage;
                            if (paginationWindowSize > scope.parameters.perPage) {
                                scope.logger.error(new Error('paginationWindowSize should not be greater than perPage value.'));
                            }
                            scope.visibleData = _.filter(data, function (e, i) {
                                return i >= (scope.parameters.page - 1) * paginationWindowSize && i < (scope.parameters.page - 1) * paginationWindowSize + scope.parameters.perPage;
                            });
                        } else {
                            scope.visibleData = data;
                        }
                        mstarComponent.getComponentInstance().setModelProperty('visibleRows', scope.visibleData);

                        update();
                    };

                    // shallow watch on data, to avoid triggering the watch if the data is modified in the table ui
                    scope.$watchCollection('data', function (newValue) {
                        updateVisibleData(newValue);
                        if (scope.settings.get('enablePartialCheckbox')) {
                            updateGroupCheckbox();
                        }
                    });

                    scope.$watchCollection('[parameters.page, parameters.perPage, parameters.sortField, parameters.sortOrder]', function (newValue) {
                        updateVisibleData(newValue);
                        if (scope.settings.get('enablePartialCheckbox')) {
                            updateGroupCheckbox();
                        }
                    });
                } else {

                    scope.$watch('data', function (newValue) {
                        if (scope.settings.get('expandAllRows')) {
                            expandAllRows();
                        }
                        scope.visibleData = scope.data;
                        mstarComponent.getComponentInstance().setModelProperty('visibleRows', scope.data);
                        scope.selectAll = false;
                        if (scope.settings.get('enablePartialCheckbox')) {
                            updateGroupCheckbox();
                        }
                    }, true);
                }

                function updateGroupCheckbox() {
                    scope.selectAll = false;

                    // Check that there is visible data
                    if (scope.visibleData) {
                        var selectedItemKeys = scope.instance.getParameter('selectedItemKeys'),
                            visibleDataSelectedItems = scope.visibleData.filter(function (currentRow) {
                            return selectedItemKeys.indexOf(scope.keyFieldParsed(currentRow)) !== -1;
                        });

                        if (visibleDataSelectedItems.length && visibleDataSelectedItems.length < scope.visibleData.length) {
                            scope.mixedSelect = true;
                        } else {
                            scope.mixedSelect = false;
                            if (scope.visibleData.length && visibleDataSelectedItems.length === scope.visibleData.length) {
                                scope.selectAll = true;
                            }
                        }
                    }
                }

                var updateVisibleFootNotes = function updateVisibleFootNotes(newValue) {
                    if (angular.isUndefined(newValue)) {
                        return;
                    }

                    if (!angular.isArray(newValue)) {
                        return;
                    }

                    //add the filter to map the note to field
                    var footNotes = [];
                    _.each(newValue, function (footNote, i) {
                        var visibleField = _.find(scope.visibleFields, function (field) {
                            return field.fieldName === footNote.fieldName;
                        });
                        if (visibleField) {
                            footNotes.push(footNote);
                        }
                    });

                    scope.footNotes = footNotes;
                };

                scope.$watchCollection('footNotes', function (newValue) {
                    updateVisibleFootNotes(newValue);
                }, true);

                mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:rows', function (newValue) {
                    scope.$evalAsync(function () {
                        scope.data = scope.model.rows;
                        stickyHandleNewSizeInDimensions();
                    });
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:footNotes', function (newValue) {
                    scope.$evalAsync(function () {
                        updateVisibleFootNotes(scope.model.footNotes);
                    });
                }));

                scope.toggleSelectedRows = function (event) {
                    var visibleKeys = [];
                    scope.selectAll = !scope.selectAll;

                    _.each(scope.visibleData, function (item) {
                        var key = scope.keyFieldParsed(item);
                        visibleKeys.push(key);
                        toggleSelect(key, scope.selectAll);
                    });

                    // Remove partial select class
                    if (scope.settings.get('enablePartialCheckbox')) {
                        scope.mixedSelect = false;
                    }
                    // Trigger listener for select all.
                    scope.instance.trigger('click', [event, 'toggleAllSelection', scope.selectAll, visibleKeys, scope.visibleData]);
                };

                scope.toggleSelectedRow = function (key, obj, $event, field) {
                    var rowClicked = $event.currentTarget.tagName.toLowerCase() === 'tr';
                    if (rowClicked && (!scope.settings.get('selectByRowEnabled') || !key)) {
                        return;
                    }

                    if (!field) {
                        //loop fields to find the radio fieldSetting
                        field = _.find(scope.visibleFields, function (visibleField) {
                            return visibleField.fieldSettings.itemTemplate === 'radio';
                        });
                    }

                    toggleSelect(key, null, field);
                    $event.stopPropagation();

                    // Trigger listener for single selection.
                    scope.instance.trigger('click', [$event, 'toggleSingleSelection', scope.isSelected(key), key, obj]);

                    if (scope.settings.get('enablePartialCheckbox')) {
                        updateGroupCheckbox();
                    }
                    scope.instance.trigger('ecTableRowSelected', [obj]);
                };

                scope.isSelected = function (key) {
                    return scope.parameters.selectedItemKeys && scope.parameters.selectedItemKeys.length > 0 && scope.parameters.selectedItemKeys.indexOf(key) > -1;
                };

                scope.parameters.deselectAll = function () {
                    scope.parameters.selectedItemKeys = [];
                };

                function toggleSelect(key, add, field) {
                    if (typeof add === 'boolean') {
                        if (add) {
                            selectItem(key);
                        } else {
                            deselectItem(key);
                        }
                    } else {
                        if (field && field.fieldSettings.itemTemplate === 'radio') {
                            scope.parameters.selectedItemKeys = [];
                            scope.parameters.selectedItemKeys.push(key);
                        } else {
                            if (scope.isSelected(key)) {
                                deselectItem(key);
                            } else {
                                selectItem(key);
                            }
                        }
                    }
                }

                function selectItem(key) {
                    if (!scope.isSelected(key)) {
                        scope.parameters.selectedItemKeys.push(key);
                    }
                }

                function deselectItem(key) {
                    if (scope.isSelected(key)) {
                        scope.parameters.selectedItemKeys.splice(scope.parameters.selectedItemKeys.indexOf(key), 1);
                    }
                }

                if (scope.settings.get('accordionMode')) {
                    scope.accordionShowMoreLessText = scope.labels.get('accordionShowMore');
                }

                var showExpandedRows = false;

                scope.handleTableRowsToggle = function (event) {
                    if (showExpandedRows) {
                        showLessRows(this);
                        showExpandedRows = false;
                        scope.instance.trigger('ecTableShowLessRows', [event]);
                    } else {
                        showMoreRows(this);
                        showExpandedRows = true;
                        scope.instance.trigger('ecTableShowMoreRows', [event]);
                    }
                };

                function showMoreRows(toggleButton) {
                    elem.addClass('ec-table--show-all');
                    swapTextButton(toggleButton, scope.labels.get('accordionShowLess'));
                }

                function showLessRows(toggleButton) {
                    elem.removeClass('ec-table--show-all');
                    swapTextButton(toggleButton, scope.labels.get('accordionShowMore'));
                }

                function swapTextButton(toggleButton, toggleButtonText) {
                    toggleButton.accordionShowMoreLessText = toggleButtonText;
                }

                // Details accordion (expand "columns" in mobile)

                scope.handleTableDetailsToggle = function (event) {
                    if ($(event.currentTarget).parents('.ec-table__row').hasClass('ec-table__row--details-show')) {
                        lessTableDetails(event);
                    } else {
                        moreTableDetails(event);
                    }
                };

                if (scope.settings.get('accordionDetailsEnable')) {
                    scope.accordionDetailsButton = scope.labels.get('accordionDetailsShow');

                    mstarDimensions(scope, elem).addListener(function (dimensions) {
                        if (dimensions.width < scope.settings.get('accordionDetailsComponentMaxWidth')) {
                            elem.find('.ec-table__cell--showdetails').show();
                        } else {
                            elem.find('.ec-table__cell--showdetails').hide();
                        }
                    });
                }

                function moreTableDetails(toggleButton) {
                    $(toggleButton.currentTarget).parents('.ec-table__row').addClass('ec-table__row--details-show');
                    swapDetailsTextButton(toggleButton, scope.labels.get('accordionDetailsHide'));
                }

                function lessTableDetails(toggleButton) {
                    $(toggleButton.currentTarget).parents('.ec-table__row').removeClass('ec-table__row--details-show');
                    swapDetailsTextButton(toggleButton, scope.labels.get('accordionDetailsShow'));
                }

                function swapDetailsTextButton(toggleButton, toggleButtonText) {
                    $(toggleButton.currentTarget).text(toggleButtonText);
                }

                scope.showMoreLink = function () {
                    if (scope.settings.get('accordionMode')) {
                        if (scope.settings.get('orientation') === 'vertical') {
                            return scope.model.rows && scope.model.rows.length > scope.settings.get('accordionMinRow');
                        } else {
                            return scope.settings.get('fields').length > scope.settings.get('accordionMinRow');
                        }
                    }
                };

                // POST client_profile merge fix: Since the '__cell--out-of-range' flag will be added to all table cells, so the table cells will be hidden at launch (INTL-16096)
                // This function fixes the hidden data-point issues after all datapoint cells added with '__cell--out-of-range'(line 13, cell.js)
                function fixStickyStatus() {
                    if (scope.settings.get('stickyLeadEnabled')) {
                        stickyHandleNewSize(mstarDimensions(scope, elem).getDimensions());
                    }
                }

                function populateSortDropdown(fieldsArray) {
                    var sortedHeaders = [];
                    _.each(fieldsArray, function (fieldObj) {
                        if (fieldObj.sortingEnabled) {
                            sortedHeaders.push(fieldObj);
                        }
                    });
                    scope.instance.setParameter('sortableFields', sortedHeaders);
                }

                function getDragDropIndex(fields, srcField, destField, direction) {
                    var srcIndex = _.findIndex(fields, {
                        fieldName: srcField.fieldName
                    }),
                        destIndex = _.findIndex(fields, {
                        fieldName: destField.fieldName
                    });
                    if (srcIndex < destIndex) {
                        destIndex = direction === 'left' || direction === 'top' ? destIndex - 1 : destIndex;
                    } else if (srcIndex > destIndex) {
                        destIndex = direction === 'right' || direction === 'bottom' ? destIndex + 1 : destIndex;
                    }
                    return {
                        src: srcIndex,
                        dest: destIndex
                    };
                }

                function swapFields(fields, srcField, destField, direction) {
                    var newFields = fields.slice(),
                        idx = getDragDropIndex(fields, srcField, destField, direction);
                    if (idx.dest !== idx.src) {
                        newFields.splice(idx.dest, 0, newFields.splice(idx.src, 1)[0]);
                    }
                    return newFields;
                }

                mstarComponent.addUnregisterCallback(scope.instance.on('dragStart', function (proxy) {
                    var drag = proxy.drag();
                    if (drag.element.hasClass(scope.namespaceClass('__cell'))) {
                        //draging column
                        if (scope.settings.get('orientation') === 'vertical') {
                            proxy.direction('x').containment(drag.element.parent());
                        } else {
                            var bounds = drag.element[0].getBoundingClientRect(),
                                elemParent = drag.element.parent().parent(),
                                parentOffset = elemParent.offset();
                            proxy.direction('y').containment({
                                left: bounds.left,
                                right: bounds.right,
                                top: parentOffset.top,
                                bottom: elemParent.outerHeight(true) + parentOffset.top
                            });
                        }
                        proxy.element().html(drag.scope.field.header);
                    }
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('drag', function (proxy) {
                    var drop = proxy.drop();
                    if (!drop) {
                        return;
                    }
                    var dropElem = drop.element;
                    if (dropElem.hasClass(scope.namespaceClass('__cell'))) {
                        //means draging in a dropable element
                        if (scope.settings.get('orientation') === 'vertical') {
                            dropElem.removeClass(scope.namespaceClass('__cell--highlight-left') + ' ' + scope.namespaceClass('__cell--highlight-right')).addClass(scope.namespaceClass('__cell--highlight-' + drop.areaPos[0]));
                        } else {
                            dropElem.removeClass(scope.namespaceClass('__cell--highlight-top') + ' ' + scope.namespaceClass('__cell--highlight-bottom')).addClass(scope.namespaceClass('__cell--highlight-' + drop.areaPos[1]));
                        }
                    }
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('drop', function (proxy) {
                    var dropElem = proxy.drop().element;
                    if (dropElem.hasClass(scope.namespaceClass('__cell'))) {
                        var dragField = proxy.drag().scope.field,
                            dropField = proxy.drop().scope.field;
                        if (dropField.fieldName !== dragField.fieldName) {
                            scope.parameters.fields = swapFields(scope.parameters.fields, dragField, dropField, proxy.drop().areaPos[scope.settings.get('orientation') === 'vertical' ? 0 : 1]);
                            scope.$apply(function () {
                                handleFields(scope.parameters.fields);
                            });
                        }
                        if (scope.settings.get('orientation') === 'vertical') {
                            dropElem.removeClass(scope.namespaceClass('__cell--highlight-left')).removeClass(scope.namespaceClass('__cell--highlight-right'));
                        } else {
                            dropElem.removeClass(scope.namespaceClass('__cell--highlight-top')).removeClass(scope.namespaceClass('__cell--highlight-bottom'));
                        }
                    }
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('dropOut', function (proxy) {
                    var dropElem = proxy.drop().element;
                    if (dropElem.hasClass(scope.namespaceClass('__cell'))) {
                        if (scope.settings.get('orientation') === 'vertical') {
                            dropElem.removeClass(scope.namespaceClass('__cell--highlight-left')).removeClass(scope.namespaceClass('__cell--highlight-right'));
                        } else {
                            dropElem.removeClass(scope.namespaceClass('__cell--highlight-top')).removeClass(scope.namespaceClass('__cell--highlight-bottom'));
                        }
                    }
                }));

                function expandAllRows() {
                    var expandAllRows = scope.settings.get('expandAllRows');
                    _.each(scope.data, function (obj) {
                        if (_.isUndefined(obj._displayingExpandedView)) {
                            obj._displayingExpandedView = expandAllRows;
                        }
                    });
                }
            }
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 6 */
/***/function (module, exports) {

    module.exports = {
        "ecTable": {
            "components": {
                "paginator": {
                    "settings": {
                        "_parameters": {
                            "page": {
                                "binding": "{{_ parameters(_).page _}}"
                            },
                            "paginationWindowSize": {
                                "binding": "{{_ parameters(_).paginationWindowSize _}}"
                            },
                            "perPage": {
                                "binding": "{{_ parameters(_).perPage _}}"
                            },
                            "totalRows": {
                                "binding": "{{_ parameters(_).totalRows _}}"
                            }
                        },
                        "numberOfWrappingPageLinks": 1
                    },
                    "type": "ecPaginator"
                },
                "paginatorSticky": {
                    "labels": {
                        "next": {
                            "da-DK": "Næste søjler",
                            "en": "Next columns",
                            "fr": "Suivant",
                            "fr-CA": "Colonnes suivantes",
                            "it": "Colonne successive",
                            "ja": "次の列",
                            "sv": "Följande kolumner",
                            "zh-CN": "下列",
                            "zh-HK": "下列"
                        },
                        "previous": {
                            "da-DK": "Forrige søjler",
                            "en": "Previous columns",
                            "fr": "Précédent",
                            "fr-CA": "Colonnes précédentes",
                            "it": "Colonne precedenti",
                            "ja": "前の列",
                            "sv": "Föregående kolumner",
                            "zh-CN": "前列",
                            "zh-HK": "前列"
                        }
                    },
                    "settings": {
                        "_parameters": {
                            "page": {
                                "binding": "{{_ parameters(_).stickyState.currentPage _}}"
                            },
                            "paginationWindowSize": {
                                "binding": "{{_ parameters(_).paginationWindowSize _}}"
                            },
                            "perPage": {
                                "binding": "{{_ parameters(_).stickyState.columnsPerPage _}}"
                            },
                            "totalRows": {
                                "binding": "{{_ parameters(_).stickyState.totalNonStickyColumns _}}"
                            }
                        },
                        "showPageNumbers": false
                    },
                    "type": "ecPaginator"
                },
                "paginatorTop": {
                    "settings": {
                        "_parameters": {
                            "page": {
                                "binding": "{{_ parameters(_).page _}}"
                            },
                            "paginationWindowSize": {
                                "binding": "{{_ parameters(_).paginationWindowSize _}}"
                            },
                            "perPage": {
                                "binding": "{{_ parameters(_).perPage _}}"
                            },
                            "totalRows": {
                                "binding": "{{_ parameters(_).totalRows _}}"
                            }
                        },
                        "numberOfWrappingPageLinks": 1
                    },
                    "type": "ecPaginator"
                },
                "sortFieldsDropdown": {
                    "labels": {
                        "placeholderTextSingle": {
                            "da-DK": "Vælg sorteringskriterie..",
                            "en": "Select sorting field..",
                            "fr": "Sélectionner le champ de tri",
                            "it": "Seleziona campo di ordinamento…",
                            "ja": "並び替え項目を選択",
                            "sv": "Välj sorteringsfält",
                            "zh-CN": "选择排序项",
                            "zh-HK": "選擇排序項"
                        }
                    },
                    "settings": {
                        "_model": {
                            "listItems": {
                                "dataSourceType": "selector",
                                "evaluationTypes": {
                                    "parameters": true
                                },
                                "selector": "{{_ parameters(_).sortableFields _}}"
                            }
                        },
                        "allowSingleDeselect": false,
                        "disableSearch": true,
                        "keyField": "fieldName",
                        "multiple": false,
                        "valueField": "header"
                    },
                    "type": "ecChosen"
                },
                "sortOrderRadio": {
                    "labels": {
                        "placeholderTextSingle": {
                            "da-DK": "Vælg en sorteringsrækkefølge...",
                            "en": "Select a sorting order..",
                            "fr": "Sélectionner l'ordre de tri",
                            "fr-CA": "Sélectionnez l'ordre de tri",
                            "it": "Seleziona tipo di ordinamento…",
                            "ja": "並び替え順を選択",
                            "sv": "Välj sorteringsordning",
                            "zh-CN": "选择顺序",
                            "zh-HK": "選擇順序"
                        }
                    },
                    "settings": {
                        "_model": {
                            "listItems": [{
                                "key": "asc",
                                "value": "asc"
                            }, {
                                "key": "desc",
                                "value": "desc"
                            }]
                        },
                        "allowSingleDeselect": false,
                        "controlType": "radio",
                        "disableSearch": true,
                        "keyField": "key",
                        "multiple": false
                    },
                    "type": "ecChosen"
                }
            },
            "labels": {
                "accordionDetailsHide": {
                    "da-DK": "Skjul detaljerede oplysninger",
                    "en": "Hide full details",
                    "fr": "Cacher les détails complets",
                    "fr-CA": "Cacher tous les détails",
                    "it": "Nascondi tutti i dettagli",
                    "ja": "詳細を非表示",
                    "sv": "Dölja detaljer",
                    "zh-CN": "隐藏全部详情",
                    "zh-HK": "隱藏全部詳情"
                },
                "accordionDetailsShow": {
                    "da-DK": "Vis detaljerede oplysninger",
                    "en": "Show full details",
                    "fr": "Afficher les détails complets",
                    "fr-CA": "Afficher tous les détails",
                    "it": "Mostra tutti i dettagli",
                    "ja": "詳細を表示",
                    "sv": "Visa detaljer",
                    "zh-CN": "显示全部详情",
                    "zh-HK": "顯示全部詳情"
                },
                "accordionShowLess": {
                    "da-DK": "Vis mindre",
                    "en": "Show less",
                    "fr": "Afficher moins",
                    "it": "Mostra meno",
                    "ja": "閉じる",
                    "sv": "Visa mindre",
                    "zh-CN": "显示较少",
                    "zh-HK": "顯示較少"
                },
                "accordionShowMore": {
                    "da-DK": "Vis mere",
                    "en": "Show more",
                    "es": "Mostrar más",
                    "fr": "Afficher plus",
                    "fr-CA": "Afficher Plus",
                    "it": "Mostra di più",
                    "ja": "さらに表示",
                    "sv": "Visa mer",
                    "zh-CN": "显示更多",
                    "zh-HK": "顯示更多"
                },
                "asc": {
                    "da-DK": "Lavest til højest",
                    "en": "Asc",
                    "fr": "Croissant",
                    "it": "Asc",
                    "ja": "昇順",
                    "sv": "Stigande",
                    "zh-CN": "顺序",
                    "zh-HK": "順序"
                },
                "desc": {
                    "da-DK": "Højest til Lavest",
                    "en": "Desc",
                    "fr": "Décroissant",
                    "it": "Disc",
                    "ja": "降順",
                    "sv": "Fallande",
                    "zh-CN": "倒序",
                    "zh-HK": "倒序"
                },
                "sortBy": {
                    "da-DK": "Vælg sorteringsrækkefølge:",
                    "en": "Select sort order:",
                    "en-GB": null,
                    "fr": "Sélectionner le champ de tri",
                    "fr-CA": "Sélectionnez l'ordre de tri",
                    "it": "Seleziona ordine:",
                    "ja": "並び替え順を選択",
                    "sv": "Välj sorteringsordning",
                    "sv-SE": null,
                    "zh-CN": "选择顺序",
                    "zh-HK": "選擇順序"
                },
                "sortField": {
                    "da-DK": "Vælg sorteringsparameter:",
                    "en": "Select sort field:",
                    "en-GB": null,
                    "fr": "Sélectionner l'ordre de tri",
                    "fr-CA": "Sélectionnez le champ de tri",
                    "it": "Seleziona campo di ordinamento:",
                    "ja": "並び替え項目を選択",
                    "sv": "Välj fält att sortera på",
                    "sv-SE": null,
                    "zh-CN": "选择排序项",
                    "zh-HK": "選擇排序項"
                }
            },
            "settings": {
                "_model": null,
                "_parameters": {
                    "caption": null,
                    "defaultPage": {},
                    "fields": null,
                    "keyField": null,
                    "page": null,
                    "paginationWindowSize": {},
                    "perPage": null,
                    "selectedItemKeys": null,
                    "sortField": null,
                    "sortFunc": {},
                    "sortOrder": null,
                    "sortableFields": {},
                    "stickyLeadBreakPoints": null,
                    "stickyState": null,
                    "totalRows": null
                },
                "_templates": {
                    "expandedRow": null,
                    "footNoteItemTemplate": "﻿<span class=\"ec-table__foot-note-indicator\">{{labels.get(footNote.indicatorLabelKey) }}:</span>\r\n<span class=\"ec-table__foot-note-content\" data-ng-bind-html=\"footNote.content\"></span>\r\n",
                    "light": "<ec-section template-type=\"light\">\r\n    <table class=\"ec-table__table ec-table__table--{{ :: settings.get('stickyLeadEnabled') ? 'sticky' : (settings.get('orientation') === 'vertical' ? 'vertical' : 'horizontal') }}{{ :: settings.get('stickyLeadEnabled') || settings.get('responsiveEnabled') ? '' : '-non-responsive' }}\">\r\n\r\n        <caption class=\"{{ settings.get('hideCaption') || !settings.get('caption') ? 'ec-table__caption--hidden' : 'ec-table__caption' }}\" mstar-tooltip-content=\"{{ :: labels.contains(settings.get('caption') + 'Tooltip') ? labels.get(settings.get('caption') + 'Tooltip') : '' }}\" mstar-tooltip>\r\n            {{ settings.get('caption') ? labels.get(settings.get('caption')) : namespaceId() }}\r\n        </caption>\r\n\r\n        <thead data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__thead ec-table__thead--vertical{{ :: settings.get('responsiveEnabled') ? '' : '-non-responsive' }}\">\r\n            <tr class=\"ec-table__row-header\">\r\n                <th scope=\"col\" ec-table-cell data-ng-repeat=\"field in visibleFields track by field.fieldName\" data-ng-class=\"{ 'ec-table__cell--numeric': field.formatDataType == 'number'}\" class=\"ec-table__cell ec-table__cell--header\">\r\n                    <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                </th>\r\n            </tr>\r\n        </thead>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__tbody ec-table__tbody--vertical{{ :: settings.get('responsiveEnabled') ? '' : '-non-responsive' }}\">\r\n            <tr data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\" class=\"ec-table__row\">\r\n                <td ec-table-cell-light data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\"\r\n                    data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data {{ :: field.formatDataType === 'number' ? 'ec-table__cell--numeric' : '' }}\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'horizontal'\" class=\"ec-table__tbody ec-table__tbody--horizontal\">\r\n            <tr data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\" class=\"ec-table__row\">\r\n                <th scope=\"row\" ec-table-cell-light data-ng-if=\"!field.fieldSettings.headerSkipped\"\r\n                    class=\"ec-table__cell ec-table__cell--header\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>\r\n                            {{ ::field.header }}\r\n                        </span>\r\n                    </div>\r\n                </th>\r\n                <td ec-table-cell-light data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\"\r\n                    data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data {{ :: field.formatDataType === 'number' ? 'ec-table__cell--numeric' : '' }}\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n\r\n    </table>\r\n    <footer data-ng-if=\"footNotes\" class=\"ec-table__footer\">\r\n        <ul class=\"ec-table__foot-notes\">\r\n            <li data-ng-repeat=\"footNote in footNotes\" class=\"ec-table__foot-note\">\r\n                <ec-table-foot-note></ec-table-foot-note>\r\n            </li>\r\n        </ul>\r\n    </footer>\r\n</ec-section>\r\n",
                    "main": "<ec-section>\r\n\r\n    <ec-paginator mstar-component-id=\"paginatorTop\" data-ng-if=\"settings.get('paginationMode') == 'top' || settings.get('paginationMode') == 'both'\"></ec-paginator>\r\n\r\n    <ec-paginator mstar-component-id=\"paginatorSticky\" data-ng-class=\"settings.get('columnSkipActionsClass')\"\r\n        data-ng-if=\"settings.get('stickyLeadEnabled') && parameters.stickyState.stickyMode && settings.get('stickyPaginationMode') === 'top'\">\r\n    </ec-paginator>\r\n\r\n    <div mstar-include=\"templates.sortControls\" data-ng-if=\"settings.get('sortingEnabled')\"></div>\r\n    <table role=\"grid\" mstar-loader=\"model.rows._$isLoading\" data-ng-class=\":: settings.get('stickyLeadEnabled') ? 'ec-table__table--sticky' : ((settings.get('orientation') === 'vertical' ? 'ec-table__table--vertical' : 'ec-table__table--horizontal') + (settings.get('responsiveEnabled')?'':'-non-responsive'))\"\r\n        data-ng-swipe-disable-mouse data-ng-swipe-left=\"swipeLeft()\" data-ng-swipe-right=\"swipeRight()\" class=\"ec-table__table\">\r\n\r\n        <caption class=\"{{ settings.get('hideCaption') || !settings.get('caption') ? 'ec-table__caption--hidden' : 'ec-table__caption' }}\" mstar-tooltip-content=\"{{ :: labels.contains(settings.get('caption') + 'Tooltip') ? labels.get(settings.get('caption') + 'Tooltip') : '' }}\" mstar-tooltip>\r\n            {{ settings.get('caption') ? labels.get(settings.get('caption')) : namespaceId() }}\r\n        </caption>\r\n\r\n        <thead data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__thead  ec-table__thead--vertical{{ :: settings.get('responsiveEnabled')?'':'-non-responsive' }}\">\r\n            <tr class=\"ec-table__row-header\">\r\n                <th data-ng-if=\"!field.fieldSettings.headerSkipped\" scope=\"col\" ec-table-cell data-ng-click=\"field.sortingEnabled && sort(field.fieldName)\" data-ng-repeat=\"field in visibleFields track by field.fieldName\" data-ng-class=\"{ 'ec-table__cell--numeric': field.formatDataType == 'number',\r\n                    'ec-table__cell--header-sorted': field.sortingEnabled && field.fieldName === parameters.sortField }\" class=\"ec-table__cell ec-table__cell--header\" mstar-drag=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\"\r\n                    mstar-drop=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\">\r\n                    <a href=\"javascript:;\" data-ng-if=\"field.sortingEnabled\" class=\"ec-table__sort\">\r\n                        <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                        <i class=\"fa fa-fw fa-sort\" data-ng-if=\"field.fieldName !== parameters.sortField\"></i>\r\n                        <i class=\"fa fa-fw fa-sort-{{parameters.sortOrder}}\" data-ng-if=\"field.fieldName === parameters.sortField\"></i>\r\n                    </a>\r\n                    <span data-ng-if=\"!field.sortingEnabled\" mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                </th>\r\n            </tr>\r\n        </thead>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__tbody ec-table__tbody--vertical{{ :: settings.get('responsiveEnabled')?'':'-non-responsive' }}\">\r\n            <tr data-ng-repeat-start=\"obj in visibleData track by keyFieldParsed(obj) || $index\" data-ng-class=\"[isSelected(keyFieldParsed(obj)) ? 'ec-table__row--selected' : '', (templates.expandedRow && obj._displayingExpandedView) ? 'ec-table__row--expanded' : '', settings.get('selectByRowEnabled') ? 'ec-table__row--clickable' : '', (settings.get('accordionMode') && $index > settings.get('accordionMinRow') - 1) ? 'ec-table__row--hide' : '']\"\r\n                data-ng-click=\"toggleSelectedRow(keyFieldParsed(obj), obj, $event)\" data-ng-init=\"rowIndex=$index\" class=\"ec-table__row\" id=\"{{namespaceId('-row-'+$index)}}\">\r\n                <td ec-table-cell data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\" data-ng-class=\"[(settings.get('accordionDetailsEnable') && $index > settings.get('accordionDetailsMinRow') - 1) ? 'ec-table__cell--details-hide' : '', field.formatDataType == 'number' ? 'ec-table__cell--numeric' : '']\"\r\n                    data-ng-init=\"colIndex=$index\" data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n                <td class=\"ec-table__cell--showdetails\" data-ng-if=\"settings.get('accordionDetailsEnable')\">\r\n                    <button data-ng-click=\"handleTableDetailsToggle($event)\" data-ng-class=\"tableDetailsToggleClass\" class=\"ec-table__toggle-details\">{{accordionDetailsButton}}</button>\r\n                </td>\r\n            </tr>\r\n            <tr data-ng-repeat-end data-ng-if=\"templates.expandedRow && obj._displayingExpandedView\" class=\"ec-table__row ec-table__row--extended\">\r\n                <td colspan=\"{{ visibleFields.length }}\" class=\"ec-table__cell ec-table__cell--data ec-table__cell--last\">\r\n                    <div mstar-include=\"templates.expandedRow\"></div>\r\n                </td>\r\n                <td class=\"ec-table__cell--showdetails\" data-ng-if=\"settings.get('accordionDetailsEnable')\"></td>\r\n            </tr>\r\n        </tbody>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'horizontal'\" class=\"ec-table__tbody ec-table__tbody--horizontal\">\r\n            <tr class=\"ec-table__row-header\" data-ng-if=\"settings.get('horizontalHeaderField')\">\r\n                <td data-ng-if=\"!labels.contains(settings.get('horizontalHeaderField'))\"></td>\r\n                <th scope=\"col\" data-ng-if=\"labels.contains(settings.get('horizontalHeaderField'))\" class=\"ec-table__cell ec-table__cell--header\">{{labels.get(settings.get('horizontalHeaderField'))}}</th>\r\n                <th scope=\"col\" data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\" class=\"ec-table__cell ec-table__cell--header\">\r\n                    {{ obj[settings.get('horizontalHeaderField')] }}\r\n                </th>\r\n            </tr>\r\n            <tr data-ng-class=\"(settings.get('accordionMode') && $index > settings.get('accordionMinRow') - 1) ? 'ec-table__row--hide' : ''\" data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\" data-ng-init=\"rowIndex=$index\" class=\"ec-table__row\">\r\n                <th scope=\"row\" ec-table-cell data-ng-click=\"field.sortingEnabled && sort(field.fieldName)\" data-col-index=\"0\" data-ng-if=\"!field.fieldSettings.headerSkipped\" data-ng-class=\"{ 'ec-table__cell--header-sorted': field.sortingEnabled && field.fieldName === parameters.sortField }\"\r\n                    class=\"ec-table__cell ec-table__cell--header\" mstar-drag=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\" mstar-drop=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        <a data-ng-if=\"field.sortingEnabled\" href=\"javascript:;\" class=\"ec-table__sort\">\r\n                            <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                            <i class=\"fa fa-fw fa-sort\" data-ng-if=\"field.fieldName !== parameters.sortField\"></i>\r\n                            <i class=\"fa fa-fw fa-sort-{{parameters.sortOrder}}\" data-ng-if=\"field.fieldName === parameters.sortField\"></i>\r\n                        </a>\r\n                        <span data-ng-if=\"!field.sortingEnabled\" mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>\r\n                            {{ ::field.header }}\r\n                        </span>\r\n                    </div>\r\n                </th>\r\n                <td ec-table-cell data-ng-class=\"[isSelected(keyFieldParsed(obj)) ? 'ec-table__row--selected' : '', field.formatDataType == 'number' ? 'ec-table__cell--numeric' : '']\" data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\"\r\n                    data-ng-init=\"colIndex=$index\" data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n\r\n    </table>\r\n\r\n    <footer data-ng-if=\"footNotes\" class=\"ec-table__footer\">\r\n        <ul class=\"ec-table__foot-notes\">\r\n            <li data-ng-repeat=\"footNote in footNotes\" class=\"ec-table__foot-note\">\r\n                <ec-table-foot-note></ec-table-foot-note>\r\n            </li>\r\n        </ul>\r\n    </footer>\r\n\r\n    <button data-ng-if=\"settings.get('accordionMode') && showMoreLink()\" data-ng-click=\"handleTableRowsToggle($event)\" data-ng-class=\"tableRowsToggleClass\" class=\"ec-table__toggle-row\">\r\n        {{accordionShowMoreLessText}}\r\n    </button>\r\n\r\n    <ec-paginator mstar-component-id=\"paginator\" data-ng-if=\"settings.get('paginationMode') == 'bottom' || settings.get('paginationMode') == 'both'\"></ec-paginator>\r\n\r\n    <ec-paginator mstar-component-id=\"paginatorSticky\" data-ng-class=\"settings.get('columnSkipActionsClass')\"\r\n        data-ng-if=\"settings.get('stickyLeadEnabled') && parameters.stickyState.stickyMode && settings.get('stickyPaginationMode') === 'bottom'\">\r\n    </ec-paginator>\r\n\r\n</ec-section>\r\n",
                    "sortControls": "<div class=\"ec-table__sort-controls\">\r\n\t<div class=\"ec-table__sort-options\">\r\n    \t<label class=\"ec-table__sort-field\">{{labels.get(\"sortField\")}}</label>\r\n        <ec-chosen mstar-component-id=\"sortFieldsDropdown\" data-ng-model=\"parameters.sortField\"></ec-chosen>\r\n    </div>\r\n    <div class=\"ec-table__sort-order\">\r\n    \t<label class=\"ec-table__sort-label\">{{labels.get(\"sortBy\")}}</label>\r\n    \t<ec-chosen mstar-component-id=\"sortOrderRadio\" data-ng-model=\"parameters.sortOrder\"></ec-chosen>\r\n    </div>\r\n</div>\r\n"
                },
                "accordionDetailsComponentMaxWidth": 668,
                "accordionDetailsEnable": false,
                "accordionDetailsHide": "Hide full details",
                "accordionDetailsMinRow": 3,
                "accordionDetailsShow": "Show full details",
                "accordionMinRow": 5,
                "accordionMode": false,
                "caption": null,
                "columnSkipActionsClass": null,
                "columnsRearrangeEnabled": false,
                "defaultFieldSettings": {
                    "button": {
                        "click": null,
                        "componentId": null
                    },
                    "buttonItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}}\">\r\n        <ec-button mstar-component-id=\"{{settings.get('orientation') === 'horizontal' ? field.fieldSettings.button.componentId + '[' + colIndex + ']' : field.fieldSettings.button.componentId + '[' + rowIndex + ']'}}\" data-ng-click=\"field.fieldSettings.button.click(keyFieldParsed(obj), $event)\"></ec-button>\r\n    </div>\r\n</td>\r\n",
                    "checkboxHeaderTemplate": "<th>\r\n    <div class=\"{{namespaceClass('__cell-content')}}\">\r\n        <div class=\"ec-form__checkbox\" data-ng-class=\"{'ec-form__checkbox--mixed' : mixedSelect && settings.get('enablePartialCheckbox')}\">\r\n            <label class=\"ec-form__label ec-form__label--checkbox\">\r\n                <!-- TODO: ecChosen's checkbox? -->\r\n                <input type=\"checkbox\" data-ng-checked=\"selectAll\" class=\"{{namespaceClass('__checkbox')}}\" data-ng-click=\"toggleSelectedRows($event)\" />\r\n                <span class=\"ec-form__checkbox-text\">\r\n                    <!-- TODO: Add label -->\r\n                </span>\r\n            </label>\r\n        </div>\r\n    </div>\r\n</th>\r\n",
                    "checkboxItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}} {{namespaceClass('__cell--checkbox')}}\">\r\n        <div class=\"ec-form__checkbox\">\r\n            <label class=\"ec-form__label ec-form__label--checkbox\">\r\n                <!-- TODO: ecChosen's checkbox? -->\r\n                <input type=\"checkbox\" data-ng-checked=\"isSelected(keyFieldParsed(obj))\" data-ng-click=\"toggleSelectedRow(keyFieldParsed(obj), obj, $event, field)\" class=\"{{namespaceClass('__checkbox')}}\" />\r\n                <span class=\"ec-form__checkbox-text\">\r\n                    <!-- TODO: Add label -->\r\n                </span>\r\n            </label>\r\n        </div>\r\n\r\n    </div>\r\n</td>\r\n",
                    "headerColspan": -1,
                    "headerRowspan": -1,
                    "headerSkipped": false,
                    "headerTemplate": null,
                    "hyperlink": {
                        "cssClass": null,
                        "target": null,
                        "text": null,
                        "textField": null,
                        "url": null,
                        "urlFields": null
                    },
                    "hyperlinkItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}}\">\r\n        <a data-ng-href=\"{{getHyperlinkUrl(obj, field.fieldSettings.hyperlink)}}\"\r\n           data-ng-attr-target=\"{{field.fieldSettings.hyperlink.target || undefined}}\"\r\n           data-ng-class=\"field.fieldSettings.hyperlink.cssClass\"\r\n           data-ng-click=\"openHyperlink($event);\"\r\n           class=\"{{namespaceClass('__link')}}\">{{getHyperlinkText(obj, field.fieldSettings.hyperlink)}}</a>\r\n    </div>\r\n</td>\r\n",
                    "itemTemplate": null,
                    "radioItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}} {{namespaceClass('__cell--radio')}}\" data-ng-class=\"isSelected(keyFieldParsed(obj)) ? namespaceClass('__cell-radio--selected') : ''\">\r\n        <div class=\"ec-form__radio\">\r\n            <label class=\"ec-form__label ec-form__label--radio\">\r\n                <input type=\"radio\" name=\"{{namespaceId('radio')}}\" data-ng-checked=\"isSelected(keyFieldParsed(obj))\" data-ng-click=\"toggleSelectedRow(keyFieldParsed(obj), obj, $event, field)\" class=\"{{namespaceClass('__radio')}}\" />\r\n                <span class=\"ec-form__radio-text\"></span>\r\n            </label>\r\n        </div>\r\n    </div>\r\n</td>\r\n"
                },
                "defaultPage": 1,
                "enablePartialCheckbox": false,
                "expandAllRows": false,
                "fields": [],
                "fixedTableHeaderEnabled": false,
                "fixedTableHeaderScrollContainer": null,
                "hideCaption": false,
                "horizontalHeaderField": null,
                "keyField": null,
                "loader": {
                    "enabled": false
                },
                "namespaceClass": "ec-table",
                "orientation": "vertical",
                "page": 1,
                "paginationMode": "bottom",
                "paginationWindowSize": null,
                "perPage": 2,
                "query": false,
                "responsiveEnabled": true,
                "selectByRowEnabled": false,
                "selectedItemKeys": [],
                "sharedTemplates": {},
                "sortCaseInsensitive": false,
                "sortField": null,
                "sortFunc": null,
                "sortOrder": "asc",
                "sortableFields": null,
                "sortingEnabled": true,
                "standalone": true,
                "stickyLeadBreakPoints": null,
                "stickyLeadEnabled": false,
                "stickyPaginationMode": "top",
                "swipeBehavior": "page"
            },
            "type": "ecTable"
        }
    };

    /***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecTable', __webpack_require__(6).ecTable);
        morningstar.asterix.meta.register('ecTable', 'allowedEvents', ['ecTableColumnSorted', 'ecTableShowLessRows', 'ecTableShowMoreRows', 'ecTableRowCollapsed', 'ecTableRowExpanded', 'ecTableRowSelected']);

        __webpack_require__(5);
        __webpack_require__(3);
        __webpack_require__(2);
        __webpack_require__(4);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 8 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 9 */
/***/function (module, exports) {

    module.exports = jQuery;

    /***/
}]
/******/);
//# sourceMappingURL=ec-table.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/******/(function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "build/";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 3);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _) {
        'use strict';

        tabs.$inject = ["mstarDimensions", "mstarState", "mstarTooltip", "$timeout", "$document"];
        angular.module('ecTabs', ['mstarCore']).directive('ecTabs', tabs).directive('ecTab', tab).directive('ecTabLazy', tabLazy).directive('ecTabAction', tabAction);

        function tabs(mstarDimensions, mstarState, mstarTooltip, $timeout, $document) {
            return {
                restrict: 'E',
                require: 'mstarComponentId',
                scope: {},
                transclude: true,
                template: __webpack_require__(4),
                link: linkFn,
                controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
                    $scope.tabs = [];

                    this.getTabs = function () {
                        return $scope.tabs;
                    };
                    this.addTab = function (tab, onSelectCallback) {
                        $scope.tabs.push(tab);
                    };
                    this.getOpenTabSpecs = function () {
                        return $scope.openTabSpecs;
                    };
                }]
            };

            function linkFn(scope, elem, attr, mstarComponent, transcludeFn) {
                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                // compiles the main template
                //mstarComponent.compileTemplate(scope, '_templates.main');

                // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
                mstarComponent.bindParameters(scope);

                // initiates our scope.model according to settings and one-way binds it to the asterix instance's model
                mstarComponent.bindModelData(scope);
                // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

                scope.$evalAsync(function () {
                    scope.tabType = scope.tabType || 'tabs';
                    // todo(slind): remove this, if we want url binding we'll use regular parameter bindings
                    scope.state = mstarState.bind({
                        key: scope.queryKey,
                        query: !!scope.queryKey,
                        defaults: {
                            tab: scope.instance.getParameter('selectedTabIndex')
                        }
                    });
                });

                scope.showTabPanel = scope.settings.get('showTabPanel');

                var body = $document.find('body');
                body.on('click', function (e) {
                    scope.closeDropdown();
                });

                scope.$watch('state.tab', function (newValue) {
                    if (!angular.isNumber(newValue)) {
                        return;
                    }
                    setActiveTabIndex(newValue);
                });

                scope.$watchCollection('tabs', function (newValue) {
                    if (newValue.length > 0) {
                        setActiveTabIndex(scope.instance.getParameter('selectedTabIndex'));
                    }
                });

                var setActiveTabIndex = function setActiveTabIndex(index) {
                    if (index >= scope.tabs.length || index < 0) {
                        return;
                    }
                    if (!scope.tabs[index].active) {
                        scope.setActiveTab(scope.tabs[index]);
                    }
                };

                scope.tabKeyPress = function (tab, event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                        scope.setActiveTab(tab);
                    }
                };

                scope.setActiveTab = function (tab) {
                    !tab.active && scope.instance.trigger('ecTabsSelected', [tab.name]);
                    _.each(scope.tabs, function (e, i) {
                        var wasActive = e.active;
                        e.active = e === tab;

                        if (e.active === true && morningstar.asterix.util.isFunction(e.onActive)) {
                            e.onActive({ index: i, tab: e });
                        }

                        if (scope.tabs[i].clickCount === undefined) {
                            scope.tabs[i].clickCount = 0;
                        }

                        if (e.active) {
                            scope.tabs[i].clickCount += 1;
                            if (!morningstar.asterix.util.isUndefined(scope.state)) {
                                scope.state.tab = i;
                            }
                            elem.find('.' + scope.namespaceClass('__tab-content')).attr('aria-labelledby', scope.namespaceId('-tab') + i); //.focus();
                            if (scope.settings.get('tooltip').trigger === 'click' && e.tooltipInstance == null) {
                                var tabLink = elem.find('#' + scope.namespaceId('-tab') + i);
                                if (tabLink.length > 0) {
                                    e.tooltipInstance = mstarTooltip(scope.$new(), tabLink, { zIndex: 900 });
                                    if (e.tooltip && e.tooltip.length > 0) {
                                        e.tooltipInstance.setContent(e.tooltip);
                                        e.tooltipInstance.updatePosition();
                                    }
                                    //When the tabs is initialized and default active tab is set then there's possibility
                                    //that the tooltip was not setup because the anchor tag was not attached to DOM yet
                                    //Now that the active tab is clicked again, tooltip should be setup and shown as well
                                    if (wasActive) {
                                        e.tooltipInstance.show();
                                    }
                                }
                            }
                        } else {
                            if (e.tooltipInstance && scope.settings.get('tooltip').trigger === 'click') {
                                e.tooltipInstance.destroy();
                                e.tooltipInstance = null;
                            }
                        }
                    });
                    scope.open = false;
                };

                mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:resetTabStatus', function (resetTabStatus) {
                    if (resetTabStatus) {
                        _.each(scope.tabs, function (tab) {
                            if (tab.active) {
                                tab.active = false;
                            }
                        });
                        scope.instance.setParameter('resetTabStatus', false);
                    }
                }));

                mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:selectedTabIndex', function (selectedTabIndex) {
                    setActiveTabIndex(selectedTabIndex);
                }));

                var getActiveTab = function getActiveTab() {
                    return _.find(scope.tabs, function (tab) {
                        return tab.active === true;
                    });
                };

                scope.getTitle = function () {
                    return scope.title ? scope.title : getActiveTab().name;
                };

                scope.closeDropdown = function () {
                    $timeout(function () {
                        scope.open = false;
                    }, 100);
                };
            }
        }

        function tab() {
            return {
                restrict: 'E',
                require: '^ecTabs',
                template: '<div data-ng-transclude data-ng-show="active"></div>',
                transclude: true,
                replace: true,
                scope: {
                    name: '@',
                    tooltip: '@',
                    ariaLabel: '@'
                },
                link: function link(scope, element, attrs, ecTabs) {
                    ecTabs.addTab(scope);
                }
            };
        }

        function tabLazy() {
            return {
                restrict: 'E',
                require: '^ecTabs',
                template: '<div></div>',
                transclude: true,
                replace: true,
                scope: {
                    name: '@',
                    tooltip: '@',
                    ariaLabel: '@'
                },
                link: function link(scope, element, attrs, ecTabs, transcludeFn) {
                    ecTabs.addTab(scope);

                    var cloneScope = null;

                    scope.$watch('active', function (newValue) {
                        if (newValue === true) {
                            cloneScope = scope.$parent.$new();
                            transcludeFn(cloneScope, function (clone) {
                                element.append(clone);
                            });
                        } else if (cloneScope) {
                            cloneScope.$destroy();
                            cloneScope = null;
                            element.empty();
                        }
                    });
                }
            };
        }

        function tabAction() {
            return {
                restrict: 'E',
                require: '^ecTabs',
                scope: {
                    name: '@',
                    onActive: '&',
                    ariaLabel: '@'
                },
                link: function link(scope, element, attrs, ecTabs) {
                    ecTabs.addTab(scope);
                }
            };
        }
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 1 */
/***/function (module, exports) {

    module.exports = {
        "ecTabs": {
            "labels": {},
            "settings": {
                "_parameters": {
                    "resetTabStatus": {},
                    "selectedTabIndex": {}
                },
                "_templates": {
                    "dropdown": "<div class=\"{{::namespaceClass('__dropdown')}}\" data-ng-class=\"open ? namespaceClass('__dropdown--open') : ''\">\r\n    <button class=\"{{::namespaceClass('__btn') + ' ' + namespaceClass('__dropdown-toggle')}}\"\r\n            id=\"{{::namespaceId('-dropdown-btn')}}\"\r\n            data-ng-click=\"open = !open; $event.stopPropagation();\"\r\n            type=\"button\"\r\n            aria-haspopup=\"true\"\r\n            aria-expanded=\"{{open}}\">\r\n        {{ getTitle() }}\r\n        <span class=\"ec-caret\" data-ng-if=\"::settings.get('dropdownCaret') === true\"></span>\r\n    </button>\r\n    <ul class=\"{{::namespaceClass('__dropdown-menu')}}\"\r\n        data-ng-class=\"open ? namespaceClass('__dropdown-menu--open') : ''\"\r\n        role=\"menu\"\r\n        aria-labelledby=\"{{::namespaceId('-dropdown-btn')}}\">\r\n        <li role=\"presentation\" class=\"{{::namespaceClass('__dropdown-item')}}\" data-ng-class=\"[ tab.active ? namespaceClass('__tab--active') : '', tab.header ? namespaceClass('__tab--header') : '', tab.separator ? namespaceClass('__tab--separator') : '']\" data-ng-repeat=\"tab in tabs\">\r\n            <a href=\"javascript:;\"\r\n                class=\"{{::namespaceClass('__dropdown-link')}}\"\r\n                role=\"menuitem\"\r\n                id=\"{{::namespaceId('-tab') + $index}}\"\r\n                data-ng-click=\"setActiveTab(tab)\"\r\n                aria-selected=\"{{tab.active}}\">\r\n                {{ tab.name }}\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n",
                    "main": "<div mstar-include=\"templates.tabs\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'tabs'\"></div>\r\n<div mstar-include=\"templates.dropdown\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'dropdown'\"></div>\r\n<div data-ng-show=\"showTabPanel\" data-ng-class=\"{'{{::namespaceClass('__tab-content--standard')}}' : settings.get('tabType') === 'standard'}\" class=\"{{::namespaceClass('__tab-content')}}\" id=\"{{::namespaceId('-tab-content')}}\" role=\"tabpanel\" tabindex=\"-1\" data-ng-transclude></div>\r\n",
                    "tabs": "<ul class=\"{{::namespaceClass('__tabs')}}\" role=\"tablist\" data-ng-class=\"settings.get('tabType') === 'standard' ? namespaceClass('__tabs--standard') : ''\">\r\n    <li role=\"presentation\" class=\"{{::namespaceClass('__tab')}}\" data-ng-class=\"tab.active ? namespaceClass('__tab--active') : ''\" data-ng-repeat=\"tab in tabs\">\r\n        <a href=\"javascript:;\"\r\n            class=\"{{::namespaceClass('__link')}}\"\r\n            role=\"tab\"\r\n            id=\"{{namespaceId('-tab') + $index}}\"\r\n            data-ng-click=\"setActiveTab(tab)\"\r\n            data-ng-keypress=\"tabKeyPress(tab, $event)\"\r\n            aria-selected=\"{{tab.active}}\"\r\n            aria-label=\"{{tab.ariaLabel ? tab.ariaLabel : tab.name}}\"\r\n            mstar-tooltip mstar-tooltip-content=\"{{settings.get('tooltip').trigger == 'hover' ? tab.tooltip : ''}}\">{{ tab.name }}</a>\r\n    </li>\r\n</ul>\r\n"
                },
                "controlType": "tabs",
                "dropdownCaret": true,
                "namespaceClass": "ec-tabs",
                "resetTabStatus": false,
                "selectedTabIndex": 0,
                "showTabPanel": true,
                "tabType": "tabs"
            },
            "type": "ecTabs"
        }
    };

    /***/
},
/* 2 */
/***/function (module, exports) {

    module.exports = morningstar;

    /***/
},
/* 3 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
        'use strict';

        morningstar.asterix.ng.register('ecTabs', __webpack_require__(1).ecTabs);
        morningstar.asterix.meta.register('ecTabs', 'skipInFullIdentifier', true);
        morningstar.asterix.meta.register('ecTabs', 'allowedEvents', ['ecTabsSelected']);

        __webpack_require__(0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /***/
},
/* 4 */
/***/function (module, exports) {

    module.exports = "<div mstar-include=\"templates.tabs\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'tabs'\"></div>\r\n<div mstar-include=\"templates.dropdown\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'dropdown'\"></div>\r\n<div data-ng-show=\"showTabPanel\" data-ng-class=\"{'{{::namespaceClass('__tab-content--standard')}}' : settings.get('tabType') === 'standard'}\" class=\"{{::namespaceClass('__tab-content')}}\" id=\"{{::namespaceId('-tab-content')}}\" role=\"tabpanel\" tabindex=\"-1\" data-ng-transclude></div>\r\n";

    /***/
},
/* 5 */
/***/function (module, exports) {

    module.exports = _;

    /***/
},
/* 6 */
/***/function (module, exports) {

    module.exports = angular;

    /***/
}]
/******/);
//# sourceMappingURL=ec-tabs.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = {
	"ecMultipleChart": {
		"components": {
			"autocompleteComparisonFund": {
				"blueprint": "standardUS",
				"components": {
					"searchInput": {
						"labels": {
							"ariaText": {
								"en": "Please use up and down arrow keys to navigate search results"
							},
							"placeholder": {
								"en": "Enter name, ticker, or fund code.",
								"fr": "Entrez nom, symbole, ou code de fonds."
							}
						},
						"type": "ecInput"
					}
				},
				"labels": {
					"ariaLabel": {
						"en": "Comparison Fund field. Enter name, ticker, or fund code. Please use up and down arrow keys to navigate search results",
						"fr": "Fonds/FNB de comparaison. Entrez nom, symbole, ou code de fonds. Servez-vous des flèches pour parcourir les résultats de votre recherche"
					}
				},
				"settings": {
					"propagatedFields": {
						"asOfDate": "asOfDate",
						"category": "category",
						"categoryId": "categoryId",
						"closePrice": "closePrice",
						"inceptionDate": "inceptionDate",
						"name": "name",
						"returnM12": "returnM12",
						"returnM120": "returnM120",
						"returnM255UA": "returnM255UA",
						"returnM36": "returnM36",
						"returnM60": "returnM60",
						"secId": "secId",
						"universe": "universe"
					},
					"restoreResultsOnFocus": "true",
					"securityDataPoints": "name|secId|category|universe|categoryId|inceptionDate|closePrice|asOfDate|returnM12|returnM36|returnM60|returnM120|returnM255UA",
					"showAriaDescribedBy": false,
					"universeId": "FOUSA|FEUSA"
				},
				"type": "ecAutocomplete"
			},
			"autocompletePrimaryFund": {
				"blueprint": "standardUS",
				"components": {
					"searchInput": {
						"labels": {
							"ariaText": {
								"en": "Please use up and down arrow keys to navigate search results"
							},
							"placeholder": {
								"en": "Enter name, ticker, or fund code.",
								"fr": "Entrez nom, symbole, ou code de fonds."
							}
						},
						"type": "ecInput"
					}
				},
				"labels": {
					"ariaLabel": {
						"en": "Primary Fund field. Enter name, ticker, or fund code. Please use up and down arrow keys to navigate search results",
						"fr": "Fonds/FNB primaire. Entrez nom, symbole, ou code de fonds. Servez-vous des flèches pour parcourir les résultats de votre recherche"
					}
				},
				"settings": {
					"name": "autocompletePrimaryFund",
					"propagatedFields": {
						"asOfDate": "asOfDate",
						"category": "category",
						"categoryId": "categoryId",
						"closePrice": "closePrice",
						"inceptionDate": "inceptionDate",
						"name": "name",
						"returnM12": "returnM12",
						"returnM120": "returnM120",
						"returnM255UA": "returnM255UA",
						"returnM36": "returnM36",
						"returnM60": "returnM60",
						"secId": "secId",
						"universe": "universe"
					},
					"restoreResultsOnFocus": "true",
					"securityDataPoints": "name|secId|category|universe|categoryId|inceptionDate|closePrice|asOfDate|returnM12|returnM36|returnM60|returnM120|returnM255UA",
					"showAriaDescribedBy": false,
					"universeId": "FOUSA|FEUSA"
				},
				"type": "ecAutocomplete"
			},
			"buttonExport": {
				"labels": {
					"caption": {
						"en": "Export",
						"fr": "Exporter"
					}
				},
				"settings": {
					"buttonType": "submit",
					"onClick": {}
				},
				"type": "ecButton"
			},
			"buttonReset": {
				"labels": {
					"caption": {
						"en": "Reset",
						"fr": "Réinitialiser"
					}
				},
				"settings": {
					"buttonType": "submit"
				},
				"type": "ecButton"
			},
			"buttonSubmit": {
				"labels": {
					"caption": {
						"en": "Submit",
						"fr": "Soumettre"
					}
				},
				"settings": {
					"buttonType": "submit",
					"onClick": {}
				},
				"type": "ecButton"
			},
			"chartTabs": {
				"settings": {
					"showTabPanel": false
				},
				"type": "ecTabs"
			},
			"chosenReinvestDistributions": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "yes",
								"value": "yes"
							},
							{
								"key": "no",
								"value": "no"
							}
						]
					},
					"controlType": "buttonList"
				},
				"type": "ecChosen"
			},
			"comboBoxFrequency": {
				"type": "ecComboBox"
			},
			"comboBoxInvestmentType": {
				"type": "ecComboBox"
			},
			"comboBoxTimeFrame": {
				"type": "ecComboBox"
			},
			"containerGrowthChart": {
				"settings": {
					"breakpoints": {
						"large": "medium",
						"medium": {
							"groups": {
								"left": {
									"cols": 2,
									"order": 0
								},
								"middle": {
									"cols": 8,
									"order": 1,
									"sections": [
										"sectionAutocomplete",
										"sectionTimeFrame",
										"sectionAmount",
										"sectionFilterReinvestDistributions",
										"sectionActionButton"
									]
								},
								"right": {
									"cols": 2,
									"order": 2
								}
							}
						},
						"small": {
							"groups": {
								"all": {
									"cols": 12,
									"order": 0,
									"sections": [
										"sectionAutocomplete",
										"sectionTimeFrame",
										"sectionAmount",
										"sectionFilterReinvestDistributions",
										"sectionActionButton"
									]
								}
							}
						},
						"xlarge": "medium"
					}
				},
				"type": "ecContainer"
			},
			"containerMultipleChart": {
				"settings": {
					"breakpoints": {
						"defaults": {
							"collapserPosition": "firstPerRow",
							"groups": {
								"all": {
									"cols": 12,
									"order": 0,
									"sections": [
										{
											"autoCollapseMode": "expand",
											"sectionId": "sectionMultipleChartInput"
										},
										"sectionPriceChart",
										"sectionPriceTable",
										"hypotheticalGrowthChart",
										"sectionHypotheticalGrowthTable",
										"sectionPerformanceTable"
									]
								}
							}
						}
					}
				},
				"type": "ecContainer"
			},
			"hypotheticalGrowthChart": {
				"components": {
					"containerHypo": {
						"settings": {
							"breakpoints": {
								"defaults": {
									"groups": {
										"all": {
											"cols": 12,
											"sections": [
												"performanceGraph"
											]
										}
									}
								},
								"small": {
									"groups": {
										"all": {
											"cols": 12,
											"sections": [
												"performanceGraph"
											]
										}
									}
								}
							}
						},
						"type": "ecContainer"
					},
					"hypoApplyButton": {
						"type": "ecButton"
					},
					"hypoChosenButton": {
						"type": "ecButton"
					},
					"hypoDateInput": {
						"type": "ecInput"
					},
					"hypoFeesApplyChosen": {
						"type": "ecChosen"
					},
					"hypoFilingStatusChosen": {
						"type": "ecChosen"
					},
					"hypoFrequencyChosen": {
						"type": "ecChosen"
					},
					"hypoFrontLoadTypeChosen": {
						"type": "ecChosen"
					},
					"hypoNumberInput": {
						"type": "ecInput"
					},
					"hypoPayChosen": {
						"type": "ecChosen"
					},
					"hypoReinvestChosen": {
						"type": "ecChosen"
					},
					"hypoReportBuilder": {
						"type": "ecReportBuilder"
					},
					"hypoSettingsButton": {
						"type": "ecButton"
					},
					"hypoSubsequentInvestmentTypeChosen": {
						"type": "ecChosen"
					},
					"hypoTimePeriodTrailingReturnChosen": {
						"type": "ecChosen"
					},
					"performanceGraph": {
						"components": {
							"annualPerformanceTable": {
								"components": {
									"paginator": {
										"type": "ecPaginator"
									},
									"paginatorSticky": {
										"type": "ecPaginator"
									},
									"paginatorTop": {
										"type": "ecPaginator"
									},
									"sortFieldsDropdown": {
										"type": "ecChosen"
									},
									"sortOrderRadio": {
										"type": "ecChosen"
									}
								},
								"type": "ecTable"
							},
							"graphContainer": {
								"type": "ecContainer"
							},
							"tabFrequency": {
								"type": "ecTabs"
							}
						},
						"labels": {
							"inception": {
								"en": "Max"
							},
							"performanceGraph": {
								"en": "Hypothetical Growth",
								"fr": "Graphique de Croissance",
								"fr-CA": "Graphique de Croissance"
							}
						},
						"settings": {
							"showTitle": false
						},
						"type": "ecPerformanceGraph"
					},
					"portfolioData": {
						"type": "ecPortfolioData"
					}
				},
				"labels": {
					"title": {
						"en": "Hypothetical Growth",
						"fr": "Graphique de Croissance"
					}
				},
				"settings": {
					"showLoading": false
				},
				"type": "ecHypotheticalGrowth"
			},
			"hypotheticalGrowthTable": {
				"components": {
					"paginator": {
						"type": "ecPaginator"
					},
					"paginatorSticky": {
						"type": "ecPaginator"
					},
					"paginatorTop": {
						"type": "ecPaginator"
					},
					"sortFieldsDropdown": {
						"type": "ecChosen"
					},
					"sortOrderRadio": {
						"type": "ecChosen"
					}
				},
				"settings": {
					"_model": {
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).growthData.rows _}}"
						}
					},
					"fields": [
						"name",
						"totalContribution",
						"value",
						"totalGain",
						"return",
						"annualizedEquivalent",
						"inceptionDate"
					]
				},
				"type": "ecTable"
			},
			"inputAmount": {
				"settings": {
					"inputType": "number",
					"name": "inputAmount"
				},
				"type": "ecInput"
			},
			"inputEndDate": {
				"labels": {
					"invalidDate": {
						"en": "Invalid format. Please try again.",
						"fr": "Format invalide. Veuillez réessayer."
					}
				},
				"settings": {
					"inputType": "date",
					"name": "inputEndDate"
				},
				"type": "ecInput"
			},
			"inputFrequency": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"frequency": "annually",
								"key": "annually",
								"list": 1,
								"value": "annually"
							},
							{
								"frequency": "monthly",
								"key": "monthly",
								"list": 2,
								"value": "monthly"
							},
							{
								"frequency": "quarterly",
								"key": "quarterly",
								"list": 3,
								"value": "quarterly"
							},
							{
								"frequency": "semiAnnually",
								"key": "semiAnnually",
								"list": 4,
								"value": "semiAnnually"
							}
						]
					},
					"inputType": "select",
					"keyField": "list",
					"valueField": "frequency"
				},
				"type": "ecInput"
			},
			"inputInitialAmount": {
				"settings": {
					"inputType": "number",
					"name": "inputInitialAmount"
				},
				"type": "ecInput"
			},
			"inputInvestmentType": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"investmentType": "contribution",
								"key": "invest",
								"list": 1,
								"value": "contribution"
							},
							{
								"investmentType": "withdrawal",
								"key": "withdrawal",
								"list": 2,
								"value": "withdrawal"
							}
						]
					},
					"inputType": "select",
					"keyField": "list",
					"valueField": "investmentType"
				},
				"type": "ecInput"
			},
			"inputStartDate": {
				"labels": {
					"invalidDate": {
						"en": "Invalid format. Please try again.",
						"fr": "Format invalide. Veuillez réessayer."
					}
				},
				"settings": {
					"inputType": "date",
					"name": "inputStartDate"
				},
				"type": "ecInput"
			},
			"inputTimeFrame": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "sinceInception",
								"list": 1,
								"timeFrame": "sinceInception",
								"value": "sinceInception"
							},
							{
								"key": "customized",
								"list": 2,
								"timeFrame": "customized",
								"value": "custom"
							}
						]
					},
					"inputType": "select",
					"keyField": "list",
					"valueField": "timeFrame"
				},
				"type": "ecInput"
			},
			"performanceTable": {
				"settings": {
					"_model": {
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).performanceData.rows _}}"
						}
					},
					"fields": [
						"name",
						"returnM12",
						"returnM36",
						"returnM60",
						"returnM120",
						"returnM255UA",
						"inceptionDate"
					]
				},
				"type": "ecTable"
			},
			"priceChart": {
				"components": {
					"annualPerformanceTable": {
						"components": {
							"paginator": {
								"type": "ecPaginator"
							},
							"paginatorSticky": {
								"type": "ecPaginator"
							},
							"paginatorTop": {
								"type": "ecPaginator"
							},
							"sortFieldsDropdown": {
								"type": "ecChosen"
							},
							"sortOrderRadio": {
								"type": "ecChosen"
							}
						},
						"type": "ecTable"
					},
					"graphContainer": {
						"type": "ecContainer"
					},
					"tabFrequency": {
						"settings": {
							"selectedTabIndex": -1
						},
						"type": "ecTabs"
					}
				},
				"labels": {
					"inception": {
						"en": "Max"
					},
					"oneMonth": {
						"en": "1M",
						"fr": "1M",
						"fr-CA": "1m"
					},
					"performanceGraph": {
						"en": "Chart",
						"fr": "Graphique",
						"fr-CA": "Graphique"
					}
				},
				"settings": {
					"_model": {
						"performanceChart": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).securities.priceChartData _}}"
						}
					},
					"_parameters": {
						"dataType": {
							"binding": "{{_ parameters(_).dataType _}}"
						},
						"endDate": {
							"binding": "{{_ parameters(_).endDate _}}"
						},
						"startDate": {
							"binding": "{{_ parameters(_).startDate _}}"
						}
					},
					"chartType": "price",
					"displayFrequency": [
						{
							"labelKey": "oneMonth",
							"value": 1
						},
						{
							"labelKey": "oneYear",
							"value": 12
						},
						{
							"labelKey": "threeYears",
							"value": 36
						},
						{
							"labelKey": "fiveYears",
							"value": 60
						},
						{
							"labelKey": "tenYears",
							"value": 120
						},
						{
							"labelKey": "inception",
							"value": 2400
						}
					],
					"enableCustomDate": true,
					"lineChartSettings": {
						"legendPosition": "top"
					},
					"showTitle": false,
					"timelineLevelDefinitions": {
						"d": {
							"day": [
								0,
								13
							],
							"month": [
								92,
								390
							],
							"quarter": [
								391,
								1170
							],
							"week": [
								14,
								91
							],
							"year": [
								1171,
								36500
							]
						},
						"w": {
							"day": [
								0,
								13
							],
							"month": [
								92,
								390
							],
							"quarter": [
								391,
								1170
							],
							"week": [
								14,
								91
							],
							"year": [
								1171,
								36500
							]
						}
					}
				},
				"type": "ecPerformanceGraph"
			},
			"priceTable": {
				"components": {
					"paginator": {
						"type": "ecPaginator"
					},
					"paginatorSticky": {
						"type": "ecPaginator"
					},
					"paginatorTop": {
						"type": "ecPaginator"
					},
					"sortFieldsDropdown": {
						"type": "ecChosen"
					},
					"sortOrderRadio": {
						"type": "ecChosen"
					}
				},
				"settings": {
					"_model": {
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).securities.priceTableData _}}"
						}
					},
					"fields": [
						"name",
						"startDate",
						"endDate",
						"priceChangePer",
						"currentPrice",
						"inceptionDate"
					]
				},
				"type": "ecTable"
			}
		},
		"labels": {
			"amount": {
				"en": "Amount {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Montant {{ format.currencySymbol(model.currencyId) }}",
				"sv-SE": null
			},
			"amountRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"annualizedEquivalent": {
				"en": "% Annualized Equivalent",
				"en-GB": null,
				"fr": "Équivalent annualisé (%)",
				"sv-SE": null
			},
			"annually": {
				"en": "Annually",
				"en-GB": null,
				"fr": "Annuelle",
				"sv-SE": null
			},
			"asOfDate": {
				"en": "as of {{format.date(model.rows[0].asOfDate, 'yy-mmm-dd')}}",
				"en-GB": null,
				"fr": "au {{format.date(model.rows[0].asOfDate, 'yy-mmm-dd')}}",
				"sv-SE": null
			},
			"comparisonFund": {
				"en": "Comparison Fund",
				"en-GB": null,
				"fr": "Fonds/FNB de comparaison",
				"sv-SE": null
			},
			"comparisonFundRequired": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"contribution": {
				"en": "Contribution",
				"en-GB": null,
				"fr": "Contribution",
				"sv-SE": null
			},
			"currentPrice": {
				"en": "Current Price",
				"en-GB": null,
				"fr": "Prix actuel",
				"sv-SE": null
			},
			"custom": {
				"en": "Custom",
				"en-GB": null,
				"fr": "Date personnalisée",
				"sv-SE": null
			},
			"date": {
				"en": "Date",
				"en-GB": null,
				"sv-SE": null
			},
			"distribution": {
				"en": "Distribution ({{0}})",
				"en-GB": null,
				"sv-SE": null
			},
			"endDate": {
				"en": "End Date",
				"en-GB": null,
				"fr": "Date de fin",
				"sv-SE": null
			},
			"endDateRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"enterData": {
				"en": "Enter data",
				"en-GB": null,
				"fr": "Entrez les données",
				"sv-SE": null
			},
			"enterDataInstruction": {
				"en": "Screenreader users can press Spacebar to open the menu. Use the arrow keys to navigate and press Enter to make your selection. Mobile user can use explore by touch.",
				"en-GB": null,
				"fr": "Les utilisateurs du lecteur d’écran peuvent appuyer sur la barre d’espace pour ouvrir le menu. Servez-vous des flèches pour vous déplacer et appuyez sur la touche d’entrée pour effectuer votre sélection. Les utilisateurs d’un appareil mobile peuvent se servir de la fonction explorer au toucher.",
				"sv-SE": null
			},
			"fieldShouldBeInteger": {
				"en": "The value you provided is invalid. Please enter a numeric value without commas, decimals, spaces, or special characters.",
				"fr": "La valeur que vous avez fournie n'est pas valide. SVP entrez une valeur numérique sans virgules, décimales, espaces ou caractères spéciaux."
			},
			"hypotheticalGrowthChart": {
				"en": "Hypothetical Growth Chart",
				"en-GB": null,
				"fr": "Graphique de Croissance",
				"sv-SE": null
			},
			"hypotheticalGrowthTable": {
				"en": "Growth Data Table (Initial investment {{ format.currencySymbol(model.currencyId) }}{{ format.number(model.chartSettings.initialInvestmentAmount) }})",
				"en-GB": null,
				"fr": "Tableau de données de croissance (Placement Initial {{ format.number(model.chartSettings.initialInvestmentAmount) }} {{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"inceptionDate": {
				"en": "Inception Date",
				"en-GB": null,
				"fr": "Date de création",
				"sv-SE": null
			},
			"initialAmountRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"initialInvestment": {
				"en": "Initial investment: {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Placement Initial: {{ format.currencySymbol(model.currencyId) }}",
				"sv-SE": null
			},
			"initialInvestmentAmount": {
				"en": "Initial Investment Amount {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Placement initial {{ format.currencySymbol(model.currencyId) }}",
				"sv-SE": null
			},
			"inputFrequency": {
				"en": "Frequency",
				"fr": "Fréquence"
			},
			"inputInvestmentType": {
				"en": "Investment Type",
				"fr": "Type d'investissement"
			},
			"inputTimeFrame": {
				"en": "Time Frame",
				"fr": "Durée"
			},
			"maxEndDate": {
				"en": "The end date can't be later than current date.",
				"en-GB": null,
				"fr": "La date de fin ne peut pas être ultérieure à la date actuelle.",
				"sv-SE": null
			},
			"maxStartDate": {
				"en": "The start date can't be later than the end date.",
				"en-GB": null,
				"fr": "La date de début ne peut pas être ultérieure à la date de fin.",
				"sv-SE": null
			},
			"monthly": {
				"en": "Monthly",
				"en-GB": null,
				"fr": "Mensuelle",
				"sv-SE": null
			},
			"multipleChartHeader": {
				"en": "Compare and analyze securities",
				"en-GB": null,
				"fr": "Comparez et analysez des titres",
				"sv-SE": null
			},
			"name": {
				"en": "Name",
				"en-GB": null,
				"fr": "Nom",
				"sv-SE": null
			},
			"no": {
				"en": "No",
				"en-GB": null,
				"fr": "Non",
				"sv-SE": null
			},
			"performanceTable": {
				"en": "Returns Data Table (as of {{ format.date(model.performanceData.asofDate, 'yy-mmm-dd') }})",
				"en-GB": null,
				"fr": "Tableau de données de rendements (au {{ format.date(model.performanceData.asofDate, 'yy-mmm-dd') }})",
				"sv-SE": null
			},
			"price": {
				"en": "Yield ({{0}})",
				"en-GB": null,
				"fr": "Rendement ({{0}})",
				"sv-SE": null
			},
			"priceChangePer": {
				"en": "% Price Change",
				"en-GB": null,
				"fr": "% changement de prix",
				"sv-SE": null
			},
			"priceChart": {
				"en": "Price Chart",
				"en-GB": null,
				"fr": "Graphique de Prix",
				"sv-SE": null
			},
			"priceChartTitle": {
				"en": "Chart",
				"en-GB": null,
				"fr": "Graphique",
				"sv-SE": null
			},
			"priceTableTitle": {
				"en": "Price Data Table",
				"en-GB": null,
				"fr": "Tableau de données de prix",
				"sv-SE": null
			},
			"primaryFund": {
				"en": "Primary Fund",
				"en-GB": null,
				"fr": "Fonds/FNB primaire",
				"sv-SE": null
			},
			"primaryFundRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"quarterly": {
				"en": "Quarterly",
				"en-GB": null,
				"fr": "Trimestriel",
				"sv-SE": null
			},
			"reinvestDistributions": {
				"en": "Re-invest Distributions",
				"en-GB": null,
				"fr": "Réinvestir les distributions",
				"sv-SE": null
			},
			"return": {
				"en": "% Return",
				"en-GB": null,
				"fr": "Rendement (%)",
				"sv-SE": null
			},
			"return120": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"return60": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"returnM12": {
				"en": "1 Yr",
				"en-GB": null,
				"fr": "1 A",
				"sv-SE": null
			},
			"returnM120": {
				"en": "10 Yrs",
				"fr": "10 A"
			},
			"returnM255UA": {
				"en": "Since Inception",
				"en-GB": null,
				"fr": "Depuis création",
				"sv-SE": null
			},
			"returnM36": {
				"en": "3 Yrs",
				"en-GB": null,
				"fr": "3 A",
				"sv-SE": null
			},
			"returnM60": {
				"en": "5 Yrs",
				"fr": "5 A"
			},
			"semiAnnually": {
				"en": "Semi-Annually",
				"en-GB": null,
				"fr": "Semiannuel",
				"fr-CA": "Hebdomadaire",
				"sv-SE": null
			},
			"sinceInception": {
				"en": "Since Inception",
				"en-GB": null,
				"fr": "Depuis création",
				"sv-SE": null
			},
			"startDate": {
				"en": "Start Date",
				"en-GB": null,
				"fr": "Date de début",
				"sv-SE": null
			},
			"startDateRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"totalContributionAmount": {
				"en": "Total Contribution Amounts {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Montant total des contributions ({{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"totalGain": {
				"en": "Total {{ format.currencySymbol(model.currencyId) }} Gain",
				"en-GB": null,
				"fr": "Gain total ({{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"value": {
				"en": "Value {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Valeur ({{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"withdrawal": {
				"en": "Withdrawal",
				"en-GB": null,
				"fr": "Retrait",
				"sv-SE": null
			},
			"yes": {
				"en": "Yes",
				"en-GB": null,
				"fr": "Oui",
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"chartSettings": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"selector": null,
					"transformPipeline": []
				},
				"growthData": {
					"rows": {
						"dataSourceType": "selector",
						"selector": "{{_ model(hypotheticalGrowthChart.portfolioData).securities _}}",
						"transformPipeline": [
							"fromPAAPIHypoToGrowthTable"
						]
					}
				},
				"performanceData": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"asOfDate": null,
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"rows": [],
					"selector": null,
					"transformPipeline": []
				},
				"priceAndDistributions": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"throttleTime": 200,
							"transformPipeline": [
								"toMarketsPriceAndDistributions"
							],
							"watchedPaths": [
								"startDate",
								"endDate",
								"secIds",
								"readyForAPI"
							]
						},
						"url": "//{{baseUrl}}/ra/rdbChartData?tickers={{secIds}}&sd={{startDate}}&ed={{endDate}}&fields=TotalDist,3244&cdt=19&qs_wsid={{sessionId}}",
						"validationExpression": "parameters.readyForAPI"
					},
					"dataSourceType": "api",
					"transformPipeline": [
						"fromMarketsPriceAndDistributions"
					]
				},
				"securities": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"throttleTime": 200,
							"transformPipeline": [
								"toMarkets"
							],
							"watchedPaths": [
								"dataType",
								"startDate",
								"endDate",
								"secIds"
							]
						},
						"url": "//{{baseUrl}}/ra/rdbChartData?f={{dataType}}&fields=HS538&sd={{startDate}}&ed={{endDate}}&tickers={{secIds}}&cdt=2&qs_wsid={{sessionId}}"
					},
					"dataSourceType": "api",
					"transformPipeline": [
						"fromMarkets"
					]
				}
			},
			"_parameters": {
				"dataType": {},
				"endDate": {},
				"startDate": {}
			},
			"_templates": {
				"enterData": "<ec-container mstar-component-id=\"containerGrowthChart\">\r\n    <form name=\"enterData\">\r\n        <ec-section section-id=\"sectionAutocomplete\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('autocompletePrimaryFund')}}-search-input-textbox\">\r\n                    {{::labels.get('primaryFund')}}\r\n                </label>\r\n                <ec-autocomplete mstar-component-id=\"autocompletePrimaryFund\" data-ng-model=\"model.chartSettings.primaryFund\"></ec-autocomplete>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.primaryFundRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('autocompleteComparisonFund')}}-search-input-textbox\">\r\n                    {{::labels.get('comparisonFund')}}\r\n                </label>\r\n                <ec-autocomplete mstar-component-id=\"autocompleteComparisonFund\" data-ng-model=\"model.chartSettings.comparisonFund\"></ec-autocomplete>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.comparisonFundRequired}}\r\n                </div>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionTimeFrame\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                    <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputTimeFrame')}}-select\">{{::labels.get('inputTimeFrame')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputTimeFrame\"\r\n                    data-ng-model=\"model.chartSettings.timeFrame\"></ec-input>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputStartDate')}}-date\">{{::labels.get('startDate')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputStartDate\"\r\n                    data-ng-model=\"model.chartSettings.startDate\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.startDateRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputEndDate')}}-date\">{{::labels.get('endDate')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputEndDate\"\r\n                    data-ng-model=\"model.chartSettings.endDate\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.endDateRequired}}\r\n                </div>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionAmount\" data-ng-show=\"activeType === 'hypotheticalGrowthChart'\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputInitialAmount')}}-number\">{{::labels.get('initialInvestmentAmount')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputInitialAmount\"\r\n                    data-ng-model=\"model.chartSettings.initialInvestmentAmount\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.initialAmountRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputInvestmentType')}}-select\">{{::labels.get('inputInvestmentType')}}</label>\r\n                <ec-input mstar-component-id=\"inputInvestmentType\" data-ng-model=\"model.chartSettings.investmentType\"></ec-input>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputAmount')}}-number\">{{::labels.get('amount')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputAmount\"\r\n                    data-ng-model=\"model.chartSettings.amount\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.amountRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputFrequency')}}-select\">{{::labels.get('inputFrequency')}}</label>\r\n                <ec-input mstar-component-id=\"inputFrequency\" data-ng-model=\"model.chartSettings.frequency\"></ec-input>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionFilterReinvestDistributions\" data-ng-show=\"activeType === 'hypotheticalGrowthChart'\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                <legend class=\"{{::namespaceClass('__label')}}\">{{::labels.get('reinvestDistributions')}}</legend>\r\n                <ec-chosen mstar-component-id=\"chosenReinvestDistributions\" data-ng-model=\"model.chartSettings.reinvestDistributions\"></ec-chosen>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionActionButton\">\r\n            <div class=\"{{::namespaceClass('__field-group-button')}}\">\r\n                <ec-button mstar-component-id=\"buttonExport\" data-ng-click=\"export()\" data-ng-show=\"activeType === 'priceChart'\" tabindex=\"-1\"></ec-button>\r\n                <ec-button mstar-component-id=\"buttonReset\" data-ng-click=\"reset()\" tabindex=\"-1\"></ec-button>\r\n                <ec-button mstar-component-id=\"buttonSubmit\" data-ng-click=\"submit()\" tabindex=\"-1\"></ec-button>\r\n            </div>\r\n        </ec-section>\r\n    </form>\r\n</ec-container>\r\n",
				"main": "<ec-section>\r\n    <div class=\"{{::namespaceClass('__top')}}\">\r\n        <div class=\"{{namespaceClass('__header')}}\">\r\n            <h2>{{::labels.get('multipleChartHeader')}}</h2>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__tabs')}}\">\r\n            <ec-tabs mstar-component-id=\"chartTabs\">\r\n                <ec-tab-action data-ng-repeat=\"view in settings.get('views')\" name=\"{{::labels.get(view)}}\" on-active=\"setActiveView(index)\">\r\n                </ec-tab-action>\r\n            </ec-tabs>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hidden-text')}}\" tabindex=\"0\">{{::labels.get('enterDataInstruction')}}</div>\r\n    </div>\r\n    <ec-container mstar-component-id=\"containerMultipleChart\" mstar-loader=\"isLoading\">\r\n        <ec-section section-id=\"sectionMultipleChartInput\" title=\"{{labels.get('enterData')}}\">\r\n            <div mstar-include=\"templates.enterData\" title=\"\"></div>\r\n        </ec-section>\r\n        <ec-hypothetical-growth mstar-component-id=\"hypotheticalGrowthChart\" data-ng-show=\"showHypoGrowthChart && activeType === 'hypotheticalGrowthChart'\"></ec-hypothetical-growth>\r\n        <ec-section section-id=\"sectionHypotheticalGrowthTable\" title=\"{{ labels.get('hypotheticalGrowthTable') }}\" data-ng-show=\"showHypoGrowthChart && activeType === 'hypotheticalGrowthChart'\">\r\n            <ec-table template-type=\"light\" mstar-component-id=\"hypotheticalGrowthTable\"></ec-table>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionPerformanceTable\" title=\"{{ labels.get('performanceTable') }}\" data-ng-show=\"showHypoGrowthChart && activeType === 'hypotheticalGrowthChart'\">\r\n            <ec-table template-type=\"light\" mstar-component-id=\"performanceTable\"></ec-table>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionPriceChart\" title=\"{{labels.get('priceChartTitle')}}\" data-ng-show=\"showPriceTable === true && activeType === 'priceChart'\">\r\n            <ec-performance-graph mstar-component-id=\"priceChart\" title=\"\"></ec-performance-graph>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionPriceTable\" title=\"{{::labels.get('priceTableTitle') }}\" data-ng-show=\"showPriceTable === true && activeType === 'priceChart'\">\r\n            <ec-table template-type=\"light\" mstar-component-id=\"priceTable\" title=\"\"></ec-table>\r\n        </ec-section>\r\n    </ec-container>\r\n</ec-section>\r\n"
			},
			"_validation": {
				"messageWhen": "manual",
				"modelRules": {
					"autocompletePrimaryFund": {
						"data": "{{_ model().chartSettings.primaryFund.name _}}",
						"labelKey": "primaryFundRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputAmount": {
						"data": "{{_ model().chartSettings.amount _}}",
						"labelKey": "amountRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputEndDate": {
						"data": "{{_ model().chartSettings.endDate _}}",
						"labelKey": "endDateRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputInitialAmount": {
						"data": "{{_ model().chartSettings.initialInvestmentAmount _}}",
						"labelKey": "initialAmountRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputStartDate": {
						"data": "{{_ model().chartSettings.startDate _}}",
						"labelKey": "startDateRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					}
				},
				"validationMessageHandlerType": "self"
			},
			"currencyId": "USD",
			"dataType": null,
			"endDate": null,
			"exportSettings": {
				"columnOrder": [
					"date",
					"price",
					"distribution"
				],
				"dateFormatAlias": "yyyy-mm-dd",
				"distributionFormatAlias": "shortDecimal",
				"priceFormatAlias": "shortDecimal"
			},
			"fieldDefinitions": {
				"annualizedEquivalent": {
					"fieldName": "avgAnnualizedReturn",
					"format": "shortDecimal",
					"headerLabelKey": "annualizedEquivalent"
				},
				"currentPrice": {
					"fieldName": "currentPrice",
					"headerLabelKey": "currentPrice"
				},
				"endDate": {
					"fieldName": "endDate",
					"format": "yy-mmm-dd",
					"headerLabelKey": "endDate"
				},
				"inceptionDate": {
					"fieldName": "inceptionDate",
					"format": "yy-mmm-dd",
					"headerLabelKey": "inceptionDate"
				},
				"name": {
					"fieldName": "name",
					"headerLabelKey": "name"
				},
				"priceChangePer": {
					"fieldName": "priceChangePer",
					"headerLabelKey": "priceChangePer"
				},
				"return": {
					"fieldName": "cumulativeReturn",
					"format": "shortDecimal",
					"headerLabelKey": "return"
				},
				"returnM12": {
					"fieldName": "returnM12",
					"format": "shortDecimal",
					"headerLabelKey": "returnM12"
				},
				"returnM120": {
					"fieldName": "returnM120",
					"format": "shortDecimal",
					"headerLabelKey": "returnM120"
				},
				"returnM255UA": {
					"fieldName": "returnM255UA",
					"format": "shortDecimal",
					"headerLabelKey": "returnM255UA"
				},
				"returnM36": {
					"fieldName": "returnM36",
					"format": "shortDecimal",
					"headerLabelKey": "returnM36"
				},
				"returnM60": {
					"fieldName": "returnM60",
					"format": "shortDecimal",
					"headerLabelKey": "returnM60"
				},
				"startDate": {
					"fieldName": "startDate",
					"format": "yy-mmm-dd",
					"headerLabelKey": "startDate"
				},
				"totalContribution": {
					"fieldName": "totalContributionAmounts",
					"format": "shortDecimal",
					"headerLabelKey": "totalContributionAmount"
				},
				"totalGain": {
					"fieldName": "totalGain",
					"format": "shortDecimal",
					"headerLabelKey": "totalGain"
				},
				"value": {
					"fieldName": "marketValue",
					"fieldSettings": {
						"headerTemplate": "<th>{{labels.get('value')}} ({{labels.get('asOfDate')}})</th>"
					},
					"format": "shortDecimal",
					"headerLabelKey": "value"
				}
			},
			"languageId": "en-US",
			"namespaceClass": "ec-multiple-chart",
			"startDate": null,
			"views": [
				"hypotheticalGrowthChart",
				"priceChart"
			]
		},
		"type": "ecMultipleChart"
	}
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// ec-multiple-chart-bundle.js